
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("6x22B", function(module, exports) {
$parcel$export(module.exports, "default", () => $53d51d4b47cc846d$export$2e2bcd8739ae039);

var $7PDKX = parcelRequire("7PDKX");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $h47gY = parcelRequire("h47gY");

var $ch9En = parcelRequire("ch9En");

var $8deuc = parcelRequire("8deuc");
const $53d51d4b47cc846d$var$ServiceEntityFragmentRenderer = (props)=>{
    const { fragmentKey: fragmentKey, area: area, projectKey: projectKey, onChange: onChange } = props;
    const data = (0, $j4oe4.useFragment)((0, $7PDKX.default), fragmentKey);
    if (!data) return null;
    const affectedServices = data.selectedAffectedServicesConnection.edges;
    const initialServices = affectedServices.map((edge)=>{
        const name = edge?.node.name;
        const id = edge?.node.serviceId;
        if (!name || !id) return null;
        return {
            data: {
                id: id,
                name: name
            },
            id: id,
            name: name
        };
    }).filter((value)=>value != null) ?? [];
    const sortedInitialServices = initialServices.sort((a, b)=>a.name.localeCompare(b.name));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "field-service-entity",
        packageName: "jira-issue-field-service-entity"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "service-entity-field",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8deuc.ServiceEntityMain), {
        initialServices: sortedInitialServices,
        fieldId: data.fieldId,
        projectKey: projectKey,
        onChange: onChange,
        area: area
    })));
};
var $53d51d4b47cc846d$export$2e2bcd8739ae039 = $53d51d4b47cc846d$var$ServiceEntityFragmentRenderer;

});
parcelRegister("7PDKX", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fcd88a8c0b3bc88$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6501ce1a0d77956a088e09b011f8c061>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7fcd88a8c0b3bc88$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "sync_issueFieldServiceEntity_ServiceEntityFragmentRenderer",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            "action": "THROW",
            "path": "fieldId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraAffectedServiceConnection",
                "kind": "LinkedField",
                "name": "selectedAffectedServicesConnection",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraAffectedServiceEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "JiraAffectedService",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "ScalarField",
                                                    "name": "serviceId"
                                                },
                                                "action": "NONE",
                                                "path": "selectedAffectedServicesConnection.edges.node.serviceId"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                "action": "NONE",
                                                "path": "selectedAffectedServicesConnection.edges.node.name"
                                            }
                                        ]
                                    },
                                    "action": "NONE",
                                    "path": "selectedAffectedServicesConnection.edges.node"
                                }
                            ]
                        },
                        "action": "NONE",
                        "path": "selectedAffectedServicesConnection.edges"
                    }
                ]
            },
            "action": "NONE",
            "path": "selectedAffectedServicesConnection"
        }
    ],
    "type": "JiraAffectedServicesField"
};
$7fcd88a8c0b3bc88$var$node.hash = "588c820b68fb8df2d8934a0c9e94cdf5";
var $7fcd88a8c0b3bc88$export$2e2bcd8739ae039 = $7fcd88a8c0b3bc88$var$node;

});

parcelRegister("8deuc", function(module, exports) {
$parcel$export(module.exports, "ServiceEntityMain", () => $1c345c4f1d76c4ea$export$b2d6edf545429d95);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $bmoS1 = parcelRequire("bmoS1");

var $2rHwS = parcelRequire("2rHwS");

var $aMZVu = parcelRequire("aMZVu");

var $ghTBe = parcelRequire("ghTBe");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $jbJvT = parcelRequire("jbJvT");

var $ffj1A = parcelRequire("ffj1A");

var $7emTv = parcelRequire("7emTv");

var $39jkZ = parcelRequire("39jkZ");

var $hoa6w = parcelRequire("hoa6w");

var $8ywYE = parcelRequire("8ywYE");

var $1tGhP = parcelRequire("1tGhP");

var $f6gq6 = parcelRequire("f6gq6");

var $7FpnE = parcelRequire("7FpnE");

var $iSmqR = parcelRequire("iSmqR");

var $lYkoS = parcelRequire("lYkoS");

var $4Pnd1 = parcelRequire("4Pnd1");
const $1c345c4f1d76c4ea$export$b2d6edf545429d95 = (props)=>{
    const isIssueOfIncidentPractice = (0, $aMZVu.useIsIssueOfIncidentsPractice)();
    const [, actions] = (0, $ghTBe.useUpdatedServices)();
    const { area: area, fieldId: fieldId, projectKey: projectKey, onChange: onChange, initialServices: initialServices } = props;
    const issueKey = (0, $bmoS1.useIssueKey)();
    const [currentOpenObject, setCurrentOpenObject] = (0, $eJOHy.useState)();
    const [{ value: fieldConfig }] = (0, $2rHwS.useFieldConfig)(issueKey, (0, $39jkZ.toString)(fieldId));
    const onViewObjectDetails = (0, $eJOHy.useCallback)((cmdbObject)=>{
        setCurrentOpenObject(cmdbObject);
    }, []);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onCloseObjectDialog = ()=>{
        setCurrentOpenObject(undefined);
    };
    const HeaderContentWithoutProjectKey = (0, $eJOHy.useCallback)((headerContentWithoutProjectKeyProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iSmqR.HeaderContent), {
            projectKey: projectKey,
            onViewObjectDetails: onViewObjectDetails,
            ...headerContentWithoutProjectKeyProps
        }), [
        onViewObjectDetails,
        projectKey
    ]);
    const render = {
        HeaderContent: HeaderContentWithoutProjectKey,
        DetailContent: $7FpnE.DetailContent,
        OptionContent: $4Pnd1.OptionContent,
        AdditionalLabelContent: $f6gq6.AdditionalLabelContent
    };
    if (!fieldConfig) return null;
    const autoCompleteConfig = {
        context: fieldConfig,
        useAutoComplete: // eslint-disable-next-line react-hooks/react-compiler
        $1tGhP.useAutoComplete
    };
    const onSuccess = ()=>{
        (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'affectedServicesField updateSucceeded', {});
    };
    const onFailure = ()=>{
        (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'affectedServicesField updateFailed', {});
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jbJvT.RelayMigrationProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hoa6w.CollapsibleField), {
        initialServices: initialServices,
        isDuplicatesAllowed: false,
        fieldId: fieldId,
        actionSubject: "serviceRegistryInlineEdit",
        source: "service",
        isMultiple: true,
        area: area,
        // @ts-expect-error - TS2322 - Type '{ HeaderContent: (headerContentWithoutProjectKeyProps: HeaderContentWithoutInjectedProps) => JSX.Element; DetailContent: (props: Props) => JSX.Element | null; OptionContent: (props: OptionRenderProps<...>) => JSX.Element; AdditionalLabelContent: ({ values }: AdditionalLabelRenderProps<...>) => JSX.Element; }' is not assignable to type 'RenderType<ServiceDetails>'.
        render: render,
        messages: (0, $lYkoS.default),
        autoCompleteConfig: autoCompleteConfig,
        // eslint-disable-next-line react-hooks/react-compiler
        useResolveFieldValuesById: (0, $8ywYE.useResolveFieldValuesByIdGraphQL),
        onSuccess: onSuccess,
        onFailure: onFailure,
        onChange: onChange,
        onConfirm: ()=>{
            if (isIssueOfIncidentPractice) actions.updateServices();
        }
    }), (0, $7jTnu.fg)('assets_embed_object_view_in_object_graph') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7emTv.AssetsObjectGraphModal), {
        objectId: currentOpenObject?.objectId,
        objectTypeId: currentOpenObject?.objectType.objectTypeId,
        onClose: onCloseObjectDialog,
        source: "service",
        isObjectGraphOpen: !!currentOpenObject,
        disableResizePanel: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ffj1A.InsightObjectGraphModal), {
        objectId: currentOpenObject?.objectId,
        objectTypeId: currentOpenObject?.objectType.objectTypeId,
        onClose: onCloseObjectDialog,
        source: "service",
        isObjectGraphOpen: !!currentOpenObject
    }));
};

});
parcelRegister("ffj1A", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "InsightObjectGraph", () => $5f8b77f214aaaf0a$export$df140f9d4d4d50d1);
$parcel$export(module.exports, "InsightObjectGraphOrNull", () => $5f8b77f214aaaf0a$export$5ad8ce0659b457a3);
$parcel$export(module.exports, "InsightObjectGraphModal", () => $5f8b77f214aaaf0a$export$1f487400bf99b836);
$parcel$export(module.exports, "default", () => $5f8b77f214aaaf0a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1aLTh = parcelRequire("1aLTh");

var $7skWy = parcelRequire("7skWy");

var $eDFE1 = parcelRequire("eDFE1");

var $3Vx3n = parcelRequire("3Vx3n");

var $fq0Uu = parcelRequire("fq0Uu");

var $f4WMd = parcelRequire("f4WMd");

var $956it = parcelRequire("956it");

var $7ep4S = parcelRequire("7ep4S");

var $2ZGUP = parcelRequire("2ZGUP");

var $1KdDN = parcelRequire("1KdDN");

var $lRq8t = parcelRequire("lRq8t");

var $aC4Bh = parcelRequire("aC4Bh");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $8XHsn = parcelRequire("8XHsn");

var $8E59C = parcelRequire("8E59C");

var $eHeML = parcelRequire("eHeML");

var $8p4l3 = parcelRequire("8p4l3");


var $kI3vL = parcelRequire("kI3vL");

var $1bt9v = parcelRequire("1bt9v");

var $b3AXu = parcelRequire("b3AXu");

var $1Kd5r = parcelRequire("1Kd5r");

var $4ZeQj = parcelRequire("4ZeQj");

var $6XJko = parcelRequire("6XJko");

var $9wObp = parcelRequire("9wObp");

var $hExsh = parcelRequire("hExsh");

var $kOjSa = parcelRequire("kOjSa");

var $9CMZx = parcelRequire("9CMZx");

var $hbXh9 = parcelRequire("hbXh9");

var $5EIle = parcelRequire("5EIle");

var $jKBKy = parcelRequire("jKBKy");

var $evEEq = parcelRequire("evEEq");

var $lMjn6 = parcelRequire("lMjn6");

var $cQzhk = parcelRequire("cQzhk");

var $1xUOV = parcelRequire("1xUOV");

var $4AhY6 = parcelRequire("4AhY6");

var $i1PEV = parcelRequire("i1PEV");
const $5f8b77f214aaaf0a$var$DIALOG_WIDTH = 1280;
const $5f8b77f214aaaf0a$var$DIALOG_HEIGHT = 720;
const $5f8b77f214aaaf0a$var$FADEIN_ANIMATION_DELAY = 500;
const $5f8b77f214aaaf0a$export$df140f9d4d4d50d1 = ({ objectId: objectId, objectTypeId: objectTypeId, onClose: onClose, source: source })=>{
    const [selectedNode, { setSelectedObjectNode: setSelectedObjectNode, setSelectedObjectTypeNode: setSelectedObjectTypeNode }] = (0, $kOjSa.useSelectedNode)(objectId);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { workspaceId: workspaceId } = (0, $8XHsn.useWorkspaceContext)();
    const [sidebarState, sidebarActions] = (0, $kI3vL.usePushingSidebar)({
        width: 480
    });
    const [isConfigPanelOpen, setIsConfigPanelOpen] = (0, $eJOHy.useState)(false);
    const [isGraphLayoutLocked, setIsGraphLayoutLocked] = (0, $eJOHy.useState)(true);
    const [{ data: objectDetailsData, loading: objectDetailsLoading, error: objectDetailsError }, fetchObjectDetails] = (0, $b3AXu.useObjectDetailsService)();
    const [{ data: objectGraphData, loading: graphLoading, error: graphError }, fetchObjectGraph] = (0, $1Kd5r.useObjectGraphService)();
    const [{ referenceTypes: referenceTypes, maxOfSameType: maxOfSameType, referenceDepth: referenceDepth }, { updateReferenceDepth: updateReferenceDepth, updateMaxOfSameType: updateMaxOfSameType, updateReferenceTypes: updateReferenceTypes }] = (0, $hExsh.useObjectGraphConfiguration)(objectGraphData, objectTypeId);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fetchGraphData = (0, $eJOHy.useCallback)((objId)=>{
        if (workspaceId) fetchObjectGraph({
            workspaceId: workspaceId,
            objectId: (0, $4ZeQj.toCmdbObjectId)(objId),
            depth: referenceDepth,
            maxOfSameType: maxOfSameType
        });
    }, [
        fetchObjectGraph,
        maxOfSameType,
        referenceDepth,
        workspaceId
    ]);
    const transformedGraphData = (0, $eJOHy.useMemo)(()=>{
        // the initial graph data response goes through a series of transformations before it renders:
        // 1. we filter the nodes & edges based on the currently selected reference types in the object graph configuration panel
        // 2. we only show nodes that have a connection (either direct or indirect) to the currently selected object based on that filtering
        // 3. we then transform the result of that into a data shape the force graph library expects
        const filteredBySelectedReferenceTypes = (0, $i1PEV.getFilteredEdgesAndNodes)(objectGraphData, referenceTypes, selectedNode.referenceId);
        const nodesConnectedToSelectedNode = (0, $i1PEV.getConnectedNodesFromParent)(filteredBySelectedReferenceTypes, selectedNode.referenceId);
        return (0, $i1PEV.getNormalizedGraphData)(nodesConnectedToSelectedNode); // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        objectGraphData,
        referenceTypes
    ]);
    // in this case we do want to explicity exclude the reference id here
    const handleFetchObjectDetails = (0, $eJOHy.useCallback)(()=>{
        if (workspaceId) fetchObjectDetails({
            objectId: (0, $4ZeQj.toCmdbObjectId)(selectedNode.referenceId),
            workspaceId: workspaceId
        });
    }, [
        fetchObjectDetails,
        selectedNode.referenceId,
        workspaceId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (workspaceId) fetchObjectDetails({
            objectId: (0, $4ZeQj.toCmdbObjectId)(selectedNode.referenceId),
            workspaceId: workspaceId
        });
    }, [
        fetchObjectDetails,
        selectedNode.referenceId,
        workspaceId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        fetchGraphData(objectId);
    }, [
        fetchGraphData,
        fetchObjectGraph,
        objectId,
        workspaceId
    ]);
    const onNodeClicked = (0, $eJOHy.useCallback)((selectedObjectData)=>{
        const { data: data, dataType: dataType } = selectedObjectData;
        const { context: context } = data;
        if (dataType === (0, $1b8b2de41d1fcbdf$export$accaa52ddae3fe58) && context) {
            switch(context.type){
                case (0, $9wObp.GRAPH_NODE_TYPES).OBJECT:
                    setSelectedObjectNode(context.id);
                    break;
                case (0, $9wObp.GRAPH_NODE_TYPES).OBJECT_TYPE:
                    setSelectedObjectTypeNode(context);
                    break;
                default:
                    break;
            }
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'insightObjectGraphItem', {
                source: source
            });
        }
    }, [
        createAnalyticsEvent,
        setSelectedObjectNode,
        setSelectedObjectTypeNode,
        source
    ]);
    const onNodeDoubleClicked = (0, $eJOHy.useCallback)((selectedObjectData)=>{
        const { data: data, dataType: dataType } = selectedObjectData;
        const { context: context } = data;
        if (dataType === (0, $1b8b2de41d1fcbdf$export$accaa52ddae3fe58) && context?.type === (0, $9wObp.GRAPH_NODE_TYPES).OBJECT) fetchGraphData(context.id);
    }, [
        fetchGraphData
    ]);
    const onObjectAttributeClick = (0, $eJOHy.useCallback)((object)=>{
        const { nodes: nodes = [] } = transformedGraphData ?? {};
        const isNodeVisibleInGraph = nodes.some((n)=>n.context?.id === object.objectId);
        if (isNodeVisibleInGraph) setSelectedObjectNode(object.objectId);
        else {
            fetchGraphData(object.objectId);
            setSelectedObjectNode(object.objectId);
        }
    }, [
        fetchGraphData,
        setSelectedObjectNode,
        transformedGraphData
    ]);
    const onToggleLockedLayout = ()=>{
        const shouldLockGraph = !isGraphLayoutLocked;
        setIsGraphLayoutLocked(shouldLockGraph);
    };
    const HideObjectGraphDetailsIconComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, (/*@__PURE__*/$parcel$interopDefault($fq0Uu))) : (0, $eHeML.HideObjectGraphDetailsIcon);
    const ShowObjectGraphDetailsIconComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, (/*@__PURE__*/$parcel$interopDefault($f4WMd))) : (0, $eHeML.ShowObjectGraphDetailsIcon);
    const actionButtons = [
        {
            Icon: isGraphLayoutLocked ? (0, (/*@__PURE__*/$parcel$interopDefault($eDFE1))) : (0, (/*@__PURE__*/$parcel$interopDefault($3Vx3n))),
            label: formatMessage(isGraphLayoutLocked ? (0, $cQzhk.default).unlockLayout : (0, $cQzhk.default).lockLayout),
            onClick: onToggleLockedLayout,
            isSelected: isGraphLayoutLocked,
            iconSpacing: 'spacious'
        },
        {
            Icon: sidebarState.isOpen ? HideObjectGraphDetailsIconComponent : ShowObjectGraphDetailsIconComponent,
            testId: 'servicedesk-insight-object-graph.ui.graph-toggle-button',
            label: formatMessage(sidebarState.isOpen ? (0, $cQzhk.default).hideDetail : (0, $cQzhk.default).showDetail),
            onClick: (event, analyticsEvent)=>{
                (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'insightObjectGraphToggleDetailsPanel', {
                    action: sidebarState.isOpen ? 'hiding' : 'showing',
                    source: source
                });
                if (isConfigPanelOpen) setIsConfigPanelOpen(()=>false);
                sidebarActions.toggleSidebar();
            },
            iconSpacing: 'spacious'
        }
    ];
    const renderGraphError = ()=>{
        (0, $8E59C.graphModalExperience).failure();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $evEEq.GraphError), null);
    };
    const renderForceGraph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8p4l3.AsyncLazyForceGraph), {
            graphData: transformedGraphData,
            onNodeClick: onNodeClicked,
            onNodeDoubleClick: onNodeDoubleClicked,
            defaultSelectedNodeId: selectedNode.nodeId,
            isLayoutLocked: isGraphLayoutLocked
        });
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lMjn6.GraphHeader), {
        title: formatMessage((0, $cQzhk.default).title),
        onClose: onClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1bt9v.PushingSidebarContainer), sidebarState, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5f8b77f214aaaf0a$var$GraphWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1aLTh.default), {
        timeout: {
            exit: $5f8b77f214aaaf0a$var$FADEIN_ANIMATION_DELAY
        },
        in: graphLoading,
        unmountOnExit: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5f8b77f214aaaf0a$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "large"
    }))), !graphLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5f8b77f214aaaf0a$var$FadeIn, null, graphError ? renderGraphError() : renderForceGraph()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9CMZx.Actions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hbXh9.GraphConfigurationActionPanel), {
        isConfigPanelOpen: isConfigPanelOpen,
        onOpenChange: (isOpen)=>{
            // Only handle open events here. Close events are handled on the wrapper of this dialog because
            // otherwise clicks on the reference depth dropdown are considered "outside" this panel, and cause
            // the panel to close instead of updating the reference depth.
            isOpen && setIsConfigPanelOpen(true);
        },
        menuPosition: sidebarState.isOpen ? 'left' : 'right',
        renderActionButton: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9CMZx.ActionsButton), {
                ...triggerProps,
                onClick: (event)=>{
                    if (isConfigPanelOpen) setIsConfigPanelOpen(false);
                    triggerProps.onClick?.(event);
                },
                triggerRef: triggerRef,
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($7skWy))),
                label: formatMessage(isConfigPanelOpen ? (0, $cQzhk.default).hideGraphConfigPanel : (0, $cQzhk.default).showGraphConfigPanel),
                iconSpacing: "spacious",
                testId: "servicedesk-insight-object-graph.ui.graph-config-button"
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5f8b77f214aaaf0a$var$ConfigPanelHeader, null, formatMessage((0, $cQzhk.default).graphConfigPanelHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5EIle.ReferenceDepthConfigurationInputs), {
        maxOfSameType: maxOfSameType,
        referenceDepth: referenceDepth,
        onUpdateReferenceDepth: updateReferenceDepth,
        onUpdateMaxOfSameType: updateMaxOfSameType
    }), referenceTypes.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5f8b77f214aaaf0a$var$ReferenceTypeListHeader, null, formatMessage((0, $cQzhk.default).referenceTypesHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jKBKy.ReferenceTypeToggleList), {
        referenceTypes: referenceTypes,
        onChange: updateReferenceTypes
    })) : null), actionButtons.map((action)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9CMZx.ActionsButton), {
            testId: `servicedesk-insight-object-graph.ui.button-${action.label}`,
            key: action.label,
            ...action
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1bt9v.PushingSidebar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5f8b77f214aaaf0a$var$ObjectViewWrapper, null, selectedNode.type === (0, $9wObp.GRAPH_NODE_TYPES).OBJECT && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4AhY6.ObjectView), {
        objectDetails: objectDetailsData,
        objectDetailsLoading: objectDetailsLoading,
        objectDetailsError: objectDetailsError,
        onRefreshButtonClick: handleFetchObjectDetails,
        selectedObjectId: (0, $4ZeQj.toCmdbObjectId)(selectedNode.referenceId),
        onObjectAttributeClick: onObjectAttributeClick,
        source: source
    }), selectedNode.type === (0, $9wObp.GRAPH_NODE_TYPES).OBJECT_TYPE && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1xUOV.ObjectTypeView), {
        objectTypeNode: selectedNode
    })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5f8b77f214aaaf0a$var$Wrapper, {
        onClick: ()=>setIsConfigPanelOpen(false)
    }, content);
};
const $5f8b77f214aaaf0a$export$5ad8ce0659b457a3 = (props)=>{
    if (props.objectId !== undefined && props.objectTypeId !== undefined) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5f8b77f214aaaf0a$export$df140f9d4d4d50d1, props);
    return null;
};
const $5f8b77f214aaaf0a$export$1f487400bf99b836 = ({ objectId: objectId, objectTypeId: objectTypeId, onClose: onClose, source: source, testId: testId, isObjectGraphOpen: isObjectGraphOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, isObjectGraphOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "InsightObjectGraph",
        packageName: "jiraServiceDeskInsightObjectGraph",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aC4Bh.JiraModal), {
        width: $5f8b77f214aaaf0a$var$DIALOG_WIDTH,
        height: $5f8b77f214aaaf0a$var$DIALOG_HEIGHT,
        onClose: onClose,
        autoFocus: false,
        stackIndex: 1,
        testId: testId,
        messageId: "servicedesk-insight-object-graph.ui.modal-dialog",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5f8b77f214aaaf0a$export$5ad8ce0659b457a3, {
        objectId: objectId,
        objectTypeId: objectTypeId,
        onClose: onClose,
        source: source,
        isObjectGraphOpen: isObjectGraphOpen
    })))));
var $5f8b77f214aaaf0a$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $5f8b77f214aaaf0a$export$1f487400bf99b836;
const $5f8b77f214aaaf0a$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1lxo",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5f8b77f214aaaf0a$var$ObjectViewWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1kl7zgxb _4t3i1osq _bfhkqbzx _18m91wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5f8b77f214aaaf0a$var$GraphWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5f8b77f214aaaf0a$var$SpinnerWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _1bsb1osq _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $5f8b77f214aaaf0a$var$fadeIn = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5f8b77f214aaaf0a$var$FadeIn = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_tzy4idpf _4t3i1osq _1bsb1osq _j7hq1wwu _tip8kb7n _ju251bs3 _5sag1doz _1o51q7pw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5f8b77f214aaaf0a$var$ConfigPanelHeader = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_otyr1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5f8b77f214aaaf0a$var$ReferenceTypeListHeader = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "h3", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pk1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7skWy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1cf75b90a238d5d18d902ac995f2545e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56db64df0b3e22ba$var$_react = $56db64df0b3e22ba$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $56db64df0b3e22ba$var$_customize = $56db64df0b3e22ba$var$_interopRequireDefault((parcelRequire("iiRWr")));

var $56db64df0b3e22ba$var$_preferences = $56db64df0b3e22ba$var$_interopRequireDefault((parcelRequire("c8Sc8")));
function $56db64df0b3e22ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CustomizeIcon.
 * This component is CustomizeIcon, with `UNSAFE_fallbackIcon` set to "PreferencesIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $56db64df0b3e22ba$var$CustomizeIcon = (props)=>/*#__PURE__*/ $56db64df0b3e22ba$var$_react.default.createElement($56db64df0b3e22ba$var$_customize.default, Object.assign({
        name: "CustomizeIcon",
        LEGACY_fallbackIcon: $56db64df0b3e22ba$var$_preferences.default
    }, props));
$56db64df0b3e22ba$var$CustomizeIcon.displayName = 'CustomizeIconMigration';
var $56db64df0b3e22ba$var$_default = module.exports.default = $56db64df0b3e22ba$var$CustomizeIcon;

});
parcelRegister("iiRWr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c3a6b9bc7cd562874d0d59c11159dd71>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d533c021bfcfd692$var$_react = $d533c021bfcfd692$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d533c021bfcfd692$var$_baseNew = $d533c021bfcfd692$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $d533c021bfcfd692$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Customize".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d533c021bfcfd692$var$CustomizeIcon = (props)=>/*#__PURE__*/ $d533c021bfcfd692$var$_react.default.createElement($d533c021bfcfd692$var$_baseNew.default, Object.assign({
        name: "CustomizeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.375C3 1.615 3.616 1 4.375 1h1.75c.76 0 1.375.616 1.375 1.375v4.25C7.5 7.385 6.884 8 6.125 8h-1.75C3.615 8 3 7.384 3 6.625V5.25H0v-1.5h3zm1.5.125v4H6v-4zM16 5.25H8.5v-1.5H16zM8.5 9.375C8.5 8.615 9.116 8 9.875 8h1.75C12.385 8 13 8.616 13 9.375v1.375h3v1.5h-3v1.375c0 .76-.616 1.375-1.375 1.375h-1.75c-.76 0-1.375-.616-1.375-1.375zM10 9.5v4h1.5v-4zM0 12.25v-1.5h7.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$d533c021bfcfd692$var$CustomizeIcon.displayName = 'CustomizeIcon';
var $d533c021bfcfd692$var$_default = module.exports.default = $d533c021bfcfd692$var$CustomizeIcon;

});

parcelRegister("c8Sc8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8d70455a797b43c6$var$_react = $8d70455a797b43c6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $8d70455a797b43c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8d70455a797b43c6$var$PreferencesIcon = (props)=>/*#__PURE__*/ $8d70455a797b43c6$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M3 7h3v2H3zm0 8h11v2H3zm7-8h11v2H10zm8 8h3v2h-3z"/><path d="M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0M9 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0m10 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-2 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0"/></g></svg>`
    }, props));
$8d70455a797b43c6$var$PreferencesIcon.displayName = 'PreferencesIcon';
var $8d70455a797b43c6$var$_default = module.exports.default = $8d70455a797b43c6$var$PreferencesIcon;

});


parcelRegister("3Vx3n", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b76a1b441dfe57f1fba67ba2ac08fda2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2dc055afccfb6415$var$_react = $2dc055afccfb6415$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $2dc055afccfb6415$var$_lockUnlocked = $2dc055afccfb6415$var$_interopRequireDefault((parcelRequire("ffGm1")));

var $2dc055afccfb6415$var$_unlockFilled = $2dc055afccfb6415$var$_interopRequireDefault((parcelRequire("g7Yw9")));
function $2dc055afccfb6415$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LockUnlockedIcon.
 * This component is LockUnlockedIcon, with `UNSAFE_fallbackIcon` set to "UnlockFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: unlocked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2dc055afccfb6415$var$LockUnlockedIcon = (props)=>/*#__PURE__*/ $2dc055afccfb6415$var$_react.default.createElement($2dc055afccfb6415$var$_lockUnlocked.default, Object.assign({
        name: "LockUnlockedIcon",
        LEGACY_fallbackIcon: $2dc055afccfb6415$var$_unlockFilled.default
    }, props));
$2dc055afccfb6415$var$LockUnlockedIcon.displayName = 'LockUnlockedIconMigration';
var $2dc055afccfb6415$var$_default = module.exports.default = $2dc055afccfb6415$var$LockUnlockedIcon;

});
parcelRegister("ffGm1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5c5d989acf678b87189f6f5a97917ee9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b1a91c657233a66e$var$_react = $b1a91c657233a66e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $b1a91c657233a66e$var$_baseNew = $b1a91c657233a66e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $b1a91c657233a66e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockUnlocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: unlocked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b1a91c657233a66e$var$LockUnlockedIcon = (props)=>/*#__PURE__*/ $b1a91c657233a66e$var$_react.default.createElement($b1a91c657233a66e$var$_baseNew.default, Object.assign({
        name: "LockUnlockedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3H12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2V4a4 4 0 1 1 8 0h-1.5A2.5 2.5 0 0 0 8 1.5m-4 7a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$b1a91c657233a66e$var$LockUnlockedIcon.displayName = 'LockUnlockedIcon';
var $b1a91c657233a66e$var$_default = module.exports.default = $b1a91c657233a66e$var$LockUnlockedIcon;

});

parcelRegister("g7Yw9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bbdc3e533d48b4e3$var$_react = $bbdc3e533d48b4e3$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $bbdc3e533d48b4e3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bbdc3e533d48b4e3$var$UnlockFilledIcon = (props)=>/*#__PURE__*/ $bbdc3e533d48b4e3$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M5 11.009C5 9.899 5.897 9 7.006 9h9.988A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991zM12 17a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/><path fill-rule="nonzero" d="M8 6.251v-.249A4.004 4.004 0 0 1 12 2a4 4 0 0 1 4 4.002V6.5h-2v-.498A2 2 0 0 0 12 4c-1.102 0-2 .898-2 2.002V11H8zm6 .249h2a1 1 0 0 1-2 0"/></g></svg>`
    }, props));
$bbdc3e533d48b4e3$var$UnlockFilledIcon.displayName = 'UnlockFilledIcon';
var $bbdc3e533d48b4e3$var$_default = module.exports.default = $bbdc3e533d48b4e3$var$UnlockFilledIcon;

});


parcelRegister("8E59C", function(module, exports) {
$parcel$export(module.exports, "graphModalExperience", () => $79a3682474cbe191$export$1b179afadba799dc);
$parcel$export(module.exports, "rapidSearchExperience", () => $79a3682474cbe191$export$1a90deecc86e78f8);
$parcel$export(module.exports, "autocompleteInsightFieldExperience", () => $79a3682474cbe191$export$94337fa170a193d2);
$parcel$export(module.exports, "fetchAffectedServicesExperience", () => $79a3682474cbe191$export$ce8d2a860f4e0316);
$parcel$export(module.exports, "objectDetailsViewExperience", () => $79a3682474cbe191$export$8e0a16d0fc0feba3);
$parcel$export(module.exports, "objectViewInlineEditSwitchFromReadToEditModeExperience", () => $79a3682474cbe191$export$5ae0e1bbe443c52b);
$parcel$export(module.exports, "objectViewInlineEditSwitchFromEditToReadModeExperience", () => $79a3682474cbe191$export$b9c9c5e92fa6a3a4);
$parcel$export(module.exports, "createObjectTypeExperience", () => $79a3682474cbe191$export$15a29f6e079c9b3d);
$parcel$export(module.exports, "createObjectExperience", () => $79a3682474cbe191$export$aaf507c87c29ab22);
$parcel$export(module.exports, "loadSchemaObjectListExperience", () => $79a3682474cbe191$export$6f02ba4c2b1e3f5f);
$parcel$export(module.exports, "loadAttributesConfigurationExperience", () => $79a3682474cbe191$export$8f63f06b0486e498);
$parcel$export(module.exports, "updateObjectFilterExperience", () => $79a3682474cbe191$export$967859e6be8e6f4b);
$parcel$export(module.exports, "getUpdateGlobalConfigInlineEditExperience", () => $79a3682474cbe191$export$e4deb66475dfa46b);
$parcel$export(module.exports, "loadObjectDetailExperience", () => $79a3682474cbe191$export$3f1da23c065671d2);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");
const $79a3682474cbe191$export$1b179afadba799dc = new (0, $f39LL.UFOExperience)('service-management.insight-cmdb.display-graph-modal', {
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult,
    type: (0, $2lxLk.ExperienceTypes).Experience
});
const $79a3682474cbe191$export$1a90deecc86e78f8 = new (0, $f39LL.UFOExperience)('service-management.insight-cmdb.display-rapid-search-results', {
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult,
    type: (0, $2lxLk.ExperienceTypes).Experience
});
const $79a3682474cbe191$export$94337fa170a193d2 = new (0, $f39LL.UFOExperience)('service-management.insight-cmdb.autocomplete-search-insight-field', {
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult,
    type: (0, $2lxLk.ExperienceTypes).Experience,
    featureFlags: [
        'jsm-insight-field-performance-improvements_fplgq'
    ]
});
const $79a3682474cbe191$export$ce8d2a860f4e0316 = new (0, $f39LL.UFOExperience)('service-management.insight-cmdb.fetch-affected-services', {
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult,
    type: (0, $2lxLk.ExperienceTypes).Experience
});
const $79a3682474cbe191$export$8e0a16d0fc0feba3 = new (0, $f39LL.UFOExperience)('jsm-cmdb-object-details-view', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
});
const $79a3682474cbe191$export$5ae0e1bbe443c52b = new (0, $f39LL.UFOExperience)('service-management.insight-cmdb.object-view-inline-edit.switch-from-read-to-edit-mode', {
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult,
    type: (0, $2lxLk.ExperienceTypes).Experience
});
const $79a3682474cbe191$export$b9c9c5e92fa6a3a4 = new (0, $f39LL.UFOExperience)('service-management.insight-cmdb.object-view-inline-edit.switch-from-edit-to-read-mode', {
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult,
    type: (0, $2lxLk.ExperienceTypes).Experience
});
const $79a3682474cbe191$export$15a29f6e079c9b3d = new (0, $f39LL.UFOExperience)('jsm-cmdb-create-object-type', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom,
    timings: [
        {
            key: 'created-on-server',
            endMark: 'object-type-created-on-server'
        }
    ]
});
const $79a3682474cbe191$export$aaf507c87c29ab22 = new (0, $f39LL.UFOExperience)('service-management.insight-cmdb.create-object', {
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult,
    type: (0, $2lxLk.ExperienceTypes).Experience
});
const $79a3682474cbe191$export$6f02ba4c2b1e3f5f = new (0, $f39LL.UFOExperience)('jsm-cmdb-load-object-list', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
});
const $79a3682474cbe191$export$8f63f06b0486e498 = new (0, $f39LL.UFOExperience)('jsm-cmdb-load-attributes-tab', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
});
const $79a3682474cbe191$export$967859e6be8e6f4b = new (0, $f39LL.UFOExperience)('jsm-cmdb-object-filter', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom,
    timings: [
        {
            key: 'response-received',
            endMark: 'server-response-received'
        },
        {
            key: 'object-table-rendered',
            endMark: 'object-table-rendered'
        },
        {
            key: 'object-list-rendered',
            endMark: 'object-list-rendered'
        },
        {
            key: 'no-filter-results-rendered',
            endMark: 'no-filter-results-rendered'
        }
    ]
});
const $79a3682474cbe191$export$e4deb66475dfa46b = ()=>new (0, $f39LL.UFOExperience)('service-management.insight-cmdb.global-config-inline-edit.update', {
        performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult,
        type: (0, $2lxLk.ExperienceTypes).Experience
    });
const $79a3682474cbe191$export$3f1da23c065671d2 = new (0, $f39LL.UFOExperience)('service-management.insight-cmdb.embedded-object-details-view', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("eHeML", function(module, exports) {
$parcel$export(module.exports, "ObjectSchemasIcon", () => $257dbe052c823ab5$export$bea30a91ea911ed8);
$parcel$export(module.exports, "ObjectGraphGlyph", () => $257dbe052c823ab5$export$fd4e4ffca6161634);
$parcel$export(module.exports, "ObjectGraphIcon", () => $257dbe052c823ab5$export$7fd55e0f2e77172c);
$parcel$export(module.exports, "ShowObjectGraphDetailsIcon", () => $257dbe052c823ab5$export$a96f5718ff672e9d);
$parcel$export(module.exports, "HideObjectGraphDetailsIcon", () => $257dbe052c823ab5$export$cf601da3438765d9);
$parcel$export(module.exports, "SchemaIcon", () => $257dbe052c823ab5$export$fc6a25a0b4021903);
$parcel$export(module.exports, "ColumnsIcon", () => $257dbe052c823ab5$export$38f001d9cffdd080);
$parcel$export(module.exports, "QrCodeIcon", () => $257dbe052c823ab5$export$33dd147542b2195b);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $2z85P = parcelRequire("2z85P");

var $3qVNB = parcelRequire("3qVNB");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $f2JN3 = parcelRequire("f2JN3");

var $6XJko = parcelRequire("6XJko");

var $j0zcH = parcelRequire("j0zcH");
const $257dbe052c823ab5$export$58cebcda192184d0 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 8C14.8954 8 14 8.89543 14 10V12C14 13.1046 14.8954 14 16 14H18C19.1046 14 20 13.1046 20 12V10C20 8.89543 19.1046 8 18 8H16ZM18 10H16V12H18V10Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 16C14.8954 16 14 16.8954 14 18V20C14 21.1046 14.8954 22 16 22H18C19.1046 22 20 21.1046 20 20V18C20 16.8954 19.1046 16 18 16H16ZM18 18H16V20H18V18Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 2C4.89543 2 4 2.89543 4 4V6C4 7.10457 4.89543 8 6 8H8C9.10457 8 10 7.10457 10 6V4C10 2.89543 9.10457 2 8 2H6ZM8 4H6V6H8V4Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        x: "6",
        y: "7",
        width: "2",
        height: "11",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6 18H15V20H8C6.89543 20 6 19.1046 6 18Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6 10H15V12H8C6.89543 12 6 11.1046 6 10Z",
        fill: "currentColor"
    }));
const $257dbe052c823ab5$export$bea30a91ea911ed8 = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), (0, (/*@__PURE__*/$parcel$interopDefault($2z85P))), (0, $j0zcH.createCustomAKIcon)($257dbe052c823ab5$export$58cebcda192184d0));
const $257dbe052c823ab5$export$fd4e4ffca6161634 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        cx: "4",
        cy: "4",
        r: "2",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        cx: "6",
        cy: "18",
        r: "2",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        cx: "20",
        cy: "6",
        r: "2",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        cx: "18",
        cy: "19",
        r: "2",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 15a4 4 0 100-8 4 4 0 000 8zm0-2a2 2 0 100-4 2 2 0 000 4z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M4 4l6 5.5m9.5-3l-5 3m-8 8l4-4.5m8 6.5l-5-6",
        stroke: "currentColor",
        strokeWidth: "1.5"
    }));
const $257dbe052c823ab5$export$7fd55e0f2e77172c = (0, $j0zcH.createCustomAKIcon)($257dbe052c823ab5$export$fd4e4ffca6161634);
const $257dbe052c823ab5$var$ShowObjectGraphDetailsGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M20 2H2V4H9V9H11V4H20V20H11V15H9V20H2V22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M2.47 12.8835C2.19 12.7165 2 12.3835 2 11.9995C2 11.6155 2.19 11.2825 2.47 11.1155L5.086 8.49946C5.2746 8.3173 5.5272 8.21651 5.7894 8.21879C6.0516 8.22107 6.30241 8.32623 6.48782 8.51164C6.67323 8.69705 6.7784 8.94786 6.78067 9.21006C6.78295 9.47226 6.68216 9.72486 6.5 9.91346L4.938 10.9995H10.118C10.605 10.9995 11 11.4475 11 11.9995C11 12.5515 10.605 12.9995 10.118 12.9995H4.938L6.5 14.0855C6.68216 14.2741 6.78295 14.5267 6.78067 14.7889C6.7784 15.0511 6.67323 15.3019 6.48782 15.4873C6.30241 15.6727 6.0516 15.7779 5.7894 15.7801C5.5272 15.7824 5.2746 15.6816 5.086 15.4995L2.47 12.8835Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M13 7C13 6.44772 13.4477 6 14 6H17C17.5523 6 18 6.44772 18 7C18 7.55228 17.5523 8 17 8H14C13.4477 8 13 7.55228 13 7Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M13 11C13 10.4477 13.4477 10 14 10H17C17.5523 10 18 10.4477 18 11C18 11.5523 17.5523 12 17 12H14C13.4477 12 13 11.5523 13 11Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M13 15C13 14.4477 13.4477 14 14 14H17C17.5523 14 18 14.4477 18 15C18 15.5523 17.5523 16 17 16H14C13.4477 16 13 15.5523 13 15Z",
        fill: "currentColor"
    }));
const $257dbe052c823ab5$var$HideObjectGraphDetailsGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M19 2H2V4H14V9H16V4H19V20H16V15H14V20H2V22H19C20.1046 22 21 21.1046 21 20V4C21 2.89543 20.1046 2 19 2Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.53 12.8835C12.81 12.7165 13 12.3835 13 11.9995C13 11.6155 12.81 11.2825 12.53 11.1155L9.914 8.49946C9.7254 8.3173 9.4728 8.21651 9.2106 8.21879C8.9484 8.22107 8.69759 8.32623 8.51218 8.51164C8.32677 8.69705 8.2216 8.94786 8.21933 9.21006C8.21705 9.47226 8.31784 9.72486 8.5 9.91346L10.062 10.9995H2.882C2.395 10.9995 2 11.4475 2 11.9995C2 12.5515 2.395 12.9995 2.882 12.9995H10.062L8.5 14.0855C8.31784 14.2741 8.21705 14.5267 8.21933 14.7889C8.2216 15.0511 8.32677 15.3019 8.51218 15.4873C8.69759 15.6727 8.9484 15.7779 9.2106 15.7801C9.4728 15.7824 9.7254 15.6816 9.914 15.4995L12.53 12.8835Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M14 9H16V15H14V9Z",
        fill: "currentColor"
    }));
const $257dbe052c823ab5$export$a96f5718ff672e9d = (0, $j0zcH.createCustomAKIcon)($257dbe052c823ab5$var$ShowObjectGraphDetailsGlyph);
const $257dbe052c823ab5$export$cf601da3438765d9 = (0, $j0zcH.createCustomAKIcon)($257dbe052c823ab5$var$HideObjectGraphDetailsGlyph);
const $257dbe052c823ab5$var$SchemaGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        x: "0.5",
        y: "0.5",
        width: "47",
        height: "47",
        rx: "4.5",
        fill: "white",
        stroke: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.6665 18.6667C27.5619 18.6667 26.6665 19.5621 26.6665 20.6667V24.6667C26.6665 25.7713 27.5619 26.6667 28.6665 26.6667H32.6665C33.7711 26.6667 34.6665 25.7713 34.6665 24.6667V20.6667C34.6665 19.5621 33.7711 18.6667 32.6665 18.6667H28.6665ZM31.9998 21.3334H29.3331V24.0001H31.9998V21.3334Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.6665 29.3333C27.5619 29.3333 26.6665 30.2287 26.6665 31.3333V35.3333C26.6665 36.4379 27.5619 37.3333 28.6665 37.3333H32.6665C33.7711 37.3333 34.6665 36.4379 34.6665 35.3333V31.3333C34.6665 30.2287 33.7711 29.3333 32.6665 29.3333H28.6665ZM31.9998 31.9999H29.3331V34.6666H31.9998V31.9999Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.3335 10.6667C14.2289 10.6667 13.3335 11.5621 13.3335 12.6667V16.6667C13.3335 17.7713 14.2289 18.6667 15.3335 18.6667H19.3335C20.4381 18.6667 21.3335 17.7713 21.3335 16.6667V12.6667C21.3335 11.5621 20.4381 10.6667 19.3335 10.6667H15.3335ZM18.6669 13.3334H16.0002V16.0001H18.6669V13.3334Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        x: "16",
        y: "17.3333",
        width: "2.66667",
        height: "14.6667",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M16 32H28V34.6667H18C16.8954 34.6667 16 33.7712 16 32.6667V32Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M16 21.3333H28V24H18C16.8954 24 16 23.1046 16 22V21.3333Z",
        fill: "#42526E"
    }));
const $257dbe052c823ab5$export$fc6a25a0b4021903 = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $257dbe052c823ab5$var$iconBorder
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2z85P))), props)), (0, $j0zcH.createCustomAKIcon)($257dbe052c823ab5$var$SchemaGlyph));
const $257dbe052c823ab5$var$ColumnsGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 6H2V8V20V22H4H7H9V20V19H7V20H4V8H5V6H4Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 8H17V20H20V8ZM15 6V22H22V6H15Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 4H9V15H12V4ZM7 2V17H14V2H7Z",
        fill: "currentColor"
    }));
const $257dbe052c823ab5$export$38f001d9cffdd080 = (0, $j0zcH.createCustomAKIcon)($257dbe052c823ab5$var$ColumnsGlyph);
const $257dbe052c823ab5$var$QrCodeGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 4V7H4V4H7V2H4H2V4ZM4 17H2V20V22H4H7V20H4V17ZM22 4V7H20V4H17V2H20H22V4ZM22 17H20V20H17V22H20H22V20V17ZM19 9H13V11H19V9ZM8 13H11V15H8V13ZM11 17H8V19H11V17ZM13 5H15V8H13V5ZM7 13H5V19H7V13ZM17 5H19V8H17V5ZM11 5H5V11H11V5ZM9 7H7V9H9V7ZM13 13H19V19H13V13ZM15 15H17V17H15V15Z",
        fill: "currentColor"
    }));
const $257dbe052c823ab5$export$33dd147542b2195b = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3qVNB))), {
        spacing: "spacious",
        ...props
    }), (0, $j0zcH.createCustomAKIcon)($257dbe052c823ab5$var$QrCodeGlyph));
const $257dbe052c823ab5$var$iconBorder = (0, $1DXK0.xcss)({
    width: '24px',
    height: '24px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: 'solid 1px',
    borderRadius: 'radius.small',
    borderColor: 'color.border'
});

});
parcelRegister("2z85P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3dee8baecbe96fe2899a780b63945d22>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1de520c84cbadd21$var$_react = $1de520c84cbadd21$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $1de520c84cbadd21$var$_baseNew = $1de520c84cbadd21$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $1de520c84cbadd21$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsSchema".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for JSM Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1de520c84cbadd21$var$AssetsSchemaIcon = (props)=>/*#__PURE__*/ $1de520c84cbadd21$var$_react.default.createElement($1de520c84cbadd21$var$_baseNew.default, Object.assign({
        name: "AssetsSchemaIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V6.5h4.628a2.25 2.25 0 1 1 0 1.5H5v3.625a.5.5 0 0 0 .5.5h4.088a2.25 2.25 0 1 1 .088 1.5H5.5a2 2 0 0 1-2-2V5.372A2.25 2.25 0 0 1 2 3.25m9.75 3.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m0 5.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$1de520c84cbadd21$var$AssetsSchemaIcon.displayName = 'AssetsSchemaIcon';
var $1de520c84cbadd21$var$_default = module.exports.default = $1de520c84cbadd21$var$AssetsSchemaIcon;

});

parcelRegister("3qVNB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0abcd48ddfe8bb24a4425c81a8c9ffca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2800a27e25d0de3b$var$_react = $2800a27e25d0de3b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $2800a27e25d0de3b$var$_baseNew = $2800a27e25d0de3b$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $2800a27e25d0de3b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QrCode".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for QR code experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2800a27e25d0de3b$var$QrCodeIcon = (props)=>/*#__PURE__*/ $2800a27e25d0de3b$var$_react.default.createElement($2800a27e25d0de3b$var$_baseNew.default, Object.assign({
        name: "QrCodeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10 10h2v2h-2z"/><path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v2.25H1V3a2 2 0 0 1 2-2h2.25v1.5zM10.75 1H13a2 2 0 0 1 2 2v2.25h-1.5V3a.5.5 0 0 0-.5-.5h-2.25zM4 4h5v5H4zm1.5 1.5v2h2v-2zm5 2.5V4H12v4zM8 12H4v-1.5h4zm-7 1v-2.25h1.5V13a.5.5 0 0 0 .5.5h2.25V15H3a2 2 0 0 1-2-2m12.5 0v-2.25H15V13a2 2 0 0 1-2 2h-2.25v-1.5H13a.5.5 0 0 0 .5-.5" clip-rule="evenodd"/>`
    }, props));
$2800a27e25d0de3b$var$QrCodeIcon.displayName = 'QrCodeIcon';
var $2800a27e25d0de3b$var$_default = module.exports.default = $2800a27e25d0de3b$var$QrCodeIcon;

});

parcelRegister("j0zcH", function(module, exports) {
$parcel$export(module.exports, "createCustomAKIcon", () => $f3dae6aa4bf179fc$export$80e74912a0a07a42);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $f3dae6aa4bf179fc$export$80e74912a0a07a42 = (glyph)=>(props)=>// @ts-expect-error - TS2769 - No overload matches this call.
        /*#__PURE__*/ (0, $eJOHy.createElement)((0, $fL0In.default), {
            glyph: glyph,
            ...props
        });

});


parcelRegister("8p4l3", function(module, exports) {
$parcel$export(module.exports, "AsyncLazyForceGraph", () => $73662adc6702b8fc$export$786a65e3efaf54c3);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $73662adc6702b8fc$var$LazyForceGraph = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("udBDF")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/insight-common/insight-graphs/force-graph/src/ui/index.tsx"
});
const $73662adc6702b8fc$export$786a65e3efaf54c3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "async.jira-servicedesk-insight-graphs-force-graph",
        packageName: "atlassian/jira-servicedesk-insight-graphs-force-graph"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "iira-servicedesk-insight-graphs-force-graph",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73662adc6702b8fc$var$LazyForceGraph, props)));

});
parcelRegister("udBDF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("128yZ").then(()=>parcelRequire('he0oB'));

});


const $1b8b2de41d1fcbdf$export$accaa52ddae3fe58 = 'node';
const $1b8b2de41d1fcbdf$export$7093ae9f18906e17 = 34;
const $1b8b2de41d1fcbdf$export$cf8a94c984678862 = 480;
const $1b8b2de41d1fcbdf$export$434d30b064b8d4cf = 120;

parcelRegister("kI3vL", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_SIDEBAR_WIDTH", () => $5e56986d38216b1c$export$444990cc7caeb4e0);
$parcel$export(module.exports, "usePushingSidebar", () => $5e56986d38216b1c$export$5ad0920cf30d9f08);

var $eJOHy = parcelRequire("eJOHy");
const $5e56986d38216b1c$export$444990cc7caeb4e0 = 300;
const $5e56986d38216b1c$export$5ad0920cf30d9f08 = ({ width: width = $5e56986d38216b1c$export$444990cc7caeb4e0, defaultIsOpen: defaultIsOpen = true })=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(defaultIsOpen);
    const toggleSidebar = ()=>{
        setIsOpen((a)=>!a);
    };
    return [
        {
            isOpen: isOpen,
            sidebarWidth: width
        },
        {
            toggleSidebar: toggleSidebar
        }
    ];
};

});

parcelRegister("1bt9v", function(module, exports) {
$parcel$export(module.exports, "PushingSidebarContainer", () => $fdbd547af458f3ef$export$7c3791d941a9e44f);
$parcel$export(module.exports, "PushingSidebar", () => $fdbd547af458f3ef$export$77de6aa1a2719891);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $bmZ1f = parcelRequire("bmZ1f");

var $34ZNB = parcelRequire("34ZNB");

var $kI3vL = parcelRequire("kI3vL");
const $fdbd547af458f3ef$var$SidebarContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    sidebarWidth: 0,
    isOpen: true
});
const $fdbd547af458f3ef$export$7c3791d941a9e44f = ({ sidebarWidth: sidebarWidth = (0, $kI3vL.DEFAULT_SIDEBAR_WIDTH), isOpen: isOpen, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdbd547af458f3ef$var$SidebarContext.Provider, {
        value: {
            sidebarWidth: sidebarWidth,
            isOpen: isOpen
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdbd547af458f3ef$var$SidebarContainerWrapper, {
        sidebarWidth: sidebarWidth,
        isOpen: isOpen
    }, props.children));
const $fdbd547af458f3ef$export$77de6aa1a2719891 = (props)=>{
    const { isOpen: isOpen, sidebarWidth: sidebarWidth } = (0, $eJOHy.useContext)($fdbd547af458f3ef$var$SidebarContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bmZ1f.default), {
        classNames: "pushing-sidebar-transition",
        in: isOpen,
        timeout: (0, $34ZNB.durations).medium,
        unmountOnExit: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdbd547af458f3ef$var$SidebarWrapper, {
        width: sidebarWidth
    }, props.children));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fdbd547af458f3ef$var$SidebarContainerWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOpen: isOpen, sidebarWidth: sidebarWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1pe7rvv": (0, $awdRS.default)(__cmplp.sidebarWidth, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _v564zzy9 _kqswh2mm _4t3i1osq _m6k4l4pu",
            __cmplp.isOpen && "_u5f3pybg",
            __cmplp.className
        ])
    });
});
const $fdbd547af458f3ef$var$SidebarWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $awdRS.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_v5641y37 _4t3i1osq _kqswstnw _154iidpf _1xi2idpf _1bsb1efm _kxovxwn4 _1p92z12g _1sctz12g _ig7mxwn4",
            __cmplp.className
        ])
    });
});

});

parcelRegister("b3AXu", function(module, exports) {
$parcel$export(module.exports, "useObjectDetailsService", () => $ef9159559c714714$export$3a033196e5926e63);

var $eJOHy = parcelRequire("eJOHy");

var $hPZg4 = parcelRequire("hPZg4");

var $51aj0 = parcelRequire("51aj0");

var $jGzN3 = parcelRequire("jGzN3");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $fmrTU = parcelRequire("fmrTU");

var $55tVS = parcelRequire("55tVS");
const $ef9159559c714714$export$3a033196e5926e63 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const request = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7031 - Binding element 'objectId' implicitly has an 'any' type. | TS7031 - Binding element 'workspaceId' implicitly has an 'any' type.
    ({ objectId: objectId, workspaceId: workspaceId })=>(0, $jGzN3.performGetRequest)((0, $fmrTU.getObjectDetailsUrl)(workspaceId, objectId)).then((0, $55tVS.transformInsightServiceObjectToCmdbObjectResponse)).then((0, $55tVS.transformBackendValueToCmdbObject)).then((cmdbObject)=>{
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchObjectDetails succeeded');
            return cmdbObject;
        }).catch((error)=>{
            (0, $51aj0.fireCmdbErrorAnalytics)({
                error: error,
                meta: {
                    id: 'fetchObjectDetails',
                    packageName: 'jiraServicedeskInsightObjectServices',
                    teamName: 'aurum'
                }
            });
            throw error;
        }), [
        createAnalyticsEvent
    ]);
    const { loading: loading, error: error, data: data, fetch: fetchObjectDetails } = (0, $hPZg4.useService)(request);
    return [
        {
            loading: loading,
            error: error,
            data: data
        },
        fetchObjectDetails
    ];
};

});
parcelRegister("51aj0", function(module, exports) {
$parcel$export(module.exports, "fireCmdbErrorAnalytics", () => $56baf2f8ac73469d$export$50d4fa14efd248c2);

var $gYnSx = parcelRequire("gYnSx");
const $56baf2f8ac73469d$export$50d4fa14efd248c2 = (payload)=>{
    return (0, $gYnSx.default)(payload);
};

});

parcelRegister("fmrTU", function(module, exports) {
$parcel$export(module.exports, "getObjectDetailsUrl", () => $c3e34130766ce084$export$fc01f82f5493edda);
$parcel$export(module.exports, "getEditableAttributeTypesUrl", () => $c3e34130766ce084$export$9155c371d7993c05);
$parcel$export(module.exports, "getObjectTypesUrl", () => $c3e34130766ce084$export$a9260b331252f36a);
$parcel$export(module.exports, "getObjectSchemaPropertyUrl", () => $c3e34130766ce084$export$d4234a7e4577aed6);

var $9VcRq = parcelRequire("9VcRq");

var $5AdC3 = parcelRequire("5AdC3");

var $bg0VY = parcelRequire("bg0VY");

var $8rYjX = parcelRequire("8rYjX");
const $c3e34130766ce084$export$fc01f82f5493edda = (workspaceId, objectId)=>(0, $8rYjX.getCmdbObjectByIdUrl)(workspaceId, objectId);
const $c3e34130766ce084$export$9155c371d7993c05 = (workspaceId, objectTypeId)=>(0, $bg0VY.getCmdbObjectTypeByIdAttributesUrl)(workspaceId, objectTypeId, {
        onlyValueEditable: true
    });
const $c3e34130766ce084$export$a9260b331252f36a = (workspaceId, objectSchemaId)=>(0, $5AdC3.getCmdbObjectSchemaByIdObjectTypesUrl)(workspaceId, objectSchemaId, {
        excludeAbstract: true
    });
const $c3e34130766ce084$export$d4234a7e4577aed6 = (workspaceId, objectSchemaId)=>(0, $9VcRq.getCmdbGlobalConfigObjectSchemaByIdPropertyUrl)(workspaceId, objectSchemaId);

});
parcelRegister("9VcRq", function(module, exports) {
$parcel$export(module.exports, "getCmdbGlobalConfigUrl", () => $4638d838a8d16ed5$export$50437136a9a5e2d3);
$parcel$export(module.exports, "getCmdbGlobalConfigObjectUrl", () => $4638d838a8d16ed5$export$73e58b72a1074528);
$parcel$export(module.exports, "getCmdbGlobalConfigObjectSchemaByIdUrl", () => $4638d838a8d16ed5$export$e2019224257efde3);
$parcel$export(module.exports, "getCmdbGlobalConfigObjectSchemaByIdPropertyUrl", () => $4638d838a8d16ed5$export$d1b25f8feb06db8a);

var $b5RwB = parcelRequire("b5RwB");

var $1qZG3 = parcelRequire("1qZG3");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/global
 */ const $4638d838a8d16ed5$var$getCmdbGlobalUrl = (workspaceId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/global`;
const $4638d838a8d16ed5$export$50437136a9a5e2d3 = (workspaceId)=>`${$4638d838a8d16ed5$var$getCmdbGlobalUrl(workspaceId)}/config`;
const $4638d838a8d16ed5$export$73e58b72a1074528 = (workspaceId, queryParams)=>`${$4638d838a8d16ed5$var$getCmdbGlobalUrl(workspaceId)}/config/object?${(0, $b5RwB.stringify)(queryParams)}`;
const $4638d838a8d16ed5$export$e2019224257efde3 = (workspaceId, objectSchemaId)=>`${$4638d838a8d16ed5$var$getCmdbGlobalUrl(workspaceId)}/config/objectschema/${objectSchemaId}`;
const $4638d838a8d16ed5$export$d1b25f8feb06db8a = (workspaceId, objectSchemaId)=>`${$4638d838a8d16ed5$var$getCmdbGlobalUrl(workspaceId)}/config/objectschema/${objectSchemaId}/property`;

});

parcelRegister("5AdC3", function(module, exports) {
$parcel$export(module.exports, "getCmdbObjectSchemaByIdUrl", () => $6567e178f8cb9d45$export$7a8f746315e81598);
$parcel$export(module.exports, "getCmdbObjectSchemaByIdObjectTypesUrl", () => $6567e178f8cb9d45$export$40fed922a68615f0);
$parcel$export(module.exports, "getCmdbObjectSchemaByIdObjectTypesFlatUrl", () => $6567e178f8cb9d45$export$ba2d9684559c6a7);
$parcel$export(module.exports, "getCmdbObjectSchemaAllObjectTypesFlatUrl", () => $6567e178f8cb9d45$export$5feed0fbe07a00c4);
$parcel$export(module.exports, "getCmdbObjectSchemaCreateUrl", () => $6567e178f8cb9d45$export$f3ba592db0974a77);
$parcel$export(module.exports, "getCmdbObjectSchemaListUrl", () => $6567e178f8cb9d45$export$e92eb77a52cdaa41);
$parcel$export(module.exports, "getCmdbFindAllAttributesUrl", () => $6567e178f8cb9d45$export$6ffa97ba17b941e9);

var $b5RwB = parcelRequire("b5RwB");

var $1qZG3 = parcelRequire("1qZG3");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/objectschema
 */ const $6567e178f8cb9d45$var$getCmdbObjectSchemaUrl = (workspaceId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/objectschema`;
const $6567e178f8cb9d45$export$7a8f746315e81598 = (workspaceId, schemaId)=>`${$6567e178f8cb9d45$var$getCmdbObjectSchemaUrl(workspaceId)}/${schemaId}`;
const $6567e178f8cb9d45$export$40fed922a68615f0 = (workspaceId, schemaId, queryParams)=>`${$6567e178f8cb9d45$export$7a8f746315e81598(workspaceId, schemaId)}/objecttypes?${(0, $b5RwB.stringify)(queryParams)}`;
const $6567e178f8cb9d45$export$ba2d9684559c6a7 = (workspaceId, schemaId, queryParams)=>`${$6567e178f8cb9d45$export$7a8f746315e81598(workspaceId, schemaId)}/objecttypes/flat${queryParams ? `?${(0, $b5RwB.stringify)(queryParams)}` : ''}`;
const $6567e178f8cb9d45$export$5feed0fbe07a00c4 = (workspaceId, schemaId, queryParams)=>`${$6567e178f8cb9d45$var$getCmdbObjectSchemaUrl(workspaceId)}/all/${schemaId}/objecttypes/flat?${(0, $b5RwB.stringify)(queryParams)}`;
const $6567e178f8cb9d45$export$f3ba592db0974a77 = (workspaceId)=>`${$6567e178f8cb9d45$var$getCmdbObjectSchemaUrl(workspaceId)}/create`;
const $6567e178f8cb9d45$export$e92eb77a52cdaa41 = (workspaceId, queryParams)=>`${$6567e178f8cb9d45$var$getCmdbObjectSchemaUrl(workspaceId)}/list?${(0, $b5RwB.stringify)(queryParams)}`;
const $6567e178f8cb9d45$export$6ffa97ba17b941e9 = (workspaceId, schemaId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/objectschema/${schemaId}/attributes?${(0, $b5RwB.stringify)({
        extended: true
    })}`;

});

parcelRegister("bg0VY", function(module, exports) {
$parcel$export(module.exports, "getCmdbObjectTypeByIdUrl", () => $5991fa2b6d1e1645$export$6f3a42f18d151e67);
$parcel$export(module.exports, "getCmdbObjectTypeByIdAttributesUrl", () => $5991fa2b6d1e1645$export$3af2a99fe1215c98);
$parcel$export(module.exports, "getCmdbObjectTypeByIdDeleteObjectsUrl", () => $5991fa2b6d1e1645$export$2ff51a9674e9ef8e);
$parcel$export(module.exports, "getCmdbObjectTypeByIdObjectsUrl", () => $5991fa2b6d1e1645$export$cc2331466d0bc62a);
$parcel$export(module.exports, "getCmdbObjectTypeByIdPositionUrl", () => $5991fa2b6d1e1645$export$a636cbbc1532dae1);
$parcel$export(module.exports, "getCmdbObjectTypeCopyUrl", () => $5991fa2b6d1e1645$export$f57e47ec92312ade);
$parcel$export(module.exports, "getCmdbObjectTypeCreateUrl", () => $5991fa2b6d1e1645$export$95f3087e511a1510);
$parcel$export(module.exports, "getCmdbObjectTypeBulkEditUrl", () => $5991fa2b6d1e1645$export$64aa1993d4a6b92c);

var $b5RwB = parcelRequire("b5RwB");

var $1qZG3 = parcelRequire("1qZG3");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/objecttype
 */ const $5991fa2b6d1e1645$var$getCmdbObjectTypeUrl = (workspaceId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/objecttype`;
const $5991fa2b6d1e1645$export$6f3a42f18d151e67 = (workspaceId, objectTypeId)=>`${$5991fa2b6d1e1645$var$getCmdbObjectTypeUrl(workspaceId)}/${objectTypeId}`;
const $5991fa2b6d1e1645$export$3af2a99fe1215c98 = (workspaceId, objectTypeId, queryParams)=>`${$5991fa2b6d1e1645$export$6f3a42f18d151e67(workspaceId, objectTypeId)}/attributes?${(0, $b5RwB.stringify)(queryParams)}`;
const $5991fa2b6d1e1645$export$2ff51a9674e9ef8e = (workspaceId, objectTypeId)=>`${$5991fa2b6d1e1645$export$6f3a42f18d151e67(workspaceId, objectTypeId)}/delete/objects`;
const $5991fa2b6d1e1645$export$cc2331466d0bc62a = (workspaceId, objectTypeId)=>`${$5991fa2b6d1e1645$export$6f3a42f18d151e67(workspaceId, objectTypeId)}/objects`;
const $5991fa2b6d1e1645$export$a636cbbc1532dae1 = (workspaceId, objectTypeId)=>`${$5991fa2b6d1e1645$export$6f3a42f18d151e67(workspaceId, objectTypeId)}/position`;
const $5991fa2b6d1e1645$export$f57e47ec92312ade = (workspaceId)=>`${$5991fa2b6d1e1645$var$getCmdbObjectTypeUrl(workspaceId)}/copy`;
const $5991fa2b6d1e1645$export$95f3087e511a1510 = (workspaceId)=>`${$5991fa2b6d1e1645$var$getCmdbObjectTypeUrl(workspaceId)}/create`;
const $5991fa2b6d1e1645$export$64aa1993d4a6b92c = (workspaceId)=>`${$5991fa2b6d1e1645$var$getCmdbObjectTypeUrl(workspaceId)}/bulkedit`;

});

parcelRegister("8rYjX", function(module, exports) {
$parcel$export(module.exports, "getCmdbObjectByIdUrl", () => $51ae915a9d99dfd8$export$d33c3e25476d091d);
$parcel$export(module.exports, "getCmdbObjectByIdUrlWithoutQueryParams", () => $51ae915a9d99dfd8$export$6ef8997552257871);
$parcel$export(module.exports, "getCmdbObjectByIdActivityUrl", () => $51ae915a9d99dfd8$export$20c207abffb62450);
$parcel$export(module.exports, "getCmdbObjectByIdAvatarUrl", () => $51ae915a9d99dfd8$export$31df868d16d545f8);
$parcel$export(module.exports, "getCmdbObjectByIdReferenceInfoUrl", () => $51ae915a9d99dfd8$export$5044a1e9fc201773);
$parcel$export(module.exports, "getCmdbObjectCloneByIdUrl", () => $51ae915a9d99dfd8$export$d7f6dc1d4f622458);
$parcel$export(module.exports, "getCmdbObjectCreateUrl", () => $51ae915a9d99dfd8$export$9cdc19e8944d38cf);
$parcel$export(module.exports, "getCmdbObjectNavlistUrl", () => $51ae915a9d99dfd8$export$bf9c534c2cd21829);
$parcel$export(module.exports, "getCmdbObjectNavlistQueryLanguageUrl", () => $51ae915a9d99dfd8$export$b35334340ee827fa);
$parcel$export(module.exports, "getCmdbObjectRecentUrl", () => $51ae915a9d99dfd8$export$a0a7c6f22bebdef0);
$parcel$export(module.exports, "getCmdbObjectQueryLanguageTotalCountUrl", () => $51ae915a9d99dfd8$export$ee74f95a469c4433);
$parcel$export(module.exports, "getCmdbObjectQueryLanguageUrl", () => $51ae915a9d99dfd8$export$84a34ee3f18e226);
$parcel$export(module.exports, "getCmdbAsyncObjectExportUrl", () => $51ae915a9d99dfd8$export$878b627ac685384e);
$parcel$export(module.exports, "getCmdbAsyncBulkQrCodeUrl", () => $51ae915a9d99dfd8$export$8eb3a6b36886db0);
$parcel$export(module.exports, "getCmdbAsyncGenerateUaDuplicatesReportUrl", () => $51ae915a9d99dfd8$export$54601fa587b1cebb);
$parcel$export(module.exports, "getCmdbAsyncBulkDeleteUrl", () => $51ae915a9d99dfd8$export$b02201bcaeb75291);
$parcel$export(module.exports, "getCmdbAsyncBulkEditUrl", () => $51ae915a9d99dfd8$export$f4d68a6f0e3217b5);
$parcel$export(module.exports, "getCmdbAsyncCdmBundleInstantiationUrl", () => $51ae915a9d99dfd8$export$ae8f0647f4610496);

var $b5RwB = parcelRequire("b5RwB");

var $1qZG3 = parcelRequire("1qZG3");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/object
 */ const $51ae915a9d99dfd8$var$getCmdbObjectUrl = (workspaceId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/object`;
const $51ae915a9d99dfd8$export$d33c3e25476d091d = (workspaceId, objectId, includeExtendedInfo = false)=>{
    const path = $51ae915a9d99dfd8$export$6ef8997552257871(workspaceId, objectId);
    if (!includeExtendedInfo) return `${path}?${(0, $b5RwB.stringify)({
        includeExtendedInfo: includeExtendedInfo
    })}`;
    return path;
};
const $51ae915a9d99dfd8$export$6ef8997552257871 = (workspaceId, objectId)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/${objectId}`;
const $51ae915a9d99dfd8$export$20c207abffb62450 = (workspaceId, objectId, queryParams)=>`${$51ae915a9d99dfd8$export$6ef8997552257871(workspaceId, objectId)}/activity?${(0, $b5RwB.stringify)(queryParams)}`;
const $51ae915a9d99dfd8$export$31df868d16d545f8 = (workspaceId, objectId)=>`${$51ae915a9d99dfd8$export$6ef8997552257871(workspaceId, objectId)}/avatar`;
const $51ae915a9d99dfd8$export$5044a1e9fc201773 = (workspaceId, objectId)=>`${$51ae915a9d99dfd8$export$6ef8997552257871(workspaceId, objectId)}/referenceinfo`;
const $51ae915a9d99dfd8$export$d7f6dc1d4f622458 = (workspaceId, objectId)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/clone/${objectId}`;
const $51ae915a9d99dfd8$export$9cdc19e8944d38cf = (workspaceId)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/create`;
const $51ae915a9d99dfd8$export$bf9c534c2cd21829 = (workspaceId)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/navlist`;
const $51ae915a9d99dfd8$export$b35334340ee827fa = (workspaceId)=>`${$51ae915a9d99dfd8$export$bf9c534c2cd21829(workspaceId)}/aql`;
const $51ae915a9d99dfd8$export$a0a7c6f22bebdef0 = (workspaceId, queryParams)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/recent?${(0, $b5RwB.stringify)(queryParams)}`;
const $51ae915a9d99dfd8$export$ee74f95a469c4433 = (workspaceId)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/aql/totalcount`;
const $51ae915a9d99dfd8$export$1016ae73c04d9079 = (workspaceId, queryParams)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/search?${(0, $b5RwB.stringify)(queryParams)}`;
const $51ae915a9d99dfd8$export$cb41514f2508b033 = (workspaceId, queryParams)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/searchbyattributes?${(0, $b5RwB.stringify)(queryParams)}`;
const $51ae915a9d99dfd8$export$84a34ee3f18e226 = (workspaceId, queryParams)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/aql?${(0, $b5RwB.stringify)(queryParams)}`;
const $51ae915a9d99dfd8$export$878b627ac685384e = (workspaceId)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/bulkexport`;
const $51ae915a9d99dfd8$export$8eb3a6b36886db0 = (workspaceId, queryParams)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/bulkqrcode?${(0, $b5RwB.stringify)(queryParams)}`;
const $51ae915a9d99dfd8$export$54601fa587b1cebb = (workspaceId, objectTypeAttributeId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/objecttypeattribute/${objectTypeAttributeId}/generate-ua-duplicates-report`;
const $51ae915a9d99dfd8$export$b02201bcaeb75291 = (workspaceId)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/bulkdelete`;
const $51ae915a9d99dfd8$export$f4d68a6f0e3217b5 = (workspaceId)=>`${$51ae915a9d99dfd8$var$getCmdbObjectUrl(workspaceId)}/bulkedit`;
const $51ae915a9d99dfd8$export$ae8f0647f4610496 = (workspaceId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/bundle/instantiate/async`;

});


parcelRegister("55tVS", function(module, exports) {
$parcel$export(module.exports, "transformInsightServiceObjectToCmdbObjectResponse", () => $93ef2dea473de0de$export$46b3c44950ea286c);
$parcel$export(module.exports, "transformBackendValueToCmdbObject", () => $93ef2dea473de0de$export$4fd59ae692c47f18);
$parcel$export(module.exports, "reduceObjectTypesByParentObjectTypeId", () => $93ef2dea473de0de$export$40eb52787b32816b);

var $fYTe8 = parcelRequire("fYTe8");

var $4ZeQj = parcelRequire("4ZeQj");
const $93ef2dea473de0de$export$46b3c44950ea286c = (object)=>{
    const attributes = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    object?.attributes?.map((attribute)=>({
            ...attribute,
            objectAttributeValues: // eslint-disable-next-line @typescript-eslint/no-explicit-any
            attribute?.objectAttributeValues?.map((value)=>{
                // Remaps the keys used for IDs slightly in 'object' type attributes
                if (attribute?.objectTypeAttribute?.type === 1) return {
                    ...value,
                    referencedObject: {
                        ...value?.referencedObject,
                        objectId: value?.referencedObject?.id,
                        id: value?.referencedObject?.globalId
                    }
                };
                return value;
            }) ?? []
        })) ?? [];
    return {
        ...object,
        attributes: attributes
    };
};
const $93ef2dea473de0de$export$4fd59ae692c47f18 = (object)=>{
    const attributes = object.attributes.map((attribute)=>{
        const castAttr = (0, $fYTe8.toObjectTypeAttribute)(attribute);
        return {
            ...castAttr,
            type: castAttr.objectTypeAttribute.type
        };
    });
    return {
        ...object,
        attributes: // @ts-expect-error - TS2322 - Type '({ type: 0 | 1 | 2 | 4 | 7; id: string; objectTypeAttributeId: string; objectTypeAttribute: CmdbObjectTypeAttributeDefault; objectAttributeValues: CmdbObjectAttributeValueDefault[]; } | { ...; } | { ...; } | { ...; } | { ...; })[]' is not assignable to type 'CmdbObjectAttribute[]'.
        attributes
    };
};
const $93ef2dea473de0de$export$40eb52787b32816b = (objectTypes)=>objectTypes.sort((a, b)=>Number(a.id) > Number(b.id) ? 1 : -1).reduce((entries, { id: objectTypeId, name: name, icon: icon, position: position, parentObjectTypeId: parentObjectTypeId })=>{
        const objectType = {
            id: (0, $4ZeQj.toCmdbObjectTypeId)(objectTypeId),
            name: name,
            icon: icon,
            position: position,
            parentObjectTypeId: parentObjectTypeId ?? null
        };
        if (objectType.parentObjectTypeId == null) {
            entries.push(objectType);
            return entries;
        }
        const newEntries = [];
        const index = entries.findIndex(({ id: id })=>id === parentObjectTypeId);
        entries.slice(0, index + 1).forEach((entry)=>{
            newEntries.push(entry);
        });
        newEntries.push(objectType);
        entries.slice(index + 1).forEach((entry)=>{
            newEntries.push(entry);
        });
        return newEntries;
    }, []);

});
parcelRegister("fYTe8", function(module, exports) {
$parcel$export(module.exports, "toObjectTypeAttribute", () => $a79f80f2be8a7c51$export$43d7501448d7c10);
const $a79f80f2be8a7c51$export$43d7501448d7c10 = (attr)=>{
    switch(attr.type){
        case 0:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return attr;
        case 1:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return attr;
        case 2:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return attr;
        case 4:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return attr;
        case 6:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return attr;
        case 7:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return attr;
        case 8:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return attr;
        case 9:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return attr;
        default:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return attr;
    }
};

});



parcelRegister("1Kd5r", function(module, exports) {
$parcel$export(module.exports, "useObjectGraphService", () => $aefe96c6d609f2e0$export$8c33c1bca444013f);

var $eJOHy = parcelRequire("eJOHy");

var $hPZg4 = parcelRequire("hPZg4");

var $51aj0 = parcelRequire("51aj0");

var $jGzN3 = parcelRequire("jGzN3");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $3mn6T = parcelRequire("3mn6T");
const $aefe96c6d609f2e0$var$getObjectGraphUrl = (workspaceId, objectId, depth, maxOfSameType)=>{
    if (depth !== undefined && maxOfSameType !== undefined) return (0, $3mn6T.getCmdbGraphObjectUrl)(workspaceId, objectId, {
        depth: depth,
        maxOfSameType: maxOfSameType
    });
    return (0, $3mn6T.getCmdbGraphObjectUrl)(workspaceId, objectId);
};
const $aefe96c6d609f2e0$export$8c33c1bca444013f = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const request = (0, $eJOHy.useCallback)(({ objectId: objectId, workspaceId: workspaceId, depth: depth, maxOfSameType: maxOfSameType })=>(0, $jGzN3.performGetRequest)($aefe96c6d609f2e0$var$getObjectGraphUrl(workspaceId, objectId, depth, maxOfSameType)).then((res)=>{
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchObjectGraphData succeeded');
            return res;
        }).catch((error)=>{
            (0, $51aj0.fireCmdbErrorAnalytics)({
                error: error,
                meta: {
                    id: 'fetchObjectGraphData',
                    packageName: 'jiraServicedeskInsightObjectServices',
                    teamName: 'aurum'
                }
            });
            throw error;
        }), [
        createAnalyticsEvent
    ]);
    const { loading: loading, error: error, data: data, fetch: fetchObjectGraph } = (0, $hPZg4.useService)(request);
    return [
        {
            loading: loading,
            error: error,
            data: data
        },
        fetchObjectGraph
    ];
};

});
parcelRegister("3mn6T", function(module, exports) {
$parcel$export(module.exports, "getCmdbGraphObjectUrl", () => $cb9301450f97e204$export$e3a43687445755b9);
$parcel$export(module.exports, "getCmdbGraphObjectTypeUrl", () => $cb9301450f97e204$export$2426d7acfd257162);
$parcel$export(module.exports, "getCmdbGraphSchemaUrl", () => $cb9301450f97e204$export$78524cf396d011ad);

var $b5RwB = parcelRequire("b5RwB");

var $1qZG3 = parcelRequire("1qZG3");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/graph
 */ const $cb9301450f97e204$var$getCmdbGraphUrl = (workspaceId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/graph`;
const $cb9301450f97e204$export$e3a43687445755b9 = (workspaceId, objectId, queryParams)=>`${$cb9301450f97e204$var$getCmdbGraphUrl(workspaceId)}/object/${objectId}${queryParams ? `?${(0, $b5RwB.stringify)(queryParams)}` : ''}`;
const $cb9301450f97e204$export$2426d7acfd257162 = (workspaceId, objectId, queryParams)=>`${$cb9301450f97e204$var$getCmdbGraphUrl(workspaceId)}/objecttype/${objectId}${queryParams ? `?${(0, $b5RwB.stringify)(queryParams)}` : ''}`;
const $cb9301450f97e204$export$78524cf396d011ad = (workspaceId, schemaId)=>`${$cb9301450f97e204$var$getCmdbGraphUrl(workspaceId)}/objectschema/${schemaId}`;

});


parcelRegister("9wObp", function(module, exports) {
$parcel$export(module.exports, "GRAPH_NODE_TYPES", () => $b5b75e15b38031ae$export$172900d1bc4220d9);
const $b5b75e15b38031ae$var$OBJECT_GRAPH_NODE_TYPE = 'O';
const $b5b75e15b38031ae$var$OBJECT_TYPE_GRAPH_NODE_TYPE = 'T';
const $b5b75e15b38031ae$export$172900d1bc4220d9 = Object.freeze({
    OBJECT: $b5b75e15b38031ae$var$OBJECT_GRAPH_NODE_TYPE,
    OBJECT_TYPE: $b5b75e15b38031ae$var$OBJECT_TYPE_GRAPH_NODE_TYPE
});

});

parcelRegister("hExsh", function(module, exports) {
$parcel$export(module.exports, "useObjectGraphConfiguration", () => $290f22287dad83ba$export$7d92b63999f03c61);

var $eJOHy = parcelRequire("eJOHy");

var $Q0twf = parcelRequire("Q0twf");

var $8JjuG = parcelRequire("8JjuG");
const $290f22287dad83ba$var$getDefaultConfiguration = ()=>({
        // controls how many degrees of separation of nodes to show based on the initial object
        referenceDepth: 1,
        // controls the amount of inbound nodes of a particular object type before merging them as a single node
        maxOfSameType: 10
    });
const $290f22287dad83ba$var$getMaxReferenceDepth = ()=>5;
const $290f22287dad83ba$var$getMaxOfSameType = ()=>50;
const $290f22287dad83ba$export$7d92b63999f03c61 = (objectGraphData, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
initialObjectTypeId)=>{
    const [configuration, setConfiguration] = (0, $eJOHy.useState)(()=>({
            ...(0, $Q0twf.getGraphConfigurationLocalStorage)() ?? $290f22287dad83ba$var$getDefaultConfiguration(),
            referenceTypes: []
        }));
    // re-generate the reference type filters whenever the graph data updates
    (0, $eJOHy.useEffect)(()=>{
        const { nodes: nodes = [], edges: edges = [] } = objectGraphData ?? {};
        const referenceTypes = (0, $8JjuG.getReferenceTypes)({
            nodes: // @ts-expect-error - TS2322 - Type 'Node[]' is not assignable to type 'ReactNode[]'.
            nodes,
            edges: edges,
            initialObjectTypeId: initialObjectTypeId,
            referenceDepth: configuration.referenceDepth
        });
        setConfiguration((config)=>({
                ...config,
                referenceTypes: referenceTypes
            }));
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        configuration.referenceDepth,
        objectGraphData
    ]); // we don't want to listen for changes to initialObjectTypeId here
    const updateReferenceTypes = (0, $eJOHy.useCallback)((updated)=>{
        (0, $Q0twf.setReferenceCheckedLocalStorage)({
            objectTypeId: initialObjectTypeId,
            referenceLabel: updated.label,
            updatedValue: updated.checked
        });
        setConfiguration((config)=>({
                ...config,
                referenceTypes: config.referenceTypes.map((r)=>r.label === updated.label ? updated : r)
            }));
    }, [
        initialObjectTypeId
    ]);
    const updateReferenceDepth = (0, $eJOHy.useCallback)((updatedReferenceDepth)=>{
        if (updatedReferenceDepth >= 1 && updatedReferenceDepth <= $290f22287dad83ba$var$getMaxReferenceDepth()) {
            (0, $Q0twf.setGraphConfigurationLocalStorage)({
                referenceDepth: updatedReferenceDepth,
                maxOfSameType: configuration.maxOfSameType
            });
            setConfiguration((config)=>({
                    ...config,
                    referenceDepth: updatedReferenceDepth
                }));
        }
    }, [
        configuration
    ]);
    const updateMaxOfSameType = (0, $eJOHy.useCallback)((updatedMaxOfSameType)=>{
        if (updatedMaxOfSameType >= 1 && updatedMaxOfSameType <= $290f22287dad83ba$var$getMaxOfSameType()) {
            (0, $Q0twf.setGraphConfigurationLocalStorage)({
                referenceDepth: configuration.referenceDepth,
                maxOfSameType: updatedMaxOfSameType
            });
            setConfiguration((config)=>({
                    ...config,
                    maxOfSameType: updatedMaxOfSameType
                }));
        }
    }, [
        configuration
    ]);
    return [
        configuration,
        {
            updateReferenceDepth: updateReferenceDepth,
            updateMaxOfSameType: updateMaxOfSameType,
            updateReferenceTypes: updateReferenceTypes
        }
    ];
};

});
parcelRegister("Q0twf", function(module, exports) {
$parcel$export(module.exports, "getGraphConfigurationLocalStorage", () => $2d7a1cdb05823fe1$export$43af2d54030d43b1);
$parcel$export(module.exports, "setGraphConfigurationLocalStorage", () => $2d7a1cdb05823fe1$export$957c0561e5b0dd2d);
$parcel$export(module.exports, "getReferenceCheckedLocalStorage", () => $2d7a1cdb05823fe1$export$e2f6fac45be157c1);
$parcel$export(module.exports, "setReferenceCheckedLocalStorage", () => $2d7a1cdb05823fe1$export$a6fb5b32429a9337);

var $dnU6V = parcelRequire("dnU6V");
const $2d7a1cdb05823fe1$var$OBJECT_GRAPH_CONFIGURATION_KEY = 'objectGraphConfiguration';
const $2d7a1cdb05823fe1$export$ddcffe0146c8f882 = (0, $dnU6V.createLocalStorageProvider)('jsm-cmdb-object-graph');
const $2d7a1cdb05823fe1$export$43af2d54030d43b1 = ()=>{
    try {
        const graphConfig = $2d7a1cdb05823fe1$export$ddcffe0146c8f882.get($2d7a1cdb05823fe1$var$OBJECT_GRAPH_CONFIGURATION_KEY);
        if (graphConfig) {
            const { referenceDepth: referenceDepth, maxOfSameType: maxOfSameType } = JSON.parse(graphConfig);
            return {
                referenceDepth: referenceDepth,
                maxOfSameType: maxOfSameType
            };
        }
        return undefined;
    } catch (err) {
        return undefined;
    }
};
const $2d7a1cdb05823fe1$export$957c0561e5b0dd2d = (updatedConfig)=>{
    const existingConfig = $2d7a1cdb05823fe1$export$43af2d54030d43b1();
    $2d7a1cdb05823fe1$export$ddcffe0146c8f882.set($2d7a1cdb05823fe1$var$OBJECT_GRAPH_CONFIGURATION_KEY, JSON.stringify({
        ...existingConfig,
        ...updatedConfig
    }));
};
const $2d7a1cdb05823fe1$export$e2f6fac45be157c1 = ({ objectTypeId: objectTypeId, referenceLabel: referenceLabel })=>{
    try {
        const isChecked = $2d7a1cdb05823fe1$export$ddcffe0146c8f882.get(`objectType${objectTypeId}-reference${referenceLabel}`);
        return JSON.parse(isChecked);
    } catch (error) {
        return undefined;
    }
};
const $2d7a1cdb05823fe1$export$a6fb5b32429a9337 = ({ objectTypeId: objectTypeId, referenceLabel: referenceLabel, updatedValue: updatedValue })=>{
    $2d7a1cdb05823fe1$export$ddcffe0146c8f882.set(`objectType${objectTypeId}-reference${referenceLabel}`, JSON.stringify(updatedValue));
};

});

parcelRegister("8JjuG", function(module, exports) {
$parcel$export(module.exports, "getReferenceTypes", () => $f1053fbaf6ea0010$export$7cc38071d2ea10f2);

var $Q0twf = parcelRequire("Q0twf");
const $f1053fbaf6ea0010$var$getReferenceCheckedState = (objectTypeId, referenceLabel, showByDefault)=>{
    const defaultCheckedState = showByDefault ?? true;
    return (0, $Q0twf.getReferenceCheckedLocalStorage)({
        objectTypeId: objectTypeId,
        referenceLabel: referenceLabel
    }) ?? defaultCheckedState;
};
const $f1053fbaf6ea0010$export$7cc38071d2ea10f2 = ({ nodes: nodes, edges: edges, referenceDepth: referenceDepth, initialObjectTypeId: initialObjectTypeId })=>{
    // we accumulate a set of reference types that store all edges between nodes that are associated with that reference
    // this is used render nodes / edges in the graph and to filter out nodes in the graph based on whether the reference type is checked or not
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const referenceTypes = edges.reduce((referenceTypeList, edge)=>{
        const reference = {
            label: edge.label,
            color: edge.color,
            from: [
                edge.from
            ],
            to: [
                edge.to
            ],
            checked: true,
            count: 1
        };
        // for each edge we validate the node/s it connects are valid before associating it with a reference
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'. | TS2339 - Property 'id' does not exist on type 'boolean | ReactChild | ReactFragment | ReactPortal'.
        const hasSourceNode = nodes.some((n)=>n.id === edge.from.slice(1));
        const hasDestinationNode = nodes.some(// @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'. | TS2339 - Property 'id' does not exist on type 'boolean | ReactChild | ReactFragment | ReactPortal'. | TS2533 - Object is possibly 'null' or 'undefined'. | TS2339 - Property 'depth' does not exist on type 'boolean | ReactChild | ReactFragment | ReactPortal'.
        (n)=>n.id === edge.to.slice(1) && n.depth <= referenceDepth);
        const isValidEdge = hasDestinationNode && hasSourceNode;
        const existingReference = referenceTypeList.find((r)=>r.label === reference.label);
        if (existingReference && isValidEdge) {
            existingReference.from.push(edge.from);
            existingReference.to.push(edge.to);
            existingReference.count += 1;
            existingReference.checked = $f1053fbaf6ea0010$var$getReferenceCheckedState(initialObjectTypeId, edge.label, existingReference.count < 10);
        } else if (isValidEdge) {
            reference.checked = $f1053fbaf6ea0010$var$getReferenceCheckedState(initialObjectTypeId, edge.label);
            referenceTypeList.push(reference);
        }
        return referenceTypeList;
    }, []);
    return referenceTypes;
};

});


parcelRegister("kOjSa", function(module, exports) {
$parcel$export(module.exports, "useSelectedNode", () => $8deb0059a43baa52$export$aa8f1c72cfda8469);

var $eJOHy = parcelRequire("eJOHy");

var $9wObp = parcelRequire("9wObp");
const $8deb0059a43baa52$export$aa8f1c72cfda8469 = (initialObjectId)=>{
    const [selectedNode, setSelectedNode] = (0, $eJOHy.useState)({
        type: (0, $9wObp.GRAPH_NODE_TYPES).OBJECT,
        nodeId: (0, $9wObp.GRAPH_NODE_TYPES).OBJECT + initialObjectId,
        referenceId: initialObjectId
    });
    const setSelectedObjectNode = (0, $eJOHy.useCallback)((objectId)=>{
        setSelectedNode({
            type: (0, $9wObp.GRAPH_NODE_TYPES).OBJECT,
            nodeId: (0, $9wObp.GRAPH_NODE_TYPES).OBJECT + objectId,
            referenceId: objectId
        });
    }, []);
    const setSelectedObjectTypeNode = (0, $eJOHy.useCallback)((node)=>{
        setSelectedNode({
            type: (0, $9wObp.GRAPH_NODE_TYPES).OBJECT_TYPE,
            nodeId: (0, $9wObp.GRAPH_NODE_TYPES).OBJECT_TYPE + node.id,
            referenceId: node.id,
            objectSchemaId: node.objectSchemaId ?? '',
            icon: node.icon,
            name: node.name
        });
    }, []);
    return [
        selectedNode,
        {
            setSelectedObjectNode: setSelectedObjectNode,
            setSelectedObjectTypeNode: setSelectedObjectTypeNode
        }
    ];
};

});

parcelRegister("9CMZx", function(module, exports) {
$parcel$export(module.exports, "ActionsButton", () => $73fa9919480cb0bf$export$548aa330bf01a877);
$parcel$export(module.exports, "Actions", () => $73fa9919480cb0bf$export$b52183d5cfb26dc9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $k71qx = parcelRequire("k71qx");
const $73fa9919480cb0bf$export$548aa330bf01a877 = (props)=>{
    const { label: label, Icon: Icon, triggerRef: triggerRef, iconSpacing: iconSpacing, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: label,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        ref: triggerRef,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
            label: label,
            spacing: iconSpacing
        }),
        ...rest
    }));
};
const $73fa9919480cb0bf$export$b52183d5cfb26dc9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73fa9919480cb0bf$var$Wrapper, null, props.children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $73fa9919480cb0bf$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154ize3t _1xi2ze3t _1e0c1txw _19pkutpp _2hwxpxbi _otyrutpp _18u0pxbi _1yp8utpp",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hbXh9", function(module, exports) {
$parcel$export(module.exports, "GraphConfigurationActionPanel", () => $ef1a69a2c8f1f838$export$f028fcb976898610);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7rjYb = parcelRequire("7rjYb");

var $1KdDN = parcelRequire("1KdDN");
const $ef1a69a2c8f1f838$export$f028fcb976898610 = ({ menuPosition: menuPosition, renderActionButton: renderActionButton, children: children, isConfigPanelOpen: isConfigPanelOpen, onOpenChange: onOpenChange })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "object-graph-configuration-panel",
        packageName: "jiraServicedeskInsightObjectGraph",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ef1a69a2c8f1f838$var$DropdownContainer, {
        onClick: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        isOpen: isConfigPanelOpen,
        onOpenChange: (args)=>{
            onOpenChange(args.isOpen);
        },
        zIndex: 1000,
        trigger: renderActionButton,
        shouldFlip: false,
        placement: `bottom-${menuPosition === 'left' ? 'start' : 'end'}`,
        appearance: "tall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ef1a69a2c8f1f838$var$ContentContainer, null, children))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ef1a69a2c8f1f838$var$DropdownContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1n1u1wug _nz6r1wug _1nyh1kdj",
            __cmplp.className
        ])
    });
});
const $ef1a69a2c8f1f838$var$ContentContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkpxbi _2hwxpxbi _otyrpxbi _18u0pxbi _p12f1b1j",
            __cmplp.className
        ])
    });
});

});

parcelRegister("5EIle", function(module, exports) {
$parcel$export(module.exports, "ReferenceDepthConfigurationInputs", () => $498af010a3f34347$export$1a7cfc9d06ab35e3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3s8bj = parcelRequire("3s8bj");

var $goZPP = parcelRequire("goZPP");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $5lAAn = parcelRequire("5lAAn");

var $3cMgR = parcelRequire("3cMgR");

var $sY9BV = parcelRequire("sY9BV");

var $lRq8t = parcelRequire("lRq8t");

var $igb71 = parcelRequire("igb71");
const $498af010a3f34347$export$a77796dd088d9f7d = ({ value: value, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const referenceDepthOptions = Array.from(Array(5), (_, i)=>i + 1);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        zIndex: 1000,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...props,
                ref: triggerRef,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
                    label: "down icon",
                    size: "small"
                }),
                testId: "servicedesk-insight-object-graph.ui.graph-config-panel.reference-depth-inputs.trigger-button"
            }, value),
        appearance: "tall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, referenceDepthOptions.map((depth)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($498af010a3f34347$var$DropdownItemWrapper, {
            key: depth
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
            onClick: ()=>onChange(depth),
            testId: "servicedesk-insight-object-graph.ui.graph-config-panel.reference-depth-inputs.depth-option"
        }, formatMessage((0, $igb71.default)[depth]))))));
};
const $498af010a3f34347$export$4b100b07e5f29926 = ({ value: value, onChange: onChange, label: label })=>{
    const [internalValue, setInternalValue] = (0, $eJOHy.useState)(value);
    const debouncedOnChange = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(onChange, 200), [
        onChange
    ]);
    (0, $eJOHy.useEffect)(()=>{
        setInternalValue(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
        testId: "servicedesk-insight-object-graph.ui.graph-config-panel.reference-depth-inputs.max-of-same-type",
        type: "number",
        autoComplete: "off",
        min: 1,
        max: 50,
        value: internalValue,
        "aria-label": label,
        onChange: (event)=>{
            // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'EventTarget'.
            const { value: updated } = event.target;
            const newValue = Number(updated);
            setInternalValue(newValue);
            debouncedOnChange(newValue);
        }
    });
};
const $498af010a3f34347$export$1a7cfc9d06ab35e3 = (props)=>{
    const { maxOfSameType: maxOfSameType, referenceDepth: referenceDepth, onUpdateReferenceDepth: onUpdateReferenceDepth, onUpdateMaxOfSameType: onUpdateMaxOfSameType } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($498af010a3f34347$var$InputContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($498af010a3f34347$var$LabelText, null, formatMessage((0, $igb71.default).referenceDepthLabel), ":"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($498af010a3f34347$export$a77796dd088d9f7d, {
        value: referenceDepth,
        onChange: onUpdateReferenceDepth
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($498af010a3f34347$var$InputContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($498af010a3f34347$var$LabelText, null, formatMessage((0, $igb71.default).inboundReferencesLabel), ":"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($498af010a3f34347$var$InboundReferencesContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($498af010a3f34347$export$4b100b07e5f29926, {
        label: formatMessage((0, $igb71.default).inboundReferencesLabel),
        value: maxOfSameType,
        onChange: onUpdateMaxOfSameType
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        as: "p",
        size: "UNSAFE_small"
    }, formatMessage((0, $igb71.default).helpText)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $498af010a3f34347$var$InputContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _otyru2gc _p12fuuw1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $498af010a3f34347$var$DropdownItemWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3u2gc _n3tdidpf _19bvu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $498af010a3f34347$var$LabelText = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $498af010a3f34347$var$InboundReferencesContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_rff01wqb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("igb71", function(module, exports) {
$parcel$export(module.exports, "default", () => $b04e5bf74190ec1a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b04e5bf74190ec1a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    referenceDepthLabel: {
        "id": "servicedesk-insight-object-graph.graph-config-panel.reference-depth-inputs.reference-depth-label",
        "defaultMessage": "Reference depth"
    },
    inboundReferencesLabel: {
        "id": "servicedesk-insight-object-graph.graph-config-panel.reference-depth-inputs.inbound-references-label",
        "defaultMessage": "Inbound references"
    },
    helpText: {
        "id": "servicedesk-insight-object-graph.graph-config-panel.reference-depth-inputs.help-text",
        "defaultMessage": "The maximum number of inbound references from the same object type, before grouping them as a single node."
    },
    '1': {
        "id": "servicedesk-insight-object-graph.graph-config-panel.reference-depth-inputs.1",
        "defaultMessage": "1"
    },
    '2': {
        "id": "servicedesk-insight-object-graph.graph-config-panel.reference-depth-inputs.2",
        "defaultMessage": "2"
    },
    '3': {
        "id": "servicedesk-insight-object-graph.graph-config-panel.reference-depth-inputs.3",
        "defaultMessage": "3"
    },
    '4': {
        "id": "servicedesk-insight-object-graph.graph-config-panel.reference-depth-inputs.4",
        "defaultMessage": "4"
    },
    '5': {
        "id": "servicedesk-insight-object-graph.graph-config-panel.reference-depth-inputs.5",
        "defaultMessage": "5"
    }
});

});


parcelRegister("jKBKy", function(module, exports) {
$parcel$export(module.exports, "ReferenceTypeToggleList", () => $8bb4753783a4c305$export$aa0ca936e7260336);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $86tBw = parcelRequire("86tBw");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $8bb4753783a4c305$export$aa0ca936e7260336 = (props)=>{
    const { referenceTypes: referenceTypes, onChange: onChange } = props;
    const onToggleReferenceType = (referenceTypeToUpdate)=>{
        const updatedReferenceType = {
            ...referenceTypeToUpdate,
            checked: !referenceTypeToUpdate.checked
        };
        onChange(updatedReferenceType);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $8bb4753783a4c305$var$containerStyles
    }, referenceTypes.map((rt)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8bb4753783a4c305$var$InputContainer, {
            key: rt.label
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86tBw.default), {
            "aria-label": rt.label,
            isChecked: rt.checked,
            onChange: ()=>onToggleReferenceType(rt),
            testId: `servicedesk-insight-object-graph.ui.graph-config-panel.reference-types-toggle-list.checkbox-${rt.label}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8bb4753783a4c305$var$ColorCircle, {
            color: rt.color
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8bb4753783a4c305$var$LabelText, null, rt.label))));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8bb4753783a4c305$var$ColorCircle = ({ color: color, children: children })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $8bb4753783a4c305$var$colorCircleStyles,
            (0, $1DXK0.xcss)({
                backgroundColor: color
            })
        ]
    }, children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8bb4753783a4c305$var$LabelText = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pku2gc _2hwxu2gc _otyru2gc _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $8bb4753783a4c305$var$InputContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _otyru2gc _slp31hna _1i4q1hna _1nmz1hna",
            __cmplp.className
        ])
    });
});
const $8bb4753783a4c305$var$containerStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.200'
});
const $8bb4753783a4c305$var$colorCircleStyles = (0, $1DXK0.xcss)({
    height: '28px',
    minWidth: '28px',
    borderRadius: 'radius.full'
});
const $8bb4753783a4c305$export$7ed12d2a5241e393 = {
    ColorCircle: $8bb4753783a4c305$var$ColorCircle,
    LabelText: $8bb4753783a4c305$var$LabelText
};

});

parcelRegister("evEEq", function(module, exports) {
$parcel$export(module.exports, "GraphError", () => $f43534dcbecc9268$export$7314831ac2fea5d8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6MnLl = parcelRequire("6MnLl");

var $dymbf = parcelRequire("dymbf");

var $aTJmy = parcelRequire("aTJmy");

var $lRq8t = parcelRequire("lRq8t");

var $g2qoe = parcelRequire("g2qoe");
const $f43534dcbecc9268$export$7314831ac2fea5d8 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const renderImage = ()=>(0, $aTJmy.getAkEmptyStateRenderImageFn)((0, $dymbf.default))({
            imageWidth: 120,
            maxImageWidth: 120,
            maxImageHeight: 212
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f43534dcbecc9268$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        header: formatMessage((0, $g2qoe.default).errorTitle),
        description: formatMessage((0, $g2qoe.default).errorDescription),
        renderImage: renderImage
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f43534dcbecc9268$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1osq _j1pnusvi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dymbf", function(module, exports) {
$parcel$export(module.exports, "default", () => $42825a5af59db372$export$2e2bcd8739ae039);
$parcel$export(module.exports, "viewBox", () => $42825a5af59db372$export$a179c88182cb9d56);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("6FdCu")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("6GQY3")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $c4huj = parcelRequire("c4huj");

var $6GQY3 = parcelRequire("6GQY3");

var $6FdCu = parcelRequire("6FdCu");
const $42825a5af59db372$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($6FdCu)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($6GQY3))
});
var $42825a5af59db372$export$2e2bcd8739ae039 = $42825a5af59db372$var$Illustration;
// for advanced use only
const $42825a5af59db372$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("6GQY3", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("6FdCu", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("g2qoe", function(module, exports) {
$parcel$export(module.exports, "default", () => $c35223996be2dd4b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c35223996be2dd4b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorTitle: {
        "id": "servicedesk-insight-object-graph.graph-error.error-title",
        "defaultMessage": "Failed to load graph"
    },
    errorDescription: {
        "id": "servicedesk-insight-object-graph.graph-error.error-description",
        "defaultMessage": "Please refresh the page and try again."
    }
});

});


parcelRegister("lMjn6", function(module, exports) {
$parcel$export(module.exports, "GraphHeader", () => $ec6c44effc958bb8$export$deaeec1bb8f9bce8);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $806LH = parcelRequire("806LH");

var $6J9k6 = parcelRequire("6J9k6");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $gJq4s = parcelRequire("gJq4s");
const $ec6c44effc958bb8$var$HEADER_HEIGHT = 72;
const $ec6c44effc958bb8$export$deaeec1bb8f9bce8 = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ec6c44effc958bb8$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ec6c44effc958bb8$var$Title, null, props.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $gJq4s.default).closeLabel),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $ec6c44effc958bb8$var$closeButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle-link",
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))), {
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)",
            label: formatMessage((0, $gJq4s.default).closeLabel)
        }),
        onClick: props.onClose,
        testId: "servicedesk-insight-object-graph.ui.graph-header.button-close"
    }))));
};
const $ec6c44effc958bb8$var$Wrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "center",
        xcss: $ec6c44effc958bb8$var$wrapperNewStyles
    }, children);
const $ec6c44effc958bb8$var$Title = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $ec6c44effc958bb8$var$titleStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "medium",
        as: "h1"
    }, children));
const $ec6c44effc958bb8$var$closeButtonStyles = (0, $1DXK0.xcss)({
    marginLeft: 'space.200'
});
const $ec6c44effc958bb8$var$wrapperNewStyles = (0, $1DXK0.xcss)({
    boxSizing: 'border-box',
    padding: 'space.300',
    borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #091E4224)"}`,
    height: `${$ec6c44effc958bb8$var$HEADER_HEIGHT}px`
});
const $ec6c44effc958bb8$var$titleStyles = (0, $1DXK0.xcss)({
    color: 'color.text',
    margin: 'space.0',
    flexGrow: '1',
    marginTop: 'space.050',
    paddingBottom: 'space.050',
    fontWeight: 'font.weight.regular'
});

});
parcelRegister("gJq4s", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c4617d9c3163015$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $1c4617d9c3163015$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    closeLabel: {
        "id": "servicedesk-insight-object-graph.graph-header.close-label",
        "defaultMessage": "Close"
    }
});

});


parcelRegister("cQzhk", function(module, exports) {
$parcel$export(module.exports, "default", () => $98b8cb54731db6cf$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $98b8cb54731db6cf$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "servicedesk-insight-object-graph.title",
        "defaultMessage": "Object details"
    },
    showDetail: {
        "id": "servicedesk-insight-object-graph.show-detail",
        "defaultMessage": "Show object details panel"
    },
    hideDetail: {
        "id": "servicedesk-insight-object-graph.hide-detail",
        "defaultMessage": "Hide object details panel"
    },
    lockLayout: {
        "id": "servicedesk-insight-object-graph.lock-layout",
        "defaultMessage": "Lock node layout"
    },
    unlockLayout: {
        "id": "servicedesk-insight-object-graph.unlock-layout",
        "defaultMessage": "Unlock node layout"
    },
    showGraphConfigPanel: {
        "id": "servicedesk-insight-object-graph.show-graph-config-panel",
        "defaultMessage": "Show graph configuration"
    },
    hideGraphConfigPanel: {
        "id": "servicedesk-insight-object-graph.hide-graph-config-panel",
        "defaultMessage": "Hide graph configuration"
    },
    graphConfigPanelHeader: {
        "id": "servicedesk-insight-object-graph.graph-config-panel-header",
        "defaultMessage": "Graph configuration"
    },
    referenceTypesHeader: {
        "id": "servicedesk-insight-object-graph.reference-types-header",
        "defaultMessage": "Reference types"
    }
});

});

parcelRegister("1xUOV", function(module, exports) {
$parcel$export(module.exports, "ObjectTypeView", () => $e59abc09a8b062e0$export$707a485e8827bede);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3cMgR = parcelRequire("3cMgR");

var $iHPvF = parcelRequire("iHPvF");

var $lRq8t = parcelRequire("lRq8t");

var $bYOuG = parcelRequire("bYOuG");

var $al3yt = parcelRequire("al3yt");

var $f5JJ6 = parcelRequire("f5JJ6");
const $e59abc09a8b062e0$export$707a485e8827bede = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { objectTypeNode: objectTypeNode } = props;
    const { name: name, icon: icon, objectSchemaId: objectSchemaId, referenceId: referenceId } = objectTypeNode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e59abc09a8b062e0$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $al3yt.SidebarHeader), {
        title: name,
        iconUrl: icon,
        tooltip: formatMessage((0, $f5JJ6.default).openObjectTypeDetails),
        link: (0, $bYOuG.createObjectTypeUrl)(objectSchemaId, referenceId)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
        appearance: "information"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        as: "p"
    }, formatMessage((0, $f5JJ6.default).maxOfTypeExceeded))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e59abc09a8b062e0$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
});
const $e59abc09a8b062e0$export$7ed12d2a5241e393 = {
    Wrapper: $e59abc09a8b062e0$var$Wrapper
};

});
parcelRegister("bYOuG", function(module, exports) {
$parcel$export(module.exports, "ASSETS_APP_ROUTE_PREFIX", () => $59de792af1bc0730$export$42e57fb76a904fc3);
$parcel$export(module.exports, "ASSETS_APP_OBJECT_ROUTE_PREFIX", () => $59de792af1bc0730$export$aede099f2ae23728);
$parcel$export(module.exports, "isInsightRoute", () => $59de792af1bc0730$export$296d80f3ce129968);
$parcel$export(module.exports, "getCreateServiceUrl", () => $59de792af1bc0730$export$1f9b8b558a361aaf);
$parcel$export(module.exports, "getRootPath", () => $59de792af1bc0730$export$5413f45d031c7806);
$parcel$export(module.exports, "getLandingPageUrl", () => $59de792af1bc0730$export$9366da5a373815e5);
$parcel$export(module.exports, "getGlobalConfigUrl", () => $59de792af1bc0730$export$20fd4a0aec335970);
$parcel$export(module.exports, "getAssetsSettingsUrl", () => $59de792af1bc0730$export$15f6d6ab94d89135);
$parcel$export(module.exports, "getDataManagerUrl", () => $59de792af1bc0730$export$c9b27b0d2e19d52f);
$parcel$export(module.exports, "getDataManagerGettingStartedUrl", () => $59de792af1bc0730$export$3d0380185f73b3d);
$parcel$export(module.exports, "getDataManagerObjectClassesUrl", () => $59de792af1bc0730$export$4c9768bc51c7a1a);
$parcel$export(module.exports, "getDataManagerVisualizationUrl", () => $59de792af1bc0730$export$6c3cb6f103b2324);
$parcel$export(module.exports, "getDataManagerAdaptersUrl", () => $59de792af1bc0730$export$cd6b35373ba077a);
$parcel$export(module.exports, "getAssetsReportsUrl", () => $59de792af1bc0730$export$c1909404b7ea317f);
$parcel$export(module.exports, "getAssetsDashboardsUrl", () => $59de792af1bc0730$export$da30a4c2eb7e2c58);
$parcel$export(module.exports, "getAssetsReportUrl", () => $59de792af1bc0730$export$272d35cbff1c220e);
$parcel$export(module.exports, "getAssetsForYouUrl", () => $59de792af1bc0730$export$ea8a41c5d5a50829);
$parcel$export(module.exports, "createObjectSchemasUrl", () => $59de792af1bc0730$export$c48ea1282c74411e);
$parcel$export(module.exports, "createObjectSchemaUrl", () => $59de792af1bc0730$export$3a0332e980fe56cf);
$parcel$export(module.exports, "createObjectTypeUrl", () => $59de792af1bc0730$export$cfefb90cfb86b528);
$parcel$export(module.exports, "createObjectSchemaConfigUrl", () => $59de792af1bc0730$export$f02479149ce3cac7);
$parcel$export(module.exports, "createObjectDetailUrl", () => $59de792af1bc0730$export$51e4229f2c7d3866);
$parcel$export(module.exports, "createObjectTypeSettingsUrl", () => $59de792af1bc0730$export$4b4b7d2c3df4fa58);
$parcel$export(module.exports, "createObjectTypeListWithObjectSelectedUrl", () => $59de792af1bc0730$export$c1790fa8f0d8e89a);
$parcel$export(module.exports, "getFeatureUsagePageUrl", () => $59de792af1bc0730$export$5ba89eed0cf60033);
$parcel$export(module.exports, "getFeatureUsageVirtualAgentPageUrl", () => $59de792af1bc0730$export$415502b49e27270d);

var $b5RwB = parcelRequire("b5RwB");

var $7jTnu = parcelRequire("7jTnu");

var $9suIz = parcelRequire("9suIz");
const $59de792af1bc0730$export$ee637ecb2dfa4f6a = '/jira/servicedesk/service-modal';
const $59de792af1bc0730$export$42e57fb76a904fc3 = '/jira/assets';
const $59de792af1bc0730$export$80e512187a5e0d10 = '/jira/servicedesk/assets';
const $59de792af1bc0730$export$6d7574dbda22cf7 = '/jira/servicedesk/insight';
const $59de792af1bc0730$export$aede099f2ae23728 = '/jira/assets/object';
const $59de792af1bc0730$export$296d80f3ce129968 = (pathname)=>pathname.includes($59de792af1bc0730$export$6d7574dbda22cf7);
const $59de792af1bc0730$export$1f9b8b558a361aaf = ()=>$59de792af1bc0730$export$ee637ecb2dfa4f6a;
const $59de792af1bc0730$export$5413f45d031c7806 = ()=>(0, $7jTnu.fg)('assets_as_an_app_v2') ? $59de792af1bc0730$export$42e57fb76a904fc3 : $59de792af1bc0730$export$80e512187a5e0d10;
const $59de792af1bc0730$export$9366da5a373815e5 = ()=>$59de792af1bc0730$export$5413f45d031c7806();
const $59de792af1bc0730$export$20fd4a0aec335970 = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/configure/global`;
const $59de792af1bc0730$export$15f6d6ab94d89135 = ()=>`${$59de792af1bc0730$export$42e57fb76a904fc3}/configure/global`;
const $59de792af1bc0730$export$c9b27b0d2e19d52f = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/data-manager/`;
const $59de792af1bc0730$export$3d0380185f73b3d = ()=>`${$59de792af1bc0730$export$42e57fb76a904fc3}/data-manager/getting-started`;
const $59de792af1bc0730$export$4c9768bc51c7a1a = ()=>`${$59de792af1bc0730$export$42e57fb76a904fc3}/data-manager/object-classes`;
const $59de792af1bc0730$export$6c3cb6f103b2324 = ()=>`${$59de792af1bc0730$export$42e57fb76a904fc3}/data-manager/#/dashboards`;
const $59de792af1bc0730$export$cd6b35373ba077a = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/data-manager/adapters/`;
const $59de792af1bc0730$export$c1909404b7ea317f = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/reports`;
const $59de792af1bc0730$export$da30a4c2eb7e2c58 = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/dashboards`;
const $59de792af1bc0730$export$771825afb10f956f = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/analytics/data-view/create`;
const $59de792af1bc0730$export$272d35cbff1c220e = (reportId)=>`${$59de792af1bc0730$export$c1909404b7ea317f()}/${reportId}`;
const $59de792af1bc0730$export$97bfda8f5f38a121 = (query)=>`${$59de792af1bc0730$export$5413f45d031c7806()}/search${query ? `?${query}` : ''}`;
const $59de792af1bc0730$export$ea8a41c5d5a50829 = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/for-you`;
const $59de792af1bc0730$export$c48ea1282c74411e = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/object-schemas`;
const $59de792af1bc0730$export$3a0332e980fe56cf = (objectSchemaId)=>`${$59de792af1bc0730$export$5413f45d031c7806()}/object-schema/${objectSchemaId}`;
const $59de792af1bc0730$export$cfefb90cfb86b528 = (objectSchemaId, objectTypeId)=>`${$59de792af1bc0730$export$3a0332e980fe56cf(objectSchemaId)}?${(0, $9suIz.SCHEMA_PAGE_QUERY_PARAMS).objectTypeId}=${objectTypeId}`;
const $59de792af1bc0730$export$f02479149ce3cac7 = (objectSchemaId)=>`${$59de792af1bc0730$export$5413f45d031c7806()}/configure/object-schema/${objectSchemaId}`;
const $59de792af1bc0730$export$51e4229f2c7d3866 = (objectId)=>`${$59de792af1bc0730$export$5413f45d031c7806()}/object/${objectId}`;
const $59de792af1bc0730$export$4b4b7d2c3df4fa58 = (objectTypeId)=>`${$59de792af1bc0730$export$5413f45d031c7806()}/configure/object-type/${objectTypeId}`;
const $59de792af1bc0730$export$c1790fa8f0d8e89a = (objectSchemaId, objectTypeId, objectId)=>`${$59de792af1bc0730$export$cfefb90cfb86b528(objectSchemaId, objectTypeId)}&view=list&objectId=${objectId}`;
const $59de792af1bc0730$export$6e21e6efe57484c5 = (queryParams = {})=>{
    const base = `${$59de792af1bc0730$export$42e57fb76a904fc3}/search`;
    if (Object.keys(queryParams).length > 0) {
        const encodedParams = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(queryParams);
        return `${base}?${encodedParams}`;
    }
    return base;
};
const $59de792af1bc0730$export$5ba89eed0cf60033 = ({ showChangeLimitModal: showChangeLimitModal } = {})=>`/jira/settings/products/servicedesk/feature-usage?feature=assets${showChangeLimitModal ? '&changeLimit=true' : ''}`;
const $59de792af1bc0730$export$415502b49e27270d = ({ showChangeLimitModal: showChangeLimitModal } = {})=>`/jira/settings/products/servicedesk/feature-usage?feature=virtual-agent${showChangeLimitModal ? '&changeLimit=true' : ''}`;

});
parcelRegister("9suIz", function(module, exports) {
$parcel$export(module.exports, "SCHEMA_PAGE_QUERY_PARAMS", () => $38b78989e1c789e8$export$a73deb42718b5c4);
$parcel$export(module.exports, "TAB_QUERY_PARAM_REFERENCE_TYPES", () => $38b78989e1c789e8$export$f7855185bab37329);
$parcel$export(module.exports, "TAB_QUERY_PARAM_STATUSES", () => $38b78989e1c789e8$export$3739ebbc7c6e87e8);
$parcel$export(module.exports, "TAB_QUERY_PARAM_ICONS", () => $38b78989e1c789e8$export$2c22dc6c729ae0bd);
$parcel$export(module.exports, "TAB_QUERY_PARAM_DATA_MANAGER", () => $38b78989e1c789e8$export$f37b3a97acf56eaf);
$parcel$export(module.exports, "TAB_QUERY_PARAM_COMMON_DATA_MODEL", () => $38b78989e1c789e8$export$b5445f8b5c64a799);
$parcel$export(module.exports, "TAB_QUERY_PARAM_GENERAL", () => $38b78989e1c789e8$export$12ebb1d5017e1d6d);
$parcel$export(module.exports, "TAB_QUERY_PARAM_ROLES", () => $38b78989e1c789e8$export$a77734d9ea30fe44);
$parcel$export(module.exports, "TAB_QUERY_PARAM_IMPORT", () => $38b78989e1c789e8$export$be37b820df30c947);
$parcel$export(module.exports, "TAB_QUERY_PARAM_INHERITANCE", () => $38b78989e1c789e8$export$670faa8ae93e0903);
$parcel$export(module.exports, "useUpdateQueryParams", () => $38b78989e1c789e8$export$e66acc5f4583ce1c);
$parcel$export(module.exports, "useObjectTypeIdQueryParam", () => $38b78989e1c789e8$export$f5a33d51dd6de08);
$parcel$export(module.exports, "useObjectIdQueryParam", () => $38b78989e1c789e8$export$a6e3187c87554a1e);
$parcel$export(module.exports, "useSchemaViewModeQueryParam", () => $38b78989e1c789e8$export$6abda0ad26022eff);
$parcel$export(module.exports, "useObjectViewModeQueryParam", () => $38b78989e1c789e8$export$1927b50f7d074492);

var $eJOHy = parcelRequire("eJOHy");

var $b5RwB = parcelRequire("b5RwB");

var $4ZeQj = parcelRequire("4ZeQj");

var $95O7y = parcelRequire("95O7y");
var $gCY1z = parcelRequire("gCY1z");
var $83DiZ = parcelRequire("83DiZ");
const $38b78989e1c789e8$export$a73deb42718b5c4 = {
    // Values are 'object' or 'attribute'
    schemaMode: 'mode',
    // Values are 'list' or undefined
    objectViewMode: 'view',
    // Both of these params are supported to set the object type ID. 'typeId' is preferred and is the one that is updated.
    // 'objecttypeid' is only used on initial load to support customers who have bookmarked this URL.
    objectTypeId: 'typeId',
    fallbackObjectTypeId: 'objecttypeid',
    objectId: 'objectId'
};
const $38b78989e1c789e8$export$f7855185bab37329 = 'reference-types';
const $38b78989e1c789e8$export$3739ebbc7c6e87e8 = 'statuses';
const $38b78989e1c789e8$export$2c22dc6c729ae0bd = 'icons';
const $38b78989e1c789e8$export$f37b3a97acf56eaf = 'data-manager';
const $38b78989e1c789e8$export$b5445f8b5c64a799 = 'common-data-model';
const $38b78989e1c789e8$export$12ebb1d5017e1d6d = 'general';
const $38b78989e1c789e8$export$a77734d9ea30fe44 = 'roles';
const $38b78989e1c789e8$export$be37b820df30c947 = 'import';
const $38b78989e1c789e8$export$670faa8ae93e0903 = 'inheritance';
const $38b78989e1c789e8$export$e66acc5f4583ce1c = ()=>{
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const [{ location: location }] = (0, $gCY1z.useRouter)();
    const updateQueryParams = (0, $eJOHy.useCallback)((queryParams = {})=>{
        const { pathname: pathname, search: search } = location;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedQueryParams = {};
        Object.keys(queryParams).forEach((key)=>{
            updatedQueryParams[key] = queryParams[key] ?? undefined;
        });
        return `${pathname}?${(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
            ...(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(search),
            ...updatedQueryParams
        })}`;
    }, [
        location
    ]);
    const pushRouterAction = (0, $eJOHy.useCallback)((path)=>{
        push(path);
    }, [
        push
    ]);
    return [
        {
            updateQueryParams: updateQueryParams,
            pushRouterAction: pushRouterAction
        }
    ];
};
const $38b78989e1c789e8$export$f5a33d51dd6de08 = ()=>{
    const [objectTypeId, setObjectTypeId] = (0, $95O7y.useQueryParam)($38b78989e1c789e8$export$a73deb42718b5c4.objectTypeId);
    const [fallbackObjectTypeId, setFallbackObjectTypeId] = (0, $95O7y.useQueryParam)($38b78989e1c789e8$export$a73deb42718b5c4.fallbackObjectTypeId);
    (0, $eJOHy.useEffect)(()=>{
        if (fallbackObjectTypeId !== undefined) {
            setObjectTypeId((0, $4ZeQj.toCmdbObjectTypeId)(fallbackObjectTypeId), 'replace');
            setFallbackObjectTypeId(undefined, 'replace');
        }
    }, [
        fallbackObjectTypeId,
        setObjectTypeId,
        setFallbackObjectTypeId
    ]);
    const nullableMain = objectTypeId !== undefined ? (0, $4ZeQj.toCmdbObjectTypeId)(objectTypeId) : null;
    const nullableFallback = fallbackObjectTypeId !== undefined ? (0, $4ZeQj.toCmdbObjectTypeId)(fallbackObjectTypeId) : null;
    const setter = (newObjectTypeId, updateType)=>{
        setObjectTypeId(newObjectTypeId !== null ? newObjectTypeId : undefined, updateType);
    };
    return [
        nullableMain !== null ? nullableMain : nullableFallback,
        setter
    ];
};
const $38b78989e1c789e8$export$a6e3187c87554a1e = ()=>{
    const [objectId, setObjectId] = (0, $95O7y.useQueryParam)($38b78989e1c789e8$export$a73deb42718b5c4.objectId);
    const nullableObjectId = objectId !== undefined ? (0, $4ZeQj.toCmdbObjectId)(objectId) : null;
    const setter = (newObjectId, updateType)=>{
        setObjectId(newObjectId !== null ? newObjectId : undefined, updateType);
    };
    return [
        nullableObjectId,
        setter
    ];
};
const $38b78989e1c789e8$export$6abda0ad26022eff = ()=>{
    const [rawParamValue, setSchemaMode] = (0, $95O7y.useQueryParam)($38b78989e1c789e8$export$a73deb42718b5c4.schemaMode);
    const schemaMode = rawParamValue === 'attribute' ? 'attribute' : 'object';
    return [
        schemaMode,
        setSchemaMode
    ];
};
const $38b78989e1c789e8$export$1927b50f7d074492 = ()=>{
    const [rawParamValue, setObjectViewMode] = (0, $95O7y.useQueryParam)($38b78989e1c789e8$export$a73deb42718b5c4.objectViewMode);
    const objectViewMode = rawParamValue === 'list' ? 'list' : 'details';
    const setter = (newValue, updateMode)=>{
        setObjectViewMode(newValue === 'list' ? 'list' : undefined, updateMode);
    };
    return [
        objectViewMode,
        setter
    ];
};

});


parcelRegister("al3yt", function(module, exports) {
$parcel$export(module.exports, "SidebarHeader", () => $65b783219b09151a$export$e575a964a1fe8b0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $806LH = parcelRequire("806LH");

var $8rAKL = parcelRequire("8rAKL");

var $8IeH1 = parcelRequire("8IeH1");

var $k71qx = parcelRequire("k71qx");

var $c9uTK = parcelRequire("c9uTK");
const $65b783219b09151a$var$CustomHeading = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        as: "h3",
        size: "small"
    }, props.children);
const $65b783219b09151a$export$e575a964a1fe8b0 = ({ iconUrl: iconUrl, link: link, title: title, tooltip: tooltip })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        "data-testId": "object-name-link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($65b783219b09151a$var$ObjectNameLink, {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($65b783219b09151a$var$ObjectIcon, {
        "data-testId": "object-name-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        src: iconUrl,
        key: iconUrl,
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($65b783219b09151a$var$ObjectName, null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        "data-testId": "object-name-tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: tooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        "data-testId": "object-name-shortcut-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8rAKL))), {
        spacing: "spacious",
        label: ""
    }))))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $65b783219b09151a$var$ObjectNameLink = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $c9uTK.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _otyrpxbi _l8ku23z3 _tf4iidpf _12hn1q5t _t7blu2gc _f8pj14q2 _30l314q2 _16xekb7n _1fmgkb7n _1n83z12g _12svz12g",
            __cmplp.className
        ])
    });
});
const $65b783219b09151a$var$ObjectIcon = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1o9zidpf _1bsb1ejb _4t3i1ejb _2hwxutpp _mezj1osq _bna71osq",
            __cmplp.className
        ])
    });
});
const $65b783219b09151a$var$ObjectName = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $65b783219b09151a$var$CustomHeading, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1gjq _1i4q1hna _slp31hna _1nmz9jpi _30l314q2",
            __cmplp.className
        ])
    });
});

});

parcelRegister("f5JJ6", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6f3dd5cef9d7795$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e6f3dd5cef9d7795$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    openObjectTypeDetails: {
        "id": "servicedesk-insight-object-graph.object-type-view.open-object-type-details",
        "defaultMessage": "Open object type details page"
    },
    maxOfTypeExceeded: {
        "id": "servicedesk-insight-object-graph.object-type-view.max-of-type-exceeded",
        "defaultMessage": "The number of objects of this type were too many to be represented individually in the graph and have therefore been grouped together in a single node."
    }
});

});


parcelRegister("4AhY6", function(module, exports) {
$parcel$export(module.exports, "ObjectView", () => $6b615858f29c201d$export$c93bdb9e9400c13c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $80xRm = parcelRequire("80xRm");

var $goZPP = parcelRequire("goZPP");

var $6MnLl = parcelRequire("6MnLl");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $cpHe2 = parcelRequire("cpHe2");
var $41h42 = parcelRequire("41h42");
var $7oCv0 = parcelRequire("7oCv0");
var $2cSdF = parcelRequire("2cSdF");

var $7jTnu = parcelRequire("7jTnu");

var $dymbf = parcelRequire("dymbf");

var $aTJmy = parcelRequire("aTJmy");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $ai8Ln = parcelRequire("ai8Ln");

var $bYOuG = parcelRequire("bYOuG");

var $37dPs = parcelRequire("37dPs");

var $al3yt = parcelRequire("al3yt");

var $ZvOaO = parcelRequire("ZvOaO");

var $dkpvZ = parcelRequire("dkpvZ");

var $lkrGD = parcelRequire("lkrGD");

var $coe0R = parcelRequire("coe0R");
const $6b615858f29c201d$export$c93bdb9e9400c13c = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { objectDetails: objectDetails, objectDetailsError: objectDetailsError, objectDetailsLoading: objectDetailsLoading, onObjectAttributeClick: onObjectAttributeClick, onRefreshButtonClick: onRefreshButtonClick, selectedObjectId: selectedObjectId, source: source } = props;
    const memoizedObjectDetails = (0, $eJOHy.useMemo)(()=>{
        if (objectDetailsError) {
            const renderImage = ()=>(0, $aTJmy.getAkEmptyStateRenderImageFn)((0, $dymbf.default))({
                    imageWidth: 120,
                    maxImageWidth: 120,
                    maxImageHeight: 212
                });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
                header: formatMessage((0, $lkrGD.default).errorTitle),
                description: formatMessage((0, $lkrGD.default).errorDescription),
                renderImage: renderImage
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6b615858f29c201d$var$ObjectViewErrorRefreshButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                appearance: "primary",
                onClick: onRefreshButtonClick
            }, formatMessage((0, $lkrGD.default).refreshButton))));
        }
        if (objectDetailsLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ZvOaO.AttributesListSkeleton), null);
        return objectDetails !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ai8Ln.AttributesList), {
            attributes: (0, (/*@__PURE__*/$parcel$interopDefault($80xRm)))(objectDetails.attributes, (attribute)=>(0, $coe0R.getPositionFromObjectAttribute)(attribute)),
            objectId: selectedObjectId,
            onObjectAttributeClick: onObjectAttributeClick
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $37dPs.TrackObjectView), {
            id: selectedObjectId
        })) : null;
    }, [
        selectedObjectId,
        formatMessage,
        objectDetailsError,
        objectDetailsLoading,
        objectDetails,
        onObjectAttributeClick,
        onRefreshButtonClick
    ]);
    const memoizedTabs = (0, $eJOHy.useMemo)(()=>[
            {
                label: formatMessage((0, $lkrGD.default).objectDetails),
                content: memoizedObjectDetails,
                tabItemId: 'insightObjectGraphObjectDetails'
            },
            {
                label: formatMessage((0, $7jTnu.fg)('itsm-issue-renaming') ? (0, $lkrGD.default).linkedIssuesIssueTermRefresh : (0, $lkrGD.default).linkedIssues),
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dkpvZ.LinkedIssues), {
                    objectId: selectedObjectId
                }),
                tabItemId: 'insightObjectGraphLinkedIssues'
            }
        ], [
        formatMessage,
        memoizedObjectDetails,
        selectedObjectId
    ]);
    const onTabSelect = (selectedTab)=>{
        const id = selectedTab.tabItemId;
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'navigationItem clicked', id, {
            source: source
        });
    }; // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleChange = (index)=>{
        const selectedTab = memoizedTabs[index];
        onTabSelect(selectedTab);
    };
    const memoizedHeader = (0, $eJOHy.useMemo)(()=>{
        if (objectDetailsError) return null;
        if (objectDetailsLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ZvOaO.TitleSkeleton), null);
        return objectDetails !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $al3yt.SidebarHeader), {
            title: objectDetails.label,
            iconUrl: objectDetails.avatar.url48,
            link: (0, $bYOuG.createObjectDetailUrl)(selectedObjectId),
            tooltip: formatMessage((0, $lkrGD.default).openObjectDetailsPage)
        }) : null;
    }, [
        formatMessage,
        selectedObjectId,
        objectDetailsError,
        objectDetailsLoading,
        objectDetails
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6b615858f29c201d$var$wrapperStyles
    }, memoizedHeader, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cpHe2.default), {
        onChange: handleChange,
        id: "object-view-tabs",
        shouldUnmountTabPanelOnChange: true,
        testId: "servicedesk-insight-object-graph.ui.object-view.tabs"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7oCv0.default), null, memoizedTabs.map((tab)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $41h42.default), {
            key: tab.tabItemId
        }, tab.label))), memoizedTabs.map((tab)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2cSdF.default), {
            key: tab.tabItemId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6b615858f29c201d$var$TabContentWrapper, null, tab.content)))));
};
const $6b615858f29c201d$var$wrapperStyles = (0, $1DXK0.xcss)({
    padding: 'space.200'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6b615858f29c201d$var$ObjectViewErrorRefreshButtonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6b615858f29c201d$var$TabContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _vchhusvi _19pkpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("80xRm", function(module, exports) {

var $72Qfa = parcelRequire("72Qfa");

var $4ppQ2 = parcelRequire("4ppQ2");

var $l76qh = parcelRequire("l76qh");

var $eA1it = parcelRequire("eA1it");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $5d48969fb93c8520$var$sortBy = $l76qh(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $eA1it(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $eA1it(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $4ppQ2(collection, $72Qfa(iteratees, 1), []);
});
module.exports = $5d48969fb93c8520$var$sortBy;

});
parcelRegister("4ppQ2", function(module, exports) {

var $lylkU = parcelRequire("lylkU");

var $5BbSa = parcelRequire("5BbSa");

var $1lM9j = parcelRequire("1lM9j");

var $k0Eii = parcelRequire("k0Eii");

var $1QISL = parcelRequire("1QISL");

var $cUaWv = parcelRequire("cUaWv");

var $6c1m2 = parcelRequire("6c1m2");

var $d7YnM = parcelRequire("d7YnM");

var $4sprp = parcelRequire("4sprp");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $335d8a321b94e157$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $lylkU(iteratees, function(iteratee) {
        if ($4sprp(iteratee)) return function(value) {
            return $5BbSa(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $d7YnM
    ];
    var index = -1;
    iteratees = $lylkU(iteratees, $cUaWv($1lM9j));
    var result = $k0Eii(collection, function(value, key, collection) {
        var criteria = $lylkU(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $1QISL(result, function(object, other) {
        return $6c1m2(object, other, orders);
    });
}
module.exports = $335d8a321b94e157$var$baseOrderBy;

});
parcelRegister("1QISL", function(module, exports) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $158d7678f0c45464$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = $158d7678f0c45464$var$baseSortBy;

});

parcelRegister("6c1m2", function(module, exports) {

var $boN2o = parcelRequire("boN2o");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $4824ea093db12906$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $boN2o(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = $4824ea093db12906$var$compareMultiple;

});
parcelRegister("boN2o", function(module, exports) {

var $9D78T = parcelRequire("9D78T");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $84c7f970dc532949$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $9D78T(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $9D78T(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = $84c7f970dc532949$var$compareAscending;

});




parcelRegister("2cSdF", function(module, exports) {
$parcel$export(module.exports, "default", () => $9291670942049679$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $g6Dmv = parcelRequire("g6Dmv");

var $lcHWu = parcelRequire("lcHWu");
// Note this is not being memoized as children is an unstable reference
/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $9291670942049679$var$TabPanel = ({ children: children, testId: testId })=>{
    const { role: role, id: id, hidden: hidden, 'aria-labelledby': ariaLabelledBy, tabIndex: tabIndex } = (0, $lcHWu.useTabPanel)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $g6Dmv.default), {
        as: "div",
        isInset: true,
        testId: testId,
        role: role,
        id: id,
        hidden: hidden,
        "aria-labelledby": ariaLabelledBy,
        tabIndex: tabIndex,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
            children: children
        })
    });
};
var $9291670942049679$export$2e2bcd8739ae039 = $9291670942049679$var$TabPanel;

});

parcelRegister("ai8Ln", function(module, exports) {
$parcel$export(module.exports, "AttributesList", () => $b9264cd01576f88f$export$52e75d5e1ea61c64);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $3YNdt = parcelRequire("3YNdt");


var $9RS73 = parcelRequire("9RS73");

var $bhqLs = parcelRequire("bhqLs");

var $kN04d = parcelRequire("kN04d");

var $9N6qc = parcelRequire("9N6qc");

var $b5zzG = parcelRequire("b5zzG");

var $2dVSF = parcelRequire("2dVSF");

var $86ghO = parcelRequire("86ghO");

var $gE6Gx = parcelRequire("gE6Gx");

var $7xaG8 = parcelRequire("7xaG8");

var $50Ckn = parcelRequire("50Ckn");

var $gZC4b = parcelRequire("gZC4b");

var $7dHaE = parcelRequire("7dHaE");

var $04s6t = parcelRequire("04s6t");

var $edbZ4 = parcelRequire("edbZ4");

var $5FcM5 = parcelRequire("5FcM5");

var $1a6aG = parcelRequire("1a6aG");

var $2KUcI = parcelRequire("2KUcI");

var $iPG1J = parcelRequire("iPG1J");

var $9fCiV = parcelRequire("9fCiV");

var $bw7AL = parcelRequire("bw7AL");
const $b9264cd01576f88f$export$52e75d5e1ea61c64 = ({ attributes: attributes, objectId: objectId, onObjectAttributeClick: onObjectAttributeClick })=>{
    const renderDefaultAttribute = (attribute)=>{
        switch(attribute.objectTypeAttribute.defaultType.id.toString()){
            case (0, $gE6Gx.DefaultAttributeSubtypeMap).Boolean:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $50Ckn.BooleanAttribute), {
                    attribute: attribute
                });
            case (0, $gE6Gx.DefaultAttributeSubtypeMap).URL:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9fCiV.UrlAttribute), {
                    attribute: attribute
                });
            case (0, $gE6Gx.DefaultAttributeSubtypeMap).Email:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9fCiV.EmailAttribute), {
                    attribute: attribute
                });
            case (0, $gE6Gx.DefaultAttributeSubtypeMap).Textarea:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2KUcI.RichTextAttribute), {
                    attribute: attribute
                });
            case (0, $gE6Gx.DefaultAttributeSubtypeMap).Date:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7dHaE.DateAttribute), {
                    attribute: attribute
                });
            case (0, $gE6Gx.DefaultAttributeSubtypeMap).DateTime:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7dHaE.DateTimeAttribute), {
                    attribute: attribute
                });
            case (0, $gE6Gx.DefaultAttributeSubtypeMap).Select:
                return attribute.objectAttributeValues.length > (0, $fac7e5aa1a4458f9$export$13bee158954a3882) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3YNdt.LozengeAndAttributeValueModal), {
                    attributeValuesInfo: {
                        type: 'select',
                        attributeValues: (0, $bhqLs.getDefaultAttributeArrayValueFromCmdbObjectAttribute)(attribute)
                    },
                    attributeName: attribute.objectTypeAttribute.name ?? '',
                    "data-testid": "servicedesk-insight-attribute-list.ui.select-lozenge"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2KUcI.TextAttribute), {
                    attribute: attribute,
                    "data-testid": "servicedesk-insight-attribute-list.ui.select-attribute"
                });
            case (0, $gE6Gx.DefaultAttributeSubtypeMap).Text:
            case (0, $gE6Gx.DefaultAttributeSubtypeMap).Integer:
            case (0, $gE6Gx.DefaultAttributeSubtypeMap).Double:
            case (0, $gE6Gx.DefaultAttributeSubtypeMap).IPAddress:
            case (0, $gE6Gx.DefaultAttributeSubtypeMap).Time:
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2KUcI.TextAttribute), {
                    attribute: attribute
                });
        }
    };
    const renderAttribute = (attribute)=>{
        const showScalableLozengeButton = attribute.objectAttributeValues.length > (0, $fac7e5aa1a4458f9$export$13bee158954a3882);
        switch(attribute.type){
            case (0, $gE6Gx.AttributeTypeMap).Default:
                return renderDefaultAttribute(attribute);
            case (0, $gE6Gx.AttributeTypeMap).Group:
                return showScalableLozengeButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3YNdt.LozengeAndAttributeValueModal), {
                    attributeValuesInfo: {
                        type: 'group',
                        attributeValues: (0, $kN04d.getGroupValuesFromCmdbObjectAttribute)(attribute)
                    },
                    attributeName: attribute.objectTypeAttribute.name ?? '',
                    "data-testid": "servicedesk-insight-attribute-list.ui.group-lozenge"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $04s6t.GroupAttribute), {
                    attribute: attribute,
                    "data-testid": "servicedesk-insight-attribute-list.ui.group-attribute"
                });
            case (0, $gE6Gx.AttributeTypeMap).Status:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1a6aG.StatusAttribute), {
                    attribute: attribute
                });
            case (0, $gE6Gx.AttributeTypeMap).Object:
                return showScalableLozengeButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3YNdt.LozengeAndAttributeValueModal), {
                    attributeValuesInfo: {
                        type: 'object',
                        attributeValues: (0, $2dVSF.getObjectReferenceOptionsFromCmdbObjectAttribute)(attribute)
                    },
                    attributeName: attribute.objectTypeAttribute.name ?? '',
                    "data-testid": "servicedesk-insight-attribute-list.ui.object-lozenge"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gZC4b.ObjectAttribute), {
                    attribute: attribute,
                    onClick: onObjectAttributeClick,
                    "data-testid": "servicedesk-insight-attribute-list.ui.object-attribute"
                });
            case (0, $gE6Gx.AttributeTypeMap).User:
                return showScalableLozengeButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3YNdt.LozengeAndAttributeValueModal), {
                    attributeValuesInfo: {
                        type: 'user',
                        attributeValues: (0, $86ghO.getUserValuesFromCmdbObjectAttribute)(attribute)
                    },
                    attributeName: attribute.objectTypeAttribute.name ?? '',
                    "data-testid": "servicedesk-insight-attribute-list.ui.user-lozenge"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bw7AL.UserAttribute), {
                    attribute: attribute,
                    "data-testid": "servicedesk-insight-attribute-list.ui.user-attribute"
                });
            case (0, $gE6Gx.AttributeTypeMap).Project:
                return showScalableLozengeButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3YNdt.LozengeAndAttributeValueModal), {
                    attributeValuesInfo: {
                        type: 'project',
                        attributeValues: (0, $b5zzG.getProjectValuesFromCmdbObjectAttribute)(attribute)
                    },
                    attributeName: attribute.objectTypeAttribute.name ?? '',
                    "data-testid": "servicedesk-insight-attribute-list.ui.project-lozenge"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5FcM5.ProjectAttribute), {
                    attribute: attribute,
                    "data-testid": "servicedesk-insight-attribute-list.ui.project-attribute"
                });
            case (0, $gE6Gx.AttributeTypeMap).BitbucketRepo:
                return showScalableLozengeButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3YNdt.LozengeAndAttributeValueModal), {
                    attributeValuesInfo: {
                        type: 'bitbucket',
                        attributeValues: (0, $9RS73.getBBRepoValuesFromCmdbObjectAttribute)(attribute)
                    },
                    attributeName: attribute.objectTypeAttribute.name ?? '',
                    "data-testid": "servicedesk-insight-attribute-list.ui.bitbucket-lozenge"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7xaG8.BitbucketRepoAttribute), {
                    attribute: attribute,
                    "data-testid": "servicedesk-insight-attribute-list.ui.bitbucket-attribute"
                });
            case (0, $gE6Gx.AttributeTypeMap).OpsgenieTeam:
                return showScalableLozengeButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3YNdt.LozengeAndAttributeValueModal), {
                    attributeValuesInfo: {
                        type: 'opsgenieTeam',
                        attributeValues: (0, $9N6qc.getOpsgenieTeamValuesFromCmdbObjectAttribute)(attribute)
                    },
                    attributeName: attribute.objectTypeAttribute.name ?? '',
                    "data-testid": "servicedesk-insight-attribute-list.ui.opsgenie-team-lozenge"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $edbZ4.OpsgenieTeamAttribute), {
                    attribute: attribute,
                    "data-testid": "servicedesk-insight-attribute-list.ui.opsgenie-team-attribute"
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iPG1J.UnknownAttribute), {
                    attribute: attribute,
                    objectId: objectId
                });
        }
    };
    const isTextarea = (attribute)=>attribute.type === (0, $gE6Gx.AttributeTypeMap).Default && attribute.objectTypeAttribute.defaultType.id === (0, $gE6Gx.DefaultAttributeSubtypeMap).Textarea;
    const objectAttributeValuesAreNotEmpty = (values)=>values.every((value)=>Object.keys(value).length > 0);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $b9264cd01576f88f$var$ListWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "dl",
        xcss: $b9264cd01576f88f$var$ListStyles
    }, attributes.map((attribute)=>objectAttributeValuesAreNotEmpty(attribute.objectAttributeValues) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            key: attribute.objectTypeAttributeId,
            testId: "servicedesk-insight-attribute-list.ui.attribute-wrapper",
            xcss: [
                $b9264cd01576f88f$var$AttributeWrapperStyles,
                isTextarea(attribute) && $b9264cd01576f88f$var$AttributeWrapperColumnStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b9264cd01576f88f$var$AttributeLabel, {
            isColumn: isTextarea(attribute)
        }, attribute.objectTypeAttribute.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            as: "dd",
            xcss: [
                $b9264cd01576f88f$var$AttributeValueStyles,
                isTextarea(attribute) && $b9264cd01576f88f$var$AttributeValueColumnStyles
            ]
        }, renderAttribute(attribute))))));
};
const $b9264cd01576f88f$var$AttributeLabel = ({ isColumn: isColumn, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "dt",
        xcss: [
            $b9264cd01576f88f$var$AttributeLabelWrapperStyles,
            isColumn && $b9264cd01576f88f$var$AttributeLabelWrapperColumnStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall",
        as: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span",
        xcss: $b9264cd01576f88f$var$attributeLabelStyles
    }, children)));
const $b9264cd01576f88f$var$ListStyles = (0, $1DXK0.xcss)({
    paddingLeft: 'space.0' // dl has 40px default padding
});
const $b9264cd01576f88f$var$ListWrapperStyles = (0, $1DXK0.xcss)({
    /* Offset the outside padding from children */ // Half vertical space between each attribute, half horizontal space between label & value
    marginTop: 'space.negative.050',
    marginRight: 'space.negative.150',
    marginBottom: 'space.negative.050',
    marginLeft: 'space.negative.150'
});
const $b9264cd01576f88f$var$attributeLabelStyles = (0, $1DXK0.xcss)({
    color: 'color.text.subtle'
});
const $b9264cd01576f88f$var$AttributeLabelWrapperStyles = (0, $1DXK0.xcss)({
    marginBlock: 'space.050',
    marginInline: 'space.150',
    minHeight: "var(--ds-space-300, 24px)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-300, 24px)",
    flexBasis: '112px',
    flexGrow: 1
});
const $b9264cd01576f88f$var$AttributeLabelWrapperColumnStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.050',
    marginRight: 'space.150',
    marginBottom: 'space.100',
    marginLeft: 'space.150',
    flexBasis: 'auto'
});
const $b9264cd01576f88f$var$AttributeValueStyles = (0, $1DXK0.xcss)({
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    wordBreak: 'break-all',
    color: 'color.text',
    // Half vertical space between each attribute, half horizontal space between label & value
    marginTop: 'space.050',
    marginRight: 'space.150',
    marginBottom: 'space.050',
    marginLeft: 'space.150',
    minHeight: "var(--ds-space-300, 24px)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-300, 24px)",
    flexBasis: '224px',
    flexGrow: 1
});
const $b9264cd01576f88f$var$AttributeValueColumnStyles = (0, $1DXK0.xcss)({
    flexBasis: 'auto'
});
const $b9264cd01576f88f$var$AttributeWrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row'
});
const $b9264cd01576f88f$var$AttributeWrapperColumnStyles = (0, $1DXK0.xcss)({
    flexDirection: 'column'
});

});
parcelRegister("3YNdt", function(module, exports) {
$parcel$export(module.exports, "ReadView", () => $217c4a31be619567$export$a4b5824ec1e018e1);
$parcel$export(module.exports, "LozengeAndAttributeValueModal", () => $217c4a31be619567$export$d24cde01c782e0df);
$parcel$export(module.exports, "ScalableReadView", () => $217c4a31be619567$export$24ff8c6c49acd72);

var $eJOHy = parcelRequire("eJOHy");

var $joj3R = parcelRequire("joj3R");

var $9RS73 = parcelRequire("9RS73");

var $bhqLs = parcelRequire("bhqLs");

var $kN04d = parcelRequire("kN04d");

var $9N6qc = parcelRequire("9N6qc");

var $b5zzG = parcelRequire("b5zzG");

var $2dVSF = parcelRequire("2dVSF");

var $86ghO = parcelRequire("86ghO");

var $2nGoJ = parcelRequire("2nGoJ");

var $jZkWo = parcelRequire("jZkWo");

var $dfnTD = parcelRequire("dfnTD");

var $lKQ7J = parcelRequire("lKQ7J");

var $jgtBt = parcelRequire("jgtBt");

var $2i6jd = parcelRequire("2i6jd");

var $7jPbD = parcelRequire("7jPbD");

var $icHaK = parcelRequire("icHaK");

var $bEgEM = parcelRequire("bEgEM");

var $15pc8 = parcelRequire("15pc8");

var $5DV7j = parcelRequire("5DV7j");

var $cPiBK = parcelRequire("cPiBK");

var $k1i1U = parcelRequire("k1i1U");

var $kxwSB = parcelRequire("kxwSB");

var $hpvfl = parcelRequire("hpvfl");
const $217c4a31be619567$var$renderDefaultAttribute = ({ defaultAttribute: defaultAttribute, showPlaceholderIfEmpty: showPlaceholderIfEmpty })=>{
    const commonProps = {
        showPlaceholderIfEmpty: showPlaceholderIfEmpty
    };
    const renderText = (value)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kxwSB.TextReadView), {
            ...commonProps,
            value: value,
            defaultAttributeType: defaultAttribute.objectTypeAttribute
        });
    const renderMultiText = (values)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kxwSB.TextReadView), {
            ...commonProps,
            value: values,
            defaultAttributeType: defaultAttribute.objectTypeAttribute
        });
    return (0, $2nGoJ.matchDefaultAttribute)(defaultAttribute, {
        url: renderMultiText,
        email: renderMultiText,
        float: renderText,
        integer: renderText,
        ipAddress: renderText,
        text: renderText,
        textarea: (value)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k1i1U.TextAreaReadView), {
                ...commonProps,
                value: value
            }),
        select: (value)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DV7j.SelectReadView), {
                ...commonProps,
                value: value
            }),
        boolean: (value)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lKQ7J.BooleanReadView), {
                value: value
            }),
        date: (value)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2i6jd.DateReadView), {
                ...commonProps,
                value: value
            }),
        datetime: (value)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jgtBt.DateTimeReadView), {
                ...commonProps,
                value: value
            })
    });
};
const $217c4a31be619567$export$a4b5824ec1e018e1 = ({ attribute: attribute, showPlaceholderIfEmpty: showPlaceholderIfEmpty })=>(0, $2nGoJ.matchInsightObjectAttribute)(attribute, {
        default: (defaultAttribute)=>$217c4a31be619567$var$renderDefaultAttribute({
                defaultAttribute: defaultAttribute,
                showPlaceholderIfEmpty: showPlaceholderIfEmpty
            }),
        object: (objectAttribute)=>{
            const referencedObjects = objectAttribute.objectTypeValues.map(({ referencedObject: referencedObject })=>{
                const { id: id, objectKey: objectKey, label: label, avatar: avatar } = referencedObject;
                return {
                    id: id,
                    objectKey: objectKey,
                    label: label,
                    avatar: avatar
                };
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $15pc8.ReferencedObjectsReadView), {
                referencedObjects: referencedObjects,
                showPlaceholderIfEmpty: showPlaceholderIfEmpty
            });
        },
        user: (userAttribute)=>{
            const users = userAttribute.userTypeValues.map(({ user: user })=>{
                const { displayName: displayName, avatarUrl: avatarUrl, key: key } = user;
                return {
                    displayName: displayName,
                    avatarUrl: avatarUrl,
                    accountId: key
                };
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hpvfl.UsersReadView), {
                users: users,
                showPlaceholderIfEmpty: showPlaceholderIfEmpty
            });
        },
        group: (groupAttribute)=>{
            const groups = groupAttribute.groupTypeValues.map((groupAttributeValue)=>({
                    name: groupAttributeValue.group.name
                }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7jPbD.GroupsReadView), {
                groups: groups,
                showPlaceholderIfEmpty: showPlaceholderIfEmpty
            });
        },
        project: (projectAttribute)=>{
            const projects = projectAttribute.projectTypeValues.map((projectAttributeValue)=>({
                    name: projectAttributeValue.project.name,
                    id: projectAttributeValue.project.id,
                    avatarUrl: projectAttributeValue.project.avatarUrl,
                    key: projectAttributeValue.project.key
                }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bEgEM.ProjectsReadView), {
                projects: projects,
                showPlaceholderIfEmpty: showPlaceholderIfEmpty
            });
        },
        bitbucketRepo: (bitbucketRepoAttribute)=>{
            const bitbucketRepos = bitbucketRepoAttribute.bitbucketRepoTypeValues.map((bitbucketRepoTypeValue)=>({
                    uuid: bitbucketRepoTypeValue.bitbucketRepo.uuid,
                    name: bitbucketRepoTypeValue.bitbucketRepo.name,
                    avatarUrl: bitbucketRepoTypeValue.bitbucketRepo.avatarUrl,
                    url: bitbucketRepoTypeValue.bitbucketRepo.url
                }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dfnTD.BitbucketReposReadView), {
                bitbucketRepos: bitbucketRepos,
                showPlaceholderIfEmpty: showPlaceholderIfEmpty
            });
        },
        status: (statusAttribute)=>{
            const [status = null] = statusAttribute.statusTypeValues.map((statusAttributeValue)=>{
                const { id: id, name: name, category: category } = statusAttributeValue.status;
                return {
                    id: id,
                    name: name,
                    category: category
                };
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cPiBK.StatusReadView), {
                status: status
            });
        },
        opsgenieTeam: (opsgenieTeamAttribute)=>{
            const opsgenieTeams = opsgenieTeamAttribute.opsgenieTeamTypeValues.map((opsgenieTeamTypeValue)=>({
                    id: opsgenieTeamTypeValue.opsgenieTeam.id,
                    name: opsgenieTeamTypeValue.opsgenieTeam.name,
                    avatarUrl: opsgenieTeamTypeValue.opsgenieTeam.avatarUrl,
                    url: opsgenieTeamTypeValue.opsgenieTeam.url
                }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $icHaK.OpsgenieTeamsReadView), {
                opsgenieTeams: opsgenieTeams,
                showPlaceholderIfEmpty: showPlaceholderIfEmpty
            });
        }
    });
const $217c4a31be619567$export$d24cde01c782e0df = (props)=>{
    const { attributeValuesInfo: attributeValuesInfo, attributeName: attributeName } = props;
    const [isEditableAttributeModalOpen, setIsEditableAttributeModalOpen] = (0, $eJOHy.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jZkWo.MultiValueLozenge), {
        attributeValueType: attributeValuesInfo.type,
        count: attributeValuesInfo.attributeValues.length,
        onClick: ()=>{
            setIsEditableAttributeModalOpen(true);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $joj3R.AsyncEditableAttributeModal), {
        isOpen: isEditableAttributeModalOpen,
        isEditable: false,
        onClose: ()=>{
            setIsEditableAttributeModalOpen(false);
        },
        attributeName: attributeName,
        attributeValuesInfo: attributeValuesInfo
    }));
};
const $217c4a31be619567$export$24ff8c6c49acd72 = ({ attribute: attribute })=>(0, $2nGoJ.matchInsightObjectAttribute)(attribute, {
        default: (defaultAttribute)=>{
            const selectOptionsValue = (0, $bhqLs.getDefaultAttributeArrayValue)(attribute);
            return defaultAttribute.objectTypeAttribute.defaultType.name === 'Select' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($217c4a31be619567$export$d24cde01c782e0df, {
                attributeValuesInfo: {
                    type: 'select',
                    attributeValues: selectOptionsValue
                },
                attributeName: attribute.objectTypeAttribute.name
            }) : $217c4a31be619567$var$renderDefaultAttribute({
                defaultAttribute: defaultAttribute
            });
        },
        object: ()=>{
            const objectValue = (0, $2dVSF.getObjectReferenceOptions)(attribute);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($217c4a31be619567$export$d24cde01c782e0df, {
                attributeValuesInfo: {
                    type: 'object',
                    attributeValues: objectValue
                },
                attributeName: attribute.objectTypeAttribute.name
            });
        },
        user: ()=>{
            const userValue = (0, $86ghO.getUserValues)(attribute);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($217c4a31be619567$export$d24cde01c782e0df, {
                attributeValuesInfo: {
                    type: 'user',
                    attributeValues: userValue
                },
                attributeName: attribute.objectTypeAttribute.name
            });
        },
        group: ()=>{
            const groupValue = (0, $kN04d.getGroupValues)(attribute);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($217c4a31be619567$export$d24cde01c782e0df, {
                attributeValuesInfo: {
                    type: 'group',
                    attributeValues: groupValue
                },
                attributeName: attribute.objectTypeAttribute.name
            });
        },
        project: ()=>{
            const projectValue = (0, $b5zzG.getProjectValues)(attribute);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($217c4a31be619567$export$d24cde01c782e0df, {
                attributeValuesInfo: {
                    type: 'project',
                    attributeValues: projectValue
                },
                attributeName: attribute.objectTypeAttribute.name
            });
        },
        bitbucketRepo: ()=>{
            const bitbucketRepoValue = (0, $9RS73.getBBRepoValues)(attribute);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($217c4a31be619567$export$d24cde01c782e0df, {
                attributeValuesInfo: {
                    type: 'bitbucket',
                    attributeValues: bitbucketRepoValue
                },
                attributeName: attribute.objectTypeAttribute.name
            });
        },
        status: (statusAttribute)=>{
            const [status = null] = statusAttribute.statusTypeValues.map((statusAttributeValue)=>{
                const { id: id, name: name, category: category } = statusAttributeValue.status;
                return {
                    id: id,
                    name: name,
                    category: category
                };
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cPiBK.StatusReadView), {
                status: status
            });
        },
        opsgenieTeam: ()=>{
            const opsgenieTeamValue = (0, $9N6qc.getOpsgenieTeamValues)(attribute);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($217c4a31be619567$export$d24cde01c782e0df, {
                attributeValuesInfo: {
                    type: 'opsgenieTeam',
                    attributeValues: opsgenieTeamValue
                },
                attributeName: attribute.objectTypeAttribute.name
            });
        }
    });

});
parcelRegister("joj3R", function(module, exports) {
$parcel$export(module.exports, "AsyncEditableAttributeModal", () => $5a401a1ad4f83d4e$export$25cdbd874970f250);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5a401a1ad4f83d4e$var$LazyEditableAttributeModal = (0, $bQWwW.lazy)(()=>(parcelRequire("7udW4")), {
    moduleId: "./src/packages/servicedesk/insight-object/object-attributes/editable-attribute-modal/src/ui/main.tsx"
});
const $5a401a1ad4f83d4e$export$25cdbd874970f250 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "editable-attribute-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5a401a1ad4f83d4e$var$LazyEditableAttributeModal, props));

});
parcelRegister("7udW4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("f81NA")
]).then(()=>parcelRequire('9lsQo'));

});


parcelRegister("9RS73", function(module, exports) {
$parcel$export(module.exports, "getBBRepoValuesFromCmdbObjectAttribute", () => $9e38d3b6c4cef49f$export$a75dcd2bf197afa6);
$parcel$export(module.exports, "getBBRepoValues", () => $9e38d3b6c4cef49f$export$65fc4a6392a158be);
$parcel$export(module.exports, "useBBRepoValue", () => $9e38d3b6c4cef49f$export$9e2c1e26b30782be);

var $eJOHy = parcelRequire("eJOHy");

var $gE6Gx = parcelRequire("gE6Gx");
const $9e38d3b6c4cef49f$export$a75dcd2bf197afa6 = (attribute)=>{
    if (attribute && attribute.type === (0, $gE6Gx.AttributeTypeMap).BitbucketRepo) return attribute.objectAttributeValues.map(({ bitbucketRepo: { uuid: uuid, name: name, avatarUrl: avatarUrl, url: url } })=>({
            uuid: uuid,
            name: name,
            avatarUrl: avatarUrl,
            url: url
        }));
    return [];
};
const $9e38d3b6c4cef49f$export$65fc4a6392a158be = (attribute)=>{
    if (attribute && attribute.type === 'bitbucketRepo') return attribute.bitbucketRepoTypeValues.map(({ bitbucketRepo: { uuid: uuid, name: name, avatarUrl: avatarUrl, url: url } })=>({
            uuid: uuid,
            name: name,
            avatarUrl: avatarUrl,
            url: url
        }));
    return [];
};
const $9e38d3b6c4cef49f$export$9e2c1e26b30782be = (attribute)=>{
    const repos = $9e38d3b6c4cef49f$export$65fc4a6392a158be(attribute);
    const [value, setValue] = (0, $eJOHy.useState)(repos);
    (0, $eJOHy.useEffect)(()=>{
        setValue(()=>$9e38d3b6c4cef49f$export$65fc4a6392a158be(attribute));
    }, [
        attribute
    ]);
    return [
        value,
        setValue
    ];
};

});
parcelRegister("gE6Gx", function(module, exports) {
$parcel$export(module.exports, "AttributeTypeMap", () => $5cf5cd237542f0dc$export$e2adf49b6d954f74);
$parcel$export(module.exports, "DefaultAttributeSubtypeMap", () => $5cf5cd237542f0dc$export$3cb06cb40b82bd9d);
const $5cf5cd237542f0dc$export$e2adf49b6d954f74 = {
    Default: 0,
    Object: 1,
    User: 2,
    Group: 4,
    Project: 6,
    Status: 7,
    BitbucketRepo: 8,
    OpsgenieTeam: 9
};
const $5cf5cd237542f0dc$export$3cb06cb40b82bd9d = {
    Text: '0',
    Integer: '1',
    Boolean: '2',
    Double: '3',
    Date: '4',
    Time: '5',
    DateTime: '6',
    URL: '7',
    Email: '8',
    Textarea: '9',
    Select: '10',
    IPAddress: '11'
};

});


parcelRegister("bhqLs", function(module, exports) {
$parcel$export(module.exports, "getDefaultAttributeValue", () => $e86750aade8a0a0f$export$4e98ca3cdec5ea01);
$parcel$export(module.exports, "getDefaultAttributeDateValue", () => $e86750aade8a0a0f$export$290fdb90eecc7ddd);
$parcel$export(module.exports, "useDefaultAttributeValue", () => $e86750aade8a0a0f$export$9726152c665eb93d);
$parcel$export(module.exports, "useDefaultAttributeDateValue", () => $e86750aade8a0a0f$export$f8aa3daba94a8fad);
$parcel$export(module.exports, "getDefaultAttributeArrayValue", () => $e86750aade8a0a0f$export$d97f60a719553752);
$parcel$export(module.exports, "getDefaultAttributeArrayValueFromCmdbObjectAttribute", () => $e86750aade8a0a0f$export$6c6273ccb0a37e6b);
$parcel$export(module.exports, "useDefaultAttributeArrayValue", () => $e86750aade8a0a0f$export$5306abdbc015828);
$parcel$export(module.exports, "getDefaultMultipleAttributeValuesAsString", () => $e86750aade8a0a0f$export$6af279cafcf0ee60);
$parcel$export(module.exports, "useDefaultMultipleAttributeValuesAsString", () => $e86750aade8a0a0f$export$78ea80c1afdcdae7);
$parcel$export(module.exports, "getBooleanAttributeValue", () => $e86750aade8a0a0f$export$e9bd635e5d8abeb0);
$parcel$export(module.exports, "useBooleanValue", () => $e86750aade8a0a0f$export$779b38db25d966d);

var $eJOHy = parcelRequire("eJOHy");

var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");

var $7jTnu = parcelRequire("7jTnu");

var $gE6Gx = parcelRequire("gE6Gx");
const $e86750aade8a0a0f$export$4e98ca3cdec5ea01 = (attribute)=>{
    if (attribute && attribute.type === 'default') {
        if ((0, $7jTnu.fg)('insight_object_attribute_safe_value_access')) {
            const [defaultValue] = attribute.defaultTypeValues.filter((item)=>item?.value != null).map(({ value: value })=>value ?? '');
            return defaultValue ?? '';
        }
        // Original behavior
        const [defaultValue] = attribute.defaultTypeValues.map(({ value: value })=>value ?? '');
        return defaultValue;
    }
    return '';
};
const $e86750aade8a0a0f$export$290fdb90eecc7ddd = (attribute)=>{
    const defaultValue = $e86750aade8a0a0f$export$4e98ca3cdec5ea01(attribute);
    // checks if it is a valid date / datetime value
    if ((0, $dBLX0.default)((0, $kQ82p.default)(defaultValue))) return defaultValue;
    return '';
};
const $e86750aade8a0a0f$export$9726152c665eb93d = (attribute)=>{
    const [value, setValue] = (0, $eJOHy.useState)($e86750aade8a0a0f$export$4e98ca3cdec5ea01(attribute));
    (0, $eJOHy.useEffect)(()=>{
        setValue($e86750aade8a0a0f$export$4e98ca3cdec5ea01(attribute));
    }, [
        attribute
    ]);
    return [
        value,
        setValue
    ];
};
const $e86750aade8a0a0f$export$f8aa3daba94a8fad = (attribute)=>{
    const [value, setValue] = (0, $eJOHy.useState)($e86750aade8a0a0f$export$290fdb90eecc7ddd(attribute));
    (0, $eJOHy.useEffect)(()=>{
        setValue($e86750aade8a0a0f$export$290fdb90eecc7ddd(attribute));
    }, [
        attribute
    ]);
    return [
        value,
        setValue
    ];
};
const $e86750aade8a0a0f$export$d97f60a719553752 = (attribute)=>{
    if (attribute && attribute.type === 'default') {
        if ((0, $7jTnu.fg)('insight_object_attribute_safe_value_access')) return attribute.defaultTypeValues.filter((item)=>item?.value != null).map(({ value: value })=>value ?? '');
        return attribute.defaultTypeValues.map(({ value: value })=>value ?? '');
    }
    return [];
};
const $e86750aade8a0a0f$export$6c6273ccb0a37e6b = (attribute)=>{
    if (attribute && attribute.type === (0, $gE6Gx.AttributeTypeMap).Default) {
        if ((0, $7jTnu.fg)('insight_object_attribute_safe_value_access')) return attribute.objectAttributeValues.filter((item)=>item?.value != null).map(({ value: value })=>value ?? '');
        return attribute.objectAttributeValues.map(({ value: value })=>value ?? '');
    }
    return [];
};
const $e86750aade8a0a0f$export$5306abdbc015828 = (attribute)=>{
    const [value, setValue] = (0, $eJOHy.useState)($e86750aade8a0a0f$export$d97f60a719553752(attribute));
    (0, $eJOHy.useEffect)(()=>{
        setValue($e86750aade8a0a0f$export$d97f60a719553752(attribute));
    }, [
        attribute
    ]);
    return [
        value,
        setValue
    ];
};
const $e86750aade8a0a0f$export$6af279cafcf0ee60 = (attribute)=>{
    if (attribute && attribute.type === 'default') {
        if ((0, $7jTnu.fg)('insight_object_attribute_safe_value_access')) return attribute.defaultTypeValues.filter((item)=>item?.value != null).map(({ value: value })=>value ?? '').join(' ');
        return attribute.defaultTypeValues.map(({ value: value })=>value ?? '').join(' ');
    }
    return '';
};
const $e86750aade8a0a0f$export$78ea80c1afdcdae7 = (attribute)=>{
    const [value, setValue] = (0, $eJOHy.useState)($e86750aade8a0a0f$export$6af279cafcf0ee60(attribute));
    (0, $eJOHy.useEffect)(()=>{
        setValue($e86750aade8a0a0f$export$6af279cafcf0ee60(attribute));
    }, [
        attribute
    ]);
    return [
        value,
        setValue
    ];
};
const $e86750aade8a0a0f$export$e9bd635e5d8abeb0 = (attribute)=>{
    if (attribute && attribute.type === 'default') {
        if ((0, $7jTnu.fg)('insight_object_attribute_safe_value_access')) {
            const validValues = attribute.defaultTypeValues.filter((item)=>item?.value != null);
            if (validValues.length > 0) {
                const firstValue = validValues[0];
                if (firstValue && firstValue.value !== undefined) {
                    const { value: value } = firstValue;
                    if (value === 'true') return true;
                    if (value === 'false') return false;
                }
            }
        } else {
            const [{ value: value }] = attribute.defaultTypeValues;
            if (value === 'true') return true;
            if (value === 'false') return false;
        }
    }
    return null;
};
const $e86750aade8a0a0f$export$779b38db25d966d = (attribute)=>{
    const [value, setValue] = (0, $eJOHy.useState)($e86750aade8a0a0f$export$e9bd635e5d8abeb0(attribute));
    (0, $eJOHy.useEffect)(()=>{
        setValue($e86750aade8a0a0f$export$e9bd635e5d8abeb0(attribute));
    }, [
        attribute
    ]);
    return [
        value,
        setValue
    ];
};

});

parcelRegister("kN04d", function(module, exports) {
$parcel$export(module.exports, "getGroupValues", () => $7e8344f61343acad$export$b5c077265f461cf2);
$parcel$export(module.exports, "getGroupValuesFromCmdbObjectAttribute", () => $7e8344f61343acad$export$e828405854937ae4);
$parcel$export(module.exports, "useGroupValue", () => $7e8344f61343acad$export$f91c652cc4689b20);

var $eJOHy = parcelRequire("eJOHy");

var $gE6Gx = parcelRequire("gE6Gx");
const $7e8344f61343acad$export$b5c077265f461cf2 = (attribute)=>{
    if (attribute && attribute.type === 'group') return attribute.groupTypeValues.map(({ group: group })=>({
            name: group.name
        }));
    return [];
};
const $7e8344f61343acad$export$e828405854937ae4 = (attribute)=>{
    if (attribute && attribute.type === (0, $gE6Gx.AttributeTypeMap).Group) return attribute.objectAttributeValues.map(({ group: group })=>({
            name: group.name
        }));
    return [];
};
const $7e8344f61343acad$export$f91c652cc4689b20 = (attribute)=>{
    const groups = $7e8344f61343acad$export$b5c077265f461cf2(attribute);
    const [value, setValue] = (0, $eJOHy.useState)(groups);
    (0, $eJOHy.useEffect)(()=>{
        setValue(()=>$7e8344f61343acad$export$b5c077265f461cf2(attribute));
    }, [
        attribute
    ]);
    return [
        value,
        setValue
    ];
};

});

parcelRegister("9N6qc", function(module, exports) {
$parcel$export(module.exports, "getOpsgenieTeamValuesFromCmdbObjectAttribute", () => $cd946234b68a64f5$export$9665db3b7d2d5476);
$parcel$export(module.exports, "getOpsgenieTeamValues", () => $cd946234b68a64f5$export$b1f5d590ed42c101);

var $gE6Gx = parcelRequire("gE6Gx");
const $cd946234b68a64f5$export$9665db3b7d2d5476 = (attribute)=>{
    if (attribute && attribute.type === (0, $gE6Gx.AttributeTypeMap).OpsgenieTeam) return attribute.objectAttributeValues.map(({ opsgenieTeam: { id: id, name: name, avatarUrl: avatarUrl, url: url } })=>({
            id: id,
            name: name,
            avatarUrl: avatarUrl,
            url: url
        }));
    return [];
};
const $cd946234b68a64f5$export$b1f5d590ed42c101 = (attribute)=>{
    if (attribute && attribute.type === 'opsgenieTeam') return attribute.opsgenieTeamTypeValues.map(({ opsgenieTeam: { id: id, name: name, avatarUrl: avatarUrl, url: url } })=>({
            id: id,
            name: name,
            avatarUrl: avatarUrl,
            url: url
        }));
    return [];
};

});

parcelRegister("b5zzG", function(module, exports) {
$parcel$export(module.exports, "getProjectValuesFromCmdbObjectAttribute", () => $d04a3d649ebd27ca$export$b02ff11409d66b40);
$parcel$export(module.exports, "getProjectValues", () => $d04a3d649ebd27ca$export$7b4c1119513c4f04);
$parcel$export(module.exports, "useProjectValue", () => $d04a3d649ebd27ca$export$3baa71aec6ee674f);

var $eJOHy = parcelRequire("eJOHy");

var $gE6Gx = parcelRequire("gE6Gx");
const $d04a3d649ebd27ca$export$b02ff11409d66b40 = (attribute)=>{
    if (attribute && attribute.type === (0, $gE6Gx.AttributeTypeMap).Project) return attribute.objectAttributeValues.map(({ project: { id: id, name: name, avatarUrl: avatarUrl, key: key } })=>({
            id: id,
            name: name,
            avatarUrl: avatarUrl,
            key: key
        }));
    return [];
};
const $d04a3d649ebd27ca$export$7b4c1119513c4f04 = (attribute)=>{
    if (attribute && attribute.type === 'project') return attribute.projectTypeValues.map(({ project: { id: id, name: name, avatarUrl: avatarUrl, key: key } })=>({
            id: id,
            name: name,
            avatarUrl: avatarUrl,
            key: key
        }));
    return [];
};
const $d04a3d649ebd27ca$export$3baa71aec6ee674f = (attribute)=>{
    const projects = $d04a3d649ebd27ca$export$7b4c1119513c4f04(attribute);
    const [value, setValue] = (0, $eJOHy.useState)(projects);
    (0, $eJOHy.useEffect)(()=>{
        setValue(()=>$d04a3d649ebd27ca$export$7b4c1119513c4f04(attribute));
    }, [
        attribute
    ]);
    return [
        value,
        setValue
    ];
};

});

parcelRegister("2dVSF", function(module, exports) {
$parcel$export(module.exports, "getObjectReferenceOptions", () => $cf759999b66393cc$export$1a06540ad3f2682a);
$parcel$export(module.exports, "getObjectReferenceOptionsFromCmdbObjectAttribute", () => $cf759999b66393cc$export$9d12516ce595c9f4);
$parcel$export(module.exports, "useReferencedObjects", () => $cf759999b66393cc$export$19cdd7dd858266);

var $eJOHy = parcelRequire("eJOHy");

var $gE6Gx = parcelRequire("gE6Gx");
const $cf759999b66393cc$export$1a06540ad3f2682a = (attribute)=>{
    if (attribute && attribute.type === 'object') return attribute.objectTypeValues.map(({ referencedObject: { id: id, objectKey: objectKey, label: label, avatar: avatar } })=>({
            id: id,
            value: objectKey,
            label: label,
            avatar: avatar,
            objectKey: objectKey
        }));
    return [];
};
const $cf759999b66393cc$export$9d12516ce595c9f4 = (attribute)=>{
    if (attribute && attribute.type === (0, $gE6Gx.AttributeTypeMap).Object) return attribute.objectAttributeValues.map(({ referencedObject: { objectKey: objectKey, label: label, avatar: avatar, objectId: objectId, workspaceId: workspaceId } })=>{
        const obejectOptionAvatar = {
            ...avatar,
            objectId: objectId,
            workspaceId: workspaceId
        };
        return {
            id: objectId,
            value: objectKey,
            label: label,
            avatar: obejectOptionAvatar,
            objectKey: objectKey
        };
    });
    return [];
};
const $cf759999b66393cc$export$19cdd7dd858266 = (attribute)=>{
    const [value, setValue] = (0, $eJOHy.useState)($cf759999b66393cc$export$1a06540ad3f2682a(attribute));
    (0, $eJOHy.useEffect)(()=>{
        setValue(()=>$cf759999b66393cc$export$1a06540ad3f2682a(attribute));
    }, [
        attribute
    ]);
    return [
        value,
        setValue
    ];
};

});

parcelRegister("86ghO", function(module, exports) {
$parcel$export(module.exports, "getUserValues", () => $31ce8486c33e6093$export$c130a1cb7abd7a89);
$parcel$export(module.exports, "getUserValuesFromCmdbObjectAttribute", () => $31ce8486c33e6093$export$8fbf8e3b3db46a71);
$parcel$export(module.exports, "useUserValue", () => $31ce8486c33e6093$export$eb6455c0215ac0a5);

var $eJOHy = parcelRequire("eJOHy");

var $gE6Gx = parcelRequire("gE6Gx");
const $31ce8486c33e6093$export$c130a1cb7abd7a89 = (attribute)=>{
    if (attribute && attribute.type === 'user') return attribute.userTypeValues.map(({ user: user })=>({
            avatarUrl: user.avatarUrl,
            displayName: user.displayName,
            accountId: user.key
        }));
    return [];
};
const $31ce8486c33e6093$export$8fbf8e3b3db46a71 = (attribute)=>{
    if (attribute && attribute.type === (0, $gE6Gx.AttributeTypeMap).User) return attribute.objectAttributeValues.filter(({ user: user })=>user.key).map(({ user: user })=>({
            avatarUrl: user.avatarUrl ?? '',
            displayName: user.displayName ?? '',
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            accountId: user.key
        }));
    return [];
};
const $31ce8486c33e6093$export$eb6455c0215ac0a5 = (attribute)=>{
    const users = $31ce8486c33e6093$export$c130a1cb7abd7a89(attribute);
    const [value, setValue] = (0, $eJOHy.useState)(users);
    (0, $eJOHy.useEffect)(()=>{
        setValue(()=>$31ce8486c33e6093$export$c130a1cb7abd7a89(attribute));
    }, [
        attribute
    ]);
    return [
        value,
        setValue
    ];
};

});

parcelRegister("2nGoJ", function(module, exports) {
$parcel$export(module.exports, "defaultTypesById", () => $ed2d2033b3fcf84a$export$ed8b555acc54193b);
$parcel$export(module.exports, "matchAttributeType", () => $ed2d2033b3fcf84a$export$69224db698d1c3c3);
$parcel$export(module.exports, "matchInsightObjectAttributeType", () => $ed2d2033b3fcf84a$export$6499e045f2464672);
$parcel$export(module.exports, "matchInsightObjectAttribute", () => $ed2d2033b3fcf84a$export$b8b765eb52fe9337);
$parcel$export(module.exports, "matchDefaultAttributeSubType", () => $ed2d2033b3fcf84a$export$be874703ff226e1);
$parcel$export(module.exports, "matchDefaultAttribute", () => $ed2d2033b3fcf84a$export$f7a928b702c26457);

var $51aj0 = parcelRequire("51aj0");
const $ed2d2033b3fcf84a$export$ed8b555acc54193b = {
    0: 'text',
    1: 'integer',
    2: 'boolean',
    3: 'float',
    4: 'date',
    6: 'datetime',
    7: 'url',
    8: 'email',
    9: 'textarea',
    10: 'select',
    11: 'ip address'
};
const $ed2d2033b3fcf84a$export$69224db698d1c3c3 = (attributeType, handlers)=>{
    switch(attributeType){
        case 'default':
            return handlers.default();
        case 'object':
            return handlers.object();
        case 'user':
            return handlers.user();
        case 'group':
            return handlers.group();
        case 'project':
            return handlers.project();
        case 'status':
            return handlers.status();
        case 'bitbucketRepo':
            return handlers.bitbucketRepo();
        case 'opsgenieTeam':
            return handlers.opsgenieTeam();
        default:
            {
                const error = new Error(`Unknown attribute type: ${attributeType}`);
                (0, $51aj0.fireCmdbErrorAnalytics)({
                    meta: {
                        id: 'type-matcher.invalid.attribute.type',
                        packageName: 'jiraServicedeskInsightObjectTypes',
                        teamName: 'aurum'
                    },
                    error: error
                });
                throw error;
            }
    }
};
const $ed2d2033b3fcf84a$export$6499e045f2464672 = (attributeType, handlers)=>{
    switch(attributeType.type){
        case 'default':
            return handlers.default(attributeType);
        case 'object':
            return handlers.object(attributeType);
        case 'user':
            return handlers.user(attributeType);
        case 'group':
            return handlers.group(attributeType);
        case 'project':
            return handlers.project(attributeType);
        case 'status':
            return handlers.status(attributeType);
        case 'bitbucketRepo':
            return handlers.bitbucketRepo(attributeType);
        case 'opsgenieTeam':
            return handlers.opsgenieTeam(attributeType);
        default:
            {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const error = new Error(`Unknown attribute type: ${attributeType.type}`);
                (0, $51aj0.fireCmdbErrorAnalytics)({
                    meta: {
                        id: 'type-matcher.invalid.insight.object.attribute.type',
                        packageName: 'jiraServicedeskInsightObjectTypes',
                        teamName: 'aurum'
                    },
                    error: error
                });
                throw error;
            }
    }
};
const $ed2d2033b3fcf84a$export$b8b765eb52fe9337 = (attribute, handlers)=>{
    switch(attribute.type){
        case 'default':
            return handlers.default(attribute);
        case 'object':
            return handlers.object(attribute);
        case 'user':
            return handlers.user(attribute);
        case 'group':
            return handlers.group(attribute);
        case 'project':
            return handlers.project(attribute);
        case 'status':
            return handlers.status(attribute);
        case 'bitbucketRepo':
            return handlers.bitbucketRepo(attribute);
        case 'opsgenieTeam':
            return handlers.opsgenieTeam(attribute);
        default:
            {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const error = new Error(`Unknown attribute type: ${attribute.type}`);
                (0, $51aj0.fireCmdbErrorAnalytics)({
                    meta: {
                        id: 'type-matcher.invalid.insight.object.attribute',
                        packageName: 'jiraServicedeskInsightObjectTypes',
                        teamName: 'aurum'
                    },
                    error: error
                });
                throw error;
            }
    }
};
const $ed2d2033b3fcf84a$export$be874703ff226e1 = (defaultType, handlers)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const defaultSubType = $ed2d2033b3fcf84a$export$ed8b555acc54193b[defaultType.id];
    switch(defaultSubType){
        case 'url':
            return handlers.url();
        case 'email':
            return handlers.email();
        case 'float':
            return handlers.float();
        case 'integer':
            return handlers.integer();
        case 'ip address':
            return handlers.ipAddress();
        case 'text':
            return handlers.text();
        case 'textarea':
            return handlers.textarea();
        case 'select':
            return handlers.select();
        case 'boolean':
            return handlers.boolean();
        case 'date':
            return handlers.date();
        case 'datetime':
            return handlers.datetime();
        default:
            {
                const error = new Error(`Unknown default attribute type id: ${defaultType.id}`);
                (0, $51aj0.fireCmdbErrorAnalytics)({
                    meta: {
                        id: 'type-matcher.invalid.default..attribute.subtype',
                        packageName: 'jiraServicedeskInsightObjectTypes',
                        teamName: 'aurum'
                    },
                    error: error
                });
                throw error;
            }
    }
};
const $ed2d2033b3fcf84a$var$firstItemOrNull = (values)=>{
    const [first = null] = values;
    return first;
};
const $ed2d2033b3fcf84a$var$filterEmptyOrNullValues = (values)=>values.filter((value)=>value != null && value !== '');
const $ed2d2033b3fcf84a$export$f7a928b702c26457 = (defaultAttribute, handlers)=>{
    const values = defaultAttribute.defaultTypeValues.map(({ value: value })=>value);
    const nonNullValues = $ed2d2033b3fcf84a$var$filterEmptyOrNullValues(values);
    const firstValue = $ed2d2033b3fcf84a$var$firstItemOrNull(values);
    return $ed2d2033b3fcf84a$export$be874703ff226e1(defaultAttribute.objectTypeAttribute.defaultType, {
        url: ()=>handlers.url(nonNullValues),
        email: ()=>handlers.email(nonNullValues),
        float: ()=>handlers.float(firstValue),
        integer: ()=>handlers.integer(firstValue),
        ipAddress: ()=>handlers.ipAddress(firstValue),
        text: ()=>handlers.text(firstValue),
        textarea: ()=>handlers.textarea(firstValue),
        select: ()=>handlers.select(values),
        boolean: ()=>handlers.boolean(firstValue !== null ? firstValue === 'true' : null),
        date: ()=>handlers.date(firstValue),
        datetime: ()=>handlers.datetime(firstValue)
    });
};

});

parcelRegister("jZkWo", function(module, exports) {
$parcel$export(module.exports, "MultiValueLozenge", () => $92e86e7d37bf9592$export$1c8065d4dd09d460);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $5lAAn = parcelRequire("5lAAn");

var $7q9BG = parcelRequire("7q9BG");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $7jTnu = parcelRequire("7jTnu");

var $fH7iZ = parcelRequire("fH7iZ");
const $92e86e7d37bf9592$export$1c8065d4dd09d460 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ count: count, attributeValueType: attributeValueType, ...restProps }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const labelMessage = {
        object: {
            buttonLabel: formatMessage((0, $fH7iZ.default).objectsLabel),
            tooltipLabel: formatMessage((0, $fH7iZ.default).showAllObjects)
        },
        user: {
            buttonLabel: formatMessage((0, $fH7iZ.default).usersLabel),
            tooltipLabel: formatMessage((0, $fH7iZ.default).showAllUsers)
        },
        group: {
            buttonLabel: formatMessage((0, $fH7iZ.default).groupsLabel),
            tooltipLabel: formatMessage((0, $fH7iZ.default).showAllGroups)
        },
        project: {
            buttonLabel: (0, $7jTnu.fg)('itsm-project-renaming') ? formatMessage((0, $fH7iZ.default).projectsLabelGalaxia) : formatMessage((0, $fH7iZ.default).projectsLabel),
            tooltipLabel: (0, $7jTnu.fg)('itsm-project-renaming') ? formatMessage((0, $fH7iZ.default).showAllProjectsGalaxia) : formatMessage((0, $fH7iZ.default).showAllProjects)
        },
        opsgenieTeam: {
            buttonLabel: formatMessage((0, $fH7iZ.default).opsgenieTeamsLabel),
            tooltipLabel: formatMessage((0, $fH7iZ.default).showAllOpsgenieTeams)
        },
        bitbucket: {
            buttonLabel: formatMessage((0, $fH7iZ.default).bitbucketRepositoriesLabel),
            tooltipLabel: formatMessage((0, $fH7iZ.default).showAllBbRepos)
        },
        select: {
            buttonLabel: formatMessage((0, $fH7iZ.default).optionsLabel),
            tooltipLabel: formatMessage((0, $fH7iZ.default).showAllOptions)
        }
    };
    const label = labelMessage[attributeValueType].buttonLabel;
    const tooltipContent = labelMessage[attributeValueType].tooltipLabel;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: tooltipContent,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($92e86e7d37bf9592$var$LozengeButton, {
        innerRef: ref,
        ...restProps,
        testId: "servicedesk-insight-shared-ui.ui.multi-value-lozenge.lozenge-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($92e86e7d37bf9592$var$LozengeLabel, null, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($92e86e7d37bf9592$var$Count, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7q9BG.default), {
        max: false
    }, count)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($92e86e7d37bf9592$var$ExpandIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
        spacing: "spacious",
        label: "",
        size: "small"
    }))));
});
const $92e86e7d37bf9592$var$lozengeStyles = null; // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $92e86e7d37bf9592$var$LozengeButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _19itglyw _16qszucj _1e0c116y _4cvr1h6o _1bsb1wug _vchhusvi _4t3i1tcg _19pkidpf _2hwxidpf _otyr1b66 _18u0idpf _ca0qidpf _u5f31b66 _n3tdv77o _19bv1b66 _80omtlke _p12f11dc _bfhkhp5a _syaz1fxt _1a3b18uv _9oik18uv _4fprglyw _1bnxglyw _5goinqa1 _jf4cnqa1 _jomrhp5a _irr3hp5a _f8pj1fxt _30l31fxt _1di6hp5a",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $92e86e7d37bf9592$var$Count = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1o9zidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $92e86e7d37bf9592$var$ExpandIcon = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1pfkr5cr _1o9zidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $92e86e7d37bf9592$var$LozengeLabel = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _19pkidpf _2hwx1b66 _otyridpf _18u01b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fH7iZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $00a007fbc15febab$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $00a007fbc15febab$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    showAllObjects: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.show-all-objects",
        "defaultMessage": "Show all objects"
    },
    showAllGroups: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.show-all-groups",
        "defaultMessage": "Show all groups"
    },
    showAllUsers: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.show-all-users",
        "defaultMessage": "Show all users"
    },
    showAllOptions: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.show-all-options",
        "defaultMessage": "Show all options"
    },
    showAllBbRepos: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.show-all-bb-repos",
        "defaultMessage": "Show all Bitbucket repositories"
    },
    showAllItems: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.show-all-items",
        "defaultMessage": "Show all items"
    },
    showAllOpsgenieTeams: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.show-all-opsgenie-teams",
        "defaultMessage": "Show all Opsgenie teams"
    },
    showAllProjects: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.show-all-projects",
        "defaultMessage": "Show all projects"
    },
    showAllProjectsGalaxia: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.show-all-projects-galaxia",
        "defaultMessage": "Show all spaces"
    },
    bitbucketRepositoriesLabel: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.bitbucket-repositories-label",
        "defaultMessage": "Bitbucket repositories"
    },
    groupsLabel: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.groups-label",
        "defaultMessage": "Groups"
    },
    opsgenieTeamsLabel: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.opsgenie-teams-label",
        "defaultMessage": "Opsgenie teams"
    },
    objectsLabel: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.objects-label",
        "defaultMessage": "Objects"
    },
    optionsLabel: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.options-label",
        "defaultMessage": "Options"
    },
    usersLabel: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.users-label",
        "defaultMessage": "Users"
    },
    defaultLabel: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.default-label",
        "defaultMessage": "Items"
    },
    projectsLabel: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.projects-label",
        "defaultMessage": "Projects"
    },
    projectsLabelGalaxia: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.projects-label-galaxia",
        "defaultMessage": "Spaces"
    }
});

});


parcelRegister("dfnTD", function(module, exports) {
$parcel$export(module.exports, "BitbucketRepoReadView", () => $ebbd5264c0101e23$export$acf1d176a599bd06);
$parcel$export(module.exports, "BitbucketReposReadView", () => $ebbd5264c0101e23$export$a88683ce920266bd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cdbP5 = parcelRequire("cdbP5");

var $5DgXR = parcelRequire("5DgXR");

var $lRq8t = parcelRequire("lRq8t");

var $c9uTK = parcelRequire("c9uTK");

var $bJscI = parcelRequire("bJscI");

var $bz3JK = parcelRequire("bz3JK");

var $fkUZE = parcelRequire("fkUZE");
const $ebbd5264c0101e23$export$acf1d176a599bd06 = ({ name: name, avatarUrl: avatarUrl, url: url })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ebbd5264c0101e23$var$BitbucketRepoContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        appearance: "square",
        size: "xsmall",
        src: avatarUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ebbd5264c0101e23$var$NeutralLink, {
        href: url
    }, name));
const $ebbd5264c0101e23$export$a88683ce920266bd = ({ bitbucketRepos: bitbucketRepos, showPlaceholderIfEmpty: showPlaceholderIfEmpty = true })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (bitbucketRepos.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.ReadViewContainer), {
        isPlaceholder: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.PlaceholderSpacer), null, showPlaceholderIfEmpty ? formatMessage((0, $fkUZE.messages).placeholder) : null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.ReadViewContainer), {
        isPlaceholder: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ebbd5264c0101e23$var$BitbucketRepoList, null, bitbucketRepos.map(({ uuid: uuid, name: name, url: url, avatarUrl: avatarUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ebbd5264c0101e23$export$acf1d176a599bd06, {
            key: uuid,
            uuid: uuid,
            name: name,
            url: url,
            avatarUrl: avatarUrl
        }))));
};
const $ebbd5264c0101e23$var$neutralLinkStyles = null;
const $ebbd5264c0101e23$var$NeutralLinkNew = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), {
        ...props,
        className: (0, $hcewu.default)([
            "_syaz1gjq _30l31gjq"
        ])
    }, children);
}; // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
const $ebbd5264c0101e23$var$NeutralLinkOld = /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
(0, $cdbP5.default)((0, $c9uTK.Link)).withConfig({
    componentId: "dnjt16-0"
})({
    color: "var(--ds-text-subtle, #44546F)",
    '&:hover': {
        color: "var(--ds-text-subtle, #44546F)"
    }
});
const $ebbd5264c0101e23$var$NeutralLink = (0, $bJscI.componentWithFG)('enghealth-4761-compiled-migration', $ebbd5264c0101e23$var$NeutralLinkNew, $ebbd5264c0101e23$var$NeutralLinkOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ebbd5264c0101e23$var$BitbucketRepoList = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _1e0c1txw _1n261g80",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ebbd5264c0101e23$var$BitbucketRepoContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulp1b66 _2rkofajl _1e0c1txw _4cvr1h6o _bfhkm7j4 _ca0qv77o _u5f3u2gc _n3tdv77o _19bv1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bz3JK", function(module, exports) {
$parcel$export(module.exports, "ObjectDetailsSpacer", () => $fe3695ebde02fb28$export$b8f1b5c1e5f43c5c);
$parcel$export(module.exports, "ReadViewContainer", () => $fe3695ebde02fb28$export$ebb3489b83262b26);
$parcel$export(module.exports, "RoleList", () => $fe3695ebde02fb28$export$f28593264fbf36da);
$parcel$export(module.exports, "RoleContainer", () => $fe3695ebde02fb28$export$e5989493d486ab26);
$parcel$export(module.exports, "RoleDisplayName", () => $fe3695ebde02fb28$export$a57fa052c6fb1799);
$parcel$export(module.exports, "AvatarWrapper", () => $fe3695ebde02fb28$export$f7513421c53ce141);
$parcel$export(module.exports, "PlaceholderSpacer", () => $fe3695ebde02fb28$export$e5d47ed31c76a9c0);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");
const $fe3695ebde02fb28$export$b8f1b5c1e5f43c5c = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qu2gc _u5f312x7 _n3tdu2gc _19bv12x7",
            __cmplp.className
        ])
    });
});
const $fe3695ebde02fb28$var$readViewContainerStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px',
    minHeight: '18px',
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
    flexFlow: 'wrap'
});
const $fe3695ebde02fb28$var$readViewContainerPlaceholderStyles = (0, $1DXK0.xcss)({
    color: 'color.text.subtlest',
    wordBreak: 'break-word',
    overflowWrap: 'break-word'
});
const $fe3695ebde02fb28$var$readViewContainerNonPlaceholderStyles = (0, $1DXK0.xcss)({
    wordBreak: 'break-all'
});
const $fe3695ebde02fb28$export$ebb3489b83262b26 = ({ children: children, isPlaceholder: isPlaceholder })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "center",
        xcss: [
            $fe3695ebde02fb28$var$readViewContainerStyles,
            isPlaceholder ? $fe3695ebde02fb28$var$readViewContainerPlaceholderStyles : $fe3695ebde02fb28$var$readViewContainerNonPlaceholderStyles
        ]
    }, children);
const $fe3695ebde02fb28$export$f28593264fbf36da = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _1e0c1txw _1n261g80",
            __cmplp.className
        ])
    });
});
const $fe3695ebde02fb28$export$e5989493d486ab26 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1rr0 _1e0c1txw _4cvr1h6o _bfhkm7j4 _ca0qv77o _u5f3u2gc _n3tdv77o _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $fe3695ebde02fb28$export$a57fa052c6fb1799 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});
const $fe3695ebde02fb28$export$f7513421c53ce141 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u0r5cr _1aayyfq0",
            __cmplp.className
        ])
    });
});
const $fe3695ebde02fb28$export$e5d47ed31c76a9c0 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qv77o _u5f3idpf _n3tdv77o _19bvidpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("fkUZE", function(module, exports) {
$parcel$export(module.exports, "messages", () => $7fce6c37781760c6$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $7fce6c37781760c6$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    placeholder: {
        "id": "servicedesk-insight-attribute-views.bitbucket-repo.placeholder",
        "defaultMessage": "No Bitbucket repositories selected"
    }
});

});


parcelRegister("lKQ7J", function(module, exports) {
$parcel$export(module.exports, "BooleanReadView", () => $1afea81607548c9b$export$dbbcef15b3e9a21c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3TFuO = parcelRequire("3TFuO");

var $kXEdL = parcelRequire("kXEdL");

var $lRq8t = parcelRequire("lRq8t");

var $bz3JK = parcelRequire("bz3JK");

var $h3kPQ = parcelRequire("h3kPQ");
const $1afea81607548c9b$var$True = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1afea81607548c9b$var$Container, {
        "data-testid": "servicedesk-insight-attribute-views.ui.boolean.value-true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1afea81607548c9b$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3TFuO))), {
        spacing: "spacious",
        label: formatMessage((0, $h3kPQ.default).true),
        color: "var(--ds-icon-success, #22A06B)"
    })), formatMessage((0, $h3kPQ.default).true));
};
const $1afea81607548c9b$var$False = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1afea81607548c9b$var$Container, {
        "data-testid": "servicedesk-insight-attribute-views.ui.boolean.value-false"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1afea81607548c9b$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kXEdL))), {
        spacing: "spacious",
        label: formatMessage((0, $h3kPQ.default).false),
        color: "var(--ds-icon-danger, #C9372C)"
    })), formatMessage((0, $h3kPQ.default).false));
};
const $1afea81607548c9b$var$None = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1afea81607548c9b$var$Container, {
        "data-testid": "servicedesk-insight-attribute-views.ui.boolean.value-none"
    }, formatMessage((0, $h3kPQ.default).none));
};
const $1afea81607548c9b$export$dbbcef15b3e9a21c = ({ value: value })=>{
    let dropdownChild;
    switch(value){
        case true:
            dropdownChild = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1afea81607548c9b$var$True, null);
            break;
        case false:
            dropdownChild = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1afea81607548c9b$var$False, null);
            break;
        case null:
            dropdownChild = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1afea81607548c9b$var$None, null);
            break;
        default:
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.ReadViewContainer), {
        isPlaceholder: value === null
    }, dropdownChild);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1afea81607548c9b$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o _1n261g80 _1tke1tcg",
            __cmplp.className
        ])
    });
});
const $1afea81607548c9b$var$IconContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_15tynkob",
            __cmplp.className
        ])
    });
});

});
parcelRegister("h3kPQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f76497fb5f096c0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $2f76497fb5f096c0$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    true: {
        "id": "servicedesk-insight-attribute-views.boolean.true",
        "defaultMessage": "True"
    },
    false: {
        "id": "servicedesk-insight-attribute-views.boolean.false",
        "defaultMessage": "False"
    },
    none: {
        "id": "servicedesk-insight-attribute-views.boolean.none",
        "defaultMessage": "None"
    }
});

});


parcelRegister("jgtBt", function(module, exports) {
$parcel$export(module.exports, "DateTimeReadView", () => $ed65464c11e0c8cd$export$962e920a3f993096);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3GKOL = parcelRequire("3GKOL");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $3NHJr = parcelRequire("3NHJr");

var $evV3e = parcelRequire("evV3e");

var $bz3JK = parcelRequire("bz3JK");
const $ed65464c11e0c8cd$export$962e920a3f993096 = ({ value: value, showPlaceholderIfEmpty: showPlaceholderIfEmpty = true })=>{
    const { formatDateTime: formatDateTime } = (0, $3NHJr.useDateTimeFormatter)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const displayValue = value !== null ? formatDateTime(value) : null;
    const hasValue = value !== null;
    const placeholderText = showPlaceholderIfEmpty ? formatMessage((0, $evV3e.default).placeholderNoneSelected) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.ReadViewContainer), {
        isPlaceholder: !hasValue
    }, hasValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed65464c11e0c8cd$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3GKOL))), {
        spacing: "spacious",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $ed65464c11e0c8cd$var$textStyles
    }, displayValue)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.PlaceholderSpacer), null, placeholderText));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ed65464c11e0c8cd$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $ed65464c11e0c8cd$var$textStyles = (0, $1DXK0.xcss)({
    marginLeft: 'space.100'
});

});
parcelRegister("evV3e", function(module, exports) {
$parcel$export(module.exports, "default", () => $14627c70cefee1d0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $14627c70cefee1d0$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    placeholderNoneEntered: {
        "id": "servicedesk-insight-attribute-views.common.placeholder-none-entered",
        "defaultMessage": "None entered"
    },
    placeholderNoneSelected: {
        "id": "servicedesk-insight-attribute-views.common.placeholder-none-selected",
        "defaultMessage": "None selected"
    }
});

});


parcelRegister("2i6jd", function(module, exports) {
$parcel$export(module.exports, "DateReadView", () => $35ff4bd642b6d903$export$c663acc1a0b7c5a9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3GKOL = parcelRequire("3GKOL");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $3NHJr = parcelRequire("3NHJr");

var $evV3e = parcelRequire("evV3e");

var $bz3JK = parcelRequire("bz3JK");
const $35ff4bd642b6d903$export$c663acc1a0b7c5a9 = ({ value: value, showPlaceholderIfEmpty: showPlaceholderIfEmpty = true })=>{
    const { formatDateOnly: formatDateOnly } = (0, $3NHJr.useDateTimeFormatter)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const displayValue = value !== null && value !== '' ? formatDateOnly(value) : null;
    const placeholderText = showPlaceholderIfEmpty ? formatMessage((0, $evV3e.default).placeholderNoneSelected) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.ReadViewContainer), {
        isPlaceholder: !displayValue
    }, displayValue !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($35ff4bd642b6d903$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3GKOL))), {
        spacing: "spacious",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $35ff4bd642b6d903$var$textStyles
    }, displayValue)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.PlaceholderSpacer), null, placeholderText));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $35ff4bd642b6d903$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $35ff4bd642b6d903$var$textStyles = (0, $1DXK0.xcss)({
    marginLeft: 'space.100'
});

});

parcelRegister("7jPbD", function(module, exports) {
$parcel$export(module.exports, "GroupsReadView", () => $24b52f2e932d2c52$export$3a2147dfab2e76f1);

var $eJOHy = parcelRequire("eJOHy");

var $lG2jM = parcelRequire("lG2jM");

var $lRq8t = parcelRequire("lRq8t");

var $bz3JK = parcelRequire("bz3JK");

var $625z4 = parcelRequire("625z4");
const $24b52f2e932d2c52$var$GroupReadView = ({ displayName: displayName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.RoleContainer), {
        key: displayName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lG2jM))), {
        LEGACY_size: "small",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.RoleDisplayName), null, displayName));
const $24b52f2e932d2c52$export$3a2147dfab2e76f1 = ({ groups: groups, showPlaceholderIfEmpty: showPlaceholderIfEmpty = true })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (groups.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.ReadViewContainer), {
        isPlaceholder: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.PlaceholderSpacer), null, showPlaceholderIfEmpty ? formatMessage((0, $625z4.messages).placeholder) : null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.ReadViewContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.RoleList), null, groups.map(({ name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($24b52f2e932d2c52$var$GroupReadView, {
            key: name,
            displayName: name
        }))));
};

});
parcelRegister("625z4", function(module, exports) {
$parcel$export(module.exports, "messages", () => $f4dab0811c37b6b3$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $f4dab0811c37b6b3$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    placeholder: {
        "id": "servicedesk-insight-attribute-views.group.placeholder",
        "defaultMessage": "No groups selected"
    }
});

});


parcelRegister("icHaK", function(module, exports) {
$parcel$export(module.exports, "OpsgenieTeamReadView", () => $34b0eb94f39e7428$export$7629e14a1f5315d6);
$parcel$export(module.exports, "OpsgenieTeamsReadView", () => $34b0eb94f39e7428$export$829de5cf25cd0e9a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5DgXR = parcelRequire("5DgXR");

var $lG2jM = parcelRequire("lG2jM");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $gDXSd = parcelRequire("gDXSd");

var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $1z9Wk = parcelRequire("1z9Wk");

var $c9uTK = parcelRequire("c9uTK");

var $5CVQ0 = parcelRequire("5CVQ0");

var $7jTnu = parcelRequire("7jTnu");

var $bz3JK = parcelRequire("bz3JK");

var $eJJM3 = parcelRequire("eJJM3");
const $34b0eb94f39e7428$export$7629e14a1f5315d6 = ({ id: id, name: name, avatarUrl: avatarUrl, url: url })=>{
    const { data: data, loading: teamLoading, error: error, fetchTeamInfo: fetchTeamInfo } = (0, $1z9Wk.default)();
    const { shouldUseJSM: shouldUseJSM } = (0, $gDXSd.useOgTenantInfo)();
    const { showFlag: showFlag } = (0, $bILK0.useFlagService)();
    const platformTeamId = data?.platformTeamId;
    const teamUrl = shouldUseJSM ? `/jira/ops/teams/${platformTeamId}` : url;
    (0, $eJOHy.useEffect)(()=>{
        let teamId;
        if ((0, $7jTnu.fg)('assets_custom_field_opsgenie_teamid_fix')) teamId = (0, $5CVQ0.getTeamIdFromAri)(id);
        else teamId = id;
        if (shouldUseJSM) fetchTeamInfo(teamId);
    }, [
        id,
        fetchTeamInfo,
        shouldUseJSM
    ]);
    if (shouldUseJSM && teamLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $34b0eb94f39e7428$var$loadingSpinnerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), null));
    if (shouldUseJSM && error) {
        showFlag({
            type: 'error',
            title: (0, $eJJM3.messages).errorTitle,
            description: (0, $eJJM3.messages).errorMessage,
            messageId: 'servicedesk-insight-attribute-views.ui.opsgenie-team.show-flag.error',
            messageType: 'transactional'
        });
        return null;
    }
    if (shouldUseJSM && !teamLoading && !platformTeamId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($34b0eb94f39e7428$var$OpsgenieTeamContainer, null, avatarUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        appearance: "square",
        size: "xsmall",
        src: avatarUrl
    }), !avatarUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lG2jM))), {
        LEGACY_size: "small",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($34b0eb94f39e7428$var$NeutralLink, {
        href: teamUrl
    }, name));
};
const $34b0eb94f39e7428$export$829de5cf25cd0e9a = ({ opsgenieTeams: opsgenieTeams, showPlaceholderIfEmpty: showPlaceholderIfEmpty = true })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (opsgenieTeams && opsgenieTeams.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.ReadViewContainer), {
        isPlaceholder: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.PlaceholderSpacer), null, showPlaceholderIfEmpty ? formatMessage((0, $eJJM3.messages).placeholder) : null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.ReadViewContainer), {
        isPlaceholder: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($34b0eb94f39e7428$var$OpsgenieTeamList, null, opsgenieTeams.map(({ id: id, name: name, url: url, avatarUrl: avatarUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($34b0eb94f39e7428$export$7629e14a1f5315d6, {
            key: id,
            id: id,
            name: name,
            url: url,
            avatarUrl: avatarUrl
        }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $34b0eb94f39e7428$var$OpsgenieTeamList = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _1e0c1txw _1n261g80",
            __cmplp.className
        ])
    });
});
const $34b0eb94f39e7428$var$OpsgenieTeamContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulp1b66 _2rkofajl _1e0c1txw _4cvr1h6o _bfhkm7j4 _ca0qv77o _u5f3u2gc _n3tdv77o _19bv1b66",
            __cmplp.className
        ])
    });
});
const $34b0eb94f39e7428$var$NeutralLink = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $c9uTK.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1gjq _30l31gjq",
            __cmplp.className
        ])
    });
});
const $34b0eb94f39e7428$var$loadingSpinnerStyle = (0, $1DXK0.xcss)({
    display: 'flex',
    justifyContent: 'start'
});

});
parcelRegister("1z9Wk", function(module, exports) {
$parcel$export(module.exports, "default", () => $d075a8959290b966$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $hPZg4 = parcelRequire("hPZg4");

var $jGzN3 = parcelRequire("jGzN3");

var $02cn1 = parcelRequire("02cn1");
const $d075a8959290b966$var$useGetTeamById = ()=>{
    const request = (0, $eJOHy.useCallback)((ogTeamId)=>(0, $jGzN3.performGetRequest)((0, $02cn1.getJSDTeamByIdURL)(ogTeamId)), []);
    const { loading: loading, error: error, data: data, fetch: fetch } = (0, $hPZg4.useService)(request, {
        loading: false
    });
    const memoisedData = (0, $eJOHy.useMemo)(()=>data, [
        data
    ]);
    return {
        loading: loading,
        error: error,
        data: memoisedData,
        fetchTeamInfo: fetch
    };
};
var $d075a8959290b966$export$2e2bcd8739ae039 = $d075a8959290b966$var$useGetTeamById;

});
parcelRegister("02cn1", function(module, exports) {
$parcel$export(module.exports, "getJSDTeamByIdURL", () => $60f87b8ffea2f284$export$91d5f1626c213f57);
$parcel$export(module.exports, "getJiraOpsTeamUrl", () => $60f87b8ffea2f284$export$d9e125f82e12d02f);
const $60f87b8ffea2f284$export$91d5f1626c213f57 = (ogTeamId = '')=>`/jsd-escalator/api/teams/${ogTeamId}`;
const $60f87b8ffea2f284$export$d9e125f82e12d02f = (platformTeamId = '')=>`/jira/ops/teams/${platformTeamId}`;

});


parcelRegister("5CVQ0", function(module, exports) {
$parcel$export(module.exports, "getTeamById", () => $d9cf4ff63bab326c$export$5dcc6aff8319c1fe);
$parcel$export(module.exports, "getTeamIdFromAri", () => $d9cf4ff63bab326c$export$79f5460bf32654a7);

var $fmkvs = parcelRequire("fmkvs");
const $d9cf4ff63bab326c$export$5dcc6aff8319c1fe = (teams, id, defaultValue)=>{
    const found = id === null || id === '' ? defaultValue : teams && teams.filter((team)=>team.id === id)[0];
    return found || defaultValue;
};
const $d9cf4ff63bab326c$export$79f5460bf32654a7 = (opsgenieTeamAri)=>{
    try {
        return (0, $fmkvs.OpsgenieTeamAri).parse(opsgenieTeamAri).opsgenieTeamId;
    } catch (err) {
        return opsgenieTeamAri;
    }
};
const $d9cf4ff63bab326c$export$5627c1733e4cdf27 = (jiraProjectType)=>{
    switch(jiraProjectType){
        case 'JIRA_SOFTWARE':
            return 'JIRA_SOFTWARE';
        case 'JIRA_CORE':
            return 'JIRA_CORE';
        case 'JIRA_SERVICEDESK':
            return 'JIRA_SERVICEDESK';
        default:
            throw new Error(`Unrecognised project type: ${jiraProjectType}`);
    }
};

});
parcelRegister("fmkvs", function(module, exports) {
$parcel$export(module.exports, "OpsgenieTeamAri", () => $b2e8d1389e11bddc$export$5ad0eeac80812a5f);

var $6pGeK = parcelRequire("6pGeK");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/opsgenie/team/manifest.ts
var $b2e8d1389e11bddc$var$opsgenieTeamAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $6pGeK.OpsgenieTeamAriResourceOwner),
    resourceType: (0, $6pGeK.OpsgenieTeamAriResourceType),
    resourceIdSlug: "{opsgenieTeamId}",
    resourceIdSegmentFormats: {
        opsgenieTeamId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/opsgenie/team/index.ts
var $b2e8d1389e11bddc$export$5ad0eeac80812a5f = class _OpsgenieTeamAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._opsgenieTeamId = opts.resourceIdSegmentValues.opsgenieTeamId;
    }
    get siteId() {
        return this._siteId;
    }
    get opsgenieTeamId() {
        return this._opsgenieTeamId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $b2e8d1389e11bddc$var$opsgenieTeamAriStaticOpts.qualifier,
            platformQualifier: $b2e8d1389e11bddc$var$opsgenieTeamAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $b2e8d1389e11bddc$var$opsgenieTeamAriStaticOpts.resourceOwner,
            resourceType: $b2e8d1389e11bddc$var$opsgenieTeamAriStaticOpts.resourceType,
            resourceId: `${opts.opsgenieTeamId}`,
            resourceIdSegmentValues: {
                opsgenieTeamId: opts.opsgenieTeamId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $b2e8d1389e11bddc$var$opsgenieTeamAriStaticOpts);
        return new _OpsgenieTeamAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $b2e8d1389e11bddc$var$opsgenieTeamAriStaticOpts);
        return new _OpsgenieTeamAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            opsgenieTeamId: this.opsgenieTeamId
        };
    }
};

});
parcelRegister("6pGeK", function(module, exports) {
$parcel$export(module.exports, "OpsgenieTeamAriResourceOwner", () => $4ab5d73ac15f873f$export$af52998167d36ab8);
$parcel$export(module.exports, "OpsgenieTeamAriResourceType", () => $4ab5d73ac15f873f$export$40c53f20a05bce0e);
// src/opsgenie/team/types.ts
var $4ab5d73ac15f873f$export$af52998167d36ab8 = "opsgenie", $4ab5d73ac15f873f$export$40c53f20a05bce0e = "team";

});



parcelRegister("eJJM3", function(module, exports) {
$parcel$export(module.exports, "messages", () => $80c5f2250af473c6$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $80c5f2250af473c6$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    placeholder: {
        "id": "servicedesk-insight-attribute-views.opsgenie-team.placeholder",
        "defaultMessage": "No Opsgenie Team selected"
    },
    errorTitle: {
        "id": "servicedesk-insight-attribute-views.opsgenie-team.error-title",
        "defaultMessage": "Failed to load Opsgenie Team"
    },
    errorMessage: {
        "id": "servicedesk-insight-attribute-views.opsgenie-team.error-message",
        "defaultMessage": "Something went wrong. Please try again."
    }
});

});


parcelRegister("bEgEM", function(module, exports) {
$parcel$export(module.exports, "ProjectReadView", () => $5f94cbfa402abc20$export$5c3359f22f4596bc);
$parcel$export(module.exports, "ProjectsReadView", () => $5f94cbfa402abc20$export$3b0257bc8aa1acd0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cdbP5 = parcelRequire("cdbP5");

var $5DgXR = parcelRequire("5DgXR");

var $lRq8t = parcelRequire("lRq8t");

var $c9uTK = parcelRequire("c9uTK");

var $bJscI = parcelRequire("bJscI");

var $7jTnu = parcelRequire("7jTnu");

var $bz3JK = parcelRequire("bz3JK");

var $34nLI = parcelRequire("34nLI");
const $5f94cbfa402abc20$export$5c3359f22f4596bc = ({ avatarUrl: avatarUrl, displayName: displayName, projectKey: projectKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5f94cbfa402abc20$var$ProjectContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        appearance: "square",
        size: "xsmall",
        src: avatarUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5f94cbfa402abc20$var$NeutralLink, {
        href: `/browse/${projectKey}`
    }, displayName));
const $5f94cbfa402abc20$export$3b0257bc8aa1acd0 = ({ projects: projects, showPlaceholderIfEmpty: showPlaceholderIfEmpty = true })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const placeholderMessageKey = (0, $7jTnu.fg)('itsm-project-renaming') ? formatMessage((0, $34nLI.messages).placeholderGalaxia) : formatMessage((0, $34nLI.messages).placeholder);
    if (projects.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.ReadViewContainer), {
        isPlaceholder: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.PlaceholderSpacer), null, showPlaceholderIfEmpty ? placeholderMessageKey : null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.ReadViewContainer), {
        isPlaceholder: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5f94cbfa402abc20$var$ProjectList, null, projects.map(({ id: id, avatarUrl: avatarUrl, name: name, key: key })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5f94cbfa402abc20$export$5c3359f22f4596bc, {
            key: id,
            avatarUrl: avatarUrl,
            displayName: name,
            projectKey: key
        }))));
};
const $5f94cbfa402abc20$var$neutralLinkStyles = null;
const $5f94cbfa402abc20$var$NeutralLinkNew = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), {
        ...props,
        className: (0, $hcewu.default)([
            "_syaz1gjq _30l31gjq"
        ])
    }, children);
}; // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
const $5f94cbfa402abc20$var$NeutralLinkOld = /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
(0, $cdbP5.default)((0, $c9uTK.Link)).withConfig({
    componentId: "yo8gvf-0"
})({
    color: "var(--ds-text-subtle, #44546F)",
    '&:hover': {
        color: "var(--ds-text-subtle, #44546F)"
    }
});
const $5f94cbfa402abc20$var$NeutralLink = (0, $bJscI.componentWithFG)('enghealth-4761-compiled-migration', $5f94cbfa402abc20$var$NeutralLinkNew, $5f94cbfa402abc20$var$NeutralLinkOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5f94cbfa402abc20$var$ProjectList = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _1e0c1txw _1n261g80",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5f94cbfa402abc20$var$ProjectContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulp1b66 _2rkofajl _1e0c1txw _4cvr1h6o _bfhkm7j4 _ca0qv77o _u5f3u2gc _n3tdv77o _19bv1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("34nLI", function(module, exports) {
$parcel$export(module.exports, "messages", () => $330520c1ab3f2fe0$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $330520c1ab3f2fe0$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    placeholder: {
        "id": "servicedesk-insight-attribute-views.project.placeholder",
        "defaultMessage": "No projects selected"
    },
    placeholderGalaxia: {
        "id": "servicedesk-insight-attribute-views.project.placeholder-galaxia",
        "defaultMessage": "No spaces selected"
    }
});

});


parcelRegister("15pc8", function(module, exports) {
$parcel$export(module.exports, "ReferencedObjectCreateView", () => $6ab3c09426fe8191$export$ea78f3bd97835b9f);
$parcel$export(module.exports, "ReferencedObjectReadView", () => $6ab3c09426fe8191$export$ae3e6ca9eba42ca);
$parcel$export(module.exports, "ReferencedObjectsReadView", () => $6ab3c09426fe8191$export$a03416ddf396563c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $cdbP5 = parcelRequire("cdbP5");

var $12DRg = parcelRequire("12DRg");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $73gPp = parcelRequire("73gPp");

var $rJILZ = parcelRequire("rJILZ");

var $bYOuG = parcelRequire("bYOuG");

var $c9uTK = parcelRequire("c9uTK");

var $bJscI = parcelRequire("bJscI");

var $evV3e = parcelRequire("evV3e");

var $bz3JK = parcelRequire("bz3JK");
const $6ab3c09426fe8191$var$TooltipTag = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6ab3c09426fe8191$var$StyledTooltipTag, {
        ref: ref,
        ...props
    }));
const $6ab3c09426fe8191$export$25bd2ea9110ffe38 = ({ label: label, avatar: avatar, icon: icon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $rJILZ.UnstyledInsightIcon), {
        iconUrl: (0, $73gPp.getUniqueIconUrl)(icon),
        size: "xsmall",
        label: label
    }), avatar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $rJILZ.UnstyledInsightIcon), {
        mediaClientConfig: avatar.mediaClientConfig,
        iconUrl: avatar.url48,
        size: "xsmall",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: label,
        tag: $6ab3c09426fe8191$var$TooltipTag,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6ab3c09426fe8191$var$ReferencedObjectLabel, null, label)));
const $6ab3c09426fe8191$export$ea78f3bd97835b9f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6ab3c09426fe8191$var$PlainText, {
        forceMaxWidth: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6ab3c09426fe8191$export$25bd2ea9110ffe38, {
        label: props.label,
        icon: props.icon
    }));
const $6ab3c09426fe8191$var$DEFAULT_APPEARANCE = 'card';
const $6ab3c09426fe8191$export$ae3e6ca9eba42ca = ({ appearance: appearance = $6ab3c09426fe8191$var$DEFAULT_APPEARANCE, includeLink: includeLink = true, onClick: onClick = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), forceMaxWidth: forceMaxWidth = true, ...referencedObject })=>{
    const { id: id, label: label, avatar: avatar } = referencedObject;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6ab3c09426fe8191$export$25bd2ea9110ffe38, {
        label: label,
        avatar: avatar
    });
    if (appearance === 'card') return includeLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6ab3c09426fe8191$var$LozengeLink, {
        to: (0, $bYOuG.createObjectDetailUrl)(id),
        onClick: onClick,
        forceMaxWidth: forceMaxWidth
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6ab3c09426fe8191$var$LozengeText, {
        forceMaxWidth: forceMaxWidth
    }, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6ab3c09426fe8191$var$PlainText, {
        forceMaxWidth: forceMaxWidth
    }, content);
};
const $6ab3c09426fe8191$export$a03416ddf396563c = ({ referencedObjects: referencedObjects, appearance: appearance = $6ab3c09426fe8191$var$DEFAULT_APPEARANCE, includeLink: includeLink = true, showPlaceholderIfEmpty: showPlaceholderIfEmpty = true })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const hasValues = referencedObjects.length > 0;
    const placeholderText = showPlaceholderIfEmpty ? formatMessage((0, $evV3e.default).placeholderNoneSelected) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.ReadViewContainer), {
        isPlaceholder: !hasValues
    }, hasValues ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6ab3c09426fe8191$var$ReferencedObjectsContainer, null, referencedObjects.map((referencedObject)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6ab3c09426fe8191$export$ae3e6ca9eba42ca // This needs to be ID because when creating a new object the key is a blank string breaking the map
        , {
            key: referencedObject.id,
            ...referencedObject,
            includeLink: includeLink,
            appearance: appearance
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.PlaceholderSpacer), null, placeholderText));
};
const $6ab3c09426fe8191$var$ellipsesTruncation = /*#__PURE__*/ (0, $cdbP5.css)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $6ab3c09426fe8191$var$ellipsesTruncation2 = null;
const $6ab3c09426fe8191$var$maxWidth = /*#__PURE__*/ (0, $cdbP5.css)({
    maxWidth: '152px'
});
const $6ab3c09426fe8191$var$maxWidth2 = null;
const $6ab3c09426fe8191$var$lozengeStyles = /*#__PURE__*/ (0, $cdbP5.css)({
    display: 'inline-flex',
    alignItems: 'center',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-100, 8px)"}`,
    backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
    color: "var(--ds-text, #172B4D)",
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderRadius: "var(--ds-radius-small, 3px)",
    marginRight: "var(--ds-space-050, 4px)"
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.forceMaxWidth ? $6ab3c09426fe8191$var$maxWidth : null, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$6ab3c09426fe8191$var$ellipsesTruncation, {
    boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
});
const $6ab3c09426fe8191$var$lozengeStyles2 = null;
const $6ab3c09426fe8191$var$tooltipStyles = null; // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6ab3c09426fe8191$var$StyledTooltipTag = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ...props,
        ref: ref,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1ul9idpf"
        ])
    }, children));
const $6ab3c09426fe8191$var$lozengeLinkStyles = null;
const $6ab3c09426fe8191$var$LozengeLinkNew = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), {
        ...props,
        className: (0, $hcewu.default)([
            "_2rkofajl _1reo15vq _18m915vq _1e0c116y _4cvr1h6o _ca0qv77o _u5f3u2gc _n3tdv77o _19bvu2gc _bfhkhp5a _syaz1fxt _2hwx1b66 _o5721q9c _1bto1l2s _16qszucj _1a3b18uv _9oik18uv _4fprglyw _1bnxglyw _5goinqa1 _jf4cnqa1 _jomr166n _irr3166n _f8pj1fxt _30l31fxt _1di61dty",
            props.forceMaxWidth && "_p12f1llu"
        ])
    }, children);
const $6ab3c09426fe8191$var$referencedObjectsContainerStyles = null;
const $6ab3c09426fe8191$var$ReferencedObjectsContainer = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_zulp1b66 _1e0c1txw _1n261g80 _p12f1osq"
        ])
    }, children);
const $6ab3c09426fe8191$var$LozengeTextNew = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ...props,
        className: (0, $hcewu.default)([
            "_2rkofajl _1reo15vq _18m915vq _1e0c116y _4cvr1h6o _ca0qv77o _u5f3u2gc _n3tdv77o _19bvu2gc _bfhkhp5a _syaz1fxt _2hwx1b66 _o5721q9c _1bto1l2s _16qszucj",
            props.forceMaxWidth && "_p12f1llu"
        ])
    }, children);
const $6ab3c09426fe8191$var$plainTextStyles = null;
const $6ab3c09426fe8191$var$PlainTextNew = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ...props,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _ca0qv77o _u5f3idpf _n3tdv77o _19bvidpf _2hwx1b66 _bfhk1kw7 _syaz1fxt",
            props.forceMaxWidth && "_p12f1llu"
        ])
    }, children);
const $6ab3c09426fe8191$var$referencedObjectLabelStyles = null;
const $6ab3c09426fe8191$var$ReferencedObjectLabelNew = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _18u01b66 _o5721q9c _1bto1l2s"
        ])
    }, children); // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
const $6ab3c09426fe8191$var$LozengeLinkOld = /*#__PURE__*/ (0, $cdbP5.default)((0, $c9uTK.Link)).withConfig({
    componentId: "gcmv2o-0"
})`${$6ab3c09426fe8191$var$lozengeStyles};&:focus,&:hover{background-color:${"var(--ds-background-neutral-subtle-hovered, #091E420F)"};color:${"var(--ds-text, #172B4D)"};text-decoration:none;}&:active{background-color:${"var(--ds-background-neutral-subtle-pressed, #091E4224)"};}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression
const $6ab3c09426fe8191$var$LozengeTextOld = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "gcmv2o-1"
})`${$6ab3c09426fe8191$var$lozengeStyles};`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $6ab3c09426fe8191$var$ReferencedObjectLabelOld = /*#__PURE__*/ (0, $cdbP5.default).span.withConfig({
    componentId: "gcmv2o-2"
})({
    marginLeft: "var(--ds-space-050, 4px)"
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$6ab3c09426fe8191$var$ellipsesTruncation); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $6ab3c09426fe8191$var$PlainTextOld = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "gcmv2o-3"
})({
    display: 'flex',
    alignItems: 'center',
    padding: `${"var(--ds-space-025, 2px)"} 0`,
    marginRight: "var(--ds-space-050, 4px)",
    backgroundColor: 'inherit',
    color: "var(--ds-text, #172B4D)"
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.forceMaxWidth ? $6ab3c09426fe8191$var$maxWidth : null);
const $6ab3c09426fe8191$var$LozengeText = (0, $bJscI.componentWithFG)('fly-2200-styled-component-migration', $6ab3c09426fe8191$var$LozengeTextNew, $6ab3c09426fe8191$var$LozengeTextOld);
const $6ab3c09426fe8191$var$ReferencedObjectLabel = (0, $bJscI.componentWithFG)('fly-2200-styled-component-migration', $6ab3c09426fe8191$var$ReferencedObjectLabelNew, $6ab3c09426fe8191$var$ReferencedObjectLabelOld);
const $6ab3c09426fe8191$var$PlainText = (0, $bJscI.componentWithFG)('fly-2200-styled-component-migration', $6ab3c09426fe8191$var$PlainTextNew, $6ab3c09426fe8191$var$PlainTextOld);
const $6ab3c09426fe8191$var$LozengeLink = (0, $bJscI.componentWithFG)('fly-2200-styled-component-migration', $6ab3c09426fe8191$var$LozengeLinkNew, $6ab3c09426fe8191$var$LozengeLinkOld);

});
parcelRegister("73gPp", function(module, exports) {
$parcel$export(module.exports, "getUniqueIconUrl", () => $756001701f37da59$export$85a1f43e7ff44c3f);

var $51aj0 = parcelRequire("51aj0");
const $756001701f37da59$export$85a1f43e7ff44c3f = (icon, options = {
    size: '48'
})=>{
    const sizeUrl = options.size === '48' ? icon.url48 : icon.url16;
    // In storybook mode, the icon URL is a data URL and appending with a query param will result in an invalid data URL
    if (sizeUrl.startsWith('data:')) return sizeUrl;
    try {
        const url = new URL(sizeUrl);
        // Give each icon a unique URL by appending the iconId query param
        url.searchParams.append('iconId', icon.id);
        return url.toString();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $51aj0.fireCmdbErrorAnalytics)({
            error: error,
            meta: {
                id: 'getUniqueIconUrl',
                packageName: 'jiraServicedeskInsightIcon',
                teamName: 'aurum'
            }
        });
        return sizeUrl;
    }
};

});

parcelRegister("rJILZ", function(module, exports) {
$parcel$export(module.exports, "InsightIcon", () => $b4089468fa56dc7f$export$4f72cced31fa9b94);
$parcel$export(module.exports, "MemoizedInsightIcon", () => $b4089468fa56dc7f$export$55641517b59933d7);
$parcel$export(module.exports, "UnstyledInsightIcon", () => $b4089468fa56dc7f$export$30c7947f25987be2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $2TCFC = parcelRequire("2TCFC");
var $5DgXR = parcelRequire("5DgXR");
var $lC3pF = parcelRequire("lC3pF");

var $cgxPA = parcelRequire("cgxPA");

var $51aj0 = parcelRequire("51aj0");
const $b4089468fa56dc7f$export$d80733771196ad02 = (mediaClientConfig)=>Boolean(mediaClientConfig.mediaBaseUrl) && Boolean(mediaClientConfig.mediaJwtToken) && Boolean(mediaClientConfig.clientId) && Boolean(mediaClientConfig.fileId);
const $b4089468fa56dc7f$var$DefaultIcon = ({ size: size, label: label })=>/*#__PURE__*/ $eJOHy.createElement((0, $5DgXR.default), {
        appearance: "square",
        size: size,
        name: label
    });
const $b4089468fa56dc7f$export$a39db5532f57c7c2 = (clientAuth)=>Promise.resolve({
        clientId: clientAuth.clientId,
        token: clientAuth.mediaJwtToken,
        baseUrl: clientAuth.mediaBaseUrl
    });
const $b4089468fa56dc7f$export$4f72cced31fa9b94 = (props)=>{
    const { iconUrl: iconUrl, size: size, label: label, mediaClientConfig: mediaClientConfig } = props;
    if (false) return /*#__PURE__*/ $eJOHy.createElement((0, $lC3pF.default), {
        appearance: "square",
        size: size
    });
    const sizeInPx = (0, $2TCFC.AVATAR_SIZES)[size];
    const renderAvatar = (src)=>/*#__PURE__*/ $eJOHy.createElement("img", {
            loading: "lazy",
            src: src,
            width: sizeInPx,
            height: sizeInPx,
            alt: ""
        });
    if (!mediaClientConfig || $b4089468fa56dc7f$export$d80733771196ad02(mediaClientConfig) === false) {
        if (iconUrl) return renderAvatar(iconUrl);
        return /*#__PURE__*/ $eJOHy.createElement($b4089468fa56dc7f$var$DefaultIcon, {
            size: size,
            label: label
        });
    }
    const fileIdentifier = {
        id: mediaClientConfig.fileId,
        mediaItemType: 'file'
    };
    const imageSize = {
        width: (0, $2TCFC.AVATAR_SIZES)[size],
        height: (0, $2TCFC.AVATAR_SIZES)[size]
    };
    return /*#__PURE__*/ $eJOHy.createElement((0, $cgxPA.MediaImageWithErrorBoundary), {
        identifier: fileIdentifier,
        mediaClientConfig: {
            authProvider: ()=>$b4089468fa56dc7f$export$a39db5532f57c7c2(mediaClientConfig)
        },
        apiConfig: imageSize
    }, ({ loading: loading, error: error, data: data })=>{
        if (loading) return /*#__PURE__*/ $eJOHy.createElement((0, $lC3pF.default), {
            appearance: "square",
            size: size
        });
        if (error) {
            (0, $51aj0.fireCmdbErrorAnalytics)({
                error: // @ts-expect-error - TS2322 - Type 'true' is not assignable to type 'Error | undefined'.
                error,
                meta: {
                    id: 'insightIcon',
                    packageName: 'jiraServicedeskInsightIcon',
                    teamName: 'aurum'
                }
            });
            return /*#__PURE__*/ $eJOHy.createElement($b4089468fa56dc7f$var$DefaultIcon, {
                size: size,
                label: label
            });
        }
        if (!data) return /*#__PURE__*/ $eJOHy.createElement($b4089468fa56dc7f$var$DefaultIcon, {
            size: size,
            label: label
        });
        return renderAvatar(data.src);
    });
};
const $b4089468fa56dc7f$export$55641517b59933d7 = /*#__PURE__*/ (0, $eJOHy.memo)($b4089468fa56dc7f$export$4f72cced31fa9b94);
const $b4089468fa56dc7f$export$30c7947f25987be2 = (props)=>/*#__PURE__*/ $eJOHy.createElement($b4089468fa56dc7f$var$UnstyledInsightIconWrapper, null, /*#__PURE__*/ $eJOHy.createElement($b4089468fa56dc7f$export$55641517b59933d7, props));
/**
 * The reason for calling !important on display block is to ovveride the inherited
 * CSS from Avatar atlaskit component in order to centre the icon within the reference
 * object container.
 */ // Double check the shadow !
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b4089468fa56dc7f$var$UnstyledInsightIconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pk1i6y _2hwx1i6y _otyr1i6y _18u01i6y _1e0c1txw _p7r1tcjq _1ugpglyw",
            __cmplp.className
        ])
    });
});

});


parcelRegister("5DV7j", function(module, exports) {
$parcel$export(module.exports, "SelectReadView", () => $af206decaeabb025$export$29081d16772ffc8d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $ewOxf = parcelRequire("ewOxf");

var $lRq8t = parcelRequire("lRq8t");

var $evV3e = parcelRequire("evV3e");

var $bz3JK = parcelRequire("bz3JK");
const $af206decaeabb025$export$29081d16772ffc8d = ({ value: value, showPlaceholderIfEmpty: showPlaceholderIfEmpty = true })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const hasValue = value.length > 0;
    const placeholderText = showPlaceholderIfEmpty ? formatMessage((0, $evV3e.default).placeholderNoneSelected) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.ReadViewContainer), {
        isPlaceholder: !hasValue
    }, hasValue ? value.map((val)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($af206decaeabb025$var$Wrapper, {
            key: val
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewOxf.default), {
            text: val
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($af206decaeabb025$var$PlaceholderSpacer, null, placeholderText));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $af206decaeabb025$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u0r5cr _2hwx1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $af206decaeabb025$var$PlaceholderSpacer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0q1b66 _u5f3idpf _n3td1b66 _19bvidpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("cPiBK", function(module, exports) {
$parcel$export(module.exports, "StatusReadView", () => $2a916f65aab8c499$export$82fc58a40c5b3a52);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $evV3e = parcelRequire("evV3e");

var $bz3JK = parcelRequire("bz3JK");

var $3r8QE = parcelRequire("3r8QE");
const $2a916f65aab8c499$export$82fc58a40c5b3a52 = ({ status: status })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const placeholderText = formatMessage((0, $evV3e.default).placeholderNoneSelected);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.ReadViewContainer), {
        isPlaceholder: !status
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.PlaceholderSpacer), null, status !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3r8QE.StatusLozenge), {
        ellipsis: true,
        isEditable: false,
        status: status
    }) : placeholderText));
};

});
parcelRegister("3r8QE", function(module, exports) {
$parcel$export(module.exports, "StatusLozenge", () => $1ae0097e395b90b7$export$f72db4ad1e9b3e6d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $cdbP5 = parcelRequire("cdbP5");

var $6BxzS = parcelRequire("6BxzS");

var $jdqdp = parcelRequire("jdqdp");

var $bJscI = parcelRequire("bJscI");
const $1ae0097e395b90b7$export$f72db4ad1e9b3e6d = ({ isEditable: isEditable, status: status, ellipsis: ellipsis })=>{
    const { name: name, category: category } = status;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1ae0097e395b90b7$var$LozengeOverrides // @ts-expect-error - TS2322: Type 'null' is not assignable to type '0 | 1 | 2 | null'.
    , {
        category: category,
        isEditable: isEditable,
        "data-testid": "servicedesk-insight-attribute-views.ui.status.status-lozenge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1ae0097e395b90b7$var$LozengeContent, null, isEditable || ellipsis ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1ae0097e395b90b7$var$EllipsisOverflow, null, name) : name, isEditable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6BxzS))), {
        LEGACY_size: "small",
        spacing: "compact",
        label: "",
        size: "small"
    }))));
};
const $1ae0097e395b90b7$var$statusCategory = {
    '0': 'inactive',
    '1': 'active',
    '2': 'pending',
    null: 'none'
};
const $1ae0097e395b90b7$var$statusBackground = {
    inactive: "var(--ds-background-danger, #FFECEB)",
    active: "var(--ds-background-success, #DCFFF1)",
    pending: "var(--ds-background-warning, #FFF7D6)",
    none: "var(--ds-background-neutral, #091E420F)"
};
const $1ae0097e395b90b7$var$bgHoverColor = {
    inactive: "var(--ds-background-danger-hovered, #FFD5D2)",
    active: "var(--ds-background-success-hovered, #BAF3DB)",
    pending: "var(--ds-background-warning-hovered, #F8E6A0)",
    none: "var(--ds-background-neutral-hovered, #091E4224)"
};
const $1ae0097e395b90b7$var$textColor = {
    inactive: "var(--ds-text-danger, #AE2E24)",
    active: "var(--ds-text-success, #216E4E)",
    pending: "var(--ds-text, #172B4D)",
    none: "var(--ds-text-subtle, #44546F)"
};
const $1ae0097e395b90b7$var$lozengeSpanEditablePaddingStyle = null; // TODO: remove this once we have migrated to the new css prop
const $1ae0097e395b90b7$var$lozengeSpanNonEditablePaddingStyle = null;
const $1ae0097e395b90b7$var$lozengeOverridesStyles = null; // TODO remove eslint-disable once we have migrated to the new css prop
const $1ae0097e395b90b7$var$lozengeContentStyles = null;
const $1ae0097e395b90b7$var$LozengeContent = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o"
        ])
    }, children); // TODO remove eslint-disable once we have migrated to the new css prop
const $1ae0097e395b90b7$var$ellipsisOverflowStyles = null;
const $1ae0097e395b90b7$var$EllipsisOverflow = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s"
        ])
    }, children);
const $1ae0097e395b90b7$var$categoryStyles = null;
const $1ae0097e395b90b7$var$editableCategoryStyles = null;
const $1ae0097e395b90b7$var$LozengeOverridesNew = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ...props,
        style: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {
            '--status-background-hover-color': $1ae0097e395b90b7$var$bgHoverColor[$1ae0097e395b90b7$var$statusCategory[props.category]],
            '--status-background-color': $1ae0097e395b90b7$var$statusBackground[$1ae0097e395b90b7$var$statusCategory[props.category]],
            '--status-text-color': $1ae0097e395b90b7$var$textColor[$1ae0097e395b90b7$var$statusCategory[props.category]]
        },
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _15ty1ndm _1nr3zryt _1a8r4jg8",
            props.isEditable ? "_16tx1y44 _12qei2wt _12y31y44 _1gzji2wt" : "_16txyh40 _12qeyh40 _12y3yh40 _1gzjyh40",
            "_1plvgz6p _1t4p14zc",
            props.isEditable && "_6nvk19pz"
        ])
    }, children); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1ae0097e395b90b7$var$LozengeOverridesOld = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "sc-6n5sz-0"
})`display:flex;align-items:center;> span{padding:${(props)=>props.isEditable ? '4px 6px' : '2px'};vertical-align:text-bottom;color:${(props)=>$1ae0097e395b90b7$var$textColor[$1ae0097e395b90b7$var$statusCategory[props.category]]};background-color:${(props)=>$1ae0097e395b90b7$var$statusBackground[$1ae0097e395b90b7$var$statusCategory[props.category]]};${(props)=>props.isEditable ? (0, $cdbP5.css)({
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: `${$1ae0097e395b90b7$var$bgHoverColor[$1ae0097e395b90b7$var$statusCategory[props.category]]}`
        }
    }) : ''};}> span > span{text-overflow:clip;white-space:normal;}`;
const $1ae0097e395b90b7$var$LozengeOverrides = (0, $bJscI.componentWithFG)('fly-2200-styled-component-migration', $1ae0097e395b90b7$var$LozengeOverridesNew, $1ae0097e395b90b7$var$LozengeOverridesOld);

});


parcelRegister("k1i1U", function(module, exports) {
$parcel$export(module.exports, "TextAreaReadView", () => $a3c87fb170f156fe$export$213c0592d08e5858);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jHb5v = parcelRequire("jHb5v");

var $lRq8t = parcelRequire("lRq8t");

var $43nEs = parcelRequire("43nEs");

var $evV3e = parcelRequire("evV3e");

var $bz3JK = parcelRequire("bz3JK");
const $a3c87fb170f156fe$var$sanitize = (html)=>(0, (/*@__PURE__*/$parcel$interopDefault($jHb5v))).sanitize(html, {
        // @ts-expect-error - TS2769 - No overload matches this call.
        ALLOWED_TAGS: (0, $43nEs.ALLOWED_TEXT_AREA_ATTRIBUTE_HTML_TAGS),
        ALLOWED_ATTR: [
            'role',
            'tabindex',
            'href',
            'target'
        ]
    });
const $a3c87fb170f156fe$export$213c0592d08e5858 = ({ value: value, showPlaceholderIfEmpty: showPlaceholderIfEmpty = true })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const nonNullValue = value ?? '';
    const hasValue = nonNullValue.length > 0;
    const placeholderText = showPlaceholderIfEmpty ? formatMessage((0, $evV3e.default).placeholderNoneEntered) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.ReadViewContainer), {
        isPlaceholder: !hasValue
    }, hasValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a3c87fb170f156fe$var$ReadOnlyView, {
        dangerouslySetInnerHTML: {
            __html: $a3c87fb170f156fe$var$sanitize(nonNullValue)
        }
    }) : placeholderText);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3c87fb170f156fe$var$ReadOnlyView = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_otyru2gc _c71l1kdj _18m91wug _1i4q1hna _1nmz1hna _o5721jtm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jHb5v", function(module, exports) {
/*! @license DOMPurify 2.5.7 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.7/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array, transformCaseFunc) {
        var _transformCaseFunc;
        transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === 'string') {
                var lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ]) === true) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn('fallback value for', element);
            return null;
        }
        return fallbackValue;
    }
    var html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    // SVG
    var svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    var svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'fedropshadow',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    var mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    var text = freeze([
        '#text'
    ]);
    var html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'xmlns',
        'slot'
    ]);
    var svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    var mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    var xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var DOCTYPE_NAME = seal(/^html$/i);
    var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = 'data-tt-policy-suffix';
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html) {
                    return html;
                },
                createScriptURL: function createScriptURL(scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = '2.5.7';
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        var getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            var template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
        var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ var ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ var SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ var SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ var SANITIZE_NAMED_PROPS = false;
        var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ var ALLOWED_NAMESPACES = null;
        var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        var transformCaseFunc;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement('form');
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || _typeof(cfg) !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === 'is' && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc;
            var leadingWhitespace;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content;
            /* Execute a hook if present */ _executeHook('beforeSanitizeElements', currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook('uponSanitizeElement', currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Mitigate a problem with templates inside select */ if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any ocurrence of processing instructions */ if (currentNode.nodeType === 7) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i){
                            var childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
                content = stringReplace(content, ERB_EXPR$1, ' ');
                content = stringReplace(content, TMPLIT_EXPR$1, ' ');
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeElements', currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */ var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr;
            var value;
            var lcName;
            var l;
            /* Execute a hook if present */ _executeHook('beforeSanitizeAttributes', currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes) return;
            var hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = name === 'value' ? attr.value : stringTrim(attr.value);
                lcName = transformCaseFunc(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
                    value = stringReplace(value, ERB_EXPR$1, ' ');
                    value = stringReplace(value, TMPLIT_EXPR$1, ' ');
                }
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeAttributes', currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook('beforeSanitizeShadowDOM', fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook('uponSanitizeShadowNode', shadowNode, null);
                /* Sanitize tags and elements */ if (_sanitizeElements(shadowNode)) continue;
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(shadowNode);
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeShadowDOM', fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body;
            var importedNode;
            var currentNode;
            var oldNode;
            var returnNode;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === 'object' || typeof window1.toStaticHTML === 'function') {
                    if (typeof dirty === 'string') return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    var tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ if (_sanitizeElements(currentNode)) continue;
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(currentNode);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});

parcelRegister("43nEs", function(module, exports) {
$parcel$export(module.exports, "ALLOWED_TEXT_AREA_ATTRIBUTE_HTML_TAGS", () => $d6cd90b8647ac288$export$3d2246e48d9cfed3);
$parcel$export(module.exports, "DATE_VALUE_FORMAT", () => $d6cd90b8647ac288$export$d1fb6689cfa66d9b);
$parcel$export(module.exports, "TIME_VALUE_FORMAT", () => $d6cd90b8647ac288$export$5f2ab89513b5926a);
$parcel$export(module.exports, "ZONE_VALUE_FORMAT", () => $d6cd90b8647ac288$export$5c2d6de3ca9adcbe);
$parcel$export(module.exports, "GENERAL_DATE_TIME_FORMAT", () => $d6cd90b8647ac288$export$defafc11b2455f78);
$parcel$export(module.exports, "SCREEN_READER_DATE_TIME_FORMAT", () => $d6cd90b8647ac288$export$f61f3fa9ed38719a);
$parcel$export(module.exports, "globalErrorContexts", () => $d6cd90b8647ac288$export$b896d7bac8b72b0);
$parcel$export(module.exports, "MAX_OBJECT_COUNT_CUTOFF", () => $d6cd90b8647ac288$export$89b103afe26b1ad0);
/**
 * When there is a `textarea` type attribute on an object, the user can enter rich text that
 * is saved and transferred as raw HTML. Because of this, we need to sanitize the input
 * before rendering it to prevent XSS. The below is the allowlist of HTML tags we're expecting
 * to receieve from the editor. All other tags will be stripped out before rendering.
 */ const $d6cd90b8647ac288$export$3d2246e48d9cfed3 = [
    'p',
    'u',
    'a',
    'em',
    'strong',
    'span',
    'ol',
    'ul',
    'li',
    'pre',
    'code',
    'h2',
    'h3',
    'h4',
    'hr',
    'table',
    'thead',
    'tbody',
    'tr',
    'th',
    'td'
];
const $d6cd90b8647ac288$export$d1fb6689cfa66d9b = 'yyyy-MM-dd';
const $d6cd90b8647ac288$export$5f2ab89513b5926a = 'HH:mm';
const $d6cd90b8647ac288$export$5c2d6de3ca9adcbe = 'XXX';
const $d6cd90b8647ac288$export$defafc11b2455f78 = 'dd/MMM/yy h:mm a';
const $d6cd90b8647ac288$export$f61f3fa9ed38719a = 'do MMMM Y h:mm a';
const $d6cd90b8647ac288$export$b896d7bac8b72b0 = [
    'objectsLimit',
    'objectTypeAttributesLimit',
    'objectSchemaLimit'
];
const $d6cd90b8647ac288$export$89b103afe26b1ad0 = 1000;

});


parcelRegister("kxwSB", function(module, exports) {
$parcel$export(module.exports, "TextReadView", () => $7229f3be4f54bff3$export$ec510b523cd75479);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eJ9f5 = parcelRequire("eJ9f5");

var $4cFYC = parcelRequire("4cFYC");
var $18DG7 = parcelRequire("18DG7");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $2nGoJ = parcelRequire("2nGoJ");

var $evV3e = parcelRequire("evV3e");

var $bz3JK = parcelRequire("bz3JK");
const $7229f3be4f54bff3$var$renderUrlAnchor = (url)=>(0, $7jTnu.fg)('replace-anchor-with-link__falcons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
        target: "_blank",
        rel: "noopener noreferrer",
        href: url
    }, url) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        href: url
    }, url);
const $7229f3be4f54bff3$var$renderEmailReadView = (emails)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7229f3be4f54bff3$var$MultiTextContainer, {
        "data-testid": "servicedesk-insight-attribute-views.ui.text.multi-text-container"
    }, emails.map((email, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
            key: index
        }, (0, $7jTnu.fg)('replace-anchor-with-link__falcons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
            href: `mailto:${email}`
        }, email) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
            href: `mailto:${email}`
        }, email))));
const $7229f3be4f54bff3$export$ec510b523cd75479 = ({ value: value, defaultAttributeType: defaultAttributeType, showPlaceholderIfEmpty: showPlaceholderIfEmpty = true })=>{
    const renderSmartLink = (url)=>{
        const handleClick = (event)=>{
            event.preventDefault(); // Open smart link in new tab by default, as it takes the user out of Jira
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank', 'noopener');
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4cFYC.Card), {
            url: url,
            appearance: "inline",
            fallbackComponent: ()=>$7229f3be4f54bff3$var$renderUrlAnchor(url),
            onClick: handleClick,
            actionOptions: {
                hide: false,
                exclude: [
                    (0, $18DG7.CardAction).ChangeStatusAction
                ]
            }
        });
    };
    const renderUrlReadViewWithSmartLinks = (urls)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7229f3be4f54bff3$var$MultiTextContainer, {
            "data-testid": "servicedesk-insight-attribute-views.ui.text.multi-text-container"
        }, urls.map((url, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
                key: index
            }, renderSmartLink(url))));
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    let readViewContent;
    const getValueAsArray = (v)=>{
        let unfilteredArray;
        if (typeof v === 'string') unfilteredArray = [
            v
        ];
        else unfilteredArray = v ?? [];
        return unfilteredArray.filter((val)=>val != null && val !== '');
    };
    const valuesAsArray = getValueAsArray(value);
    const hasValue = valuesAsArray.length > 0;
    if (hasValue) {
        const firstValue = valuesAsArray[0];
        const renderValue = ()=>firstValue;
        readViewContent = (0, $2nGoJ.matchDefaultAttributeSubType)(defaultAttributeType.defaultType, {
            url: ()=>renderUrlReadViewWithSmartLinks(valuesAsArray),
            email: ()=>$7229f3be4f54bff3$var$renderEmailReadView(valuesAsArray),
            // @ts-expect-error - TS2322 - Type '() => ReactNode' is not assignable to type '() => Element | null | undefined'.
            float: renderValue,
            // @ts-expect-error - TS2322 - Type '() => ReactNode' is not assignable to type '() => Element | null | undefined'.
            integer: renderValue,
            // @ts-expect-error - TS2322 - Type '() => ReactNode' is not assignable to type '() => Element | null | undefined'.
            ipAddress: renderValue,
            // @ts-expect-error - TS2322 - Type '() => ReactNode' is not assignable to type '() => Element | null | undefined'.
            text: renderValue,
            // @ts-expect-error - TS2322 - Type '() => ReactNode' is not assignable to type '() => Element | null | undefined'.
            textarea: renderValue,
            // @ts-expect-error - TS2322 - Type '() => ReactNode' is not assignable to type '() => Element | null | undefined'.
            select: renderValue,
            // @ts-expect-error - TS2322 - Type '() => ReactNode' is not assignable to type '() => Element | null | undefined'.
            boolean: renderValue,
            // @ts-expect-error - TS2322 - Type '() => ReactNode' is not assignable to type '() => Element | null | undefined'.
            date: renderValue,
            // @ts-expect-error - TS2322 - Type '() => ReactNode' is not assignable to type '() => Element | null | undefined'.
            datetime: renderValue
        });
    } else readViewContent = showPlaceholderIfEmpty ? formatMessage((0, $evV3e.default).placeholderNoneEntered) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.ReadViewContainer), {
        isPlaceholder: !hasValue
    }, readViewContent, hasValue && defaultAttributeType.suffix !== undefined ? ` ${defaultAttributeType.suffix}` : null);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7229f3be4f54bff3$var$MultiTextContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_7yhbu2gc _1joi1tcg _mw6q1o8l",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hpvfl", function(module, exports) {
$parcel$export(module.exports, "UsersReadView", () => $c328ef3dd3704eca$export$b734ed5017674c4e);

var $eJOHy = parcelRequire("eJOHy");

var $5DgXR = parcelRequire("5DgXR");

var $lG2jM = parcelRequire("lG2jM");

var $lRq8t = parcelRequire("lRq8t");

var $3AXU8 = parcelRequire("3AXU8");


var $bz3JK = parcelRequire("bz3JK");

var $6yq5I = parcelRequire("6yq5I");
const $c328ef3dd3704eca$var$UserReadViewWithProfileCard = ({ accountId: accountId, avatarUrl: avatarUrl, displayName: displayName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3AXU8.default), {
        accountId: accountId,
        actions: [
            (0, $6d22448f78a7f25a$export$23cedd3261bd8015)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.RoleContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.AvatarWrapper), null, avatarUrl !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        appearance: "circle",
        size: "xsmall",
        src: avatarUrl
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lG2jM))), {
        LEGACY_size: "small",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.RoleDisplayName), null, displayName)));
const $c328ef3dd3704eca$export$b734ed5017674c4e = ({ users: users, showPlaceholderIfEmpty: showPlaceholderIfEmpty = true })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (users.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.ReadViewContainer), {
        isPlaceholder: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.PlaceholderSpacer), null, showPlaceholderIfEmpty ? formatMessage((0, $6yq5I.messages).placeholder) : null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.ReadViewContainer), {
        isPlaceholder: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz3JK.RoleList), null, users.map(({ accountId: accountId, avatarUrl: avatarUrl, displayName: displayName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c328ef3dd3704eca$var$UserReadViewWithProfileCard, {
            key: accountId,
            accountId: accountId,
            avatarUrl: avatarUrl,
            displayName: displayName
        }))));
};

});
parcelRegister("3AXU8", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c1c7fb5d1ac654d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");


const $1c1c7fb5d1ac654d$var$ConditionalProfileCard = (parcelRequire("gtXs1")).default;
function $1c1c7fb5d1ac654d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1c1c7fb5d1ac654d$var$ConditionalProfileCard, props);
}

});
parcelRegister("gtXs1", function(module, exports) {

module.exports = (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
    return parcelRequire('7xXvm');
}, function() {
    return parcelRequire('jQS3A');
});

});
parcelRegister("g81qY", function(module, exports) {
"use strict";

var $9VDxJ = parcelRequire("9VDxJ");
var $bbde81794392820b$require$getBundleURL = $9VDxJ.getBundleURL;

var $iTG8W = parcelRequire("iTG8W");
var $bbde81794392820b$require$resolve = $iTG8W.resolve;
module.exports = function loadCond(cond, ifTrue, ifFalse, fallback) {
    let result = globalThis.__MCOND(cond);
    try {
        return result ? ifTrue() : ifFalse();
    } catch (err) {
        if (fallback) {
            globalThis.__ATLASPACK_ERRORS = globalThis.__ATLASPACK_ERRORS || [];
            globalThis.__ATLASPACK_ERRORS.push(new Error(`Sync dependency fallback triggered for condition "${cond}": ${err.message}`));
            for (const id of fallback.i)fallback.l(new URL($bbde81794392820b$require$resolve(id), $bbde81794392820b$require$getBundleURL(id)).toString());
            return result ? ifTrue() : ifFalse();
        } else throw err;
    }
};

});
parcelRegister("9VDxJ", function(module, exports) {
$parcel$export(module.exports, "getBundleURL", () => $73a81c5f1e1fde26$export$bdfd709ae4826697, (v) => $73a81c5f1e1fde26$export$bdfd709ae4826697 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73a81c5f1e1fde26$export$5a759dc7a1cfb72a;
var $73a81c5f1e1fde26$export$bdfd709ae4826697;
var $73a81c5f1e1fde26$export$c9e73fbda7da57b6;
"use strict";
const $73a81c5f1e1fde26$var$stackTraceUrlRegexp = /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g;
const $73a81c5f1e1fde26$var$bundleURL = {};
/**
 * Retrieves the cached bundle URL for a given identifier.
 * If the URL is not cached, it computes and stores it in the cache.
 *
 * @param {string} id - The identifier for the bundle.
 * @param {Error?} inputError - An error object to extract the stack trace from
 * (for testing purposes).
 * @returns {string} The URL of the bundle, without file name.
 */ function $73a81c5f1e1fde26$var$getBundleURLCached(id, inputError) {
    let value = $73a81c5f1e1fde26$var$bundleURL[id];
    if (!value) {
        value = $73a81c5f1e1fde26$var$getBundleURL(inputError);
        $73a81c5f1e1fde26$var$bundleURL[id] = value;
    }
    return value;
}
/** Get the URL without the filename (last / segment)
 *
 * @param {string} url
 * @returns {string} The URL with the file name removed
 */ function $73a81c5f1e1fde26$var$getBaseURL(url) {
    return url.slice(0, url.lastIndexOf('/')) + '/';
}
function $73a81c5f1e1fde26$var$getBundleURL(inputError) {
    try {
        throw inputError ?? new Error();
    } catch (err) {
        var matches = ('' + err.stack).match($73a81c5f1e1fde26$var$stackTraceUrlRegexp);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $73a81c5f1e1fde26$var$getBaseURL(matches[2]);
    }
    return '/';
}
/**
 * @param {string} url
 * @returns {string}
 */ function $73a81c5f1e1fde26$var$getOrigin(url) {
    return new URL(url).origin;
}
$73a81c5f1e1fde26$export$5a759dc7a1cfb72a = $73a81c5f1e1fde26$var$getOrigin;
$73a81c5f1e1fde26$export$bdfd709ae4826697 = $73a81c5f1e1fde26$var$getBundleURLCached;
$73a81c5f1e1fde26$export$c9e73fbda7da57b6 = $73a81c5f1e1fde26$var$getBaseURL;

});




const $6d22448f78a7f25a$export$9345d7360ffe0722 = 'jira-profilecard-next';
const $6d22448f78a7f25a$export$81319ffa9c0d18d7 = 'profileCardNext';
const $6d22448f78a7f25a$export$50632e21ea714398 = 'profileCardNextLegacy';
const $6d22448f78a7f25a$export$d053e144c034c8aa = 'teamProfileCardNextLegacy';
const $6d22448f78a7f25a$export$23cedd3261bd8015 = 'viewProfile';
const $6d22448f78a7f25a$export$6bef782d14a92db8 = 'assignedIssues';
const $6d22448f78a7f25a$export$6b36f20db7a18a86 = 'reportedIssues';
const $6d22448f78a7f25a$export$56da0dd0b0aa67b9 = 'viewFilters';

parcelRegister("6yq5I", function(module, exports) {
$parcel$export(module.exports, "messages", () => $edfab3b688d8ef8b$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $edfab3b688d8ef8b$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    placeholder: {
        "id": "servicedesk-insight-attribute-views.user.placeholder",
        "defaultMessage": "No users selected"
    }
});

});



const $fac7e5aa1a4458f9$export$13bee158954a3882 = 20;

parcelRegister("7xaG8", function(module, exports) {
$parcel$export(module.exports, "BitbucketRepoAttribute", () => $d254f5d388910a2e$export$3de3d466bca83769);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dfnTD = parcelRequire("dfnTD");
const $d254f5d388910a2e$export$3de3d466bca83769 = (props)=>{
    const { attribute: attribute } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d254f5d388910a2e$var$Wrapper, null, attribute.objectAttributeValues.map(({ bitbucketRepo: { uuid: uuid, avatarUrl: avatarUrl, name: name, url: url } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dfnTD.BitbucketRepoReadView), {
            key: uuid,
            uuid: uuid,
            url: url,
            avatarUrl: avatarUrl,
            name: name
        })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d254f5d388910a2e$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _1e0c1txw _1n261g80",
            __cmplp.className
        ])
    });
});

});

parcelRegister("50Ckn", function(module, exports) {
$parcel$export(module.exports, "BooleanAttribute", () => $9df90baec2aaed26$export$9c894cb7469f1f94);

var $eJOHy = parcelRequire("eJOHy");
const $9df90baec2aaed26$export$9c894cb7469f1f94 = (props)=>{
    const { attribute: attribute } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, attribute.objectAttributeValues.map((value, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": "servicedesk-insight-attribute-list.ui.boolean-attribute",
            key: index
        }, value.displayValue)));
};

});

parcelRegister("gZC4b", function(module, exports) {
$parcel$export(module.exports, "ObjectAttribute", () => $662dcb9b170d2b76$export$15d74c5a12ccc9b0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $cdbP5 = parcelRequire("cdbP5");

var $8rAKL = parcelRequire("8rAKL");

var $k71qx = parcelRequire("k71qx");

var $goZPP = parcelRequire("goZPP");

var $6K3F5 = parcelRequire("6K3F5");

var $lRq8t = parcelRequire("lRq8t");

var $8XHsn = parcelRequire("8XHsn");

var $rJILZ = parcelRequire("rJILZ");

var $bYOuG = parcelRequire("bYOuG");

var $bJscI = parcelRequire("bJscI");

var $78Tcu = parcelRequire("78Tcu");
const $662dcb9b170d2b76$var$RenderTooltipWhenTextOverflows = ({ children: children })=>{
    const [isTextWiderThanContainer, setIsTextWiderThanContainer] = (0, $eJOHy.useState)(false); /**
                                                                                    * This check will only run once when the component is initially rendered.
                                                                                    * Won't re-check when windows resize or text length changes without re-rendering.
                                                                                    */ 
    // @ts-expect-error - TS7006 - Parameter 'node' implicitly has an 'any' type.
    const checkTextWidth = (0, $eJOHy.useCallback)((node)=>{
        if (node != null) setIsTextWiderThanContainer(node.offsetWidth < node.scrollWidth);
    }, []);
    if (isTextWiderThanContainer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        position: "top",
        content: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($662dcb9b170d2b76$var$TextWithEllipsis, null, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($662dcb9b170d2b76$var$TextWithEllipsis, {
        ref: checkTextWidth
    }, children);
};
const $662dcb9b170d2b76$export$fd917fe393fd3fa9 = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($662dcb9b170d2b76$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $rJILZ.MemoizedInsightIcon), {
        mediaClientConfig: props.mediaClientConfig,
        iconUrl: props.avatarUrl,
        label: props.label,
        size: "xsmall"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        spacing: "compact",
        onClick: (event)=>{
            event.stopPropagation();
            props.onClick();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($662dcb9b170d2b76$var$RenderTooltipWhenTextOverflows, null, props.label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $78Tcu.default).viewObjectDetails)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($662dcb9b170d2b76$var$ObjectAttributeLink, {
        appearance: "subtle",
        spacing: "compact",
        label: props.label,
        target: "_blank",
        href: (0, $bYOuG.createObjectDetailUrl)(props.objectId),
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8rAKL))), {
                spacing: "spacious",
                label: ""
            }),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8rAKL))), {
            spacing: "spacious",
            label: ""
        })
    })));
};
const $662dcb9b170d2b76$export$48542bae20cd03e9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($662dcb9b170d2b76$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $rJILZ.MemoizedInsightIcon), {
        mediaClientConfig: props.mediaClientConfig,
        iconUrl: props.avatarUrl,
        label: props.label,
        size: "xsmall"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($662dcb9b170d2b76$var$RenderTooltipWhenTextOverflows, null, props.label));
const $662dcb9b170d2b76$export$15d74c5a12ccc9b0 = ({ attribute: attribute, onClick: onClick })=>{
    const isInsightVisible = (0, $8XHsn.useInsightVisibility)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, attribute.objectAttributeValues.map((value, index)=>isInsightVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($662dcb9b170d2b76$export$fd917fe393fd3fa9, {
            key: index,
            avatarUrl: value.referencedObject.avatar.url48,
            mediaClientConfig: value.referencedObject.avatar.mediaClientConfig,
            label: value.displayValue,
            onClick: ()=>{
                onClick(value.referencedObject);
            },
            objectId: value.referencedObject.objectId
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($662dcb9b170d2b76$export$48542bae20cd03e9, {
            key: index,
            avatarUrl: value.referencedObject.avatar.url48,
            mediaClientConfig: value.referencedObject.avatar.mediaClientConfig,
            label: value.displayValue
        })));
};
const $662dcb9b170d2b76$var$objectAttributeLinkStyles = null; // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $662dcb9b170d2b76$var$ObjectAttributeLinkNew = ({ ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_tzy4idpf _t9ecs3yl _1h7hkb7n _1bvq1xty"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6K3F5.default), {
        "data-component-selector": "object-attribute-link-selector",
        ...props
    }));
};
const $662dcb9b170d2b76$var$wrapperStyles = null;
const $662dcb9b170d2b76$var$WrapperNew = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1s4b23z3 _1tzmu2gc _8a47kb7n _1jtj1xty"
        ])
    }, children);
const $662dcb9b170d2b76$var$textWithEllipsisStyles = null;
const $662dcb9b170d2b76$var$TextWithEllipsis = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ref: ref,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _p12fd36x"
        ])
    }, children)); // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $662dcb9b170d2b76$var$ObjectAttributeLinkOld = /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
(0, $cdbP5.default)((0, $goZPP.default)).withConfig({
    componentId: "sc-1pcub2p-0"
})({
    opacity: 0,
    transform: 'translate(-8px, 0)',
    '&:focus': {
        opacity: 1,
        transform: 'translate(0, 0)'
    }
}); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $662dcb9b170d2b76$var$WrapperOld = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "sc-1pcub2p-1"
})`display:flex;align-items:center;> div:first-child{margin-right:${"var(--ds-space-100, 8px)"};}${$662dcb9b170d2b76$var$ObjectAttributeLinkOld}{transition:opacity 0.2s,transform 0.2s;}&:hover ${$662dcb9b170d2b76$var$ObjectAttributeLinkOld}{opacity:1;transform:translate(0,0);}`;
const $662dcb9b170d2b76$var$Wrapper = (0, $bJscI.componentWithFG)('fly-2200-styled-component-migration', $662dcb9b170d2b76$var$WrapperNew, $662dcb9b170d2b76$var$WrapperOld);
const $662dcb9b170d2b76$var$ObjectAttributeLink = (0, $bJscI.componentWithFG)('fly-2200-styled-component-migration', $662dcb9b170d2b76$var$ObjectAttributeLinkNew, $662dcb9b170d2b76$var$ObjectAttributeLinkOld);

});
parcelRegister("78Tcu", function(module, exports) {
$parcel$export(module.exports, "default", () => $665d3406178263fb$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $665d3406178263fb$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    viewObjectDetails: {
        "id": "servicedesk-insight-attribute-list.button-attribute-with-avatar.view-object-details",
        "defaultMessage": "View details"
    }
});

});


parcelRegister("7dHaE", function(module, exports) {
$parcel$export(module.exports, "DateAttribute", () => $91872dc36c148639$export$1dfc6d6b778c012f);
$parcel$export(module.exports, "DateTimeAttribute", () => $91872dc36c148639$export$762339c6da2c8489);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3GKOL = parcelRequire("3GKOL");

var $3NHJr = parcelRequire("3NHJr");
const $91872dc36c148639$var$AttributeWithIcon = ({ formattedValue: formattedValue })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($91872dc36c148639$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3GKOL))), {
        spacing: "spacious",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, formattedValue));
const $91872dc36c148639$export$1dfc6d6b778c012f = ({ attribute: attribute })=>{
    const { formatDateOnly: formatDateOnly } = (0, $3NHJr.useDateTimeFormatter)();
    const [objectAttributeValue = null] = attribute.objectAttributeValues;
    if (objectAttributeValue === null || !objectAttributeValue.value) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($91872dc36c148639$var$AttributeWithIcon, {
        formattedValue: formatDateOnly(objectAttributeValue.value)
    });
};
const $91872dc36c148639$export$762339c6da2c8489 = ({ attribute: attribute })=>{
    const { formatDateTime: formatDateTime } = (0, $3NHJr.useDateTimeFormatter)();
    const [objectAttributeValue = null] = attribute.objectAttributeValues;
    if (objectAttributeValue === null || !objectAttributeValue.value) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($91872dc36c148639$var$AttributeWithIcon, {
        formattedValue: formatDateTime(objectAttributeValue.value)
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91872dc36c148639$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("04s6t", function(module, exports) {
$parcel$export(module.exports, "GroupAttribute", () => $96d2d0cd2ed8f399$export$d98ccc7fb64ed0fe);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $ar6fB = parcelRequire("ar6fB");

var $9ewtR = parcelRequire("9ewtR");
const $96d2d0cd2ed8f399$export$d98ccc7fb64ed0fe = (props)=>{
    const { attribute: attribute } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($96d2d0cd2ed8f399$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9ewtR.default), null, attribute.objectAttributeValues.map(({ group: { name: name } }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ar6fB.default), {
            testId: "servicedesk-insight-attribute-list.ui.group-attribute.value",
            key: index,
            text: name,
            isRemovable: false
        }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $96d2d0cd2ed8f399$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxr5cr _otyridpf _18u0r5cr",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ar6fB", function(module, exports) {
$parcel$export(module.exports, "default", () => $7bf2340f5bdb4d38$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $315a7 = parcelRequire("315a7");

var $gyJTO = parcelRequire("gyJTO");

var $3Vuhz = parcelRequire("3Vuhz");

var $Ys7jv = parcelRequire("Ys7jv");
var $lncqW = parcelRequire("lncqW");

var $1fStw = parcelRequire("1fStw");

var $40nZT = parcelRequire("40nZT");

var $6UE2q = parcelRequire("6UE2q");

var $h89xH = parcelRequire("h89xH");
const $7bf2340f5bdb4d38$var$textLinkCssVar = '--ds-ctl';
const $7bf2340f5bdb4d38$var$textDefaultCssVar = '--ds-ct';
const $7bf2340f5bdb4d38$var$textActiveCssVar = '--ds-ctp';
const $7bf2340f5bdb4d38$var$backgroundHoverCssVar = '--ds-cbh';
const $7bf2340f5bdb4d38$var$backgroundActiveCssVar = '--ds-cba';
var $7bf2340f5bdb4d38$var$TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}($7bf2340f5bdb4d38$var$TagStatus || {});
const $7bf2340f5bdb4d38$var$packageName = "platform-pkg";
const $7bf2340f5bdb4d38$var$packageVersion = "0.0.0-use.local";
const $7bf2340f5bdb4d38$var$defaultBeforeRemoveAction = ()=>true; /**
                                               * These hide the focus ring for the tag when its remove button is focused,
                                               * preventing a double focus ring.
                                               */ 
const $7bf2340f5bdb4d38$var$removingStyles = null;
const $7bf2340f5bdb4d38$var$RemovableTagComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, removeButtonLabel: removeButtonLabel, testId: testId, onBeforeRemoveAction: onBeforeRemoveAction = $7bf2340f5bdb4d38$var$defaultBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction = (0, $3Vuhz.default), linkComponent: linkComponent }, ref)=>{
    const [status, setStatus] = (0, $eJOHy.useState)("showing");
    const [isHoverCloseButton, setIsHoverCloseButton] = (0, $eJOHy.useState)(false);
    const onAfterRemoveActionWithAnalytics = (0, $315a7.useCallbackWithAnalytics)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $7bf2340f5bdb4d38$var$packageName,
            packageVersion: $7bf2340f5bdb4d38$var$packageVersion
        }
    }, 'atlaskit');
    const handleRemoveComplete = (0, $eJOHy.useCallback)(()=>{
        onAfterRemoveActionWithAnalytics(text);
        setStatus("removed");
    }, [
        onAfterRemoveActionWithAnalytics,
        text
    ]);
    const handleRemoveRequest = (0, $eJOHy.useCallback)(()=>{
        if (onBeforeRemoveAction && onBeforeRemoveAction()) handleRemoveComplete();
    }, [
        handleRemoveComplete,
        onBeforeRemoveAction
    ]);
    const onKeyPress = (0, $eJOHy.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $eJOHy.useCallback)(()=>setStatus("removing"), []);
    const showingTag = (0, $eJOHy.useCallback)(()=>setStatus("showing"), []);
    const handleMouseOver = (0, $eJOHy.useCallback)(()=>setIsHoverCloseButton(true), []);
    const handleMouseOut = (0, $eJOHy.useCallback)(()=>setIsHoverCloseButton(false), []);
    const removeButton = isRemovable ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h89xH.default), {
        "aria-label": `${removeButtonLabel || 'Remove'} ${text}`,
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: `close-button-${testId}`
    }) : undefined;
    const content = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6UE2q.default), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    const hoverCloseButtonColors = {
        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
        // Tag background color on hover
        [$7bf2340f5bdb4d38$var$backgroundHoverCssVar]: undefined,
        // Tag background color on press
        [$7bf2340f5bdb4d38$var$backgroundActiveCssVar]: undefined,
        // The tag text on hover of remove button
        [$7bf2340f5bdb4d38$var$textDefaultCssVar]: undefined,
        // 'elemBefore' text on press of remove button
        [$7bf2340f5bdb4d38$var$textActiveCssVar]: undefined,
        // The tag link text on hover of remove button
        [$7bf2340f5bdb4d38$var$textLinkCssVar]: undefined
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ys7jv.default), {
        children: !(status === "removed") && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lncqW.default), {
            children: (motion)=>{
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1fStw.default), {
                    ref: (0, $gyJTO.default)([
                        motion.ref,
                        ref
                    ]),
                    appearance: appearance,
                    color: color,
                    testId: testId,
                    style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
                    "data-removable": true,
                    "data-removing": status === "removing",
                    "data-ishoverclosebutton": isHoverCloseButton,
                    href: href,
                    before: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $40nZT.default), {
                        elemBefore: elemBefore
                    }),
                    contentElement: content,
                    after: removeButton,
                    className: (0, $hcewu.default)([
                        status === "removing" && "_z30c1r31 _twwiglyw _1pka1o36 _bqht1nip"
                    ])
                });
            }
        })
    });
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ const $7bf2340f5bdb4d38$var$RemovableTag = /*#__PURE__*/ (0, $eJOHy.memo)($7bf2340f5bdb4d38$var$RemovableTagComponent);
var $7bf2340f5bdb4d38$export$2e2bcd8739ae039 = $7bf2340f5bdb4d38$var$RemovableTag;

});
parcelRegister("lncqW", function(module, exports) {
$parcel$export(module.exports, "default", () => $10f384baaa61acd2$export$2e2bcd8739ae039);

var $34ZNB = parcelRequire("34ZNB");

var $gcrIE = parcelRequire("gcrIE");

var $grWPV = parcelRequire("grWPV");

var $5mfrv = parcelRequire("5mfrv");

var $Ys7jv = parcelRequire("Ys7jv");
/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $10f384baaa61acd2$var$ShrinkOut = ({ children: children, duration: duration = 'small', onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $grWPV.useElementRef)();
    const exiting = (0, $Ys7jv.useExitingPersistence)();
    const requestAnimationFrame = (0, $gcrIE.useRequestAnimationFrame)();
    const setTimeout = (0, $gcrIE.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $5mfrv.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles = {
                        width: '0px',
                        margin: '0px',
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $34ZNB.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $34ZNB.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $10f384baaa61acd2$export$2e2bcd8739ae039 = $10f384baaa61acd2$var$ShrinkOut;

});
parcelRegister("grWPV", function(module, exports) {
$parcel$export(module.exports, "useElementRef", () => $d3a4ee4e08936b24$export$ff879f35a69d56b7);

var $eJOHy = parcelRequire("eJOHy");
const $d3a4ee4e08936b24$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $eJOHy.useRef)(null);
    const setRef = (0, $eJOHy.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});


parcelRegister("h89xH", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebeaa36c6c332ef4$export$2e2bcd8739ae039);
/* remove-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $5wxTT = parcelRequire("5wxTT");

var $eGOwo = parcelRequire("eGOwo");

var $46R8N = parcelRequire("46R8N");
const $ebeaa36c6c332ef4$var$removeButtonStyles = {
    root: "_19itglyw _2rkolb4i _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i7vkz _1bsb7vkz _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhk1w7a _syaz1fxt _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah31i6y _irr3166n _1di61dty"
};
const $ebeaa36c6c332ef4$var$removeButtonStylesOldIcon = {
    root: "_rjxpze3t"
};
const $ebeaa36c6c332ef4$var$removeButtonStylesNewIcon = {
    root: "_rjxpv77o"
};
const $ebeaa36c6c332ef4$var$RemoveButton = ({ 'aria-label': ariaLabel, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyPress: onKeyPress, onMouseOver: onMouseOver, onMouseOut: onMouseOut, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        xcss: (0, $6qaBj.cx)($ebeaa36c6c332ef4$var$removeButtonStyles.root, $ebeaa36c6c332ef4$var$removeButtonStylesOldIcon.root, (0, $eGOwo.fg)('platform-visual-refresh-icons') && $ebeaa36c6c332ef4$var$removeButtonStylesNewIcon.root),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        testId: testId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5wxTT))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "small",
            size: "small"
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ebeaa36c6c332ef4$export$2e2bcd8739ae039 = $ebeaa36c6c332ef4$var$RemoveButton;

});
parcelRegister("5wxTT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::18cd44b40ff8809efea24ae850576bc8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $405a3cd7d6c6872a$var$_react = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $405a3cd7d6c6872a$var$_cross = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("6zhpo")));

var $405a3cd7d6c6872a$var$_close = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("6OLN4")));
function $405a3cd7d6c6872a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $405a3cd7d6c6872a$var$CrossIcon = (props)=>/*#__PURE__*/ $405a3cd7d6c6872a$var$_react.default.createElement($405a3cd7d6c6872a$var$_cross.default, Object.assign({
        name: "CrossIcon",
        LEGACY_fallbackIcon: $405a3cd7d6c6872a$var$_close.default
    }, props));
$405a3cd7d6c6872a$var$CrossIcon.displayName = 'CrossIconMigration';
var $405a3cd7d6c6872a$var$_default = module.exports.default = $405a3cd7d6c6872a$var$CrossIcon;

});
parcelRegister("6OLN4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f6c7bc606f2d15e$var$_react = $4f6c7bc606f2d15e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $4f6c7bc606f2d15e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f6c7bc606f2d15e$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $4f6c7bc606f2d15e$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props));
$4f6c7bc606f2d15e$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $4f6c7bc606f2d15e$var$_default = module.exports.default = $4f6c7bc606f2d15e$var$EditorCloseIcon;

});




parcelRegister("9ewtR", function(module, exports) {
$parcel$export(module.exports, "default", () => $07b7decad61e4cb4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $07b7decad61e4cb4$var$baseStyles = null;
const $07b7decad61e4cb4$var$justifyStartStyles = null;
const $07b7decad61e4cb4$var$justifyEndStyles = null;
/**
 * __Tag group__
 *
 * A tag group controls the layout and alignment for a collection of tags.
 *
 * - [Examples](https://atlassian.design/components/tag-group/examples)
 * - [Code](https://atlassian.design/components/tag-group/code)
 * - [Usage](https://atlassian.design/components/tag-group/usage)
 */ const $07b7decad61e4cb4$var$TagGroup = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ alignment: alignment = 'start', titleId: titleId, label: label, children: children }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "group",
        ref: ref,
        "aria-label": label,
        "aria-labelledby": titleId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bsb1osq _1n261g80",
            alignment === 'start' && "_1bah1y6m",
            alignment === 'end' && "_1bahesu3"
        ]),
        children: children
    });
});
var $07b7decad61e4cb4$export$2e2bcd8739ae039 = $07b7decad61e4cb4$var$TagGroup;

});


parcelRegister("edbZ4", function(module, exports) {
$parcel$export(module.exports, "OpsgenieTeamAttribute", () => $488627be24afd778$export$7b4e7461be2e2525);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $icHaK = parcelRequire("icHaK");
const $488627be24afd778$export$7b4e7461be2e2525 = (props)=>{
    const { attribute: attribute } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($488627be24afd778$var$Wrapper, null, attribute.objectAttributeValues.map(({ opsgenieTeam: { id: id, avatarUrl: avatarUrl, name: name, url: url } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $icHaK.OpsgenieTeamReadView), {
            key: id,
            id: id,
            url: url,
            avatarUrl: avatarUrl,
            name: name
        })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $488627be24afd778$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _1e0c1txw _1n261g80",
            __cmplp.className
        ])
    });
});

});

parcelRegister("5FcM5", function(module, exports) {
$parcel$export(module.exports, "ProjectAttribute", () => $708e5fef4a8b10a9$export$c917b99594d44fb8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $bEgEM = parcelRequire("bEgEM");
const $708e5fef4a8b10a9$export$c917b99594d44fb8 = (props)=>{
    const { attribute: attribute } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($708e5fef4a8b10a9$var$Wrapper, null, attribute.objectAttributeValues.map(({ project: { avatarUrl: avatarUrl, key: key, name: name, id: id } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bEgEM.ProjectReadView), {
            key: id,
            projectKey: key,
            avatarUrl: avatarUrl,
            displayName: name
        })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $708e5fef4a8b10a9$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _1e0c1txw _1n261g80",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1a6aG", function(module, exports) {
$parcel$export(module.exports, "StatusAttribute", () => $97163f1eca8b3734$export$df9089d96a51b907);

var $eJOHy = parcelRequire("eJOHy");

var $jdqdp = parcelRequire("jdqdp");
const $97163f1eca8b3734$export$b716aadee3b63550 = (category)=>{
    switch(category){
        case 0:
            return 'removed';
        case 1:
            return 'success';
        case 2:
            return 'moved';
        default:
            return 'default';
    }
};
const $97163f1eca8b3734$export$df9089d96a51b907 = ({ attribute: attribute })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, attribute.objectAttributeValues.map((value, index)=>{
        const appearance = $97163f1eca8b3734$export$b716aadee3b63550(value.status.category);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
            key: index,
            isBold: true,
            appearance: appearance
        }, value.displayValue);
    }));

});

parcelRegister("2KUcI", function(module, exports) {
$parcel$export(module.exports, "TextAttribute", () => $32a8b75e67ad6b4e$export$524ab8b6c1ca9de3);
$parcel$export(module.exports, "RichTextAttribute", () => $32a8b75e67ad6b4e$export$ad1e0393ba7fff77);

var $eJOHy = parcelRequire("eJOHy");

var $jHb5v = parcelRequire("jHb5v");

var $43nEs = parcelRequire("43nEs");
const $32a8b75e67ad6b4e$var$sanitize = (html)=>(0, (/*@__PURE__*/$parcel$interopDefault($jHb5v))).sanitize(html, {
        // @ts-expect-error - TS2769 - No overload matches this call.
        ALLOWED_TAGS: (0, $43nEs.ALLOWED_TEXT_AREA_ATTRIBUTE_HTML_TAGS),
        ALLOWED_ATTR: [
            'role',
            'tabindex',
            'href',
            'target'
        ]
    });
const $32a8b75e67ad6b4e$var$GenericTextAttribute = (props)=>{
    const { attribute: attribute, isRichText: isRichText = false } = props;
    const renderText = (value, index)=>{
        if (isRichText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            key: index,
            "data-testId": "insight-attribute-list-text-attribute-text",
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: $32a8b75e67ad6b4e$var$sanitize(value.displayValue)
            }
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            key: index
        }, value.value);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, attribute.objectAttributeValues.map(renderText));
};
const $32a8b75e67ad6b4e$export$524ab8b6c1ca9de3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($32a8b75e67ad6b4e$var$GenericTextAttribute, props);
const $32a8b75e67ad6b4e$export$ad1e0393ba7fff77 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($32a8b75e67ad6b4e$var$GenericTextAttribute, {
        ...props,
        isRichText: true
    });

});

parcelRegister("iPG1J", function(module, exports) {
$parcel$export(module.exports, "UnknownAttribute", () => $38e57d0e5fc53f05$export$78a991caba2f3146);

var $eJOHy = parcelRequire("eJOHy");

var $51aj0 = parcelRequire("51aj0");
const $38e57d0e5fc53f05$export$78a991caba2f3146 = (props)=>{
    const { attribute: { objectTypeAttributeId: objectTypeAttributeId, type: type }, objectId: objectId } = props;
    (0, $eJOHy.useEffect)(()=>{
        (0, $51aj0.fireCmdbErrorAnalytics)({
            meta: {
                id: 'attributesListRenderUnknownAttribute',
                packageName: 'jiraServicedeskInsightAttributeList',
                teamName: 'aurum'
            },
            error: new Error(`Unknown attribute type - object id: ${objectId}, object type attribute id: ${objectTypeAttributeId}, type: ${type}`)
        });
    }, [
        objectId,
        objectTypeAttributeId,
        type
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, "Unknown Attribute");
};

});

parcelRegister("9fCiV", function(module, exports) {
$parcel$export(module.exports, "EmailAttribute", () => $f12a467ea971dfd9$export$bed4cdeb189c2268);
$parcel$export(module.exports, "UrlAttribute", () => $f12a467ea971dfd9$export$ec066e79c9f40c37);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4cFYC = parcelRequire("4cFYC");
var $18DG7 = parcelRequire("18DG7");
const $f12a467ea971dfd9$export$bed4cdeb189c2268 = (props)=>{
    const { attribute: attribute } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, attribute.objectAttributeValues.map((value, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f12a467ea971dfd9$var$StyledAnchor, {
            target: "_blank",
            key: index,
            href: `mailto:${value.displayValue}`
        }, value.displayValue)));
};
const $f12a467ea971dfd9$export$ec066e79c9f40c37 = ({ attribute: attribute })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, attribute.objectAttributeValues.map((value, index)=>{
        const href = value.displayValue;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4cFYC.Card), {
            key: index,
            url: href,
            appearance: "inline",
            fallbackComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f12a467ea971dfd9$var$StyledAnchor, {
                    target: "_blank",
                    key: index,
                    href: href
                }, value.displayValue),
            actionOptions: {
                hide: false,
                exclude: [
                    (0, $18DG7.CardAction).ChangeStatusAction
                ]
            }
        });
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f12a467ea971dfd9$var$StyledAnchor = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bw7AL", function(module, exports) {
$parcel$export(module.exports, "UserAttribute", () => $8f11474fd3db0e10$export$734f569777cc0b79);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5DgXR = parcelRequire("5DgXR");

var $eSnSE = parcelRequire("eSnSE");

var $3AXU8 = parcelRequire("3AXU8");
const $8f11474fd3db0e10$export$734f569777cc0b79 = (props)=>{
    const { attribute: attribute } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8f11474fd3db0e10$var$Wrapper, null, attribute.objectAttributeValues.map((value, index)=>{
        if (!value?.user) {
            /* Given we're in the user attribute the data structure expects user to be here,
         * but we're seeing instances where it's not. Logging here to keep track of it happening.
         * This can be removed if logs show this isn't happening anymore.
         * More Info: https://hello.jira.atlassian.cloud/browse/FLY-1871
         * */ (0, $eSnSE.default).safeErrorWithoutCustomerData('servicedesk.insight-common.insight-attribute-list.ui.user-attribute', `missing-user-attribute: ${attribute.objectAttributeValues.length}, valuePresent: ${!!value}`);
            return;
        }
        return value.user.key && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3AXU8.default), {
            key: index,
            accountId: value.user.key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8f11474fd3db0e10$var$UserWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
            size: "small",
            src: value.user.avatarUrl
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8f11474fd3db0e10$var$UserName, null, value.user.displayName)));
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8f11474fd3db0e10$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1n261g80 _18u0x0bf",
            __cmplp.className
        ])
    });
});
const $8f11474fd3db0e10$var$UserWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _1e0c1txw _4cvr1h6o _ca0q1b66 _u5f3u2gc _n3td1b66 _19bvu2gc _syaz1fxt _80om73ad _irr3166n",
            __cmplp.className
        ])
    });
});
const $8f11474fd3db0e10$var$UserName = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});

});


parcelRegister("37dPs", function(module, exports) {
$parcel$export(module.exports, "TrackObjectView", () => $ec0a6f07c6b8a280$export$f3c0140e1e635e20);
$parcel$export(module.exports, "TrackObjectTypeView", () => $ec0a6f07c6b8a280$export$db0346606e968cdc);
$parcel$export(module.exports, "TrackObjectSchemaView", () => $ec0a6f07c6b8a280$export$a71b6a1bced1e79e);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $51aj0 = parcelRequire("51aj0");

var $8XHsn = parcelRequire("8XHsn");

var $2eLZZ = parcelRequire("2eLZZ");
const $ec0a6f07c6b8a280$var$TrackView = ({ id: id, entityType: entityType })=>{
    (0, $gRw8I.di)(clearTimeout, setTimeout);
    const { workspaceId: workspaceId } = (0, $8XHsn.useWorkspaceContext)();
    (0, $eJOHy.useEffect)(()=>{
        if (!workspaceId) return ()=>undefined;
        // Delay the track request to avoid contention with other requests for initial loading
        const trackTimeoutId = setTimeout(()=>{
            (0, $2eLZZ.trackView)({
                workspaceId: workspaceId,
                entityId: id,
                entityType: entityType
            }).catch((error)=>{
                (0, $51aj0.fireCmdbErrorAnalytics)({
                    error: error,
                    meta: {
                        id: 'TrackView',
                        packageName: 'jiraServicedeskInsightUserHistoryTracker',
                        teamName: 'aurum'
                    },
                    attributes: {
                        entityId: id,
                        entityType: entityType
                    }
                });
            });
        }, 1000);
        return ()=>clearTimeout(trackTimeoutId);
    }, [
        workspaceId,
        id,
        entityType
    ]);
    return null;
};
const $ec0a6f07c6b8a280$export$f3c0140e1e635e20 = ({ id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ec0a6f07c6b8a280$var$TrackView, {
        id: id,
        entityType: "object"
    });
const $ec0a6f07c6b8a280$export$db0346606e968cdc = ({ id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ec0a6f07c6b8a280$var$TrackView, {
        id: id,
        entityType: "object-type"
    });
const $ec0a6f07c6b8a280$export$a71b6a1bced1e79e = ({ id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ec0a6f07c6b8a280$var$TrackView, {
        id: id,
        entityType: "object-schema"
    });

});
parcelRegister("2eLZZ", function(module, exports) {
$parcel$export(module.exports, "trackView", () => $b30e1ddeca22e8f0$export$cf121cb4a790600a);

var $u4YbY = parcelRequire("u4YbY");

var $d80vY = parcelRequire("d80vY");
const $b30e1ddeca22e8f0$export$cf121cb4a790600a = async ({ workspaceId: workspaceId, entityId: entityId, entityType: entityType })=>{
    await (0, $u4YbY.performCmdbPostRequest)((0, $d80vY.getCmdbUserHistoryViewedUrl)(workspaceId), {
        body: JSON.stringify({
            entityId: entityId,
            entityType: entityType
        })
    });
};

});
parcelRegister("d80vY", function(module, exports) {
$parcel$export(module.exports, "getCmdbUserHistoryViewedUrl", () => $889786739c51ade3$export$c31d4edf380c08d5);

var $1qZG3 = parcelRequire("1qZG3");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/user-history
 */ const $889786739c51ade3$var$getCmdbUserHistoryUrl = (workspaceId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/user-history`;
const $889786739c51ade3$export$c31d4edf380c08d5 = (workspaceId)=>`${$889786739c51ade3$var$getCmdbUserHistoryUrl(workspaceId)}/viewed`;

});



parcelRegister("ZvOaO", function(module, exports) {
$parcel$export(module.exports, "TitleSkeleton", () => $db9aa8c1d23d4e72$export$5992f258b912f234);
$parcel$export(module.exports, "AttributesListSkeleton", () => $db9aa8c1d23d4e72$export$1a33f1b535de2335);
$parcel$export(module.exports, "LinkedIssuesSkeleton", () => $db9aa8c1d23d4e72$export$7a6a12132903144d);

var $eJOHy = parcelRequire("eJOHy");

var $5eUzv = parcelRequire("5eUzv");
const $db9aa8c1d23d4e72$export$5992f258b912f234 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5eUzv.FlexContainer), {
        marginBottom: 16
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5eUzv.Avatar), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5eUzv.Title), null));
const $db9aa8c1d23d4e72$var$AttributesListItem = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5eUzv.FlexContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5eUzv.AttributeName), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5eUzv.AttributeValue), null));
const $db9aa8c1d23d4e72$export$1a33f1b535de2335 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($db9aa8c1d23d4e72$var$AttributesListItem, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($db9aa8c1d23d4e72$var$AttributesListItem, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($db9aa8c1d23d4e72$var$AttributesListItem, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($db9aa8c1d23d4e72$var$AttributesListItem, null));
const $db9aa8c1d23d4e72$export$7a6a12132903144d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5eUzv.LinkedIssueCard), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5eUzv.LinkedIssueCard), null));

});
parcelRegister("5eUzv", function(module, exports) {
$parcel$export(module.exports, "FlexContainer", () => $f37fdb2868f2283d$export$124d4c7bf7db9715);
$parcel$export(module.exports, "Avatar", () => $f37fdb2868f2283d$export$e2255cf6045e8d47);
$parcel$export(module.exports, "Title", () => $f37fdb2868f2283d$export$f99233281efd08a0);
$parcel$export(module.exports, "AttributeName", () => $f37fdb2868f2283d$export$8b0888326e6c88ff);
$parcel$export(module.exports, "AttributeValue", () => $f37fdb2868f2283d$export$2a2a59a443c4e63e);
$parcel$export(module.exports, "LinkedIssueCard", () => $f37fdb2868f2283d$export$f27b9e35b8dd22a1);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $f37fdb2868f2283d$var$fromPositionX = -150;
const $f37fdb2868f2283d$var$toPositionX = 600;
const $f37fdb2868f2283d$var$shimmer = null;
const $f37fdb2868f2283d$export$c3b0ebed856b8b1a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _2rkofajl _5sag9cwz _1o51q7pw _tip812c5 _j7hq1id6 _1pglp3kn _bfhkn82g _1itk1kpv _12vemgnk",
            __cmplp.className
        ])
    });
});
const $f37fdb2868f2283d$export$124d4c7bf7db9715 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { marginBottom: marginBottom, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ik9eo": (0, $awdRS.default)(__cmplp.marginBottom ?? 0, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1osq _otyrssky",
            __cmplp.className
        ])
    });
});
const $f37fdb2868f2283d$export$e2255cf6045e8d47 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $f37fdb2868f2283d$export$c3b0ebed856b8b1a, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1rr0 _1bsb1ejb _4t3i1ejb _1o9zidpf _2hwxutpp",
            __cmplp.className
        ])
    });
});
const $f37fdb2868f2283d$export$f99233281efd08a0 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $f37fdb2868f2283d$export$c3b0ebed856b8b1a, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1llu _4t3ipxbi",
            __cmplp.className
        ])
    });
});
const $f37fdb2868f2283d$export$8b0888326e6c88ff = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $f37fdb2868f2283d$export$c3b0ebed856b8b1a, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _19pk1b66 _2hwxu2gc _otyr1b66 _18u0idpf _4t3ipxbi _1bsb93m8",
            __cmplp.className
        ])
    });
});
const $f37fdb2868f2283d$export$2a2a59a443c4e63e = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $f37fdb2868f2283d$export$c3b0ebed856b8b1a, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _19pk1b66 _2hwxidpf _otyr1b66 _18u0idpf _4t3ipxbi",
            __cmplp.className
        ])
    });
});
const $f37fdb2868f2283d$export$f27b9e35b8dd22a1 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $f37fdb2868f2283d$export$c3b0ebed856b8b1a, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pk1b66 _2hwxu2gc _otyr1b66 _18u0idpf _4t3ixy5q",
            __cmplp.className
        ])
    });
});

});


parcelRegister("dkpvZ", function(module, exports) {
$parcel$export(module.exports, "LinkedIssues", () => $70f5d2af6e09639a$export$22f152f6fc01fd93);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6MnLl = parcelRequire("6MnLl");

var $b3eVo = parcelRequire("b3eVo");

var $ln6Iy = parcelRequire("ln6Iy");

var $7jTnu = parcelRequire("7jTnu");

var $dymbf = parcelRequire("dymbf");

var $aTJmy = parcelRequire("aTJmy");

var $lRq8t = parcelRequire("lRq8t");

var $ftdjj = parcelRequire("ftdjj");

var $9PdD7 = parcelRequire("9PdD7");

var $ZvOaO = parcelRequire("ZvOaO");

var $47BDS = parcelRequire("47BDS");
// @ts-expect-error - TS7006 - Parameter 'issue' implicitly has an 'any' type.
const $70f5d2af6e09639a$var$formatIssue = (issue)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const newIssue = {};
    newIssue.id = issue.id.toString();
    newIssue.isLoading = false;
    newIssue.issueSummary = issue.title;
    newIssue.issueKey = issue.key;
    newIssue.issueLink = `/browse/${issue.key || ''}`;
    newIssue.issueTypeName = issue.type.name;
    newIssue.issueTypeIconUrl = issue.type.iconUrl;
    newIssue.issuePriorityName = issue.priority ? issue.priority.name : '';
    newIssue.issuePriorityUrl = issue.priority ? issue.priority.iconUrl : '';
    newIssue.projectType = (0, $ln6Iy.SERVICE_DESK_PROJECT);
    return newIssue;
};
const $70f5d2af6e09639a$var$ErrorState = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const renderImage = ()=>(0, $aTJmy.getAkEmptyStateRenderImageFn)((0, $dymbf.default))({
            imageWidth: 120,
            maxImageWidth: 120,
            maxImageHeight: 212
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        width: "wide",
        renderImage: renderImage,
        header: formatMessage((0, $7jTnu.fg)('itsm-issue-renaming') ? (0, $47BDS.default).errorStateHeaderIssueTermRefresh : (0, $47BDS.default).errorStateHeader),
        description: formatMessage((0, $47BDS.default).errorStateDescription)
    });
};
const $70f5d2af6e09639a$export$22f152f6fc01fd93 = ({ objectId: objectId })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [{ linkedIssues: linkedIssues, loading: loading, error: error, pages: pages, pageIndex: pageIndex }, { onPageChange: onPageChange }] = (0, $ftdjj.useObjectConnectedIssuesPaginated)(objectId);
    const linkedIssuesFormatted = (0, $eJOHy.useMemo)(()=>linkedIssues && linkedIssues.map((issue)=>$70f5d2af6e09639a$var$formatIssue(issue)), [
        linkedIssues
    ]);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ZvOaO.LinkedIssuesSkeleton), null);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($70f5d2af6e09639a$var$ErrorState, null);
    if (!linkedIssues || linkedIssues.length === 0) return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", {
        "data-testid": "servicedesk-insight-object-graph.ui.object-view.linked-issues.empty-state"
    }, formatMessage((0, $7jTnu.fg)('itsm-issue-renaming') ? (0, $47BDS.default).noLinkedIssuesIssueTermRefresh : (0, $47BDS.default).noLinkedIssues)));
    const handleClick = (event, page)=>{
        onPageChange(page);
    };
    return linkedIssuesFormatted && linkedIssuesFormatted.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($70f5d2af6e09639a$var$LinkedIssuesContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9PdD7.IssueLineCardGroup), {
        issues: linkedIssuesFormatted,
        groupId: "linked-issues-group"
    })), pages !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($70f5d2af6e09639a$var$PaginationWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b3eVo.default), {
        selectedIndex: pageIndex,
        pages: pages,
        onChange: handleClick
    }))) : null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $70f5d2af6e09639a$var$LinkedIssuesContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo1wug _18m91wug _n3tdu2gc _c71l1y37",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $70f5d2af6e09639a$var$PaginationWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ftdjj", function(module, exports) {
$parcel$export(module.exports, "useObjectConnectedIssuesPaginated", () => $9d11a5e425f2c8f8$export$94f8772416dd142f);

var $eJOHy = parcelRequire("eJOHy");

var $hPZg4 = parcelRequire("hPZg4");

var $51aj0 = parcelRequire("51aj0");

var $jGzN3 = parcelRequire("jGzN3");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $bOaPE = parcelRequire("bOaPE");

var $8XHsn = parcelRequire("8XHsn");

const $9d11a5e425f2c8f8$var$calculatePages = (data)=>{
    let pages;
    if (data && data.total > 0) pages = Array.from({
        length: Math.floor((data.total - 1) / (0, $d8c0d7c5752f32c1$export$46c56510812d46b6)) + 1
    }, (_, i)=>i + 1);
    return pages;
};
const $9d11a5e425f2c8f8$export$94f8772416dd142f = (objectId, params)=>{
    const [selectedIndex, setSelectedIndex] = (0, $eJOHy.useState)(0);
    const { workspaceId: workspaceId } = (0, $8XHsn.useWorkspaceContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const request = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7031 - Binding element 'startAt' implicitly has an 'any' type.
    ({ startAt: startAt })=>{
        if (!objectId) throw new Error('objectId undefined');
        if (!workspaceId) throw new Error('workspaceId undefined');
        return (0, $jGzN3.performGetRequest)((0, $bOaPE.getCmdbObjectConnectedTicketsPaginatedUrl)(workspaceId, objectId, {
            startAt: startAt,
            limit: (0, $d8c0d7c5752f32c1$export$46c56510812d46b6),
            ...params?.filterId && {
                filterId: params.filterId
            },
            ...params?.textFilter && {
                textFilter: params.textFilter
            },
            hideResolved: params?.hideResolved
        })).then((res)=>{
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchObjectConnectedIssues succeeded');
            return res;
        }).catch((error)=>{
            (0, $51aj0.fireCmdbErrorAnalytics)({
                error: error,
                meta: {
                    id: 'fetchObjectConnectedIssues',
                    packageName: 'jiraServicedeskInsightObjectServices',
                    teamName: 'aurum'
                }
            });
            throw error;
        });
    }, [
        createAnalyticsEvent,
        objectId,
        workspaceId,
        params?.filterId,
        params?.textFilter,
        params?.hideResolved
    ]);
    const { loading: loading, error: error, data: data, fetch: fetch } = (0, $hPZg4.useService)(request);
    // Auto fetch connected issues when hook is called
    (0, $eJOHy.useEffect)(()=>{
        if (workspaceId) fetch({
            startAt: 0
        });
    }, [
        fetch,
        objectId,
        workspaceId
    ]);
    const onPageChange = (pageNumber)=>{
        const requestedPage = pageNumber >= 1 ? pageNumber : 1;
        setSelectedIndex(requestedPage - 1);
        fetch({
            startAt: (requestedPage - 1) * (0, $d8c0d7c5752f32c1$export$46c56510812d46b6)
        });
    };
    return [
        {
            loading: loading,
            error: error,
            jqlString: data?.allTicketsQuery,
            linkedIssues: data?.values,
            pages: $9d11a5e425f2c8f8$var$calculatePages(data),
            pageIndex: selectedIndex
        },
        {
            onPageChange: onPageChange
        }
    ];
};

});
parcelRegister("bOaPE", function(module, exports) {
$parcel$export(module.exports, "getCmdbObjectConnectedTicketsPaginatedUrl", () => $1c4eacacc76269af$export$d2e9d2efad0b629c);

var $b5RwB = parcelRequire("b5RwB");

var $1qZG3 = parcelRequire("1qZG3");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/objectconnectedtickets/${objectId}
 */ const $1c4eacacc76269af$var$getCmdbObjectConnectedTicketsBaseUrl = (workspaceId, objectId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/objectconnectedtickets/${objectId}`;
const $1c4eacacc76269af$export$d1579cbefb941ecf = (workspaceId, objectId, filterQueryParams = {})=>{
    const url = `${$1c4eacacc76269af$var$getCmdbObjectConnectedTicketsBaseUrl(workspaceId, objectId)}/tickets`;
    const encodedQueryParams = (0, $b5RwB.stringify)(filterQueryParams);
    if (encodedQueryParams) return `${url}?${encodedQueryParams}`;
    return url;
};
const $1c4eacacc76269af$export$d2e9d2efad0b629c = (workspaceId, objectId, queryParams)=>`${$1c4eacacc76269af$var$getCmdbObjectConnectedTicketsBaseUrl(workspaceId, objectId)}/paginatedtickets?${(0, $b5RwB.stringify)(queryParams)}`;

});

const $d8c0d7c5752f32c1$export$46c56510812d46b6 = 10;


parcelRegister("9PdD7", function(module, exports) {
$parcel$export(module.exports, "IssueLineCardGroup", () => $25c11c64843736ea$export$32d4eb7126135529);

var $eJOHy = parcelRequire("eJOHy");

var $47OMg = parcelRequire("47OMg");

var $8V4gK = parcelRequire("8V4gK");
class $25c11c64843736ea$export$32d4eb7126135529 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isReorderEnabled: false,
            isInteractive: true,
            projectType: null
        };
    }
    render() {
        const { issues: issues, onOrderChange: onOrderChange, groupId: groupId, isReorderEnabled: isReorderEnabled, isInteractive: isInteractive, projectType: projectType } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $47OMg.default), {
            items: issues,
            onOrderChange: onOrderChange,
            groupId: groupId,
            isReorderEnabled: isReorderEnabled,
            isInteractive: isInteractive,
            onClick: this.handleClick
        }, (isHovering, isActive, isFocused, issue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8V4gK.default), {
                isHovering: isHovering,
                isActive: isActive,
                isFocused: isFocused,
                isDraggable: isReorderEnabled,
                isInteractive: isInteractive,
                issueId: issue.id,
                // @ts-expect-error - TS2783 - 'projectType' is specified more than once, so this usage will be overwritten.
                projectType: projectType,
                ...issue
            }));
    }
    constructor(...args){
        super(...args), this.handleClick = (issue)=>{
            if (issue.issueLink !== null && issue.issueLink !== undefined && issue.issueLink !== '') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(issue.issueLink, '_blank');
        };
    }
}

});
parcelRegister("47OMg", function(module, exports) {
$parcel$export(module.exports, "default", () => $70d80e70eba34273$export$2e2bcd8739ae039);
/* item-line-card-group-view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $e8YwC = parcelRequire("e8YwC");

var $h47gY = parcelRequire("h47gY");

var $hjf2q = parcelRequire("hjf2q");

var $652G5 = parcelRequire("652G5");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $70d80e70eba34273$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _2mzuglyw _16qszucj _bfhkhp5a _ca0qv77o _u5f3idpf _n3tdv77o _19bvidpf",
            __cmplp.className
        ])
    });
});
const $70d80e70eba34273$export$f27f87a07355c60b = (0, $hjf2q.AnalyticsEventToProps)('issueRank', {
    onDragEnd: 'updated'
})((0, $e8YwC.DragDropContext));
class $70d80e70eba34273$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isReorderEnabled: false,
            isInteractive: true,
            isVariableHeightCards: false,
            onOrderChange: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    renderCards(cardsProps = {}) {
        const { isReorderEnabled: isReorderEnabled, isInteractive: isInteractive, isVariableHeightCards: isVariableHeightCards, onClick: onClick } = this.props;
        const { placeholder: placeholder, ...rest } = cardsProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($70d80e70eba34273$var$Container, rest, this.props.items.map((item, index)=>{
            const itemLineCardProps = {
                key: item.id,
                item: item,
                index: index,
                isReorderEnabled: isReorderEnabled,
                isInteractive: isInteractive,
                isVariableHeight: isVariableHeightCards,
                onClick: onClick,
                children: this.props.children
            };
            const itemLineCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
                key: item.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $652G5.default), itemLineCardProps));
            return itemLineCard;
        }), placeholder);
    }
    renderDraggableCards() {
        const dragDropContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($70d80e70eba34273$export$f27f87a07355c60b, {
            onDragEnd: this.onDragEnd
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e8YwC.Droppable), {
            droppableId: this.props.groupId
        }, (provided, snapshot)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, this.renderCards({
                isDraggingOver: snapshot.isDraggingOver,
                placeholder: provided.placeholder,
                ref: provided.innerRef
            }))));
        return dragDropContext;
    }
    render() {
        if (!this.props.isReorderEnabled) return this.renderCards();
        return this.renderDraggableCards();
    }
    constructor(...args){
        super(...args), this.onDragEnd = (result, provided, analyticsEvent)=>{
            const { source: source } = result;
            const { destination: destination } = result;
            if (!destination || source.droppableId !== destination.droppableId) return;
            const items = [
                ...this.props.items
            ];
            const target = items.find((item)=>item.id === result.draggableId);
            if (!target) return;
            // Move the dropped item into the correct spot
            items.splice(source.index, 1);
            items.splice(destination.index, 0, target);
            this.props.onOrderChange(items, target, source.index, destination.index, analyticsEvent);
        };
    }
}

});
parcelRegister("e8YwC", function(module, exports) {
$parcel$export(module.exports, "DragDropContext", () => $a4c0c313a61fc29c$export$237bd83162c14364);
$parcel$export(module.exports, "Draggable", () => $a4c0c313a61fc29c$export$f2a139e5d18b9882);
$parcel$export(module.exports, "Droppable", () => $a4c0c313a61fc29c$export$423ec2075359570a);

var $eJOHy = parcelRequire("eJOHy");

var $7pA0u = parcelRequire("7pA0u");

var $yG6r7 = parcelRequire("yG6r7");

var $iyGBi = parcelRequire("iyGBi");

var $24c1Z = parcelRequire("24c1Z");
parcelRequire("myP3H");
var $6gcAF = parcelRequire("6gcAF");
var $k8ZHs = parcelRequire("k8ZHs");

var $ixGZi = parcelRequire("ixGZi");

var $gj4eS = parcelRequire("gj4eS");

var $dSQ3b = parcelRequire("dSQ3b");

var $dAFDe = parcelRequire("dAFDe");

var $bBYr0 = parcelRequire("bBYr0");

var $digWO = parcelRequire("digWO");

var $lQkst = parcelRequire("lQkst");

var $aQK2r = parcelRequire("aQK2r");

var $ejJQe = parcelRequire("ejJQe");
var $a4c0c313a61fc29c$var$isProduction = true;
var $a4c0c313a61fc29c$var$spacesAndTabs = /[ \t]{2,}/g;
var $a4c0c313a61fc29c$var$lineStartWithSpaces = /^[ \t]*/gm;
var $a4c0c313a61fc29c$var$clean = function clean(value) {
    return value.replace($a4c0c313a61fc29c$var$spacesAndTabs, ' ').replace($a4c0c313a61fc29c$var$lineStartWithSpaces, '').trim();
};
var $a4c0c313a61fc29c$var$getDevMessage = function getDevMessage(message) {
    return $a4c0c313a61fc29c$var$clean("\n  %creact-beautiful-dnd\n\n  %c" + $a4c0c313a61fc29c$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
};
var $a4c0c313a61fc29c$var$getFormattedMessage = function getFormattedMessage(message) {
    return [
        $a4c0c313a61fc29c$var$getDevMessage(message),
        'color: #00C584; font-size: 1.2em; font-weight: bold;',
        'line-height: 1.5',
        'color: #723874;'
    ];
};
var $a4c0c313a61fc29c$var$isDisabledFlag = '__react-beautiful-dnd-disable-dev-warnings';
function $a4c0c313a61fc29c$var$log(type, message) {
    var _console;
    if ($a4c0c313a61fc29c$var$isProduction) return;
    if (typeof window !== 'undefined' && window[$a4c0c313a61fc29c$var$isDisabledFlag]) return;
    (_console = console)[type].apply(_console, $a4c0c313a61fc29c$var$getFormattedMessage(message));
}
var $a4c0c313a61fc29c$var$warning = $a4c0c313a61fc29c$var$log.bind(null, 'warn');
var $a4c0c313a61fc29c$var$error = $a4c0c313a61fc29c$var$log.bind(null, 'error');
function $a4c0c313a61fc29c$var$noop() {}
function $a4c0c313a61fc29c$var$getOptions(shared, fromBinding) {
    return (0, $iyGBi.default)({}, shared, fromBinding);
}
function $a4c0c313a61fc29c$var$bindEvents(el, bindings, sharedOptions) {
    var unbindings = bindings.map(function(binding) {
        var options = $a4c0c313a61fc29c$var$getOptions(sharedOptions, binding.options);
        el.addEventListener(binding.eventName, binding.fn, options);
        return function unbind() {
            el.removeEventListener(binding.eventName, binding.fn, options);
        };
    });
    return function unbindAll() {
        unbindings.forEach(function(unbind) {
            unbind();
        });
    };
}
var $a4c0c313a61fc29c$var$isProduction$1 = true;
var $a4c0c313a61fc29c$var$prefix = 'Invariant failed';
function $a4c0c313a61fc29c$var$RbdInvariant(message) {
    this.message = message;
}
$a4c0c313a61fc29c$var$RbdInvariant.prototype.toString = function toString() {
    return this.message;
};
function $a4c0c313a61fc29c$var$invariant(condition, message) {
    if (condition) return;
    if ($a4c0c313a61fc29c$var$isProduction$1) throw new $a4c0c313a61fc29c$var$RbdInvariant($a4c0c313a61fc29c$var$prefix);
    else throw new $a4c0c313a61fc29c$var$RbdInvariant($a4c0c313a61fc29c$var$prefix + ": " + (message || ''));
}
var $a4c0c313a61fc29c$var$ErrorBoundary = function(_React$Component) {
    (0, $yG6r7.default)(ErrorBoundary, _React$Component);
    function ErrorBoundary() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.callbacks = null;
        _this.unbind = $a4c0c313a61fc29c$var$noop;
        _this.onWindowError = function(event) {
            var callbacks = _this.getCallbacks();
            if (callbacks.isDragging()) callbacks.tryAbort();
            var err = event.error;
            if (err instanceof $a4c0c313a61fc29c$var$RbdInvariant) event.preventDefault();
        };
        _this.getCallbacks = function() {
            if (!_this.callbacks) throw new Error('Unable to find AppCallbacks in <ErrorBoundary/>');
            return _this.callbacks;
        };
        _this.setCallbacks = function(callbacks) {
            _this.callbacks = callbacks;
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.unbind = $a4c0c313a61fc29c$var$bindEvents(window, [
            {
                eventName: 'error',
                fn: this.onWindowError
            }
        ]);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unbind();
    };
    _proto.componentDidCatch = function componentDidCatch(err) {
        if (err instanceof $a4c0c313a61fc29c$var$RbdInvariant) {
            this.setState({});
            return;
        }
        throw err;
    };
    _proto.render = function render() {
        return this.props.children(this.setCallbacks);
    };
    return ErrorBoundary;
}((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component);
var $a4c0c313a61fc29c$var$liftInstruction = "Draggable item. Ensure your screen reader is not in browse mode and then press space bar to lift.";
var $a4c0c313a61fc29c$var$position = function position(index) {
    return index + 1;
};
var $a4c0c313a61fc29c$var$onDragStart = function onDragStart(start) {
    return "\n  You have lifted an item in position " + $a4c0c313a61fc29c$var$position(start.source.index) + ".\n  Use the arrow keys to move, space bar to drop, and escape to cancel.\n";
};
var $a4c0c313a61fc29c$var$withLocation = function withLocation(source, destination) {
    var isInHomeList = source.droppableId === destination.droppableId;
    var startPosition = $a4c0c313a61fc29c$var$position(source.index);
    var endPosition = $a4c0c313a61fc29c$var$position(destination.index);
    if (isInHomeList) return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
    return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};
var $a4c0c313a61fc29c$var$withCombine = function withCombine(id, source, combine) {
    var inHomeList = source.droppableId === combine.droppableId;
    if (inHomeList) return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
    return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};
var $a4c0c313a61fc29c$var$onDragUpdate = function onDragUpdate(update) {
    var location = update.destination;
    if (location) return $a4c0c313a61fc29c$var$withLocation(update.source, location);
    var combine = update.combine;
    if (combine) return $a4c0c313a61fc29c$var$withCombine(update.draggableId, update.source, combine);
    return 'You are over an area that cannot be dropped on';
};
var $a4c0c313a61fc29c$var$returnedToStart = function returnedToStart(source) {
    return "\n  The item has returned to its starting position\n  of " + $a4c0c313a61fc29c$var$position(source.index) + "\n";
};
var $a4c0c313a61fc29c$var$onDragEnd = function onDragEnd(result) {
    if (result.reason === 'CANCEL') return "\n      Movement cancelled.\n      " + $a4c0c313a61fc29c$var$returnedToStart(result.source) + "\n    ";
    var location = result.destination;
    var combine = result.combine;
    if (location) return "\n      You have dropped the item.\n      " + $a4c0c313a61fc29c$var$withLocation(result.source, location) + "\n    ";
    if (combine) return "\n      You have dropped the item.\n      " + $a4c0c313a61fc29c$var$withCombine(result.draggableId, result.source, combine) + "\n    ";
    return "\n    The item has been dropped while not over a drop area.\n    " + $a4c0c313a61fc29c$var$returnedToStart(result.source) + "\n  ";
};
var $a4c0c313a61fc29c$var$preset = {
    liftInstruction: $a4c0c313a61fc29c$var$liftInstruction,
    onDragStart: $a4c0c313a61fc29c$var$onDragStart,
    onDragUpdate: $a4c0c313a61fc29c$var$onDragUpdate,
    onDragEnd: $a4c0c313a61fc29c$var$onDragEnd
};
var $a4c0c313a61fc29c$var$origin = {
    x: 0,
    y: 0
};
var $a4c0c313a61fc29c$var$add = function add(point1, point2) {
    return {
        x: point1.x + point2.x,
        y: point1.y + point2.y
    };
};
var $a4c0c313a61fc29c$var$subtract = function subtract(point1, point2) {
    return {
        x: point1.x - point2.x,
        y: point1.y - point2.y
    };
};
var $a4c0c313a61fc29c$var$isEqual = function isEqual(point1, point2) {
    return point1.x === point2.x && point1.y === point2.y;
};
var $a4c0c313a61fc29c$var$negate = function negate(point) {
    return {
        x: point.x !== 0 ? -point.x : 0,
        y: point.y !== 0 ? -point.y : 0
    };
};
var $a4c0c313a61fc29c$var$patch = function patch(line, value, otherValue) {
    var _ref;
    if (otherValue === void 0) otherValue = 0;
    return _ref = {}, _ref[line] = value, _ref[line === 'x' ? 'y' : 'x'] = otherValue, _ref;
};
var $a4c0c313a61fc29c$var$distance = function distance(point1, point2) {
    return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var $a4c0c313a61fc29c$var$closest = function closest(target, points) {
    return Math.min.apply(Math, points.map(function(point) {
        return $a4c0c313a61fc29c$var$distance(target, point);
    }));
};
var $a4c0c313a61fc29c$var$apply = function apply(fn) {
    return function(point) {
        return {
            x: fn(point.x),
            y: fn(point.y)
        };
    };
};
var $a4c0c313a61fc29c$var$executeClip = function(frame, subject) {
    var result = (0, $ixGZi.getRect)({
        top: Math.max(subject.top, frame.top),
        right: Math.min(subject.right, frame.right),
        bottom: Math.min(subject.bottom, frame.bottom),
        left: Math.max(subject.left, frame.left)
    });
    if (result.width <= 0 || result.height <= 0) return null;
    return result;
};
var $a4c0c313a61fc29c$var$offsetByPosition = function offsetByPosition(spacing, point) {
    return {
        top: spacing.top + point.y,
        left: spacing.left + point.x,
        bottom: spacing.bottom + point.y,
        right: spacing.right + point.x
    };
};
var $a4c0c313a61fc29c$var$getCorners = function getCorners(spacing) {
    return [
        {
            x: spacing.left,
            y: spacing.top
        },
        {
            x: spacing.right,
            y: spacing.top
        },
        {
            x: spacing.left,
            y: spacing.bottom
        },
        {
            x: spacing.right,
            y: spacing.bottom
        }
    ];
};
var $a4c0c313a61fc29c$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $a4c0c313a61fc29c$var$scroll = function scroll(target, frame) {
    if (!frame) return target;
    return $a4c0c313a61fc29c$var$offsetByPosition(target, frame.scroll.diff.displacement);
};
var $a4c0c313a61fc29c$var$increase = function increase(target, axis, withPlaceholder) {
    if (withPlaceholder && withPlaceholder.increasedBy) {
        var _extends2;
        return (0, $iyGBi.default)({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
    }
    return target;
};
var $a4c0c313a61fc29c$var$clip = function clip(target, frame) {
    if (frame && frame.shouldClipSubject) return $a4c0c313a61fc29c$var$executeClip(frame.pageMarginBox, target);
    return (0, $ixGZi.getRect)(target);
};
var $a4c0c313a61fc29c$var$getSubject = function(_ref) {
    var page = _ref.page, withPlaceholder = _ref.withPlaceholder, axis = _ref.axis, frame = _ref.frame;
    var scrolled = $a4c0c313a61fc29c$var$scroll(page.marginBox, frame);
    var increased = $a4c0c313a61fc29c$var$increase(scrolled, axis, withPlaceholder);
    var clipped = $a4c0c313a61fc29c$var$clip(increased, frame);
    return {
        page: page,
        withPlaceholder: withPlaceholder,
        active: clipped
    };
};
var $a4c0c313a61fc29c$var$scrollDroppable = function(droppable, newScroll) {
    !droppable.frame && $a4c0c313a61fc29c$var$invariant(false);
    var scrollable = droppable.frame;
    var scrollDiff = $a4c0c313a61fc29c$var$subtract(newScroll, scrollable.scroll.initial);
    var scrollDisplacement = $a4c0c313a61fc29c$var$negate(scrollDiff);
    var frame = (0, $iyGBi.default)({}, scrollable, {
        scroll: {
            initial: scrollable.scroll.initial,
            current: newScroll,
            diff: {
                value: scrollDiff,
                displacement: scrollDisplacement
            },
            max: scrollable.scroll.max
        }
    });
    var subject = $a4c0c313a61fc29c$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: droppable.subject.withPlaceholder,
        axis: droppable.axis,
        frame: frame
    });
    var result = (0, $iyGBi.default)({}, droppable, {
        frame: frame,
        subject: subject
    });
    return result;
};
function $a4c0c313a61fc29c$var$values(map) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($dSQ3b)))(map);
}
function $a4c0c313a61fc29c$var$findIndex(list, predicate) {
    if (list.findIndex) return list.findIndex(predicate);
    for(var i = 0; i < list.length; i++){
        if (predicate(list[i])) return i;
    }
    return -1;
}
function $a4c0c313a61fc29c$var$find(list, predicate) {
    if (list.find) return list.find(predicate);
    var index = $a4c0c313a61fc29c$var$findIndex(list, predicate);
    if (index !== -1) return list[index];
    return undefined;
}
function $a4c0c313a61fc29c$var$toArray(list) {
    return Array.prototype.slice.call(list);
}
var $a4c0c313a61fc29c$var$toDroppableMap = (0, $gj4eS.default)(function(droppables) {
    return droppables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $a4c0c313a61fc29c$var$toDraggableMap = (0, $gj4eS.default)(function(draggables) {
    return draggables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $a4c0c313a61fc29c$var$toDroppableList = (0, $gj4eS.default)(function(droppables) {
    return $a4c0c313a61fc29c$var$values(droppables);
});
var $a4c0c313a61fc29c$var$toDraggableList = (0, $gj4eS.default)(function(draggables) {
    return $a4c0c313a61fc29c$var$values(draggables);
});
var $a4c0c313a61fc29c$var$getDraggablesInsideDroppable = (0, $gj4eS.default)(function(droppableId, draggables) {
    var result = $a4c0c313a61fc29c$var$toDraggableList(draggables).filter(function(draggable) {
        return droppableId === draggable.descriptor.droppableId;
    }).sort(function(a, b) {
        return a.descriptor.index - b.descriptor.index;
    });
    return result;
});
function $a4c0c313a61fc29c$var$tryGetDestination(impact) {
    if (impact.at && impact.at.type === 'REORDER') return impact.at.destination;
    return null;
}
function $a4c0c313a61fc29c$var$tryGetCombine(impact) {
    if (impact.at && impact.at.type === 'COMBINE') return impact.at.combine;
    return null;
}
var $a4c0c313a61fc29c$var$removeDraggableFromList = (0, $gj4eS.default)(function(remove, list) {
    return list.filter(function(item) {
        return item.descriptor.id !== remove.descriptor.id;
    });
});
var $a4c0c313a61fc29c$var$moveToNextCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact;
    if (!destination.isCombineEnabled) return null;
    var location = $a4c0c313a61fc29c$var$tryGetDestination(previousImpact);
    if (!location) return null;
    function getImpact(target) {
        var at = {
            type: 'COMBINE',
            combine: {
                draggableId: target,
                droppableId: destination.descriptor.id
            }
        };
        return (0, $iyGBi.default)({}, previousImpact, {
            at: at
        });
    }
    var all = previousImpact.displaced.all;
    var closestId = all.length ? all[0] : null;
    if (isMovingForward) return closestId ? getImpact(closestId) : null;
    var withoutDraggable = $a4c0c313a61fc29c$var$removeDraggableFromList(draggable, insideDestination);
    if (!closestId) {
        if (!withoutDraggable.length) return null;
        var last = withoutDraggable[withoutDraggable.length - 1];
        return getImpact(last.descriptor.id);
    }
    var indexOfClosest = $a4c0c313a61fc29c$var$findIndex(withoutDraggable, function(d) {
        return d.descriptor.id === closestId;
    });
    !(indexOfClosest !== -1) && $a4c0c313a61fc29c$var$invariant(false);
    var proposedIndex = indexOfClosest - 1;
    if (proposedIndex < 0) return null;
    var before = withoutDraggable[proposedIndex];
    return getImpact(before.descriptor.id);
};
var $a4c0c313a61fc29c$var$isHomeOf = function(draggable, destination) {
    return draggable.descriptor.droppableId === destination.descriptor.id;
};
var $a4c0c313a61fc29c$var$noDisplacedBy = {
    point: $a4c0c313a61fc29c$var$origin,
    value: 0
};
var $a4c0c313a61fc29c$var$emptyGroups = {
    invisible: {},
    visible: {},
    all: []
};
var $a4c0c313a61fc29c$var$noImpact = {
    displaced: $a4c0c313a61fc29c$var$emptyGroups,
    displacedBy: $a4c0c313a61fc29c$var$noDisplacedBy,
    at: null
};
var $a4c0c313a61fc29c$var$isWithin = function(lowerBound, upperBound) {
    return function(value) {
        return lowerBound <= value && value <= upperBound;
    };
};
var $a4c0c313a61fc29c$var$isPartiallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $a4c0c313a61fc29c$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $a4c0c313a61fc29c$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        if (isContained) return true;
        var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
        var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
        var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
        if (isPartiallyContained) return true;
        var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
        var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
        var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
        if (isTargetBiggerThanFrame) return true;
        var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
        return isTargetBiggerOnOneAxis;
    };
};
var $a4c0c313a61fc29c$var$isTotallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $a4c0c313a61fc29c$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $a4c0c313a61fc29c$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        return isContained;
    };
};
var $a4c0c313a61fc29c$var$vertical = {
    direction: 'vertical',
    line: 'y',
    crossAxisLine: 'x',
    start: 'top',
    end: 'bottom',
    size: 'height',
    crossAxisStart: 'left',
    crossAxisEnd: 'right',
    crossAxisSize: 'width'
};
var $a4c0c313a61fc29c$var$horizontal = {
    direction: 'horizontal',
    line: 'x',
    crossAxisLine: 'y',
    start: 'left',
    end: 'right',
    size: 'width',
    crossAxisStart: 'top',
    crossAxisEnd: 'bottom',
    crossAxisSize: 'height'
};
var $a4c0c313a61fc29c$var$isTotallyVisibleThroughFrameOnAxis = function(axis) {
    return function(frame) {
        var isWithinVertical = $a4c0c313a61fc29c$var$isWithin(frame.top, frame.bottom);
        var isWithinHorizontal = $a4c0c313a61fc29c$var$isWithin(frame.left, frame.right);
        return function(subject) {
            if (axis === $a4c0c313a61fc29c$var$vertical) return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
            return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        };
    };
};
var $a4c0c313a61fc29c$var$getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
    var displacement = destination.frame ? destination.frame.scroll.diff.displacement : $a4c0c313a61fc29c$var$origin;
    return $a4c0c313a61fc29c$var$offsetByPosition(target, displacement);
};
var $a4c0c313a61fc29c$var$isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
    if (!destination.subject.active) return false;
    return isVisibleThroughFrameFn(destination.subject.active)(target);
};
var $a4c0c313a61fc29c$var$isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
    return isVisibleThroughFrameFn(viewport)(target);
};
var $a4c0c313a61fc29c$var$isVisible = function isVisible(_ref) {
    var toBeDisplaced = _ref.target, destination = _ref.destination, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
    var displacedTarget = withDroppableDisplacement ? $a4c0c313a61fc29c$var$getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
    return $a4c0c313a61fc29c$var$isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && $a4c0c313a61fc29c$var$isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};
var $a4c0c313a61fc29c$var$isPartiallyVisible = function isPartiallyVisible(args) {
    return $a4c0c313a61fc29c$var$isVisible((0, $iyGBi.default)({}, args, {
        isVisibleThroughFrameFn: $a4c0c313a61fc29c$var$isPartiallyVisibleThroughFrame
    }));
};
var $a4c0c313a61fc29c$var$isTotallyVisible = function isTotallyVisible(args) {
    return $a4c0c313a61fc29c$var$isVisible((0, $iyGBi.default)({}, args, {
        isVisibleThroughFrameFn: $a4c0c313a61fc29c$var$isTotallyVisibleThroughFrame
    }));
};
var $a4c0c313a61fc29c$var$isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
    return $a4c0c313a61fc29c$var$isVisible((0, $iyGBi.default)({}, args, {
        isVisibleThroughFrameFn: $a4c0c313a61fc29c$var$isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
    }));
};
var $a4c0c313a61fc29c$var$getShouldAnimate = function getShouldAnimate(id, last, forceShouldAnimate) {
    if (typeof forceShouldAnimate === 'boolean') return forceShouldAnimate;
    if (!last) return true;
    var invisible = last.invisible, visible = last.visible;
    if (invisible[id]) return false;
    var previous = visible[id];
    return previous ? previous.shouldAnimate : true;
};
function $a4c0c313a61fc29c$var$getTarget(draggable, displacedBy) {
    var marginBox = draggable.page.marginBox;
    var expandBy = {
        top: displacedBy.point.y,
        right: 0,
        bottom: 0,
        left: displacedBy.point.x
    };
    return (0, $ixGZi.getRect)((0, $ixGZi.expand)(marginBox, expandBy));
}
function $a4c0c313a61fc29c$var$getDisplacementGroups(_ref) {
    var afterDragging = _ref.afterDragging, destination = _ref.destination, displacedBy = _ref.displacedBy, viewport = _ref.viewport, forceShouldAnimate = _ref.forceShouldAnimate, last = _ref.last;
    return afterDragging.reduce(function process(groups, draggable) {
        var target = $a4c0c313a61fc29c$var$getTarget(draggable, displacedBy);
        var id = draggable.descriptor.id;
        groups.all.push(id);
        var isVisible = $a4c0c313a61fc29c$var$isPartiallyVisible({
            target: target,
            destination: destination,
            viewport: viewport,
            withDroppableDisplacement: true
        });
        if (!isVisible) {
            groups.invisible[draggable.descriptor.id] = true;
            return groups;
        }
        var shouldAnimate = $a4c0c313a61fc29c$var$getShouldAnimate(id, last, forceShouldAnimate);
        var displacement = {
            draggableId: id,
            shouldAnimate: shouldAnimate
        };
        groups.visible[id] = displacement;
        return groups;
    }, {
        all: [],
        visible: {},
        invisible: {}
    });
}
function $a4c0c313a61fc29c$var$getIndexOfLastItem(draggables, options) {
    if (!draggables.length) return 0;
    var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
    return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}
function $a4c0c313a61fc29c$var$goAtEnd(_ref) {
    var insideDestination = _ref.insideDestination, inHomeList = _ref.inHomeList, displacedBy = _ref.displacedBy, destination = _ref.destination;
    var newIndex = $a4c0c313a61fc29c$var$getIndexOfLastItem(insideDestination, {
        inHomeList: inHomeList
    });
    return {
        displaced: $a4c0c313a61fc29c$var$emptyGroups,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: {
                droppableId: destination.descriptor.id,
                index: newIndex
            }
        }
    };
}
function $a4c0c313a61fc29c$var$calculateReorderImpact(_ref2) {
    var draggable = _ref2.draggable, insideDestination = _ref2.insideDestination, destination = _ref2.destination, viewport = _ref2.viewport, displacedBy = _ref2.displacedBy, last = _ref2.last, index = _ref2.index, forceShouldAnimate = _ref2.forceShouldAnimate;
    var inHomeList = $a4c0c313a61fc29c$var$isHomeOf(draggable, destination);
    if (index == null) return $a4c0c313a61fc29c$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var match = $a4c0c313a61fc29c$var$find(insideDestination, function(item) {
        return item.descriptor.index === index;
    });
    if (!match) return $a4c0c313a61fc29c$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var withoutDragging = $a4c0c313a61fc29c$var$removeDraggableFromList(draggable, insideDestination);
    var sliceFrom = insideDestination.indexOf(match);
    var impacted = withoutDragging.slice(sliceFrom);
    var displaced = $a4c0c313a61fc29c$var$getDisplacementGroups({
        afterDragging: impacted,
        destination: destination,
        displacedBy: displacedBy,
        last: last,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate
    });
    return {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: {
                droppableId: destination.descriptor.id,
                index: index
            }
        }
    };
}
function $a4c0c313a61fc29c$var$didStartAfterCritical(draggableId, afterCritical) {
    return Boolean(afterCritical.effected[draggableId]);
}
var $a4c0c313a61fc29c$var$fromCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, destination = _ref.destination, draggables = _ref.draggables, combine = _ref.combine, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var combineId = combine.draggableId;
    var combineWith = draggables[combineId];
    var combineWithIndex = combineWith.descriptor.index;
    var didCombineWithStartAfterCritical = $a4c0c313a61fc29c$var$didStartAfterCritical(combineId, afterCritical);
    if (didCombineWithStartAfterCritical) {
        if (isMovingForward) return combineWithIndex;
        return combineWithIndex - 1;
    }
    if (isMovingForward) return combineWithIndex + 1;
    return combineWithIndex;
};
var $a4c0c313a61fc29c$var$fromReorder = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, insideDestination = _ref.insideDestination, location = _ref.location;
    if (!insideDestination.length) return null;
    var currentIndex = location.index;
    var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
    var firstIndex = insideDestination[0].descriptor.index;
    var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
    var upperBound = isInHomeList ? lastIndex : lastIndex + 1;
    if (proposedIndex < firstIndex) return null;
    if (proposedIndex > upperBound) return null;
    return proposedIndex;
};
var $a4c0c313a61fc29c$var$moveToNextIndex = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var wasAt = previousImpact.at;
    !wasAt && $a4c0c313a61fc29c$var$invariant(false);
    if (wasAt.type === 'REORDER') {
        var _newIndex = $a4c0c313a61fc29c$var$fromReorder({
            isMovingForward: isMovingForward,
            isInHomeList: isInHomeList,
            location: wasAt.destination,
            insideDestination: insideDestination
        });
        if (_newIndex == null) return null;
        return $a4c0c313a61fc29c$var$calculateReorderImpact({
            draggable: draggable,
            insideDestination: insideDestination,
            destination: destination,
            viewport: viewport,
            last: previousImpact.displaced,
            displacedBy: previousImpact.displacedBy,
            index: _newIndex
        });
    }
    var newIndex = $a4c0c313a61fc29c$var$fromCombine({
        isMovingForward: isMovingForward,
        destination: destination,
        displaced: previousImpact.displaced,
        draggables: draggables,
        combine: wasAt.combine,
        afterCritical: afterCritical
    });
    if (newIndex == null) return null;
    return $a4c0c313a61fc29c$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: previousImpact.displaced,
        displacedBy: previousImpact.displacedBy,
        index: newIndex
    });
};
var $a4c0c313a61fc29c$var$getCombinedItemDisplacement = function(_ref) {
    var displaced = _ref.displaced, afterCritical = _ref.afterCritical, combineWith = _ref.combineWith, displacedBy = _ref.displacedBy;
    var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);
    if ($a4c0c313a61fc29c$var$didStartAfterCritical(combineWith, afterCritical)) return isDisplaced ? $a4c0c313a61fc29c$var$origin : $a4c0c313a61fc29c$var$negate(displacedBy.point);
    return isDisplaced ? displacedBy.point : $a4c0c313a61fc29c$var$origin;
};
var $a4c0c313a61fc29c$var$whenCombining = function(_ref) {
    var afterCritical = _ref.afterCritical, impact = _ref.impact, draggables = _ref.draggables;
    var combine = $a4c0c313a61fc29c$var$tryGetCombine(impact);
    !combine && $a4c0c313a61fc29c$var$invariant(false);
    var combineWith = combine.draggableId;
    var center = draggables[combineWith].page.borderBox.center;
    var displaceBy = $a4c0c313a61fc29c$var$getCombinedItemDisplacement({
        displaced: impact.displaced,
        afterCritical: afterCritical,
        combineWith: combineWith,
        displacedBy: impact.displacedBy
    });
    return $a4c0c313a61fc29c$var$add(center, displaceBy);
};
var $a4c0c313a61fc29c$var$distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
    return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};
var $a4c0c313a61fc29c$var$distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
    return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};
var $a4c0c313a61fc29c$var$getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
    return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};
var $a4c0c313a61fc29c$var$goAfter = function goAfter(_ref) {
    var axis = _ref.axis, moveRelativeTo = _ref.moveRelativeTo, isMoving = _ref.isMoving;
    return $a4c0c313a61fc29c$var$patch(axis.line, moveRelativeTo.marginBox[axis.end] + $a4c0c313a61fc29c$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $a4c0c313a61fc29c$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $a4c0c313a61fc29c$var$goBefore = function goBefore(_ref2) {
    var axis = _ref2.axis, moveRelativeTo = _ref2.moveRelativeTo, isMoving = _ref2.isMoving;
    return $a4c0c313a61fc29c$var$patch(axis.line, moveRelativeTo.marginBox[axis.start] - $a4c0c313a61fc29c$var$distanceFromEndToBorderBoxCenter(axis, isMoving), $a4c0c313a61fc29c$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $a4c0c313a61fc29c$var$goIntoStart = function goIntoStart(_ref3) {
    var axis = _ref3.axis, moveInto = _ref3.moveInto, isMoving = _ref3.isMoving;
    return $a4c0c313a61fc29c$var$patch(axis.line, moveInto.contentBox[axis.start] + $a4c0c313a61fc29c$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $a4c0c313a61fc29c$var$getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};
var $a4c0c313a61fc29c$var$whenReordering = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, draggables = _ref.draggables, droppable = _ref.droppable, afterCritical = _ref.afterCritical;
    var insideDestination = $a4c0c313a61fc29c$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var draggablePage = draggable.page;
    var axis = droppable.axis;
    if (!insideDestination.length) return $a4c0c313a61fc29c$var$goIntoStart({
        axis: axis,
        moveInto: droppable.page,
        isMoving: draggablePage
    });
    var displaced = impact.displaced, displacedBy = impact.displacedBy;
    var closestAfter = displaced.all[0];
    if (closestAfter) {
        var closest = draggables[closestAfter];
        if ($a4c0c313a61fc29c$var$didStartAfterCritical(closestAfter, afterCritical)) return $a4c0c313a61fc29c$var$goBefore({
            axis: axis,
            moveRelativeTo: closest.page,
            isMoving: draggablePage
        });
        var withDisplacement = (0, $ixGZi.offset)(closest.page, displacedBy.point);
        return $a4c0c313a61fc29c$var$goBefore({
            axis: axis,
            moveRelativeTo: withDisplacement,
            isMoving: draggablePage
        });
    }
    var last = insideDestination[insideDestination.length - 1];
    if (last.descriptor.id === draggable.descriptor.id) return draggablePage.borderBox.center;
    if ($a4c0c313a61fc29c$var$didStartAfterCritical(last.descriptor.id, afterCritical)) {
        var page = (0, $ixGZi.offset)(last.page, $a4c0c313a61fc29c$var$negate(afterCritical.displacedBy.point));
        return $a4c0c313a61fc29c$var$goAfter({
            axis: axis,
            moveRelativeTo: page,
            isMoving: draggablePage
        });
    }
    return $a4c0c313a61fc29c$var$goAfter({
        axis: axis,
        moveRelativeTo: last.page,
        isMoving: draggablePage
    });
};
var $a4c0c313a61fc29c$var$withDroppableDisplacement = function(droppable, point) {
    var frame = droppable.frame;
    if (!frame) return point;
    return $a4c0c313a61fc29c$var$add(point, frame.scroll.diff.displacement);
};
var $a4c0c313a61fc29c$var$getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, afterCritical = _ref.afterCritical;
    var original = draggable.page.borderBox.center;
    var at = impact.at;
    if (!droppable) return original;
    if (!at) return original;
    if (at.type === 'REORDER') return $a4c0c313a61fc29c$var$whenReordering({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $a4c0c313a61fc29c$var$whenCombining({
        impact: impact,
        draggables: draggables,
        afterCritical: afterCritical
    });
};
var $a4c0c313a61fc29c$var$getPageBorderBoxCenterFromImpact = function(args) {
    var withoutDisplacement = $a4c0c313a61fc29c$var$getResultWithoutDroppableDisplacement(args);
    var droppable = args.droppable;
    var withDisplacement = droppable ? $a4c0c313a61fc29c$var$withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
    return withDisplacement;
};
var $a4c0c313a61fc29c$var$scrollViewport = function(viewport, newScroll) {
    var diff = $a4c0c313a61fc29c$var$subtract(newScroll, viewport.scroll.initial);
    var displacement = $a4c0c313a61fc29c$var$negate(diff);
    var frame = (0, $ixGZi.getRect)({
        top: newScroll.y,
        bottom: newScroll.y + viewport.frame.height,
        left: newScroll.x,
        right: newScroll.x + viewport.frame.width
    });
    var updated = {
        frame: frame,
        scroll: {
            initial: viewport.scroll.initial,
            max: viewport.scroll.max,
            current: newScroll,
            diff: {
                value: diff,
                displacement: displacement
            }
        }
    };
    return updated;
};
function $a4c0c313a61fc29c$var$getDraggables(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
function $a4c0c313a61fc29c$var$tryGetVisible(id, groups) {
    for(var i = 0; i < groups.length; i++){
        var displacement = groups[i].visible[id];
        if (displacement) return displacement;
    }
    return null;
}
var $a4c0c313a61fc29c$var$speculativelyIncrease = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, destination = _ref.destination, draggables = _ref.draggables, maxScrollChange = _ref.maxScrollChange;
    var scrolledViewport = $a4c0c313a61fc29c$var$scrollViewport(viewport, $a4c0c313a61fc29c$var$add(viewport.scroll.current, maxScrollChange));
    var scrolledDroppable = destination.frame ? $a4c0c313a61fc29c$var$scrollDroppable(destination, $a4c0c313a61fc29c$var$add(destination.frame.scroll.current, maxScrollChange)) : destination;
    var last = impact.displaced;
    var withViewportScroll = $a4c0c313a61fc29c$var$getDisplacementGroups({
        afterDragging: $a4c0c313a61fc29c$var$getDraggables(last.all, draggables),
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: scrolledViewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var withDroppableScroll = $a4c0c313a61fc29c$var$getDisplacementGroups({
        afterDragging: $a4c0c313a61fc29c$var$getDraggables(last.all, draggables),
        destination: scrolledDroppable,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var invisible = {};
    var visible = {};
    var groups = [
        last,
        withViewportScroll,
        withDroppableScroll
    ];
    last.all.forEach(function(id) {
        var displacement = $a4c0c313a61fc29c$var$tryGetVisible(id, groups);
        if (displacement) {
            visible[id] = displacement;
            return;
        }
        invisible[id] = true;
    });
    var newImpact = (0, $iyGBi.default)({}, impact, {
        displaced: {
            all: last.all,
            invisible: invisible,
            visible: visible
        }
    });
    return newImpact;
};
var $a4c0c313a61fc29c$var$withViewportDisplacement = function(viewport, point) {
    return $a4c0c313a61fc29c$var$add(viewport.scroll.diff.displacement, point);
};
var $a4c0c313a61fc29c$var$getClientFromPageBorderBoxCenter = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, draggable = _ref.draggable, viewport = _ref.viewport;
    var withoutPageScrollChange = $a4c0c313a61fc29c$var$withViewportDisplacement(viewport, pageBorderBoxCenter);
    var offset = $a4c0c313a61fc29c$var$subtract(withoutPageScrollChange, draggable.page.borderBox.center);
    return $a4c0c313a61fc29c$var$add(draggable.client.borderBox.center, offset);
};
var $a4c0c313a61fc29c$var$isTotallyVisibleInNewLocation = function(_ref) {
    var draggable = _ref.draggable, destination = _ref.destination, newPageBorderBoxCenter = _ref.newPageBorderBoxCenter, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, _ref$onlyOnMainAxis = _ref.onlyOnMainAxis, onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
    var changeNeeded = $a4c0c313a61fc29c$var$subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
    var shifted = $a4c0c313a61fc29c$var$offsetByPosition(draggable.page.borderBox, changeNeeded);
    var args = {
        target: shifted,
        destination: destination,
        withDroppableDisplacement: withDroppableDisplacement,
        viewport: viewport
    };
    return onlyOnMainAxis ? $a4c0c313a61fc29c$var$isTotallyVisibleOnAxis(args) : $a4c0c313a61fc29c$var$isTotallyVisible(args);
};
var $a4c0c313a61fc29c$var$moveToNextPlace = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, draggables = _ref.draggables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, previousClientSelection = _ref.previousClientSelection, afterCritical = _ref.afterCritical;
    if (!destination.isEnabled) return null;
    var insideDestination = $a4c0c313a61fc29c$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var isInHomeList = $a4c0c313a61fc29c$var$isHomeOf(draggable, destination);
    var impact = $a4c0c313a61fc29c$var$moveToNextCombine({
        isMovingForward: isMovingForward,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact
    }) || $a4c0c313a61fc29c$var$moveToNextIndex({
        isMovingForward: isMovingForward,
        isInHomeList: isInHomeList,
        draggable: draggable,
        draggables: draggables,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $a4c0c313a61fc29c$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var isVisibleInNewLocation = $a4c0c313a61fc29c$var$isTotallyVisibleInNewLocation({
        draggable: draggable,
        destination: destination,
        newPageBorderBoxCenter: pageBorderBoxCenter,
        viewport: viewport.frame,
        withDroppableDisplacement: false,
        onlyOnMainAxis: true
    });
    if (isVisibleInNewLocation) {
        var clientSelection = $a4c0c313a61fc29c$var$getClientFromPageBorderBoxCenter({
            pageBorderBoxCenter: pageBorderBoxCenter,
            draggable: draggable,
            viewport: viewport
        });
        return {
            clientSelection: clientSelection,
            impact: impact,
            scrollJumpRequest: null
        };
    }
    var distance = $a4c0c313a61fc29c$var$subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
    var cautious = $a4c0c313a61fc29c$var$speculativelyIncrease({
        impact: impact,
        viewport: viewport,
        destination: destination,
        draggables: draggables,
        maxScrollChange: distance
    });
    return {
        clientSelection: previousClientSelection,
        impact: cautious,
        scrollJumpRequest: distance
    };
};
var $a4c0c313a61fc29c$var$getKnownActive = function getKnownActive(droppable) {
    var rect = droppable.subject.active;
    !rect && $a4c0c313a61fc29c$var$invariant(false);
    return rect;
};
var $a4c0c313a61fc29c$var$getBestCrossAxisDroppable = function(_ref) {
    var isMovingForward = _ref.isMovingForward, pageBorderBoxCenter = _ref.pageBorderBoxCenter, source = _ref.source, droppables = _ref.droppables, viewport = _ref.viewport;
    var active = source.subject.active;
    if (!active) return null;
    var axis = source.axis;
    var isBetweenSourceClipped = $a4c0c313a61fc29c$var$isWithin(active[axis.start], active[axis.end]);
    var candidates = $a4c0c313a61fc29c$var$toDroppableList(droppables).filter(function(droppable) {
        return droppable !== source;
    }).filter(function(droppable) {
        return droppable.isEnabled;
    }).filter(function(droppable) {
        return Boolean(droppable.subject.active);
    }).filter(function(droppable) {
        return $a4c0c313a61fc29c$var$isPartiallyVisibleThroughFrame(viewport.frame)($a4c0c313a61fc29c$var$getKnownActive(droppable));
    }).filter(function(droppable) {
        var activeOfTarget = $a4c0c313a61fc29c$var$getKnownActive(droppable);
        if (isMovingForward) return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
        return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
    }).filter(function(droppable) {
        var activeOfTarget = $a4c0c313a61fc29c$var$getKnownActive(droppable);
        var isBetweenDestinationClipped = $a4c0c313a61fc29c$var$isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
        return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
    }).sort(function(a, b) {
        var first = $a4c0c313a61fc29c$var$getKnownActive(a)[axis.crossAxisStart];
        var second = $a4c0c313a61fc29c$var$getKnownActive(b)[axis.crossAxisStart];
        if (isMovingForward) return first - second;
        return second - first;
    }).filter(function(droppable, index, array) {
        return $a4c0c313a61fc29c$var$getKnownActive(droppable)[axis.crossAxisStart] === $a4c0c313a61fc29c$var$getKnownActive(array[0])[axis.crossAxisStart];
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0];
    var contains = candidates.filter(function(droppable) {
        var isWithinDroppable = $a4c0c313a61fc29c$var$isWithin($a4c0c313a61fc29c$var$getKnownActive(droppable)[axis.start], $a4c0c313a61fc29c$var$getKnownActive(droppable)[axis.end]);
        return isWithinDroppable(pageBorderBoxCenter[axis.line]);
    });
    if (contains.length === 1) return contains[0];
    if (contains.length > 1) return contains.sort(function(a, b) {
        return $a4c0c313a61fc29c$var$getKnownActive(a)[axis.start] - $a4c0c313a61fc29c$var$getKnownActive(b)[axis.start];
    })[0];
    return candidates.sort(function(a, b) {
        var first = $a4c0c313a61fc29c$var$closest(pageBorderBoxCenter, $a4c0c313a61fc29c$var$getCorners($a4c0c313a61fc29c$var$getKnownActive(a)));
        var second = $a4c0c313a61fc29c$var$closest(pageBorderBoxCenter, $a4c0c313a61fc29c$var$getCorners($a4c0c313a61fc29c$var$getKnownActive(b)));
        if (first !== second) return first - second;
        return $a4c0c313a61fc29c$var$getKnownActive(a)[axis.start] - $a4c0c313a61fc29c$var$getKnownActive(b)[axis.start];
    })[0];
};
var $a4c0c313a61fc29c$var$getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, afterCritical) {
    var original = draggable.page.borderBox.center;
    return $a4c0c313a61fc29c$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $a4c0c313a61fc29c$var$subtract(original, afterCritical.displacedBy.point) : original;
};
var $a4c0c313a61fc29c$var$getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, afterCritical) {
    var original = draggable.page.borderBox;
    return $a4c0c313a61fc29c$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $a4c0c313a61fc29c$var$offsetByPosition(original, $a4c0c313a61fc29c$var$negate(afterCritical.displacedBy.point)) : original;
};
var $a4c0c313a61fc29c$var$getClosestDraggable = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, viewport = _ref.viewport, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    var sorted = insideDestination.filter(function(draggable) {
        return $a4c0c313a61fc29c$var$isTotallyVisible({
            target: $a4c0c313a61fc29c$var$getCurrentPageBorderBox(draggable, afterCritical),
            destination: destination,
            viewport: viewport.frame,
            withDroppableDisplacement: true
        });
    }).sort(function(a, b) {
        var distanceToA = $a4c0c313a61fc29c$var$distance(pageBorderBoxCenter, $a4c0c313a61fc29c$var$withDroppableDisplacement(destination, $a4c0c313a61fc29c$var$getCurrentPageBorderBoxCenter(a, afterCritical)));
        var distanceToB = $a4c0c313a61fc29c$var$distance(pageBorderBoxCenter, $a4c0c313a61fc29c$var$withDroppableDisplacement(destination, $a4c0c313a61fc29c$var$getCurrentPageBorderBoxCenter(b, afterCritical)));
        if (distanceToA < distanceToB) return -1;
        if (distanceToB < distanceToA) return 1;
        return a.descriptor.index - b.descriptor.index;
    });
    return sorted[0] || null;
};
var $a4c0c313a61fc29c$var$getDisplacedBy = (0, $gj4eS.default)(function getDisplacedBy(axis, displaceBy) {
    var displacement = displaceBy[axis.line];
    return {
        value: displacement,
        point: $a4c0c313a61fc29c$var$patch(axis.line, displacement)
    };
});
var $a4c0c313a61fc29c$var$getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
    var axis = droppable.axis;
    if (droppable.descriptor.mode === 'virtual') return $a4c0c313a61fc29c$var$patch(axis.line, placeholderSize[axis.line]);
    var availableSpace = droppable.subject.page.contentBox[axis.size];
    var insideDroppable = $a4c0c313a61fc29c$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var spaceUsed = insideDroppable.reduce(function(sum, dimension) {
        return sum + dimension.client.marginBox[axis.size];
    }, 0);
    var requiredSpace = spaceUsed + placeholderSize[axis.line];
    var needsToGrowBy = requiredSpace - availableSpace;
    if (needsToGrowBy <= 0) return null;
    return $a4c0c313a61fc29c$var$patch(axis.line, needsToGrowBy);
};
var $a4c0c313a61fc29c$var$withMaxScroll = function withMaxScroll(frame, max) {
    return (0, $iyGBi.default)({}, frame, {
        scroll: (0, $iyGBi.default)({}, frame.scroll, {
            max: max
        })
    });
};
var $a4c0c313a61fc29c$var$addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
    var frame = droppable.frame;
    !!$a4c0c313a61fc29c$var$isHomeOf(draggable, droppable) && $a4c0c313a61fc29c$var$invariant(false);
    !!droppable.subject.withPlaceholder && $a4c0c313a61fc29c$var$invariant(false);
    var placeholderSize = $a4c0c313a61fc29c$var$getDisplacedBy(droppable.axis, draggable.displaceBy).point;
    var requiredGrowth = $a4c0c313a61fc29c$var$getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
    var added = {
        placeholderSize: placeholderSize,
        increasedBy: requiredGrowth,
        oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
    };
    if (!frame) {
        var _subject = $a4c0c313a61fc29c$var$getSubject({
            page: droppable.subject.page,
            withPlaceholder: added,
            axis: droppable.axis,
            frame: droppable.frame
        });
        return (0, $iyGBi.default)({}, droppable, {
            subject: _subject
        });
    }
    var maxScroll = requiredGrowth ? $a4c0c313a61fc29c$var$add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
    var newFrame = $a4c0c313a61fc29c$var$withMaxScroll(frame, maxScroll);
    var subject = $a4c0c313a61fc29c$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: added,
        axis: droppable.axis,
        frame: newFrame
    });
    return (0, $iyGBi.default)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $a4c0c313a61fc29c$var$removePlaceholder = function removePlaceholder(droppable) {
    var added = droppable.subject.withPlaceholder;
    !added && $a4c0c313a61fc29c$var$invariant(false);
    var frame = droppable.frame;
    if (!frame) {
        var _subject2 = $a4c0c313a61fc29c$var$getSubject({
            page: droppable.subject.page,
            axis: droppable.axis,
            frame: null,
            withPlaceholder: null
        });
        return (0, $iyGBi.default)({}, droppable, {
            subject: _subject2
        });
    }
    var oldMaxScroll = added.oldFrameMaxScroll;
    !oldMaxScroll && $a4c0c313a61fc29c$var$invariant(false);
    var newFrame = $a4c0c313a61fc29c$var$withMaxScroll(frame, oldMaxScroll);
    var subject = $a4c0c313a61fc29c$var$getSubject({
        page: droppable.subject.page,
        axis: droppable.axis,
        frame: newFrame,
        withPlaceholder: null
    });
    return (0, $iyGBi.default)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $a4c0c313a61fc29c$var$moveToNewDroppable = function(_ref) {
    var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, moveRelativeTo = _ref.moveRelativeTo, insideDestination = _ref.insideDestination, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    if (!moveRelativeTo) {
        if (insideDestination.length) return null;
        var proposed = {
            displaced: $a4c0c313a61fc29c$var$emptyGroups,
            displacedBy: $a4c0c313a61fc29c$var$noDisplacedBy,
            at: {
                type: 'REORDER',
                destination: {
                    droppableId: destination.descriptor.id,
                    index: 0
                }
            }
        };
        var proposedPageBorderBoxCenter = $a4c0c313a61fc29c$var$getPageBorderBoxCenterFromImpact({
            impact: proposed,
            draggable: draggable,
            droppable: destination,
            draggables: draggables,
            afterCritical: afterCritical
        });
        var withPlaceholder = $a4c0c313a61fc29c$var$isHomeOf(draggable, destination) ? destination : $a4c0c313a61fc29c$var$addPlaceholder(destination, draggable, draggables);
        var isVisibleInNewLocation = $a4c0c313a61fc29c$var$isTotallyVisibleInNewLocation({
            draggable: draggable,
            destination: withPlaceholder,
            newPageBorderBoxCenter: proposedPageBorderBoxCenter,
            viewport: viewport.frame,
            withDroppableDisplacement: false,
            onlyOnMainAxis: true
        });
        return isVisibleInNewLocation ? proposed : null;
    }
    var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);
    var proposedIndex = function() {
        var relativeTo = moveRelativeTo.descriptor.index;
        if (moveRelativeTo.descriptor.id === draggable.descriptor.id) return relativeTo;
        if (isGoingBeforeTarget) return relativeTo;
        return relativeTo + 1;
    }();
    var displacedBy = $a4c0c313a61fc29c$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    return $a4c0c313a61fc29c$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        displacedBy: displacedBy,
        last: $a4c0c313a61fc29c$var$emptyGroups,
        index: proposedIndex
    });
};
var $a4c0c313a61fc29c$var$moveCrossAxis = function(_ref) {
    var isMovingForward = _ref.isMovingForward, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, draggable = _ref.draggable, isOver = _ref.isOver, draggables = _ref.draggables, droppables = _ref.droppables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var destination = $a4c0c313a61fc29c$var$getBestCrossAxisDroppable({
        isMovingForward: isMovingForward,
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        source: isOver,
        droppables: droppables,
        viewport: viewport
    });
    if (!destination) return null;
    var insideDestination = $a4c0c313a61fc29c$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var moveRelativeTo = $a4c0c313a61fc29c$var$getClosestDraggable({
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        viewport: viewport,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    });
    var impact = $a4c0c313a61fc29c$var$moveToNewDroppable({
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        destination: destination,
        draggable: draggable,
        draggables: draggables,
        moveRelativeTo: moveRelativeTo,
        insideDestination: insideDestination,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $a4c0c313a61fc29c$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var clientSelection = $a4c0c313a61fc29c$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
    return {
        clientSelection: clientSelection,
        impact: impact,
        scrollJumpRequest: null
    };
};
var $a4c0c313a61fc29c$var$whatIsDraggedOver = function(impact) {
    var at = impact.at;
    if (!at) return null;
    if (at.type === 'REORDER') return at.destination.droppableId;
    return at.combine.droppableId;
};
var $a4c0c313a61fc29c$var$getDroppableOver = function getDroppableOver(impact, droppables) {
    var id = $a4c0c313a61fc29c$var$whatIsDraggedOver(impact);
    return id ? droppables[id] : null;
};
var $a4c0c313a61fc29c$var$moveInDirection = function(_ref) {
    var state = _ref.state, type = _ref.type;
    var isActuallyOver = $a4c0c313a61fc29c$var$getDroppableOver(state.impact, state.dimensions.droppables);
    var isMainAxisMovementAllowed = Boolean(isActuallyOver);
    var home = state.dimensions.droppables[state.critical.droppable.id];
    var isOver = isActuallyOver || home;
    var direction = isOver.axis.direction;
    var isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');
    if (isMovingOnMainAxis && !isMainAxisMovementAllowed) return null;
    var isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
    var _state$dimensions = state.dimensions, draggables = _state$dimensions.draggables, droppables = _state$dimensions.droppables;
    return isMovingOnMainAxis ? $a4c0c313a61fc29c$var$moveToNextPlace({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        destination: isOver,
        draggables: draggables,
        viewport: state.viewport,
        previousClientSelection: state.current.client.selection,
        previousImpact: state.impact,
        afterCritical: state.afterCritical
    }) : $a4c0c313a61fc29c$var$moveCrossAxis({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        isOver: isOver,
        draggables: draggables,
        droppables: droppables,
        viewport: state.viewport,
        afterCritical: state.afterCritical
    });
};
function $a4c0c313a61fc29c$var$isMovementAllowed(state) {
    return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
}
function $a4c0c313a61fc29c$var$isPositionInFrame(frame) {
    var isWithinVertical = $a4c0c313a61fc29c$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $a4c0c313a61fc29c$var$isWithin(frame.left, frame.right);
    return function run(point) {
        return isWithinVertical(point.y) && isWithinHorizontal(point.x);
    };
}
function $a4c0c313a61fc29c$var$getHasOverlap(first, second) {
    return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}
function $a4c0c313a61fc29c$var$getFurthestAway(_ref) {
    var pageBorderBox = _ref.pageBorderBox, draggable = _ref.draggable, candidates = _ref.candidates;
    var startCenter = draggable.page.borderBox.center;
    var sorted = candidates.map(function(candidate) {
        var axis = candidate.axis;
        var target = $a4c0c313a61fc29c$var$patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
        return {
            id: candidate.descriptor.id,
            distance: $a4c0c313a61fc29c$var$distance(startCenter, target)
        };
    }).sort(function(a, b) {
        return b.distance - a.distance;
    });
    return sorted[0] ? sorted[0].id : null;
}
function $a4c0c313a61fc29c$var$getDroppableOver$1(_ref2) {
    var pageBorderBox = _ref2.pageBorderBox, draggable = _ref2.draggable, droppables = _ref2.droppables;
    var candidates = $a4c0c313a61fc29c$var$toDroppableList(droppables).filter(function(item) {
        if (!item.isEnabled) return false;
        var active = item.subject.active;
        if (!active) return false;
        if (!$a4c0c313a61fc29c$var$getHasOverlap(pageBorderBox, active)) return false;
        if ($a4c0c313a61fc29c$var$isPositionInFrame(active)(pageBorderBox.center)) return true;
        var axis = item.axis;
        var childCenter = active.center[axis.crossAxisLine];
        var crossAxisStart = pageBorderBox[axis.crossAxisStart];
        var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
        var isContained = $a4c0c313a61fc29c$var$isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
        var isStartContained = isContained(crossAxisStart);
        var isEndContained = isContained(crossAxisEnd);
        if (!isStartContained && !isEndContained) return true;
        if (isStartContained) return crossAxisStart < childCenter;
        return crossAxisEnd > childCenter;
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0].descriptor.id;
    return $a4c0c313a61fc29c$var$getFurthestAway({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        candidates: candidates
    });
}
var $a4c0c313a61fc29c$var$offsetRectByPosition = function offsetRectByPosition(rect, point) {
    return (0, $ixGZi.getRect)($a4c0c313a61fc29c$var$offsetByPosition(rect, point));
};
var $a4c0c313a61fc29c$var$withDroppableScroll = function(droppable, area) {
    var frame = droppable.frame;
    if (!frame) return area;
    return $a4c0c313a61fc29c$var$offsetRectByPosition(area, frame.scroll.diff.value);
};
function $a4c0c313a61fc29c$var$getIsDisplaced(_ref) {
    var displaced = _ref.displaced, id = _ref.id;
    return Boolean(displaced.visible[id] || displaced.invisible[id]);
}
function $a4c0c313a61fc29c$var$atIndex(_ref) {
    var draggable = _ref.draggable, closest = _ref.closest, inHomeList = _ref.inHomeList;
    if (!closest) return null;
    if (!inHomeList) return closest.descriptor.index;
    if (closest.descriptor.index > draggable.descriptor.index) return closest.descriptor.index - 1;
    return closest.descriptor.index;
}
var $a4c0c313a61fc29c$var$getReorderImpact = function(_ref2) {
    var targetRect = _ref2.pageBorderBoxWithDroppableScroll, draggable = _ref2.draggable, destination = _ref2.destination, insideDestination = _ref2.insideDestination, last = _ref2.last, viewport = _ref2.viewport, afterCritical = _ref2.afterCritical;
    var axis = destination.axis;
    var displacedBy = $a4c0c313a61fc29c$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $a4c0c313a61fc29c$var$removeDraggableFromList(draggable, insideDestination);
    var closest = $a4c0c313a61fc29c$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childCenter = child.page.borderBox.center[axis.line];
        var didStartAfterCritical$1 = $a4c0c313a61fc29c$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $a4c0c313a61fc29c$var$getIsDisplaced({
            displaced: last,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd <= childCenter;
            return targetStart < childCenter - displacement;
        }
        if (isDisplaced) return targetEnd <= childCenter + displacement;
        return targetStart < childCenter;
    });
    var newIndex = $a4c0c313a61fc29c$var$atIndex({
        draggable: draggable,
        closest: closest,
        inHomeList: $a4c0c313a61fc29c$var$isHomeOf(draggable, destination)
    });
    return $a4c0c313a61fc29c$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: last,
        displacedBy: displacedBy,
        index: newIndex
    });
};
var $a4c0c313a61fc29c$var$combineThresholdDivisor = 4;
var $a4c0c313a61fc29c$var$getCombineImpact = function(_ref) {
    var draggable = _ref.draggable, targetRect = _ref.pageBorderBoxWithDroppableScroll, previousImpact = _ref.previousImpact, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var axis = destination.axis;
    var displacedBy = $a4c0c313a61fc29c$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $a4c0c313a61fc29c$var$removeDraggableFromList(draggable, insideDestination);
    var combineWith = $a4c0c313a61fc29c$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childRect = child.page.borderBox;
        var childSize = childRect[axis.size];
        var threshold = childSize / $a4c0c313a61fc29c$var$combineThresholdDivisor;
        var didStartAfterCritical$1 = $a4c0c313a61fc29c$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $a4c0c313a61fc29c$var$getIsDisplaced({
            displaced: previousImpact.displaced,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
            return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
        }
        if (isDisplaced) return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
        return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
    });
    if (!combineWith) return null;
    var impact = {
        displacedBy: displacedBy,
        displaced: previousImpact.displaced,
        at: {
            type: 'COMBINE',
            combine: {
                draggableId: combineWith.descriptor.id,
                droppableId: destination.descriptor.id
            }
        }
    };
    return impact;
};
var $a4c0c313a61fc29c$var$getDragImpact = function(_ref) {
    var pageOffset = _ref.pageOffset, draggable = _ref.draggable, draggables = _ref.draggables, droppables = _ref.droppables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBox = $a4c0c313a61fc29c$var$offsetRectByPosition(draggable.page.borderBox, pageOffset);
    var destinationId = $a4c0c313a61fc29c$var$getDroppableOver$1({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        droppables: droppables
    });
    if (!destinationId) return $a4c0c313a61fc29c$var$noImpact;
    var destination = droppables[destinationId];
    var insideDestination = $a4c0c313a61fc29c$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var pageBorderBoxWithDroppableScroll = $a4c0c313a61fc29c$var$withDroppableScroll(destination, pageBorderBox);
    return $a4c0c313a61fc29c$var$getCombineImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        previousImpact: previousImpact,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    }) || $a4c0c313a61fc29c$var$getReorderImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        last: previousImpact.displaced,
        viewport: viewport,
        afterCritical: afterCritical
    });
};
var $a4c0c313a61fc29c$var$patchDroppableMap = function(droppables, updated) {
    var _extends2;
    return (0, $iyGBi.default)({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
};
var $a4c0c313a61fc29c$var$clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
    var previousImpact = _ref.previousImpact, impact = _ref.impact, droppables = _ref.droppables;
    var last = $a4c0c313a61fc29c$var$whatIsDraggedOver(previousImpact);
    var now = $a4c0c313a61fc29c$var$whatIsDraggedOver(impact);
    if (!last) return droppables;
    if (last === now) return droppables;
    var lastDroppable = droppables[last];
    if (!lastDroppable.subject.withPlaceholder) return droppables;
    var updated = $a4c0c313a61fc29c$var$removePlaceholder(lastDroppable);
    return $a4c0c313a61fc29c$var$patchDroppableMap(droppables, updated);
};
var $a4c0c313a61fc29c$var$recomputePlaceholders = function(_ref2) {
    var draggable = _ref2.draggable, draggables = _ref2.draggables, droppables = _ref2.droppables, previousImpact = _ref2.previousImpact, impact = _ref2.impact;
    var cleaned = $a4c0c313a61fc29c$var$clearUnusedPlaceholder({
        previousImpact: previousImpact,
        impact: impact,
        droppables: droppables
    });
    var isOver = $a4c0c313a61fc29c$var$whatIsDraggedOver(impact);
    if (!isOver) return cleaned;
    var droppable = droppables[isOver];
    if ($a4c0c313a61fc29c$var$isHomeOf(draggable, droppable)) return cleaned;
    if (droppable.subject.withPlaceholder) return cleaned;
    var patched = $a4c0c313a61fc29c$var$addPlaceholder(droppable, draggable, draggables);
    return $a4c0c313a61fc29c$var$patchDroppableMap(cleaned, patched);
};
var $a4c0c313a61fc29c$var$update = function(_ref) {
    var state = _ref.state, forcedClientSelection = _ref.clientSelection, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport, forcedImpact = _ref.impact, scrollJumpRequest = _ref.scrollJumpRequest;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var clientSelection = forcedClientSelection || state.current.client.selection;
    var offset = $a4c0c313a61fc29c$var$subtract(clientSelection, state.initial.client.selection);
    var client = {
        offset: offset,
        selection: clientSelection,
        borderBoxCenter: $a4c0c313a61fc29c$var$add(state.initial.client.borderBoxCenter, offset)
    };
    var page = {
        selection: $a4c0c313a61fc29c$var$add(client.selection, viewport.scroll.current),
        borderBoxCenter: $a4c0c313a61fc29c$var$add(client.borderBoxCenter, viewport.scroll.current),
        offset: $a4c0c313a61fc29c$var$add(client.offset, viewport.scroll.diff.value)
    };
    var current = {
        client: client,
        page: page
    };
    if (state.phase === 'COLLECTING') return (0, $iyGBi.default)({
        phase: 'COLLECTING'
    }, state, {
        dimensions: dimensions,
        viewport: viewport,
        current: current
    });
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var newImpact = forcedImpact || $a4c0c313a61fc29c$var$getDragImpact({
        pageOffset: page.offset,
        draggable: draggable,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: state.impact,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    var withUpdatedPlaceholders = $a4c0c313a61fc29c$var$recomputePlaceholders({
        draggable: draggable,
        impact: newImpact,
        previousImpact: state.impact,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables
    });
    var result = (0, $iyGBi.default)({}, state, {
        current: current,
        dimensions: {
            draggables: dimensions.draggables,
            droppables: withUpdatedPlaceholders
        },
        impact: newImpact,
        viewport: viewport,
        scrollJumpRequest: scrollJumpRequest || null,
        forceShouldAnimate: scrollJumpRequest ? false : null
    });
    return result;
};
function $a4c0c313a61fc29c$var$getDraggables$1(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
var $a4c0c313a61fc29c$var$recompute = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, draggables = _ref.draggables, destination = _ref.destination, forceShouldAnimate = _ref.forceShouldAnimate;
    var last = impact.displaced;
    var afterDragging = $a4c0c313a61fc29c$var$getDraggables$1(last.all, draggables);
    var displaced = $a4c0c313a61fc29c$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate,
        last: last
    });
    return (0, $iyGBi.default)({}, impact, {
        displaced: displaced
    });
};
var $a4c0c313a61fc29c$var$getClientBorderBoxCenter = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBoxCenter = $a4c0c313a61fc29c$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $a4c0c313a61fc29c$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
};
var $a4c0c313a61fc29c$var$refreshSnap = function(_ref) {
    var state = _ref.state, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport;
    !(state.movementMode === 'SNAP') && $a4c0c313a61fc29c$var$invariant(false);
    var needsVisibilityCheck = state.impact;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var draggable = draggables[state.critical.draggable.id];
    var isOver = $a4c0c313a61fc29c$var$whatIsDraggedOver(needsVisibilityCheck);
    !isOver && $a4c0c313a61fc29c$var$invariant(false);
    var destination = droppables[isOver];
    var impact = $a4c0c313a61fc29c$var$recompute({
        impact: needsVisibilityCheck,
        viewport: viewport,
        destination: destination,
        draggables: draggables
    });
    var clientSelection = $a4c0c313a61fc29c$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    return $a4c0c313a61fc29c$var$update({
        impact: impact,
        clientSelection: clientSelection,
        state: state,
        dimensions: dimensions,
        viewport: viewport
    });
};
var $a4c0c313a61fc29c$var$getHomeLocation = function(descriptor) {
    return {
        index: descriptor.index,
        droppableId: descriptor.droppableId
    };
};
var $a4c0c313a61fc29c$var$getLiftEffect = function(_ref) {
    var draggable = _ref.draggable, home = _ref.home, draggables = _ref.draggables, viewport = _ref.viewport;
    var displacedBy = $a4c0c313a61fc29c$var$getDisplacedBy(home.axis, draggable.displaceBy);
    var insideHome = $a4c0c313a61fc29c$var$getDraggablesInsideDroppable(home.descriptor.id, draggables);
    var rawIndex = insideHome.indexOf(draggable);
    !(rawIndex !== -1) && $a4c0c313a61fc29c$var$invariant(false);
    var afterDragging = insideHome.slice(rawIndex + 1);
    var effected = afterDragging.reduce(function(previous, item) {
        previous[item.descriptor.id] = true;
        return previous;
    }, {});
    var afterCritical = {
        inVirtualList: home.descriptor.mode === 'virtual',
        displacedBy: displacedBy,
        effected: effected
    };
    var displaced = $a4c0c313a61fc29c$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: home,
        displacedBy: displacedBy,
        last: null,
        viewport: viewport.frame,
        forceShouldAnimate: false
    });
    var impact = {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: $a4c0c313a61fc29c$var$getHomeLocation(draggable.descriptor)
        }
    };
    return {
        impact: impact,
        afterCritical: afterCritical
    };
};
var $a4c0c313a61fc29c$var$patchDimensionMap = function(dimensions, updated) {
    return {
        draggables: dimensions.draggables,
        droppables: $a4c0c313a61fc29c$var$patchDroppableMap(dimensions.droppables, updated)
    };
};
var $a4c0c313a61fc29c$var$records = {};
var $a4c0c313a61fc29c$var$isEnabled = false;
var $a4c0c313a61fc29c$var$isTimingsEnabled = function isTimingsEnabled() {
    return $a4c0c313a61fc29c$var$isEnabled;
};
var $a4c0c313a61fc29c$var$start = function start(key) {
    var now;
};
var $a4c0c313a61fc29c$var$finish = function finish(key) {
    var now, previous, result, rounded, style;
};
var $a4c0c313a61fc29c$var$offsetDraggable = function(_ref) {
    var draggable = _ref.draggable, offset$1 = _ref.offset, initialWindowScroll = _ref.initialWindowScroll;
    var client = (0, $ixGZi.offset)(draggable.client, offset$1);
    var page = (0, $ixGZi.withScroll)(client, initialWindowScroll);
    var moved = (0, $iyGBi.default)({}, draggable, {
        placeholder: (0, $iyGBi.default)({}, draggable.placeholder, {
            client: client
        }),
        client: client,
        page: page
    });
    return moved;
};
var $a4c0c313a61fc29c$var$getFrame = function(droppable) {
    var frame = droppable.frame;
    !frame && $a4c0c313a61fc29c$var$invariant(false);
    return frame;
};
var $a4c0c313a61fc29c$var$adjustAdditionsForScrollChanges = function(_ref) {
    var additions = _ref.additions, updatedDroppables = _ref.updatedDroppables, viewport = _ref.viewport;
    var windowScrollChange = viewport.scroll.diff.value;
    return additions.map(function(draggable) {
        var droppableId = draggable.descriptor.droppableId;
        var modified = updatedDroppables[droppableId];
        var frame = $a4c0c313a61fc29c$var$getFrame(modified);
        var droppableScrollChange = frame.scroll.diff.value;
        var totalChange = $a4c0c313a61fc29c$var$add(windowScrollChange, droppableScrollChange);
        var moved = $a4c0c313a61fc29c$var$offsetDraggable({
            draggable: draggable,
            offset: totalChange,
            initialWindowScroll: viewport.scroll.initial
        });
        return moved;
    });
};
var $a4c0c313a61fc29c$var$timingsKey = 'Processing dynamic changes';
var $a4c0c313a61fc29c$var$publishWhileDraggingInVirtual = function(_ref) {
    var _extends2, _extends3;
    var state = _ref.state, published = _ref.published;
    $a4c0c313a61fc29c$var$start($a4c0c313a61fc29c$var$timingsKey);
    var withScrollChange = published.modified.map(function(update) {
        var existing = state.dimensions.droppables[update.droppableId];
        var scrolled = $a4c0c313a61fc29c$var$scrollDroppable(existing, update.scroll);
        return scrolled;
    });
    var droppables = (0, $iyGBi.default)({}, state.dimensions.droppables, $a4c0c313a61fc29c$var$toDroppableMap(withScrollChange));
    var updatedAdditions = $a4c0c313a61fc29c$var$toDraggableMap($a4c0c313a61fc29c$var$adjustAdditionsForScrollChanges({
        additions: published.additions,
        updatedDroppables: droppables,
        viewport: state.viewport
    }));
    var draggables = (0, $iyGBi.default)({}, state.dimensions.draggables, updatedAdditions);
    published.removals.forEach(function(id) {
        delete draggables[id];
    });
    var dimensions = {
        droppables: droppables,
        draggables: draggables
    };
    var wasOverId = $a4c0c313a61fc29c$var$whatIsDraggedOver(state.impact);
    var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var home = dimensions.droppables[state.critical.droppable.id];
    var _getLiftEffect = $a4c0c313a61fc29c$var$getLiftEffect({
        draggable: draggable,
        home: home,
        draggables: draggables,
        viewport: state.viewport
    }), onLiftImpact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
    var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
    var impact = $a4c0c313a61fc29c$var$getDragImpact({
        pageOffset: state.current.page.offset,
        draggable: dimensions.draggables[state.critical.draggable.id],
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: previousImpact,
        viewport: state.viewport,
        afterCritical: afterCritical
    });
    $a4c0c313a61fc29c$var$finish($a4c0c313a61fc29c$var$timingsKey);
    var draggingState = (0, $iyGBi.default)({
        phase: 'DRAGGING'
    }, state, (_extends2 = {}, _extends2["phase"] = 'DRAGGING', _extends2.impact = impact, _extends2.onLiftImpact = onLiftImpact, _extends2.dimensions = dimensions, _extends2.afterCritical = afterCritical, _extends2.forceShouldAnimate = false, _extends2));
    if (state.phase === 'COLLECTING') return draggingState;
    var dropPending = (0, $iyGBi.default)({
        phase: 'DROP_PENDING'
    }, draggingState, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.reason = state.reason, _extends3.isWaiting = false, _extends3));
    return dropPending;
};
var $a4c0c313a61fc29c$var$isSnapping = function isSnapping(state) {
    return state.movementMode === 'SNAP';
};
var $a4c0c313a61fc29c$var$postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
    var dimensions = $a4c0c313a61fc29c$var$patchDimensionMap(state.dimensions, updated);
    if (!$a4c0c313a61fc29c$var$isSnapping(state) || isEnabledChanging) return $a4c0c313a61fc29c$var$update({
        state: state,
        dimensions: dimensions
    });
    return $a4c0c313a61fc29c$var$refreshSnap({
        state: state,
        dimensions: dimensions
    });
};
function $a4c0c313a61fc29c$var$removeScrollJumpRequest(state) {
    if (state.isDragging && state.movementMode === 'SNAP') return (0, $iyGBi.default)({
        phase: 'DRAGGING'
    }, state, {
        scrollJumpRequest: null
    });
    return state;
}
var $a4c0c313a61fc29c$var$idle = {
    phase: 'IDLE',
    completed: null,
    shouldFlush: false
};
var $a4c0c313a61fc29c$var$reducer = function(state, action) {
    if (state === void 0) state = $a4c0c313a61fc29c$var$idle;
    if (action.type === 'FLUSH') return (0, $iyGBi.default)({}, $a4c0c313a61fc29c$var$idle, {
        shouldFlush: true
    });
    if (action.type === 'INITIAL_PUBLISH') {
        !(state.phase === 'IDLE') && $a4c0c313a61fc29c$var$invariant(false);
        var _action$payload = action.payload, critical = _action$payload.critical, clientSelection = _action$payload.clientSelection, viewport = _action$payload.viewport, dimensions = _action$payload.dimensions, movementMode = _action$payload.movementMode;
        var draggable = dimensions.draggables[critical.draggable.id];
        var home = dimensions.droppables[critical.droppable.id];
        var client = {
            selection: clientSelection,
            borderBoxCenter: draggable.client.borderBox.center,
            offset: $a4c0c313a61fc29c$var$origin
        };
        var initial = {
            client: client,
            page: {
                selection: $a4c0c313a61fc29c$var$add(client.selection, viewport.scroll.initial),
                borderBoxCenter: $a4c0c313a61fc29c$var$add(client.selection, viewport.scroll.initial),
                offset: $a4c0c313a61fc29c$var$add(client.selection, viewport.scroll.diff.value)
            }
        };
        var isWindowScrollAllowed = $a4c0c313a61fc29c$var$toDroppableList(dimensions.droppables).every(function(item) {
            return !item.isFixedOnPage;
        });
        var _getLiftEffect = $a4c0c313a61fc29c$var$getLiftEffect({
            draggable: draggable,
            home: home,
            draggables: dimensions.draggables,
            viewport: viewport
        }), impact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
        var result = {
            phase: 'DRAGGING',
            isDragging: true,
            critical: critical,
            movementMode: movementMode,
            dimensions: dimensions,
            initial: initial,
            current: initial,
            isWindowScrollAllowed: isWindowScrollAllowed,
            impact: impact,
            afterCritical: afterCritical,
            onLiftImpact: impact,
            viewport: viewport,
            scrollJumpRequest: null,
            forceShouldAnimate: null
        };
        return result;
    }
    if (action.type === 'COLLECTION_STARTING') {
        var _extends2;
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && $a4c0c313a61fc29c$var$invariant(false);
        var _result = (0, $iyGBi.default)({
            phase: 'COLLECTING'
        }, state, (_extends2 = {}, _extends2["phase"] = 'COLLECTING', _extends2));
        return _result;
    }
    if (action.type === 'PUBLISH_WHILE_DRAGGING') {
        !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') && $a4c0c313a61fc29c$var$invariant(false);
        return $a4c0c313a61fc29c$var$publishWhileDraggingInVirtual({
            state: state,
            published: action.payload
        });
    }
    if (action.type === 'MOVE') {
        if (state.phase === 'DROP_PENDING') return state;
        !$a4c0c313a61fc29c$var$isMovementAllowed(state) && $a4c0c313a61fc29c$var$invariant(false);
        var _clientSelection = action.payload.client;
        if ($a4c0c313a61fc29c$var$isEqual(_clientSelection, state.current.client.selection)) return state;
        return $a4c0c313a61fc29c$var$update({
            state: state,
            clientSelection: _clientSelection,
            impact: $a4c0c313a61fc29c$var$isSnapping(state) ? state.impact : null
        });
    }
    if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
        if (state.phase === 'DROP_PENDING') return $a4c0c313a61fc29c$var$removeScrollJumpRequest(state);
        if (state.phase === 'COLLECTING') return $a4c0c313a61fc29c$var$removeScrollJumpRequest(state);
        !$a4c0c313a61fc29c$var$isMovementAllowed(state) && $a4c0c313a61fc29c$var$invariant(false);
        var _action$payload2 = action.payload, id = _action$payload2.id, newScroll = _action$payload2.newScroll;
        var target = state.dimensions.droppables[id];
        if (!target) return state;
        var scrolled = $a4c0c313a61fc29c$var$scrollDroppable(target, newScroll);
        return $a4c0c313a61fc29c$var$postDroppableChange(state, scrolled, false);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !$a4c0c313a61fc29c$var$isMovementAllowed(state) && $a4c0c313a61fc29c$var$invariant(false);
        var _action$payload3 = action.payload, _id = _action$payload3.id, isEnabled = _action$payload3.isEnabled;
        var _target = state.dimensions.droppables[_id];
        !_target && $a4c0c313a61fc29c$var$invariant(false);
        !(_target.isEnabled !== isEnabled) && $a4c0c313a61fc29c$var$invariant(false);
        var updated = (0, $iyGBi.default)({}, _target, {
            isEnabled: isEnabled
        });
        return $a4c0c313a61fc29c$var$postDroppableChange(state, updated, true);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !$a4c0c313a61fc29c$var$isMovementAllowed(state) && $a4c0c313a61fc29c$var$invariant(false);
        var _action$payload4 = action.payload, _id2 = _action$payload4.id, isCombineEnabled = _action$payload4.isCombineEnabled;
        var _target2 = state.dimensions.droppables[_id2];
        !_target2 && $a4c0c313a61fc29c$var$invariant(false);
        !(_target2.isCombineEnabled !== isCombineEnabled) && $a4c0c313a61fc29c$var$invariant(false);
        var _updated = (0, $iyGBi.default)({}, _target2, {
            isCombineEnabled: isCombineEnabled
        });
        return $a4c0c313a61fc29c$var$postDroppableChange(state, _updated, true);
    }
    if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
        if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') return state;
        !$a4c0c313a61fc29c$var$isMovementAllowed(state) && $a4c0c313a61fc29c$var$invariant(false);
        !state.isWindowScrollAllowed && $a4c0c313a61fc29c$var$invariant(false);
        var _newScroll = action.payload.newScroll;
        if ($a4c0c313a61fc29c$var$isEqual(state.viewport.scroll.current, _newScroll)) return $a4c0c313a61fc29c$var$removeScrollJumpRequest(state);
        var _viewport = $a4c0c313a61fc29c$var$scrollViewport(state.viewport, _newScroll);
        if ($a4c0c313a61fc29c$var$isSnapping(state)) return $a4c0c313a61fc29c$var$refreshSnap({
            state: state,
            viewport: _viewport
        });
        return $a4c0c313a61fc29c$var$update({
            state: state,
            viewport: _viewport
        });
    }
    if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
        if (!$a4c0c313a61fc29c$var$isMovementAllowed(state)) return state;
        var maxScroll = action.payload.maxScroll;
        if ($a4c0c313a61fc29c$var$isEqual(maxScroll, state.viewport.scroll.max)) return state;
        var withMaxScroll = (0, $iyGBi.default)({}, state.viewport, {
            scroll: (0, $iyGBi.default)({}, state.viewport.scroll, {
                max: maxScroll
            })
        });
        return (0, $iyGBi.default)({
            phase: 'DRAGGING'
        }, state, {
            viewport: withMaxScroll
        });
    }
    if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && $a4c0c313a61fc29c$var$invariant(false);
        var _result2 = $a4c0c313a61fc29c$var$moveInDirection({
            state: state,
            type: action.type
        });
        if (!_result2) return state;
        return $a4c0c313a61fc29c$var$update({
            state: state,
            impact: _result2.impact,
            clientSelection: _result2.clientSelection,
            scrollJumpRequest: _result2.scrollJumpRequest
        });
    }
    if (action.type === 'DROP_PENDING') {
        var _extends3;
        var reason = action.payload.reason;
        !(state.phase === 'COLLECTING') && $a4c0c313a61fc29c$var$invariant(false);
        var newState = (0, $iyGBi.default)({
            phase: 'DROP_PENDING'
        }, state, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.isWaiting = true, _extends3.reason = reason, _extends3));
        return newState;
    }
    if (action.type === 'DROP_ANIMATE') {
        var _action$payload5 = action.payload, completed = _action$payload5.completed, dropDuration = _action$payload5.dropDuration, newHomeClientOffset = _action$payload5.newHomeClientOffset;
        !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && $a4c0c313a61fc29c$var$invariant(false);
        var _result3 = {
            phase: 'DROP_ANIMATING',
            completed: completed,
            dropDuration: dropDuration,
            newHomeClientOffset: newHomeClientOffset,
            dimensions: state.dimensions
        };
        return _result3;
    }
    if (action.type === 'DROP_COMPLETE') {
        var _completed = action.payload.completed;
        return {
            phase: 'IDLE',
            completed: _completed,
            shouldFlush: false
        };
    }
    return state;
};
var $a4c0c313a61fc29c$var$beforeInitialCapture = function beforeInitialCapture(args) {
    return {
        type: 'BEFORE_INITIAL_CAPTURE',
        payload: args
    };
};
var $a4c0c313a61fc29c$var$lift = function lift(args) {
    return {
        type: 'LIFT',
        payload: args
    };
};
var $a4c0c313a61fc29c$var$initialPublish = function initialPublish(args) {
    return {
        type: 'INITIAL_PUBLISH',
        payload: args
    };
};
var $a4c0c313a61fc29c$var$publishWhileDragging = function publishWhileDragging(args) {
    return {
        type: 'PUBLISH_WHILE_DRAGGING',
        payload: args
    };
};
var $a4c0c313a61fc29c$var$collectionStarting = function collectionStarting() {
    return {
        type: 'COLLECTION_STARTING',
        payload: null
    };
};
var $a4c0c313a61fc29c$var$updateDroppableScroll = function updateDroppableScroll(args) {
    return {
        type: 'UPDATE_DROPPABLE_SCROLL',
        payload: args
    };
};
var $a4c0c313a61fc29c$var$updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
    return {
        type: 'UPDATE_DROPPABLE_IS_ENABLED',
        payload: args
    };
};
var $a4c0c313a61fc29c$var$updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
    return {
        type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
        payload: args
    };
};
var $a4c0c313a61fc29c$var$move = function move(args) {
    return {
        type: 'MOVE',
        payload: args
    };
};
var $a4c0c313a61fc29c$var$moveByWindowScroll = function moveByWindowScroll(args) {
    return {
        type: 'MOVE_BY_WINDOW_SCROLL',
        payload: args
    };
};
var $a4c0c313a61fc29c$var$updateViewportMaxScroll = function updateViewportMaxScroll(args) {
    return {
        type: 'UPDATE_VIEWPORT_MAX_SCROLL',
        payload: args
    };
};
var $a4c0c313a61fc29c$var$moveUp = function moveUp() {
    return {
        type: 'MOVE_UP',
        payload: null
    };
};
var $a4c0c313a61fc29c$var$moveDown = function moveDown() {
    return {
        type: 'MOVE_DOWN',
        payload: null
    };
};
var $a4c0c313a61fc29c$var$moveRight = function moveRight() {
    return {
        type: 'MOVE_RIGHT',
        payload: null
    };
};
var $a4c0c313a61fc29c$var$moveLeft = function moveLeft() {
    return {
        type: 'MOVE_LEFT',
        payload: null
    };
};
var $a4c0c313a61fc29c$var$flush = function flush() {
    return {
        type: 'FLUSH',
        payload: null
    };
};
var $a4c0c313a61fc29c$var$animateDrop = function animateDrop(args) {
    return {
        type: 'DROP_ANIMATE',
        payload: args
    };
};
var $a4c0c313a61fc29c$var$completeDrop = function completeDrop(args) {
    return {
        type: 'DROP_COMPLETE',
        payload: args
    };
};
var $a4c0c313a61fc29c$var$drop = function drop(args) {
    return {
        type: 'DROP',
        payload: args
    };
};
var $a4c0c313a61fc29c$var$dropPending = function dropPending(args) {
    return {
        type: 'DROP_PENDING',
        payload: args
    };
};
var $a4c0c313a61fc29c$var$dropAnimationFinished = function dropAnimationFinished() {
    return {
        type: 'DROP_ANIMATION_FINISHED',
        payload: null
    };
};
function $a4c0c313a61fc29c$var$checkIndexes(insideDestination) {
    if (insideDestination.length <= 1) return;
    var indexes = insideDestination.map(function(d) {
        return d.descriptor.index;
    });
    var errors = {};
    for(var i = 1; i < indexes.length; i++){
        var current = indexes[i];
        var previous = indexes[i - 1];
        if (current !== previous + 1) errors[current] = true;
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($dAFDe)))(errors).length) return;
    var formatted = indexes.map(function(index) {
        var hasError = Boolean(errors[index]);
        return hasError ? "[\uD83D\uDD25" + index + "]" : "" + index;
    }).join(', ');
}
function $a4c0c313a61fc29c$var$validateDimensions(critical, dimensions) {
    var insideDestination;
}
var $a4c0c313a61fc29c$var$lift$1 = function(marshal) {
    return function(_ref) {
        var getState = _ref.getState, dispatch = _ref.dispatch;
        return function(next) {
            return function(action) {
                if (action.type !== 'LIFT') {
                    next(action);
                    return;
                }
                var _action$payload = action.payload, id = _action$payload.id, clientSelection = _action$payload.clientSelection, movementMode = _action$payload.movementMode;
                var initial = getState();
                if (initial.phase === 'DROP_ANIMATING') dispatch($a4c0c313a61fc29c$var$completeDrop({
                    completed: initial.completed
                }));
                !(getState().phase === 'IDLE') && $a4c0c313a61fc29c$var$invariant(false);
                dispatch($a4c0c313a61fc29c$var$flush());
                dispatch($a4c0c313a61fc29c$var$beforeInitialCapture({
                    draggableId: id,
                    movementMode: movementMode
                }));
                var scrollOptions = {
                    shouldPublishImmediately: movementMode === 'SNAP'
                };
                var request = {
                    draggableId: id,
                    scrollOptions: scrollOptions
                };
                var _marshal$startPublish = marshal.startPublishing(request), critical = _marshal$startPublish.critical, dimensions = _marshal$startPublish.dimensions, viewport = _marshal$startPublish.viewport;
                $a4c0c313a61fc29c$var$validateDimensions(critical, dimensions);
                dispatch($a4c0c313a61fc29c$var$initialPublish({
                    critical: critical,
                    dimensions: dimensions,
                    clientSelection: clientSelection,
                    movementMode: movementMode,
                    viewport: viewport
                }));
            };
        };
    };
};
var $a4c0c313a61fc29c$var$style = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'INITIAL_PUBLISH') marshal.dragging();
                if (action.type === 'DROP_ANIMATE') marshal.dropping(action.payload.completed.result.reason);
                if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE') marshal.resting();
                next(action);
            };
        };
    };
};
var $a4c0c313a61fc29c$var$curves = {
    outOfTheWay: 'cubic-bezier(0.2, 0, 0, 1)',
    drop: 'cubic-bezier(.2,1,.1,1)'
};
var $a4c0c313a61fc29c$var$combine = {
    opacity: {
        drop: 0,
        combining: 0.7
    },
    scale: {
        drop: 0.75
    }
};
var $a4c0c313a61fc29c$var$timings = {
    outOfTheWay: 0.2,
    minDropTime: 0.33,
    maxDropTime: 0.55
};
var $a4c0c313a61fc29c$var$outOfTheWayTiming = $a4c0c313a61fc29c$var$timings.outOfTheWay + "s " + $a4c0c313a61fc29c$var$curves.outOfTheWay;
var $a4c0c313a61fc29c$var$transitions = {
    fluid: "opacity " + $a4c0c313a61fc29c$var$outOfTheWayTiming,
    snap: "transform " + $a4c0c313a61fc29c$var$outOfTheWayTiming + ", opacity " + $a4c0c313a61fc29c$var$outOfTheWayTiming,
    drop: function drop(duration) {
        var timing = duration + "s " + $a4c0c313a61fc29c$var$curves.drop;
        return "transform " + timing + ", opacity " + timing;
    },
    outOfTheWay: "transform " + $a4c0c313a61fc29c$var$outOfTheWayTiming,
    placeholder: "height " + $a4c0c313a61fc29c$var$outOfTheWayTiming + ", width " + $a4c0c313a61fc29c$var$outOfTheWayTiming + ", margin " + $a4c0c313a61fc29c$var$outOfTheWayTiming
};
var $a4c0c313a61fc29c$var$moveTo = function moveTo(offset) {
    return $a4c0c313a61fc29c$var$isEqual(offset, $a4c0c313a61fc29c$var$origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};
var $a4c0c313a61fc29c$var$transforms = {
    moveTo: $a4c0c313a61fc29c$var$moveTo,
    drop: function drop(offset, isCombining) {
        var translate = $a4c0c313a61fc29c$var$moveTo(offset);
        if (!translate) return null;
        if (!isCombining) return translate;
        return translate + " scale(" + $a4c0c313a61fc29c$var$combine.scale.drop + ")";
    }
};
var $a4c0c313a61fc29c$var$minDropTime = $a4c0c313a61fc29c$var$timings.minDropTime, $a4c0c313a61fc29c$var$maxDropTime = $a4c0c313a61fc29c$var$timings.maxDropTime;
var $a4c0c313a61fc29c$var$dropTimeRange = $a4c0c313a61fc29c$var$maxDropTime - $a4c0c313a61fc29c$var$minDropTime;
var $a4c0c313a61fc29c$var$maxDropTimeAtDistance = 1500;
var $a4c0c313a61fc29c$var$cancelDropModifier = 0.6;
var $a4c0c313a61fc29c$var$getDropDuration = function(_ref) {
    var current = _ref.current, destination = _ref.destination, reason = _ref.reason;
    var distance$1 = $a4c0c313a61fc29c$var$distance(current, destination);
    if (distance$1 <= 0) return $a4c0c313a61fc29c$var$minDropTime;
    if (distance$1 >= $a4c0c313a61fc29c$var$maxDropTimeAtDistance) return $a4c0c313a61fc29c$var$maxDropTime;
    var percentage = distance$1 / $a4c0c313a61fc29c$var$maxDropTimeAtDistance;
    var duration = $a4c0c313a61fc29c$var$minDropTime + $a4c0c313a61fc29c$var$dropTimeRange * percentage;
    var withDuration = reason === 'CANCEL' ? duration * $a4c0c313a61fc29c$var$cancelDropModifier : duration;
    return Number(withDuration.toFixed(2));
};
var $a4c0c313a61fc29c$var$getNewHomeClientOffset = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, dimensions = _ref.dimensions, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var droppableId = $a4c0c313a61fc29c$var$whatIsDraggedOver(impact);
    var destination = droppableId ? droppables[droppableId] : null;
    var home = droppables[draggable.descriptor.droppableId];
    var newClientCenter = $a4c0c313a61fc29c$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        afterCritical: afterCritical,
        droppable: destination || home,
        viewport: viewport
    });
    var offset = $a4c0c313a61fc29c$var$subtract(newClientCenter, draggable.client.borderBox.center);
    return offset;
};
var $a4c0c313a61fc29c$var$getDropImpact = function(_ref) {
    var draggables = _ref.draggables, reason = _ref.reason, lastImpact = _ref.lastImpact, home = _ref.home, viewport = _ref.viewport, onLiftImpact = _ref.onLiftImpact;
    if (!lastImpact.at || reason !== 'DROP') {
        var recomputedHomeImpact = $a4c0c313a61fc29c$var$recompute({
            draggables: draggables,
            impact: onLiftImpact,
            destination: home,
            viewport: viewport,
            forceShouldAnimate: true
        });
        return {
            impact: recomputedHomeImpact,
            didDropInsideDroppable: false
        };
    }
    if (lastImpact.at.type === 'REORDER') return {
        impact: lastImpact,
        didDropInsideDroppable: true
    };
    var withoutMovement = (0, $iyGBi.default)({}, lastImpact, {
        displaced: $a4c0c313a61fc29c$var$emptyGroups
    });
    return {
        impact: withoutMovement,
        didDropInsideDroppable: true
    };
};
var $a4c0c313a61fc29c$var$drop$1 = function(_ref) {
    var getState = _ref.getState, dispatch = _ref.dispatch;
    return function(next) {
        return function(action) {
            if (action.type !== 'DROP') {
                next(action);
                return;
            }
            var state = getState();
            var reason = action.payload.reason;
            if (state.phase === 'COLLECTING') {
                dispatch($a4c0c313a61fc29c$var$dropPending({
                    reason: reason
                }));
                return;
            }
            if (state.phase === 'IDLE') return;
            var isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
            !!isWaitingForDrop && $a4c0c313a61fc29c$var$invariant(false);
            !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && $a4c0c313a61fc29c$var$invariant(false);
            var critical = state.critical;
            var dimensions = state.dimensions;
            var draggable = dimensions.draggables[state.critical.draggable.id];
            var _getDropImpact = $a4c0c313a61fc29c$var$getDropImpact({
                reason: reason,
                lastImpact: state.impact,
                afterCritical: state.afterCritical,
                onLiftImpact: state.onLiftImpact,
                home: state.dimensions.droppables[state.critical.droppable.id],
                viewport: state.viewport,
                draggables: state.dimensions.draggables
            }), impact = _getDropImpact.impact, didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;
            var destination = didDropInsideDroppable ? $a4c0c313a61fc29c$var$tryGetDestination(impact) : null;
            var combine = didDropInsideDroppable ? $a4c0c313a61fc29c$var$tryGetCombine(impact) : null;
            var source = {
                index: critical.draggable.index,
                droppableId: critical.droppable.id
            };
            var result = {
                draggableId: draggable.descriptor.id,
                type: draggable.descriptor.type,
                source: source,
                reason: reason,
                mode: state.movementMode,
                destination: destination,
                combine: combine
            };
            var newHomeClientOffset = $a4c0c313a61fc29c$var$getNewHomeClientOffset({
                impact: impact,
                draggable: draggable,
                dimensions: dimensions,
                viewport: state.viewport,
                afterCritical: state.afterCritical
            });
            var completed = {
                critical: state.critical,
                afterCritical: state.afterCritical,
                result: result,
                impact: impact
            };
            var isAnimationRequired = !$a4c0c313a61fc29c$var$isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);
            if (!isAnimationRequired) {
                dispatch($a4c0c313a61fc29c$var$completeDrop({
                    completed: completed
                }));
                return;
            }
            var dropDuration = $a4c0c313a61fc29c$var$getDropDuration({
                current: state.current.client.offset,
                destination: newHomeClientOffset,
                reason: reason
            });
            var args = {
                newHomeClientOffset: newHomeClientOffset,
                dropDuration: dropDuration,
                completed: completed
            };
            dispatch($a4c0c313a61fc29c$var$animateDrop(args));
        };
    };
};
var $a4c0c313a61fc29c$var$getWindowScroll = function() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
function $a4c0c313a61fc29c$var$getWindowScrollBinding(update) {
    return {
        eventName: 'scroll',
        options: {
            passive: true,
            capture: false
        },
        fn: function fn(event) {
            if (event.target !== window && event.target !== window.document) return;
            update();
        }
    };
}
function $a4c0c313a61fc29c$var$getScrollListener(_ref) {
    var onWindowScroll = _ref.onWindowScroll;
    function updateScroll() {
        onWindowScroll($a4c0c313a61fc29c$var$getWindowScroll());
    }
    var scheduled = (0, $bBYr0.default)(updateScroll);
    var binding = $a4c0c313a61fc29c$var$getWindowScrollBinding(scheduled);
    var unbind = $a4c0c313a61fc29c$var$noop;
    function isActive() {
        return unbind !== $a4c0c313a61fc29c$var$noop;
    }
    function start() {
        !!isActive() && $a4c0c313a61fc29c$var$invariant(false);
        unbind = $a4c0c313a61fc29c$var$bindEvents(window, [
            binding
        ]);
    }
    function stop() {
        !isActive() && $a4c0c313a61fc29c$var$invariant(false);
        scheduled.cancel();
        unbind();
        unbind = $a4c0c313a61fc29c$var$noop;
    }
    return {
        start: start,
        stop: stop,
        isActive: isActive
    };
}
var $a4c0c313a61fc29c$var$shouldEnd = function shouldEnd(action) {
    return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};
var $a4c0c313a61fc29c$var$scrollListener = function(store) {
    var listener = $a4c0c313a61fc29c$var$getScrollListener({
        onWindowScroll: function onWindowScroll(newScroll) {
            store.dispatch($a4c0c313a61fc29c$var$moveByWindowScroll({
                newScroll: newScroll
            }));
        }
    });
    return function(next) {
        return function(action) {
            if (!listener.isActive() && action.type === 'INITIAL_PUBLISH') listener.start();
            if (listener.isActive() && $a4c0c313a61fc29c$var$shouldEnd(action)) listener.stop();
            next(action);
        };
    };
};
var $a4c0c313a61fc29c$var$getExpiringAnnounce = function(announce) {
    var wasCalled = false;
    var isExpired = false;
    var timeoutId = setTimeout(function() {
        isExpired = true;
    });
    var result = function result(message) {
        if (wasCalled) return;
        if (isExpired) return;
        wasCalled = true;
        announce(message);
        clearTimeout(timeoutId);
    };
    result.wasCalled = function() {
        return wasCalled;
    };
    return result;
};
var $a4c0c313a61fc29c$var$getAsyncMarshal = function() {
    var entries = [];
    var execute = function execute(timerId) {
        var index = $a4c0c313a61fc29c$var$findIndex(entries, function(item) {
            return item.timerId === timerId;
        });
        !(index !== -1) && $a4c0c313a61fc29c$var$invariant(false);
        var _entries$splice = entries.splice(index, 1), entry = _entries$splice[0];
        entry.callback();
    };
    var add = function add(fn) {
        var timerId = setTimeout(function() {
            return execute(timerId);
        });
        var entry = {
            timerId: timerId,
            callback: fn
        };
        entries.push(entry);
    };
    var flush = function flush() {
        if (!entries.length) return;
        var shallow = [].concat(entries);
        entries.length = 0;
        shallow.forEach(function(entry) {
            clearTimeout(entry.timerId);
            entry.callback();
        });
    };
    return {
        add: add,
        flush: flush
    };
};
var $a4c0c313a61fc29c$var$areLocationsEqual = function areLocationsEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.droppableId === second.droppableId && first.index === second.index;
};
var $a4c0c313a61fc29c$var$isCombineEqual = function isCombineEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var $a4c0c313a61fc29c$var$isCriticalEqual = function isCriticalEqual(first, second) {
    if (first === second) return true;
    var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
    var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
    return isDraggableEqual && isDroppableEqual;
};
var $a4c0c313a61fc29c$var$withTimings = function withTimings(key, fn) {
    $a4c0c313a61fc29c$var$start(key);
    fn();
    $a4c0c313a61fc29c$var$finish(key);
};
var $a4c0c313a61fc29c$var$getDragStart = function getDragStart(critical, mode) {
    return {
        draggableId: critical.draggable.id,
        type: critical.droppable.type,
        source: {
            droppableId: critical.droppable.id,
            index: critical.draggable.index
        },
        mode: mode
    };
};
var $a4c0c313a61fc29c$var$execute = function execute(responder, data, announce, getDefaultMessage) {
    if (!responder) {
        announce(getDefaultMessage(data));
        return;
    }
    var willExpire = $a4c0c313a61fc29c$var$getExpiringAnnounce(announce);
    var provided = {
        announce: willExpire
    };
    responder(data, provided);
    if (!willExpire.wasCalled()) announce(getDefaultMessage(data));
};
var $a4c0c313a61fc29c$var$getPublisher = function(getResponders, announce) {
    var asyncMarshal = $a4c0c313a61fc29c$var$getAsyncMarshal();
    var dragging = null;
    var beforeCapture = function beforeCapture(draggableId, mode) {
        !!dragging && $a4c0c313a61fc29c$var$invariant(false);
        $a4c0c313a61fc29c$var$withTimings('onBeforeCapture', function() {
            var fn = getResponders().onBeforeCapture;
            if (fn) {
                var before = {
                    draggableId: draggableId,
                    mode: mode
                };
                fn(before);
            }
        });
    };
    var beforeStart = function beforeStart(critical, mode) {
        !!dragging && $a4c0c313a61fc29c$var$invariant(false);
        $a4c0c313a61fc29c$var$withTimings('onBeforeDragStart', function() {
            var fn = getResponders().onBeforeDragStart;
            if (fn) fn($a4c0c313a61fc29c$var$getDragStart(critical, mode));
        });
    };
    var start = function start(critical, mode) {
        !!dragging && $a4c0c313a61fc29c$var$invariant(false);
        var data = $a4c0c313a61fc29c$var$getDragStart(critical, mode);
        dragging = {
            mode: mode,
            lastCritical: critical,
            lastLocation: data.source,
            lastCombine: null
        };
        asyncMarshal.add(function() {
            $a4c0c313a61fc29c$var$withTimings('onDragStart', function() {
                return $a4c0c313a61fc29c$var$execute(getResponders().onDragStart, data, announce, $a4c0c313a61fc29c$var$preset.onDragStart);
            });
        });
    };
    var update = function update(critical, impact) {
        var location = $a4c0c313a61fc29c$var$tryGetDestination(impact);
        var combine = $a4c0c313a61fc29c$var$tryGetCombine(impact);
        !dragging && $a4c0c313a61fc29c$var$invariant(false);
        var hasCriticalChanged = !$a4c0c313a61fc29c$var$isCriticalEqual(critical, dragging.lastCritical);
        if (hasCriticalChanged) dragging.lastCritical = critical;
        var hasLocationChanged = !$a4c0c313a61fc29c$var$areLocationsEqual(dragging.lastLocation, location);
        if (hasLocationChanged) dragging.lastLocation = location;
        var hasGroupingChanged = !$a4c0c313a61fc29c$var$isCombineEqual(dragging.lastCombine, combine);
        if (hasGroupingChanged) dragging.lastCombine = combine;
        if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) return;
        var data = (0, $iyGBi.default)({}, $a4c0c313a61fc29c$var$getDragStart(critical, dragging.mode), {
            combine: combine,
            destination: location
        });
        asyncMarshal.add(function() {
            $a4c0c313a61fc29c$var$withTimings('onDragUpdate', function() {
                return $a4c0c313a61fc29c$var$execute(getResponders().onDragUpdate, data, announce, $a4c0c313a61fc29c$var$preset.onDragUpdate);
            });
        });
    };
    var flush = function flush() {
        !dragging && $a4c0c313a61fc29c$var$invariant(false);
        asyncMarshal.flush();
    };
    var drop = function drop(result) {
        !dragging && $a4c0c313a61fc29c$var$invariant(false);
        dragging = null;
        $a4c0c313a61fc29c$var$withTimings('onDragEnd', function() {
            return $a4c0c313a61fc29c$var$execute(getResponders().onDragEnd, result, announce, $a4c0c313a61fc29c$var$preset.onDragEnd);
        });
    };
    var abort = function abort() {
        if (!dragging) return;
        var result = (0, $iyGBi.default)({}, $a4c0c313a61fc29c$var$getDragStart(dragging.lastCritical, dragging.mode), {
            combine: null,
            destination: null,
            reason: 'CANCEL'
        });
        drop(result);
    };
    return {
        beforeCapture: beforeCapture,
        beforeStart: beforeStart,
        start: start,
        update: update,
        flush: flush,
        drop: drop,
        abort: abort
    };
};
var $a4c0c313a61fc29c$var$responders = function(getResponders, announce) {
    var publisher = $a4c0c313a61fc29c$var$getPublisher(getResponders, announce);
    return function(store) {
        return function(next) {
            return function(action) {
                if (action.type === 'BEFORE_INITIAL_CAPTURE') {
                    publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
                    return;
                }
                if (action.type === 'INITIAL_PUBLISH') {
                    var critical = action.payload.critical;
                    publisher.beforeStart(critical, action.payload.movementMode);
                    next(action);
                    publisher.start(critical, action.payload.movementMode);
                    return;
                }
                if (action.type === 'DROP_COMPLETE') {
                    var result = action.payload.completed.result;
                    publisher.flush();
                    next(action);
                    publisher.drop(result);
                    return;
                }
                next(action);
                if (action.type === 'FLUSH') {
                    publisher.abort();
                    return;
                }
                var state = store.getState();
                if (state.phase === 'DRAGGING') publisher.update(state.critical, state.impact);
            };
        };
    };
};
var $a4c0c313a61fc29c$var$dropAnimationFinish = function(store) {
    return function(next) {
        return function(action) {
            if (action.type !== 'DROP_ANIMATION_FINISHED') {
                next(action);
                return;
            }
            var state = store.getState();
            !(state.phase === 'DROP_ANIMATING') && $a4c0c313a61fc29c$var$invariant(false);
            store.dispatch($a4c0c313a61fc29c$var$completeDrop({
                completed: state.completed
            }));
        };
    };
};
var $a4c0c313a61fc29c$var$dropAnimationFlushOnScroll = function(store) {
    var unbind = null;
    var frameId = null;
    function clear() {
        if (frameId) {
            cancelAnimationFrame(frameId);
            frameId = null;
        }
        if (unbind) {
            unbind();
            unbind = null;
        }
    }
    return function(next) {
        return function(action) {
            if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATION_FINISHED') clear();
            next(action);
            if (action.type !== 'DROP_ANIMATE') return;
            var binding = {
                eventName: 'scroll',
                options: {
                    capture: true,
                    passive: false,
                    once: true
                },
                fn: function flushDropAnimation() {
                    var state = store.getState();
                    if (state.phase === 'DROP_ANIMATING') store.dispatch($a4c0c313a61fc29c$var$dropAnimationFinished());
                }
            };
            frameId = requestAnimationFrame(function() {
                frameId = null;
                unbind = $a4c0c313a61fc29c$var$bindEvents(window, [
                    binding
                ]);
            });
        };
    };
};
var $a4c0c313a61fc29c$var$dimensionMarshalStopper = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'DROP_COMPLETE' || action.type === 'FLUSH' || action.type === 'DROP_ANIMATE') marshal.stopPublishing();
                next(action);
            };
        };
    };
};
var $a4c0c313a61fc29c$var$focus = function(marshal) {
    var isWatching = false;
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'INITIAL_PUBLISH') {
                    isWatching = true;
                    marshal.tryRecordFocus(action.payload.critical.draggable.id);
                    next(action);
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                next(action);
                if (!isWatching) return;
                if (action.type === 'FLUSH') {
                    isWatching = false;
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                if (action.type === 'DROP_COMPLETE') {
                    isWatching = false;
                    var result = action.payload.completed.result;
                    if (result.combine) marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
                    marshal.tryRestoreFocusRecorded();
                }
            };
        };
    };
};
var $a4c0c313a61fc29c$var$shouldStop = function shouldStop(action) {
    return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};
var $a4c0c313a61fc29c$var$autoScroll = function(autoScroller) {
    return function(store) {
        return function(next) {
            return function(action) {
                if ($a4c0c313a61fc29c$var$shouldStop(action)) {
                    autoScroller.stop();
                    next(action);
                    return;
                }
                if (action.type === 'INITIAL_PUBLISH') {
                    next(action);
                    var state = store.getState();
                    !(state.phase === 'DRAGGING') && $a4c0c313a61fc29c$var$invariant(false);
                    autoScroller.start(state);
                    return;
                }
                next(action);
                autoScroller.scroll(store.getState());
            };
        };
    };
};
var $a4c0c313a61fc29c$var$pendingDrop = function(store) {
    return function(next) {
        return function(action) {
            next(action);
            if (action.type !== 'PUBLISH_WHILE_DRAGGING') return;
            var postActionState = store.getState();
            if (postActionState.phase !== 'DROP_PENDING') return;
            if (postActionState.isWaiting) return;
            store.dispatch($a4c0c313a61fc29c$var$drop({
                reason: postActionState.reason
            }));
        };
    };
};
var $a4c0c313a61fc29c$var$composeEnhancers = (0, $24c1Z.compose);
var $a4c0c313a61fc29c$var$createStore = function(_ref) {
    var dimensionMarshal = _ref.dimensionMarshal, focusMarshal = _ref.focusMarshal, styleMarshal = _ref.styleMarshal, getResponders = _ref.getResponders, announce = _ref.announce, autoScroller = _ref.autoScroller;
    return (0, $24c1Z.createStore)($a4c0c313a61fc29c$var$reducer, $a4c0c313a61fc29c$var$composeEnhancers((0, $24c1Z.applyMiddleware)($a4c0c313a61fc29c$var$style(styleMarshal), $a4c0c313a61fc29c$var$dimensionMarshalStopper(dimensionMarshal), $a4c0c313a61fc29c$var$lift$1(dimensionMarshal), $a4c0c313a61fc29c$var$drop$1, $a4c0c313a61fc29c$var$dropAnimationFinish, $a4c0c313a61fc29c$var$dropAnimationFlushOnScroll, $a4c0c313a61fc29c$var$pendingDrop, $a4c0c313a61fc29c$var$autoScroll(autoScroller), $a4c0c313a61fc29c$var$scrollListener, $a4c0c313a61fc29c$var$focus(focusMarshal), $a4c0c313a61fc29c$var$responders(getResponders, announce))));
};
var $a4c0c313a61fc29c$var$clean$1 = function clean() {
    return {
        additions: {},
        removals: {},
        modified: {}
    };
};
var $a4c0c313a61fc29c$var$timingKey = 'Publish collection from DOM';
function $a4c0c313a61fc29c$var$createPublisher(_ref) {
    var registry = _ref.registry, callbacks = _ref.callbacks;
    var staging = $a4c0c313a61fc29c$var$clean$1();
    var frameId = null;
    var collect = function collect() {
        if (frameId) return;
        callbacks.collectionStarting();
        frameId = requestAnimationFrame(function() {
            frameId = null;
            $a4c0c313a61fc29c$var$start($a4c0c313a61fc29c$var$timingKey);
            var _staging = staging, additions = _staging.additions, removals = _staging.removals, modified = _staging.modified;
            var added = (0, (/*@__PURE__*/$parcel$interopDefault($dAFDe)))(additions).map(function(id) {
                return registry.draggable.getById(id).getDimension($a4c0c313a61fc29c$var$origin);
            }).sort(function(a, b) {
                return a.descriptor.index - b.descriptor.index;
            });
            var updated = (0, (/*@__PURE__*/$parcel$interopDefault($dAFDe)))(modified).map(function(id) {
                var entry = registry.droppable.getById(id);
                var scroll = entry.callbacks.getScrollWhileDragging();
                return {
                    droppableId: id,
                    scroll: scroll
                };
            });
            var result = {
                additions: added,
                removals: (0, (/*@__PURE__*/$parcel$interopDefault($dAFDe)))(removals),
                modified: updated
            };
            staging = $a4c0c313a61fc29c$var$clean$1();
            $a4c0c313a61fc29c$var$finish($a4c0c313a61fc29c$var$timingKey);
            callbacks.publish(result);
        });
    };
    var add = function add(entry) {
        var id = entry.descriptor.id;
        staging.additions[id] = entry;
        staging.modified[entry.descriptor.droppableId] = true;
        if (staging.removals[id]) delete staging.removals[id];
        collect();
    };
    var remove = function remove(entry) {
        var descriptor = entry.descriptor;
        staging.removals[descriptor.id] = true;
        staging.modified[descriptor.droppableId] = true;
        if (staging.additions[descriptor.id]) delete staging.additions[descriptor.id];
        collect();
    };
    var stop = function stop() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
        staging = $a4c0c313a61fc29c$var$clean$1();
    };
    return {
        add: add,
        remove: remove,
        stop: stop
    };
}
var $a4c0c313a61fc29c$var$getMaxScroll = function(_ref) {
    var scrollHeight = _ref.scrollHeight, scrollWidth = _ref.scrollWidth, height = _ref.height, width = _ref.width;
    var maxScroll = $a4c0c313a61fc29c$var$subtract({
        x: scrollWidth,
        y: scrollHeight
    }, {
        x: width,
        y: height
    });
    var adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};
var $a4c0c313a61fc29c$var$getDocumentElement = function() {
    var doc = document.documentElement;
    !doc && $a4c0c313a61fc29c$var$invariant(false);
    return doc;
};
var $a4c0c313a61fc29c$var$getMaxWindowScroll = function() {
    var doc = $a4c0c313a61fc29c$var$getDocumentElement();
    var maxScroll = $a4c0c313a61fc29c$var$getMaxScroll({
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};
var $a4c0c313a61fc29c$var$getViewport = function() {
    var scroll = $a4c0c313a61fc29c$var$getWindowScroll();
    var maxScroll = $a4c0c313a61fc29c$var$getMaxWindowScroll();
    var top = scroll.y;
    var left = scroll.x;
    var doc = $a4c0c313a61fc29c$var$getDocumentElement();
    var width = doc.clientWidth;
    var height = doc.clientHeight;
    var right = left + width;
    var bottom = top + height;
    var frame = (0, $ixGZi.getRect)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    var viewport = {
        frame: frame,
        scroll: {
            initial: scroll,
            current: scroll,
            max: maxScroll,
            diff: {
                value: $a4c0c313a61fc29c$var$origin,
                displacement: $a4c0c313a61fc29c$var$origin
            }
        }
    };
    return viewport;
};
var $a4c0c313a61fc29c$var$getInitialPublish = function(_ref) {
    var critical = _ref.critical, scrollOptions = _ref.scrollOptions, registry = _ref.registry;
    var timingKey = 'Initial collection from DOM';
    $a4c0c313a61fc29c$var$start(timingKey);
    var viewport = $a4c0c313a61fc29c$var$getViewport();
    var windowScroll = viewport.scroll.current;
    var home = critical.droppable;
    var droppables = registry.droppable.getAllByType(home.type).map(function(entry) {
        return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
    });
    var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function(entry) {
        return entry.getDimension(windowScroll);
    });
    var dimensions = {
        draggables: $a4c0c313a61fc29c$var$toDraggableMap(draggables),
        droppables: $a4c0c313a61fc29c$var$toDroppableMap(droppables)
    };
    $a4c0c313a61fc29c$var$finish(timingKey);
    var result = {
        dimensions: dimensions,
        critical: critical,
        viewport: viewport
    };
    return result;
};
function $a4c0c313a61fc29c$var$shouldPublishUpdate(registry, dragging, entry) {
    if (entry.descriptor.id === dragging.id) return false;
    if (entry.descriptor.type !== dragging.type) return false;
    var home = registry.droppable.getById(entry.descriptor.droppableId);
    if (home.descriptor.mode !== 'virtual') return false;
    return true;
}
var $a4c0c313a61fc29c$var$createDimensionMarshal = function(registry, callbacks) {
    var collection = null;
    var publisher = $a4c0c313a61fc29c$var$createPublisher({
        callbacks: {
            publish: callbacks.publishWhileDragging,
            collectionStarting: callbacks.collectionStarting
        },
        registry: registry
    });
    var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
        !registry.droppable.exists(id) && $a4c0c313a61fc29c$var$invariant(false);
        if (!collection) return;
        callbacks.updateDroppableIsEnabled({
            id: id,
            isEnabled: isEnabled
        });
    };
    var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
        if (!collection) return;
        !registry.droppable.exists(id) && $a4c0c313a61fc29c$var$invariant(false);
        callbacks.updateDroppableIsCombineEnabled({
            id: id,
            isCombineEnabled: isCombineEnabled
        });
    };
    var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
        if (!collection) return;
        !registry.droppable.exists(id) && $a4c0c313a61fc29c$var$invariant(false);
        callbacks.updateDroppableScroll({
            id: id,
            newScroll: newScroll
        });
    };
    var scrollDroppable = function scrollDroppable(id, change) {
        if (!collection) return;
        registry.droppable.getById(id).callbacks.scroll(change);
    };
    var stopPublishing = function stopPublishing() {
        if (!collection) return;
        publisher.stop();
        var home = collection.critical.droppable;
        registry.droppable.getAllByType(home.type).forEach(function(entry) {
            return entry.callbacks.dragStopped();
        });
        collection.unsubscribe();
        collection = null;
    };
    var subscriber = function subscriber(event) {
        !collection && $a4c0c313a61fc29c$var$invariant(false);
        var dragging = collection.critical.draggable;
        if (event.type === 'ADDITION') {
            if ($a4c0c313a61fc29c$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.add(event.value);
        }
        if (event.type === 'REMOVAL') {
            if ($a4c0c313a61fc29c$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.remove(event.value);
        }
    };
    var startPublishing = function startPublishing(request) {
        !!collection && $a4c0c313a61fc29c$var$invariant(false);
        var entry = registry.draggable.getById(request.draggableId);
        var home = registry.droppable.getById(entry.descriptor.droppableId);
        var critical = {
            draggable: entry.descriptor,
            droppable: home.descriptor
        };
        var unsubscribe = registry.subscribe(subscriber);
        collection = {
            critical: critical,
            unsubscribe: unsubscribe
        };
        return $a4c0c313a61fc29c$var$getInitialPublish({
            critical: critical,
            registry: registry,
            scrollOptions: request.scrollOptions
        });
    };
    var marshal = {
        updateDroppableIsEnabled: updateDroppableIsEnabled,
        updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
        scrollDroppable: scrollDroppable,
        updateDroppableScroll: updateDroppableScroll,
        startPublishing: startPublishing,
        stopPublishing: stopPublishing
    };
    return marshal;
};
var $a4c0c313a61fc29c$var$canStartDrag = function(state, id) {
    if (state.phase === 'IDLE') return true;
    if (state.phase !== 'DROP_ANIMATING') return false;
    if (state.completed.result.draggableId === id) return false;
    return state.completed.result.reason === 'DROP';
};
var $a4c0c313a61fc29c$var$scrollWindow = function(change) {
    window.scrollBy(change.x, change.y);
};
var $a4c0c313a61fc29c$var$getScrollableDroppables = (0, $gj4eS.default)(function(droppables) {
    return $a4c0c313a61fc29c$var$toDroppableList(droppables).filter(function(droppable) {
        if (!droppable.isEnabled) return false;
        if (!droppable.frame) return false;
        return true;
    });
});
var $a4c0c313a61fc29c$var$getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
    var maybe = $a4c0c313a61fc29c$var$find($a4c0c313a61fc29c$var$getScrollableDroppables(droppables), function(droppable) {
        !droppable.frame && $a4c0c313a61fc29c$var$invariant(false);
        return $a4c0c313a61fc29c$var$isPositionInFrame(droppable.frame.pageMarginBox)(target);
    });
    return maybe;
};
var $a4c0c313a61fc29c$var$getBestScrollableDroppable = function(_ref) {
    var center = _ref.center, destination = _ref.destination, droppables = _ref.droppables;
    if (destination) {
        var _dimension = droppables[destination];
        if (!_dimension.frame) return null;
        return _dimension;
    }
    var dimension = $a4c0c313a61fc29c$var$getScrollableDroppableOver(center, droppables);
    return dimension;
};
var $a4c0c313a61fc29c$var$config = {
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    maxPixelScroll: 28,
    ease: function ease(percentage) {
        return Math.pow(percentage, 2);
    },
    durationDampening: {
        stopDampeningAt: 1200,
        accelerateAt: 360
    }
};
var $a4c0c313a61fc29c$var$getDistanceThresholds = function(container, axis) {
    var startScrollingFrom = container[axis.size] * $a4c0c313a61fc29c$var$config.startFromPercentage;
    var maxScrollValueAt = container[axis.size] * $a4c0c313a61fc29c$var$config.maxScrollAtPercentage;
    var thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var $a4c0c313a61fc29c$var$getPercentage = function(_ref) {
    var startOfRange = _ref.startOfRange, endOfRange = _ref.endOfRange, current = _ref.current;
    var range = endOfRange - startOfRange;
    if (range === 0) return 0;
    var currentInRange = current - startOfRange;
    var percentage = currentInRange / range;
    return percentage;
};
var $a4c0c313a61fc29c$var$minScroll = 1;
var $a4c0c313a61fc29c$var$getValueFromDistance = function(distanceToEdge, thresholds) {
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    if (distanceToEdge <= thresholds.maxScrollValueAt) return $a4c0c313a61fc29c$var$config.maxPixelScroll;
    if (distanceToEdge === thresholds.startScrollingFrom) return $a4c0c313a61fc29c$var$minScroll;
    var percentageFromMaxScrollValueAt = $a4c0c313a61fc29c$var$getPercentage({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    var scroll = $a4c0c313a61fc29c$var$config.maxPixelScroll * $a4c0c313a61fc29c$var$config.ease(percentageFromStartScrollingFrom);
    return Math.ceil(scroll);
};
var $a4c0c313a61fc29c$var$accelerateAt = $a4c0c313a61fc29c$var$config.durationDampening.accelerateAt;
var $a4c0c313a61fc29c$var$stopAt = $a4c0c313a61fc29c$var$config.durationDampening.stopDampeningAt;
var $a4c0c313a61fc29c$var$dampenValueByTime = function(proposedScroll, dragStartTime) {
    var startOfRange = dragStartTime;
    var endOfRange = $a4c0c313a61fc29c$var$stopAt;
    var now = (0, (/*@__PURE__*/$parcel$interopDefault($digWO)))();
    var runTime = now - startOfRange;
    if (runTime >= $a4c0c313a61fc29c$var$stopAt) return proposedScroll;
    if (runTime < $a4c0c313a61fc29c$var$accelerateAt) return $a4c0c313a61fc29c$var$minScroll;
    var betweenAccelerateAtAndStopAtPercentage = $a4c0c313a61fc29c$var$getPercentage({
        startOfRange: $a4c0c313a61fc29c$var$accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    var scroll = proposedScroll * $a4c0c313a61fc29c$var$config.ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};
var $a4c0c313a61fc29c$var$getValue = function(_ref) {
    var distanceToEdge = _ref.distanceToEdge, thresholds = _ref.thresholds, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $a4c0c313a61fc29c$var$getValueFromDistance(distanceToEdge, thresholds);
    if (scroll === 0) return 0;
    if (!shouldUseTimeDampening) return scroll;
    return Math.max($a4c0c313a61fc29c$var$dampenValueByTime(scroll, dragStartTime), $a4c0c313a61fc29c$var$minScroll);
};
var $a4c0c313a61fc29c$var$getScrollOnAxis = function(_ref) {
    var container = _ref.container, distanceToEdges = _ref.distanceToEdges, dragStartTime = _ref.dragStartTime, axis = _ref.axis, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var thresholds = $a4c0c313a61fc29c$var$getDistanceThresholds(container, axis);
    var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return $a4c0c313a61fc29c$var$getValue({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return -1 * $a4c0c313a61fc29c$var$getValue({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
};
var $a4c0c313a61fc29c$var$adjustForSizeLimits = function(_ref) {
    var container = _ref.container, subject = _ref.subject, proposedScroll = _ref.proposedScroll;
    var isTooBigVertically = subject.height > container.height;
    var isTooBigHorizontally = subject.width > container.width;
    if (!isTooBigHorizontally && !isTooBigVertically) return proposedScroll;
    if (isTooBigHorizontally && isTooBigVertically) return null;
    return {
        x: isTooBigHorizontally ? 0 : proposedScroll.x,
        y: isTooBigVertically ? 0 : proposedScroll.y
    };
};
var $a4c0c313a61fc29c$var$clean$2 = $a4c0c313a61fc29c$var$apply(function(value) {
    return value === 0 ? 0 : value;
});
var $a4c0c313a61fc29c$var$getScroll = function(_ref) {
    var dragStartTime = _ref.dragStartTime, container = _ref.container, subject = _ref.subject, center = _ref.center, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    var y = $a4c0c313a61fc29c$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $a4c0c313a61fc29c$var$vertical,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var x = $a4c0c313a61fc29c$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $a4c0c313a61fc29c$var$horizontal,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var required = $a4c0c313a61fc29c$var$clean$2({
        x: x,
        y: y
    });
    if ($a4c0c313a61fc29c$var$isEqual(required, $a4c0c313a61fc29c$var$origin)) return null;
    var limited = $a4c0c313a61fc29c$var$adjustForSizeLimits({
        container: container,
        subject: subject,
        proposedScroll: required
    });
    if (!limited) return null;
    return $a4c0c313a61fc29c$var$isEqual(limited, $a4c0c313a61fc29c$var$origin) ? null : limited;
};
var $a4c0c313a61fc29c$var$smallestSigned = $a4c0c313a61fc29c$var$apply(function(value) {
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
var $a4c0c313a61fc29c$var$getOverlap = function() {
    var getRemainder = function getRemainder(target, max) {
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return function(_ref) {
        var current = _ref.current, max = _ref.max, change = _ref.change;
        var targetScroll = $a4c0c313a61fc29c$var$add(current, change);
        var overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if ($a4c0c313a61fc29c$var$isEqual(overlap, $a4c0c313a61fc29c$var$origin)) return null;
        return overlap;
    };
}();
var $a4c0c313a61fc29c$var$canPartiallyScroll = function canPartiallyScroll(_ref2) {
    var rawMax = _ref2.max, current = _ref2.current, change = _ref2.change;
    var max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    var smallestChange = $a4c0c313a61fc29c$var$smallestSigned(change);
    var overlap = $a4c0c313a61fc29c$var$getOverlap({
        max: max,
        current: current,
        change: smallestChange
    });
    if (!overlap) return true;
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
var $a4c0c313a61fc29c$var$canScrollWindow = function canScrollWindow(viewport, change) {
    return $a4c0c313a61fc29c$var$canPartiallyScroll({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
};
var $a4c0c313a61fc29c$var$getWindowOverlap = function getWindowOverlap(viewport, change) {
    if (!$a4c0c313a61fc29c$var$canScrollWindow(viewport, change)) return null;
    var max = viewport.scroll.max;
    var current = viewport.scroll.current;
    return $a4c0c313a61fc29c$var$getOverlap({
        current: current,
        max: max,
        change: change
    });
};
var $a4c0c313a61fc29c$var$canScrollDroppable = function canScrollDroppable(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return false;
    return $a4c0c313a61fc29c$var$canPartiallyScroll({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $a4c0c313a61fc29c$var$getDroppableOverlap = function getDroppableOverlap(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return null;
    if (!$a4c0c313a61fc29c$var$canScrollDroppable(droppable, change)) return null;
    return $a4c0c313a61fc29c$var$getOverlap({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $a4c0c313a61fc29c$var$getWindowScrollChange = function(_ref) {
    var viewport = _ref.viewport, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $a4c0c313a61fc29c$var$getScroll({
        dragStartTime: dragStartTime,
        container: viewport.frame,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $a4c0c313a61fc29c$var$canScrollWindow(viewport, scroll) ? scroll : null;
};
var $a4c0c313a61fc29c$var$getDroppableScrollChange = function(_ref) {
    var droppable = _ref.droppable, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var frame = droppable.frame;
    if (!frame) return null;
    var scroll = $a4c0c313a61fc29c$var$getScroll({
        dragStartTime: dragStartTime,
        container: frame.pageMarginBox,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $a4c0c313a61fc29c$var$canScrollDroppable(droppable, scroll) ? scroll : null;
};
var $a4c0c313a61fc29c$var$scroll$1 = function(_ref) {
    var state = _ref.state, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening, scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var center = state.current.page.borderBoxCenter;
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var subject = draggable.page.marginBox;
    if (state.isWindowScrollAllowed) {
        var viewport = state.viewport;
        var _change = $a4c0c313a61fc29c$var$getWindowScrollChange({
            dragStartTime: dragStartTime,
            viewport: viewport,
            subject: subject,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (_change) {
            scrollWindow(_change);
            return;
        }
    }
    var droppable = $a4c0c313a61fc29c$var$getBestScrollableDroppable({
        center: center,
        destination: $a4c0c313a61fc29c$var$whatIsDraggedOver(state.impact),
        droppables: state.dimensions.droppables
    });
    if (!droppable) return;
    var change = $a4c0c313a61fc29c$var$getDroppableScrollChange({
        dragStartTime: dragStartTime,
        droppable: droppable,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    if (change) scrollDroppable(droppable.descriptor.id, change);
};
var $a4c0c313a61fc29c$var$createFluidScroller = function(_ref) {
    var scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var scheduleWindowScroll = (0, $bBYr0.default)(scrollWindow);
    var scheduleDroppableScroll = (0, $bBYr0.default)(scrollDroppable);
    var dragging = null;
    var tryScroll = function tryScroll(state) {
        !dragging && $a4c0c313a61fc29c$var$invariant(false);
        var _dragging = dragging, shouldUseTimeDampening = _dragging.shouldUseTimeDampening, dragStartTime = _dragging.dragStartTime;
        $a4c0c313a61fc29c$var$scroll$1({
            state: state,
            scrollWindow: scheduleWindowScroll,
            scrollDroppable: scheduleDroppableScroll,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
    };
    var start$1 = function start$1(state) {
        $a4c0c313a61fc29c$var$start('starting fluid scroller');
        !!dragging && $a4c0c313a61fc29c$var$invariant(false);
        var dragStartTime = (0, (/*@__PURE__*/$parcel$interopDefault($digWO)))();
        var wasScrollNeeded = false;
        var fakeScrollCallback = function fakeScrollCallback() {
            wasScrollNeeded = true;
        };
        $a4c0c313a61fc29c$var$scroll$1({
            state: state,
            dragStartTime: 0,
            shouldUseTimeDampening: false,
            scrollWindow: fakeScrollCallback,
            scrollDroppable: fakeScrollCallback
        });
        dragging = {
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: wasScrollNeeded
        };
        $a4c0c313a61fc29c$var$finish('starting fluid scroller');
        if (wasScrollNeeded) tryScroll(state);
    };
    var stop = function stop() {
        if (!dragging) return;
        scheduleWindowScroll.cancel();
        scheduleDroppableScroll.cancel();
        dragging = null;
    };
    return {
        start: start$1,
        stop: stop,
        scroll: tryScroll
    };
};
var $a4c0c313a61fc29c$var$createJumpScroller = function(_ref) {
    var move = _ref.move, scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow;
    var moveByOffset = function moveByOffset(state, offset) {
        var client = $a4c0c313a61fc29c$var$add(state.current.client.selection, offset);
        move({
            client: client
        });
    };
    var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
        if (!$a4c0c313a61fc29c$var$canScrollDroppable(droppable, change)) return change;
        var overlap = $a4c0c313a61fc29c$var$getDroppableOverlap(droppable, change);
        if (!overlap) {
            scrollDroppable(droppable.descriptor.id, change);
            return null;
        }
        var whatTheDroppableCanScroll = $a4c0c313a61fc29c$var$subtract(change, overlap);
        scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
        var remainder = $a4c0c313a61fc29c$var$subtract(change, whatTheDroppableCanScroll);
        return remainder;
    };
    var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
        if (!isWindowScrollAllowed) return change;
        if (!$a4c0c313a61fc29c$var$canScrollWindow(viewport, change)) return change;
        var overlap = $a4c0c313a61fc29c$var$getWindowOverlap(viewport, change);
        if (!overlap) {
            scrollWindow(change);
            return null;
        }
        var whatTheWindowCanScroll = $a4c0c313a61fc29c$var$subtract(change, overlap);
        scrollWindow(whatTheWindowCanScroll);
        var remainder = $a4c0c313a61fc29c$var$subtract(change, whatTheWindowCanScroll);
        return remainder;
    };
    var jumpScroller = function jumpScroller(state) {
        var request = state.scrollJumpRequest;
        if (!request) return;
        var destination = $a4c0c313a61fc29c$var$whatIsDraggedOver(state.impact);
        !destination && $a4c0c313a61fc29c$var$invariant(false);
        var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);
        if (!droppableRemainder) return;
        var viewport = state.viewport;
        var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);
        if (!windowRemainder) return;
        moveByOffset(state, windowRemainder);
    };
    return jumpScroller;
};
var $a4c0c313a61fc29c$var$createAutoScroller = function(_ref) {
    var scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow, move = _ref.move;
    var fluidScroller = $a4c0c313a61fc29c$var$createFluidScroller({
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var jumpScroll = $a4c0c313a61fc29c$var$createJumpScroller({
        move: move,
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var scroll = function scroll(state) {
        if (state.phase !== 'DRAGGING') return;
        if (state.movementMode === 'FLUID') {
            fluidScroller.scroll(state);
            return;
        }
        if (!state.scrollJumpRequest) return;
        jumpScroll(state);
    };
    var scroller = {
        scroll: scroll,
        start: fluidScroller.start,
        stop: fluidScroller.stop
    };
    return scroller;
};
var $a4c0c313a61fc29c$var$prefix$1 = 'data-rbd';
var $a4c0c313a61fc29c$var$dragHandle = function() {
    var base = $a4c0c313a61fc29c$var$prefix$1 + "-drag-handle";
    return {
        base: base,
        draggableId: base + "-draggable-id",
        contextId: base + "-context-id"
    };
}();
var $a4c0c313a61fc29c$var$draggable = function() {
    var base = $a4c0c313a61fc29c$var$prefix$1 + "-draggable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $a4c0c313a61fc29c$var$droppable = function() {
    var base = $a4c0c313a61fc29c$var$prefix$1 + "-droppable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $a4c0c313a61fc29c$var$scrollContainer = {
    contextId: $a4c0c313a61fc29c$var$prefix$1 + "-scroll-container-context-id"
};
var $a4c0c313a61fc29c$var$makeGetSelector = function makeGetSelector(context) {
    return function(attribute) {
        return "[" + attribute + "=\"" + context + "\"]";
    };
};
var $a4c0c313a61fc29c$var$getStyles = function getStyles(rules, property) {
    return rules.map(function(rule) {
        var value = rule.styles[property];
        if (!value) return '';
        return rule.selector + " { " + value + " }";
    }).join(' ');
};
var $a4c0c313a61fc29c$var$noPointerEvents = 'pointer-events: none;';
var $a4c0c313a61fc29c$var$getStyles$1 = function(contextId) {
    var getSelector = $a4c0c313a61fc29c$var$makeGetSelector(contextId);
    var dragHandle$1 = function() {
        var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
        return {
            selector: getSelector($a4c0c313a61fc29c$var$dragHandle.contextId),
            styles: {
                always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
                resting: grabCursor,
                dragging: $a4c0c313a61fc29c$var$noPointerEvents,
                dropAnimating: grabCursor
            }
        };
    }();
    var draggable$1 = function() {
        var transition = "\n      transition: " + $a4c0c313a61fc29c$var$transitions.outOfTheWay + ";\n    ";
        return {
            selector: getSelector($a4c0c313a61fc29c$var$draggable.contextId),
            styles: {
                dragging: transition,
                dropAnimating: transition,
                userCancel: transition
            }
        };
    }();
    var droppable$1 = {
        selector: getSelector($a4c0c313a61fc29c$var$droppable.contextId),
        styles: {
            always: "overflow-anchor: none;"
        }
    };
    var body = {
        selector: 'body',
        styles: {
            dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
        }
    };
    var rules = [
        draggable$1,
        dragHandle$1,
        droppable$1,
        body
    ];
    return {
        always: $a4c0c313a61fc29c$var$getStyles(rules, 'always'),
        resting: $a4c0c313a61fc29c$var$getStyles(rules, 'resting'),
        dragging: $a4c0c313a61fc29c$var$getStyles(rules, 'dragging'),
        dropAnimating: $a4c0c313a61fc29c$var$getStyles(rules, 'dropAnimating'),
        userCancel: $a4c0c313a61fc29c$var$getStyles(rules, 'userCancel')
    };
};
var $a4c0c313a61fc29c$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $eJOHy.useLayoutEffect) : (0, $eJOHy.useEffect);
var $a4c0c313a61fc29c$var$getHead = function getHead() {
    var head = document.querySelector('head');
    !head && $a4c0c313a61fc29c$var$invariant(false);
    return head;
};
var $a4c0c313a61fc29c$var$createStyleEl = function createStyleEl(nonce) {
    var el = document.createElement('style');
    if (nonce) el.setAttribute('nonce', nonce);
    el.type = 'text/css';
    return el;
};
function $a4c0c313a61fc29c$var$useStyleMarshal(contextId, nonce) {
    var styles = (0, $7pA0u.useMemo)(function() {
        return $a4c0c313a61fc29c$var$getStyles$1(contextId);
    }, [
        contextId
    ]);
    var alwaysRef = (0, $eJOHy.useRef)(null);
    var dynamicRef = (0, $eJOHy.useRef)(null);
    var setDynamicStyle = (0, $7pA0u.useCallback)((0, $gj4eS.default)(function(proposed) {
        var el = dynamicRef.current;
        !el && $a4c0c313a61fc29c$var$invariant(false);
        el.textContent = proposed;
    }), []);
    var setAlwaysStyle = (0, $7pA0u.useCallback)(function(proposed) {
        var el = alwaysRef.current;
        !el && $a4c0c313a61fc29c$var$invariant(false);
        el.textContent = proposed;
    }, []);
    $a4c0c313a61fc29c$var$useIsomorphicLayoutEffect(function() {
        !(!alwaysRef.current && !dynamicRef.current) && $a4c0c313a61fc29c$var$invariant(false);
        var always = $a4c0c313a61fc29c$var$createStyleEl(nonce);
        var dynamic = $a4c0c313a61fc29c$var$createStyleEl(nonce);
        alwaysRef.current = always;
        dynamicRef.current = dynamic;
        always.setAttribute($a4c0c313a61fc29c$var$prefix$1 + "-always", contextId);
        dynamic.setAttribute($a4c0c313a61fc29c$var$prefix$1 + "-dynamic", contextId);
        $a4c0c313a61fc29c$var$getHead().appendChild(always);
        $a4c0c313a61fc29c$var$getHead().appendChild(dynamic);
        setAlwaysStyle(styles.always);
        setDynamicStyle(styles.resting);
        return function() {
            var remove = function remove(ref) {
                var current = ref.current;
                !current && $a4c0c313a61fc29c$var$invariant(false);
                $a4c0c313a61fc29c$var$getHead().removeChild(current);
                ref.current = null;
            };
            remove(alwaysRef);
            remove(dynamicRef);
        };
    }, [
        nonce,
        setAlwaysStyle,
        setDynamicStyle,
        styles.always,
        styles.resting,
        contextId
    ]);
    var dragging = (0, $7pA0u.useCallback)(function() {
        return setDynamicStyle(styles.dragging);
    }, [
        setDynamicStyle,
        styles.dragging
    ]);
    var dropping = (0, $7pA0u.useCallback)(function(reason) {
        if (reason === 'DROP') {
            setDynamicStyle(styles.dropAnimating);
            return;
        }
        setDynamicStyle(styles.userCancel);
    }, [
        setDynamicStyle,
        styles.dropAnimating,
        styles.userCancel
    ]);
    var resting = (0, $7pA0u.useCallback)(function() {
        if (!dynamicRef.current) return;
        setDynamicStyle(styles.resting);
    }, [
        setDynamicStyle,
        styles.resting
    ]);
    var marshal = (0, $7pA0u.useMemo)(function() {
        return {
            dragging: dragging,
            dropping: dropping,
            resting: resting
        };
    }, [
        dragging,
        dropping,
        resting
    ]);
    return marshal;
}
var $a4c0c313a61fc29c$var$getWindowFromEl = function(el) {
    return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
};
function $a4c0c313a61fc29c$var$isHtmlElement(el) {
    return el instanceof $a4c0c313a61fc29c$var$getWindowFromEl(el).HTMLElement;
}
function $a4c0c313a61fc29c$var$findDragHandle(contextId, draggableId) {
    var selector = "[" + $a4c0c313a61fc29c$var$dragHandle.contextId + "=\"" + contextId + "\"]";
    var possible = $a4c0c313a61fc29c$var$toArray(document.querySelectorAll(selector));
    if (!possible.length) return null;
    var handle = $a4c0c313a61fc29c$var$find(possible, function(el) {
        return el.getAttribute($a4c0c313a61fc29c$var$dragHandle.draggableId) === draggableId;
    });
    if (!handle) return null;
    if (!$a4c0c313a61fc29c$var$isHtmlElement(handle)) return null;
    return handle;
}
function $a4c0c313a61fc29c$var$useFocusMarshal(contextId) {
    var entriesRef = (0, $eJOHy.useRef)({});
    var recordRef = (0, $eJOHy.useRef)(null);
    var restoreFocusFrameRef = (0, $eJOHy.useRef)(null);
    var isMountedRef = (0, $eJOHy.useRef)(false);
    var register = (0, $7pA0u.useCallback)(function register(id, focus) {
        var entry = {
            id: id,
            focus: focus
        };
        entriesRef.current[id] = entry;
        return function unregister() {
            var entries = entriesRef.current;
            var current = entries[id];
            if (current !== entry) delete entries[id];
        };
    }, []);
    var tryGiveFocus = (0, $7pA0u.useCallback)(function tryGiveFocus(tryGiveFocusTo) {
        var handle = $a4c0c313a61fc29c$var$findDragHandle(contextId, tryGiveFocusTo);
        if (handle && handle !== document.activeElement) handle.focus();
    }, [
        contextId
    ]);
    var tryShiftRecord = (0, $7pA0u.useCallback)(function tryShiftRecord(previous, redirectTo) {
        if (recordRef.current === previous) recordRef.current = redirectTo;
    }, []);
    var tryRestoreFocusRecorded = (0, $7pA0u.useCallback)(function tryRestoreFocusRecorded() {
        if (restoreFocusFrameRef.current) return;
        if (!isMountedRef.current) return;
        restoreFocusFrameRef.current = requestAnimationFrame(function() {
            restoreFocusFrameRef.current = null;
            var record = recordRef.current;
            if (record) tryGiveFocus(record);
        });
    }, [
        tryGiveFocus
    ]);
    var tryRecordFocus = (0, $7pA0u.useCallback)(function tryRecordFocus(id) {
        recordRef.current = null;
        var focused = document.activeElement;
        if (!focused) return;
        if (focused.getAttribute($a4c0c313a61fc29c$var$dragHandle.draggableId) !== id) return;
        recordRef.current = id;
    }, []);
    $a4c0c313a61fc29c$var$useIsomorphicLayoutEffect(function() {
        isMountedRef.current = true;
        return function clearFrameOnUnmount() {
            isMountedRef.current = false;
            var frameId = restoreFocusFrameRef.current;
            if (frameId) cancelAnimationFrame(frameId);
        };
    }, []);
    var marshal = (0, $7pA0u.useMemo)(function() {
        return {
            register: register,
            tryRecordFocus: tryRecordFocus,
            tryRestoreFocusRecorded: tryRestoreFocusRecorded,
            tryShiftRecord: tryShiftRecord
        };
    }, [
        register,
        tryRecordFocus,
        tryRestoreFocusRecorded,
        tryShiftRecord
    ]);
    return marshal;
}
function $a4c0c313a61fc29c$var$createRegistry() {
    var entries = {
        draggables: {},
        droppables: {}
    };
    var subscribers = [];
    function subscribe(cb) {
        subscribers.push(cb);
        return function unsubscribe() {
            var index = subscribers.indexOf(cb);
            if (index === -1) return;
            subscribers.splice(index, 1);
        };
    }
    function notify(event) {
        if (subscribers.length) subscribers.forEach(function(cb) {
            return cb(event);
        });
    }
    function findDraggableById(id) {
        return entries.draggables[id] || null;
    }
    function getDraggableById(id) {
        var entry = findDraggableById(id);
        !entry && $a4c0c313a61fc29c$var$invariant(false);
        return entry;
    }
    var draggableAPI = {
        register: function register(entry) {
            entries.draggables[entry.descriptor.id] = entry;
            notify({
                type: 'ADDITION',
                value: entry
            });
        },
        update: function update(entry, last) {
            var current = entries.draggables[last.descriptor.id];
            if (!current) return;
            if (current.uniqueId !== entry.uniqueId) return;
            delete entries.draggables[last.descriptor.id];
            entries.draggables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var draggableId = entry.descriptor.id;
            var current = findDraggableById(draggableId);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.draggables[draggableId];
            notify({
                type: 'REMOVAL',
                value: entry
            });
        },
        getById: getDraggableById,
        findById: findDraggableById,
        exists: function exists(id) {
            return Boolean(findDraggableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $a4c0c313a61fc29c$var$values(entries.draggables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function findDroppableById(id) {
        return entries.droppables[id] || null;
    }
    function getDroppableById(id) {
        var entry = findDroppableById(id);
        !entry && $a4c0c313a61fc29c$var$invariant(false);
        return entry;
    }
    var droppableAPI = {
        register: function register(entry) {
            entries.droppables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var current = findDroppableById(entry.descriptor.id);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.droppables[entry.descriptor.id];
        },
        getById: getDroppableById,
        findById: findDroppableById,
        exists: function exists(id) {
            return Boolean(findDroppableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $a4c0c313a61fc29c$var$values(entries.droppables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function clean() {
        entries.draggables = {};
        entries.droppables = {};
        subscribers.length = 0;
    }
    return {
        draggable: draggableAPI,
        droppable: droppableAPI,
        subscribe: subscribe,
        clean: clean
    };
}
function $a4c0c313a61fc29c$var$useRegistry() {
    var registry = (0, $7pA0u.useMemo)($a4c0c313a61fc29c$var$createRegistry, []);
    (0, $eJOHy.useEffect)(function() {
        return function unmount() {
            requestAnimationFrame(registry.clean);
        };
    }, [
        registry
    ]);
    return registry;
}
var $a4c0c313a61fc29c$var$StoreContext = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(null);
var $a4c0c313a61fc29c$var$getBodyElement = function() {
    var body = document.body;
    !body && $a4c0c313a61fc29c$var$invariant(false);
    return body;
};
var $a4c0c313a61fc29c$var$visuallyHidden = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    margin: '-1px',
    border: '0',
    padding: '0',
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    'clip-path': 'inset(100%)'
};
var $a4c0c313a61fc29c$var$getId = function getId(contextId) {
    return "rbd-announcement-" + contextId;
};
function $a4c0c313a61fc29c$var$useAnnouncer(contextId) {
    var id = (0, $7pA0u.useMemo)(function() {
        return $a4c0c313a61fc29c$var$getId(contextId);
    }, [
        contextId
    ]);
    var ref = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(function setup() {
        var el = document.createElement('div');
        ref.current = el;
        el.id = id;
        el.setAttribute('aria-live', 'assertive');
        el.setAttribute('role', 'log');
        el.setAttribute('aria-atomic', 'true');
        (0, (/*@__PURE__*/$parcel$interopDefault($lQkst)))(el.style, $a4c0c313a61fc29c$var$visuallyHidden);
        $a4c0c313a61fc29c$var$getBodyElement().appendChild(el);
        return function cleanup() {
            setTimeout(function remove() {
                $a4c0c313a61fc29c$var$getBodyElement().removeChild(el);
                if (el === ref.current) ref.current = null;
            });
        };
    }, [
        id
    ]);
    var announce = (0, $7pA0u.useCallback)(function(message) {
        var el = ref.current;
        if (el) {
            el.textContent = message;
            return;
        }
    }, []);
    return announce;
}
var $a4c0c313a61fc29c$var$getId$1 = function getId(contextId) {
    return "rbd-lift-instruction-" + contextId;
};
function $a4c0c313a61fc29c$var$useLiftInstruction(contextId, liftInstruction) {
    var id = (0, $7pA0u.useMemo)(function() {
        return $a4c0c313a61fc29c$var$getId$1(contextId);
    }, [
        contextId
    ]);
    (0, $eJOHy.useEffect)(function mount() {
        var el = document.createElement('div');
        el.id = id;
        el.textContent = liftInstruction;
        (0, (/*@__PURE__*/$parcel$interopDefault($lQkst)))(el.style, {
            display: 'none'
        });
        $a4c0c313a61fc29c$var$getBodyElement().appendChild(el);
        return function unmount() {
            $a4c0c313a61fc29c$var$getBodyElement().removeChild(el);
        };
    }, [
        id,
        liftInstruction
    ]);
    return id;
}
var $a4c0c313a61fc29c$var$AppContext = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(null);
var $a4c0c313a61fc29c$var$peerDependencies = {
    react: "^16.8.5",
    "react-dom": "^16.8.5"
};
var $a4c0c313a61fc29c$var$semver = /(\d+)\.(\d+)\.(\d+)/;
var $a4c0c313a61fc29c$var$getVersion = function getVersion(value) {
    var result = $a4c0c313a61fc29c$var$semver.exec(value);
    !(result != null) && $a4c0c313a61fc29c$var$invariant(false);
    var major = Number(result[1]);
    var minor = Number(result[2]);
    var patch = Number(result[3]);
    return {
        major: major,
        minor: minor,
        patch: patch,
        raw: value
    };
};
var $a4c0c313a61fc29c$var$isSatisfied = function isSatisfied(expected, actual) {
    if (actual.major > expected.major) return true;
    if (actual.major < expected.major) return false;
    if (actual.minor > expected.minor) return true;
    if (actual.minor < expected.minor) return false;
    return actual.patch >= expected.patch;
};
var $a4c0c313a61fc29c$var$checkReactVersion = function(peerDepValue, actualValue) {
    var peerDep = $a4c0c313a61fc29c$var$getVersion(peerDepValue);
    var actual = $a4c0c313a61fc29c$var$getVersion(actualValue);
    if ($a4c0c313a61fc29c$var$isSatisfied(peerDep, actual)) return;
};
var $a4c0c313a61fc29c$var$suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var $a4c0c313a61fc29c$var$checkDoctype = function(doc) {
    var doctype = doc.doctype;
    if (!doctype) return;
    doctype.name.toLowerCase();
    doctype.publicId;
};
function $a4c0c313a61fc29c$var$useDev(useHook) {}
function $a4c0c313a61fc29c$var$useDevSetupWarning(fn, inputs) {
    $a4c0c313a61fc29c$var$useDev(function() {
        (0, $eJOHy.useEffect)(function() {
            try {
                fn();
            } catch (e) {
                $a4c0c313a61fc29c$var$error("\n          A setup problem was encountered.\n\n          > " + e.message + "\n        ");
            }
        }, inputs);
    });
}
function $a4c0c313a61fc29c$var$useStartupValidation() {
    $a4c0c313a61fc29c$var$useDevSetupWarning(function() {
        $a4c0c313a61fc29c$var$checkReactVersion($a4c0c313a61fc29c$var$peerDependencies.react, (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).version);
        $a4c0c313a61fc29c$var$checkDoctype(document);
    }, []);
}
function $a4c0c313a61fc29c$var$usePrevious(current) {
    var ref = (0, $eJOHy.useRef)(current);
    (0, $eJOHy.useEffect)(function() {
        ref.current = current;
    });
    return ref;
}
function $a4c0c313a61fc29c$var$create() {
    var lock = null;
    function isClaimed() {
        return Boolean(lock);
    }
    function isActive(value) {
        return value === lock;
    }
    function claim(abandon) {
        !!lock && $a4c0c313a61fc29c$var$invariant(false);
        var newLock = {
            abandon: abandon
        };
        lock = newLock;
        return newLock;
    }
    function release() {
        !lock && $a4c0c313a61fc29c$var$invariant(false);
        lock = null;
    }
    function tryAbandon() {
        if (lock) {
            lock.abandon();
            release();
        }
    }
    return {
        isClaimed: isClaimed,
        isActive: isActive,
        claim: claim,
        release: release,
        tryAbandon: tryAbandon
    };
}
var $a4c0c313a61fc29c$var$tab = 9;
var $a4c0c313a61fc29c$var$enter = 13;
var $a4c0c313a61fc29c$var$escape = 27;
var $a4c0c313a61fc29c$var$space = 32;
var $a4c0c313a61fc29c$var$pageUp = 33;
var $a4c0c313a61fc29c$var$pageDown = 34;
var $a4c0c313a61fc29c$var$end = 35;
var $a4c0c313a61fc29c$var$home = 36;
var $a4c0c313a61fc29c$var$arrowLeft = 37;
var $a4c0c313a61fc29c$var$arrowUp = 38;
var $a4c0c313a61fc29c$var$arrowRight = 39;
var $a4c0c313a61fc29c$var$arrowDown = 40;
var $a4c0c313a61fc29c$var$_preventedKeys;
var $a4c0c313a61fc29c$var$preventedKeys = ($a4c0c313a61fc29c$var$_preventedKeys = {}, $a4c0c313a61fc29c$var$_preventedKeys[$a4c0c313a61fc29c$var$enter] = true, $a4c0c313a61fc29c$var$_preventedKeys[$a4c0c313a61fc29c$var$tab] = true, $a4c0c313a61fc29c$var$_preventedKeys);
var $a4c0c313a61fc29c$var$preventStandardKeyEvents = function(event) {
    if ($a4c0c313a61fc29c$var$preventedKeys[event.keyCode]) event.preventDefault();
};
var $a4c0c313a61fc29c$var$supportedEventName = function() {
    var base = 'visibilitychange';
    if (typeof document === 'undefined') return base;
    var candidates = [
        base,
        "ms" + base,
        "webkit" + base,
        "moz" + base,
        "o" + base
    ];
    var supported = $a4c0c313a61fc29c$var$find(candidates, function(eventName) {
        return "on" + eventName in document;
    });
    return supported || base;
}();
var $a4c0c313a61fc29c$var$primaryButton = 0;
var $a4c0c313a61fc29c$var$sloppyClickThreshold = 5;
function $a4c0c313a61fc29c$var$isSloppyClickThresholdExceeded(original, current) {
    return Math.abs(current.x - original.x) >= $a4c0c313a61fc29c$var$sloppyClickThreshold || Math.abs(current.y - original.y) >= $a4c0c313a61fc29c$var$sloppyClickThreshold;
}
var $a4c0c313a61fc29c$var$idle$1 = {
    type: 'IDLE'
};
function $a4c0c313a61fc29c$var$getCaptureBindings(_ref) {
    var cancel = _ref.cancel, completed = _ref.completed, getPhase = _ref.getPhase, setPhase = _ref.setPhase;
    return [
        {
            eventName: 'mousemove',
            fn: function fn(event) {
                var button = event.button, clientX = event.clientX, clientY = event.clientY;
                if (button !== $a4c0c313a61fc29c$var$primaryButton) return;
                var point = {
                    x: clientX,
                    y: clientY
                };
                var phase = getPhase();
                if (phase.type === 'DRAGGING') {
                    event.preventDefault();
                    phase.actions.move(point);
                    return;
                }
                !(phase.type === 'PENDING') && $a4c0c313a61fc29c$var$invariant(false);
                var pending = phase.point;
                if (!$a4c0c313a61fc29c$var$isSloppyClickThresholdExceeded(pending, point)) return;
                event.preventDefault();
                var actions = phase.actions.fluidLift(point);
                setPhase({
                    type: 'DRAGGING',
                    actions: actions
                });
            }
        },
        {
            eventName: 'mouseup',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: 'mousedown',
            fn: function fn(event) {
                if (getPhase().type === 'DRAGGING') event.preventDefault();
                cancel();
            }
        },
        {
            eventName: 'keydown',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type === 'PENDING') {
                    cancel();
                    return;
                }
                if (event.keyCode === $a4c0c313a61fc29c$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                $a4c0c313a61fc29c$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'scroll',
            options: {
                passive: true,
                capture: false
            },
            fn: function fn() {
                if (getPhase().type === 'PENDING') cancel();
            }
        },
        {
            eventName: 'webkitmouseforcedown',
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== 'IDLE') && $a4c0c313a61fc29c$var$invariant(false);
                if (phase.actions.shouldRespectForcePress()) {
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $a4c0c313a61fc29c$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $a4c0c313a61fc29c$var$useMouseSensor(api) {
    var phaseRef = (0, $eJOHy.useRef)($a4c0c313a61fc29c$var$idle$1);
    var unbindEventsRef = (0, $eJOHy.useRef)($a4c0c313a61fc29c$var$noop);
    var startCaptureBinding = (0, $7pA0u.useMemo)(function() {
        return {
            eventName: 'mousedown',
            fn: function onMouseDown(event) {
                if (event.defaultPrevented) return;
                if (event.button !== $a4c0c313a61fc29c$var$primaryButton) return;
                if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                event.preventDefault();
                var point = {
                    x: event.clientX,
                    y: event.clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var preventForcePressBinding = (0, $7pA0u.useMemo)(function() {
        return {
            eventName: 'webkitmouseforcewillbegin',
            fn: function fn(event) {
                if (event.defaultPrevented) return;
                var id = api.findClosestDraggableId(event);
                if (!id) return;
                var options = api.findOptionsForDraggable(id);
                if (!options) return;
                if (options.shouldRespectForcePress) return;
                if (!api.canGetLock(id)) return;
                event.preventDefault();
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $7pA0u.useCallback)(function listenForCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $a4c0c313a61fc29c$var$bindEvents(window, [
            preventForcePressBinding,
            startCaptureBinding
        ], options);
    }, [
        preventForcePressBinding,
        startCaptureBinding
    ]);
    var stop = (0, $7pA0u.useCallback)(function() {
        var current = phaseRef.current;
        if (current.type === 'IDLE') return;
        phaseRef.current = $a4c0c313a61fc29c$var$idle$1;
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture
    ]);
    var cancel = (0, $7pA0u.useCallback)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === 'DRAGGING') phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === 'PENDING') phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $7pA0u.useCallback)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var bindings = $a4c0c313a61fc29c$var$getCaptureBindings({
            cancel: cancel,
            completed: stop,
            getPhase: function getPhase() {
                return phaseRef.current;
            },
            setPhase: function setPhase(phase) {
                phaseRef.current = phase;
            }
        });
        unbindEventsRef.current = $a4c0c313a61fc29c$var$bindEvents(window, bindings, options);
    }, [
        cancel,
        stop
    ]);
    var startPendingDrag = (0, $7pA0u.useCallback)(function startPendingDrag(actions, point) {
        !(phaseRef.current.type === 'IDLE') && $a4c0c313a61fc29c$var$invariant(false);
        phaseRef.current = {
            type: 'PENDING',
            point: point,
            actions: actions
        };
        bindCapturingEvents();
    }, [
        bindCapturingEvents
    ]);
    $a4c0c313a61fc29c$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $a4c0c313a61fc29c$var$_scrollJumpKeys;
function $a4c0c313a61fc29c$var$noop$1() {}
var $a4c0c313a61fc29c$var$scrollJumpKeys = ($a4c0c313a61fc29c$var$_scrollJumpKeys = {}, $a4c0c313a61fc29c$var$_scrollJumpKeys[$a4c0c313a61fc29c$var$pageDown] = true, $a4c0c313a61fc29c$var$_scrollJumpKeys[$a4c0c313a61fc29c$var$pageUp] = true, $a4c0c313a61fc29c$var$_scrollJumpKeys[$a4c0c313a61fc29c$var$home] = true, $a4c0c313a61fc29c$var$_scrollJumpKeys[$a4c0c313a61fc29c$var$end] = true, $a4c0c313a61fc29c$var$_scrollJumpKeys);
function $a4c0c313a61fc29c$var$getDraggingBindings(actions, stop) {
    function cancel() {
        stop();
        actions.cancel();
    }
    function drop() {
        stop();
        actions.drop();
    }
    return [
        {
            eventName: 'keydown',
            fn: function fn(event) {
                if (event.keyCode === $a4c0c313a61fc29c$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                if (event.keyCode === $a4c0c313a61fc29c$var$space) {
                    event.preventDefault();
                    drop();
                    return;
                }
                if (event.keyCode === $a4c0c313a61fc29c$var$arrowDown) {
                    event.preventDefault();
                    actions.moveDown();
                    return;
                }
                if (event.keyCode === $a4c0c313a61fc29c$var$arrowUp) {
                    event.preventDefault();
                    actions.moveUp();
                    return;
                }
                if (event.keyCode === $a4c0c313a61fc29c$var$arrowRight) {
                    event.preventDefault();
                    actions.moveRight();
                    return;
                }
                if (event.keyCode === $a4c0c313a61fc29c$var$arrowLeft) {
                    event.preventDefault();
                    actions.moveLeft();
                    return;
                }
                if ($a4c0c313a61fc29c$var$scrollJumpKeys[event.keyCode]) {
                    event.preventDefault();
                    return;
                }
                $a4c0c313a61fc29c$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: 'mousedown',
            fn: cancel
        },
        {
            eventName: 'mouseup',
            fn: cancel
        },
        {
            eventName: 'click',
            fn: cancel
        },
        {
            eventName: 'touchstart',
            fn: cancel
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'wheel',
            fn: cancel,
            options: {
                passive: true
            }
        },
        {
            eventName: $a4c0c313a61fc29c$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $a4c0c313a61fc29c$var$useKeyboardSensor(api) {
    var unbindEventsRef = (0, $eJOHy.useRef)($a4c0c313a61fc29c$var$noop$1);
    var startCaptureBinding = (0, $7pA0u.useMemo)(function() {
        return {
            eventName: 'keydown',
            fn: function onKeyDown(event) {
                if (event.defaultPrevented) return;
                if (event.keyCode !== $a4c0c313a61fc29c$var$space) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var preDrag = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!preDrag) return;
                event.preventDefault();
                var isCapturing = true;
                var actions = preDrag.snapLift();
                unbindEventsRef.current();
                function stop() {
                    !isCapturing && $a4c0c313a61fc29c$var$invariant(false);
                    isCapturing = false;
                    unbindEventsRef.current();
                    listenForCapture();
                }
                unbindEventsRef.current = $a4c0c313a61fc29c$var$bindEvents(window, $a4c0c313a61fc29c$var$getDraggingBindings(actions, stop), {
                    capture: true,
                    passive: false
                });
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $7pA0u.useCallback)(function tryStartCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $a4c0c313a61fc29c$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    $a4c0c313a61fc29c$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $a4c0c313a61fc29c$var$idle$2 = {
    type: 'IDLE'
};
var $a4c0c313a61fc29c$var$timeForLongPress = 120;
var $a4c0c313a61fc29c$var$forcePressThreshold = 0.15;
function $a4c0c313a61fc29c$var$getWindowBindings(_ref) {
    var cancel = _ref.cancel, getPhase = _ref.getPhase;
    return [
        {
            eventName: 'orientationchange',
            fn: cancel
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'contextmenu',
            fn: function fn(event) {
                event.preventDefault();
            }
        },
        {
            eventName: 'keydown',
            fn: function fn(event) {
                if (getPhase().type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                if (event.keyCode === $a4c0c313a61fc29c$var$escape) event.preventDefault();
                cancel();
            }
        },
        {
            eventName: $a4c0c313a61fc29c$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $a4c0c313a61fc29c$var$getHandleBindings(_ref2) {
    var cancel = _ref2.cancel, completed = _ref2.completed, getPhase = _ref2.getPhase;
    return [
        {
            eventName: 'touchmove',
            options: {
                capture: false
            },
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                phase.hasMoved = true;
                var _event$touches$ = event.touches[0], clientX = _event$touches$.clientX, clientY = _event$touches$.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                event.preventDefault();
                phase.actions.move(point);
            }
        },
        {
            eventName: 'touchend',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: 'touchcancel',
            fn: function fn(event) {
                if (getPhase().type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                cancel();
            }
        },
        {
            eventName: 'touchforcechange',
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== 'IDLE') && $a4c0c313a61fc29c$var$invariant(false);
                var touch = event.touches[0];
                if (!touch) return;
                var isForcePress = touch.force >= $a4c0c313a61fc29c$var$forcePressThreshold;
                if (!isForcePress) return;
                var shouldRespect = phase.actions.shouldRespectForcePress();
                if (phase.type === 'PENDING') {
                    if (shouldRespect) cancel();
                    return;
                }
                if (shouldRespect) {
                    if (phase.hasMoved) {
                        event.preventDefault();
                        return;
                    }
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $a4c0c313a61fc29c$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $a4c0c313a61fc29c$var$useMouseSensor$1(api) {
    var phaseRef = (0, $eJOHy.useRef)($a4c0c313a61fc29c$var$idle$2);
    var unbindEventsRef = (0, $eJOHy.useRef)($a4c0c313a61fc29c$var$noop);
    var getPhase = (0, $7pA0u.useCallback)(function getPhase() {
        return phaseRef.current;
    }, []);
    var setPhase = (0, $7pA0u.useCallback)(function setPhase(phase) {
        phaseRef.current = phase;
    }, []);
    var startCaptureBinding = (0, $7pA0u.useMemo)(function() {
        return {
            eventName: 'touchstart',
            fn: function onTouchStart(event) {
                if (event.defaultPrevented) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                var touch = event.touches[0];
                var clientX = touch.clientX, clientY = touch.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $7pA0u.useCallback)(function listenForCapture() {
        var options = {
            capture: true,
            passive: false
        };
        unbindEventsRef.current = $a4c0c313a61fc29c$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    var stop = (0, $7pA0u.useCallback)(function() {
        var current = phaseRef.current;
        if (current.type === 'IDLE') return;
        if (current.type === 'PENDING') clearTimeout(current.longPressTimerId);
        setPhase($a4c0c313a61fc29c$var$idle$2);
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture,
        setPhase
    ]);
    var cancel = (0, $7pA0u.useCallback)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === 'DRAGGING') phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === 'PENDING') phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $7pA0u.useCallback)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var args = {
            cancel: cancel,
            completed: stop,
            getPhase: getPhase
        };
        var unbindTarget = $a4c0c313a61fc29c$var$bindEvents(window, $a4c0c313a61fc29c$var$getHandleBindings(args), options);
        var unbindWindow = $a4c0c313a61fc29c$var$bindEvents(window, $a4c0c313a61fc29c$var$getWindowBindings(args), options);
        unbindEventsRef.current = function unbindAll() {
            unbindTarget();
            unbindWindow();
        };
    }, [
        cancel,
        getPhase,
        stop
    ]);
    var startDragging = (0, $7pA0u.useCallback)(function startDragging() {
        var phase = getPhase();
        !(phase.type === 'PENDING') && $a4c0c313a61fc29c$var$invariant(false);
        var actions = phase.actions.fluidLift(phase.point);
        setPhase({
            type: 'DRAGGING',
            actions: actions,
            hasMoved: false
        });
    }, [
        getPhase,
        setPhase
    ]);
    var startPendingDrag = (0, $7pA0u.useCallback)(function startPendingDrag(actions, point) {
        !(getPhase().type === 'IDLE') && $a4c0c313a61fc29c$var$invariant(false);
        var longPressTimerId = setTimeout(startDragging, $a4c0c313a61fc29c$var$timeForLongPress);
        setPhase({
            type: 'PENDING',
            point: point,
            actions: actions,
            longPressTimerId: longPressTimerId
        });
        bindCapturingEvents();
    }, [
        bindCapturingEvents,
        getPhase,
        setPhase,
        startDragging
    ]);
    $a4c0c313a61fc29c$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
            var phase = getPhase();
            if (phase.type === 'PENDING') {
                clearTimeout(phase.longPressTimerId);
                setPhase($a4c0c313a61fc29c$var$idle$2);
            }
        };
    }, [
        getPhase,
        listenForCapture,
        setPhase
    ]);
    $a4c0c313a61fc29c$var$useIsomorphicLayoutEffect(function webkitHack() {
        var unbind = $a4c0c313a61fc29c$var$bindEvents(window, [
            {
                eventName: 'touchmove',
                fn: function fn() {},
                options: {
                    capture: false,
                    passive: false
                }
            }
        ]);
        return unbind;
    }, []);
}
function $a4c0c313a61fc29c$var$useValidateSensorHooks(sensorHooks) {
    $a4c0c313a61fc29c$var$useDev(function() {
        var previousRef = $a4c0c313a61fc29c$var$usePrevious(sensorHooks);
        $a4c0c313a61fc29c$var$useDevSetupWarning(function() {
            !(previousRef.current.length === sensorHooks.length) && $a4c0c313a61fc29c$var$invariant(false);
        });
    });
}
var $a4c0c313a61fc29c$var$interactiveTagNames = {
    input: true,
    button: true,
    textarea: true,
    select: true,
    option: true,
    optgroup: true,
    video: true,
    audio: true
};
function $a4c0c313a61fc29c$var$isAnInteractiveElement(parent, current) {
    if (current == null) return false;
    var hasAnInteractiveTag = Boolean($a4c0c313a61fc29c$var$interactiveTagNames[current.tagName.toLowerCase()]);
    if (hasAnInteractiveTag) return true;
    var attribute = current.getAttribute('contenteditable');
    if (attribute === 'true' || attribute === '') return true;
    if (current === parent) return false;
    return $a4c0c313a61fc29c$var$isAnInteractiveElement(parent, current.parentElement);
}
function $a4c0c313a61fc29c$var$isEventInInteractiveElement(draggable, event) {
    var target = event.target;
    if (!$a4c0c313a61fc29c$var$isHtmlElement(target)) return false;
    return $a4c0c313a61fc29c$var$isAnInteractiveElement(draggable, target);
}
var $a4c0c313a61fc29c$var$getBorderBoxCenterPosition = function(el) {
    return (0, $ixGZi.getRect)(el.getBoundingClientRect()).center;
};
function $a4c0c313a61fc29c$var$isElement(el) {
    return el instanceof $a4c0c313a61fc29c$var$getWindowFromEl(el).Element;
}
var $a4c0c313a61fc29c$var$supportedMatchesName = function() {
    var base = 'matches';
    if (typeof document === 'undefined') return base;
    var candidates = [
        base,
        'msMatchesSelector',
        'webkitMatchesSelector'
    ];
    var value = $a4c0c313a61fc29c$var$find(candidates, function(name) {
        return name in Element.prototype;
    });
    return value || base;
}();
function $a4c0c313a61fc29c$var$closestPonyfill(el, selector) {
    if (el == null) return null;
    if (el[$a4c0c313a61fc29c$var$supportedMatchesName](selector)) return el;
    return $a4c0c313a61fc29c$var$closestPonyfill(el.parentElement, selector);
}
function $a4c0c313a61fc29c$var$closest$1(el, selector) {
    if (el.closest) return el.closest(selector);
    return $a4c0c313a61fc29c$var$closestPonyfill(el, selector);
}
function $a4c0c313a61fc29c$var$getSelector(contextId) {
    return "[" + $a4c0c313a61fc29c$var$dragHandle.contextId + "=\"" + contextId + "\"]";
}
function $a4c0c313a61fc29c$var$findClosestDragHandleFromEvent(contextId, event) {
    var target = event.target;
    if (!$a4c0c313a61fc29c$var$isElement(target)) return null;
    var selector = $a4c0c313a61fc29c$var$getSelector(contextId);
    var handle = $a4c0c313a61fc29c$var$closest$1(target, selector);
    if (!handle) return null;
    if (!$a4c0c313a61fc29c$var$isHtmlElement(handle)) return null;
    return handle;
}
function $a4c0c313a61fc29c$var$tryGetClosestDraggableIdFromEvent(contextId, event) {
    var handle = $a4c0c313a61fc29c$var$findClosestDragHandleFromEvent(contextId, event);
    if (!handle) return null;
    return handle.getAttribute($a4c0c313a61fc29c$var$dragHandle.draggableId);
}
function $a4c0c313a61fc29c$var$findDraggable(contextId, draggableId) {
    var selector = "[" + $a4c0c313a61fc29c$var$draggable.contextId + "=\"" + contextId + "\"]";
    var possible = $a4c0c313a61fc29c$var$toArray(document.querySelectorAll(selector));
    var draggable$1 = $a4c0c313a61fc29c$var$find(possible, function(el) {
        return el.getAttribute($a4c0c313a61fc29c$var$draggable.id) === draggableId;
    });
    if (!draggable$1) return null;
    if (!$a4c0c313a61fc29c$var$isHtmlElement(draggable$1)) return null;
    return draggable$1;
}
function $a4c0c313a61fc29c$var$preventDefault(event) {
    event.preventDefault();
}
function $a4c0c313a61fc29c$var$_isActive(_ref) {
    var expected = _ref.expected, phase = _ref.phase, isLockActive = _ref.isLockActive, shouldWarn = _ref.shouldWarn;
    if (!isLockActive()) {
        shouldWarn;
        return false;
    }
    if (expected !== phase) {
        shouldWarn;
        return false;
    }
    return true;
}
function $a4c0c313a61fc29c$var$canStart(_ref2) {
    var lockAPI = _ref2.lockAPI, store = _ref2.store, registry = _ref2.registry, draggableId = _ref2.draggableId;
    if (lockAPI.isClaimed()) return false;
    var entry = registry.draggable.findById(draggableId);
    if (!entry) return false;
    if (!entry.options.isEnabled) return false;
    if (!$a4c0c313a61fc29c$var$canStartDrag(store.getState(), draggableId)) return false;
    return true;
}
function $a4c0c313a61fc29c$var$tryStart(_ref3) {
    var lockAPI = _ref3.lockAPI, contextId = _ref3.contextId, store = _ref3.store, registry = _ref3.registry, draggableId = _ref3.draggableId, forceSensorStop = _ref3.forceSensorStop, sourceEvent = _ref3.sourceEvent;
    var shouldStart = $a4c0c313a61fc29c$var$canStart({
        lockAPI: lockAPI,
        store: store,
        registry: registry,
        draggableId: draggableId
    });
    if (!shouldStart) return null;
    var entry = registry.draggable.getById(draggableId);
    var el = $a4c0c313a61fc29c$var$findDraggable(contextId, entry.descriptor.id);
    if (!el) return null;
    if (sourceEvent && !entry.options.canDragInteractiveElements && $a4c0c313a61fc29c$var$isEventInInteractiveElement(el, sourceEvent)) return null;
    var lock = lockAPI.claim(forceSensorStop || $a4c0c313a61fc29c$var$noop);
    var phase = 'PRE_DRAG';
    function getShouldRespectForcePress() {
        return entry.options.shouldRespectForcePress;
    }
    function isLockActive() {
        return lockAPI.isActive(lock);
    }
    function tryDispatch(expected, getAction) {
        if ($a4c0c313a61fc29c$var$_isActive({
            expected: expected,
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        })) store.dispatch(getAction());
    }
    var tryDispatchWhenDragging = tryDispatch.bind(this, 'DRAGGING');
    function lift$1(args) {
        function completed() {
            lockAPI.release();
            phase = 'COMPLETED';
        }
        if (phase !== 'PRE_DRAG') {
            completed();
            !(phase === 'PRE_DRAG') && $a4c0c313a61fc29c$var$invariant(false);
        }
        store.dispatch($a4c0c313a61fc29c$var$lift(args.liftActionArgs));
        phase = 'DRAGGING';
        function finish(reason, options) {
            if (options === void 0) options = {
                shouldBlockNextClick: false
            };
            args.cleanup();
            if (options.shouldBlockNextClick) {
                var unbind = $a4c0c313a61fc29c$var$bindEvents(window, [
                    {
                        eventName: 'click',
                        fn: $a4c0c313a61fc29c$var$preventDefault,
                        options: {
                            once: true,
                            passive: false,
                            capture: true
                        }
                    }
                ]);
                setTimeout(unbind);
            }
            completed();
            store.dispatch($a4c0c313a61fc29c$var$drop({
                reason: reason
            }));
        }
        return (0, $iyGBi.default)({
            isActive: function isActive() {
                return $a4c0c313a61fc29c$var$_isActive({
                    expected: 'DRAGGING',
                    phase: phase,
                    isLockActive: isLockActive,
                    shouldWarn: false
                });
            },
            shouldRespectForcePress: getShouldRespectForcePress,
            drop: function drop(options) {
                return finish('DROP', options);
            },
            cancel: function cancel(options) {
                return finish('CANCEL', options);
            }
        }, args.actions);
    }
    function fluidLift(clientSelection) {
        var move$1 = (0, $bBYr0.default)(function(client) {
            tryDispatchWhenDragging(function() {
                return $a4c0c313a61fc29c$var$move({
                    client: client
                });
            });
        });
        var api = lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: clientSelection,
                movementMode: 'FLUID'
            },
            cleanup: function cleanup() {
                return move$1.cancel();
            },
            actions: {
                move: move$1
            }
        });
        return (0, $iyGBi.default)({}, api, {
            move: move$1
        });
    }
    function snapLift() {
        var actions = {
            moveUp: function moveUp$1() {
                return tryDispatchWhenDragging($a4c0c313a61fc29c$var$moveUp);
            },
            moveRight: function moveRight$1() {
                return tryDispatchWhenDragging($a4c0c313a61fc29c$var$moveRight);
            },
            moveDown: function moveDown$1() {
                return tryDispatchWhenDragging($a4c0c313a61fc29c$var$moveDown);
            },
            moveLeft: function moveLeft$1() {
                return tryDispatchWhenDragging($a4c0c313a61fc29c$var$moveLeft);
            }
        };
        return lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: $a4c0c313a61fc29c$var$getBorderBoxCenterPosition(el),
                movementMode: 'SNAP'
            },
            cleanup: $a4c0c313a61fc29c$var$noop,
            actions: actions
        });
    }
    function abortPreDrag() {
        var shouldRelease = $a4c0c313a61fc29c$var$_isActive({
            expected: 'PRE_DRAG',
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        });
        if (shouldRelease) lockAPI.release();
    }
    var preDrag = {
        isActive: function isActive() {
            return $a4c0c313a61fc29c$var$_isActive({
                expected: 'PRE_DRAG',
                phase: phase,
                isLockActive: isLockActive,
                shouldWarn: false
            });
        },
        shouldRespectForcePress: getShouldRespectForcePress,
        fluidLift: fluidLift,
        snapLift: snapLift,
        abort: abortPreDrag
    };
    return preDrag;
}
var $a4c0c313a61fc29c$var$defaultSensors = [
    $a4c0c313a61fc29c$var$useMouseSensor,
    $a4c0c313a61fc29c$var$useKeyboardSensor,
    $a4c0c313a61fc29c$var$useMouseSensor$1
];
function $a4c0c313a61fc29c$var$useSensorMarshal(_ref4) {
    var contextId = _ref4.contextId, store = _ref4.store, registry = _ref4.registry, customSensors = _ref4.customSensors, enableDefaultSensors = _ref4.enableDefaultSensors;
    var useSensors = [].concat(enableDefaultSensors ? $a4c0c313a61fc29c$var$defaultSensors : [], customSensors || []);
    var lockAPI = (0, $eJOHy.useState)(function() {
        return $a4c0c313a61fc29c$var$create();
    })[0];
    var tryAbandonLock = (0, $7pA0u.useCallback)(function tryAbandonLock(previous, current) {
        if (previous.isDragging && !current.isDragging) lockAPI.tryAbandon();
    }, [
        lockAPI
    ]);
    $a4c0c313a61fc29c$var$useIsomorphicLayoutEffect(function listenToStore() {
        var previous = store.getState();
        var unsubscribe = store.subscribe(function() {
            var current = store.getState();
            tryAbandonLock(previous, current);
            previous = current;
        });
        return unsubscribe;
    }, [
        lockAPI,
        store,
        tryAbandonLock
    ]);
    $a4c0c313a61fc29c$var$useIsomorphicLayoutEffect(function() {
        return lockAPI.tryAbandon;
    }, [
        lockAPI.tryAbandon
    ]);
    var canGetLock = (0, $7pA0u.useCallback)(function(draggableId) {
        return $a4c0c313a61fc29c$var$canStart({
            lockAPI: lockAPI,
            registry: registry,
            store: store,
            draggableId: draggableId
        });
    }, [
        lockAPI,
        registry,
        store
    ]);
    var tryGetLock = (0, $7pA0u.useCallback)(function(draggableId, forceStop, options) {
        return $a4c0c313a61fc29c$var$tryStart({
            lockAPI: lockAPI,
            registry: registry,
            contextId: contextId,
            store: store,
            draggableId: draggableId,
            forceSensorStop: forceStop,
            sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
        });
    }, [
        contextId,
        lockAPI,
        registry,
        store
    ]);
    var findClosestDraggableId = (0, $7pA0u.useCallback)(function(event) {
        return $a4c0c313a61fc29c$var$tryGetClosestDraggableIdFromEvent(contextId, event);
    }, [
        contextId
    ]);
    var findOptionsForDraggable = (0, $7pA0u.useCallback)(function(id) {
        var entry = registry.draggable.findById(id);
        return entry ? entry.options : null;
    }, [
        registry.draggable
    ]);
    var tryReleaseLock = (0, $7pA0u.useCallback)(lockAPI.tryAbandon, [
        lockAPI
    ]);
    var isLockClaimed = (0, $7pA0u.useCallback)(lockAPI.isClaimed, [
        lockAPI
    ]);
    var api = (0, $7pA0u.useMemo)(function() {
        return {
            canGetLock: canGetLock,
            tryGetLock: tryGetLock,
            findClosestDraggableId: findClosestDraggableId,
            findOptionsForDraggable: findOptionsForDraggable,
            tryReleaseLock: tryReleaseLock,
            isLockClaimed: isLockClaimed
        };
    }, [
        canGetLock,
        tryGetLock,
        findClosestDraggableId,
        findOptionsForDraggable,
        tryReleaseLock,
        isLockClaimed
    ]);
    $a4c0c313a61fc29c$var$useValidateSensorHooks(useSensors);
    for(var i = 0; i < useSensors.length; i++)useSensors[i](api);
}
var $a4c0c313a61fc29c$var$createResponders = function createResponders(props) {
    return {
        onBeforeCapture: props.onBeforeCapture,
        onBeforeDragStart: props.onBeforeDragStart,
        onDragStart: props.onDragStart,
        onDragEnd: props.onDragEnd,
        onDragUpdate: props.onDragUpdate
    };
};
function $a4c0c313a61fc29c$var$getStore(lazyRef) {
    !lazyRef.current && $a4c0c313a61fc29c$var$invariant(false);
    return lazyRef.current;
}
function $a4c0c313a61fc29c$var$App(props) {
    var contextId = props.contextId, setCallbacks = props.setCallbacks, sensors = props.sensors, nonce = props.nonce, liftInstruction = props.liftInstruction;
    var lazyStoreRef = (0, $eJOHy.useRef)(null);
    $a4c0c313a61fc29c$var$useStartupValidation();
    var lastPropsRef = $a4c0c313a61fc29c$var$usePrevious(props);
    var getResponders = (0, $7pA0u.useCallback)(function() {
        return $a4c0c313a61fc29c$var$createResponders(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    var announce = $a4c0c313a61fc29c$var$useAnnouncer(contextId);
    var liftInstructionId = $a4c0c313a61fc29c$var$useLiftInstruction(contextId, liftInstruction);
    var styleMarshal = $a4c0c313a61fc29c$var$useStyleMarshal(contextId, nonce);
    var lazyDispatch = (0, $7pA0u.useCallback)(function(action) {
        $a4c0c313a61fc29c$var$getStore(lazyStoreRef).dispatch(action);
    }, []);
    var marshalCallbacks = (0, $7pA0u.useMemo)(function() {
        return (0, $24c1Z.bindActionCreators)({
            publishWhileDragging: $a4c0c313a61fc29c$var$publishWhileDragging,
            updateDroppableScroll: $a4c0c313a61fc29c$var$updateDroppableScroll,
            updateDroppableIsEnabled: $a4c0c313a61fc29c$var$updateDroppableIsEnabled,
            updateDroppableIsCombineEnabled: $a4c0c313a61fc29c$var$updateDroppableIsCombineEnabled,
            collectionStarting: $a4c0c313a61fc29c$var$collectionStarting
        }, lazyDispatch);
    }, [
        lazyDispatch
    ]);
    var registry = $a4c0c313a61fc29c$var$useRegistry();
    var dimensionMarshal = (0, $7pA0u.useMemo)(function() {
        return $a4c0c313a61fc29c$var$createDimensionMarshal(registry, marshalCallbacks);
    }, [
        registry,
        marshalCallbacks
    ]);
    var autoScroller = (0, $7pA0u.useMemo)(function() {
        return $a4c0c313a61fc29c$var$createAutoScroller((0, $iyGBi.default)({
            scrollWindow: $a4c0c313a61fc29c$var$scrollWindow,
            scrollDroppable: dimensionMarshal.scrollDroppable
        }, (0, $24c1Z.bindActionCreators)({
            move: $a4c0c313a61fc29c$var$move
        }, lazyDispatch)));
    }, [
        dimensionMarshal.scrollDroppable,
        lazyDispatch
    ]);
    var focusMarshal = $a4c0c313a61fc29c$var$useFocusMarshal(contextId);
    var store = (0, $7pA0u.useMemo)(function() {
        return $a4c0c313a61fc29c$var$createStore({
            announce: announce,
            autoScroller: autoScroller,
            dimensionMarshal: dimensionMarshal,
            focusMarshal: focusMarshal,
            getResponders: getResponders,
            styleMarshal: styleMarshal
        });
    }, [
        announce,
        autoScroller,
        dimensionMarshal,
        focusMarshal,
        getResponders,
        styleMarshal
    ]);
    lazyStoreRef.current = store;
    var tryResetStore = (0, $7pA0u.useCallback)(function() {
        var current = $a4c0c313a61fc29c$var$getStore(lazyStoreRef);
        var state = current.getState();
        if (state.phase !== 'IDLE') current.dispatch($a4c0c313a61fc29c$var$flush());
    }, []);
    var isDragging = (0, $7pA0u.useCallback)(function() {
        var state = $a4c0c313a61fc29c$var$getStore(lazyStoreRef).getState();
        return state.isDragging || state.phase === 'DROP_ANIMATING';
    }, []);
    var appCallbacks = (0, $7pA0u.useMemo)(function() {
        return {
            isDragging: isDragging,
            tryAbort: tryResetStore
        };
    }, [
        isDragging,
        tryResetStore
    ]);
    setCallbacks(appCallbacks);
    var getCanLift = (0, $7pA0u.useCallback)(function(id) {
        return $a4c0c313a61fc29c$var$canStartDrag($a4c0c313a61fc29c$var$getStore(lazyStoreRef).getState(), id);
    }, []);
    var getIsMovementAllowed = (0, $7pA0u.useCallback)(function() {
        return $a4c0c313a61fc29c$var$isMovementAllowed($a4c0c313a61fc29c$var$getStore(lazyStoreRef).getState());
    }, []);
    var appContext = (0, $7pA0u.useMemo)(function() {
        return {
            marshal: dimensionMarshal,
            focus: focusMarshal,
            contextId: contextId,
            canLift: getCanLift,
            isMovementAllowed: getIsMovementAllowed,
            liftInstructionId: liftInstructionId,
            registry: registry
        };
    }, [
        contextId,
        dimensionMarshal,
        focusMarshal,
        getCanLift,
        getIsMovementAllowed,
        liftInstructionId,
        registry
    ]);
    $a4c0c313a61fc29c$var$useSensorMarshal({
        contextId: contextId,
        store: store,
        registry: registry,
        customSensors: sensors,
        enableDefaultSensors: props.enableDefaultSensors !== false
    });
    (0, $eJOHy.useEffect)(function() {
        return tryResetStore;
    }, [
        tryResetStore
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a4c0c313a61fc29c$var$AppContext.Provider, {
        value: appContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k8ZHs.default), {
        context: $a4c0c313a61fc29c$var$StoreContext,
        store: store
    }, props.children));
}
var $a4c0c313a61fc29c$var$instanceCount = 0;
function $a4c0c313a61fc29c$export$2bfe52350fc0150d() {
    $a4c0c313a61fc29c$var$instanceCount = 0;
}
function $a4c0c313a61fc29c$export$237bd83162c14364(props) {
    var contextId = (0, $7pA0u.useMemo)(function() {
        return "" + $a4c0c313a61fc29c$var$instanceCount++;
    }, []);
    var liftInstruction = props.liftInstruction || $a4c0c313a61fc29c$var$preset.liftInstruction;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a4c0c313a61fc29c$var$ErrorBoundary, null, function(setCallbacks) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a4c0c313a61fc29c$var$App, {
            nonce: props.nonce,
            contextId: contextId,
            setCallbacks: setCallbacks,
            liftInstruction: liftInstruction,
            enableDefaultSensors: props.enableDefaultSensors,
            sensors: props.sensors,
            onBeforeCapture: props.onBeforeCapture,
            onBeforeDragStart: props.onBeforeDragStart,
            onDragStart: props.onDragStart,
            onDragUpdate: props.onDragUpdate,
            onDragEnd: props.onDragEnd
        }, props.children);
    });
}
var $a4c0c313a61fc29c$var$isEqual$1 = function isEqual(base) {
    return function(value) {
        return base === value;
    };
};
var $a4c0c313a61fc29c$var$isScroll = $a4c0c313a61fc29c$var$isEqual$1('scroll');
var $a4c0c313a61fc29c$var$isAuto = $a4c0c313a61fc29c$var$isEqual$1('auto');
var $a4c0c313a61fc29c$var$isVisible$1 = $a4c0c313a61fc29c$var$isEqual$1('visible');
var $a4c0c313a61fc29c$var$isEither = function isEither(overflow, fn) {
    return fn(overflow.overflowX) || fn(overflow.overflowY);
};
var $a4c0c313a61fc29c$var$isBoth = function isBoth(overflow, fn) {
    return fn(overflow.overflowX) && fn(overflow.overflowY);
};
var $a4c0c313a61fc29c$var$isElementScrollable = function isElementScrollable(el) {
    var style = window.getComputedStyle(el);
    var overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $a4c0c313a61fc29c$var$isEither(overflow, $a4c0c313a61fc29c$var$isScroll) || $a4c0c313a61fc29c$var$isEither(overflow, $a4c0c313a61fc29c$var$isAuto);
};
var $a4c0c313a61fc29c$var$isBodyScrollable = function isBodyScrollable() {
    var body, html, htmlStyle, htmlOverflow;
    return false;
};
var $a4c0c313a61fc29c$var$getClosestScrollable = function getClosestScrollable(el) {
    if (el == null) return null;
    if (el === document.body) return $a4c0c313a61fc29c$var$isBodyScrollable() ? el : null;
    if (el === document.documentElement) return null;
    if (!$a4c0c313a61fc29c$var$isElementScrollable(el)) return getClosestScrollable(el.parentElement);
    return el;
};
var $a4c0c313a61fc29c$var$checkForNestedScrollContainers = function(scrollable) {
    if (!scrollable) return;
    var anotherScrollParent = $a4c0c313a61fc29c$var$getClosestScrollable(scrollable.parentElement);
    if (!anotherScrollParent) return;
};
var $a4c0c313a61fc29c$var$getScroll$1 = function(el) {
    return {
        x: el.scrollLeft,
        y: el.scrollTop
    };
};
var $a4c0c313a61fc29c$var$getIsFixed = function getIsFixed(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.position === 'fixed') return true;
    return getIsFixed(el.parentElement);
};
var $a4c0c313a61fc29c$var$getEnv = function(start) {
    var closestScrollable = $a4c0c313a61fc29c$var$getClosestScrollable(start);
    var isFixedOnPage = $a4c0c313a61fc29c$var$getIsFixed(start);
    return {
        closestScrollable: closestScrollable,
        isFixedOnPage: isFixedOnPage
    };
};
var $a4c0c313a61fc29c$var$getDroppableDimension = function(_ref) {
    var descriptor = _ref.descriptor, isEnabled = _ref.isEnabled, isCombineEnabled = _ref.isCombineEnabled, isFixedOnPage = _ref.isFixedOnPage, direction = _ref.direction, client = _ref.client, page = _ref.page, closest = _ref.closest;
    var frame = function() {
        if (!closest) return null;
        var scrollSize = closest.scrollSize, frameClient = closest.client;
        var maxScroll = $a4c0c313a61fc29c$var$getMaxScroll({
            scrollHeight: scrollSize.scrollHeight,
            scrollWidth: scrollSize.scrollWidth,
            height: frameClient.paddingBox.height,
            width: frameClient.paddingBox.width
        });
        return {
            pageMarginBox: closest.page.marginBox,
            frameClient: frameClient,
            scrollSize: scrollSize,
            shouldClipSubject: closest.shouldClipSubject,
            scroll: {
                initial: closest.scroll,
                current: closest.scroll,
                max: maxScroll,
                diff: {
                    value: $a4c0c313a61fc29c$var$origin,
                    displacement: $a4c0c313a61fc29c$var$origin
                }
            }
        };
    }();
    var axis = direction === 'vertical' ? $a4c0c313a61fc29c$var$vertical : $a4c0c313a61fc29c$var$horizontal;
    var subject = $a4c0c313a61fc29c$var$getSubject({
        page: page,
        withPlaceholder: null,
        axis: axis,
        frame: frame
    });
    var dimension = {
        descriptor: descriptor,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: isFixedOnPage,
        axis: axis,
        isEnabled: isEnabled,
        client: client,
        page: page,
        frame: frame,
        subject: subject
    };
    return dimension;
};
var $a4c0c313a61fc29c$var$getClient = function getClient(targetRef, closestScrollable) {
    var base = (0, $ixGZi.getBox)(targetRef);
    if (!closestScrollable) return base;
    if (targetRef !== closestScrollable) return base;
    var top = base.paddingBox.top - closestScrollable.scrollTop;
    var left = base.paddingBox.left - closestScrollable.scrollLeft;
    var bottom = top + closestScrollable.scrollHeight;
    var right = left + closestScrollable.scrollWidth;
    var paddingBox = {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
    var borderBox = (0, $ixGZi.expand)(paddingBox, base.border);
    var client = (0, $ixGZi.createBox)({
        borderBox: borderBox,
        margin: base.margin,
        border: base.border,
        padding: base.padding
    });
    return client;
};
var $a4c0c313a61fc29c$var$getDimension = function(_ref) {
    var ref = _ref.ref, descriptor = _ref.descriptor, env = _ref.env, windowScroll = _ref.windowScroll, direction = _ref.direction, isDropDisabled = _ref.isDropDisabled, isCombineEnabled = _ref.isCombineEnabled, shouldClipSubject = _ref.shouldClipSubject;
    var closestScrollable = env.closestScrollable;
    var client = $a4c0c313a61fc29c$var$getClient(ref, closestScrollable);
    var page = (0, $ixGZi.withScroll)(client, windowScroll);
    var closest = function() {
        if (!closestScrollable) return null;
        var frameClient = (0, $ixGZi.getBox)(closestScrollable);
        var scrollSize = {
            scrollHeight: closestScrollable.scrollHeight,
            scrollWidth: closestScrollable.scrollWidth
        };
        return {
            client: frameClient,
            page: (0, $ixGZi.withScroll)(frameClient, windowScroll),
            scroll: $a4c0c313a61fc29c$var$getScroll$1(closestScrollable),
            scrollSize: scrollSize,
            shouldClipSubject: shouldClipSubject
        };
    }();
    var dimension = $a4c0c313a61fc29c$var$getDroppableDimension({
        descriptor: descriptor,
        isEnabled: !isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: env.isFixedOnPage,
        direction: direction,
        client: client,
        page: page,
        closest: closest
    });
    return dimension;
};
var $a4c0c313a61fc29c$var$immediate = {
    passive: false
};
var $a4c0c313a61fc29c$var$delayed = {
    passive: true
};
var $a4c0c313a61fc29c$var$getListenerOptions = function(options) {
    return options.shouldPublishImmediately ? $a4c0c313a61fc29c$var$immediate : $a4c0c313a61fc29c$var$delayed;
};
function $a4c0c313a61fc29c$var$useRequiredContext(Context) {
    var result = (0, $eJOHy.useContext)(Context);
    !result && $a4c0c313a61fc29c$var$invariant(false);
    return result;
}
var $a4c0c313a61fc29c$var$count = 0;
function $a4c0c313a61fc29c$var$useUniqueId(prefix) {
    var countRef = (0, $eJOHy.useRef)($a4c0c313a61fc29c$var$count++);
    return prefix + "::" + countRef.current;
}
var $a4c0c313a61fc29c$var$getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
    return dragging && dragging.env.closestScrollable || null;
};
function $a4c0c313a61fc29c$var$useDroppablePublisher(args) {
    var whileDraggingRef = (0, $eJOHy.useRef)(null);
    var appContext = $a4c0c313a61fc29c$var$useRequiredContext($a4c0c313a61fc29c$var$AppContext);
    var uniqueId = $a4c0c313a61fc29c$var$useUniqueId('droppable');
    var registry = appContext.registry, marshal = appContext.marshal;
    var previousRef = $a4c0c313a61fc29c$var$usePrevious(args);
    var descriptor = (0, $7pA0u.useMemo)(function() {
        return {
            id: args.droppableId,
            type: args.type,
            mode: args.mode
        };
    }, [
        args.droppableId,
        args.mode,
        args.type
    ]);
    var publishedDescriptorRef = (0, $eJOHy.useRef)(descriptor);
    var memoizedUpdateScroll = (0, $7pA0u.useMemo)(function() {
        return (0, $gj4eS.default)(function(x, y) {
            !whileDraggingRef.current && $a4c0c313a61fc29c$var$invariant(false);
            var scroll = {
                x: x,
                y: y
            };
            marshal.updateDroppableScroll(descriptor.id, scroll);
        });
    }, [
        descriptor.id,
        marshal
    ]);
    var getClosestScroll = (0, $7pA0u.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        if (!dragging || !dragging.env.closestScrollable) return $a4c0c313a61fc29c$var$origin;
        return $a4c0c313a61fc29c$var$getScroll$1(dragging.env.closestScrollable);
    }, []);
    var updateScroll = (0, $7pA0u.useCallback)(function() {
        var scroll = getClosestScroll();
        memoizedUpdateScroll(scroll.x, scroll.y);
    }, [
        getClosestScroll,
        memoizedUpdateScroll
    ]);
    var scheduleScrollUpdate = (0, $7pA0u.useMemo)(function() {
        return (0, $bBYr0.default)(updateScroll);
    }, [
        updateScroll
    ]);
    var onClosestScroll = (0, $7pA0u.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $a4c0c313a61fc29c$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $a4c0c313a61fc29c$var$invariant(false);
        var options = dragging.scrollOptions;
        if (options.shouldPublishImmediately) {
            updateScroll();
            return;
        }
        scheduleScrollUpdate();
    }, [
        scheduleScrollUpdate,
        updateScroll
    ]);
    var getDimensionAndWatchScroll = (0, $7pA0u.useCallback)(function(windowScroll, options) {
        !!whileDraggingRef.current && $a4c0c313a61fc29c$var$invariant(false);
        var previous = previousRef.current;
        var ref = previous.getDroppableRef();
        !ref && $a4c0c313a61fc29c$var$invariant(false);
        var env = $a4c0c313a61fc29c$var$getEnv(ref);
        var dragging = {
            ref: ref,
            descriptor: descriptor,
            env: env,
            scrollOptions: options
        };
        whileDraggingRef.current = dragging;
        var dimension = $a4c0c313a61fc29c$var$getDimension({
            ref: ref,
            descriptor: descriptor,
            env: env,
            windowScroll: windowScroll,
            direction: previous.direction,
            isDropDisabled: previous.isDropDisabled,
            isCombineEnabled: previous.isCombineEnabled,
            shouldClipSubject: !previous.ignoreContainerClipping
        });
        var scrollable = env.closestScrollable;
        if (scrollable) {
            scrollable.setAttribute($a4c0c313a61fc29c$var$scrollContainer.contextId, appContext.contextId);
            scrollable.addEventListener('scroll', onClosestScroll, $a4c0c313a61fc29c$var$getListenerOptions(dragging.scrollOptions));
        }
        return dimension;
    }, [
        appContext.contextId,
        descriptor,
        onClosestScroll,
        previousRef
    ]);
    var getScrollWhileDragging = (0, $7pA0u.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $a4c0c313a61fc29c$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $a4c0c313a61fc29c$var$invariant(false);
        return $a4c0c313a61fc29c$var$getScroll$1(closest);
    }, []);
    var dragStopped = (0, $7pA0u.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        !dragging && $a4c0c313a61fc29c$var$invariant(false);
        var closest = $a4c0c313a61fc29c$var$getClosestScrollableFromDrag(dragging);
        whileDraggingRef.current = null;
        if (!closest) return;
        scheduleScrollUpdate.cancel();
        closest.removeAttribute($a4c0c313a61fc29c$var$scrollContainer.contextId);
        closest.removeEventListener('scroll', onClosestScroll, $a4c0c313a61fc29c$var$getListenerOptions(dragging.scrollOptions));
    }, [
        onClosestScroll,
        scheduleScrollUpdate
    ]);
    var scroll = (0, $7pA0u.useCallback)(function(change) {
        var dragging = whileDraggingRef.current;
        !dragging && $a4c0c313a61fc29c$var$invariant(false);
        var closest = $a4c0c313a61fc29c$var$getClosestScrollableFromDrag(dragging);
        !closest && $a4c0c313a61fc29c$var$invariant(false);
        closest.scrollTop += change.y;
        closest.scrollLeft += change.x;
    }, []);
    var callbacks = (0, $7pA0u.useMemo)(function() {
        return {
            getDimensionAndWatchScroll: getDimensionAndWatchScroll,
            getScrollWhileDragging: getScrollWhileDragging,
            dragStopped: dragStopped,
            scroll: scroll
        };
    }, [
        dragStopped,
        getDimensionAndWatchScroll,
        getScrollWhileDragging,
        scroll
    ]);
    var entry = (0, $7pA0u.useMemo)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            callbacks: callbacks
        };
    }, [
        callbacks,
        descriptor,
        uniqueId
    ]);
    $a4c0c313a61fc29c$var$useIsomorphicLayoutEffect(function() {
        publishedDescriptorRef.current = entry.descriptor;
        registry.droppable.register(entry);
        return function() {
            if (whileDraggingRef.current) dragStopped();
            registry.droppable.unregister(entry);
        };
    }, [
        callbacks,
        descriptor,
        dragStopped,
        entry,
        marshal,
        registry.droppable
    ]);
    $a4c0c313a61fc29c$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
    }, [
        args.isDropDisabled,
        marshal
    ]);
    $a4c0c313a61fc29c$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
    }, [
        args.isCombineEnabled,
        marshal
    ]);
}
function $a4c0c313a61fc29c$var$noop$2() {}
var $a4c0c313a61fc29c$var$empty = {
    width: 0,
    height: 0,
    margin: $a4c0c313a61fc29c$var$noSpacing
};
var $a4c0c313a61fc29c$var$getSize = function getSize(_ref) {
    var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount, placeholder = _ref.placeholder, animate = _ref.animate;
    if (isAnimatingOpenOnMount) return $a4c0c313a61fc29c$var$empty;
    if (animate === 'close') return $a4c0c313a61fc29c$var$empty;
    return {
        height: placeholder.client.borderBox.height,
        width: placeholder.client.borderBox.width,
        margin: placeholder.client.margin
    };
};
var $a4c0c313a61fc29c$var$getStyle = function getStyle(_ref2) {
    var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount, placeholder = _ref2.placeholder, animate = _ref2.animate;
    var size = $a4c0c313a61fc29c$var$getSize({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        placeholder: placeholder,
        animate: animate
    });
    return {
        display: placeholder.display,
        boxSizing: 'border-box',
        width: size.width,
        height: size.height,
        marginTop: size.margin.top,
        marginRight: size.margin.right,
        marginBottom: size.margin.bottom,
        marginLeft: size.margin.left,
        flexShrink: '0',
        flexGrow: '0',
        pointerEvents: 'none',
        transition: animate !== 'none' ? $a4c0c313a61fc29c$var$transitions.placeholder : null
    };
};
function $a4c0c313a61fc29c$var$Placeholder(props) {
    var animateOpenTimerRef = (0, $eJOHy.useRef)(null);
    var tryClearAnimateOpenTimer = (0, $7pA0u.useCallback)(function() {
        if (!animateOpenTimerRef.current) return;
        clearTimeout(animateOpenTimerRef.current);
        animateOpenTimerRef.current = null;
    }, []);
    var animate = props.animate, onTransitionEnd = props.onTransitionEnd, onClose = props.onClose, contextId = props.contextId;
    var _useState = (0, $eJOHy.useState)(props.animate === 'open'), isAnimatingOpenOnMount = _useState[0], setIsAnimatingOpenOnMount = _useState[1];
    (0, $eJOHy.useEffect)(function() {
        if (!isAnimatingOpenOnMount) return $a4c0c313a61fc29c$var$noop$2;
        if (animate !== 'open') {
            tryClearAnimateOpenTimer();
            setIsAnimatingOpenOnMount(false);
            return $a4c0c313a61fc29c$var$noop$2;
        }
        if (animateOpenTimerRef.current) return $a4c0c313a61fc29c$var$noop$2;
        animateOpenTimerRef.current = setTimeout(function() {
            animateOpenTimerRef.current = null;
            setIsAnimatingOpenOnMount(false);
        });
        return tryClearAnimateOpenTimer;
    }, [
        animate,
        isAnimatingOpenOnMount,
        tryClearAnimateOpenTimer
    ]);
    var onSizeChangeEnd = (0, $7pA0u.useCallback)(function(event) {
        if (event.propertyName !== 'height') return;
        onTransitionEnd();
        if (animate === 'close') onClose();
    }, [
        animate,
        onClose,
        onTransitionEnd
    ]);
    var style = $a4c0c313a61fc29c$var$getStyle({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        animate: props.animate,
        placeholder: props.placeholder
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(props.placeholder.tagName, {
        style: style,
        'data-rbd-placeholder-context-id': contextId,
        onTransitionEnd: onSizeChangeEnd,
        ref: props.innerRef
    });
}
var $a4c0c313a61fc29c$var$Placeholder$1 = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo($a4c0c313a61fc29c$var$Placeholder);
var $a4c0c313a61fc29c$var$DroppableContext = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(null);
function $a4c0c313a61fc29c$var$checkIsValidInnerRef(el) {
    !(el && $a4c0c313a61fc29c$var$isHtmlElement(el)) && $a4c0c313a61fc29c$var$invariant(false);
}
function $a4c0c313a61fc29c$var$isBoolean(value) {
    return typeof value === 'boolean';
}
function $a4c0c313a61fc29c$var$runChecks(args, checks) {
    checks.forEach(function(check) {
        return check(args);
    });
}
var $a4c0c313a61fc29c$var$shared = [
    function required(_ref) {
        var props = _ref.props;
        !props.droppableId && $a4c0c313a61fc29c$var$invariant(false);
        !(typeof props.droppableId === 'string') && $a4c0c313a61fc29c$var$invariant(false);
    },
    function _boolean(_ref2) {
        var props = _ref2.props;
        !$a4c0c313a61fc29c$var$isBoolean(props.isDropDisabled) && $a4c0c313a61fc29c$var$invariant(false);
        !$a4c0c313a61fc29c$var$isBoolean(props.isCombineEnabled) && $a4c0c313a61fc29c$var$invariant(false);
        !$a4c0c313a61fc29c$var$isBoolean(props.ignoreContainerClipping) && $a4c0c313a61fc29c$var$invariant(false);
    },
    function ref(_ref3) {
        var getDroppableRef = _ref3.getDroppableRef;
        $a4c0c313a61fc29c$var$checkIsValidInnerRef(getDroppableRef());
    }
];
var $a4c0c313a61fc29c$var$standard = [
    function placeholder(_ref4) {
        var props = _ref4.props, getPlaceholderRef = _ref4.getPlaceholderRef;
        if (!props.placeholder) return;
        var ref = getPlaceholderRef();
        if (ref) return;
    }
];
var $a4c0c313a61fc29c$var$virtual = [
    function hasClone(_ref5) {
        var props = _ref5.props;
        !props.renderClone && $a4c0c313a61fc29c$var$invariant(false);
    },
    function hasNoPlaceholder(_ref6) {
        var getPlaceholderRef = _ref6.getPlaceholderRef;
        !!getPlaceholderRef() && $a4c0c313a61fc29c$var$invariant(false);
    }
];
function $a4c0c313a61fc29c$var$useValidation(args) {
    $a4c0c313a61fc29c$var$useDevSetupWarning(function() {
        $a4c0c313a61fc29c$var$runChecks(args, $a4c0c313a61fc29c$var$shared);
        if (args.props.mode === 'standard') $a4c0c313a61fc29c$var$runChecks(args, $a4c0c313a61fc29c$var$standard);
        if (args.props.mode === 'virtual') $a4c0c313a61fc29c$var$runChecks(args, $a4c0c313a61fc29c$var$virtual);
    });
}
var $a4c0c313a61fc29c$var$AnimateInOut = function(_React$PureComponent) {
    (0, $yG6r7.default)(AnimateInOut, _React$PureComponent);
    function AnimateInOut() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$PureComponent.call.apply(_React$PureComponent, [
            this
        ].concat(args)) || this;
        _this.state = {
            isVisible: Boolean(_this.props.on),
            data: _this.props.on,
            animate: _this.props.shouldAnimate && _this.props.on ? 'open' : 'none'
        };
        _this.onClose = function() {
            if (_this.state.animate !== 'close') return;
            _this.setState({
                isVisible: false
            });
        };
        return _this;
    }
    AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (!props.shouldAnimate) return {
            isVisible: Boolean(props.on),
            data: props.on,
            animate: 'none'
        };
        if (props.on) return {
            isVisible: true,
            data: props.on,
            animate: 'open'
        };
        if (state.isVisible) return {
            isVisible: true,
            data: state.data,
            animate: 'close'
        };
        return {
            isVisible: false,
            animate: 'close',
            data: null
        };
    };
    var _proto = AnimateInOut.prototype;
    _proto.render = function render() {
        if (!this.state.isVisible) return null;
        var provided = {
            onClose: this.onClose,
            data: this.state.data,
            animate: this.state.animate
        };
        return this.props.children(provided);
    };
    return AnimateInOut;
}((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent);
var $a4c0c313a61fc29c$var$zIndexOptions = {
    dragging: 5000,
    dropAnimating: 4500
};
var $a4c0c313a61fc29c$var$getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
    if (dropping) return $a4c0c313a61fc29c$var$transitions.drop(dropping.duration);
    if (shouldAnimateDragMovement) return $a4c0c313a61fc29c$var$transitions.snap;
    return $a4c0c313a61fc29c$var$transitions.fluid;
};
var $a4c0c313a61fc29c$var$getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
    if (!isCombining) return null;
    return isDropAnimating ? $a4c0c313a61fc29c$var$combine.opacity.drop : $a4c0c313a61fc29c$var$combine.opacity.combining;
};
var $a4c0c313a61fc29c$var$getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
    if (dragging.forceShouldAnimate != null) return dragging.forceShouldAnimate;
    return dragging.mode === 'SNAP';
};
function $a4c0c313a61fc29c$var$getDraggingStyle(dragging) {
    var dimension = dragging.dimension;
    var box = dimension.client;
    var offset = dragging.offset, combineWith = dragging.combineWith, dropping = dragging.dropping;
    var isCombining = Boolean(combineWith);
    var shouldAnimate = $a4c0c313a61fc29c$var$getShouldDraggingAnimate(dragging);
    var isDropAnimating = Boolean(dropping);
    var transform = isDropAnimating ? $a4c0c313a61fc29c$var$transforms.drop(offset, isCombining) : $a4c0c313a61fc29c$var$transforms.moveTo(offset);
    var style = {
        position: 'fixed',
        top: box.marginBox.top,
        left: box.marginBox.left,
        boxSizing: 'border-box',
        width: box.borderBox.width,
        height: box.borderBox.height,
        transition: $a4c0c313a61fc29c$var$getDraggingTransition(shouldAnimate, dropping),
        transform: transform,
        opacity: $a4c0c313a61fc29c$var$getDraggingOpacity(isCombining, isDropAnimating),
        zIndex: isDropAnimating ? $a4c0c313a61fc29c$var$zIndexOptions.dropAnimating : $a4c0c313a61fc29c$var$zIndexOptions.dragging,
        pointerEvents: 'none'
    };
    return style;
}
function $a4c0c313a61fc29c$var$getSecondaryStyle(secondary) {
    return {
        transform: $a4c0c313a61fc29c$var$transforms.moveTo(secondary.offset),
        transition: secondary.shouldAnimateDisplacement ? null : 'none'
    };
}
function $a4c0c313a61fc29c$var$getStyle$1(mapped) {
    return mapped.type === 'DRAGGING' ? $a4c0c313a61fc29c$var$getDraggingStyle(mapped) : $a4c0c313a61fc29c$var$getSecondaryStyle(mapped);
}
function $a4c0c313a61fc29c$var$getDimension$1(descriptor, el, windowScroll) {
    if (windowScroll === void 0) windowScroll = $a4c0c313a61fc29c$var$origin;
    var computedStyles = window.getComputedStyle(el);
    var borderBox = el.getBoundingClientRect();
    var client = (0, $ixGZi.calculateBox)(borderBox, computedStyles);
    var page = (0, $ixGZi.withScroll)(client, windowScroll);
    var placeholder = {
        client: client,
        tagName: el.tagName.toLowerCase(),
        display: computedStyles.display
    };
    var displaceBy = {
        x: client.marginBox.width,
        y: client.marginBox.height
    };
    var dimension = {
        descriptor: descriptor,
        placeholder: placeholder,
        displaceBy: displaceBy,
        client: client,
        page: page
    };
    return dimension;
}
function $a4c0c313a61fc29c$var$useDraggablePublisher(args) {
    var uniqueId = $a4c0c313a61fc29c$var$useUniqueId('draggable');
    var descriptor = args.descriptor, registry = args.registry, getDraggableRef = args.getDraggableRef, canDragInteractiveElements = args.canDragInteractiveElements, shouldRespectForcePress = args.shouldRespectForcePress, isEnabled = args.isEnabled;
    var options = (0, $7pA0u.useMemo)(function() {
        return {
            canDragInteractiveElements: canDragInteractiveElements,
            shouldRespectForcePress: shouldRespectForcePress,
            isEnabled: isEnabled
        };
    }, [
        canDragInteractiveElements,
        isEnabled,
        shouldRespectForcePress
    ]);
    var getDimension = (0, $7pA0u.useCallback)(function(windowScroll) {
        var el = getDraggableRef();
        !el && $a4c0c313a61fc29c$var$invariant(false);
        return $a4c0c313a61fc29c$var$getDimension$1(descriptor, el, windowScroll);
    }, [
        descriptor,
        getDraggableRef
    ]);
    var entry = (0, $7pA0u.useMemo)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            options: options,
            getDimension: getDimension
        };
    }, [
        descriptor,
        getDimension,
        options,
        uniqueId
    ]);
    var publishedRef = (0, $eJOHy.useRef)(entry);
    var isFirstPublishRef = (0, $eJOHy.useRef)(true);
    $a4c0c313a61fc29c$var$useIsomorphicLayoutEffect(function() {
        registry.draggable.register(publishedRef.current);
        return function() {
            return registry.draggable.unregister(publishedRef.current);
        };
    }, [
        registry.draggable
    ]);
    $a4c0c313a61fc29c$var$useIsomorphicLayoutEffect(function() {
        if (isFirstPublishRef.current) {
            isFirstPublishRef.current = false;
            return;
        }
        var last = publishedRef.current;
        publishedRef.current = entry;
        registry.draggable.update(entry, last);
    }, [
        entry,
        registry.draggable
    ]);
}
function $a4c0c313a61fc29c$var$useValidation$1(props, contextId, getRef) {
    $a4c0c313a61fc29c$var$useDevSetupWarning(function() {
        function prefix(id) {
            return "Draggable[id: " + id + "]: ";
        }
        var id = props.draggableId;
        !id && $a4c0c313a61fc29c$var$invariant(false);
        !(typeof id === 'string') && $a4c0c313a61fc29c$var$invariant(false);
        !(0, (/*@__PURE__*/$parcel$interopDefault($ejJQe)))(props.index) && $a4c0c313a61fc29c$var$invariant(false);
        if (props.mapped.type === 'DRAGGING') return;
        $a4c0c313a61fc29c$var$checkIsValidInnerRef(getRef());
        if (props.isEnabled) !$a4c0c313a61fc29c$var$findDragHandle(contextId, id) && $a4c0c313a61fc29c$var$invariant(false);
    });
}
function $a4c0c313a61fc29c$var$useClonePropValidation(isClone) {
    $a4c0c313a61fc29c$var$useDev(function() {
        var initialRef = (0, $eJOHy.useRef)(isClone);
        $a4c0c313a61fc29c$var$useDevSetupWarning(function() {
            !(isClone === initialRef.current) && $a4c0c313a61fc29c$var$invariant(false);
        }, [
            isClone
        ]);
    });
}
function $a4c0c313a61fc29c$var$preventHtml5Dnd(event) {
    event.preventDefault();
}
function $a4c0c313a61fc29c$var$Draggable(props) {
    var ref = (0, $eJOHy.useRef)(null);
    var setRef = (0, $7pA0u.useCallback)(function(el) {
        ref.current = el;
    }, []);
    var getRef = (0, $7pA0u.useCallback)(function() {
        return ref.current;
    }, []);
    var _useRequiredContext = $a4c0c313a61fc29c$var$useRequiredContext($a4c0c313a61fc29c$var$AppContext), contextId = _useRequiredContext.contextId, liftInstructionId = _useRequiredContext.liftInstructionId, registry = _useRequiredContext.registry;
    var _useRequiredContext2 = $a4c0c313a61fc29c$var$useRequiredContext($a4c0c313a61fc29c$var$DroppableContext), type = _useRequiredContext2.type, droppableId = _useRequiredContext2.droppableId;
    var descriptor = (0, $7pA0u.useMemo)(function() {
        return {
            id: props.draggableId,
            index: props.index,
            type: type,
            droppableId: droppableId
        };
    }, [
        props.draggableId,
        props.index,
        type,
        droppableId
    ]);
    var children = props.children, draggableId = props.draggableId, isEnabled = props.isEnabled, shouldRespectForcePress = props.shouldRespectForcePress, canDragInteractiveElements = props.canDragInteractiveElements, isClone = props.isClone, mapped = props.mapped, dropAnimationFinishedAction = props.dropAnimationFinished;
    $a4c0c313a61fc29c$var$useValidation$1(props, contextId, getRef);
    $a4c0c313a61fc29c$var$useClonePropValidation(isClone);
    if (!isClone) {
        var forPublisher = (0, $7pA0u.useMemo)(function() {
            return {
                descriptor: descriptor,
                registry: registry,
                getDraggableRef: getRef,
                canDragInteractiveElements: canDragInteractiveElements,
                shouldRespectForcePress: shouldRespectForcePress,
                isEnabled: isEnabled
            };
        }, [
            descriptor,
            registry,
            getRef,
            canDragInteractiveElements,
            shouldRespectForcePress,
            isEnabled
        ]);
        $a4c0c313a61fc29c$var$useDraggablePublisher(forPublisher);
    }
    var dragHandleProps = (0, $7pA0u.useMemo)(function() {
        return isEnabled ? {
            tabIndex: 0,
            'data-rbd-drag-handle-draggable-id': draggableId,
            'data-rbd-drag-handle-context-id': contextId,
            'aria-labelledby': liftInstructionId,
            draggable: false,
            onDragStart: $a4c0c313a61fc29c$var$preventHtml5Dnd
        } : null;
    }, [
        contextId,
        draggableId,
        isEnabled,
        liftInstructionId
    ]);
    var onMoveEnd = (0, $7pA0u.useCallback)(function(event) {
        if (mapped.type !== 'DRAGGING') return;
        if (!mapped.dropping) return;
        if (event.propertyName !== 'transform') return;
        dropAnimationFinishedAction();
    }, [
        dropAnimationFinishedAction,
        mapped
    ]);
    var provided = (0, $7pA0u.useMemo)(function() {
        var style = $a4c0c313a61fc29c$var$getStyle$1(mapped);
        var onTransitionEnd = mapped.type === 'DRAGGING' && mapped.dropping ? onMoveEnd : null;
        var result = {
            innerRef: setRef,
            draggableProps: {
                'data-rbd-draggable-context-id': contextId,
                'data-rbd-draggable-id': draggableId,
                style: style,
                onTransitionEnd: onTransitionEnd
            },
            dragHandleProps: dragHandleProps
        };
        return result;
    }, [
        contextId,
        dragHandleProps,
        draggableId,
        mapped,
        onMoveEnd,
        setRef
    ]);
    var rubric = (0, $7pA0u.useMemo)(function() {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    }, [
        descriptor.droppableId,
        descriptor.id,
        descriptor.index,
        descriptor.type
    ]);
    return children(provided, mapped.snapshot, rubric);
}
var $a4c0c313a61fc29c$var$isStrictEqual = function(a, b) {
    return a === b;
};
var $a4c0c313a61fc29c$var$whatIsDraggedOverFromResult = function(result) {
    var combine = result.combine, destination = result.destination;
    if (destination) return destination.droppableId;
    if (combine) return combine.droppableId;
    return null;
};
var $a4c0c313a61fc29c$var$getCombineWithFromResult = function getCombineWithFromResult(result) {
    return result.combine ? result.combine.draggableId : null;
};
var $a4c0c313a61fc29c$var$getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
    return impact.at && impact.at.type === 'COMBINE' ? impact.at.combine.draggableId : null;
};
function $a4c0c313a61fc29c$var$getDraggableSelector() {
    var memoizedOffset = (0, $gj4eS.default)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $gj4eS.default)(function(mode, isClone, draggingOver, combineWith, dropping) {
        return {
            isDragging: true,
            isClone: isClone,
            isDropAnimating: Boolean(dropping),
            dropAnimation: dropping,
            mode: mode,
            draggingOver: draggingOver,
            combineWith: combineWith,
            combineTargetFor: null
        };
    });
    var getMemoizedProps = (0, $gj4eS.default)(function(offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
        return {
            mapped: {
                type: 'DRAGGING',
                dropping: null,
                draggingOver: draggingOver,
                combineWith: combineWith,
                mode: mode,
                offset: offset,
                dimension: dimension,
                forceShouldAnimate: forceShouldAnimate,
                snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
            }
        };
    });
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id !== ownProps.draggableId) return null;
            var offset = state.current.client.offset;
            var dimension = state.dimensions.draggables[ownProps.draggableId];
            var draggingOver = $a4c0c313a61fc29c$var$whatIsDraggedOver(state.impact);
            var combineWith = $a4c0c313a61fc29c$var$getCombineWithFromImpact(state.impact);
            var forceShouldAnimate = state.forceShouldAnimate;
            return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (completed.result.draggableId !== ownProps.draggableId) return null;
            var isClone = ownProps.isClone;
            var _dimension = state.dimensions.draggables[ownProps.draggableId];
            var result = completed.result;
            var mode = result.mode;
            var _draggingOver = $a4c0c313a61fc29c$var$whatIsDraggedOverFromResult(result);
            var _combineWith = $a4c0c313a61fc29c$var$getCombineWithFromResult(result);
            var duration = state.dropDuration;
            var dropping = {
                duration: duration,
                curve: $a4c0c313a61fc29c$var$curves.drop,
                moveTo: state.newHomeClientOffset,
                opacity: _combineWith ? $a4c0c313a61fc29c$var$combine.opacity.drop : null,
                scale: _combineWith ? $a4c0c313a61fc29c$var$combine.scale.drop : null
            };
            return {
                mapped: {
                    type: 'DRAGGING',
                    offset: state.newHomeClientOffset,
                    dimension: _dimension,
                    dropping: dropping,
                    draggingOver: _draggingOver,
                    combineWith: _combineWith,
                    mode: mode,
                    forceShouldAnimate: null,
                    snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
                }
            };
        }
        return null;
    };
    return selector;
}
function $a4c0c313a61fc29c$var$getSecondarySnapshot(combineTargetFor) {
    return {
        isDragging: false,
        isDropAnimating: false,
        isClone: false,
        dropAnimation: null,
        mode: null,
        draggingOver: null,
        combineTargetFor: combineTargetFor,
        combineWith: null
    };
}
var $a4c0c313a61fc29c$var$atRest = {
    mapped: {
        type: 'SECONDARY',
        offset: $a4c0c313a61fc29c$var$origin,
        combineTargetFor: null,
        shouldAnimateDisplacement: true,
        snapshot: $a4c0c313a61fc29c$var$getSecondarySnapshot(null)
    }
};
function $a4c0c313a61fc29c$var$getSecondarySelector() {
    var memoizedOffset = (0, $gj4eS.default)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $gj4eS.default)($a4c0c313a61fc29c$var$getSecondarySnapshot);
    var getMemoizedProps = (0, $gj4eS.default)(function(offset, combineTargetFor, shouldAnimateDisplacement) {
        if (combineTargetFor === void 0) combineTargetFor = null;
        return {
            mapped: {
                type: 'SECONDARY',
                offset: offset,
                combineTargetFor: combineTargetFor,
                shouldAnimateDisplacement: shouldAnimateDisplacement,
                snapshot: getMemoizedSnapshot(combineTargetFor)
            }
        };
    });
    var getFallback = function getFallback(combineTargetFor) {
        return combineTargetFor ? getMemoizedProps($a4c0c313a61fc29c$var$origin, combineTargetFor, true) : null;
    };
    var getProps = function getProps(ownId, draggingId, impact, afterCritical) {
        var visualDisplacement = impact.displaced.visible[ownId];
        var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
        var combine = $a4c0c313a61fc29c$var$tryGetCombine(impact);
        var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;
        if (!visualDisplacement) {
            if (!isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
            if (impact.displaced.invisible[ownId]) return null;
            var change = $a4c0c313a61fc29c$var$negate(afterCritical.displacedBy.point);
            var _offset = memoizedOffset(change.x, change.y);
            return getMemoizedProps(_offset, combineTargetFor, true);
        }
        if (isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
        var displaceBy = impact.displacedBy.point;
        var offset = memoizedOffset(displaceBy.x, displaceBy.y);
        return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
    };
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (completed.result.draggableId === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
        }
        return null;
    };
    return selector;
}
var $a4c0c313a61fc29c$var$makeMapStateToProps = function makeMapStateToProps() {
    var draggingSelector = $a4c0c313a61fc29c$var$getDraggableSelector();
    var secondarySelector = $a4c0c313a61fc29c$var$getSecondarySelector();
    var selector = function selector(state, ownProps) {
        return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || $a4c0c313a61fc29c$var$atRest;
    };
    return selector;
};
var $a4c0c313a61fc29c$var$mapDispatchToProps = {
    dropAnimationFinished: $a4c0c313a61fc29c$var$dropAnimationFinished
};
var $a4c0c313a61fc29c$var$ConnectedDraggable = (0, $6gcAF.default)($a4c0c313a61fc29c$var$makeMapStateToProps, $a4c0c313a61fc29c$var$mapDispatchToProps, null, {
    context: $a4c0c313a61fc29c$var$StoreContext,
    pure: true,
    areStatePropsEqual: $a4c0c313a61fc29c$var$isStrictEqual
})($a4c0c313a61fc29c$var$Draggable);
function $a4c0c313a61fc29c$var$PrivateDraggable(props) {
    var droppableContext = $a4c0c313a61fc29c$var$useRequiredContext($a4c0c313a61fc29c$var$DroppableContext);
    var isUsingCloneFor = droppableContext.isUsingCloneFor;
    if (isUsingCloneFor === props.draggableId && !props.isClone) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a4c0c313a61fc29c$var$ConnectedDraggable, props);
}
function $a4c0c313a61fc29c$export$f2a139e5d18b9882(props) {
    var isEnabled = typeof props.isDragDisabled === 'boolean' ? !props.isDragDisabled : true;
    var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
    var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a4c0c313a61fc29c$var$PrivateDraggable, (0, $iyGBi.default)({}, props, {
        isClone: false,
        isEnabled: isEnabled,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress
    }));
}
function $a4c0c313a61fc29c$var$Droppable(props) {
    var appContext = (0, $eJOHy.useContext)($a4c0c313a61fc29c$var$AppContext);
    !appContext && $a4c0c313a61fc29c$var$invariant(false);
    var contextId = appContext.contextId, isMovementAllowed = appContext.isMovementAllowed;
    var droppableRef = (0, $eJOHy.useRef)(null);
    var placeholderRef = (0, $eJOHy.useRef)(null);
    var children = props.children, droppableId = props.droppableId, type = props.type, mode = props.mode, direction = props.direction, ignoreContainerClipping = props.ignoreContainerClipping, isDropDisabled = props.isDropDisabled, isCombineEnabled = props.isCombineEnabled, snapshot = props.snapshot, useClone = props.useClone, updateViewportMaxScroll = props.updateViewportMaxScroll, getContainerForClone = props.getContainerForClone;
    var getDroppableRef = (0, $7pA0u.useCallback)(function() {
        return droppableRef.current;
    }, []);
    var setDroppableRef = (0, $7pA0u.useCallback)(function(value) {
        droppableRef.current = value;
    }, []);
    var getPlaceholderRef = (0, $7pA0u.useCallback)(function() {
        return placeholderRef.current;
    }, []);
    var setPlaceholderRef = (0, $7pA0u.useCallback)(function(value) {
        placeholderRef.current = value;
    }, []);
    $a4c0c313a61fc29c$var$useValidation({
        props: props,
        getDroppableRef: getDroppableRef,
        getPlaceholderRef: getPlaceholderRef
    });
    var onPlaceholderTransitionEnd = (0, $7pA0u.useCallback)(function() {
        if (isMovementAllowed()) updateViewportMaxScroll({
            maxScroll: $a4c0c313a61fc29c$var$getMaxWindowScroll()
        });
    }, [
        isMovementAllowed,
        updateViewportMaxScroll
    ]);
    $a4c0c313a61fc29c$var$useDroppablePublisher({
        droppableId: droppableId,
        type: type,
        mode: mode,
        direction: direction,
        isDropDisabled: isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        ignoreContainerClipping: ignoreContainerClipping,
        getDroppableRef: getDroppableRef
    });
    var placeholder = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a4c0c313a61fc29c$var$AnimateInOut, {
        on: props.placeholder,
        shouldAnimate: props.shouldAnimatePlaceholder
    }, function(_ref) {
        var onClose = _ref.onClose, data = _ref.data, animate = _ref.animate;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a4c0c313a61fc29c$var$Placeholder$1, {
            placeholder: data,
            onClose: onClose,
            innerRef: setPlaceholderRef,
            animate: animate,
            contextId: contextId,
            onTransitionEnd: onPlaceholderTransitionEnd
        });
    });
    var provided = (0, $7pA0u.useMemo)(function() {
        return {
            innerRef: setDroppableRef,
            placeholder: placeholder,
            droppableProps: {
                'data-rbd-droppable-id': droppableId,
                'data-rbd-droppable-context-id': contextId
            }
        };
    }, [
        contextId,
        droppableId,
        placeholder,
        setDroppableRef
    ]);
    var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
    var droppableContext = (0, $7pA0u.useMemo)(function() {
        return {
            droppableId: droppableId,
            type: type,
            isUsingCloneFor: isUsingCloneFor
        };
    }, [
        droppableId,
        isUsingCloneFor,
        type
    ]);
    function getClone() {
        if (!useClone) return null;
        var dragging = useClone.dragging, render = useClone.render;
        var node = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a4c0c313a61fc29c$var$PrivateDraggable, {
            draggableId: dragging.draggableId,
            index: dragging.source.index,
            isClone: true,
            isEnabled: true,
            shouldRespectForcePress: false,
            canDragInteractiveElements: true
        }, function(draggableProvided, draggableSnapshot) {
            return render(draggableProvided, draggableSnapshot, dragging);
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).createPortal(node, getContainerForClone());
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a4c0c313a61fc29c$var$DroppableContext.Provider, {
        value: droppableContext
    }, children(provided, snapshot), getClone());
}
var $a4c0c313a61fc29c$var$isMatchingType = function isMatchingType(type, critical) {
    return type === critical.droppable.type;
};
var $a4c0c313a61fc29c$var$getDraggable = function getDraggable(critical, dimensions) {
    return dimensions.draggables[critical.draggable.id];
};
var $a4c0c313a61fc29c$var$makeMapStateToProps$1 = function makeMapStateToProps() {
    var idleWithAnimation = {
        placeholder: null,
        shouldAnimatePlaceholder: true,
        snapshot: {
            isDraggingOver: false,
            draggingOverWith: null,
            draggingFromThisWith: null,
            isUsingPlaceholder: false
        },
        useClone: null
    };
    var idleWithoutAnimation = (0, $iyGBi.default)({}, idleWithAnimation, {
        shouldAnimatePlaceholder: false
    });
    var getDraggableRubric = (0, $gj4eS.default)(function(descriptor) {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    });
    var getMapProps = (0, $gj4eS.default)(function(id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
        var draggableId = dragging.descriptor.id;
        var isHome = dragging.descriptor.droppableId === id;
        if (isHome) {
            var useClone = renderClone ? {
                render: renderClone,
                dragging: getDraggableRubric(dragging.descriptor)
            } : null;
            var _snapshot = {
                isDraggingOver: isDraggingOverForConsumer,
                draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
                draggingFromThisWith: draggableId,
                isUsingPlaceholder: true
            };
            return {
                placeholder: dragging.placeholder,
                shouldAnimatePlaceholder: false,
                snapshot: _snapshot,
                useClone: useClone
            };
        }
        if (!isEnabled) return idleWithoutAnimation;
        if (!isDraggingOverForImpact) return idleWithAnimation;
        var snapshot = {
            isDraggingOver: isDraggingOverForConsumer,
            draggingOverWith: draggableId,
            draggingFromThisWith: null,
            isUsingPlaceholder: true
        };
        return {
            placeholder: dragging.placeholder,
            shouldAnimatePlaceholder: true,
            snapshot: snapshot,
            useClone: null
        };
    });
    var selector = function selector(state, ownProps) {
        var id = ownProps.droppableId;
        var type = ownProps.type;
        var isEnabled = !ownProps.isDropDisabled;
        var renderClone = ownProps.renderClone;
        if (state.isDragging) {
            var critical = state.critical;
            if (!$a4c0c313a61fc29c$var$isMatchingType(type, critical)) return idleWithoutAnimation;
            var dragging = $a4c0c313a61fc29c$var$getDraggable(critical, state.dimensions);
            var isDraggingOver = $a4c0c313a61fc29c$var$whatIsDraggedOver(state.impact) === id;
            return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (!$a4c0c313a61fc29c$var$isMatchingType(type, completed.critical)) return idleWithoutAnimation;
            var _dragging = $a4c0c313a61fc29c$var$getDraggable(completed.critical, state.dimensions);
            return getMapProps(id, isEnabled, $a4c0c313a61fc29c$var$whatIsDraggedOverFromResult(completed.result) === id, $a4c0c313a61fc29c$var$whatIsDraggedOver(completed.impact) === id, _dragging, renderClone);
        }
        if (state.phase === 'IDLE' && state.completed && !state.shouldFlush) {
            var _completed = state.completed;
            if (!$a4c0c313a61fc29c$var$isMatchingType(type, _completed.critical)) return idleWithoutAnimation;
            var wasOver = $a4c0c313a61fc29c$var$whatIsDraggedOver(_completed.impact) === id;
            var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === 'COMBINE');
            var isHome = _completed.critical.droppable.id === id;
            if (wasOver) return wasCombining ? idleWithAnimation : idleWithoutAnimation;
            if (isHome) return idleWithAnimation;
            return idleWithoutAnimation;
        }
        return idleWithoutAnimation;
    };
    return selector;
};
var $a4c0c313a61fc29c$var$mapDispatchToProps$1 = {
    updateViewportMaxScroll: $a4c0c313a61fc29c$var$updateViewportMaxScroll
};
function $a4c0c313a61fc29c$var$getBody() {
    !document.body && $a4c0c313a61fc29c$var$invariant(false);
    return document.body;
}
var $a4c0c313a61fc29c$var$defaultProps = {
    mode: 'standard',
    type: 'DEFAULT',
    direction: 'vertical',
    isDropDisabled: false,
    isCombineEnabled: false,
    ignoreContainerClipping: false,
    renderClone: null,
    getContainerForClone: $a4c0c313a61fc29c$var$getBody
};
var $a4c0c313a61fc29c$export$423ec2075359570a = (0, $6gcAF.default)($a4c0c313a61fc29c$var$makeMapStateToProps$1, $a4c0c313a61fc29c$var$mapDispatchToProps$1, null, {
    context: $a4c0c313a61fc29c$var$StoreContext,
    pure: true,
    areStatePropsEqual: $a4c0c313a61fc29c$var$isStrictEqual
})($a4c0c313a61fc29c$var$Droppable);
$a4c0c313a61fc29c$export$423ec2075359570a.defaultProps = $a4c0c313a61fc29c$var$defaultProps;

});
parcelRegister("yG6r7", function(module, exports) {
$parcel$export(module.exports, "default", () => $0683d5d4f8197618$export$2e2bcd8739ae039);

var $d9SSJ = parcelRequire("d9SSJ");

var $3K7Dz = parcelRequire("3K7Dz");
function $0683d5d4f8197618$export$2e2bcd8739ae039(t, o) {
    t.prototype = (0, (/*@__PURE__*/$parcel$interopDefault($d9SSJ)))(o.prototype), t.prototype.constructor = t, (0, $3K7Dz.default)(t, o);
}

});
parcelRegister("d9SSJ", function(module, exports) {
parcelRequire("bDxet");

var $h9BqL = parcelRequire("h9BqL");
var $9946affdaea0a35f$require$$Object = $h9BqL.Object;
module.exports = function create(P, D) {
    return $9946affdaea0a35f$require$$Object.create(P, D);
};

});
parcelRegister("bDxet", function(module, exports) {

var $1VdgD = parcelRequire("1VdgD");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$1VdgD($1VdgD.S, 'Object', {
    create: (parcelRequire("eP7J8"))
});

});
parcelRegister("1VdgD", function(module, exports) {

var $ea50F = parcelRequire("ea50F");

var $h9BqL = parcelRequire("h9BqL");

var $hFYx0 = parcelRequire("hFYx0");

var $2fICR = parcelRequire("2fICR");

var $2k1EH = parcelRequire("2k1EH");
var $166567f03e3e0b37$var$PROTOTYPE = 'prototype';
var $166567f03e3e0b37$var$$export = function(type, name, source) {
    var IS_FORCED = type & $166567f03e3e0b37$var$$export.F;
    var IS_GLOBAL = type & $166567f03e3e0b37$var$$export.G;
    var IS_STATIC = type & $166567f03e3e0b37$var$$export.S;
    var IS_PROTO = type & $166567f03e3e0b37$var$$export.P;
    var IS_BIND = type & $166567f03e3e0b37$var$$export.B;
    var IS_WRAP = type & $166567f03e3e0b37$var$$export.W;
    var exports = IS_GLOBAL ? $h9BqL : $h9BqL[name] || ($h9BqL[name] = {});
    var expProto = exports[$166567f03e3e0b37$var$PROTOTYPE];
    var target = IS_GLOBAL ? $ea50F : IS_STATIC ? $ea50F[name] : ($ea50F[name] || {})[$166567f03e3e0b37$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $2k1EH(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $hFYx0(out, $ea50F) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$166567f03e3e0b37$var$PROTOTYPE] = C[$166567f03e3e0b37$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? $hFYx0(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $166567f03e3e0b37$var$$export.R && expProto && !expProto[key]) $2fICR(expProto, key, out);
        }
    }
};
// type bitmap
$166567f03e3e0b37$var$$export.F = 1; // forced
$166567f03e3e0b37$var$$export.G = 2; // global
$166567f03e3e0b37$var$$export.S = 4; // static
$166567f03e3e0b37$var$$export.P = 8; // proto
$166567f03e3e0b37$var$$export.B = 16; // bind
$166567f03e3e0b37$var$$export.W = 32; // wrap
$166567f03e3e0b37$var$$export.U = 64; // safe
$166567f03e3e0b37$var$$export.R = 128; // real proto method for `library`
module.exports = $166567f03e3e0b37$var$$export;

});
parcelRegister("ea50F", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $a4f5e2b85dab3797$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $a4f5e2b85dab3797$var$global; // eslint-disable-line no-undef

});

parcelRegister("h9BqL", function(module, exports) {
var $c7d04fe055d04aa8$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $c7d04fe055d04aa8$var$core; // eslint-disable-line no-undef

});

parcelRegister("hFYx0", function(module, exports) {
// optional / simple context binding

var $ixKF3 = parcelRequire("ixKF3");
module.exports = function(fn, that, length) {
    $ixKF3(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("ixKF3", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("2fICR", function(module, exports) {

var $6SgFA = parcelRequire("6SgFA");

var $65sdk = parcelRequire("65sdk");

module.exports = (parcelRequire("2ZZjJ")) ? function(object, key, value) {
    return $6SgFA.f(object, key, $65sdk(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("6SgFA", function(module, exports) {
$parcel$export(module.exports, "f", () => $5014b779d90da306$export$2d1720544b23b823, (v) => $5014b779d90da306$export$2d1720544b23b823 = v);
var $5014b779d90da306$export$2d1720544b23b823;

var $gH7sg = parcelRequire("gH7sg");

var $d5nHr = parcelRequire("d5nHr");

var $cBMOE = parcelRequire("cBMOE");
var $5014b779d90da306$var$dP = Object.defineProperty;

$5014b779d90da306$export$2d1720544b23b823 = (parcelRequire("2ZZjJ")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $gH7sg(O);
    P = $cBMOE(P, true);
    $gH7sg(Attributes);
    if ($d5nHr) try {
        return $5014b779d90da306$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("gH7sg", function(module, exports) {

var $4Us5Z = parcelRequire("4Us5Z");
module.exports = function(it) {
    if (!$4Us5Z(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("4Us5Z", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("d5nHr", function(module, exports) {



module.exports = !(parcelRequire("2ZZjJ")) && !(parcelRequire("60hL6"))(function() {
    return Object.defineProperty((parcelRequire("1uU7O"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("2ZZjJ", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("60hL6"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("60hL6", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("1uU7O", function(module, exports) {

var $4Us5Z = parcelRequire("4Us5Z");

var $ea50F = parcelRequire("ea50F");
var $117421055f7b9992$require$document = $ea50F.document;
// typeof document.createElement is 'object' in old IE
var $117421055f7b9992$var$is = $4Us5Z($117421055f7b9992$require$document) && $4Us5Z($117421055f7b9992$require$document.createElement);
module.exports = function(it) {
    return $117421055f7b9992$var$is ? $117421055f7b9992$require$document.createElement(it) : {};
};

});


parcelRegister("cBMOE", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $4Us5Z = parcelRequire("4Us5Z");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$4Us5Z(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$4Us5Z(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$4Us5Z(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$4Us5Z(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("65sdk", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("2k1EH", function(module, exports) {
var $1b0ebbbf46784288$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $1b0ebbbf46784288$var$hasOwnProperty.call(it, key);
};

});


parcelRegister("eP7J8", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $gH7sg = parcelRequire("gH7sg");

var $iyYcd = parcelRequire("iyYcd");

var $clOgA = parcelRequire("clOgA");

var $acabd284dd3abc94$var$IE_PROTO = (parcelRequire("dqUYm"))('IE_PROTO');
var $acabd284dd3abc94$var$Empty = function() {};
var $acabd284dd3abc94$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $acabd284dd3abc94$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("1uU7O"))('iframe');
    var i = $clOgA.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("bsGy8")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $acabd284dd3abc94$var$createDict = iframeDocument.F;
    while(i--)delete $acabd284dd3abc94$var$createDict[$acabd284dd3abc94$var$PROTOTYPE][$clOgA[i]];
    return $acabd284dd3abc94$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $acabd284dd3abc94$var$Empty[$acabd284dd3abc94$var$PROTOTYPE] = $gH7sg(O);
        result = new $acabd284dd3abc94$var$Empty();
        $acabd284dd3abc94$var$Empty[$acabd284dd3abc94$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$acabd284dd3abc94$var$IE_PROTO] = O;
    } else result = $acabd284dd3abc94$var$createDict();
    return Properties === undefined ? result : $iyYcd(result, Properties);
};

});
parcelRegister("iyYcd", function(module, exports) {

var $6SgFA = parcelRequire("6SgFA");

var $gH7sg = parcelRequire("gH7sg");

var $f49xG = parcelRequire("f49xG");

module.exports = (parcelRequire("2ZZjJ")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $gH7sg(O);
    var keys = $f49xG(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$6SgFA.f(O, P = keys[i++], Properties[P]);
    return O;
};

});
parcelRegister("f49xG", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $56isG = parcelRequire("56isG");

var $clOgA = parcelRequire("clOgA");
module.exports = Object.keys || function keys(O) {
    return $56isG(O, $clOgA);
};

});
parcelRegister("56isG", function(module, exports) {

var $2k1EH = parcelRequire("2k1EH");

var $kOF1h = parcelRequire("kOF1h");

var $3b6bd5665d9e9f5d$var$arrayIndexOf = (parcelRequire("fzEzO"))(false);

var $3b6bd5665d9e9f5d$var$IE_PROTO = (parcelRequire("dqUYm"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $kOF1h(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $3b6bd5665d9e9f5d$var$IE_PROTO) $2k1EH(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($2k1EH(O, key = names[i++])) ~$3b6bd5665d9e9f5d$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("kOF1h", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $aokPx = parcelRequire("aokPx");

var $iojCL = parcelRequire("iojCL");
module.exports = function(it) {
    return $aokPx($iojCL(it));
};

});
parcelRegister("aokPx", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $c4I03 = parcelRequire("c4I03");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $c4I03(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("c4I03", function(module, exports) {
var $0244c625fdfa1f38$var$toString = {}.toString;
module.exports = function(it) {
    return $0244c625fdfa1f38$var$toString.call(it).slice(8, -1);
};

});


parcelRegister("iojCL", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("fzEzO", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $kOF1h = parcelRequire("kOF1h");

var $h9XHT = parcelRequire("h9XHT");

var $cEixM = parcelRequire("cEixM");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $kOF1h($this);
        var length = $h9XHT(O.length);
        var index = $cEixM(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("h9XHT", function(module, exports) {
// 7.1.15 ToLength

var $ltpLS = parcelRequire("ltpLS");
var $c7e1977b7e8c28f6$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $c7e1977b7e8c28f6$var$min($ltpLS(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});
parcelRegister("ltpLS", function(module, exports) {
// 7.1.4 ToInteger
var $fa204c08ab638536$var$ceil = Math.ceil;
var $fa204c08ab638536$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $fa204c08ab638536$var$floor : $fa204c08ab638536$var$ceil)(it);
};

});


parcelRegister("cEixM", function(module, exports) {

var $ltpLS = parcelRequire("ltpLS");
var $93579add973f9bea$var$max = Math.max;
var $93579add973f9bea$var$min = Math.min;
module.exports = function(index, length) {
    index = $ltpLS(index);
    return index < 0 ? $93579add973f9bea$var$max(index + length, 0) : $93579add973f9bea$var$min(index, length);
};

});


parcelRegister("dqUYm", function(module, exports) {

var $9c79e5a684320090$var$shared = (parcelRequire("he9HP"))('keys');

var $d07cI = parcelRequire("d07cI");
module.exports = function(key) {
    return $9c79e5a684320090$var$shared[key] || ($9c79e5a684320090$var$shared[key] = $d07cI(key));
};

});
parcelRegister("he9HP", function(module, exports) {

var $h9BqL = parcelRequire("h9BqL");

var $ea50F = parcelRequire("ea50F");
var $c8ab45da1606111a$var$SHARED = '__core-js_shared__';
var $c8ab45da1606111a$var$store = $ea50F[$c8ab45da1606111a$var$SHARED] || ($ea50F[$c8ab45da1606111a$var$SHARED] = {});

(module.exports = function(key, value) {
    return $c8ab45da1606111a$var$store[key] || ($c8ab45da1606111a$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $h9BqL.version,
    mode: (parcelRequire("336Nq")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("336Nq", function(module, exports) {
module.exports = true;

});


parcelRegister("d07cI", function(module, exports) {
var $9770dd0be1eab494$var$id = 0;
var $9770dd0be1eab494$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$9770dd0be1eab494$var$id + $9770dd0be1eab494$var$px).toString(36));
};

});



parcelRegister("clOgA", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});



parcelRegister("bsGy8", function(module, exports) {

var $ea50F = parcelRequire("ea50F");
var $858350b57c4e0418$require$document = $ea50F.document;
module.exports = $858350b57c4e0418$require$document && $858350b57c4e0418$require$document.documentElement;

});




parcelRegister("3K7Dz", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b9b97915bde93bc$export$2e2bcd8739ae039);

var $hEveR = parcelRequire("hEveR");
function $2b9b97915bde93bc$export$2e2bcd8739ae039(t, e) {
    return $2b9b97915bde93bc$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($hEveR))) ? (0, (/*@__PURE__*/$parcel$interopDefault($hEveR))).bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $2b9b97915bde93bc$export$2e2bcd8739ae039(t, e);
}

});
parcelRegister("hEveR", function(module, exports) {
parcelRequire("iNGqd");

module.exports = (parcelRequire("h9BqL")).Object.setPrototypeOf;

});
parcelRegister("iNGqd", function(module, exports) {
// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $1VdgD = parcelRequire("1VdgD");

$1VdgD($1VdgD.S, 'Object', {
    setPrototypeOf: (parcelRequire("6B4nF")).set
});

});
parcelRegister("6B4nF", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $4Us5Z = parcelRequire("4Us5Z");

var $gH7sg = parcelRequire("gH7sg");
var $4cd998ad50462ac3$var$check = function(O, proto) {
    $gH7sg(O);
    if (!$4Us5Z(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("hFYx0"))(Function.call, (parcelRequire("2YAEc")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $4cd998ad50462ac3$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $4cd998ad50462ac3$var$check
};

});
parcelRegister("2YAEc", function(module, exports) {
$parcel$export(module.exports, "f", () => $22ad9cc291bf8d00$export$2d1720544b23b823, (v) => $22ad9cc291bf8d00$export$2d1720544b23b823 = v);
var $22ad9cc291bf8d00$export$2d1720544b23b823;

var $7NEQF = parcelRequire("7NEQF");

var $65sdk = parcelRequire("65sdk");

var $kOF1h = parcelRequire("kOF1h");

var $cBMOE = parcelRequire("cBMOE");

var $2k1EH = parcelRequire("2k1EH");

var $d5nHr = parcelRequire("d5nHr");
var $22ad9cc291bf8d00$var$gOPD = Object.getOwnPropertyDescriptor;

$22ad9cc291bf8d00$export$2d1720544b23b823 = (parcelRequire("2ZZjJ")) ? $22ad9cc291bf8d00$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $kOF1h(O);
    P = $cBMOE(P, true);
    if ($d5nHr) try {
        return $22ad9cc291bf8d00$var$gOPD(O, P);
    } catch (e) {}
    if ($2k1EH(O, P)) return $65sdk(!$7NEQF.f.call(O, P), O[P]);
};

});
parcelRegister("7NEQF", function(module, exports) {
$parcel$export(module.exports, "f", () => $5adccbac77835174$export$2d1720544b23b823, (v) => $5adccbac77835174$export$2d1720544b23b823 = v);
var $5adccbac77835174$export$2d1720544b23b823;
$5adccbac77835174$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});







parcelRegister("iyGBi", function(module, exports) {
$parcel$export(module.exports, "default", () => $d82c728cb70ebb4a$export$2e2bcd8739ae039);

var $aJlqc = parcelRequire("aJlqc");
function $d82c728cb70ebb4a$export$2e2bcd8739ae039() {
    return $d82c728cb70ebb4a$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($aJlqc))) ? (0, (/*@__PURE__*/$parcel$interopDefault($aJlqc))).bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d82c728cb70ebb4a$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("aJlqc", function(module, exports) {
parcelRequire("9HxL5");

module.exports = (parcelRequire("h9BqL")).Object.assign;

});
parcelRegister("9HxL5", function(module, exports) {
// 19.1.3.1 Object.assign(target, source)

var $1VdgD = parcelRequire("1VdgD");

$1VdgD($1VdgD.S + $1VdgD.F, 'Object', {
    assign: (parcelRequire("j3SKw"))
});

});
parcelRegister("j3SKw", function(module, exports) {
'use strict';

var $2ZZjJ = parcelRequire("2ZZjJ");

var $f49xG = parcelRequire("f49xG");

var $29Vta = parcelRequire("29Vta");

var $7NEQF = parcelRequire("7NEQF");

var $9IOcn = parcelRequire("9IOcn");

var $aokPx = parcelRequire("aokPx");
var $de08c43c136e4a2e$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$de08c43c136e4a2e$var$$assign || (parcelRequire("60hL6"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $de08c43c136e4a2e$var$$assign({}, A)[S] != 7 || Object.keys($de08c43c136e4a2e$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $9IOcn(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $29Vta.f;
    var isEnum = $7NEQF.f;
    while(aLen > index){
        var S = $aokPx(arguments[index++]);
        var keys = getSymbols ? $f49xG(S).concat(getSymbols(S)) : $f49xG(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$2ZZjJ || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $de08c43c136e4a2e$var$$assign;

});
parcelRegister("29Vta", function(module, exports) {
$parcel$export(module.exports, "f", () => $1929004539fa1d59$export$2d1720544b23b823, (v) => $1929004539fa1d59$export$2d1720544b23b823 = v);
var $1929004539fa1d59$export$2d1720544b23b823;
$1929004539fa1d59$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("9IOcn", function(module, exports) {
// 7.1.13 ToObject(argument)

var $iojCL = parcelRequire("iojCL");
module.exports = function(it) {
    return Object($iojCL(it));
};

});





parcelRegister("24c1Z", function(module, exports) {
$parcel$export(module.exports, "createStore", () => $1815499a1ea629ec$export$f51a9068ac82ea43);
$parcel$export(module.exports, "combineReducers", () => $1815499a1ea629ec$export$66e4520cdb265d18);
$parcel$export(module.exports, "bindActionCreators", () => $1815499a1ea629ec$export$aea084d96e84da92);
$parcel$export(module.exports, "compose", () => $1815499a1ea629ec$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "applyMiddleware", () => $1815499a1ea629ec$export$9ff26e0402cc7b7);

var $gY07e = parcelRequire("gY07e");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $1815499a1ea629ec$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $1815499a1ea629ec$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $1815499a1ea629ec$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $1815499a1ea629ec$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $1815499a1ea629ec$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $1815499a1ea629ec$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $1815499a1ea629ec$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $1815499a1ea629ec$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $1815499a1ea629ec$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($1815499a1ea629ec$var$isDate(val)) return 'date';
    if ($1815499a1ea629ec$var$isError(val)) return 'error';
    var constructorName = $1815499a1ea629ec$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $1815499a1ea629ec$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $1815499a1ea629ec$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $1815499a1ea629ec$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $1815499a1ea629ec$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $1815499a1ea629ec$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($1815499a1ea629ec$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($1815499a1ea629ec$var$formatProdErrorMessage(1));
        return enhancer($1815499a1ea629ec$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($1815499a1ea629ec$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($1815499a1ea629ec$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($1815499a1ea629ec$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($1815499a1ea629ec$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($1815499a1ea629ec$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$1815499a1ea629ec$var$isPlainObject(action)) throw new Error($1815499a1ea629ec$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($1815499a1ea629ec$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($1815499a1ea629ec$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($1815499a1ea629ec$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $1815499a1ea629ec$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($1815499a1ea629ec$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$1815499a1ea629ec$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $1815499a1ea629ec$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$1815499a1ea629ec$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $1815499a1ea629ec$export$8928921ea2d3b126 = $1815499a1ea629ec$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $1815499a1ea629ec$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $1815499a1ea629ec$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $1815499a1ea629ec$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$1815499a1ea629ec$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $1815499a1ea629ec$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $1815499a1ea629ec$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $1815499a1ea629ec$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $1815499a1ea629ec$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($1815499a1ea629ec$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $1815499a1ea629ec$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($1815499a1ea629ec$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $1815499a1ea629ec$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $1815499a1ea629ec$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($1815499a1ea629ec$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $1815499a1ea629ec$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $1815499a1ea629ec$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $1815499a1ea629ec$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($1815499a1ea629ec$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $1815499a1ea629ec$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $1815499a1ea629ec$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $1815499a1ea629ec$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($1815499a1ea629ec$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $1815499a1ea629ec$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $gY07e.default)((0, $gY07e.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("gY07e", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5a256e47eb97384$export$2e2bcd8739ae039);

var $7M3Wu = parcelRequire("7M3Wu");
function $c5a256e47eb97384$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c5a256e47eb97384$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c5a256e47eb97384$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $7M3Wu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c5a256e47eb97384$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});


parcelRegister("myP3H", function(module, exports) {
$parcel$export(module.exports, "connect", () => (parcelRequire("6gcAF")).default);
$parcel$export(module.exports, "Provider", () => (parcelRequire("k8ZHs")).default);
$parcel$export(module.exports, "shallowEqual", () => (parcelRequire("bWZ4E")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("7aZYj")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("fBL8b")).useSelector);
$parcel$export(module.exports, "useStore", () => (parcelRequire("ig7qg")).useStore);
parcelRequire("2nJ0m");
parcelRequire("hsyT7");
var $aQK2r = parcelRequire("aQK2r");

var $gjbg1 = parcelRequire("gjbg1");
// with standard React renderers (ReactDOM, React Native)
(0, $gjbg1.setBatch)((0, $aQK2r.unstable_batchedUpdates));

});
parcelRegister("2nJ0m", function(module, exports) {
$parcel$export(module.exports, "Provider", () => (parcelRequire("k8ZHs")).default);
$parcel$export(module.exports, "connect", () => (parcelRequire("6gcAF")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("7aZYj")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("fBL8b")).useSelector);
$parcel$export(module.exports, "useStore", () => (parcelRequire("ig7qg")).useStore);
$parcel$export(module.exports, "shallowEqual", () => (parcelRequire("bWZ4E")).default);

var $k8ZHs = parcelRequire("k8ZHs");

var $j9GyN = parcelRequire("j9GyN");

var $3s4w5 = parcelRequire("3s4w5");

var $6gcAF = parcelRequire("6gcAF");

var $7aZYj = parcelRequire("7aZYj");

var $fBL8b = parcelRequire("fBL8b");

var $ig7qg = parcelRequire("ig7qg");

var $bWZ4E = parcelRequire("bWZ4E");

});
parcelRegister("k8ZHs", function(module, exports) {
$parcel$export(module.exports, "default", () => $eaa46a4c93b93406$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");


var $3s4w5 = parcelRequire("3s4w5");

var $gEoP7 = parcelRequire("gEoP7");

var $573OP = parcelRequire("573OP");
function $eaa46a4c93b93406$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $eJOHy.useMemo)(function() {
        var subscription = (0, $gEoP7.createSubscription)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $eJOHy.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $573OP.useIsomorphicLayoutEffect)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $3s4w5.ReactReduxContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $eaa46a4c93b93406$export$2e2bcd8739ae039 = $eaa46a4c93b93406$var$Provider;

});
parcelRegister("3s4w5", function(module, exports) {
$parcel$export(module.exports, "ReactReduxContext", () => $28377d86e214458b$export$cc80c08dc91f1c00);

var $eJOHy = parcelRequire("eJOHy");
var $28377d86e214458b$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(null);
var $28377d86e214458b$export$2e2bcd8739ae039 = $28377d86e214458b$export$cc80c08dc91f1c00;

});

parcelRegister("gEoP7", function(module, exports) {
$parcel$export(module.exports, "createSubscription", () => $c1f3a33091ba74f1$export$d567d2b9af322f8f);

var $gjbg1 = parcelRequire("gjbg1");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $c1f3a33091ba74f1$var$createListenerCollection() {
    var batch = (0, $gjbg1.getBatch)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $c1f3a33091ba74f1$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $c1f3a33091ba74f1$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $c1f3a33091ba74f1$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $c1f3a33091ba74f1$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $c1f3a33091ba74f1$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}

});
parcelRegister("gjbg1", function(module, exports) {
$parcel$export(module.exports, "setBatch", () => $bdf727278bd68726$export$4b9874722d0da7bc);
$parcel$export(module.exports, "getBatch", () => $bdf727278bd68726$export$fc47d4c0ba3bd2c6);
// Default to a dummy "batch" implementation that just runs the callback
function $bdf727278bd68726$var$defaultNoopBatch(callback) {
    callback();
}
var $bdf727278bd68726$var$batch = $bdf727278bd68726$var$defaultNoopBatch; // Allow injecting another batching function later
var $bdf727278bd68726$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $bdf727278bd68726$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $bdf727278bd68726$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $bdf727278bd68726$var$batch;
};

});


parcelRegister("573OP", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $3b909183711ff688$export$700979bc83e7db82);

var $eJOHy = parcelRequire("eJOHy");
var $3b909183711ff688$export$700979bc83e7db82 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $eJOHy.useLayoutEffect) : (0, $eJOHy.useEffect);

});


parcelRegister("j9GyN", function(module, exports) {
$parcel$export(module.exports, "default", () => $df1fdf28727a5ca9$export$2e2bcd8739ae039);

var $fpB9r = parcelRequire("fpB9r");

var $2unhp = parcelRequire("2unhp");

var $cjwij = parcelRequire("cjwij");

var $eJOHy = parcelRequire("eJOHy");

var $cAYVI = parcelRequire("cAYVI");

var $gEoP7 = parcelRequire("gEoP7");

var $573OP = parcelRequire("573OP");

var $3s4w5 = parcelRequire("3s4w5");
var $df1fdf28727a5ca9$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $df1fdf28727a5ca9$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $df1fdf28727a5ca9$var$EMPTY_ARRAY = [];
var $df1fdf28727a5ca9$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $df1fdf28727a5ca9$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $df1fdf28727a5ca9$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $df1fdf28727a5ca9$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $573OP.useIsomorphicLayoutEffect)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $df1fdf28727a5ca9$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $df1fdf28727a5ca9$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: 'STORE_UPDATED',
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $df1fdf28727a5ca9$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $df1fdf28727a5ca9$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $3s4w5.ReactReduxContext) : _ref2$context, connectOptions = (0, $2unhp.default)(_ref2, $df1fdf28727a5ca9$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $fpB9r.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $eJOHy.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $eJOHy.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $2unhp.default)(props, $df1fdf28727a5ca9$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $eJOHy.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $cAYVI.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $eJOHy.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $eJOHy.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $eJOHy.useMemo)(function() {
                if (!shouldHandleStateChanges) return $df1fdf28727a5ca9$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $gEoP7.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $eJOHy.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $fpB9r.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $eJOHy.useReducer)($df1fdf28727a5ca9$var$storeStateUpdatesReducer, $df1fdf28727a5ca9$var$EMPTY_ARRAY, $df1fdf28727a5ca9$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $eJOHy.useRef)();
            var lastWrapperProps = (0, $eJOHy.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $eJOHy.useRef)();
            var renderIsScheduled = (0, $eJOHy.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $df1fdf28727a5ca9$var$useIsomorphicLayoutEffectWithArgs($df1fdf28727a5ca9$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $df1fdf28727a5ca9$var$useIsomorphicLayoutEffectWithArgs($df1fdf28727a5ca9$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $eJOHy.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, (0, $fpB9r.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $eJOHy.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Connect, (0, $fpB9r.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($cjwij)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($cjwij)))(Connect, WrappedComponent);
    };
}

});
parcelRegister("cAYVI", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fGoTM"));

});
parcelRegister("fGoTM", function(module, exports) {
$parcel$export(module.exports, "ContextConsumer", () => $b6ae1798f9265c22$export$a7c73072b1a182ae, (v) => $b6ae1798f9265c22$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $b6ae1798f9265c22$export$9f27bc3417b4524d, (v) => $b6ae1798f9265c22$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $b6ae1798f9265c22$export$db77ccec0bb4ccac, (v) => $b6ae1798f9265c22$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $b6ae1798f9265c22$export$8392c0c9d3dcbd35, (v) => $b6ae1798f9265c22$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $b6ae1798f9265c22$export$ffb0004e005737fa, (v) => $b6ae1798f9265c22$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $b6ae1798f9265c22$export$b624eff549462981, (v) => $b6ae1798f9265c22$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $b6ae1798f9265c22$export$7897aa7841a5380c, (v) => $b6ae1798f9265c22$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $b6ae1798f9265c22$export$602eac185826482c, (v) => $b6ae1798f9265c22$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $b6ae1798f9265c22$export$e2c29f18771995cb, (v) => $b6ae1798f9265c22$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $b6ae1798f9265c22$export$5f8d39834fd61797, (v) => $b6ae1798f9265c22$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $b6ae1798f9265c22$export$74bf444e3cd11ea5, (v) => $b6ae1798f9265c22$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $b6ae1798f9265c22$export$92387174baf9b227, (v) => $b6ae1798f9265c22$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $b6ae1798f9265c22$export$ec112efeb987d9c6, (v) => $b6ae1798f9265c22$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $b6ae1798f9265c22$export$b706b080d889d2c9, (v) => $b6ae1798f9265c22$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $b6ae1798f9265c22$export$5be5a87408f70ddc, (v) => $b6ae1798f9265c22$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $b6ae1798f9265c22$export$45a5e7f76e0caa8d, (v) => $b6ae1798f9265c22$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $b6ae1798f9265c22$export$455c2e768291efa6, (v) => $b6ae1798f9265c22$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $b6ae1798f9265c22$export$9522e17588c12572, (v) => $b6ae1798f9265c22$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $b6ae1798f9265c22$export$2110ac352bb060b9, (v) => $b6ae1798f9265c22$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $b6ae1798f9265c22$export$56885ab8b9c456ab, (v) => $b6ae1798f9265c22$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $b6ae1798f9265c22$export$d927fcb6adf8f9de, (v) => $b6ae1798f9265c22$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $b6ae1798f9265c22$export$b82d16f27459e05a, (v) => $b6ae1798f9265c22$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $b6ae1798f9265c22$export$522c17b4f5e123e8, (v) => $b6ae1798f9265c22$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $b6ae1798f9265c22$export$1aabd8a0274ecfd6, (v) => $b6ae1798f9265c22$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $b6ae1798f9265c22$export$9b621391a187a31a, (v) => $b6ae1798f9265c22$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $b6ae1798f9265c22$export$f5bbd400c2f4426f, (v) => $b6ae1798f9265c22$export$f5bbd400c2f4426f = v);
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b6ae1798f9265c22$export$a7c73072b1a182ae;
var $b6ae1798f9265c22$export$9f27bc3417b4524d;
var $b6ae1798f9265c22$export$db77ccec0bb4ccac;
var $b6ae1798f9265c22$export$8392c0c9d3dcbd35;
var $b6ae1798f9265c22$export$ffb0004e005737fa;
var $b6ae1798f9265c22$export$b624eff549462981;
var $b6ae1798f9265c22$export$7897aa7841a5380c;
var $b6ae1798f9265c22$export$602eac185826482c;
var $b6ae1798f9265c22$export$e2c29f18771995cb;
var $b6ae1798f9265c22$export$5f8d39834fd61797;
var $b6ae1798f9265c22$export$74bf444e3cd11ea5;
var $b6ae1798f9265c22$export$92387174baf9b227;
var $b6ae1798f9265c22$export$ec112efeb987d9c6;
var $b6ae1798f9265c22$export$b706b080d889d2c9;
var $b6ae1798f9265c22$export$5be5a87408f70ddc;
var $b6ae1798f9265c22$export$45a5e7f76e0caa8d;
var $b6ae1798f9265c22$export$455c2e768291efa6;
var $b6ae1798f9265c22$export$9522e17588c12572;
var $b6ae1798f9265c22$export$2110ac352bb060b9;
var $b6ae1798f9265c22$export$56885ab8b9c456ab;
var $b6ae1798f9265c22$export$d927fcb6adf8f9de;
var $b6ae1798f9265c22$export$b82d16f27459e05a;
var $b6ae1798f9265c22$export$522c17b4f5e123e8;
var $b6ae1798f9265c22$export$1aabd8a0274ecfd6;
var $b6ae1798f9265c22$export$9b621391a187a31a;
var $b6ae1798f9265c22$export$f5bbd400c2f4426f;
'use strict';
var $b6ae1798f9265c22$var$b = 60103, $b6ae1798f9265c22$var$c = 60106, $b6ae1798f9265c22$var$d = 60107, $b6ae1798f9265c22$var$e = 60108, $b6ae1798f9265c22$var$f = 60114, $b6ae1798f9265c22$var$g = 60109, $b6ae1798f9265c22$var$h = 60110, $b6ae1798f9265c22$var$k = 60112, $b6ae1798f9265c22$var$l = 60113, $b6ae1798f9265c22$var$m = 60120, $b6ae1798f9265c22$var$n = 60115, $b6ae1798f9265c22$var$p = 60116, $b6ae1798f9265c22$var$q = 60121, $b6ae1798f9265c22$var$r = 60122, $b6ae1798f9265c22$var$u = 60117, $b6ae1798f9265c22$var$v = 60129, $b6ae1798f9265c22$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $b6ae1798f9265c22$var$x = Symbol.for;
    $b6ae1798f9265c22$var$b = $b6ae1798f9265c22$var$x("react.element");
    $b6ae1798f9265c22$var$c = $b6ae1798f9265c22$var$x("react.portal");
    $b6ae1798f9265c22$var$d = $b6ae1798f9265c22$var$x("react.fragment");
    $b6ae1798f9265c22$var$e = $b6ae1798f9265c22$var$x("react.strict_mode");
    $b6ae1798f9265c22$var$f = $b6ae1798f9265c22$var$x("react.profiler");
    $b6ae1798f9265c22$var$g = $b6ae1798f9265c22$var$x("react.provider");
    $b6ae1798f9265c22$var$h = $b6ae1798f9265c22$var$x("react.context");
    $b6ae1798f9265c22$var$k = $b6ae1798f9265c22$var$x("react.forward_ref");
    $b6ae1798f9265c22$var$l = $b6ae1798f9265c22$var$x("react.suspense");
    $b6ae1798f9265c22$var$m = $b6ae1798f9265c22$var$x("react.suspense_list");
    $b6ae1798f9265c22$var$n = $b6ae1798f9265c22$var$x("react.memo");
    $b6ae1798f9265c22$var$p = $b6ae1798f9265c22$var$x("react.lazy");
    $b6ae1798f9265c22$var$q = $b6ae1798f9265c22$var$x("react.block");
    $b6ae1798f9265c22$var$r = $b6ae1798f9265c22$var$x("react.server.block");
    $b6ae1798f9265c22$var$u = $b6ae1798f9265c22$var$x("react.fundamental");
    $b6ae1798f9265c22$var$v = $b6ae1798f9265c22$var$x("react.debug_trace_mode");
    $b6ae1798f9265c22$var$w = $b6ae1798f9265c22$var$x("react.legacy_hidden");
}
function $b6ae1798f9265c22$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $b6ae1798f9265c22$var$b:
                switch(a = a.type, a){
                    case $b6ae1798f9265c22$var$d:
                    case $b6ae1798f9265c22$var$f:
                    case $b6ae1798f9265c22$var$e:
                    case $b6ae1798f9265c22$var$l:
                    case $b6ae1798f9265c22$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $b6ae1798f9265c22$var$h:
                            case $b6ae1798f9265c22$var$k:
                            case $b6ae1798f9265c22$var$p:
                            case $b6ae1798f9265c22$var$n:
                            case $b6ae1798f9265c22$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $b6ae1798f9265c22$var$c:
                return t;
        }
    }
}
var $b6ae1798f9265c22$var$z = $b6ae1798f9265c22$var$g, $b6ae1798f9265c22$var$A = $b6ae1798f9265c22$var$b, $b6ae1798f9265c22$var$B = $b6ae1798f9265c22$var$k, $b6ae1798f9265c22$var$C = $b6ae1798f9265c22$var$d, $b6ae1798f9265c22$var$D = $b6ae1798f9265c22$var$p, $b6ae1798f9265c22$var$E = $b6ae1798f9265c22$var$n, $b6ae1798f9265c22$var$F = $b6ae1798f9265c22$var$c, $b6ae1798f9265c22$var$G = $b6ae1798f9265c22$var$f, $b6ae1798f9265c22$var$H = $b6ae1798f9265c22$var$e, $b6ae1798f9265c22$var$I = $b6ae1798f9265c22$var$l;
$b6ae1798f9265c22$export$a7c73072b1a182ae = $b6ae1798f9265c22$var$h;
$b6ae1798f9265c22$export$9f27bc3417b4524d = $b6ae1798f9265c22$var$z;
$b6ae1798f9265c22$export$db77ccec0bb4ccac = $b6ae1798f9265c22$var$A;
$b6ae1798f9265c22$export$8392c0c9d3dcbd35 = $b6ae1798f9265c22$var$B;
$b6ae1798f9265c22$export$ffb0004e005737fa = $b6ae1798f9265c22$var$C;
$b6ae1798f9265c22$export$b624eff549462981 = $b6ae1798f9265c22$var$D;
$b6ae1798f9265c22$export$7897aa7841a5380c = $b6ae1798f9265c22$var$E;
$b6ae1798f9265c22$export$602eac185826482c = $b6ae1798f9265c22$var$F;
$b6ae1798f9265c22$export$e2c29f18771995cb = $b6ae1798f9265c22$var$G;
$b6ae1798f9265c22$export$5f8d39834fd61797 = $b6ae1798f9265c22$var$H;
$b6ae1798f9265c22$export$74bf444e3cd11ea5 = $b6ae1798f9265c22$var$I;
$b6ae1798f9265c22$export$92387174baf9b227 = function() {
    return !1;
};
$b6ae1798f9265c22$export$ec112efeb987d9c6 = function() {
    return !1;
};
$b6ae1798f9265c22$export$b706b080d889d2c9 = function(a) {
    return $b6ae1798f9265c22$var$y(a) === $b6ae1798f9265c22$var$h;
};
$b6ae1798f9265c22$export$5be5a87408f70ddc = function(a) {
    return $b6ae1798f9265c22$var$y(a) === $b6ae1798f9265c22$var$g;
};
$b6ae1798f9265c22$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b6ae1798f9265c22$var$b;
};
$b6ae1798f9265c22$export$455c2e768291efa6 = function(a) {
    return $b6ae1798f9265c22$var$y(a) === $b6ae1798f9265c22$var$k;
};
$b6ae1798f9265c22$export$9522e17588c12572 = function(a) {
    return $b6ae1798f9265c22$var$y(a) === $b6ae1798f9265c22$var$d;
};
$b6ae1798f9265c22$export$2110ac352bb060b9 = function(a) {
    return $b6ae1798f9265c22$var$y(a) === $b6ae1798f9265c22$var$p;
};
$b6ae1798f9265c22$export$56885ab8b9c456ab = function(a) {
    return $b6ae1798f9265c22$var$y(a) === $b6ae1798f9265c22$var$n;
};
$b6ae1798f9265c22$export$d927fcb6adf8f9de = function(a) {
    return $b6ae1798f9265c22$var$y(a) === $b6ae1798f9265c22$var$c;
};
$b6ae1798f9265c22$export$b82d16f27459e05a = function(a) {
    return $b6ae1798f9265c22$var$y(a) === $b6ae1798f9265c22$var$f;
};
$b6ae1798f9265c22$export$522c17b4f5e123e8 = function(a) {
    return $b6ae1798f9265c22$var$y(a) === $b6ae1798f9265c22$var$e;
};
$b6ae1798f9265c22$export$1aabd8a0274ecfd6 = function(a) {
    return $b6ae1798f9265c22$var$y(a) === $b6ae1798f9265c22$var$l;
};
$b6ae1798f9265c22$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $b6ae1798f9265c22$var$d || a === $b6ae1798f9265c22$var$f || a === $b6ae1798f9265c22$var$v || a === $b6ae1798f9265c22$var$e || a === $b6ae1798f9265c22$var$l || a === $b6ae1798f9265c22$var$m || a === $b6ae1798f9265c22$var$w || "object" === typeof a && null !== a && (a.$$typeof === $b6ae1798f9265c22$var$p || a.$$typeof === $b6ae1798f9265c22$var$n || a.$$typeof === $b6ae1798f9265c22$var$g || a.$$typeof === $b6ae1798f9265c22$var$h || a.$$typeof === $b6ae1798f9265c22$var$k || a.$$typeof === $b6ae1798f9265c22$var$u || a.$$typeof === $b6ae1798f9265c22$var$q || a[0] === $b6ae1798f9265c22$var$r) ? !0 : !1;
};
$b6ae1798f9265c22$export$f5bbd400c2f4426f = $b6ae1798f9265c22$var$y;

});



parcelRegister("6gcAF", function(module, exports) {
$parcel$export(module.exports, "default", () => $48ee00e9e3c05c73$export$2e2bcd8739ae039);

var $fpB9r = parcelRequire("fpB9r");

var $2unhp = parcelRequire("2unhp");

var $j9GyN = parcelRequire("j9GyN");

var $bWZ4E = parcelRequire("bWZ4E");

var $dzaju = parcelRequire("dzaju");

var $blWlf = parcelRequire("blWlf");

var $aznpN = parcelRequire("aznpN");

var $g7lof = parcelRequire("g7lof");
var $48ee00e9e3c05c73$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $48ee00e9e3c05c73$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $48ee00e9e3c05c73$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $48ee00e9e3c05c73$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $j9GyN.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $blWlf.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $dzaju.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $aznpN.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $g7lof.default) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $48ee00e9e3c05c73$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $bWZ4E.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $bWZ4E.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $bWZ4E.default) : _ref3$areMergedPropsE, extraOptions = (0, $2unhp.default)(_ref3, $48ee00e9e3c05c73$var$_excluded);
        var initMapStateToProps = $48ee00e9e3c05c73$var$match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
        var initMapDispatchToProps = $48ee00e9e3c05c73$var$match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
        var initMergeProps = $48ee00e9e3c05c73$var$match(mergeProps, mergePropsFactories, 'mergeProps');
        return connectHOC(selectorFactory, (0, $fpB9r.default)({
            // used in error messages
            methodName: 'connect',
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $48ee00e9e3c05c73$export$2e2bcd8739ae039 = /*#__PURE__*/ $48ee00e9e3c05c73$export$9f9feb656dec1fc4();

});
parcelRegister("bWZ4E", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b347c8016cf1d6e$export$2e2bcd8739ae039);
function $8b347c8016cf1d6e$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $8b347c8016cf1d6e$export$2e2bcd8739ae039(objA, objB) {
    if ($8b347c8016cf1d6e$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$8b347c8016cf1d6e$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});

parcelRegister("dzaju", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e068b3d1ed26118$export$2e2bcd8739ae039);

var $kvw2i = parcelRequire("kvw2i");

var $6b9c1 = parcelRequire("6b9c1");
function $9e068b3d1ed26118$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === 'function' ? (0, $6b9c1.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function $9e068b3d1ed26118$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $6b9c1.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $9e068b3d1ed26118$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $6b9c1.wrapMapToPropsConstant)(function(dispatch) {
        return (0, $kvw2i.default)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $9e068b3d1ed26118$export$2e2bcd8739ae039 = [
    $9e068b3d1ed26118$export$a9f27b4b187c1166,
    $9e068b3d1ed26118$export$ba20d1a7aa0c4a90,
    $9e068b3d1ed26118$export$94a6e55709d4d961
];

});
parcelRegister("kvw2i", function(module, exports) {
$parcel$export(module.exports, "default", () => $eedf8d97adca30f3$export$2e2bcd8739ae039);
function $eedf8d97adca30f3$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}

});

parcelRegister("6b9c1", function(module, exports) {
$parcel$export(module.exports, "wrapMapToPropsConstant", () => $47fae6aa51ffc7d1$export$710f7c60f68acd3e);
$parcel$export(module.exports, "wrapMapToPropsFunc", () => $47fae6aa51ffc7d1$export$8d46c7f53c8c602f);
parcelRequire("gXaUI");
function $47fae6aa51ffc7d1$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $47fae6aa51ffc7d1$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $47fae6aa51ffc7d1$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $47fae6aa51ffc7d1$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $47fae6aa51ffc7d1$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("gXaUI", function(module, exports) {

var $ff8bv = parcelRequire("ff8bv");

var $aQBNC = parcelRequire("aQBNC");
function $c57a9f45a6129d37$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $ff8bv.default)(value)) (0, $aQBNC.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}

});
parcelRegister("ff8bv", function(module, exports) {
$parcel$export(module.exports, "default", () => $b18e9b055eea55ba$export$2e2bcd8739ae039);
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $b18e9b055eea55ba$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});

parcelRegister("aQBNC", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e5c14dfc5eb62f0$export$2e2bcd8739ae039);
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $7e5c14dfc5eb62f0$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});




parcelRegister("blWlf", function(module, exports) {
$parcel$export(module.exports, "default", () => $843ee94e3c270501$export$2e2bcd8739ae039);

var $6b9c1 = parcelRequire("6b9c1");
function $843ee94e3c270501$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === 'function' ? (0, $6b9c1.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
}
function $843ee94e3c270501$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $6b9c1.wrapMapToPropsConstant)(function() {
        return {};
    }) : undefined;
}
var $843ee94e3c270501$export$2e2bcd8739ae039 = [
    $843ee94e3c270501$export$23fc470827b14aa,
    $843ee94e3c270501$export$514bc8c1a53c1d66
];

});

parcelRegister("aznpN", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b1f55fde6feeb23$export$2e2bcd8739ae039);

var $fpB9r = parcelRequire("fpB9r");
parcelRequire("gXaUI");
function $7b1f55fde6feeb23$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $fpB9r.default)({}, ownProps, stateProps, dispatchProps);
}
function $7b1f55fde6feeb23$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $7b1f55fde6feeb23$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === 'function' ? $7b1f55fde6feeb23$export$5b105939c84b5234(mergeProps) : undefined;
}
function $7b1f55fde6feeb23$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $7b1f55fde6feeb23$export$691c327fc30bc857;
    } : undefined;
}
var $7b1f55fde6feeb23$export$2e2bcd8739ae039 = [
    $7b1f55fde6feeb23$export$d61b680184bc3f00,
    $7b1f55fde6feeb23$export$a13ba70ef50dda6d
];

});

parcelRegister("g7lof", function(module, exports) {
$parcel$export(module.exports, "default", () => $bbbde46d40893da9$export$2e2bcd8739ae039);

var $2unhp = parcelRequire("2unhp");
parcelRequire("ap0GT");
var $bbbde46d40893da9$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $bbbde46d40893da9$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $bbbde46d40893da9$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $bbbde46d40893da9$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $2unhp.default)(_ref2, $bbbde46d40893da9$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $bbbde46d40893da9$export$d20c0c2ca6eb2b6f : $bbbde46d40893da9$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("ap0GT", function(module, exports) {

var $aQBNC = parcelRequire("aQBNC");
function $792cc65cdc018482$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $aQBNC.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $792cc65cdc018482$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $792cc65cdc018482$var$verify(mapStateToProps, 'mapStateToProps', displayName);
    $792cc65cdc018482$var$verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
    $792cc65cdc018482$var$verify(mergeProps, 'mergeProps', displayName);
}

});



parcelRegister("7aZYj", function(module, exports) {
$parcel$export(module.exports, "useDispatch", () => $539989e76d2cc78d$export$8ad76b76a4c905f8);

var $3s4w5 = parcelRequire("3s4w5");

var $ig7qg = parcelRequire("ig7qg");
function $539989e76d2cc78d$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $3s4w5.ReactReduxContext);
    var useStore = context === (0, $3s4w5.ReactReduxContext) ? (0, $ig7qg.useStore) : (0, $ig7qg.createStoreHook)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $539989e76d2cc78d$export$8ad76b76a4c905f8 = /*#__PURE__*/ $539989e76d2cc78d$export$bc9b55530897c558();

});
parcelRegister("ig7qg", function(module, exports) {
$parcel$export(module.exports, "createStoreHook", () => $d4af7a9ab4967769$export$671dba69185d0304);
$parcel$export(module.exports, "useStore", () => $d4af7a9ab4967769$export$6ccbb43953eebf8);

var $eJOHy = parcelRequire("eJOHy");

var $3s4w5 = parcelRequire("3s4w5");

var $7178Y = parcelRequire("7178Y");
function $d4af7a9ab4967769$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $3s4w5.ReactReduxContext);
    var useReduxContext = context === (0, $3s4w5.ReactReduxContext) ? (0, $7178Y.useReduxContext) : function() {
        return (0, $eJOHy.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $d4af7a9ab4967769$export$6ccbb43953eebf8 = /*#__PURE__*/ $d4af7a9ab4967769$export$671dba69185d0304();

});
parcelRegister("7178Y", function(module, exports) {
$parcel$export(module.exports, "useReduxContext", () => $51be2af9e1592be6$export$c1275ca9a6fd3ec5);

var $eJOHy = parcelRequire("eJOHy");

var $3s4w5 = parcelRequire("3s4w5");
function $51be2af9e1592be6$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $eJOHy.useContext)((0, $3s4w5.ReactReduxContext));
    return contextValue;
}

});



parcelRegister("fBL8b", function(module, exports) {
$parcel$export(module.exports, "useSelector", () => $b5cedef5e6a0dd27$export$2105062e25df4afe);

var $eJOHy = parcelRequire("eJOHy");

var $7178Y = parcelRequire("7178Y");

var $gEoP7 = parcelRequire("gEoP7");

var $573OP = parcelRequire("573OP");

var $3s4w5 = parcelRequire("3s4w5");
var $b5cedef5e6a0dd27$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $b5cedef5e6a0dd27$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $eJOHy.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $eJOHy.useMemo)(function() {
        return (0, $gEoP7.createSubscription)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $eJOHy.useRef)();
    var latestSelector = (0, $eJOHy.useRef)();
    var latestStoreState = (0, $eJOHy.useRef)();
    var latestSelectedState = (0, $eJOHy.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $573OP.useIsomorphicLayoutEffect)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $573OP.useIsomorphicLayoutEffect)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $b5cedef5e6a0dd27$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $3s4w5.ReactReduxContext);
    var useReduxContext = context === (0, $3s4w5.ReactReduxContext) ? (0, $7178Y.useReduxContext) : function() {
        return (0, $eJOHy.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $b5cedef5e6a0dd27$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $b5cedef5e6a0dd27$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $eJOHy.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $b5cedef5e6a0dd27$export$2105062e25df4afe = /*#__PURE__*/ $b5cedef5e6a0dd27$export$2b53f90d2bd1cbfb();

});


parcelRegister("hsyT7", function(module, exports) {
$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("aQK2r")).unstable_batchedUpdates);
/* eslint-disable import/no-unresolved */ 
var $aQK2r = parcelRequire("aQK2r");

});


parcelRegister("ixGZi", function(module, exports) {
$parcel$export(module.exports, "getRect", () => $d7fca780b0f0e073$export$4b834cebd9e5cebe);
$parcel$export(module.exports, "expand", () => $d7fca780b0f0e073$export$9f77e0932fb78f72);
$parcel$export(module.exports, "createBox", () => $d7fca780b0f0e073$export$6459fc9e86be362e);
$parcel$export(module.exports, "offset", () => $d7fca780b0f0e073$export$cc800923e997bb8);
$parcel$export(module.exports, "withScroll", () => $d7fca780b0f0e073$export$1d0caec378d7d0ae);
$parcel$export(module.exports, "calculateBox", () => $d7fca780b0f0e073$export$b8dfc5d4e552b8e1);
$parcel$export(module.exports, "getBox", () => $d7fca780b0f0e073$export$34928e660d2a8702);

var $8GOss = parcelRequire("8GOss");
var $d7fca780b0f0e073$export$4b834cebd9e5cebe = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var $d7fca780b0f0e073$export$9f77e0932fb78f72 = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var $d7fca780b0f0e073$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var $d7fca780b0f0e073$var$shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var $d7fca780b0f0e073$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $d7fca780b0f0e073$export$6459fc9e86be362e = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $d7fca780b0f0e073$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $d7fca780b0f0e073$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $d7fca780b0f0e073$var$noSpacing : _ref2$padding;
    var marginBox = $d7fca780b0f0e073$export$4b834cebd9e5cebe($d7fca780b0f0e073$export$9f77e0932fb78f72(borderBox, margin));
    var paddingBox = $d7fca780b0f0e073$export$4b834cebd9e5cebe($d7fca780b0f0e073$export$8b1f3092f5e28575(borderBox, border));
    var contentBox = $d7fca780b0f0e073$export$4b834cebd9e5cebe($d7fca780b0f0e073$export$8b1f3092f5e28575(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: $d7fca780b0f0e073$export$4b834cebd9e5cebe(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var $d7fca780b0f0e073$var$parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== 'px') return 0;
    var result = Number(value);
    !!isNaN(result) && (0, $8GOss.default)(false);
    return result;
};
var $d7fca780b0f0e073$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $d7fca780b0f0e073$export$cc800923e997bb8 = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = $d7fca780b0f0e073$var$shift(borderBox, change);
    return $d7fca780b0f0e073$export$6459fc9e86be362e({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var $d7fca780b0f0e073$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = $d7fca780b0f0e073$var$getWindowScroll();
    return $d7fca780b0f0e073$export$cc800923e997bb8(original, scroll);
};
var $d7fca780b0f0e073$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
    var margin = {
        top: $d7fca780b0f0e073$var$parse(styles.marginTop),
        right: $d7fca780b0f0e073$var$parse(styles.marginRight),
        bottom: $d7fca780b0f0e073$var$parse(styles.marginBottom),
        left: $d7fca780b0f0e073$var$parse(styles.marginLeft)
    };
    var padding = {
        top: $d7fca780b0f0e073$var$parse(styles.paddingTop),
        right: $d7fca780b0f0e073$var$parse(styles.paddingRight),
        bottom: $d7fca780b0f0e073$var$parse(styles.paddingBottom),
        left: $d7fca780b0f0e073$var$parse(styles.paddingLeft)
    };
    var border = {
        top: $d7fca780b0f0e073$var$parse(styles.borderTopWidth),
        right: $d7fca780b0f0e073$var$parse(styles.borderRightWidth),
        bottom: $d7fca780b0f0e073$var$parse(styles.borderBottomWidth),
        left: $d7fca780b0f0e073$var$parse(styles.borderLeftWidth)
    };
    return $d7fca780b0f0e073$export$6459fc9e86be362e({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var $d7fca780b0f0e073$export$34928e660d2a8702 = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return $d7fca780b0f0e073$export$b8dfc5d4e552b8e1(borderBox, styles);
};

});

parcelRegister("gj4eS", function(module, exports) {
$parcel$export(module.exports, "default", () => $bdf1b5728bd08db4$export$2e2bcd8739ae039);
var $bdf1b5728bd08db4$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $bdf1b5728bd08db4$var$isEqual(first, second) {
    if (first === second) return true;
    if ($bdf1b5728bd08db4$var$safeIsNaN(first) && $bdf1b5728bd08db4$var$safeIsNaN(second)) return true;
    return false;
}
function $bdf1b5728bd08db4$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$bdf1b5728bd08db4$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $bdf1b5728bd08db4$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $bdf1b5728bd08db4$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $bdf1b5728bd08db4$export$2e2bcd8739ae039 = $bdf1b5728bd08db4$var$memoizeOne;

});

parcelRegister("dSQ3b", function(module, exports) {

module.exports = (parcelRequire("iAq0j"));

});
parcelRegister("iAq0j", function(module, exports) {
parcelRequire("8l2Fy");

module.exports = (parcelRequire("h9BqL")).Object.values;

});
parcelRegister("8l2Fy", function(module, exports) {
// https://github.com/tc39/proposal-object-values-entries

var $1VdgD = parcelRequire("1VdgD");

var $61225af440891856$var$$values = (parcelRequire("gfulP"))(false);
$1VdgD($1VdgD.S, 'Object', {
    values: function values(it) {
        return $61225af440891856$var$$values(it);
    }
});

});
parcelRegister("gfulP", function(module, exports) {

var $2ZZjJ = parcelRequire("2ZZjJ");

var $f49xG = parcelRequire("f49xG");

var $kOF1h = parcelRequire("kOF1h");

var $7NEQF = parcelRequire("7NEQF");
var $bd45971fc2e1864d$require$isEnum = $7NEQF.f;
module.exports = function(isEntries) {
    return function(it) {
        var O = $kOF1h(it);
        var keys = $f49xG(O);
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while(length > i){
            key = keys[i++];
            if (!$2ZZjJ || $bd45971fc2e1864d$require$isEnum.call(O, key)) result.push(isEntries ? [
                key,
                O[key]
            ] : O[key]);
        }
        return result;
    };
};

});




parcelRegister("dAFDe", function(module, exports) {

module.exports = (parcelRequire("dDtJM"));

});
parcelRegister("dDtJM", function(module, exports) {
parcelRequire("3nRiT");

module.exports = (parcelRequire("h9BqL")).Object.keys;

});
parcelRegister("3nRiT", function(module, exports) {
// 19.1.2.14 Object.keys(O)

var $9IOcn = parcelRequire("9IOcn");

var $f49xG = parcelRequire("f49xG");

(parcelRequire("6rscv"))('keys', function() {
    return function keys(it) {
        return $f49xG($9IOcn(it));
    };
});

});
parcelRegister("6rscv", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $1VdgD = parcelRequire("1VdgD");

var $h9BqL = parcelRequire("h9BqL");

var $60hL6 = parcelRequire("60hL6");
module.exports = function(KEY, exec) {
    var fn = ($h9BqL.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $1VdgD($1VdgD.S + $1VdgD.F * $60hL6(function() {
        fn(1);
    }), 'Object', exp);
};

});




parcelRegister("bBYr0", function(module, exports) {
$parcel$export(module.exports, "default", () => $8742077b484367ee$export$2e2bcd8739ae039);
var $8742077b484367ee$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $8742077b484367ee$export$2e2bcd8739ae039 = $8742077b484367ee$var$rafSchd;

});

parcelRegister("digWO", function(module, exports) {

module.exports = (parcelRequire("l515f"));

});
parcelRegister("l515f", function(module, exports) {
parcelRequire("hqJLA");

module.exports = (parcelRequire("h9BqL")).Date.now;

});
parcelRegister("hqJLA", function(module, exports) {
// 20.3.3.1 / 15.9.4.4 Date.now()

var $1VdgD = parcelRequire("1VdgD");
$1VdgD($1VdgD.S, 'Date', {
    now: function() {
        return new Date().getTime();
    }
});

});



parcelRegister("lQkst", function(module, exports) {

module.exports = (parcelRequire("aJlqc"));

});

parcelRegister("ejJQe", function(module, exports) {

module.exports = (parcelRequire("jd9OJ"));

});
parcelRegister("jd9OJ", function(module, exports) {
parcelRequire("iQv6R");

module.exports = (parcelRequire("h9BqL")).Number.isInteger;

});
parcelRegister("iQv6R", function(module, exports) {
// 20.1.2.3 Number.isInteger(number)

var $1VdgD = parcelRequire("1VdgD");

$1VdgD($1VdgD.S, 'Number', {
    isInteger: (parcelRequire("dtDJt"))
});

});
parcelRegister("dtDJt", function(module, exports) {
// 20.1.2.3 Number.isInteger(number)

var $4Us5Z = parcelRequire("4Us5Z");
var $9cfccdcf77580d26$var$floor = Math.floor;
module.exports = function isInteger(it) {
    return !$4Us5Z(it) && isFinite(it) && $9cfccdcf77580d26$var$floor(it) === it;
};

});





parcelRegister("652G5", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e1bd48c01f4aca6$export$2e2bcd8739ae039);
/* item-line-card-view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $cT3Ey = parcelRequire("cT3Ey");

var $12DRg = parcelRequire("12DRg");

var $e8YwC = parcelRequire("e8YwC");

var $bJscI = parcelRequire("bJscI");

var $7jTnu = parcelRequire("7jTnu");
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-compiled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7e1bd48c01f4aca6$var$CardContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _gfdrglyw _uxit3acm",
            __cmplp.className
        ])
    });
});
const $7e1bd48c01f4aca6$var$DraggableCardContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_gfdrglyw _uxit3acm",
            __cmplp.className
        ])
    });
});
const $7e1bd48c01f4aca6$var$clearBorderMixin = null;
const $7e1bd48c01f4aca6$var$withFixedHeight = null;
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-compiled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7e1bd48c01f4aca6$var$CardOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isInteractive: isInteractive, isDragging: isDragging, isVariableHeight: isVariableHeight, isDraggable: isDraggable, isHovering: isHovering, isActive: isActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_lk280q": (0, $awdRS.default)((()=>{
                if (__cmplp.isInteractive) return __cmplp.isDragging ? 'grabbing' : 'pointer';
                return 'auto';
            })()),
            "--_mfjrkx": (0, $awdRS.default)(__cmplp.isDragging ? "var(--ds-surface-overlay, #FFFFFF)" : "var(--ds-background-neutral-subtle-pressed, #091E4224)")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11q71w7a _2rko12b0 _1yt41cy0 _18s81nxw _80oma357 _1e0c1txw _kqswh2mm _nt751r31 _49pcglyw _1hvw1o36 _rk8tkb7n _7ehi1hxt",
            !__cmplp.isVariableHeight && "_4t3i1ylp",
            __cmplp.isDragging ? "_n7zl1bht" : "_n7zlzgxb",
            !__cmplp.isDraggable && "_13jwglyw _y7iw3acm",
            __cmplp.isHovering && "_4bfu18uv _1hmsglyw _ajmmnqa1 _bfhk166n",
            __cmplp.isActive && "_11q7495g _16qs1cd0",
            __cmplp.className
        ])
    });
});
const $7e1bd48c01f4aca6$var$CardNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isInteractive: isInteractive, isDragging: isDragging, isVariableHeight: isVariableHeight, isHovering: isHovering, isActive: isActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_lk280q": (0, $awdRS.default)((()=>{
                if (__cmplp.isInteractive) return __cmplp.isDragging ? 'grabbing' : 'pointer';
                return 'auto';
            })()),
            "--_mfjrkx": (0, $awdRS.default)(__cmplp.isDragging ? "var(--ds-surface-overlay, #FFFFFF)" : "var(--ds-background-neutral-subtle-pressed, #091E4224)")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11q71w7a _2rko12b0 _1yt41cy0 _18s81nxw _80oma357 _1e0c1txw _kqswh2mm _nt751r31 _49pcglyw _1hvw1o36 _rk8tkb7n _7ehi10dx",
            !__cmplp.isVariableHeight && "_4t3i1ylp",
            __cmplp.isDragging ? "_n7zl1bht" : "_n7zlzgxb",
            __cmplp.isHovering && "_4bfu18uv _1hmsglyw _ajmmnqa1 _bfhk166n",
            __cmplp.isActive && "_11q7495g _16qs1cd0",
            __cmplp.className
        ])
    });
});
const $7e1bd48c01f4aca6$var$Card = (0, $bJscI.componentWithFG)('issue-view_item-line-card-a11y-clone', $7e1bd48c01f4aca6$var$CardNew, $7e1bd48c01f4aca6$var$CardOld);
const $7e1bd48c01f4aca6$var$isMiddleClick = (event)=>event.button === 1;
class $7e1bd48c01f4aca6$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.propTypes = {
            item: (0, (/*@__PURE__*/$parcel$interopDefault($cT3Ey))).object.isRequired,
            index: (0, (/*@__PURE__*/$parcel$interopDefault($cT3Ey))).number.isRequired,
            isReorderEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($cT3Ey))).bool,
            isInteractive: (0, (/*@__PURE__*/$parcel$interopDefault($cT3Ey))).bool,
            isVariableHeight: (0, (/*@__PURE__*/$parcel$interopDefault($cT3Ey))).bool,
            children: (0, (/*@__PURE__*/$parcel$interopDefault($cT3Ey))).func.isRequired,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($cT3Ey))).func
        };
    }
    static{
        this.defaultProps = {
            isReorderEnabled: false,
            isInteractive: true,
            isVariableHeight: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    renderDraggableCard() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e8YwC.Draggable), {
            draggableId: this.props.item.id,
            index: this.props.index
        }, (provided, snapshot)=>{
            const cardJSX = this.renderCard({
                ref: provided.innerRef,
                isDraggable: true,
                isDragging: snapshot.isDragging,
                ...provided.draggableProps,
                ...this.patchedHandlers(provided.dragHandleProps, snapshot)
            });
            return (0, $7jTnu.fg)('issue-view_item-line-card-a11y-clone') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7e1bd48c01f4aca6$var$CardContainer, null, cardJSX) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7e1bd48c01f4aca6$var$DraggableCardContainer, null, cardJSX);
        });
    }
    render() {
        if (this.props.isReorderEnabled) return this.renderDraggableCard();
        if ((0, $7jTnu.fg)('issue-view_item-line-card-a11y-clone')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7e1bd48c01f4aca6$var$CardContainer, null, this.renderCard({
            ...this.eventHandlers
        }));
        return this.renderCard({
            ...this.eventHandlers
        });
    }
    constructor(...args){
        super(...args), this.state = {
            isHovering: false,
            isActive: false,
            isFocused: false
        }, this.eventHandlers = {
            onBlur: ()=>{
                this.setState({
                    isFocused: false
                });
            },
            onClick: (event)=>{
                // best practice to use for react-beautiful-dnd (https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/how-we-use-dom-events.md)
                if (event.defaultPrevented === true) return;
                // Middle clicks are handled in onMouseDown for cross browser support.
                if (!$7e1bd48c01f4aca6$var$isMiddleClick(event)) this.propagateClick(event);
            },
            onDragEnd: ()=>this.setState({
                    isActive: false
                }),
            onFocus: ()=>{
                this.setState({
                    isFocused: true
                });
            },
            onMouseEnter: ()=>this.setState({
                    isHovering: true
                }),
            onMouseLeave: ()=>this.setState({
                    isHovering: false,
                    isActive: false
                }),
            onMouseDown: (event)=>{
                if ($7e1bd48c01f4aca6$var$isMiddleClick(event)) this.propagateClick(event);
                this.setState({
                    isActive: true
                });
            },
            onMouseUp: ()=>this.setState({
                    isActive: false
                })
        }, this.propagateClick = (event)=>{
            this.props.onClick(this.props.item, event);
        }, this.patchedHandlers = (dragHandleProps, snapshot)=>{
            /* The 'isActive' state is determined by the draggable state,
             i.e. if isDragging then the state is considered active. */ const onMouseDown = (event)=>{
                if ($7e1bd48c01f4aca6$var$isMiddleClick(event)) this.propagateClick(event);
            };
            const onClick = !dragHandleProps ? this.eventHandlers.onClick : (event)=>{
                if (!snapshot.isDragging) this.eventHandlers.onClick(event);
            };
            return {
                ...dragHandleProps,
                ...this.eventHandlers,
                onClick: onClick,
                onMouseDown: onMouseDown
            };
        }, this.renderCard = (cardProps)=>{
            const { isInteractive: isInteractive, item: item, isVariableHeight: isVariableHeight } = this.props;
            const { isHovering: isHovering, isFocused: isFocused } = this.state;
            const isActive = Boolean(cardProps.isDragging) || this.state.isActive;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7e1bd48c01f4aca6$var$Card, {
                ...cardProps,
                ...this.state,
                isInteractive: isInteractive,
                isActive: isActive,
                isVariableHeight: isVariableHeight
            }, this.props.children(isHovering, isActive, isFocused, item));
        };
    }
}

});


parcelRegister("8V4gK", function(module, exports) {
$parcel$export(module.exports, "default", () => $f88e2dac132980d9$export$2e2bcd8739ae039);
/* issue-line-card-view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $k71qx = parcelRequire("k71qx");

var $bQyn2 = parcelRequire("bQyn2");

var $7keuM = parcelRequire("7keuM");

var $7qGN1 = parcelRequire("7qGN1");
var $6YFG2 = parcelRequire("6YFG2");

var $liqxH = parcelRequire("liqxH");

var $eaTQ3 = parcelRequire("eaTQ3");

var $814y1 = parcelRequire("814y1");

var $ljej9 = parcelRequire("ljej9");
const $f88e2dac132980d9$var$messages = (0, $7qGN1.defineMessages)({
    issueTypeTitle: {
        "id": "servicedesk-issue-line-card-group.common.utils.issue-line-card.issue-line-card-view.issue-type-title",
        "defaultMessage": "Issue type: {issueTypeName}"
    },
    issuePriorityTitle: {
        "id": "servicedesk-issue-line-card-group.common.utils.issue-line-card.issue-line-card-view.issue-priority-title",
        "defaultMessage": "Priority: {issuePriorityName}"
    }
});
const { DONE: $f88e2dac132980d9$var$DONE } = (0, $7keuM);
const $f88e2dac132980d9$var$priorityIconSize = 20;
class $f88e2dac132980d9$export$647087a665973f7e extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isHovering: false,
            isActive: false,
            isFocused: false,
            hasError: false,
            onDelete: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    shouldRenderKey() {
        return !!this.props.issueKey;
    }
    isActionVisible() {
        return this.props.isActive !== true && (this.props.isHovering === true || this.props.isFocused === true);
    }
    deleteButtonAction(e) {
        e.stopPropagation();
        if (this.props.issueKey) this.props.onDelete(this.props.issueKey);
    }
    renderAssigneeInteractive() {
        const { issueKey: issueKey } = this.props;
        if (issueKey === undefined) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f88e2dac132980d9$var$PaddedFlexContainer, {
            role: "button",
            onClick: (e)=>e.preventDefault(),
            onFocus: (e)=>e.stopPropagation(),
            onKeyDown: (e)=>(e.key === 'Enter' || e.key === 'Space') && e.stopPropagation(),
            tabIndex: 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $liqxH.AsyncIssueAssigneeField), {
            issueKey: (0, $ljej9.toIssueKey)(issueKey)
        }));
    }
    renderPriority() {
        const { intl: intl, issuePriorityUrl: issuePriorityUrl, issuePriorityName: issuePriorityName } = this.props;
        if (issuePriorityUrl === null || issuePriorityUrl === undefined || !issuePriorityUrl.length) return null;
        const title = intl.formatMessage($f88e2dac132980d9$var$messages.issuePriorityTitle, {
            issuePriorityName: issuePriorityName
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: issuePriorityName || '',
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQyn2.default), {
            alt: title,
            url: issuePriorityUrl,
            width: $f88e2dac132980d9$var$priorityIconSize,
            height: $f88e2dac132980d9$var$priorityIconSize
        }));
    }
    renderError() {
        if (this.props.hasError !== true && !this.props.errorInlineMessage) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f88e2dac132980d9$var$PaddedFlexContainer, {
            onClick: this.handleErrorDialogClick,
            onMouseDown: this.handleErrorDialogMouseDown,
            role: "button",
            tabIndex: 0,
            onKeyDown: (e)=>(e.key === 'Enter' || e.key === 'Space') && this.handleErrorDialogClick
        }, this.props.errorInlineMessage);
    }
    renderSummary() {
        const { isActive: isActive, issueSummary: issueSummary } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f88e2dac132980d9$var$Summary // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        , {
            "data-testid": "issue.issue-view.views.common.issue-line-card.issue-line-card-view.summary" // @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
            ,
            isActive: isActive
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: issueSummary,
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f88e2dac132980d9$export$35cd4d671a6f3dc7, null, issueSummary)));
    }
    renderKey() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f88e2dac132980d9$var$Key // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        , {
            "data-testid": "issue.issue-view.views.common.issue-line-card.issue-line-card-view.key",
            href: this.props.issueLink,
            isActive: this.props.isActive,
            isDone: this.props.statusCategory === $f88e2dac132980d9$var$DONE,
            onClick: this.handleLinkKeyClick
        }, this.props.issueKey);
    }
    renderType() {
        const { intl: intl, issueTypeIconUrl: issueTypeIconUrl, issueTypeName: issueTypeName } = this.props;
        if (issueTypeName === null || issueTypeName === undefined || !issueTypeName.length) return null;
        const title = intl.formatMessage($f88e2dac132980d9$var$messages.issueTypeTitle, {
            issueTypeName: issueTypeName
        }); // Using an intermediate div since AKTooltip needs an element to bind to
        // We aren't wrapping just ListIcon or AsyncIcon since AKTooltip is stateful
        // and we don't want it to unmount as the mouseHover changes
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: issueTypeName,
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f88e2dac132980d9$var$FlexContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQyn2.default), {
            alt: title,
            url: issueTypeIconUrl
        }))));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f88e2dac132980d9$var$Card, null, this.renderType(), this.shouldRenderKey() && this.renderKey(), this.renderSummary(), this.renderPriority(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f88e2dac132980d9$var$ConnectedIssueAssigneeContainer, null, this.renderAssigneeInteractive()), this.renderError());
    }
    constructor(...args){
        super(...args), this.handleErrorDialogClick = (e)=>{
            e.stopPropagation();
        }, this.handleErrorDialogMouseDown = (e)=>{
            e.preventDefault();
            e.stopPropagation();
        }, this.handleLinkKeyClick = (e)=>{
            e.preventDefault();
            if (this.props.issueLink !== undefined && this.props.issueLink !== null && this.props.issueLink.length) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(this.props.issueLink, '_blank');
        };
    }
}
// DO NOT MODIFY THIS. TODO FLY-448 - consider changing this to use @atlassian/jira-issue-line-card instead
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f88e2dac132980d9$var$IssueLineCardWithHooks = (props)=>{
    // tipying this causes a ripple effect everywhere else
    const { issueKey: issueKey = (0, $ljej9.toIssueKey)('') } = props;
    const [assignee] = (0, $eaTQ3.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $814y1.ASSIGNEE_TYPE)
    });
    const shouldShowInteractiveAssignee = assignee !== undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f88e2dac132980d9$export$647087a665973f7e, {
        shouldShowInteractiveAssignee: shouldShowInteractiveAssignee,
        ...props
    });
}; // eslint-disable-next-line jira/js/no-inject-intl-if-functional-component
var $f88e2dac132980d9$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
 = (0, $6YFG2.default)($f88e2dac132980d9$var$IssueLineCardWithHooks);
const $f88e2dac132980d9$var$FlexContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f88e2dac132980d9$var$ConnectedIssueAssigneeContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_lcxvglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f88e2dac132980d9$var$Card = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $f88e2dac132980d9$var$FlexContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1osq _4t3i1osq _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f88e2dac132980d9$var$PaddedFlexContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $f88e2dac132980d9$var$FlexContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19bvu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f88e2dac132980d9$var$Key = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, isDone: isDone, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _11c8dcr7 _18u0u2gc _k48p1pd9 _o5721q9c _1q5t1r31 _1dit1r31 _q1at1r31 _9nxe1r31 _1ohyglyw _ksodglyw _q4asglyw _tpgfglyw _1r9x1o36 _4hz81o36 _dlvh1o36 _12gr1o36",
            __cmplp.isActive ? "_syazaqb7" : "_syaz131l",
            __cmplp.isDone ? "_4bfu18uv _1hms1911 _ajmmnqa1" : "_4bfu18uv _1hmsglyw _ajmmnqa1",
            __cmplp.isActive ? "_9h8haqb7 _30l3aqb7 _ysv7aqb7 _1053aqb7" : "_9h8h131l _30l3131l _ysv7131l _1053131l",
            __cmplp.isDone ? "_1nrm18uv _9oik18uv _5bd618uv _1ydc18uv _c2wa1911 _1bnx1911 _13jx1911 _1x281911 _1iohnqa1 _jf4cnqa1 _xatrnqa1 _1726nqa1" : "_1nrm18uv _9oik18uv _5bd618uv _1ydc18uv _c2waglyw _1bnxglyw _13jxglyw _1x28glyw _1iohnqa1 _jf4cnqa1 _xatrnqa1 _1726nqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f88e2dac132980d9$var$Summary = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _19bvu2gc _o5721q9c _1bto1l2s",
            __cmplp.isActive && "_syazaqb7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $f88e2dac132980d9$export$35cd4d671a6f3dc7 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bQyn2", function(module, exports) {
$parcel$export(module.exports, "default", () => $69a57831c94bcd51$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $69a57831c94bcd51$var$defaultIconSize = 16;
/* Represents an asynchronous icon loader that handles loading of icons from URLs with error handling.
 * It displays the icon fetched from the provided URL. In case of an error or if the URL is undefined,
 * a fallback UI component or placeholder is displayed.
 * This component accepts various props like URL, title, alt text, dimensions, and a fallback component
 * to customize the behavior and presentation of the loaded or placeholder icon.
 * The component also includes functionality to prevent the icon from being draggable.
 */ const $69a57831c94bcd51$var$AsyncIcon = /*#__PURE__*/ (0, $eJOHy.memo)(({ url: url, title: title, alt: alt, width: width, height: height, fallback: fallback })=>{
    const [isBroken, setIsBroken] = (0, $eJOHy.useState)(false);
    const onError = (0, $eJOHy.useCallback)(()=>{
        setIsBroken(true);
    }, []);
    const convertSize = (0, $eJOHy.useCallback)((size)=>size ? `${size}px` : '0', []);
    if (isBroken && fallback) return fallback();
    const convertedWidth = convertSize(width ?? $69a57831c94bcd51$var$defaultIconSize);
    const convertedHeight = convertSize(height ?? $69a57831c94bcd51$var$defaultIconSize);
    if (url) return /*#__PURE__*/ $eJOHy.createElement($69a57831c94bcd51$var$Image, {
        src: url,
        width: convertedWidth,
        height: convertedHeight,
        title: title ?? undefined,
        alt: alt ?? '',
        onError: onError,
        /**
     * Disabling dragging so drags happen on the parent instead of this icon.
     */ draggable: false,
        "data-vc": "common-components-async-icon"
    });
    return /*#__PURE__*/ $eJOHy.createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            height: convertedHeight,
            width: convertedWidth
        },
        "data-testid": "common-components-async-icon.placeholder",
        className: (0, $hcewu.default)([
            "_2rkofajl _16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _bfhk1d5g"
        ])
    });
});
const $69a57831c94bcd51$var$placeholderStyles = null;
// Firefox displays the alt text when the image can't load, the narrow provided width
// means this alt text leaks into the summary vertically if overflow is allowed
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $69a57831c94bcd51$var$Image = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});
$69a57831c94bcd51$var$AsyncIcon.displayName = 'AsyncIcon';
var $69a57831c94bcd51$export$2e2bcd8739ae039 = $69a57831c94bcd51$var$AsyncIcon;

});

parcelRegister("liqxH", function(module, exports) {
$parcel$export(module.exports, "AsyncLazyIssueAssigneeField", () => $b6632c4944cd149c$export$3eed76542de607d2);
$parcel$export(module.exports, "AsyncIssueAssigneeField", () => $b6632c4944cd149c$export$5cdab73b9e0803a1);
$parcel$export(module.exports, "IssueAssigneeFieldBoundary", () => $b6632c4944cd149c$export$9b541007f4ef3ffe);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $h47gY = parcelRequire("h47gY");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

var $15LmV = parcelRequire("15LmV");

const $b6632c4944cd149c$export$3eed76542de607d2 = (0, $bQWwW.lazy)(()=>Promise.resolve((parcelRequire("20vtc"))), {
    moduleId: "./src/packages/issue/fields/assignee/src/ui/popover/index.tsx"
});
const $b6632c4944cd149c$export$5cdab73b9e0803a1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "issue-field-assignee",
        packageName: "jira-issue-field-assignee",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $15LmV.AssigneePickerView), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "issue-assignee-field",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $15LmV.AssigneePickerView), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b6632c4944cd149c$export$3eed76542de607d2, props)));
const $b6632c4944cd149c$export$9b541007f4ef3ffe = ({ children: children, fallback: fallback, packageName: packageName, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "issue-assignee-field",
        packageName: packageName,
        fallback: fallback ? ()=>fallback : undefined,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "issue-assignee-field-boundary",
        fallback: fallback
    }, children));

});
parcelRegister("15LmV", function(module, exports) {
$parcel$export(module.exports, "AssigneePickerView", () => $94b9eee935519b19$export$7df43f1214c1ab94);
$parcel$export(module.exports, "AvatarWrapper", () => $94b9eee935519b19$export$f7513421c53ce141);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5DgXR = parcelRequire("5DgXR");

var $k71qx = parcelRequire("k71qx");

var $dTocu = parcelRequire("dTocu");


var $30Vch = parcelRequire("30Vch");

var $jYxsf = parcelRequire("jYxsf");
const $94b9eee935519b19$export$7df43f1214c1ab94 = ({ value: value })=>{
    const intl = (0, $dTocu.useIntlV2)();
    const unassigned = (0, $30Vch.getUnassignedUser)(intl);
    const user = value || unassigned;
    const assigneeName = user.accountId === (0, $ee8519ef4d8fa2c0$export$bdab9bfb39981463) ? user.displayName : intl.formatMessage((0, $jYxsf.default).assigneeTooltip, {
        name: user.displayName
    });
    const avatarUrl = (0, $30Vch.getUserAvatarUrl)(user);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($94b9eee935519b19$export$f7513421c53ce141, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: assigneeName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        testId: "issue-field-assignee.common.ui.read-view.popover.avatar",
        size: "small",
        src: avatarUrl,
        name: assigneeName,
        borderColor: "transparent"
    })));
};
var $94b9eee935519b19$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = $94b9eee935519b19$export$7df43f1214c1ab94;
const $94b9eee935519b19$export$f7513421c53ce141 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1f4h _4t3i1f4h _vchhusvi _80om73ad",
            __cmplp.className
        ])
    });
});

});
const $ee8519ef4d8fa2c0$export$bdab9bfb39981463 = '__UNASSIGNED_ID__';
const $ee8519ef4d8fa2c0$export$d875316cb0cd94f7 = '__INVITE_PEOPLE_ID__';
const $ee8519ef4d8fa2c0$export$f5d5f6bb902f1027 = '-1';

parcelRegister("30Vch", function(module, exports) {
$parcel$export(module.exports, "getUnassignedUser", () => $099fe508ffcd564f$export$42c5a0b65ef9ee80);
$parcel$export(module.exports, "getAutomaticUserOption", () => $099fe508ffcd564f$export$8d7a63500893c8c);
$parcel$export(module.exports, "getInvitePeopleOption", () => $099fe508ffcd564f$export$84a82764cf0a696e);
$parcel$export(module.exports, "getUserOptionFromUser", () => $099fe508ffcd564f$export$16086438354dcc85);
$parcel$export(module.exports, "getUserFromUserOption", () => $099fe508ffcd564f$export$78a8bcc5bd21caa2);
$parcel$export(module.exports, "getUserAvatarUrl", () => $099fe508ffcd564f$export$7d801d84202c7743);
$parcel$export(module.exports, "getUserShape", () => $099fe508ffcd564f$export$322b6ab8c29a006e);

var $75erM = parcelRequire("75erM");

var $khZGg = parcelRequire("khZGg");

const $099fe508ffcd564f$export$42c5a0b65ef9ee80 = ({ formatMessage: formatMessage })=>({
        accountId: (0, $ee8519ef4d8fa2c0$export$bdab9bfb39981463),
        displayName: formatMessage((0, $75erM.default).unassignedOption),
        avatarUrls: {}
    });
const $099fe508ffcd564f$export$8d7a63500893c8c = ({ formatMessage: formatMessage })=>({
        accountId: (0, $ee8519ef4d8fa2c0$export$f5d5f6bb902f1027),
        displayName: formatMessage((0, $75erM.default).automaticOption),
        avatarUrls: {}
    });
const $099fe508ffcd564f$export$84a82764cf0a696e = ({ formatMessage: formatMessage }, isAdmin)=>({
        accountId: (0, $ee8519ef4d8fa2c0$export$d875316cb0cd94f7),
        displayName: formatMessage(isAdmin ? (0, $75erM.default).invitePeopleOptionAdmin : (0, $75erM.default).invitePeopleOption),
        avatarUrls: {
            '48x48': (0, (/*@__PURE__*/$parcel$interopDefault($khZGg)))
        }
    });
const $099fe508ffcd564f$export$16086438354dcc85 = ({ accountId: accountId, displayName: displayName, avatarUrls: avatarUrls, emailAddress: emailAddress })=>({
        id: accountId || '',
        name: displayName,
        avatarUrl: avatarUrls['48x48'],
        // @ts-expect-error Will be part of JIV-13488; `user.emailAddress` returned by the REST API can be null depending on their privacy settings
        byline: emailAddress
    });
const $099fe508ffcd564f$export$78a8bcc5bd21caa2 = ({ id: id, name: name, avatarUrl: avatarUrl })=>({
        accountId: id,
        displayName: name,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });
const $099fe508ffcd564f$export$7d801d84202c7743 = ({ avatarUrls: avatarUrls })=>avatarUrls['48x48'];
const $099fe508ffcd564f$export$322b6ab8c29a006e = (accountId, displayName, avatarUrl)=>({
        accountId: accountId,
        displayName: displayName,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });

});
parcelRegister("75erM", function(module, exports) {
$parcel$export(module.exports, "default", () => $7306fd7bf3880cfd$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $7306fd7bf3880cfd$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    unassignedOption: {
        "id": "issue-field-assignee.unassigned-option",
        "defaultMessage": "Unassigned"
    },
    automaticOption: {
        "id": "issue-field-assignee.automatic-option",
        "defaultMessage": "Automatic"
    },
    assignToMe: {
        "id": "issue-field-assignee.assign-to-me",
        "defaultMessage": "Assign to me"
    },
    searchForAssignee: {
        "id": "issue-field-assignee.search-for-assignee",
        "defaultMessage": "Search for assignee"
    },
    invitePeopleOption: {
        "id": "issue-field-assignee.invite-people-option",
        "defaultMessage": "Add teammate to Jira"
    },
    invitePeopleOptionAdmin: {
        "id": "issue-field-assignee.invite-people-option-admin",
        "defaultMessage": "Invite teammate to Jira"
    }
});

});

parcelRegister("khZGg", function(module, exports) {
module.exports = new URL("add.b8fea212.png", import.meta.url).toString();

});


parcelRegister("jYxsf", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4d6078751615e63$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c4d6078751615e63$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    assigneeTooltip: {
        "id": "issue-field-assignee.common.read-view.popover.assignee-tooltip",
        "defaultMessage": "Assignee: {name}"
    }
});

});



parcelRegister("eaTQ3", function(module, exports) {
$parcel$export(module.exports, "useFieldValue", () => $626f51b4fb1f2379$export$b79fae7fbe3ac392);
$parcel$export(module.exports, "useFieldsValues", () => $626f51b4fb1f2379$export$25b73e671fe7a8fa);
$parcel$export(module.exports, "useMultiFieldValuesForIssues", () => $626f51b4fb1f2379$export$915cdeec521b54f7);
$parcel$export(module.exports, "FieldValueSubscriber", () => $626f51b4fb1f2379$export$4e5f1f4ed08d155e);
$parcel$export(module.exports, "useFieldsValuesActions", () => $626f51b4fb1f2379$export$612d9bcb0c9d8976);

var $eJOHy = parcelRequire("eJOHy");

var $1O6Yz = parcelRequire("1O6Yz");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");
const $626f51b4fb1f2379$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: fields
        });
    };
const $626f51b4fb1f2379$var$setIssues = (issues)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState(newIssues);
    };
const $626f51b4fb1f2379$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: value
            }
        });
    };
const $626f51b4fb1f2379$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
        const issueFieldValues = getState()[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
const $626f51b4fb1f2379$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, getState()[issueKey], fields)
        });
    };
const $626f51b4fb1f2379$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
        if (issues.length === 0) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, getState(), newIssues));
    };
const $626f51b4fb1f2379$var$actions = {
    setFieldValue: $626f51b4fb1f2379$var$setFieldValue,
    getFieldValue: $626f51b4fb1f2379$var$getFieldValue,
    setIssue: $626f51b4fb1f2379$var$setIssue,
    mergeIssue: $626f51b4fb1f2379$var$mergeIssue,
    setIssues: $626f51b4fb1f2379$var$setIssues,
    mergeIssues: $626f51b4fb1f2379$export$11aa02e14fdf7753
};
// this is a global store
const $626f51b4fb1f2379$var$store = (0, $GtRbT.createStore)({
    name: 'issue-fields',
    initialState: {},
    actions: $626f51b4fb1f2379$var$actions
});
const $626f51b4fb1f2379$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
    const issueFieldValues = state[issueKey];
    return issueFieldValues && issueFieldValues[fieldKey];
};
const $626f51b4fb1f2379$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$626f51b4fb1f2379$var$getFieldValueSelector(state, {
            fieldKey: fieldKey,
            issueKey: issueKey
        }));
const $626f51b4fb1f2379$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
        if (!state[issueKey]) return accumulator;
        const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
            acc[fieldKey] = $626f51b4fb1f2379$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            });
            return acc;
        }, {});
        accumulator[issueKey] = fieldValue;
        return accumulator;
    }, {});
const $626f51b4fb1f2379$var$getAllFields = (state, issueKey)=>state[issueKey];
const $626f51b4fb1f2379$export$b79fae7fbe3ac392 = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getFieldValueSelector
});
const $626f51b4fb1f2379$export$25b73e671fe7a8fa = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getAllFields
});
const $626f51b4fb1f2379$export$ac289b84121829df = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getFieldValuesForIssuesSelector
});
const $626f51b4fb1f2379$export$915cdeec521b54f7 = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getMultiFieldValuesForIssuesSelector
});
const $626f51b4fb1f2379$export$4e5f1f4ed08d155e = (0, $ht3nQ.createSubscriber)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getFieldValueSelector
});
const $626f51b4fb1f2379$var$useFieldValueStoreActions = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: null
});
const $626f51b4fb1f2379$export$612d9bcb0c9d8976 = ()=>{
    const [, fieldValueStoreActions] = $626f51b4fb1f2379$var$useFieldValueStoreActions();
    const fieldsValuesActions = (0, $eJOHy.useMemo)(()=>{
        const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
        const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
        const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
        const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
        const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
        return {
            setIssue: setIssueAction,
            setFieldValue: setFieldValueAction,
            getFieldValue: getFieldValueAction,
            mergeIssue: mergeIssueAction,
            setIssues: setIssuesAction,
            mergeIssues: mergeIssuesAction
        };
    }, [
        fieldValueStoreActions
    ]);
    return [
        null,
        fieldsValuesActions
    ];
};

});



parcelRegister("47BDS", function(module, exports) {
$parcel$export(module.exports, "default", () => $b05cd26fc9d4f68a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b05cd26fc9d4f68a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorStateHeader: {
        "id": "servicedesk-insight-object-graph.object-view.linked-issues.error-state-header",
        "defaultMessage": "We couldn't fetch the linked issues for this object"
    },
    errorStateHeaderIssueTermRefresh: {
        "id": "servicedesk-insight-object-graph.object-view.linked-issues.error-state-header-issue-term-refresh",
        "defaultMessage": "We couldn't fetch the linked work items for this object"
    },
    errorStateDescription: {
        "id": "servicedesk-insight-object-graph.object-view.linked-issues.error-state-description",
        "defaultMessage": "Try reloading the page."
    },
    noLinkedIssues: {
        "id": "servicedesk-insight-object-graph.object-view.linked-issues.no-linked-issues",
        "defaultMessage": "No linked issues"
    },
    noLinkedIssuesIssueTermRefresh: {
        "id": "servicedesk-insight-object-graph.object-view.linked-issues.no-linked-issues-issue-term-refresh",
        "defaultMessage": "No linked work items"
    }
});

});


parcelRegister("lkrGD", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b79d89357d4c257$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $6b79d89357d4c257$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    objectDetails: {
        "id": "servicedesk-insight-object-graph.object-view.object-details",
        "defaultMessage": "Object details"
    },
    linkedIssues: {
        "id": "servicedesk-insight-object-graph.object-view.linked-issues",
        "defaultMessage": "Linked issues"
    },
    linkedIssuesIssueTermRefresh: {
        "id": "servicedesk-insight-object-graph.object-view.linked-issues-issue-term-refresh",
        "defaultMessage": "Linked work items"
    },
    linkedPages: {
        "id": "servicedesk-insight-object-graph.object-view.linked-pages",
        "defaultMessage": "Linked pages"
    },
    openObjectDetailsPage: {
        "id": "servicedesk-insight-object-graph.object-view.open-object-details-page",
        "defaultMessage": "Open in object details page"
    },
    refreshButton: {
        "id": "servicedesk-insight-object-graph.object-view.refresh-button",
        "defaultMessage": "Refresh"
    },
    errorTitle: {
        "id": "servicedesk-insight-object-graph.object-view.error-title",
        "defaultMessage": "We couldn't display this object."
    },
    errorDescription: {
        "id": "servicedesk-insight-object-graph.object-view.error-description",
        "defaultMessage": "Refresh the page and try again."
    }
});

});

parcelRegister("coe0R", function(module, exports) {
$parcel$export(module.exports, "getPositionFromObjectAttribute", () => $4d1ce8db5d378ac7$export$181ea8d28ce9cd35);
const $4d1ce8db5d378ac7$export$181ea8d28ce9cd35 = (attribute)=>attribute.objectTypeAttribute?.position ?? Infinity;

});


parcelRegister("i1PEV", function(module, exports) {
$parcel$export(module.exports, "getNormalizedGraphData", () => $74fc2583cab95390$export$34e9eaff58eacd53);
$parcel$export(module.exports, "getFilteredEdgesAndNodes", () => $74fc2583cab95390$export$24f0dc2bbb91dd1a);
$parcel$export(module.exports, "getConnectedNodesFromParent", () => $74fc2583cab95390$export$3c9910179eb68b3b);


var $7g3Zh = parcelRequire("7g3Zh");
const $74fc2583cab95390$var$normalizeNode = (n)=>({
        id: `${n.type}${n.id}`,
        value: n.id,
        /**
	 * TODO We should consider that 'Object Type' and 'Object' nodes are
	 * visually identical but behave differently when clicked. The server
	 * version of the graph gets around this by appending (Type) to 'Object
	 * Type' node names. However that approach would require injecting intl
	 * functions into this transformer function which isn't ideal in this case.
	 */ name: n.name,
        draggable: true,
        symbol: `image://${n.icon}`,
        symbolSize: (0, $1b8b2de41d1fcbdf$export$7093ae9f18906e17),
        context: {
            type: n.type,
            name: n.name,
            id: n.id,
            icon: n.icon,
            objectSchemaId: n.objectSchemaId
        }
    });
const $74fc2583cab95390$var$normalizeEdge = (e)=>({
        name: e.label,
        source: e.from,
        target: e.to,
        lineStyle: {
            color: e.color,
            ...(0, $7g3Zh.DEFAULT_LINE_STYLE)
        },
        symbolSize: 8
    });
const $74fc2583cab95390$export$34e9eaff58eacd53 = (insightGraphData)=>{
    const { nodes: nodes = [], edges: edges = [] } = insightGraphData ?? {};
    const normalizedEdges = edges.map($74fc2583cab95390$var$normalizeEdge);
    const normalizedNodes = nodes.map($74fc2583cab95390$var$normalizeNode);
    return {
        nodes: normalizedNodes,
        edges: normalizedEdges
    };
};
const $74fc2583cab95390$export$24f0dc2bbb91dd1a = (objectGraphData, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
referenceTypes, selectedObjectId)=>{
    const { nodes: nodes = [], edges: edges = [] } = objectGraphData ?? {};
    const enabledReferenceTypes = referenceTypes.filter((r)=>r.checked === true);
    const updatedEdges = edges.filter((edge)=>enabledReferenceTypes.some((r)=>r.to.includes(edge.to)) && enabledReferenceTypes.some((r)=>r.from.includes(edge.from)));
    const updatedNodes = nodes.filter((node)=>// always include the currently selected node (even with no outgoing edges)
        node.id === selectedObjectId || updatedEdges.find((e)=>e.to.slice(1) === node.id) || updatedEdges.find((e)=>e.from.slice(1) === node.id));
    return {
        nodes: updatedNodes,
        edges: updatedEdges
    };
};
const $74fc2583cab95390$export$3c9910179eb68b3b = (objectGraphData, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
parentObjectId)=>{
    const { nodes: nodes = [], edges: edges = [] } = objectGraphData ?? {};
    const parentObject = nodes.find((n)=>n.id === parentObjectId);
    const updatedNodes = parentObject ? [
        parentObject
    ] : [];
    const updatedEdges = [];
    // TODO: can potentially refactor the way this logic works to be more efficient
    // every time we add a new connection, we want to re-iterate to ensure we add additional valid connections to those new nodes we added in the previous iteration
    let shouldTraverseEdges = true;
    while(shouldTraverseEdges){
        shouldTraverseEdges = false;
        for (const edge of edges){
            const isAlreadyAdded = updatedEdges.some((existingEdge)=>existingEdge === edge);
            const hasValidConnection = updatedNodes.filter(Boolean).some((n)=>n.id === edge.to.slice(1) || n.id === edge.from.slice(1));
            if (!isAlreadyAdded && hasValidConnection) {
                shouldTraverseEdges = true;
                updatedEdges.push(edge);
                // whenever we add a valid edge we go through the existing nodes and add those that are connected via the edge to the result
                nodes.forEach((node)=>{
                    if (!updatedNodes.includes(node) && (node.id === edge.to.slice(1) || node.id === edge.from.slice(1))) updatedNodes.push(node);
                });
            }
        }
    }
    return {
        nodes: updatedNodes,
        edges: updatedEdges
    };
};

});
parcelRegister("7g3Zh", function(module, exports) {
$parcel$export(module.exports, "getDefaultSeriesConfig", () => $508699c0bbba7520$export$ed50ab7344ba4db3);
$parcel$export(module.exports, "DEFAULT_GRAPH_OPTIONS", () => $508699c0bbba7520$export$8e4937d7b59cfae5);
$parcel$export(module.exports, "SELECTED_NODE_OPTIONS", () => $508699c0bbba7520$export$156ec5ad21e61a8d);
$parcel$export(module.exports, "getDefaultNodeOptions", () => $508699c0bbba7520$export$326c176f3724490d);
$parcel$export(module.exports, "DEFAULT_LINE_STYLE", () => $508699c0bbba7520$export$e70fad7f87c3cb26);
$parcel$export(module.exports, "FIXED_NODE", () => $508699c0bbba7520$export$4453bb392d3bb402);
$parcel$export(module.exports, "UNFIXED_NODE", () => $508699c0bbba7520$export$3f07a18bcac46f86);
$parcel$export(module.exports, "DEFAULT_STYLES", () => $508699c0bbba7520$export$e0faacd43528e300);


var $2On2D = parcelRequire("2On2D");

var $cc8Bd = parcelRequire("cc8Bd");

const $508699c0bbba7520$var$defaultNodeLabelOverflow = {
    overflow: 'breakAll',
    width: 150
};
const $508699c0bbba7520$var$DARK_MODE_TEXT_COLOR = '#9fadbc';
const $508699c0bbba7520$var$DEFAULT_NODE_LABEL_LIGHT_MODE = {
    fontFamily: (0, $2On2D.default)('font.family.body', "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"),
    show: true,
    position: 'bottom',
    // Can't convert this to tokens/css-vars as it ends up in a 'canvas' context
    color: (0, $7bb4c1736002a04a$exports).N700,
    font: (0, $2On2D.default)('font.body.small', (0, $cc8Bd.fontFallback).body.small),
    ...$508699c0bbba7520$var$defaultNodeLabelOverflow
};
const $508699c0bbba7520$var$DEFAULT_NODE_LABEL_DARK_MODE = {
    ...$508699c0bbba7520$var$DEFAULT_NODE_LABEL_LIGHT_MODE,
    color: $508699c0bbba7520$var$DARK_MODE_TEXT_COLOR
};
const $508699c0bbba7520$export$719f6bf66d1dcb28 = (enableAnimation)=>({
        initLayout: 'circular',
        repulsion: (0, $1b8b2de41d1fcbdf$export$cf8a94c984678862),
        edgeLength: (0, $1b8b2de41d1fcbdf$export$434d30b064b8d4cf),
        friction: 1,
        layoutAnimation: enableAnimation
    });
const $508699c0bbba7520$export$ed50ab7344ba4db3 = (enableAnimation, isDarkMode)=>({
        type: 'graph',
        layout: 'force',
        roam: 'move',
        label: isDarkMode ? $508699c0bbba7520$var$DEFAULT_NODE_LABEL_DARK_MODE : $508699c0bbba7520$var$DEFAULT_NODE_LABEL_LIGHT_MODE,
        edgeSymbol: [
            'none',
            'arrow'
        ],
        symbolSize: (0, $1b8b2de41d1fcbdf$export$7093ae9f18906e17),
        force: $508699c0bbba7520$export$719f6bf66d1dcb28(enableAnimation),
        emphasis: {
            scale: false
        },
        animation: enableAnimation
    });
const $508699c0bbba7520$var$escapeHtml = (unsafe)=>unsafe.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
const $508699c0bbba7520$export$8e4937d7b59cfae5 = {
    tooltip: {
        padding: 4,
        // Can't convert this to tokens/css-vars as it ends up in a 'canvas' context
        backgroundColor: (0, $7bb4c1736002a04a$exports).N800,
        borderColor: '#333333',
        textStyle: {
            // Can't convert this to tokens/css-vars as it ends up in a 'canvas' context
            color: (0, $7bb4c1736002a04a$exports).N0,
            fontFamily: (0, $2On2D.default)('font.family.body', "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"),
            // Can't convert this to tokens/css-vars as it ends up in a 'canvas' context
            fontSize: 11
        },
        formatter: ({ data: data })=>{
            // @ts-expect-error - TS2339 - Property 'label' does not exist on type 'EchartsGraphNode'.
            const { name: name = '', label: label = '' } = data ?? {};
            return $508699c0bbba7520$var$escapeHtml(name ?? label);
        }
    }
};
const $508699c0bbba7520$export$156ec5ad21e61a8d = {
    label: {
        fontFamily: (0, $2On2D.default)('font.family.body', "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"),
        fontWeight: (0, $2On2D.default)('font.weight.bold', '700'),
        fontSize: 13,
        // don't truncate label when node is selected
        formatter: ({ name: name })=>name
    }
};
const $508699c0bbba7520$export$326c176f3724490d = (isDarkMode)=>({
        label: isDarkMode ? $508699c0bbba7520$var$DEFAULT_NODE_LABEL_DARK_MODE : $508699c0bbba7520$var$DEFAULT_NODE_LABEL_LIGHT_MODE
    });
const $508699c0bbba7520$export$e70fad7f87c3cb26 = {
    width: 0.8,
    opacity: 1,
    type: 'solid',
    curveness: 0.1
};
const $508699c0bbba7520$export$4453bb392d3bb402 = {
    fixed: true
};
const $508699c0bbba7520$export$3f07a18bcac46f86 = {
    fixed: false
};
const $508699c0bbba7520$export$e0faacd43528e300 = {
    height: '100%',
    width: '100%'
};

});
var $7bb4c1736002a04a$exports = {};
$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';




parcelRegister("7emTv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "AssetsObjectGraph", () => $dae6b27cc5281b1a$export$573b76330ba35de9);
$parcel$export(module.exports, "AssetsObjectGraphOrNull", () => $dae6b27cc5281b1a$export$dc9600340d59f76e);
$parcel$export(module.exports, "AssetsObjectGraphModal", () => $dae6b27cc5281b1a$export$a977f1b0b79c2218);
$parcel$export(module.exports, "default", () => $dae6b27cc5281b1a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $1aLTh = parcelRequire("1aLTh");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7skWy = parcelRequire("7skWy");

var $eDFE1 = parcelRequire("eDFE1");

var $3Vx3n = parcelRequire("3Vx3n");

var $fq0Uu = parcelRequire("fq0Uu");

var $f4WMd = parcelRequire("f4WMd");

var $956it = parcelRequire("956it");

var $7ep4S = parcelRequire("7ep4S");

var $k71qx = parcelRequire("k71qx");

var $Ay1uj = parcelRequire("Ay1uj");

var $6DVKI = parcelRequire("6DVKI");

var $aI5B2 = parcelRequire("aI5B2");

var $6QXXm = parcelRequire("6QXXm");

var $8kfYI = parcelRequire("8kfYI");

var $aTwtU = parcelRequire("aTwtU");

var $efPdM = parcelRequire("efPdM");

var $2ZGUP = parcelRequire("2ZGUP");

var $1KdDN = parcelRequire("1KdDN");

var $lRq8t = parcelRequire("lRq8t");

var $aC4Bh = parcelRequire("aC4Bh");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $8XHsn = parcelRequire("8XHsn");

var $8E59C = parcelRequire("8E59C");

var $eHeML = parcelRequire("eHeML");

var $fr3Es = parcelRequire("fr3Es");


var $ggKmh = parcelRequire("ggKmh");

var $1Kd5r = parcelRequire("1Kd5r");

var $4ZeQj = parcelRequire("4ZeQj");

var $6XJko = parcelRequire("6XJko");

var $jzwEl = parcelRequire("jzwEl");

var $2otBq = parcelRequire("2otBq");

var $ikpEg = parcelRequire("ikpEg");

var $fT8uq = parcelRequire("fT8uq");

var $21rPz = parcelRequire("21rPz");


var $lu2my = parcelRequire("lu2my");

var $kJzNO = parcelRequire("kJzNO");

var $dM8nW = parcelRequire("dM8nW");

var $jPx2I = parcelRequire("jPx2I");

var $rakSF = parcelRequire("rakSF");

var $28GgS = parcelRequire("28GgS");

var $U3bzc = parcelRequire("U3bzc");
const $dae6b27cc5281b1a$var$OBJECT_GRAPH_FADEIN_ANIMATION_DELAY = 500;
const $dae6b27cc5281b1a$export$573b76330ba35de9 = ({ objectId: objectId, objectTypeId: objectTypeId, onClose: onClose, source: source, disableResizePanel: disableResizePanel = false })=>{
    const [selectedNode, { setSelectedObjectNode: setSelectedObjectNode, setSelectedObjectTypeNode: setSelectedObjectTypeNode }] = (0, $21rPz.useSelectedNode)(objectId);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { workspaceId: workspaceId } = (0, $8XHsn.useWorkspaceContext)();
    const [sidebarState, { toggleSidebar: toggleSidebar, setSidebarWidth: setSidebarWidth }] = (0, $ggKmh.usePushingSidebar)({
        width: 560
    });
    const [isConfigPanelOpen, setIsConfigPanelOpen] = (0, $eJOHy.useState)(false);
    const [isGraphLayoutLocked, setIsGraphLayoutLocked] = (0, $eJOHy.useState)(true);
    const hasUpdatedObjectView = (0, $eJOHy.useRef)(false);
    const singleClickedNodeContext = (0, $eJOHy.useRef)(null);
    const [selectedObjectIdToDisplayObjectGraph, setSelectedObjectIdToDisplayObjectGraph] = (0, $eJOHy.useState)(objectId);
    const [{ data: objectGraphData, loading: graphLoading, error: graphError }, fetchObjectGraph] = (0, $1Kd5r.useObjectGraphService)();
    const [{ referenceTypes: referenceTypes, maxOfSameType: maxOfSameType, referenceDepth: referenceDepth }, { updateReferenceDepth: updateReferenceDepth, updateMaxOfSameType: updateMaxOfSameType, updateReferenceTypes: updateReferenceTypes }] = (0, $fT8uq.useObjectGraphConfiguration)(objectGraphData, objectTypeId);
    const [, { refreshSearch: refreshSearch }] = (0, $efPdM.useObjectSearchStoreState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fetchGraphData = (0, $eJOHy.useCallback)((objId)=>{
        if (workspaceId) fetchObjectGraph({
            workspaceId: workspaceId,
            objectId: (0, $4ZeQj.toCmdbObjectId)(objId),
            depth: referenceDepth,
            maxOfSameType: maxOfSameType
        });
    }, [
        fetchObjectGraph,
        maxOfSameType,
        referenceDepth,
        workspaceId
    ]);
    const transformedGraphData = (0, $eJOHy.useMemo)(()=>{
        // the initial graph data response goes through a series of transformations before it renders:
        // 1. we filter the nodes & edges based on the currently selected reference types in the object graph configuration panel
        // 2. we only show nodes that have a connection (either direct or indirect) to the currently selected object based on that filtering
        // 3. we then transform the result of that into a data shape the force graph library expects
        const filteredBySelectedReferenceTypes = (0, $U3bzc.getFilteredEdgesAndNodes)(objectGraphData, referenceTypes, selectedNode.referenceId);
        const nodesConnectedToSelectedNode = (0, $U3bzc.getConnectedNodesFromParent)(filteredBySelectedReferenceTypes, selectedNode.referenceId);
        return (0, $U3bzc.getNormalizedGraphData)(nodesConnectedToSelectedNode); // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        objectGraphData,
        referenceTypes
    ]);
    // in this case we do want to explicity exclude the reference id here
    (0, $eJOHy.useEffect)(()=>{
        fetchGraphData(objectId);
    }, [
        fetchGraphData,
        fetchObjectGraph,
        objectId,
        workspaceId
    ]);
    const onNodeClicked = (0, $eJOHy.useCallback)((selectedObjectData)=>{
        singleClickedNodeContext.current = selectedObjectData;
        const { data: data, dataType: dataType } = selectedObjectData;
        const { context: context } = data;
        if (dataType === (0, $6b5a3de1ca600c55$export$accaa52ddae3fe58) && context) {
            switch(context.type){
                case (0, $ikpEg.GRAPH_NODE_TYPES).OBJECT:
                    setSelectedObjectNode(context.id);
                    break;
                case (0, $ikpEg.GRAPH_NODE_TYPES).OBJECT_TYPE:
                    setSelectedObjectTypeNode(context);
                    break;
                default:
                    break;
            }
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'insightObjectGraphItem', {
                source: source
            });
        }
    }, [
        createAnalyticsEvent,
        setSelectedObjectNode,
        setSelectedObjectTypeNode,
        source
    ]);
    const onNodeDoubleClicked = (0, $eJOHy.useCallback)((selectedObjectData)=>{
        const { data: data, dataType: dataType } = selectedObjectData;
        const { context: context } = data;
        if (dataType === (0, $6b5a3de1ca600c55$export$accaa52ddae3fe58) && context?.type === (0, $ikpEg.GRAPH_NODE_TYPES).OBJECT) {
            setSelectedObjectIdToDisplayObjectGraph((0, $4ZeQj.toCmdbObjectId)(context.id));
            fetchGraphData(context.id);
        }
    }, [
        fetchGraphData
    ]);
    const onToggleLockedLayout = ()=>{
        const shouldLockGraph = !isGraphLayoutLocked;
        setIsGraphLayoutLocked(shouldLockGraph);
    };
    const HideObjectGraphDetailsIconComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, (/*@__PURE__*/$parcel$interopDefault($fq0Uu))) : (0, $eHeML.HideObjectGraphDetailsIcon);
    const ShowObjectGraphDetailsIconComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, (/*@__PURE__*/$parcel$interopDefault($f4WMd))) : (0, $eHeML.ShowObjectGraphDetailsIcon);
    const renderGraphError = ()=>{
        (0, $8E59C.graphModalExperience).failure();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jPx2I.GraphError), null);
    };
    const renderForceGraph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fr3Es.AsyncLazyForceGraph), {
            graphData: transformedGraphData,
            onNodeClick: onNodeClicked,
            onNodeDoubleClick: onNodeDoubleClicked,
            defaultSelectedNodeId: selectedNode.nodeId,
            isLayoutLocked: isGraphLayoutLocked
        });
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jzwEl.GraphHeader), {
        title: formatMessage((0, $rakSF.default).title),
        onClose: onClose,
        toggleGraphSideBarAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
            icon: sidebarState.isOpen ? HideObjectGraphDetailsIconComponent : ShowObjectGraphDetailsIconComponent,
            appearance: "subtle",
            onClick: (_, analyticsEvent)=>{
                (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'insightObjectGraphToggleDetailsPanel', {
                    action: sidebarState.isOpen ? 'hiding' : 'showing',
                    source: source
                });
                if (isConfigPanelOpen) setIsConfigPanelOpen(()=>false);
                toggleSidebar();
            },
            testId: "assets-object-graph.ui.graph-toggle-button",
            label: formatMessage(sidebarState.isOpen ? (0, $rakSF.default).hideDetail : (0, $rakSF.default).showDetail)
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6DVKI.GraphLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aI5B2.GraphWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1aLTh.default), {
        timeout: {
            exit: $dae6b27cc5281b1a$var$OBJECT_GRAPH_FADEIN_ANIMATION_DELAY
        },
        in: graphLoading,
        unmountOnExit: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $dae6b27cc5281b1a$var$spinnerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "large"
    }))), !graphLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dae6b27cc5281b1a$var$FadeIn, null, graphError ? renderGraphError() : renderForceGraph()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6QXXm.GraphActionsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lu2my.GraphConfigurationActionPanel), {
        isConfigPanelOpen: isConfigPanelOpen,
        onOpenChange: (isOpen)=>{
            // Only handle open events here. Close events are handled on the wrapper of this dialog because
            // otherwise clicks on the reference depth dropdown are considered "outside" this panel, and cause
            // the panel to close instead of updating the reference depth.
            isOpen && setIsConfigPanelOpen(true);
        },
        menuPosition: sidebarState.isOpen ? 'left' : 'right',
        renderActionButton: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                content: formatMessage(isConfigPanelOpen ? (0, $rakSF.default).hideGraphConfigPanel : (0, $rakSF.default).showGraphConfigPanel),
                position: "top"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ), {
                ref: triggerRef,
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($7skWy))),
                onClick: (event)=>{
                    if (isConfigPanelOpen) setIsConfigPanelOpen(false);
                    triggerProps.onClick?.(event);
                },
                label: formatMessage(isConfigPanelOpen ? (0, $rakSF.default).hideGraphConfigPanel : (0, $rakSF.default).showGraphConfigPanel),
                testId: "assets-object-graph.ui.graph-config-button"
            }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $dae6b27cc5281b1a$var$configPanelHeaderStyles,
        as: "h2"
    }, formatMessage((0, $rakSF.default).graphConfigPanelHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJzNO.ReferenceDepthConfigurationInputs), {
        maxOfSameType: maxOfSameType,
        referenceDepth: referenceDepth,
        onUpdateReferenceDepth: updateReferenceDepth,
        onUpdateMaxOfSameType: updateMaxOfSameType
    }), referenceTypes.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $dae6b27cc5281b1a$var$referenceTypeListHeaderStyles,
        as: "h3"
    }, formatMessage((0, $rakSF.default).referenceTypesHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dM8nW.ReferenceTypeToggleList), {
        referenceTypes: referenceTypes,
        onChange: updateReferenceTypes
    })) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage(isGraphLayoutLocked ? (0, $rakSF.default).unlockLayout : (0, $rakSF.default).lockLayout),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        appearance: "subtle",
        icon: isGraphLayoutLocked ? (0, (/*@__PURE__*/$parcel$interopDefault($eDFE1))) : (0, (/*@__PURE__*/$parcel$interopDefault($3Vx3n))),
        onClick: onToggleLockedLayout,
        isSelected: isGraphLayoutLocked,
        label: formatMessage(isGraphLayoutLocked ? (0, $rakSF.default).unlockLayout : (0, $rakSF.default).lockLayout)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2otBq.GraphPanelSplitter), {
        isOpen: sidebarState.isOpen,
        sidebarWidth: sidebarState.sidebarWidth,
        setSidebarWidth: setSidebarWidth,
        disableResizePanel: disableResizePanel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, selectedNode.type === (0, $ikpEg.GRAPH_NODE_TYPES).OBJECT && workspaceId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aTwtU.EmbeddedObjectView), {
        context: (0, $8kfYI.ObjectDetailsRenderingContext).ObjectGraph,
        objectId: selectedNode.referenceId,
        workspaceId: workspaceId,
        onUpdate: ()=>{
            hasUpdatedObjectView.current = true;
            refreshSearch();
        },
        onDelete: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onClone: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        redirectOnDelete: false,
        showFullBreadcrumbTrail: false,
        onFinishLoading: ()=>{
            if (hasUpdatedObjectView.current) {
                let objectIdToUpdate = selectedObjectIdToDisplayObjectGraph;
                if (singleClickedNodeContext.current?.data?.context) {
                    objectIdToUpdate = (0, $4ZeQj.toCmdbObjectId)(singleClickedNodeContext.current.data.context.id);
                    setSelectedObjectIdToDisplayObjectGraph(objectIdToUpdate);
                }
                fetchGraphData(objectIdToUpdate);
            }
            hasUpdatedObjectView.current = false;
            singleClickedNodeContext.current = null;
        }
    }), selectedNode.type === (0, $ikpEg.GRAPH_NODE_TYPES).OBJECT_TYPE && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $28GgS.ObjectTypeView), {
        objectTypeNode: selectedNode
    })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $dae6b27cc5281b1a$var$wrapperStyles,
        onClick: ()=>setIsConfigPanelOpen(false),
        role: "presentation",
        tabIndex: -1,
        onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    }, content);
};
const $dae6b27cc5281b1a$export$dc9600340d59f76e = (props)=>{
    if (props.objectId !== undefined && props.objectTypeId !== undefined) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dae6b27cc5281b1a$export$573b76330ba35de9, props);
    return null;
};
const $dae6b27cc5281b1a$export$a977f1b0b79c2218 = ({ objectId: objectId, objectTypeId: objectTypeId, onClose: onClose, source: source, testId: testId, isObjectGraphOpen: isObjectGraphOpen, disableResizePanel: disableResizePanel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, isObjectGraphOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "AssetsObjectGraph",
        packageName: "jiraAssetsObjectGraph",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aC4Bh.JiraModal), {
        width: (0, $f336ad0fcf5cc359$export$161cd349e5a4ad87),
        height: (0, $f336ad0fcf5cc359$export$668351e45c4a316f),
        onClose: onClose,
        autoFocus: false,
        stackIndex: 1,
        testId: testId,
        messageId: "assets-object-graph.ui.modal-dialog",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dae6b27cc5281b1a$export$dc9600340d59f76e, {
        objectId: objectId,
        objectTypeId: objectTypeId,
        onClose: onClose,
        source: source,
        isObjectGraphOpen: isObjectGraphOpen,
        disableResizePanel: disableResizePanel
    })))));
var $dae6b27cc5281b1a$export$2e2bcd8739ae039 = $dae6b27cc5281b1a$export$a977f1b0b79c2218;
const $dae6b27cc5281b1a$var$wrapperStyles = (0, $1DXK0.xcss)({
    height: 'calc(100% - 72px)',
    minHeight: '80px'
});
const $dae6b27cc5281b1a$var$spinnerWrapperStyles = (0, $1DXK0.xcss)({
    /* Using position absolute because the SpinnerWrapper and graph get rendered at the same time momentarily. */ /* This prevents the spinner from moving the graph position while they're both rendered */ position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $dae6b27cc5281b1a$var$fadeIn = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dae6b27cc5281b1a$var$FadeIn = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_tzy4idpf _4t3i1osq _1bsb1osq _j7hq1wwu _tip8kb7n _ju251bs3 _5sag1doz _1o51q7pw",
            __cmplp.className
        ])
    });
});
const $dae6b27cc5281b1a$var$configPanelHeaderStyles = (0, $1DXK0.xcss)({
    marginBottom: 'space.300'
});
const $dae6b27cc5281b1a$var$referenceTypeListHeaderStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.300'
});

});
parcelRegister("6DVKI", function(module, exports) {
$parcel$export(module.exports, "GraphLayout", () => $410c9733db633c5a$export$d287819c2da63bf6);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $410c9733db633c5a$export$d287819c2da63bf6 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $410c9733db633c5a$var$layoutStyles
    }, children);
const $410c9733db633c5a$var$layoutStyles = (0, $1DXK0.xcss)({
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) auto',
    height: '100%',
    overflow: 'hidden',
    borderRadius: '5px',
    backgroundColor: 'elevation.surface.raised',
    minHeight: '80px'
});

});

parcelRegister("aI5B2", function(module, exports) {
$parcel$export(module.exports, "GraphWrapper", () => $1d83326efa415416$export$c4a562231524e009);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $1d83326efa415416$export$c4a562231524e009 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $1d83326efa415416$var$graphWrapperStyles
    }, children);
const $1d83326efa415416$var$graphWrapperStyles = (0, $1DXK0.xcss)({
    position: 'relative',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    backgroundColor: 'elevation.surface.raised'
});

});

parcelRegister("6QXXm", function(module, exports) {
$parcel$export(module.exports, "GraphActionsWrapper", () => $d10176743719fc67$export$79cce14e9e2d8669);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");
const $d10176743719fc67$export$79cce14e9e2d8669 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $d10176743719fc67$var$actionWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "center",
        justifyContent: "space-between",
        columnGap: "space.150"
    }, children));
const $d10176743719fc67$var$actionWrapperStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    top: 'space.200',
    right: 'space.300',
    display: 'flex',
    alignItems: 'center',
    alignContent: 'center',
    flexFlow: 'row nowrap',
    justifyContent: 'space-between',
    background: 'red',
    borderRadius: 'radius.small',
    backgroundColor: 'elevation.surface.overlay',
    boxShadow: 'elevation.shadow.overlay',
    padding: 'space.100'
});

});

parcelRegister("8kfYI", function(module, exports) {
$parcel$export(module.exports, "ObjectDetailsRenderingContext", () => $7d9851f4b0af5951$export$8455be6f0fe4b2f9);
const $7d9851f4b0af5951$export$8455be6f0fe4b2f9 = {
    Page: 'Page',
    Component: 'Component',
    ObjectGraph: 'ObjectGraph'
};

});

parcelRegister("aTwtU", function(module, exports) {
$parcel$export(module.exports, "EmbeddedObjectView", () => $e9ba491d50de4ae7$export$1bc70d6456eff891);

var $eJOHy = parcelRequire("eJOHy");

var $8E59C = parcelRequire("8E59C");

var $3ZzKK = parcelRequire("3ZzKK");

var $8gBzI = parcelRequire("8gBzI");
const $e9ba491d50de4ae7$export$1bc70d6456eff891 = (props)=>{
    // Hook will ensure experience is aborted on unmount
    (0, $8gBzI.useUFOComponentExperience)((0, $8E59C.loadObjectDetailExperience));
    // useEffect will restart experience whenever viewed object is changed
    (0, $eJOHy.useEffect)(()=>{
        (0, $8E59C.loadObjectDetailExperience).abort();
        (0, $8E59C.loadObjectDetailExperience).start();
    }, [
        props.objectId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3ZzKK.AsyncObjectView), props);
};

});
parcelRegister("3ZzKK", function(module, exports) {
$parcel$export(module.exports, "AsyncObjectView", () => $8361ef67c93c19e4$export$a278d7d56065625d);

var $eJOHy = parcelRequire("eJOHy");

var $a1hYp = parcelRequire("a1hYp");

var $ch9En = parcelRequire("ch9En");

var $bQ7Lm = parcelRequire("bQ7Lm");

var $bQWwW = parcelRequire("bQWwW");

const $8361ef67c93c19e4$var$LazyObjectView = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("7qHyr")), {
    moduleId: "./src/packages/servicedesk/insight-object/object-view/src/main.tsx"
});
const $8361ef67c93c19e4$export$a278d7d56065625d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "insight-object-view",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQ7Lm.InsightObjectViewSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a1hYp.default), {
        value: 2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8361ef67c93c19e4$var$LazyObjectView, props)));

});
parcelRegister("bQ7Lm", function(module, exports) {
$parcel$export(module.exports, "InsightObjectViewSkeleton", () => $56649d3a22745c64$export$4318a5dd76ab9b69);
$parcel$export(module.exports, "InsightObjectViewInObjectGraphSkeleton", () => $56649d3a22745c64$export$704549c86968f278);
$parcel$export(module.exports, "InsightObjectViewHeaderSkeleton", () => $56649d3a22745c64$export$8adbf5d0ad204f0d);
$parcel$export(module.exports, "InsightObjectViewAttributesSkeleton", () => $56649d3a22745c64$export$fd4d1c10d8bf3e15);
$parcel$export(module.exports, "InsightObjectViewLinkedObjectsSkeleton", () => $56649d3a22745c64$export$92d9f62d25f4209e);
$parcel$export(module.exports, "InsightObjectViewPanelSkeleton", () => $56649d3a22745c64$export$e84eb014f3325b25);
/* InsightObjectViewSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dLR8J = parcelRequire("dLR8J");

var $hwuZ0 = parcelRequire("hwuZ0");

var $63TWc = parcelRequire("63TWc");

var $3MDdv = parcelRequire("3MDdv");

var $4swFq = parcelRequire("4swFq");

var $1kM3D = parcelRequire("1kM3D");

var $l1IeY = parcelRequire("l1IeY");

var $9l30T = parcelRequire("9l30T");
const $56649d3a22745c64$var$skeletonCssStyles = null;
const $56649d3a22745c64$export$4318a5dd76ab9b69 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($56649d3a22745c64$var$ObjectViewWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "object-view-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($l1IeY))),
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    })));
const $56649d3a22745c64$export$704549c86968f278 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($56649d3a22745c64$var$ObjectViewWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "object-view-in-object-graph-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9l30T))),
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    })));
const $56649d3a22745c64$export$8adbf5d0ad204f0d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($56649d3a22745c64$var$HeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "object-view-header-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3MDdv))),
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    })));
const $56649d3a22745c64$export$fd4d1c10d8bf3e15 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($56649d3a22745c64$var$AttributesWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "object-view-attributes-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($63TWc))),
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    })));
const $56649d3a22745c64$export$92d9f62d25f4209e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($56649d3a22745c64$var$LinkedObjectsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "object-view-linked-objects-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4swFq))),
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    })));
const $56649d3a22745c64$export$e84eb014f3325b25 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($56649d3a22745c64$var$PanelWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "object-view-panel-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1kM3D))),
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $56649d3a22745c64$var$ObjectViewWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_c71l1jgf _18m915vq",
            __cmplp.className
        ])
    });
});
const $56649d3a22745c64$var$HeaderWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_c71l1nlq",
            __cmplp.className
        ])
    });
});
const $56649d3a22745c64$var$AttributesWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_c71ldgin",
            __cmplp.className
        ])
    });
});
const $56649d3a22745c64$var$LinkedObjectsWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_c71lhcro _18m915vq",
            __cmplp.className
        ])
    });
});
const $56649d3a22745c64$var$PanelWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_c71l8ved _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("63TWc", function(module, exports) {
module.exports = new URL("insight-object-view-attributes-skeleton.tpl.06a118aa.svg", import.meta.url).toString();

});

parcelRegister("3MDdv", function(module, exports) {
module.exports = new URL("insight-object-view-header-skeleton.tpl.16b423cc.svg", import.meta.url).toString();

});

parcelRegister("4swFq", function(module, exports) {
module.exports = new URL("insight-object-view-linked-objects-skeleton.tpl.ba10f51b.svg", import.meta.url).toString();

});

parcelRegister("1kM3D", function(module, exports) {
module.exports = new URL("insight-object-view-panel-skeleton.tpl.b6b0e1b0.svg", import.meta.url).toString();

});

parcelRegister("l1IeY", function(module, exports) {
module.exports = new URL("insight-object-view-skeleton.tpl.6c773a02.svg", import.meta.url).toString();

});

parcelRegister("9l30T", function(module, exports) {
module.exports = new URL("insight-object-view-in-object-graph-skeleton.tpl.fdc4a1a1.svg", import.meta.url).toString();

});


parcelRegister("7qHyr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("f5PLD")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("cahdx")
        ]);
    }),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("fliVL"),
    $ewTvA("iou9M")
]).then(()=>parcelRequire('kgixI'));

});



parcelRegister("efPdM", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $69f76e585f37c88a$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "useObjectSearchStoreState", () => $69f76e585f37c88a$export$42212dc18cbfdaef);
$parcel$export(module.exports, "InsightObjectSearchStore", () => $69f76e585f37c88a$export$ee1152b3c6b4bb6a);
$parcel$export(module.exports, "useObjectSearchPagination", () => $69f76e585f37c88a$export$664abd4b798b5cf7);
$parcel$export(module.exports, "useLastSearch", () => $69f76e585f37c88a$export$6a02fb239d1eed1e);

var $eJOHy = parcelRequire("eJOHy");

var $7GNC3 = parcelRequire("7GNC3");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $35h4n = parcelRequire("35h4n");

var $kXsN9 = parcelRequire("kXsN9");

var $hHvBG = parcelRequire("hHvBG");

var $6ukrC = parcelRequire("6ukrC");
const $69f76e585f37c88a$var$ASYNC_LOADING_STATE = {
    type: 'loading'
};
const $69f76e585f37c88a$export$d4c72bab9d6cc13a = {
    lastSearch: $69f76e585f37c88a$var$ASYNC_LOADING_STATE,
    pendingSearch: null,
    searchMode: 'basic',
    currentSearchScope: null,
    selectedColumns: [],
    summableColumns: new Set(),
    filtersUpdated: false
};
const $69f76e585f37c88a$var$Store = (0, $GtRbT.createStore)({
    initialState: $69f76e585f37c88a$export$d4c72bab9d6cc13a,
    actions: $6ukrC.actions
});
const $69f76e585f37c88a$export$42212dc18cbfdaef = (0, $iJq0l.createHook)($69f76e585f37c88a$var$Store, {
    selector: (state)=>state
});
const $69f76e585f37c88a$var$onInit = ()=>async (api, containerProps)=>{
        const { setState: setState, dispatch: dispatch } = api;
        const { initialSelectedObjectId: initialSelectedObjectId, searchScope: searchScope } = containerProps;
        const { objectTypeId: objectTypeId } = (0, $35h4n.checkIsSupportedSearchScope)(searchScope);
        const localLastSearchQuery = (0, $kXsN9.getLocalLastSearchQuery)(objectTypeId);
        const newSearchQuery = localLastSearchQuery ?? (0, $7GNC3.EMPTY_VALIDATED_IQL);
        const localSearchMode = (0, $kXsN9.getLocalSearchMode)(objectTypeId);
        if (localSearchMode !== null && localSearchMode !== undefined) setState({
            searchMode: localSearchMode
        });
        const INITIAL_SEARCH_REQUEST = {
            query: {
                type: 'qlQuery',
                qlQuery: newSearchQuery
            },
            page: {
                type: 'page-number',
                pageNumber: 1
            }
        };
        const initialSearchRequest = initialSelectedObjectId !== undefined && initialSelectedObjectId !== null ? {
            ...INITIAL_SEARCH_REQUEST,
            page: {
                type: 'page-containing-object',
                objectId: initialSelectedObjectId
            }
        } : INITIAL_SEARCH_REQUEST;
        setState({
            currentSearchScope: searchScope
        });
        await dispatch((0, $6ukrC.actions).executeSearch({
            request: initialSearchRequest,
            resetUncappedNumObjects: true
        }));
    };
const $69f76e585f37c88a$export$6161e6f8dbfd7d74 = (0, $6E16M.createContainer)($69f76e585f37c88a$var$Store, {
    onInit: $69f76e585f37c88a$var$onInit
});
const $69f76e585f37c88a$export$ee1152b3c6b4bb6a = ({ children: children, ...props })=>{
    const { workspaceId: workspaceId, searchScope: searchScope } = props;
    let storeScope;
    if (searchScope.type === 'schema-object-type') storeScope = `${workspaceId}/${searchScope.objectSchemaId}/${searchScope.objectTypeId}`;
    else storeScope = workspaceId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($69f76e585f37c88a$export$6161e6f8dbfd7d74, {
        ...props,
        scope: storeScope
    }, children);
};
const $69f76e585f37c88a$export$664abd4b798b5cf7 = (0, $iJq0l.createHook)($69f76e585f37c88a$var$Store, {
    selector: (0, $hHvBG.getPagination)
});
const $69f76e585f37c88a$export$6a02fb239d1eed1e = (0, $iJq0l.createStateHook)($69f76e585f37c88a$var$Store, {
    selector: (0, $hHvBG.getLastSearch)
});

});
parcelRegister("7GNC3", function(module, exports) {
$parcel$export(module.exports, "EMPTY_VALIDATED_IQL", () => $2b8911246c28aaf6$export$f3e6582beacb59ad);

var $3VjNa = parcelRequire("3VjNa");
const $2b8911246c28aaf6$export$f3e6582beacb59ad = (0, $3VjNa.toValidatedIql)('');

});
parcelRegister("3VjNa", function(module, exports) {
$parcel$export(module.exports, "toValidatedIql", () => $f119345919c992e3$export$d2a6b8af2abc27c3);
const $f119345919c992e3$export$d2a6b8af2abc27c3 = (value)=>value;

});


parcelRegister("35h4n", function(module, exports) {
$parcel$export(module.exports, "checkIsSupportedSearchScope", () => $39a53531156eabdf$export$fd416eb57a0a04ad);
$parcel$export(module.exports, "extractOrderBy", () => $39a53531156eabdf$export$1f1af827dcd2dad9);
$parcel$export(module.exports, "transformSearchResponse", () => $39a53531156eabdf$export$51f7467d916c62ae);
$parcel$export(module.exports, "isSameColumn", () => $39a53531156eabdf$export$2a7304df9108e430);
$parcel$export(module.exports, "generateQlQueryForSearchScope", () => $39a53531156eabdf$export$d9cee1a12399ed34);

var $3VjNa = parcelRequire("3VjNa");

var $iw1Hx = parcelRequire("iw1Hx");

var $hAViP = parcelRequire("hAViP");

var $2GHCX = parcelRequire("2GHCX");
const $39a53531156eabdf$export$fd416eb57a0a04ad = (searchScope)=>{
    if (searchScope.type === 'global') throw new Error('checkSearchScope - global search is not yet supported');
    const { objectSchemaId: objectSchemaId, objectTypeId: objectTypeId, isObjectTypeInherited: isObjectTypeInherited } = searchScope;
    return {
        objectSchemaId: objectSchemaId,
        objectTypeId: objectTypeId,
        isObjectTypeInherited: isObjectTypeInherited
    };
};
const $39a53531156eabdf$export$1f1af827dcd2dad9 = (iql)=>{
    const [beforeOrder, attributeNameAndDirection = null] = String(iql).split(/\s*order\s+by\s+/gi);
    if (attributeNameAndDirection === null) return {
        iqlWithoutOrderBy: iql,
        orderBy: null
    };
    const [maybeQuotedName, optionalDirection = 'ASC'] = attributeNameAndDirection.trim().split(/\s+/g);
    const direction = optionalDirection.trim().toLowerCase() === 'desc' ? 'DESC' : 'ASC';
    const attributeName = maybeQuotedName.replace(/^"/g, '').replace(/"$/g, '').trim();
    return {
        iqlWithoutOrderBy: (0, $3VjNa.toValidatedIql)(beforeOrder.trim()),
        orderBy: {
            attributeName: attributeName,
            direction: direction
        }
    };
};
const $39a53531156eabdf$export$51f7467d916c62ae = (searchResponse, objectTypesForFiltering)=>{
    const { objectEntries: objectEntries, objectTypeAttributes: objectTypeAttributes, pageNumber: pageNumber, pageSize: pageSize, qlQuery: qlQuery, filters: filters = null, orderByTypeAttrId: orderByTypeAttrId, orderWay: orderWay, totalFilterCount: totalFilterCount, hasMoreResults: hasMoreResults, startIndex: startIndex, objectTypeId: objectTypeId, objectTypeIsInherited: objectTypeIsInherited, toIndex: toIndex } = searchResponse;
    const searchResultAttributes = [];
    const attributesById = {};
    // we only want to push the object type filter if there are other attributes
    objectTypeAttributes.forEach((attributeResponse)=>{
        const { id: id, name: name, system: system, label: label, type: type, maximumCardinality: maximumCardinality } = attributeResponse;
        const attributeType = (0, $iw1Hx.toAttributeType)(type);
        let defaultType;
        if (attributeType === 'default' && attributeResponse.defaultType) defaultType = attributeResponse.defaultType;
        const objectTypeAttribute = {
            id: id,
            name: name,
            isSystem: system,
            isLabel: label,
            attributeType: attributeType,
            defaultType: defaultType,
            maximumCardinality: maximumCardinality
        };
        searchResultAttributes.push(objectTypeAttribute);
        attributesById[id] = objectTypeAttribute;
    });
    let orderBy = null;
    if (orderByTypeAttrId != null) {
        const orderByAttribute = attributesById[orderByTypeAttrId];
        if (orderByAttribute) orderBy = {
            direction: orderWay === 'ascending' ? 'ASC' : 'DESC',
            objectTypeAttributeId: orderByTypeAttrId,
            attributeName: orderByAttribute.name
        };
    }
    const { iqlWithoutOrderBy: iqlWithoutOrderBy } = $39a53531156eabdf$export$1f1af827dcd2dad9(qlQuery);
    const canConvertQlQueryToFilter = filters !== null && !(filters.length === 0 && iqlWithoutOrderBy.length > 0);
    const objectTypeValues = (0, $2GHCX.formatSelectedObjectTypesForResponse)({
        filters: filters,
        objectTypesForFiltering: objectTypesForFiltering
    });
    return {
        objects: objectEntries.map((objectEntry)=>{
            const { id: id, objectKey: objectKey, avatar: avatar, attributes: attributes, label: label, objectType: objectType } = objectEntry;
            return {
                id: id,
                label: label,
                objectKey: objectKey,
                avatar: avatar,
                attributes: attributes.map((attribute)=>(0, $iw1Hx.normalizeObjectAttributeResponse)(attribute)),
                objectTypeId: objectType.id
            };
        }),
        attributes: searchResultAttributes,
        qlQuery: qlQuery,
        filters: (filters || []).reduce((acc, filterResponse)=>{
            const { objectTypeAttributeId: objectTypeAttributeId, selectedValues: selectedValues } = filterResponse;
            const objectTypeAttribute = attributesById[objectTypeAttributeId];
            if (!objectTypeAttribute) return acc;
            const { name: name } = objectTypeAttribute;
            const attributeFilter = (0, $hAViP.filterFromResponse)({
                objectTypeAttribute: objectTypeAttribute,
                selectedValues: selectedValues
            });
            acc[name] = {
                objectTypeAttributeId: objectTypeAttributeId,
                attributeFilter: attributeFilter
            };
            return acc;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        }, {}),
        canConvertQlQueryToFilter: canConvertQlQueryToFilter,
        objectTypeIsInherited: objectTypeIsInherited,
        objectTypeId: objectTypeId,
        pageNumber: pageNumber,
        numObjects: totalFilterCount,
        numPages: pageSize,
        hasMoreResults: hasMoreResults ?? false,
        orderBy: orderBy,
        startIndex: startIndex,
        toIndex: toIndex,
        objectTypes: objectTypeValues
    };
};
const $39a53531156eabdf$export$b604ea06788c11df = (target)=>target.type === 'attribute';
const $39a53531156eabdf$export$2a7304df9108e430 = (selectedColumn, originalColumn)=>{
    const isAttributeSelectedColumn = $39a53531156eabdf$export$b604ea06788c11df(selectedColumn);
    const isAttributeOriginalColumn = originalColumn.type === 'attribute';
    // if it's not an attribute column compare by type
    if (!isAttributeSelectedColumn || !isAttributeOriginalColumn) return selectedColumn.type === originalColumn.type;
    // only compare by name if it's an attribute column
    return selectedColumn.name === originalColumn.name;
};
const $39a53531156eabdf$var$QLQUERY_CONCATENATOR = ' AND ';
const $39a53531156eabdf$var$generateObjectSchemaClause = (objectSchemaId)=>`objectSchemaId = ${objectSchemaId}`;
const $39a53531156eabdf$var$generateObjectTypeClause = (objectTypeId, isObjectTypeInherited)=>{
    if (isObjectTypeInherited) return `objectType IN objectTypeAndChildren(${objectTypeId})`;
    return `objectTypeId = ${objectTypeId}`;
};
const $39a53531156eabdf$export$d9cee1a12399ed34 = (currentQlQuery, { objectSchemaId: objectSchemaId, objectTypeId: objectTypeId, isObjectTypeInherited: isObjectTypeInherited }, includeOrderBy = false)=>{
    const { iqlWithoutOrderBy: qlQueryWithoutOrderBy, orderBy: orderBy } = $39a53531156eabdf$export$1f1af827dcd2dad9(currentQlQuery);
    const qlQueryWithSearchScopeClauses = [
        // Only add existing qlQuery if not empty
        ...qlQueryWithoutOrderBy ? [
            qlQueryWithoutOrderBy
        ] : [],
        $39a53531156eabdf$var$generateObjectSchemaClause(objectSchemaId),
        $39a53531156eabdf$var$generateObjectTypeClause(objectTypeId, isObjectTypeInherited)
    ].join($39a53531156eabdf$var$QLQUERY_CONCATENATOR);
    const orderByClause = includeOrderBy && orderBy ? ` ORDER BY "${orderBy.attributeName}" ${orderBy.direction}` : '';
    return `${qlQueryWithSearchScopeClauses}${orderByClause}`;
};

});
parcelRegister("iw1Hx", function(module, exports) {
$parcel$export(module.exports, "toAttributeType", () => $1e04b6263e2a75dd$export$720a7caa078a04b0);
$parcel$export(module.exports, "normalizeAttributeTypeResponse", () => $1e04b6263e2a75dd$export$c5f92fa9faff4a5e);
$parcel$export(module.exports, "normalizeAttributeTypesResponse", () => $1e04b6263e2a75dd$export$d6675b3ab298ac1f);
$parcel$export(module.exports, "normalizeObjectAttributeResponse", () => $1e04b6263e2a75dd$export$ab549e9cd750448c);
$parcel$export(module.exports, "normalizeObjectDetailsResponse", () => $1e04b6263e2a75dd$export$1ac2dbbd05bc2ac7);

var $51aj0 = parcelRequire("51aj0");

var $4ZeQj = parcelRequire("4ZeQj");

var $iD8Jp = parcelRequire("iD8Jp");

var $2nGoJ = parcelRequire("2nGoJ");
const $1e04b6263e2a75dd$export$720a7caa078a04b0 = (attributeTypeAsNumber)=>{
    switch(attributeTypeAsNumber){
        case (0, $iD8Jp.AttributeTypeNumbers).default:
            return 'default';
        case (0, $iD8Jp.AttributeTypeNumbers).object:
            return 'object';
        case (0, $iD8Jp.AttributeTypeNumbers).user:
            return 'user';
        case (0, $iD8Jp.AttributeTypeNumbers).group:
            return 'group';
        case (0, $iD8Jp.AttributeTypeNumbers).project:
            return 'project';
        case (0, $iD8Jp.AttributeTypeNumbers).status:
            return 'status';
        case (0, $iD8Jp.AttributeTypeNumbers).bitbucketRepo:
            return 'bitbucketRepo';
        case (0, $iD8Jp.AttributeTypeNumbers).opsgenieTeam:
            return 'opsgenieTeam';
        default:
            {
                const attributeTypeAsNumberExhaustive = attributeTypeAsNumber;
                const error = new Error(`Invalid attribute type provided from Insight service found: ${attributeTypeAsNumberExhaustive}`);
                (0, $51aj0.fireCmdbErrorAnalytics)({
                    meta: {
                        id: 'invalid.attribute.type',
                        packageName: 'jiraServicedeskInsightObjectTypes',
                        teamName: 'aurum'
                    },
                    error: error
                });
                throw error;
            }
    }
};
const $1e04b6263e2a75dd$var$assertDefined = (value)=>{
    if (value != null) return value;
    (0, $51aj0.fireCmdbErrorAnalytics)({
        meta: {
            id: 'missing.property.from.insight.service',
            packageName: 'jiraServicedeskInsightObjectTypes'
        }
    });
    throw new Error('Expected value from Insight service is null or undefined');
};
const $1e04b6263e2a75dd$export$c5f92fa9faff4a5e = ({ type: type, defaultType: defaultType, suffix: suffix, regexValidation: regexValidation, referenceType: referenceType, referenceObjectType: referenceObjectType, ...attributeType })=>(0, $2nGoJ.matchAttributeType)($1e04b6263e2a75dd$export$720a7caa078a04b0(type), {
        default: ()=>({
                ...attributeType,
                defaultType: $1e04b6263e2a75dd$var$assertDefined(defaultType),
                suffix: suffix,
                regexValidation: regexValidation,
                type: 'default'
            }),
        object: ()=>({
                ...attributeType,
                referenceType: $1e04b6263e2a75dd$var$assertDefined(referenceType),
                referenceObjectType: $1e04b6263e2a75dd$var$assertDefined(referenceObjectType),
                type: 'object'
            }),
        user: ()=>({
                ...attributeType,
                type: 'user'
            }),
        group: ()=>({
                ...attributeType,
                type: 'group'
            }),
        project: ()=>({
                ...attributeType,
                type: 'project'
            }),
        status: ()=>({
                ...attributeType,
                type: 'status'
            }),
        bitbucketRepo: ()=>({
                ...attributeType,
                type: 'bitbucketRepo'
            }),
        opsgenieTeam: ()=>({
                ...attributeType,
                type: 'opsgenieTeam'
            })
    });
const $1e04b6263e2a75dd$export$d6675b3ab298ac1f = (attributeTypes)=>attributeTypes.map((objectTypeAttributeResponse)=>$1e04b6263e2a75dd$export$c5f92fa9faff4a5e(objectTypeAttributeResponse));
const $1e04b6263e2a75dd$export$ab549e9cd750448c = (attributeResponse)=>{
    const { objectId: objectId, workspaceId: workspaceId, ...rest } = attributeResponse;
    const { objectTypeAttributeId: objectTypeAttributeId, objectTypeAttribute: objectTypeAttribute, objectAttributeValues: objectAttributeValues } = rest;
    const attributeCommon = {
        objectTypeAttributeId: (0, $4ZeQj.toObjectTypeAttributeId)(objectTypeAttributeId)
    };
    return (0, $2nGoJ.matchAttributeType)($1e04b6263e2a75dd$export$720a7caa078a04b0(attributeResponse.objectTypeAttribute.type), {
        default: ()=>{
            const { type: type, ...withoutNumberType } = objectTypeAttribute;
            return {
                ...attributeCommon,
                type: 'default',
                objectTypeAttribute: {
                    ...withoutNumberType,
                    type: 'default',
                    defaultType: $1e04b6263e2a75dd$var$assertDefined(objectTypeAttribute.defaultType)
                },
                defaultTypeValues: objectAttributeValues.map((attributeValue)=>{
                    const { referencedObject: referencedObject, group: group, project: project, user: user, status: status, ...attrValue } = attributeValue;
                    return {
                        ...attrValue,
                        value: attrValue.value
                    };
                })
            };
        },
        object: ()=>{
            const { type: type, ...withoutNumberType } = objectTypeAttribute;
            return {
                ...attributeCommon,
                type: 'object',
                objectTypeAttribute: {
                    ...withoutNumberType,
                    type: 'object',
                    referenceType: $1e04b6263e2a75dd$var$assertDefined(objectTypeAttribute.referenceType),
                    referenceObjectType: $1e04b6263e2a75dd$var$assertDefined(objectTypeAttribute.referenceObjectType)
                },
                objectTypeValues: objectAttributeValues.map((attributeValue)=>{
                    const { bitbucketRepo: bitbucketRepo, group: group, project: project, user: user, status: status, value: value, ...attrValue } = attributeValue;
                    return {
                        ...attrValue,
                        referencedObject: $1e04b6263e2a75dd$var$assertDefined(attrValue.referencedObject)
                    };
                })
            };
        },
        user: ()=>{
            const { type: type, ...withoutNumberType } = objectTypeAttribute;
            return {
                ...attributeCommon,
                type: 'user',
                objectTypeAttribute: {
                    ...withoutNumberType,
                    type: 'user'
                },
                userTypeValues: objectAttributeValues.map((attributeValue)=>{
                    const { bitbucketRepo: bitbucketRepo, referencedObject: referencedObject, project: project, group: group, status: status, value: value, ...attrValue } = attributeValue;
                    return {
                        ...attrValue,
                        user: $1e04b6263e2a75dd$var$assertDefined(attrValue.user)
                    };
                })
            };
        },
        group: ()=>{
            const { type: type, ...withoutNumberType } = objectTypeAttribute;
            return {
                ...attributeCommon,
                type: 'group',
                objectTypeAttribute: {
                    ...withoutNumberType,
                    type: 'group'
                },
                groupTypeValues: objectAttributeValues.map((attributeValue)=>{
                    const { bitbucketRepo: bitbucketRepo, referencedObject: referencedObject, project: project, user: user, status: status, value: value, ...attrValue } = attributeValue;
                    return {
                        ...attrValue,
                        group: $1e04b6263e2a75dd$var$assertDefined(attrValue.group)
                    };
                })
            };
        },
        project: ()=>{
            const { type: type, ...withoutNumberType } = objectTypeAttribute;
            return {
                ...attributeCommon,
                type: 'project',
                objectTypeAttribute: {
                    ...withoutNumberType,
                    type: 'project'
                },
                projectTypeValues: objectAttributeValues.map((attributeValue)=>{
                    const { bitbucketRepo: bitbucketRepo, referencedObject: referencedObject, user: user, group: group, status: status, value: value, ...attrValue } = attributeValue;
                    return {
                        ...attrValue,
                        project: $1e04b6263e2a75dd$var$assertDefined(attrValue.project)
                    };
                })
            };
        },
        status: ()=>{
            const { type: type, ...withoutNumberType } = objectTypeAttribute;
            return {
                ...attributeCommon,
                type: 'status',
                objectTypeAttribute: {
                    ...withoutNumberType,
                    type: 'status'
                },
                statusTypeValues: objectAttributeValues.map((attributeValue)=>{
                    const { bitbucketRepo: bitbucketRepo, referencedObject: referencedObject, user: user, group: group, project: project, value: value, ...attrValue } = attributeValue;
                    return {
                        ...attrValue,
                        status: $1e04b6263e2a75dd$var$assertDefined(attrValue.status)
                    };
                })
            };
        },
        bitbucketRepo: ()=>{
            const { type: type, ...withoutNumberType } = objectTypeAttribute;
            return {
                ...attributeCommon,
                type: 'bitbucketRepo',
                objectTypeAttribute: {
                    ...withoutNumberType,
                    type: 'bitbucketRepo'
                },
                bitbucketRepoTypeValues: objectAttributeValues.map((attributeValue)=>{
                    const { referencedObject: referencedObject, user: user, group: group, project: project, value: value, ...attrValue } = attributeValue;
                    return {
                        ...attrValue,
                        bitbucketRepo: $1e04b6263e2a75dd$var$assertDefined(attrValue.bitbucketRepo)
                    };
                })
            };
        },
        opsgenieTeam: ()=>{
            const { type: type, ...withoutNumberType } = objectTypeAttribute;
            return {
                ...attributeCommon,
                type: 'opsgenieTeam',
                objectTypeAttribute: {
                    ...withoutNumberType,
                    type: 'opsgenieTeam'
                },
                opsgenieTeamTypeValues: objectAttributeValues.map((attributeValue)=>{
                    const { referencedObject: referencedObject, user: user, group: group, project: project, value: value, ...attrValue } = attributeValue;
                    return {
                        ...attrValue,
                        opsgenieTeam: $1e04b6263e2a75dd$var$assertDefined(attrValue.opsgenieTeam)
                    };
                })
            };
        }
    });
};
const $1e04b6263e2a75dd$export$1ac2dbbd05bc2ac7 = (objectDetails)=>{
    const normalisedAttributes = objectDetails.attributes.map((attributeResponse)=>$1e04b6263e2a75dd$export$ab549e9cd750448c(attributeResponse));
    return {
        ...objectDetails,
        attributes: normalisedAttributes
    };
};

});
parcelRegister("iD8Jp", function(module, exports) {
$parcel$export(module.exports, "AttributeTypeNumbers", () => $ba298301270ce58d$export$537905fc88c8f191);
const $ba298301270ce58d$export$537905fc88c8f191 = {
    default: 0,
    object: 1,
    user: 2,
    group: 4,
    project: 6,
    status: 7,
    bitbucketRepo: 8,
    opsgenieTeam: 9
};

});


parcelRegister("hAViP", function(module, exports) {
$parcel$export(module.exports, "extractWildcard", () => $9691cfafb4c68dca$export$91d8fe649093dc1d);
$parcel$export(module.exports, "filterFromResponse", () => $9691cfafb4c68dca$export$2792cc2770892ddc);
$parcel$export(module.exports, "createFilterRequestItems", () => $9691cfafb4c68dca$export$d45ff895fb47e69c);

var $51aj0 = parcelRequire("51aj0");

var $2nGoJ = parcelRequire("2nGoJ");

var $4ZeQj = parcelRequire("4ZeQj");

var $ljej9 = parcelRequire("ljej9");
// See ObjectFilterValuesBean for the definition of these constants on the back-end
const $9691cfafb4c68dca$var$WILDCARD_MARKER = '<<FILTER_WILDCARD>>';
// Date filter types
const $9691cfafb4c68dca$var$DATE_FILTER_WITHIN_LAST_AGO = '1';
const $9691cfafb4c68dca$var$DATE_FILTER_MORE_THAN_AGO = '2';
const $9691cfafb4c68dca$var$DATE_FILTER_BETWEEN = '3';
const $9691cfafb4c68dca$var$DATE_FILTER_WITHIN_FROMNOW = '4';
const $9691cfafb4c68dca$var$DATE_FILTER_MORE_THAN_FROMNOW = '5';
// Number filter types
const $9691cfafb4c68dca$var$TYPE_NUMBER_EQUALS = '0';
const $9691cfafb4c68dca$var$TYPE_NUMBER_LESS = '1';
const $9691cfafb4c68dca$var$TYPE_NUMBER_GREATER = '2';
const $9691cfafb4c68dca$var$TYPE_NUMBER_BETWEEN = '3';
const $9691cfafb4c68dca$var$parseNumberFilter = (selectedValues)=>{
    const [filterType, firstValue, secondValue] = selectedValues;
    switch(filterType){
        case $9691cfafb4c68dca$var$TYPE_NUMBER_EQUALS:
            return {
                type: 'number',
                value: {
                    type: 'equals',
                    value: firstValue
                }
            };
        case $9691cfafb4c68dca$var$TYPE_NUMBER_LESS:
            return {
                type: 'number',
                value: {
                    type: 'less-than',
                    value: firstValue
                }
            };
        case $9691cfafb4c68dca$var$TYPE_NUMBER_GREATER:
            return {
                type: 'number',
                value: {
                    type: 'greater-than',
                    value: firstValue
                }
            };
        case $9691cfafb4c68dca$var$TYPE_NUMBER_BETWEEN:
            return {
                type: 'number',
                value: {
                    type: 'between',
                    min: firstValue,
                    max: secondValue
                }
            };
        default:
            throw new Error(`Unexpected filterType: ${filterType} for number attribute`);
    }
};
const $9691cfafb4c68dca$var$asPeriodType = (value)=>value;
const $9691cfafb4c68dca$var$parseDateFilterValue = (selectedValues)=>{
    const [filterType, firstValue, secondValue] = selectedValues;
    switch(filterType){
        case $9691cfafb4c68dca$var$DATE_FILTER_WITHIN_LAST_AGO:
            return {
                type: 'within-the-last',
                value: firstValue,
                periodType: $9691cfafb4c68dca$var$asPeriodType(secondValue)
            };
        case $9691cfafb4c68dca$var$DATE_FILTER_MORE_THAN_AGO:
            return {
                type: 'more-than-ago',
                value: firstValue,
                periodType: $9691cfafb4c68dca$var$asPeriodType(secondValue)
            };
        case $9691cfafb4c68dca$var$DATE_FILTER_BETWEEN:
            return {
                type: 'between',
                start: firstValue,
                end: secondValue
            };
        case $9691cfafb4c68dca$var$DATE_FILTER_WITHIN_FROMNOW:
            return {
                type: 'within-from-now',
                value: firstValue,
                periodType: $9691cfafb4c68dca$var$asPeriodType(secondValue)
            };
        case $9691cfafb4c68dca$var$DATE_FILTER_MORE_THAN_FROMNOW:
            return {
                type: 'more-than-from-now',
                value: firstValue,
                periodType: $9691cfafb4c68dca$var$asPeriodType(secondValue)
            };
        default:
            throw new Error(`Unexpected filterType: ${filterType} for date / date-time attribute`);
    }
};
const $9691cfafb4c68dca$export$91d8fe649093dc1d = (value)=>{
    if (value.endsWith($9691cfafb4c68dca$var$WILDCARD_MARKER)) return {
        value: value.replace($9691cfafb4c68dca$var$WILDCARD_MARKER, ''),
        isWildcard: true
    };
    return {
        value: value,
        isWildcard: false
    };
};
const $9691cfafb4c68dca$export$2792cc2770892ddc = ({ objectTypeAttribute: objectTypeAttribute, selectedValues: selectedValues })=>{
    try {
        const extractStringValueMatches = ()=>selectedValues.map((rawValue)=>{
                const { value: value, isWildcard: isWildcard } = $9691cfafb4c68dca$export$91d8fe649093dc1d(rawValue);
                if (isWildcard) return {
                    type: 'wildcard',
                    value: value
                };
                return {
                    type: 'exact-match',
                    value: value
                };
            });
        return (0, $2nGoJ.matchAttributeType)(objectTypeAttribute.attributeType, {
            default: ()=>{
                if (objectTypeAttribute.defaultType === undefined) throw new Error('Unexpected defaultType missing from default object type attribute');
                const handleTextFilter = ()=>({
                        type: 'text',
                        values: extractStringValueMatches()
                    });
                const handleNumberFilter = ()=>$9691cfafb4c68dca$var$parseNumberFilter(selectedValues);
                return (0, $2nGoJ.matchDefaultAttributeSubType)(objectTypeAttribute.defaultType, {
                    url: handleTextFilter,
                    email: handleTextFilter,
                    float: handleNumberFilter,
                    integer: handleNumberFilter,
                    ipAddress: handleTextFilter,
                    text: handleTextFilter,
                    textarea: ()=>({
                            type: 'textarea',
                            // The UI only supports matching on one value in basic mode
                            value: (selectedValues[0] || '').replace($9691cfafb4c68dca$var$WILDCARD_MARKER, '')
                        }),
                    select: handleTextFilter,
                    boolean: ()=>{
                        const [rawValue] = selectedValues;
                        return {
                            type: 'boolean',
                            value: rawValue === '1' || rawValue.toLowerCase() === 'true'
                        };
                    },
                    date: ()=>({
                            type: 'date',
                            value: $9691cfafb4c68dca$var$parseDateFilterValue(selectedValues)
                        }),
                    datetime: ()=>({
                            type: 'date-time',
                            value: $9691cfafb4c68dca$var$parseDateFilterValue(selectedValues)
                        })
                });
            },
            object: ()=>({
                    type: 'object',
                    values: selectedValues.map((rawValue)=>{
                        const { value: value, isWildcard: isWildcard } = $9691cfafb4c68dca$export$91d8fe649093dc1d(rawValue);
                        if (isWildcard) return {
                            type: 'wildcard',
                            value: value
                        };
                        return {
                            type: 'exact-match',
                            value: (0, $4ZeQj.toCmdbObjectId)(value)
                        };
                    })
                }),
            user: ()=>({
                    type: 'user',
                    values: selectedValues.map((rawValue)=>{
                        const { value: value, isWildcard: isWildcard } = $9691cfafb4c68dca$export$91d8fe649093dc1d(rawValue);
                        if (isWildcard) return {
                            type: 'wildcard',
                            value: value
                        };
                        return {
                            type: 'exact-match',
                            value: (0, $ljej9.toAccountId)(value)
                        };
                    })
                }),
            group: ()=>({
                    type: 'group',
                    values: extractStringValueMatches()
                }),
            project: ()=>({
                    type: 'project',
                    values: extractStringValueMatches()
                }),
            status: ()=>({
                    type: 'status',
                    values: extractStringValueMatches()
                }),
            bitbucketRepo: ()=>({
                    type: 'bitbucketRepo',
                    values: extractStringValueMatches()
                }),
            opsgenieTeam: ()=>({
                    type: 'opsgenieTeam',
                    values: extractStringValueMatches()
                })
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $51aj0.fireCmdbErrorAnalytics)({
            error: error,
            meta: {
                id: 'filterFromResponse',
                packageName: 'jiraServicedeskInsightObjectSearchStore'
            },
            attributes: {
                message: error.message
            }
        });
        throw error;
    }
};
const $9691cfafb4c68dca$export$5d0135c85159d289 = (attributeFilter)=>{
    switch(attributeFilter.type){
        case 'boolean':
            return [
                attributeFilter.value ? '1' : '0'
            ];
        case 'number':
            {
                const { value: value } = attributeFilter;
                switch(value.type){
                    case 'equals':
                        return [
                            $9691cfafb4c68dca$var$TYPE_NUMBER_EQUALS,
                            String(value.value)
                        ];
                    case 'less-than':
                        return [
                            $9691cfafb4c68dca$var$TYPE_NUMBER_LESS,
                            String(value.value)
                        ];
                    case 'greater-than':
                        return [
                            $9691cfafb4c68dca$var$TYPE_NUMBER_GREATER,
                            String(value.value)
                        ];
                    case 'between':
                        {
                            const minFloat = parseFloat(value.min);
                            const maxFloat = parseFloat(value.max);
                            const actualMin = Math.min(minFloat, maxFloat);
                            const actualMax = Math.max(minFloat, maxFloat);
                            return [
                                $9691cfafb4c68dca$var$TYPE_NUMBER_BETWEEN,
                                String(actualMin),
                                String(actualMax)
                            ];
                        }
                    default:
                        // prettier-ignore
                        // @ts-expect-error - TS2339 - Property 'type' does not exist on type 'never'.
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        value.type;
                        throw new Error(`Unhandled number value: ${JSON.stringify(value)}`);
                }
            }
        case 'date-time':
        case 'date':
            {
                const { value: value } = attributeFilter;
                switch(value.type){
                    case 'within-the-last':
                        return [
                            $9691cfafb4c68dca$var$DATE_FILTER_WITHIN_LAST_AGO,
                            String(value.value),
                            value.periodType
                        ];
                    case 'more-than-ago':
                        return [
                            $9691cfafb4c68dca$var$DATE_FILTER_MORE_THAN_AGO,
                            String(value.value),
                            value.periodType
                        ];
                    case 'more-than-from-now':
                        return [
                            $9691cfafb4c68dca$var$DATE_FILTER_MORE_THAN_FROMNOW,
                            String(value.value),
                            value.periodType
                        ];
                    case 'within-from-now':
                        return [
                            $9691cfafb4c68dca$var$DATE_FILTER_WITHIN_FROMNOW,
                            String(value.value),
                            value.periodType
                        ];
                    case 'between':
                        {
                            const { start: start, end: end } = value;
                            return [
                                $9691cfafb4c68dca$var$DATE_FILTER_BETWEEN,
                                start,
                                end
                            ];
                        }
                    default:
                        // prettier-ignore
                        // @ts-expect-error - TS2339 - Property 'type' does not exist on type 'never'.
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        value.type;
                        throw new Error(`Unhandled date value: ${JSON.stringify(value)}`);
                }
            }
        case 'textarea':
            return [
                `${attributeFilter.value}${$9691cfafb4c68dca$var$WILDCARD_MARKER}`
            ];
        case 'text':
        case 'object':
        case 'user':
        case 'group':
        case 'project':
        case 'bitbucketRepo':
        case 'status':
        case 'opsgenieTeam':
        case 'objectType':
            return attributeFilter.values.map((valueMatch)=>{
                if (valueMatch.type === 'wildcard') return `${valueMatch.value}${$9691cfafb4c68dca$var$WILDCARD_MARKER}`;
                return String(valueMatch.value);
            });
        default:
            {
                // The following line will show a ts error when the switch statement
                // is non-exhaustive. If this happens, add the unhandled case
                // explicitly.
                const assertAttributeFilterIsNever = attributeFilter;
                throw new Error(`Unhandled attributeFilter: ${JSON.stringify(assertAttributeFilterIsNever)}`);
            }
    }
};
const $9691cfafb4c68dca$export$d45ff895fb47e69c = (attributeFiltersByName, objectTypeFilters = [])=>{
    const filterRequestItems = Object.keys(attributeFiltersByName).map((attributeName)=>{
        const { attributeFilter: attributeFilter, objectTypeAttributeId: objectTypeAttributeId } = attributeFiltersByName[attributeName];
        const selectedValues = $9691cfafb4c68dca$export$5d0135c85159d289(attributeFilter);
        return {
            selectedValues: selectedValues,
            objectTypeAttributeId: objectTypeAttributeId
        };
    });
    if (objectTypeFilters.length) {
        const selectedObjectValues = $9691cfafb4c68dca$export$5d0135c85159d289({
            type: 'objectType',
            values: objectTypeFilters
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        filterRequestItems.push({
            selectedValues: selectedObjectValues,
            filterByObjectType: true
        });
    }
    return filterRequestItems;
};

});

parcelRegister("2GHCX", function(module, exports) {
$parcel$export(module.exports, "getObjectTypesIfObjectIsInherited", () => $c70a17f9aa4dc1c5$export$cce0f2ee5d2906e4);
$parcel$export(module.exports, "formatSelectedObjectTypesForResponse", () => $c70a17f9aa4dc1c5$export$c26eeb877164622);

var $u4YbY = parcelRequire("u4YbY");

var $4whDG = parcelRequire("4whDG");

var $hAViP = parcelRequire("hAViP");
const $c70a17f9aa4dc1c5$export$cce0f2ee5d2906e4 = async ({ objectTypeIsInherited: objectTypeIsInherited, workspaceId: workspaceId, objectTypeId: objectTypeId })=>{
    if (!objectTypeIsInherited) return null;
    const objectTypes = await (0, $u4YbY.performCmdbPostRequest)((0, $4whDG.getCmdbObjectTypeAttributeFilterUrl)(workspaceId, objectTypeId), {
        body: JSON.stringify({
            // we don't use these params as the filtering is handled elsewhere
            // they are required for the endpoint call
            query: '',
            exceptionList: []
        })
    });
    return objectTypes;
};
const $c70a17f9aa4dc1c5$export$454a9b5878e5ff6 = (filters, entries)=>{
    const filterData = filters.filter((item)=>item?.filterByObjectType ? item : null);
    if (Array.isArray(filterData) && filterData.length > 0) return filterData[0].selectedValues.map((item)=>{
        // we need to check if the current selection values exist in the selectedValues column
        // this is because the backend alters the AQL statement for objectType queries to use IN rather than LIKE
        const matchedEntry = entries.map((entryItem)=>entryItem.objectTypeName);
        const itemDoesNotExistInList = matchedEntry.indexOf(item) < 0;
        const wildCardValue = (0, $hAViP.extractWildcard)(item);
        const isWildCardEntry = wildCardValue.isWildcard || itemDoesNotExistInList;
        const type = isWildCardEntry ? 'wildcard' : 'exact-match';
        const value = isWildCardEntry ? wildCardValue.value : item;
        return {
            type: type,
            value: value
        };
    });
    return [];
};
const $c70a17f9aa4dc1c5$export$c26eeb877164622 = ({ filters: filters, objectTypesForFiltering: objectTypesForFiltering = null })=>{
    if (!objectTypesForFiltering) return null;
    if (!filters) return {
        ...objectTypesForFiltering,
        selectedValues: []
    };
    const selectedValues = $c70a17f9aa4dc1c5$export$454a9b5878e5ff6(filters, objectTypesForFiltering.entries);
    return {
        ...objectTypesForFiltering,
        selectedValues: selectedValues
    };
};

});
parcelRegister("4whDG", function(module, exports) {
$parcel$export(module.exports, "getCmdbObjectAttributeFilterListUrl", () => $0edcbe329c28e029$export$f9e3f7a64680917d);
$parcel$export(module.exports, "getCmdbObjectTypeAttributeFilterUrl", () => $0edcbe329c28e029$export$6dbd1c6b83c9de30);

var $1qZG3 = parcelRequire("1qZG3");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/objectattributefilter
 */ const $0edcbe329c28e029$var$getCmdbObjectAttributeFilterUrl = (workspaceId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/objectattributefilter`;
const $0edcbe329c28e029$export$f9e3f7a64680917d = (workspaceId)=>`${$0edcbe329c28e029$var$getCmdbObjectAttributeFilterUrl(workspaceId)}/filterlist`;
const $0edcbe329c28e029$export$6dbd1c6b83c9de30 = (workspaceId, objectTypeId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/objecttype/${objectTypeId}/filterlist`;

});



parcelRegister("kXsN9", function(module, exports) {
$parcel$export(module.exports, "insightObjectSearchLocalStorage", () => $3c8c6d537798cced$export$f4aa5cae6294ae5b);
$parcel$export(module.exports, "SELECTED_COLUMNS", () => $3c8c6d537798cced$export$595ebdf66da442f8);
$parcel$export(module.exports, "SUMMABLE_COLUMNS", () => $3c8c6d537798cced$export$c5b339a3dd7a6850);
$parcel$export(module.exports, "OBJECT_TYPE", () => $3c8c6d537798cced$export$852b3d7559c48ae8);
$parcel$export(module.exports, "setLocalLastSearchQuery", () => $3c8c6d537798cced$export$a0efd94141b90a00);
$parcel$export(module.exports, "getLocalLastSearchQuery", () => $3c8c6d537798cced$export$764b2eb589252cfc);
$parcel$export(module.exports, "setLocalSearchMode", () => $3c8c6d537798cced$export$7b6612b7a7eba49d);
$parcel$export(module.exports, "getLocalSearchMode", () => $3c8c6d537798cced$export$37b95a4bff5adfad);

var $dnU6V = parcelRequire("dnU6V");
const $3c8c6d537798cced$export$f4aa5cae6294ae5b = (0, $dnU6V.createLocalStorageProvider)('jsm-cmdb-insight-object-search');
const $3c8c6d537798cced$export$595ebdf66da442f8 = 'selected-columns';
const $3c8c6d537798cced$export$c5b339a3dd7a6850 = 'summable-columns';
const $3c8c6d537798cced$export$852b3d7559c48ae8 = 'object-type:';
const $3c8c6d537798cced$export$a0efd94141b90a00 = (objectTypeId, query)=>{
    $3c8c6d537798cced$export$f4aa5cae6294ae5b.set(`localLastSearchQuery-${objectTypeId}`, query);
};
const $3c8c6d537798cced$export$764b2eb589252cfc = (objectTypeId)=>$3c8c6d537798cced$export$f4aa5cae6294ae5b.get(`localLastSearchQuery-${objectTypeId}`);
const $3c8c6d537798cced$export$7b6612b7a7eba49d = (objectTypeId, mode)=>{
    $3c8c6d537798cced$export$f4aa5cae6294ae5b.set(`searchMode-${objectTypeId}`, mode);
};
const $3c8c6d537798cced$export$37b95a4bff5adfad = (objectTypeId)=>$3c8c6d537798cced$export$f4aa5cae6294ae5b.get(`searchMode-${objectTypeId}`);

});

parcelRegister("hHvBG", function(module, exports) {
$parcel$export(module.exports, "ICON_COLUMN_TARGET", () => $f274be2069119bd0$export$a4498fa25cbe8996);
$parcel$export(module.exports, "getColumns", () => $f274be2069119bd0$export$978e30a0fb8610d8);
$parcel$export(module.exports, "getAttributeFilters", () => $f274be2069119bd0$export$682c3cabe6b459c5);
$parcel$export(module.exports, "getObjectTypeFilters", () => $f274be2069119bd0$export$c2e9644c553953e7);
$parcel$export(module.exports, "getNumFilteredAttributes", () => $f274be2069119bd0$export$b6b47f9225933eb);
$parcel$export(module.exports, "getPendingSearchType", () => $f274be2069119bd0$export$fa10632a253270d5);
$parcel$export(module.exports, "getCanConvertQlQueryToFilter", () => $f274be2069119bd0$export$2c06b7d17781474);
$parcel$export(module.exports, "userCanFilterByObjectType", () => $f274be2069119bd0$export$4720dcb1166cbc76);
$parcel$export(module.exports, "getOrderBy", () => $f274be2069119bd0$export$128f09144c413f07);
$parcel$export(module.exports, "getObjectTypeAttribute", () => $f274be2069119bd0$export$ad3733b0e38a6f8e);
$parcel$export(module.exports, "getObjectTypeEntries", () => $f274be2069119bd0$export$df87b530f36fdc12);
$parcel$export(module.exports, "objectTypeHasNoObjects", () => $f274be2069119bd0$export$953688a268d84680);
$parcel$export(module.exports, "getPagination", () => $f274be2069119bd0$export$7107d372eaf3477f);
$parcel$export(module.exports, "getLastSearch", () => $f274be2069119bd0$export$8480542a6c6084e3);

var $gE6Gx = parcelRequire("gE6Gx");

var $ewZAy = parcelRequire("ewZAy");

var $35h4n = parcelRequire("35h4n");
const $f274be2069119bd0$export$a4498fa25cbe8996 = {
    type: 'avatar'
};
const $f274be2069119bd0$export$978e30a0fb8610d8 = ({ selectedColumns: selectedColumns, lastSearch: lastSearch, summableColumns: summableColumns })=>(0, $ewZAy.matchSearchState)(lastSearch, {
        loading: ()=>[],
        error: ()=>[],
        success: ({ result: result })=>{
            const attributes = result.attributes.map((attr)=>({
                    ...attr,
                    type: 'attribute'
                }));
            const columns = [
                $f274be2069119bd0$export$a4498fa25cbe8996,
                ...attributes
            ];
            const unselectedColumns = columns.filter((column)=>{
                const unselectedColumn = selectedColumns.find((selectedColumn)=>(0, $35h4n.isSameColumn)(selectedColumn, column));
                return !unselectedColumn;
            });
            const selectedColumnList = selectedColumns.map((selectedColumn)=>columns.filter((columnItem)=>(0, $35h4n.isSameColumn)(selectedColumn, columnItem))).flat();
            const updatedColumnList = [
                ...selectedColumnList,
                ...unselectedColumns
            ];
            return updatedColumnList.map((column)=>{
                const isSelected = !!selectedColumns.find((selectedColumn)=>(0, $35h4n.isSameColumn)(selectedColumn, column));
                const isIcon = column.type === 'avatar';
                const target = isIcon ? $f274be2069119bd0$export$a4498fa25cbe8996 : {
                    id: column.id,
                    name: column.name,
                    isLabel: column.isLabel,
                    type: column.type,
                    isSummable: summableColumns.has(column.id),
                    attributeType: column.attributeType,
                    defaultType: column.defaultType,
                    maximumCardinality: column.maximumCardinality
                };
                return {
                    isSelected: isSelected,
                    target: target
                };
            });
        }
    });
const $f274be2069119bd0$var$EMPTY_ATTRIBUTE_FILTERS = {
    allAttributeNames: [],
    filters: {},
    qlQuery: ''
};
const $f274be2069119bd0$export$682c3cabe6b459c5 = ({ lastSearch: lastSearch })=>(0, $ewZAy.matchSearchState)(lastSearch, {
        loading: ()=>$f274be2069119bd0$var$EMPTY_ATTRIBUTE_FILTERS,
        error: ()=>$f274be2069119bd0$var$EMPTY_ATTRIBUTE_FILTERS,
        success: ({ result: result })=>{
            const { attributes: attributes, filters: filters, qlQuery: qlQuery } = result;
            const allAttributeNames = attributes.filter((attr)=>attr.defaultType?.id?.toString() !== (0, $gE6Gx.DefaultAttributeSubtypeMap).Textarea).map(({ name: name })=>name);
            return {
                allAttributeNames: allAttributeNames,
                filters: filters,
                qlQuery: qlQuery
            };
        }
    });
const $f274be2069119bd0$export$c2e9644c553953e7 = ({ lastSearch: lastSearch })=>(0, $ewZAy.matchSearchState)(lastSearch, {
        loading: ()=>[],
        error: ()=>[],
        success: ({ result: result })=>{
            const { objectTypes: objectTypes } = result;
            if (!objectTypes) return [];
            return objectTypes.selectedValues;
        }
    });
const $f274be2069119bd0$export$b6b47f9225933eb = (state)=>{
    const { searchMode: searchMode } = state;
    const { filters: filters, qlQuery: qlQuery } = $f274be2069119bd0$export$682c3cabe6b459c5(state);
    if (searchMode === 'basic') {
        const selectedObjectValues = $f274be2069119bd0$export$c2e9644c553953e7(state);
        // TODO - the hasSelectedValues variable is currently filtering out wildcards for object type searches because
        // the backend doesn't support this at the moment. Once the backend supports objecttype wildcard/"like" searches,
        // this code can stop filtering out wildcards
        // https://stash.atlassian.com/projects/JIRACLOUD/repos/jira-frontend/pull-requests/83963/overview
        const hasSelectedValues = selectedObjectValues.length && selectedObjectValues.filter((item)=>item.type === 'wildcard').length !== selectedObjectValues.length ? 1 : 0;
        return Object.keys(filters).length + hasSelectedValues;
    }
    // if there's a qlQuery applied, count it as 1 filter
    return qlQuery !== '' ? 1 : 0;
};
const $f274be2069119bd0$export$fa10632a253270d5 = ({ lastSearch: lastSearch, pendingSearch: pendingSearch })=>(0, $ewZAy.matchSearchState)(lastSearch, {
        loading: ()=>'search',
        error: ()=>null,
        success: ()=>{
            if (pendingSearch !== null) return pendingSearch.isRefresh ? 'refresh' : 'search';
            return null;
        }
    });
const $f274be2069119bd0$export$2c06b7d17781474 = ({ lastSearch: lastSearch })=>(0, $ewZAy.matchSearchState)(lastSearch, {
        loading: ()=>false,
        error: ()=>false,
        success: ({ result: result })=>result.canConvertQlQueryToFilter
    });
const $f274be2069119bd0$export$4720dcb1166cbc76 = ({ lastSearch: lastSearch })=>(0, $ewZAy.matchSearchState)(lastSearch, {
        loading: ()=>false,
        error: ()=>false,
        success: ({ result: result })=>result.objectTypeIsInherited
    });
const $f274be2069119bd0$export$128f09144c413f07 = ({ lastSearch: lastSearch, pendingSearch: pendingSearch })=>(0, $ewZAy.matchSearchState)(lastSearch, {
        loading: ()=>null,
        error: ()=>null,
        success: ({ result: result })=>{
            if (pendingSearch === null) return result.orderBy;
            const pendingSearchRequest = pendingSearch.request;
            // Use pendingSearchRequest to optimistically show the new sort order for the pending request
            if (pendingSearchRequest.query.type === 'qlQuery') {
                const { qlQuery: qlQuery } = pendingSearchRequest.query;
                const { orderBy: orderBy } = (0, $35h4n.extractOrderBy)(qlQuery);
                if (orderBy === null) return null;
                const orderByAttribute = result.attributes.find(({ name: name })=>name === orderBy.attributeName);
                if (!orderByAttribute) return result.orderBy;
                return {
                    ...orderBy,
                    objectTypeAttributeId: orderByAttribute.id
                };
            }
            return pendingSearchRequest.query.orderBy;
        }
    });
const $f274be2069119bd0$export$ad3733b0e38a6f8e = ({ lastSearch: lastSearch }, attributeName)=>(0, $ewZAy.matchSearchState)(lastSearch, {
        loading: ()=>null,
        error: ()=>null,
        success: ({ result: result })=>{
            const { attributes: attributes } = result;
            return attributes.find(({ name: name })=>name === attributeName) || null;
        }
    });
const $f274be2069119bd0$export$df87b530f36fdc12 = ({ lastSearch: lastSearch })=>(0, $ewZAy.matchSearchState)(lastSearch, {
        loading: ()=>[],
        error: ()=>[],
        success: ({ result: result })=>{
            const { objectTypes: objectTypes } = result;
            if (objectTypes === null) return [];
            return objectTypes.entries;
        }
    });
const $f274be2069119bd0$var$isRequestForAllObjects = ({ query: query })=>{
    switch(query.type){
        case 'qlQuery':
            return String(query.qlQuery).trim().length === 0;
        case 'filter':
            return Object.keys(query.filters).length === 0 && query.objectTypes.length === 0;
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            query;
            return false;
    }
};
const $f274be2069119bd0$export$953688a268d84680 = (searchState)=>(0, $ewZAy.matchSearchState)(searchState, {
        loading: ()=>false,
        error: ()=>false,
        success: ({ result: result, request: request })=>result.objects.length === 0 && $f274be2069119bd0$var$isRequestForAllObjects(request)
    });
const $f274be2069119bd0$var$EMPTY_PAGINATION = {
    hasNextPage: false,
    hasPrevPage: false,
    numObjects: 0,
    numPages: 1,
    hasMoreResults: false,
    uncappedNumObjects: undefined,
    pageNumber: 1,
    startIndex: 1,
    toIndex: 1
};
const $f274be2069119bd0$export$7107d372eaf3477f = ({ lastSearch: lastSearch })=>(0, $ewZAy.matchSearchState)(lastSearch, {
        loading: ()=>$f274be2069119bd0$var$EMPTY_PAGINATION,
        error: ()=>$f274be2069119bd0$var$EMPTY_PAGINATION,
        success: ({ result: result })=>{
            const { pageNumber: pageNumber, numObjects: numObjects, numPages: numPages, startIndex: startIndex, toIndex: toIndex, hasMoreResults: hasMoreResults, uncappedNumObjects: uncappedNumObjects } = result;
            return {
                hasPrevPage: pageNumber > 1,
                hasNextPage: pageNumber < numPages,
                numObjects: numObjects,
                numPages: numPages,
                hasMoreResults: hasMoreResults,
                uncappedNumObjects: uncappedNumObjects,
                pageNumber: pageNumber,
                startIndex: startIndex,
                toIndex: toIndex
            };
        }
    });
const $f274be2069119bd0$export$8480542a6c6084e3 = (state)=>(0, $ewZAy.matchSearchState)(state.lastSearch, {
        error: ()=>undefined,
        loading: ()=>undefined,
        success: (search)=>search
    });

});
parcelRegister("ewZAy", function(module, exports) {
$parcel$export(module.exports, "matchSearchState", () => $1bef3c38c499c338$export$e3132099b420bc97);
const $1bef3c38c499c338$export$6f4891c7dfe2cc03 = (asyncState, handlers)=>{
    switch(asyncState.type){
        case 'loading':
            return handlers.loading();
        case 'error':
            return handlers.error(asyncState.error);
        case 'success':
            return handlers.success(asyncState.value);
        default:
            // This can never happen...
            // @ts-expect-error Property 'type' does not exist on type 'never'.
            throw new Error(`Unexpected async type: ${asyncState.type}`);
    }
};
const $1bef3c38c499c338$export$e3132099b420bc97 = (searchState, handlers)=>$1bef3c38c499c338$export$6f4891c7dfe2cc03(searchState, handlers);
const $1bef3c38c499c338$export$a4c23e3e596a4946 = (searchScope, handlers)=>{
    switch(searchScope.type){
        case 'global':
            return handlers.global();
        case 'schema-object-type':
            {
                const { objectSchemaId: objectSchemaId, objectTypeId: objectTypeId } = searchScope;
                return handlers.objectType(objectSchemaId, objectTypeId);
            }
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            searchScope;
            // @ts-expect-error - TS2339 - Property 'type' does not exist on type 'never'.
            throw new Error(`Unexpected searchScope.type: ${searchScope.type}`);
    }
};

});


parcelRegister("6ukrC", function(module, exports) {
$parcel$export(module.exports, "actions", () => $604e731eef0a32f2$export$e324594224ef24da);

var $hE2kS = parcelRequire("hE2kS");

var $9qU43 = parcelRequire("9qU43");

var $lMuMD = parcelRequire("lMuMD");

var $hJd9A = parcelRequire("hJd9A");

var $p9L9Q = parcelRequire("p9L9Q");

var $9JIPR = parcelRequire("9JIPR");

var $2kEQK = parcelRequire("2kEQK");

var $2lJ1U = parcelRequire("2lJ1U");
const $604e731eef0a32f2$export$e324594224ef24da = {
    executeSearch: $9qU43.executeSearch,
    updateSearchIql: $9qU43.updateSearchIql,
    updateSearchFilter: $9qU43.updateSearchFilter,
    updateOrderBy: $2lJ1U.updateOrderBy,
    refreshSearch: $9qU43.refreshSearch,
    setSelectedColumns: $9JIPR.setSelectedColumns,
    setSummableColumns: $2kEQK.setSummableColumns,
    setSearchMode: $p9L9Q.setSearchMode,
    changePagination: $hE2kS.changePagination,
    triggerSuccessfulObjectFilterExperience: $hJd9A.triggerSuccessfulObjectFilterExperience,
    startUpdateObjectFilterExperience: $hJd9A.startUpdateObjectFilterExperience,
    failUpdateObjectFilterExperience: $hJd9A.failUpdateObjectFilterExperience,
    fetchUncappedCount: $lMuMD.fetchUncappedCount
};

});
parcelRegister("hE2kS", function(module, exports) {
$parcel$export(module.exports, "changePagination", () => $df0533cfeec4b853$export$2a3c3c6237b72dd);

var $9qU43 = parcelRequire("9qU43");
const $df0533cfeec4b853$export$2a3c3c6237b72dd = (pageNumber)=>async ({ getState: getState, dispatch: dispatch })=>{
        const { lastSearch: lastSearch } = getState();
        if (lastSearch.type !== 'success') return;
        await dispatch((0, $9qU43.executeSearch)({
            request: {
                query: lastSearch.value.request.query,
                page: {
                    type: 'page-number',
                    pageNumber: pageNumber
                }
            },
            isRefresh: true
        }));
    };

});
parcelRegister("9qU43", function(module, exports) {
$parcel$export(module.exports, "executeSearch", () => $44bd3643fc34362d$export$8b48f59de667ba4);
$parcel$export(module.exports, "updateSearchIql", () => $44bd3643fc34362d$export$61c14f78acd2156b);
$parcel$export(module.exports, "updateSearchFilter", () => $44bd3643fc34362d$export$26d6aab4e2bd3c2d);
$parcel$export(module.exports, "refreshSearch", () => $44bd3643fc34362d$export$f3c29abf5e27aca2);

var $51aj0 = parcelRequire("51aj0");

var $1uIew = parcelRequire("1uIew");

var $gCeeo = parcelRequire("gCeeo");

var $ewZAy = parcelRequire("ewZAy");

var $35h4n = parcelRequire("35h4n");

var $kXsN9 = parcelRequire("kXsN9");

var $4wEUK = parcelRequire("4wEUK");

var $hHvBG = parcelRequire("hHvBG");

var $efPdM = parcelRequire("efPdM");

var $abSrP = parcelRequire("abSrP");
const $44bd3643fc34362d$export$8b48f59de667ba4 = ({ request: request, isRefresh: isRefresh = false, resetUncappedNumObjects: // The uncapped (>1000) total count is fetched externally using the /aql/totalcount and not apart of /navlist
// but use the same state store, we only want the previously stored uncappedNumObjects to reset in certain situations
// e.g new AQL, filters or refresh - updating of pagination, ORDER BY should not reset.
resetUncappedNumObjects = false })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent, searchScope: searchScope })=>{
        const isInitialRequest = (0, $ewZAy.matchSearchState)(getState().lastSearch, {
            loading: ()=>true,
            error: ()=>false,
            success: ()=>false
        });
        try {
            setState({
                pendingSearch: {
                    request: request,
                    isRefresh: isRefresh
                }
            });
            const result = await (0, $4wEUK.fetchSearchResults)({
                workspaceId: workspaceId,
                searchScope: searchScope,
                searchRequest: request
            });
            // Check that pendingSearch in state is identical. If not, another search has been run since this
            // one, so the current search should be discarded.
            const { pendingSearch: pendingSearch, currentSearchScope: currentSearchScope, lastSearch: previousSearch } = getState();
            if (pendingSearch !== null && request !== pendingSearch.request) return;
            if (currentSearchScope === null) return;
            const { objectTypeId: objectTypeId } = (0, $35h4n.checkIsSupportedSearchScope)(currentSearchScope);
            const previousUncappedNumObjects = previousSearch.type === 'success' ? previousSearch.value.result.uncappedNumObjects : undefined;
            const lastSearch = {
                type: 'success',
                value: {
                    request: request,
                    result: {
                        ...result,
                        uncappedNumObjects: resetUncappedNumObjects ? undefined : previousUncappedNumObjects
                    }
                }
            };
            const localObjectTypeRecord = (0, $kXsN9.insightObjectSearchLocalStorage).get((0, $kXsN9.OBJECT_TYPE) + objectTypeId);
            const localSelectedColumnRecord = localObjectTypeRecord === undefined ? undefined : localObjectTypeRecord[0, $kXsN9.SELECTED_COLUMNS];
            const localSummableColumnRecord = localObjectTypeRecord === undefined ? undefined : localObjectTypeRecord[0, $kXsN9.SUMMABLE_COLUMNS];
            if (isInitialRequest) {
                const selectedColumns = localSelectedColumnRecord !== undefined ? (0, $abSrP.getLocalSelectedColumns)(localSelectedColumnRecord, result) : [
                    (0, $hHvBG.ICON_COLUMN_TARGET),
                    ...(0, $abSrP.getInitialSelectedColumns)(result)
                ];
                setState({
                    lastSearch: lastSearch,
                    pendingSearch: null,
                    selectedColumns: selectedColumns,
                    summableColumns: new Set(localSummableColumnRecord ?? [])
                });
            } else {
                (0, $kXsN9.setLocalLastSearchQuery)(objectTypeId, result.qlQuery);
                setState({
                    lastSearch: lastSearch,
                    pendingSearch: null
                });
            }
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'executeSearch succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // Check that pendingSearch in state is identical. If not, another search has been run since this
            // one, so the current search should be discarded.
            const { pendingSearch: pendingSearch, currentSearchScope: currentSearchScope } = getState();
            if (pendingSearch !== null && request !== pendingSearch.request) return;
            /**
			 * When user set up the filter with custom object attributes, filter will be stored in both store and localStorage
			 * When the user deletes that attribute but we still have that attribute in the qlquery, backend will return 400 ValidationError
			 * In this case frontend will show an error state and the user is not able to access the table view
			 * In this situation, this piece of code will clear the qlQuery filter to aviod error state
			 */ if (currentSearchScope?.type === 'schema-object-type' && error instanceof (0, $1uIew.ValidationError) && (0, $kXsN9.getLocalLastSearchQuery)(currentSearchScope.objectTypeId) && (isInitialRequest || isRefresh)) {
                const { page: page } = request;
                const newRequest = {
                    query: {
                        type: 'qlQuery',
                        qlQuery: ''
                    },
                    page: page
                };
                setState({
                    ...(0, $efPdM.initialState),
                    currentSearchScope: currentSearchScope
                });
                (0, $kXsN9.setLocalLastSearchQuery)(currentSearchScope.objectTypeId, '');
                await dispatch($44bd3643fc34362d$export$8b48f59de667ba4({
                    request: newRequest,
                    resetUncappedNumObjects: true
                }));
                return;
            }
            // Only ever set `lastSearch` to error if this is the initial request. For updates, the error is thrown
            // allowing callers to indicate the failure (e.g. with a flag).
            if (isInitialRequest) setState({
                lastSearch: {
                    type: 'error',
                    error: error
                },
                pendingSearch: null
            });
            else setState({
                pendingSearch: null
            });
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'executeSearch',
                    packageName: 'jiraServicedeskInsightObjectSearchStore',
                    teamName: 'aurum'
                },
                error: error
            });
            throw error;
        }
    };
const $44bd3643fc34362d$var$throwForInvalidState = async ()=>{
    throw new Error('Cannot call search update in loading / error state');
};
const $44bd3643fc34362d$export$61c14f78acd2156b = (newIql)=>async ({ getState: getState, dispatch: dispatch })=>{
        const { lastSearch: lastSearch } = getState();
        return (0, $ewZAy.matchSearchState)(lastSearch, {
            loading: $44bd3643fc34362d$var$throwForInvalidState,
            error: $44bd3643fc34362d$var$throwForInvalidState,
            success: async ()=>{
                const newRequest = {
                    query: {
                        type: 'qlQuery',
                        qlQuery: newIql
                    },
                    page: {
                        type: 'page-number',
                        pageNumber: 1
                    }
                };
                await dispatch($44bd3643fc34362d$export$8b48f59de667ba4({
                    request: newRequest,
                    resetUncappedNumObjects: true
                }));
            }
        });
    };
const $44bd3643fc34362d$export$26d6aab4e2bd3c2d = (newFilters, newObjectTypes = [])=>async ({ getState: getState, dispatch: dispatch })=>{
        const { lastSearch: lastSearch } = getState();
        return (0, $ewZAy.matchSearchState)(lastSearch, {
            loading: $44bd3643fc34362d$var$throwForInvalidState,
            error: $44bd3643fc34362d$var$throwForInvalidState,
            success: async ({ result: result })=>{
                const { orderBy: orderBy } = result;
                const newRequest = {
                    query: {
                        type: 'filter',
                        orderBy: // Retain existing order by
                        orderBy,
                        filters: newFilters,
                        objectTypes: newObjectTypes
                    },
                    page: {
                        type: 'page-number',
                        pageNumber: 1
                    }
                };
                await dispatch($44bd3643fc34362d$export$8b48f59de667ba4({
                    request: newRequest,
                    resetUncappedNumObjects: true
                }));
            }
        });
    };
const $44bd3643fc34362d$export$f3c29abf5e27aca2 = ()=>async ({ getState: getState, dispatch: dispatch })=>{
        const { lastSearch: lastSearch } = getState();
        return (0, $ewZAy.matchSearchState)(lastSearch, {
            // Ignore if this is called while still loading
            loading: ()=>Promise.resolve(undefined),
            error: ()=>Promise.resolve(undefined),
            success: async ({ request: request })=>{
                await dispatch($44bd3643fc34362d$export$8b48f59de667ba4({
                    request: request,
                    isRefresh: true,
                    resetUncappedNumObjects: true
                }));
            }
        });
    };

});
parcelRegister("4wEUK", function(module, exports) {
$parcel$export(module.exports, "fetchSearchResults", () => $c55c8e1f00004d29$export$c7eeb53d50673e29);

var $u4YbY = parcelRequire("u4YbY");

var $8rYjX = parcelRequire("8rYjX");



var $hAViP = parcelRequire("hAViP");

var $2GHCX = parcelRequire("2GHCX");

var $aAk9o = parcelRequire("aAk9o");

var $35h4n = parcelRequire("35h4n");
const $c55c8e1f00004d29$export$c7eeb53d50673e29 = async ({ workspaceId: workspaceId, searchScope: searchScope, searchRequest: searchRequest })=>{
    const { objectSchemaId: objectSchemaId, objectTypeId: objectTypeId } = (0, $35h4n.checkIsSupportedSearchScope)(searchScope);
    const { query: query, page: page } = searchRequest;
    const baseRequestPayload = {
        objectTypeId: objectTypeId,
        objectSchemaId: objectSchemaId,
        // Pass in null for now to fetch all attributes
        // NB: this ensures that ALL object type attributes (objectTypeAttributes property) are returned so is used to
        // render the list of all possible attributes. If this is changed to a subset (i.e. to only fetch required
        // attribute VALUES), then the list of all attributes should be fetched separately.
        attributesToDisplay: null,
        includeAttributes: true,
        objectId: page.type === 'page-containing-object' ? page.objectId : undefined,
        page: page.type === 'page-number' ? page.pageNumber : 1,
        resultsPerPage: (0, $34cc1ab04c33fd0c$export$d2f17d20365655cb)
    };
    switch(query.type){
        case 'qlQuery':
            {
                const { qlQuery: qlQuery } = query;
                const requestPayload = {
                    ...baseRequestPayload,
                    qlQuery: qlQuery
                };
                const response = await (0, $u4YbY.performCmdbPostRequest)((0, $8rYjX.getCmdbObjectNavlistQueryLanguageUrl)(workspaceId), {
                    body: JSON.stringify(requestPayload)
                });
                const searchResultObjectTypes = await (0, $2GHCX.getObjectTypesIfObjectIsInherited)({
                    objectTypeIsInherited: response.objectTypeIsInherited,
                    workspaceId: workspaceId,
                    objectTypeId: objectTypeId
                });
                const searchResult = (0, $35h4n.transformSearchResponse)(response, searchResultObjectTypes);
                return {
                    ...searchResult,
                    filters: await (0, $aAk9o.replaceFilterStatusNamesWithIds)({
                        workspaceId: workspaceId,
                        schemaId: objectSchemaId,
                        filters: searchResult.filters
                    })
                };
            }
        case 'filter':
            {
                const { orderBy: orderBy, filters: filters, objectTypes: objectTypes } = query;
                const requestPayload = {
                    ...baseRequestPayload,
                    filters: (0, $hAViP.createFilterRequestItems)(filters, objectTypes)
                };
                if (orderBy !== null) {
                    requestPayload.asc = orderBy.direction === 'ASC' ? (0, $183b1488d190b220$export$622ae7b3ab289d35) : (0, $183b1488d190b220$export$582a7724d79d52c7);
                    requestPayload.orderByTypeAttrId = orderBy.objectTypeAttributeId;
                }
                const response = await (0, $u4YbY.performCmdbPostRequest)((0, $8rYjX.getCmdbObjectNavlistUrl)(workspaceId), {
                    body: JSON.stringify(requestPayload)
                });
                const searchResultObjectTypes = await (0, $2GHCX.getObjectTypesIfObjectIsInherited)({
                    objectTypeIsInherited: response.objectTypeIsInherited,
                    workspaceId: workspaceId,
                    objectTypeId: objectTypeId
                });
                const searchResult = (0, $35h4n.transformSearchResponse)(response, searchResultObjectTypes);
                return {
                    ...searchResult,
                    filters: await (0, $aAk9o.replaceFilterStatusNamesWithIds)({
                        workspaceId: workspaceId,
                        schemaId: objectSchemaId,
                        filters: searchResult.filters
                    })
                };
            }
        default:
            // prettier-ignore
            // @ts-expect-error - TS2339 - Property 'type' does not exist on type 'never'.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            query.type;
            throw new Error("Unexpected query type is not 'qlQuery' or 'filter'");
    }
};

});
const $34cc1ab04c33fd0c$export$d2f17d20365655cb = 100;

const $183b1488d190b220$export$582a7724d79d52c7 = '0';
const $183b1488d190b220$export$622ae7b3ab289d35 = '1';

parcelRegister("aAk9o", function(module, exports) {
$parcel$export(module.exports, "replaceFilterStatusNamesWithIds", () => $97678ca59a3e0050$export$8dc6cfaeac3b5d92);

var $51aj0 = parcelRequire("51aj0");

var $1WACN = parcelRequire("1WACN");
const $97678ca59a3e0050$export$8dc6cfaeac3b5d92 = async ({ workspaceId: workspaceId, schemaId: schemaId, filters: filters })=>{
    try {
        const updatedFilters = {};
        let loadedStatuses = null;
        for(let filterIndex = 0; filterIndex < Object.keys(filters).length; filterIndex += 1){
            const attributeName = Object.keys(filters)[filterIndex];
            const filter = filters[attributeName];
            const { attributeFilter: attributeFilter } = filter;
            if (attributeFilter.type !== 'status') {
                updatedFilters[attributeName] = filter;
                continue;
            }
            if (loadedStatuses === null) // Will be called at most once for the entire function
            // eslint-disable-next-line no-await-in-loop
            loadedStatuses = await (0, $1WACN.fetchSchemaStatusTypes)({
                workspaceId: workspaceId,
                schemaId: schemaId
            });
            const updatedStatusValueMatches = [];
            for(let valueIndex = 0; valueIndex < attributeFilter.values.length; valueIndex += 1){
                const valueMatch = attributeFilter.values[valueIndex];
                if (valueMatch.type === 'wildcard') updatedStatusValueMatches.push(valueMatch);
                else {
                    const statusName = valueMatch.value;
                    const matchingStatus = loadedStatuses.find((status)=>status.name.toLowerCase() === statusName.toLowerCase());
                    if (matchingStatus != null) updatedStatusValueMatches.push({
                        type: 'exact-match',
                        value: matchingStatus.id
                    });
                }
            }
            updatedFilters[attributeName] = {
                ...filter,
                attributeFilter: {
                    type: 'status',
                    values: updatedStatusValueMatches
                }
            };
        }
        return updatedFilters;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $51aj0.fireCmdbErrorAnalytics)({
            meta: {
                id: 'replaceFilterStatusNamesWithIds',
                packageName: 'jiraServicedeskInsightObjectSearchStore',
                teamName: 'aurum'
            },
            error: error
        });
        return filters;
    }
};

});
parcelRegister("1WACN", function(module, exports) {
$parcel$export(module.exports, "fetchSchemaStatusTypes", () => $b9f3c229e9669d97$export$ebc73685955e2f6e);

var $u4YbY = parcelRequire("u4YbY");

var $fKDKn = parcelRequire("fKDKn");
const $b9f3c229e9669d97$export$ebc73685955e2f6e = async ({ workspaceId: workspaceId, schemaId: schemaId, controller: controller })=>{
    const globalStatusesPromise = (0, $u4YbY.performCmdbGetRequest)((0, $fKDKn.getCmdbConfigStatusTypeUrl)(workspaceId), controller ? {
        signal: controller.signal
    } : undefined);
    const schemaStatusesPromise = (0, $u4YbY.performCmdbGetRequest)((0, $fKDKn.getCmdbConfigStatusTypeUrl)(workspaceId, {
        objectSchemaId: schemaId
    }), controller ? {
        signal: controller.signal
    } : undefined);
    return [
        ...await globalStatusesPromise,
        ...await schemaStatusesPromise
    ];
};

});
parcelRegister("fKDKn", function(module, exports) {
$parcel$export(module.exports, "getCmdbConfigStatusTypeUrl", () => $d87cbbb4189fe650$export$3269d36b59c9d27f);
$parcel$export(module.exports, "getCmdbConfigStatusTypeByIdUrl", () => $d87cbbb4189fe650$export$229964acb6a55e5);
$parcel$export(module.exports, "getCmdbConfigStatusTypePickerUrl", () => $d87cbbb4189fe650$export$1991fb4d07b18469);
$parcel$export(module.exports, "getCmdbConfigReferenceTypeUrl", () => $d87cbbb4189fe650$export$ad07341c88d2bbab);
$parcel$export(module.exports, "getCmdbConfigReferenceTypeByIdUrl", () => $d87cbbb4189fe650$export$293e2bfa6752a2aa);
$parcel$export(module.exports, "getCmdbConfigRoleByIdUrl", () => $d87cbbb4189fe650$export$225d5f547cc90d86);
$parcel$export(module.exports, "getCmdbConfigRoleObjectSchemaByIdUrl", () => $d87cbbb4189fe650$export$9c1d73050da32aae);
$parcel$export(module.exports, "getCmdbConfigRoleObjectTypeByIdUrl", () => $d87cbbb4189fe650$export$6583ed007df50d2b);
$parcel$export(module.exports, "getCmdbPermsPrincipalUrl", () => $d87cbbb4189fe650$export$a635e2e9382b1621);
$parcel$export(module.exports, "getCmdbPermsRoleAssignmentUrl", () => $d87cbbb4189fe650$export$b3cb4590859563b0);
$parcel$export(module.exports, "getCmdbPermsTokenStatusUrl", () => $d87cbbb4189fe650$export$8ae00db5fd7218c5);
$parcel$export(module.exports, "getMyDataManagerRolesUrl", () => $d87cbbb4189fe650$export$794aa3ae46133f30);

var $b5RwB = parcelRequire("b5RwB");

var $1qZG3 = parcelRequire("1qZG3");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/config
 */ const $d87cbbb4189fe650$var$getCmdbConfigUrl = (workspaceId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/config`;
const $d87cbbb4189fe650$export$3269d36b59c9d27f = (workspaceId, queryParams)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/statustype${queryParams ? `?${(0, $b5RwB.stringify)(queryParams)}` : ''}`;
const $d87cbbb4189fe650$export$229964acb6a55e5 = (workspaceId, statusTypeId)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/statustype/${statusTypeId}`;
const $d87cbbb4189fe650$export$1991fb4d07b18469 = (workspaceId, queryParams)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/statustype/picker?${(0, $b5RwB.stringify)(queryParams)}`;
const $d87cbbb4189fe650$export$ad07341c88d2bbab = (workspaceId, queryParams)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/referencetype${queryParams ? `?${(0, $b5RwB.stringify)(queryParams)}` : ''}`;
const $d87cbbb4189fe650$export$293e2bfa6752a2aa = (workspaceId, referenceTypeId)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/referencetype/${referenceTypeId}`;
const $d87cbbb4189fe650$export$225d5f547cc90d86 = (workspaceId, roleId)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/role/${roleId}`;
const $d87cbbb4189fe650$export$9c1d73050da32aae = (workspaceId, objectSchemaId)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/role/objectschema/${objectSchemaId}`;
const $d87cbbb4189fe650$export$6583ed007df50d2b = (workspaceId, objectTypeId)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/role/objecttype/${objectTypeId}`;
const $d87cbbb4189fe650$export$a635e2e9382b1621 = (workspaceId)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/perms/principal`;
const $d87cbbb4189fe650$export$b3cb4590859563b0 = (workspaceId)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/perms/role-assignment`;
const $d87cbbb4189fe650$export$8ae00db5fd7218c5 = (workspaceId, token)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/perms/token-status?token=${token}`;
const $d87cbbb4189fe650$export$794aa3ae46133f30 = (workspaceId)=>`${$d87cbbb4189fe650$var$getCmdbConfigUrl(workspaceId)}/perms/my-roles`;

});




parcelRegister("abSrP", function(module, exports) {
$parcel$export(module.exports, "getInitialSelectedColumns", () => $a0c228023e0d8660$export$116c479121240dd1);
$parcel$export(module.exports, "getLocalSelectedColumns", () => $a0c228023e0d8660$export$b333c80bd7eb379e);

var $hHvBG = parcelRequire("hHvBG");
const $a0c228023e0d8660$export$116c479121240dd1 = (searchResult)=>searchResult.attributes.reduce((acc, attribute)=>{
        const { id: id, name: name, isSystem: isSystem, isLabel: isLabel } = attribute;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const column = {
            id: id,
            name: name,
            type: 'attribute',
            isLabel: isLabel
        };
        if (isSystem || isLabel) acc.push(column);
        return acc;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, []);
const $a0c228023e0d8660$export$b333c80bd7eb379e = (localRecordList, searchResult)=>localRecordList.reduce((acc, columnId)=>{
        const { attributes: attributes } = searchResult;
        attributes.forEach((attribute)=>{
            const { id: id, name: name, isLabel: isLabel } = attribute;
            if (id === columnId) {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const column = {
                    id: id,
                    name: name,
                    type: 'attribute',
                    isLabel: isLabel
                };
                acc.push(column);
            }
        });
        if (columnId === 'icon') acc.push((0, $hHvBG.ICON_COLUMN_TARGET));
        return acc;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, []);

});



parcelRegister("lMuMD", function(module, exports) {
$parcel$export(module.exports, "fetchUncappedCount", () => $d29d635f9bbe5350$export$695335223a92ee07);

var $51aj0 = parcelRequire("51aj0");

var $gCeeo = parcelRequire("gCeeo");

var $u4YbY = parcelRequire("u4YbY");

var $8rYjX = parcelRequire("8rYjX");

var $35h4n = parcelRequire("35h4n");
const $d29d635f9bbe5350$export$3fdd59c45361d985 = async (workspaceId, qlQuery)=>(0, $u4YbY.performCmdbPostRequest)((0, $8rYjX.getCmdbObjectQueryLanguageTotalCountUrl)(workspaceId), {
        body: JSON.stringify({
            qlQuery: qlQuery
        })
    });
const $d29d635f9bbe5350$var$updateUncappedNumObjectsState = (lastSearch, uncappedNumObjects)=>({
        lastSearch: {
            ...lastSearch,
            value: {
                ...lastSearch.value,
                result: {
                    ...lastSearch.value.result,
                    uncappedNumObjects: uncappedNumObjects
                }
            }
        }
    });
const $d29d635f9bbe5350$export$695335223a92ee07 = ()=>async ({ getState: getState, setState: setState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { lastSearch: lastSearch, currentSearchScope: currentSearchScope } = getState();
        if (lastSearch.type !== 'success' || !currentSearchScope) return;
        setState($d29d635f9bbe5350$var$updateUncappedNumObjectsState(lastSearch, {
            totalCount: undefined,
            loading: true,
            error: undefined
        }));
        try {
            const lastQlQueryString = lastSearch.value.result.qlQuery;
            const { objectTypeId: objectTypeId, objectSchemaId: objectSchemaId, isObjectTypeInherited: isObjectTypeInherited } = (0, $35h4n.checkIsSupportedSearchScope)(currentSearchScope);
            const qlQuery = (0, $35h4n.generateQlQueryForSearchScope)(lastQlQueryString, {
                objectTypeId: objectTypeId,
                objectSchemaId: objectSchemaId,
                isObjectTypeInherited: isObjectTypeInherited
            });
            const response = await $d29d635f9bbe5350$export$3fdd59c45361d985(workspaceId, qlQuery);
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchUncappedCount succeeded');
            setState($d29d635f9bbe5350$var$updateUncappedNumObjectsState(lastSearch, {
                totalCount: response.totalCount,
                loading: false,
                error: undefined
            }));
        } catch (err) {
            const typesafeError = err instanceof Error ? err : new Error('Unknown error');
            setState($d29d635f9bbe5350$var$updateUncappedNumObjectsState(lastSearch, {
                totalCount: undefined,
                loading: false,
                error: typesafeError
            }));
            (0, $51aj0.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchUncappedCount',
                    packageName: 'jiraServicedeskInsightObjectSearchStore',
                    teamName: 'aurum'
                },
                error: typesafeError
            });
        }
    };

});

parcelRegister("hJd9A", function(module, exports) {
$parcel$export(module.exports, "triggerSuccessfulObjectFilterExperience", () => $dd5f1749dbb14c9d$export$f30bf7e8a8203b12);
$parcel$export(module.exports, "startUpdateObjectFilterExperience", () => $dd5f1749dbb14c9d$export$103a0122fe34ec01);
$parcel$export(module.exports, "failUpdateObjectFilterExperience", () => $dd5f1749dbb14c9d$export$403926e537661d94);

var $8E59C = parcelRequire("8E59C");
const $dd5f1749dbb14c9d$export$f30bf7e8a8203b12 = ()=>async ({ setState: setState })=>{
        (0, $8E59C.updateObjectFilterExperience).success();
        setState({
            filtersUpdated: false
        });
        return undefined;
    };
const $dd5f1749dbb14c9d$export$103a0122fe34ec01 = ()=>async ({ setState: setState })=>{
        (0, $8E59C.updateObjectFilterExperience).start();
        setState({
            filtersUpdated: true
        });
        return undefined;
    };
const $dd5f1749dbb14c9d$export$403926e537661d94 = ()=>async ({ setState: setState })=>{
        (0, $8E59C.updateObjectFilterExperience).failure();
        setState({
            filtersUpdated: false
        });
        return undefined;
    };

});

parcelRegister("p9L9Q", function(module, exports) {
$parcel$export(module.exports, "setSearchMode", () => $9a9ff3c214a19320$export$f192987f0c42cf5c);

var $35h4n = parcelRequire("35h4n");

var $kXsN9 = parcelRequire("kXsN9");
const $9a9ff3c214a19320$export$f192987f0c42cf5c = (newSearchMode)=>async ({ setState: setState }, { searchScope: searchScope })=>{
        const { objectTypeId: objectTypeId } = (0, $35h4n.checkIsSupportedSearchScope)(searchScope);
        setState({
            searchMode: newSearchMode
        });
        (0, $kXsN9.setLocalSearchMode)(objectTypeId, newSearchMode);
    };

});

parcelRegister("9JIPR", function(module, exports) {
$parcel$export(module.exports, "setSelectedColumns", () => $080eb78811e69c8d$export$2e78a27e0c3fc4d7);
const $080eb78811e69c8d$export$2e78a27e0c3fc4d7 = (newSelectedColumns)=>async ({ setState: setState })=>{
        setState({
            selectedColumns: newSelectedColumns
        });
    };

});

parcelRegister("2kEQK", function(module, exports) {
$parcel$export(module.exports, "setSummableColumns", () => $ce298d5a58339641$export$ce081b0554996cb4);
const $ce298d5a58339641$export$ce081b0554996cb4 = (column)=>async ({ setState: setState, getState: getState })=>{
        const summableColumns = new Set(getState().summableColumns ?? []);
        if (column.isSummable) summableColumns.add(column.id);
        else summableColumns.delete(column.id);
        setState({
            summableColumns: summableColumns
        });
    };

});

parcelRegister("2lJ1U", function(module, exports) {
$parcel$export(module.exports, "updateOrderBy", () => $8a518f0ae38ba882$export$97e7cc6f9d60e442);

var $3VjNa = parcelRequire("3VjNa");

var $35h4n = parcelRequire("35h4n");

var $9qU43 = parcelRequire("9qU43");
const $8a518f0ae38ba882$export$97e7cc6f9d60e442 = (newOrderBy)=>async ({ getState: getState, dispatch: dispatch })=>{
        const { lastSearch: lastSearch } = getState();
        if (lastSearch.type !== 'success') return;
        // Take the request that was made for the current displayed search and update with the new order
        const originalRequestQuery = lastSearch.value.request.query;
        let query;
        if (originalRequestQuery.type === 'qlQuery') {
            const { iqlWithoutOrderBy: iqlWithoutOrderBy } = (0, $35h4n.extractOrderBy)(originalRequestQuery.qlQuery);
            const { attributeName: attributeName, direction: direction } = newOrderBy;
            const updatedQlQuery = (0, $3VjNa.toValidatedIql)(`${String(iqlWithoutOrderBy)} ORDER BY "${attributeName}" ${direction}`);
            query = {
                ...originalRequestQuery,
                qlQuery: updatedQlQuery
            };
        } else query = {
            ...originalRequestQuery,
            orderBy: newOrderBy
        };
        await dispatch((0, $9qU43.executeSearch)({
            request: {
                query: query,
                // Always go to page 1 after changing order
                page: {
                    type: 'page-number',
                    pageNumber: 1
                }
            },
            isRefresh: true
        }));
    };

});



parcelRegister("fr3Es", function(module, exports) {
$parcel$export(module.exports, "AsyncLazyForceGraph", () => $e6d0443f25fe8b50$export$786a65e3efaf54c3);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e6d0443f25fe8b50$var$LazyForceGraph = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("fG2hB")), {
    ssr: false,
    moduleId: "./src/packages/assets-app/assets-common/assets-graphs/force-graph/src/ui/index.tsx"
});
const $e6d0443f25fe8b50$export$786a65e3efaf54c3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "async.jira-assets-graphs-force-graph",
        packageName: "atlassian/jira-assets-graphs-force-graph"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "jira-assets-graphs-force-graph",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e6d0443f25fe8b50$var$LazyForceGraph, props)));

});
parcelRegister("fG2hB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lzpdB").then(()=>parcelRequire('dPQzM'));

});


const $6b5a3de1ca600c55$export$accaa52ddae3fe58 = 'node';
const $6b5a3de1ca600c55$export$7093ae9f18906e17 = 34;
const $6b5a3de1ca600c55$export$cf8a94c984678862 = 480;
const $6b5a3de1ca600c55$export$434d30b064b8d4cf = 120;

parcelRegister("ggKmh", function(module, exports) {
$parcel$export(module.exports, "usePushingSidebar", () => $efc70fd5a4918eaf$export$5ad0920cf30d9f08);

var $eJOHy = parcelRequire("eJOHy");
const $efc70fd5a4918eaf$export$444990cc7caeb4e0 = 300;
const $efc70fd5a4918eaf$export$5ad0920cf30d9f08 = ({ width: width = $efc70fd5a4918eaf$export$444990cc7caeb4e0, defaultIsOpen: defaultIsOpen = true })=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(defaultIsOpen);
    const [sidebarWidth, setSidebarWidth] = (0, $eJOHy.useState)(width);
    const toggleSidebar = ()=>{
        setIsOpen((a)=>!a);
    };
    return (0, $eJOHy.useMemo)(()=>[
            {
                isOpen: isOpen,
                sidebarWidth: sidebarWidth
            },
            {
                toggleSidebar: toggleSidebar,
                setSidebarWidth: setSidebarWidth
            }
        ], [
        isOpen,
        sidebarWidth
    ]);
};

});

parcelRegister("jzwEl", function(module, exports) {
$parcel$export(module.exports, "GraphHeader", () => $8cdec4e9645ba007$export$deaeec1bb8f9bce8);

var $eJOHy = parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $6J9k6 = parcelRequire("6J9k6");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $Ay1uj = parcelRequire("Ay1uj");

var $lRq8t = parcelRequire("lRq8t");

var $iJEtc = parcelRequire("iJEtc");
const $8cdec4e9645ba007$export$deaeec1bb8f9bce8 = ({ title: title, onClose: onClose, toggleGraphSideBarAction: toggleGraphSideBarAction })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "center",
        xcss: $8cdec4e9645ba007$var$wrapperNewObjectGraphStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8cdec4e9645ba007$var$Title, null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "center",
        justifyContent: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $8cdec4e9645ba007$var$sidebarActionBorderStyles
    }, toggleGraphSideBarAction), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $iJEtc.default).closeLabel),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))),
        appearance: "subtle",
        onClick: onClose,
        testId: "assets-graph-header.button-close",
        label: formatMessage((0, $iJEtc.default).closeButtonIcon)
    }))));
};
const $8cdec4e9645ba007$var$Title = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $8cdec4e9645ba007$var$titleStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "large",
        as: "h1"
    }, children));
const $8cdec4e9645ba007$var$wrapperNewObjectGraphStyles = (0, $1DXK0.xcss)({
    boxSizing: 'border-box',
    padding: 'space.300',
    borderBottomWidth: 'border.width',
    borderBottomStyle: 'solid',
    borderBottomColor: 'color.border',
    height: '72px'
});
const $8cdec4e9645ba007$var$titleStyles = (0, $1DXK0.xcss)({
    color: 'color.text',
    margin: 'space.0',
    flexGrow: '1',
    marginTop: 'space.050',
    paddingBottom: 'space.050',
    fontWeight: 'font.weight.regular'
});
const $8cdec4e9645ba007$var$sidebarActionBorderStyles = (0, $1DXK0.xcss)({
    paddingRight: 'space.100',
    borderRightWidth: 'border.width.selected',
    borderRightStyle: 'solid',
    borderRightColor: 'color.border',
    marginRight: 'space.100'
});

});
parcelRegister("iJEtc", function(module, exports) {
$parcel$export(module.exports, "default", () => $b24abadd36ae6f0b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b24abadd36ae6f0b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    closeLabel: {
        "id": "assets-graph-header.close-label",
        "defaultMessage": "Close"
    },
    closeButtonIcon: {
        "id": "assets-graph-header.close-button-icon",
        "defaultMessage": "Close Button Icon"
    }
});

});


parcelRegister("2otBq", function(module, exports) {
$parcel$export(module.exports, "GraphPanelSplitter", () => $7f2bca67667c7a60$export$f83cbd12b483d558);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $2bY1m = parcelRequire("2bY1m");
var $glIca = parcelRequire("glIca");

var $lRq8t = parcelRequire("lRq8t");

var $3NC6z = parcelRequire("3NC6z");


var $4aKFs = parcelRequire("4aKFs");
const $7f2bca67667c7a60$var$resizingCssVar = '--panel-splitter-resizing';
const $7f2bca67667c7a60$var$widthVar = '--panel-width';
const $7f2bca67667c7a60$export$f83cbd12b483d558 = ({ isOpen: isOpen, sidebarWidth: sidebarWidth, setSidebarWidth: setSidebarWidth, children: children, disableResizePanel: disableResizePanel = false })=>{
    const panelSplitterParentRef = (0, $eJOHy.useRef)(null);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const setAndStoreWidth = (0, $eJOHy.useCallback)((newWidth)=>{
        const validNewWidth = Math.min((0, $99f1d34fa7fb4417$export$3417d6a98c71f50d), Math.max((0, $99f1d34fa7fb4417$export$9e62bf46fccb5c80), newWidth));
        setSidebarWidth(validNewWidth);
    }, [
        setSidebarWidth
    ]);
    if (!isOpen) return null;
    if (disableResizePanel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $7f2bca67667c7a60$var$sidebarPanelWrapper,
            $7f2bca67667c7a60$var$sidebarPanelWithoutResizer
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $7f2bca67667c7a60$var$objectViewWrapperStyles
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $7f2bca67667c7a60$var$sidebarPanelWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        ref: panelSplitterParentRef,
        xcss: $7f2bca67667c7a60$var$resizableStyles,
        // eslint-disable-next-line jira/react/no-style-attribute -- Ignored via go/DSP-18766
        style: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {
            [$7f2bca67667c7a60$var$widthVar]: `${sidebarWidth}px`
        },
        testId: "assets-graph-panel-splitter.ui.graph-panel-splitter.box"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $glIca.PanelSplitterProvider), {
        panelRef: panelSplitterParentRef,
        panelWidth: sidebarWidth,
        onCompleteResize: setAndStoreWidth,
        getResizeBounds: (0, $3NC6z.getResizeBounds),
        resizingCssVar: $7f2bca67667c7a60$var$resizingCssVar,
        position: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $7f2bca67667c7a60$var$objectViewWrapperStyles
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bY1m.PanelSplitter), {
        label: formatMessage((0, $4aKFs.default).graphPanelSplitterLabel)
    }))));
};
const $7f2bca67667c7a60$var$sidebarPanelWrapper = (0, $1DXK0.xcss)({
    overflow: 'hidden',
    paddingLeft: 'space.025'
});
const $7f2bca67667c7a60$var$sidebarPanelWithoutResizer = (0, $1DXK0.xcss)({
    width: '600px'
});
const $7f2bca67667c7a60$var$objectViewWrapperStyles = (0, $1DXK0.xcss)({
    height: '100%',
    overflow: 'hidden',
    borderLeftWidth: 'border.width',
    borderLeftStyle: 'solid',
    borderLeftColor: 'color.border'
});
const $7f2bca67667c7a60$var$resizableStyles = (0, $1DXK0.xcss)({
    position: 'relative',
    backgroundColor: 'elevation.surface',
    width: `var(${$7f2bca67667c7a60$var$resizingCssVar}, var(${$7f2bca67667c7a60$var$widthVar}))`,
    height: '100%'
});

});
parcelRegister("3NC6z", function(module, exports) {
$parcel$export(module.exports, "getResizeBounds", () => $6bdfd78240860f1a$export$95d758f0170ec9ec);

function $6bdfd78240860f1a$export$95d758f0170ec9ec() {
    return {
        min: `${0, $99f1d34fa7fb4417$export$9e62bf46fccb5c80}px`,
        max: `${0, $99f1d34fa7fb4417$export$3417d6a98c71f50d}px`
    };
}

});
// Object Graph - Side Panel
const $99f1d34fa7fb4417$export$9e62bf46fccb5c80 = 250;
const $99f1d34fa7fb4417$export$3417d6a98c71f50d = 1000;


parcelRegister("4aKFs", function(module, exports) {
$parcel$export(module.exports, "default", () => $f16cc5cb4ac615b9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f16cc5cb4ac615b9$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    graphPanelSplitterLabel: {
        "id": "assets-graph-panel-splitter.graph-panel-splitter.graph-panel-splitter-label",
        "defaultMessage": "Assets Graph Panel Splitter"
    }
});

});


parcelRegister("ikpEg", function(module, exports) {
$parcel$export(module.exports, "GRAPH_NODE_TYPES", () => $bc5b7b0c9f58e9ee$export$172900d1bc4220d9);
const $bc5b7b0c9f58e9ee$var$OBJECT_GRAPH_NODE_TYPE = 'O';
const $bc5b7b0c9f58e9ee$var$OBJECT_TYPE_GRAPH_NODE_TYPE = 'T';
const $bc5b7b0c9f58e9ee$export$172900d1bc4220d9 = Object.freeze({
    OBJECT: $bc5b7b0c9f58e9ee$var$OBJECT_GRAPH_NODE_TYPE,
    OBJECT_TYPE: $bc5b7b0c9f58e9ee$var$OBJECT_TYPE_GRAPH_NODE_TYPE
});

});

parcelRegister("fT8uq", function(module, exports) {
$parcel$export(module.exports, "useObjectGraphConfiguration", () => $08badab004fbe782$export$7d92b63999f03c61);

var $eJOHy = parcelRequire("eJOHy");

var $6GQyf = parcelRequire("6GQyf");

var $eY3jn = parcelRequire("eY3jn");
const $08badab004fbe782$var$getDefaultConfiguration = ()=>({
        // controls how many degrees of separation of nodes to show based on the initial object
        referenceDepth: 1,
        // controls the amount of inbound nodes of a particular object type before merging them as a single node
        maxOfSameType: 10
    });
const $08badab004fbe782$var$getMaxReferenceDepth = ()=>5;
const $08badab004fbe782$var$getMaxOfSameType = ()=>50;
const $08badab004fbe782$export$7d92b63999f03c61 = (objectGraphData, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
initialObjectTypeId)=>{
    const [configuration, setConfiguration] = (0, $eJOHy.useState)(()=>({
            ...(0, $6GQyf.getGraphConfigurationLocalStorage)() ?? $08badab004fbe782$var$getDefaultConfiguration(),
            referenceTypes: []
        }));
    // re-generate the reference type filters whenever the graph data updates
    (0, $eJOHy.useEffect)(()=>{
        const { nodes: nodes = [], edges: edges = [] } = objectGraphData ?? {};
        const referenceTypes = (0, $eY3jn.getReferenceTypes)({
            nodes: // @ts-expect-error - TS2322 - Type 'Node[]' is not assignable to type 'ReactNode[]'.
            nodes,
            edges: edges,
            initialObjectTypeId: initialObjectTypeId,
            referenceDepth: configuration.referenceDepth
        });
        setConfiguration((config)=>({
                ...config,
                referenceTypes: referenceTypes
            }));
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        configuration.referenceDepth,
        objectGraphData
    ]); // we don't want to listen for changes to initialObjectTypeId here
    const updateReferenceTypes = (0, $eJOHy.useCallback)((updated)=>{
        (0, $6GQyf.setReferenceCheckedLocalStorage)({
            objectTypeId: initialObjectTypeId,
            referenceLabel: updated.label,
            updatedValue: updated.checked
        });
        setConfiguration((config)=>({
                ...config,
                referenceTypes: config.referenceTypes.map((r)=>r.label === updated.label ? updated : r)
            }));
    }, [
        initialObjectTypeId
    ]);
    const updateReferenceDepth = (0, $eJOHy.useCallback)((updatedReferenceDepth)=>{
        if (updatedReferenceDepth >= 1 && updatedReferenceDepth <= $08badab004fbe782$var$getMaxReferenceDepth()) {
            (0, $6GQyf.setGraphConfigurationLocalStorage)({
                referenceDepth: updatedReferenceDepth,
                maxOfSameType: configuration.maxOfSameType
            });
            setConfiguration((config)=>({
                    ...config,
                    referenceDepth: updatedReferenceDepth
                }));
        }
    }, [
        configuration
    ]);
    const updateMaxOfSameType = (0, $eJOHy.useCallback)((updatedMaxOfSameType)=>{
        if (updatedMaxOfSameType >= 1 && updatedMaxOfSameType <= $08badab004fbe782$var$getMaxOfSameType()) {
            (0, $6GQyf.setGraphConfigurationLocalStorage)({
                referenceDepth: configuration.referenceDepth,
                maxOfSameType: updatedMaxOfSameType
            });
            setConfiguration((config)=>({
                    ...config,
                    maxOfSameType: updatedMaxOfSameType
                }));
        }
    }, [
        configuration
    ]);
    return [
        configuration,
        {
            updateReferenceDepth: updateReferenceDepth,
            updateMaxOfSameType: updateMaxOfSameType,
            updateReferenceTypes: updateReferenceTypes
        }
    ];
};

});
parcelRegister("6GQyf", function(module, exports) {
$parcel$export(module.exports, "getGraphConfigurationLocalStorage", () => $634c88ab332747e9$export$43af2d54030d43b1);
$parcel$export(module.exports, "setGraphConfigurationLocalStorage", () => $634c88ab332747e9$export$957c0561e5b0dd2d);
$parcel$export(module.exports, "getReferenceCheckedLocalStorage", () => $634c88ab332747e9$export$e2f6fac45be157c1);
$parcel$export(module.exports, "setReferenceCheckedLocalStorage", () => $634c88ab332747e9$export$a6fb5b32429a9337);

var $dnU6V = parcelRequire("dnU6V");
const $634c88ab332747e9$var$OBJECT_GRAPH_CONFIGURATION_KEY = 'objectGraphConfiguration';
const $634c88ab332747e9$export$ddcffe0146c8f882 = (0, $dnU6V.createLocalStorageProvider)('jsm-cmdb-object-graph');
const $634c88ab332747e9$export$43af2d54030d43b1 = ()=>{
    try {
        const graphConfig = $634c88ab332747e9$export$ddcffe0146c8f882.get($634c88ab332747e9$var$OBJECT_GRAPH_CONFIGURATION_KEY);
        if (graphConfig) {
            const { referenceDepth: referenceDepth, maxOfSameType: maxOfSameType } = JSON.parse(graphConfig);
            return {
                referenceDepth: referenceDepth,
                maxOfSameType: maxOfSameType
            };
        }
        return undefined;
    } catch (err) {
        return undefined;
    }
};
const $634c88ab332747e9$export$957c0561e5b0dd2d = (updatedConfig)=>{
    const existingConfig = $634c88ab332747e9$export$43af2d54030d43b1();
    $634c88ab332747e9$export$ddcffe0146c8f882.set($634c88ab332747e9$var$OBJECT_GRAPH_CONFIGURATION_KEY, JSON.stringify({
        ...existingConfig,
        ...updatedConfig
    }));
};
const $634c88ab332747e9$export$e2f6fac45be157c1 = ({ objectTypeId: objectTypeId, referenceLabel: referenceLabel })=>{
    try {
        const isChecked = $634c88ab332747e9$export$ddcffe0146c8f882.get(`objectType${objectTypeId}-reference${referenceLabel}`);
        return JSON.parse(isChecked);
    } catch (error) {
        return undefined;
    }
};
const $634c88ab332747e9$export$a6fb5b32429a9337 = ({ objectTypeId: objectTypeId, referenceLabel: referenceLabel, updatedValue: updatedValue })=>{
    $634c88ab332747e9$export$ddcffe0146c8f882.set(`objectType${objectTypeId}-reference${referenceLabel}`, JSON.stringify(updatedValue));
};

});

parcelRegister("eY3jn", function(module, exports) {
$parcel$export(module.exports, "getReferenceTypes", () => $2762cb963b8a1329$export$7cc38071d2ea10f2);

var $6GQyf = parcelRequire("6GQyf");
const $2762cb963b8a1329$var$getReferenceCheckedState = (objectTypeId, referenceLabel, showByDefault)=>{
    const defaultCheckedState = showByDefault ?? true;
    return (0, $6GQyf.getReferenceCheckedLocalStorage)({
        objectTypeId: objectTypeId,
        referenceLabel: referenceLabel
    }) ?? defaultCheckedState;
};
const $2762cb963b8a1329$export$7cc38071d2ea10f2 = ({ nodes: nodes, edges: edges, referenceDepth: referenceDepth, initialObjectTypeId: initialObjectTypeId })=>{
    // we accumulate a set of reference types that store all edges between nodes that are associated with that reference
    // this is used render nodes / edges in the graph and to filter out nodes in the graph based on whether the reference type is checked or not
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const referenceTypes = edges.reduce((referenceTypeList, edge)=>{
        const reference = {
            label: edge.label,
            color: edge.color,
            from: [
                edge.from
            ],
            to: [
                edge.to
            ],
            checked: true,
            count: 1
        };
        // for each edge we validate the node/s it connects are valid before associating it with a reference
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'. | TS2339 - Property 'id' does not exist on type 'boolean | ReactChild | ReactFragment | ReactPortal'.
        const hasSourceNode = nodes.some((n)=>n.id === edge.from.slice(1));
        const hasDestinationNode = nodes.some(// @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'. | TS2339 - Property 'id' does not exist on type 'boolean | ReactChild | ReactFragment | ReactPortal'. | TS2533 - Object is possibly 'null' or 'undefined'. | TS2339 - Property 'depth' does not exist on type 'boolean | ReactChild | ReactFragment | ReactPortal'.
        (n)=>n.id === edge.to.slice(1) && n.depth <= referenceDepth);
        const isValidEdge = hasDestinationNode && hasSourceNode;
        const existingReference = referenceTypeList.find((r)=>r.label === reference.label);
        if (existingReference && isValidEdge) {
            existingReference.from.push(edge.from);
            existingReference.to.push(edge.to);
            existingReference.count += 1;
            existingReference.checked = $2762cb963b8a1329$var$getReferenceCheckedState(initialObjectTypeId, edge.label, existingReference.count < 10);
        } else if (isValidEdge) {
            reference.checked = $2762cb963b8a1329$var$getReferenceCheckedState(initialObjectTypeId, edge.label);
            referenceTypeList.push(reference);
        }
        return referenceTypeList;
    }, []);
    return referenceTypes;
};

});


parcelRegister("21rPz", function(module, exports) {
$parcel$export(module.exports, "useSelectedNode", () => $c90582135a8fe748$export$aa8f1c72cfda8469);

var $eJOHy = parcelRequire("eJOHy");

var $ikpEg = parcelRequire("ikpEg");
const $c90582135a8fe748$export$aa8f1c72cfda8469 = (initialObjectId)=>{
    const [selectedNode, setSelectedNode] = (0, $eJOHy.useState)({
        type: (0, $ikpEg.GRAPH_NODE_TYPES).OBJECT,
        nodeId: (0, $ikpEg.GRAPH_NODE_TYPES).OBJECT + initialObjectId,
        referenceId: initialObjectId
    });
    const setSelectedObjectNode = (0, $eJOHy.useCallback)((objectId)=>{
        setSelectedNode({
            type: (0, $ikpEg.GRAPH_NODE_TYPES).OBJECT,
            nodeId: (0, $ikpEg.GRAPH_NODE_TYPES).OBJECT + objectId,
            referenceId: objectId
        });
    }, []);
    const setSelectedObjectTypeNode = (0, $eJOHy.useCallback)((node)=>{
        setSelectedNode({
            type: (0, $ikpEg.GRAPH_NODE_TYPES).OBJECT_TYPE,
            nodeId: (0, $ikpEg.GRAPH_NODE_TYPES).OBJECT_TYPE + node.id,
            referenceId: node.id,
            objectSchemaId: node.objectSchemaId ?? '',
            icon: node.icon,
            name: node.name
        });
    }, []);
    return [
        selectedNode,
        {
            setSelectedObjectNode: setSelectedObjectNode,
            setSelectedObjectTypeNode: setSelectedObjectTypeNode
        }
    ];
};

});

// Object Graph
const $f336ad0fcf5cc359$export$161cd349e5a4ad87 = '95vw';
const $f336ad0fcf5cc359$export$668351e45c4a316f = '100vh';

parcelRegister("lu2my", function(module, exports) {
$parcel$export(module.exports, "GraphConfigurationActionPanel", () => $e59938847ff0865b$export$f028fcb976898610);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7rjYb = parcelRequire("7rjYb");

var $1KdDN = parcelRequire("1KdDN");
const $e59938847ff0865b$export$f028fcb976898610 = ({ menuPosition: menuPosition, renderActionButton: renderActionButton, children: children, isConfigPanelOpen: isConfigPanelOpen, onOpenChange: onOpenChange })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "object-graph-configuration-panel",
        packageName: "jiraAssetsObjectGraph",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e59938847ff0865b$var$DropdownContainer, {
        onClick: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        isOpen: isConfigPanelOpen,
        onOpenChange: (args)=>{
            onOpenChange(args.isOpen);
        },
        zIndex: 1000,
        trigger: renderActionButton,
        shouldFlip: false,
        placement: `bottom-${menuPosition === 'left' ? 'start' : 'end'}`,
        appearance: "tall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $e59938847ff0865b$var$contentContainerStyles
    }, children))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e59938847ff0865b$var$DropdownContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1n1u1wug _nz6r1wug _1nyh1kdj",
            __cmplp.className
        ])
    });
});
const $e59938847ff0865b$var$contentContainerStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.200',
    marginRight: 'space.200',
    marginBottom: 'space.200',
    marginLeft: 'space.200',
    maxWidth: '370px'
});

});

parcelRegister("kJzNO", function(module, exports) {
$parcel$export(module.exports, "ReferenceDepthConfigurationInputs", () => $863f11fd6b5f61ed$export$1a7cfc9d06ab35e3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3s8bj = parcelRequire("3s8bj");

var $goZPP = parcelRequire("goZPP");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $5lAAn = parcelRequire("5lAAn");

var $3cMgR = parcelRequire("3cMgR");

var $sY9BV = parcelRequire("sY9BV");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $7jTnu = parcelRequire("7jTnu");

var $7YC0i = parcelRequire("7YC0i");
const $863f11fd6b5f61ed$export$a77796dd088d9f7d = ({ value: value, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const referenceDepthOptions = Array.from(Array(5), (_, i)=>i + 1);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        zIndex: 1000,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...props,
                ref: triggerRef,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
                    label: "down icon",
                    size: "small"
                }),
                testId: "assets-object-graph.ui.graph-config-panel.reference-depth-inputs.trigger-button"
            }, value),
        appearance: "tall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, referenceDepthOptions.map((depth)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            paddingInline: "space.100",
            key: depth
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
            onClick: ()=>onChange(depth),
            testId: "assets-object-graph.ui.graph-config-panel.reference-depth-inputs.depth-option"
        }, formatMessage((0, $7YC0i.default)[depth]))))));
};
const $863f11fd6b5f61ed$export$4b100b07e5f29926 = ({ value: value, onChange: onChange })=>{
    const [internalValue, setInternalValue] = (0, $eJOHy.useState)(value);
    const debouncedOnChange = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(onChange, 200), [
        onChange
    ]);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    (0, $eJOHy.useEffect)(()=>{
        setInternalValue(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
        testId: "assets-object-graph.ui.graph-config-panel.reference-depth-inputs.max-of-same-type",
        type: "number",
        autoComplete: "off",
        min: 1,
        max: 50,
        value: internalValue,
        onChange: (event)=>{
            // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'EventTarget'.
            const { value: updated } = event.target;
            const newValue = Number(updated);
            setInternalValue(newValue);
            debouncedOnChange(newValue);
        },
        "aria-label": (0, $7jTnu.fg)('assets_enghealth_aurum-1') ? formatMessage((0, $7YC0i.default).inboundReferencesLabel) : undefined
    });
};
const $863f11fd6b5f61ed$export$1a7cfc9d06ab35e3 = (props)=>{
    const { maxOfSameType: maxOfSameType, referenceDepth: referenceDepth, onUpdateReferenceDepth: onUpdateReferenceDepth, onUpdateMaxOfSameType: onUpdateMaxOfSameType } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $863f11fd6b5f61ed$var$inputContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $863f11fd6b5f61ed$var$labelTextStyles,
        as: "p"
    }, formatMessage((0, $7YC0i.default).referenceDepthLabel), ":"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($863f11fd6b5f61ed$export$a77796dd088d9f7d, {
        value: referenceDepth,
        onChange: onUpdateReferenceDepth
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $863f11fd6b5f61ed$var$inputContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $863f11fd6b5f61ed$var$labelTextStyles,
        as: "p"
    }, formatMessage((0, $7YC0i.default).inboundReferencesLabel), ":"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($863f11fd6b5f61ed$var$InboundReferencesContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($863f11fd6b5f61ed$export$4b100b07e5f29926, {
        value: maxOfSameType,
        onChange: onUpdateMaxOfSameType
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        as: "p",
        size: "UNSAFE_small"
    }, formatMessage((0, $7YC0i.default).helpText)));
};
const $863f11fd6b5f61ed$var$inputContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 'space.100',
    maxWidth: '200px'
});
const $863f11fd6b5f61ed$var$labelTextStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $863f11fd6b5f61ed$var$InboundReferencesContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_rff01wqb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7YC0i", function(module, exports) {
$parcel$export(module.exports, "default", () => $e449cf6c13b69a5e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e449cf6c13b69a5e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    referenceDepthLabel: {
        "id": "assets-object-graph.graph-config-panel.reference-depth-inputs.reference-depth-label",
        "defaultMessage": "Reference depth"
    },
    inboundReferencesLabel: {
        "id": "assets-object-graph.graph-config-panel.reference-depth-inputs.inbound-references-label",
        "defaultMessage": "Inbound references"
    },
    helpText: {
        "id": "assets-object-graph.graph-config-panel.reference-depth-inputs.help-text",
        "defaultMessage": "The maximum number of inbound references from the same object type, before grouping them as a single node."
    },
    '1': {
        "id": "assets-object-graph.graph-config-panel.reference-depth-inputs.1",
        "defaultMessage": "1"
    },
    '2': {
        "id": "assets-object-graph.graph-config-panel.reference-depth-inputs.2",
        "defaultMessage": "2"
    },
    '3': {
        "id": "assets-object-graph.graph-config-panel.reference-depth-inputs.3",
        "defaultMessage": "3"
    },
    '4': {
        "id": "assets-object-graph.graph-config-panel.reference-depth-inputs.4",
        "defaultMessage": "4"
    },
    '5': {
        "id": "assets-object-graph.graph-config-panel.reference-depth-inputs.5",
        "defaultMessage": "5"
    }
});

});


parcelRegister("dM8nW", function(module, exports) {
$parcel$export(module.exports, "ReferenceTypeToggleList", () => $7af4388e649e5df3$export$aa0ca936e7260336);

var $eJOHy = parcelRequire("eJOHy");

var $86tBw = parcelRequire("86tBw");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7jTnu = parcelRequire("7jTnu");
const $7af4388e649e5df3$export$aa0ca936e7260336 = (props)=>{
    const { referenceTypes: referenceTypes, onChange: onChange } = props;
    const onToggleReferenceType = (referenceTypeToUpdate)=>{
        const updatedReferenceType = {
            ...referenceTypeToUpdate,
            checked: !referenceTypeToUpdate.checked
        };
        onChange(updatedReferenceType);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $7af4388e649e5df3$var$containerStyles
    }, referenceTypes.map((rt)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $7af4388e649e5df3$var$inputContainerStyles,
            key: rt.label
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86tBw.default), {
            isChecked: rt.checked,
            onChange: ()=>onToggleReferenceType(rt),
            testId: `assets-object-graph.ui.graph-config-panel.reference-types-toggle-list.checkbox-${rt.label}`,
            "aria-label": (0, $7jTnu.fg)('assets_enghealth_aurum-1') ? rt.label : undefined
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7af4388e649e5df3$var$ColorCircle, {
            color: rt.color
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $7af4388e649e5df3$var$labelTextStyles,
            as: "p"
        }, rt.label))));
};
const $7af4388e649e5df3$var$ColorCircle = ({ color: color, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $7af4388e649e5df3$var$colorCircleStyles,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            backgroundColor: color
        }
    }, children);
const $7af4388e649e5df3$var$labelTextStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.100',
    marginRight: 'space.100',
    marginBottom: 'space.100',
    marginLeft: 'space.100'
});
const $7af4388e649e5df3$var$inputContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center',
    marginBottom: 'space.100',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    wordBreak: 'break-word'
});
const $7af4388e649e5df3$var$containerStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.200'
});
const $7af4388e649e5df3$var$colorCircleStyles = (0, $1DXK0.xcss)({
    height: '28px',
    minWidth: '28px',
    borderRadius: 'radius.full'
});

});

parcelRegister("jPx2I", function(module, exports) {
$parcel$export(module.exports, "GraphError", () => $62b2935441550176$export$7314831ac2fea5d8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6MnLl = parcelRequire("6MnLl");

var $dymbf = parcelRequire("dymbf");

var $aTJmy = parcelRequire("aTJmy");

var $lRq8t = parcelRequire("lRq8t");

var $4DAcC = parcelRequire("4DAcC");
const $62b2935441550176$export$7314831ac2fea5d8 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const renderImage = ()=>(0, $aTJmy.getAkEmptyStateRenderImageFn)((0, $dymbf.default))({
            imageWidth: 120,
            maxImageWidth: 120,
            maxImageHeight: 212
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($62b2935441550176$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        header: formatMessage((0, $4DAcC.default).errorTitle),
        description: formatMessage((0, $4DAcC.default).errorDescription),
        renderImage: renderImage
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $62b2935441550176$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1osq _j1pnusvi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4DAcC", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1139bd8c57d5ada$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a1139bd8c57d5ada$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorTitle: {
        "id": "assets-object-graph.graph-error.error-title",
        "defaultMessage": "Failed to load graph"
    },
    errorDescription: {
        "id": "assets-object-graph.graph-error.error-description",
        "defaultMessage": "Please refresh the page and try again."
    }
});

});


parcelRegister("rakSF", function(module, exports) {
$parcel$export(module.exports, "default", () => $70a5c5b140617e41$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $70a5c5b140617e41$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "assets-object-graph.title",
        "defaultMessage": "Object graph"
    },
    showDetail: {
        "id": "assets-object-graph.show-detail",
        "defaultMessage": "Show object details panel"
    },
    hideDetail: {
        "id": "assets-object-graph.hide-detail",
        "defaultMessage": "Hide object details panel"
    },
    lockLayout: {
        "id": "assets-object-graph.lock-layout",
        "defaultMessage": "Lock node layout"
    },
    unlockLayout: {
        "id": "assets-object-graph.unlock-layout",
        "defaultMessage": "Unlock node layout"
    },
    showGraphConfigPanel: {
        "id": "assets-object-graph.show-graph-config-panel",
        "defaultMessage": "Show graph configuration"
    },
    hideGraphConfigPanel: {
        "id": "assets-object-graph.hide-graph-config-panel",
        "defaultMessage": "Hide graph configuration"
    },
    graphConfigPanelHeader: {
        "id": "assets-object-graph.graph-config-panel-header",
        "defaultMessage": "Graph configuration"
    },
    referenceTypesHeader: {
        "id": "assets-object-graph.reference-types-header",
        "defaultMessage": "Reference types"
    }
});

});

parcelRegister("28GgS", function(module, exports) {
$parcel$export(module.exports, "ObjectTypeView", () => $da628b01bc1dff4b$export$707a485e8827bede);

var $eJOHy = parcelRequire("eJOHy");

var $3cMgR = parcelRequire("3cMgR");

var $8nu6j = parcelRequire("8nu6j");

var $iHPvF = parcelRequire("iHPvF");

var $lRq8t = parcelRequire("lRq8t");

var $bYOuG = parcelRequire("bYOuG");

var $5iXCb = parcelRequire("5iXCb");

var $j4dSC = parcelRequire("j4dSC");
const $da628b01bc1dff4b$export$707a485e8827bede = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { objectTypeNode: objectTypeNode } = props;
    const { name: name, icon: icon, objectSchemaId: objectSchemaId, referenceId: referenceId } = objectTypeNode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        padding: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5iXCb.SidebarHeader), {
        title: name,
        iconUrl: icon,
        tooltip: formatMessage((0, $j4dSC.default).openObjectTypeDetails),
        link: (0, $bYOuG.createObjectTypeUrl)(objectSchemaId, referenceId)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
        appearance: "information"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        as: "p"
    }, formatMessage((0, $j4dSC.default).maxOfTypeExceeded))));
};

});
parcelRegister("5iXCb", function(module, exports) {
$parcel$export(module.exports, "SidebarHeader", () => $76e3d3bcec274345$export$e575a964a1fe8b0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $806LH = parcelRequire("806LH");

var $8rAKL = parcelRequire("8rAKL");

var $8IeH1 = parcelRequire("8IeH1");

var $k71qx = parcelRequire("k71qx");

var $c9uTK = parcelRequire("c9uTK");
const $76e3d3bcec274345$var$CustomHeading = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        as: "h3",
        size: "small"
    }, props.children);
const $76e3d3bcec274345$export$e575a964a1fe8b0 = ({ iconUrl: iconUrl, link: link, title: title, tooltip: tooltip })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        "data-testId": "object-name-link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($76e3d3bcec274345$var$ObjectNameLink, {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($76e3d3bcec274345$var$ObjectIcon, {
        "data-testId": "object-name-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        src: iconUrl,
        key: iconUrl,
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($76e3d3bcec274345$var$ObjectName, null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        "data-testId": "object-name-tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: tooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        "data-testId": "assets-object-graph.common.ui.sidebar-header.object-name-shortcut-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8rAKL))), {
        spacing: "spacious",
        label: ""
    }))))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $76e3d3bcec274345$var$ObjectNameLink = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $c9uTK.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _otyrpxbi _l8ku23z3 _tf4iidpf _12hn1q5t _t7blu2gc _f8pj14q2 _30l314q2 _16xekb7n _1fmgkb7n _1n83z12g _12svz12g",
            __cmplp.className
        ])
    });
});
const $76e3d3bcec274345$var$ObjectIcon = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1o9zidpf _1bsb1ejb _4t3i1ejb _2hwxutpp _mezj1osq _bna71osq",
            __cmplp.className
        ])
    });
});
const $76e3d3bcec274345$var$ObjectName = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $76e3d3bcec274345$var$CustomHeading, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1gjq _1i4q1hna _slp31hna _1nmz9jpi _30l314q2",
            __cmplp.className
        ])
    });
});

});

parcelRegister("j4dSC", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f53e18fa3945471$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $0f53e18fa3945471$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    openObjectTypeDetails: {
        "id": "assets-object-graph.object-type-view.open-object-type-details",
        "defaultMessage": "Open object type details page"
    },
    maxOfTypeExceeded: {
        "id": "assets-object-graph.object-type-view.max-of-type-exceeded",
        "defaultMessage": "The number of objects of this type were too many to be represented individually in the graph and have therefore been grouped together in a single node."
    }
});

});


parcelRegister("U3bzc", function(module, exports) {
$parcel$export(module.exports, "getNormalizedGraphData", () => $ab534ccf85aa33ce$export$34e9eaff58eacd53);
$parcel$export(module.exports, "getFilteredEdgesAndNodes", () => $ab534ccf85aa33ce$export$24f0dc2bbb91dd1a);
$parcel$export(module.exports, "getConnectedNodesFromParent", () => $ab534ccf85aa33ce$export$3c9910179eb68b3b);


var $7g3Zh = parcelRequire("7g3Zh");
const $ab534ccf85aa33ce$var$normalizeNode = (n)=>({
        id: `${n.type}${n.id}`,
        value: n.id,
        /**
	 * TODO We should consider that 'Object Type' and 'Object' nodes are
	 * visually identical but behave differently when clicked. The server
	 * version of the graph gets around this by appending (Type) to 'Object
	 * Type' node names. However that approach would require injecting intl
	 * functions into this transformer function which isn't ideal in this case.
	 */ name: n.name,
        draggable: true,
        symbol: `image://${n.icon}`,
        symbolSize: (0, $1b8b2de41d1fcbdf$export$7093ae9f18906e17),
        context: {
            type: n.type,
            name: n.name,
            id: n.id,
            icon: n.icon,
            objectSchemaId: n.objectSchemaId
        }
    });
const $ab534ccf85aa33ce$var$normalizeEdge = (e)=>({
        name: e.label,
        source: e.from,
        target: e.to,
        lineStyle: {
            color: e.color,
            ...(0, $7g3Zh.DEFAULT_LINE_STYLE)
        },
        symbolSize: 8
    });
const $ab534ccf85aa33ce$export$34e9eaff58eacd53 = (insightGraphData)=>{
    const { nodes: nodes = [], edges: edges = [] } = insightGraphData ?? {};
    const normalizedEdges = edges.map($ab534ccf85aa33ce$var$normalizeEdge);
    const normalizedNodes = nodes.map($ab534ccf85aa33ce$var$normalizeNode);
    return {
        nodes: normalizedNodes,
        edges: normalizedEdges
    };
};
const $ab534ccf85aa33ce$export$24f0dc2bbb91dd1a = (objectGraphData, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
referenceTypes, selectedObjectId)=>{
    const { nodes: nodes = [], edges: edges = [] } = objectGraphData ?? {};
    const enabledReferenceTypes = referenceTypes.filter((r)=>r.checked === true);
    const updatedEdges = edges.filter((edge)=>enabledReferenceTypes.some((r)=>r.to.includes(edge.to)) && enabledReferenceTypes.some((r)=>r.from.includes(edge.from)));
    const updatedNodes = nodes.filter((node)=>// always include the currently selected node (even with no outgoing edges)
        node.id === selectedObjectId || updatedEdges.find((e)=>e.to.slice(1) === node.id) || updatedEdges.find((e)=>e.from.slice(1) === node.id));
    return {
        nodes: updatedNodes,
        edges: updatedEdges
    };
};
const $ab534ccf85aa33ce$export$3c9910179eb68b3b = (objectGraphData, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
parentObjectId)=>{
    const { nodes: nodes = [], edges: edges = [] } = objectGraphData ?? {};
    const parentObject = nodes.find((n)=>n.id === parentObjectId);
    const updatedNodes = parentObject ? [
        parentObject
    ] : [];
    const updatedEdges = [];
    // TODO: can potentially refactor the way this logic works to be more efficient
    // every time we add a new connection, we want to re-iterate to ensure we add additional valid connections to those new nodes we added in the previous iteration
    let shouldTraverseEdges = true;
    while(shouldTraverseEdges){
        shouldTraverseEdges = false;
        for (const edge of edges){
            const isAlreadyAdded = updatedEdges.some((existingEdge)=>existingEdge === edge);
            const hasValidConnection = updatedNodes.filter(Boolean).some((n)=>n.id === edge.to.slice(1) || n.id === edge.from.slice(1));
            if (!isAlreadyAdded && hasValidConnection) {
                shouldTraverseEdges = true;
                updatedEdges.push(edge);
                // whenever we add a valid edge we go through the existing nodes and add those that are connected via the edge to the result
                nodes.forEach((node)=>{
                    if (!updatedNodes.includes(node) && (node.id === edge.to.slice(1) || node.id === edge.from.slice(1))) updatedNodes.push(node);
                });
            }
        }
    }
    return {
        nodes: updatedNodes,
        edges: updatedEdges
    };
};

});


parcelRegister("39jkZ", function(module, exports) {
$parcel$export(module.exports, "toValueType", () => $375d089555cd8bcc$export$1d86e34639695da1);
$parcel$export(module.exports, "toString", () => $375d089555cd8bcc$export$f84e8e69fd4488a5);
// eslint-disable-next-line jira/restricted/react-component-props
const $375d089555cd8bcc$export$1d86e34639695da1 = (input)=>({
        id: input.id,
        name: input.name,
        data: input
    });
const $375d089555cd8bcc$export$93482bcbaeb7d581 = (id)=>id;
const $375d089555cd8bcc$export$f84e8e69fd4488a5 = (fieldId)=>fieldId;

});

parcelRegister("hoa6w", function(module, exports) {
$parcel$export(module.exports, "CollapsibleField", () => $2353d2a3e6891d9b$export$d83dc62c6c49f683);

var $eJOHy = parcelRequire("eJOHy");

var $2bMVP = parcelRequire("2bMVP");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $dLR8J = parcelRequire("dLR8J");

var $bmoS1 = parcelRequire("bmoS1");

var $2rHwS = parcelRequire("2rHwS");

var $daGbj = parcelRequire("daGbj");

var $5OyZl = parcelRequire("5OyZl");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $dZRaT = parcelRequire("dZRaT");

var $eJrcF = parcelRequire("eJrcF");

var $7jTnu = parcelRequire("7jTnu");

var $39jkZ = parcelRequire("39jkZ");

var $92SYB = parcelRequire("92SYB");

var $hCIC7 = parcelRequire("hCIC7");

var $j66uq = parcelRequire("j66uq");

var $3y1fQ = parcelRequire("3y1fQ");

var $dZ10j = parcelRequire("dZ10j");

var $p7eiP = parcelRequire("p7eiP");

var $95Rzw = parcelRequire("95Rzw");
const $2353d2a3e6891d9b$var$sortValues = (values)=>[
        ...values
    ].sort((a, b)=>a.name.localeCompare(b.name));
const $2353d2a3e6891d9b$var$displayValuesFromData = (data)=>{
    // If we use `.filter()` instead of `.reduce()`, we'd need to disable the
    // type system. Using `.reduce()` allows Flow to statically analyse.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const errorsRemoved = (data ?? []).reduce((acc, current)=>{
        if (current instanceof Error) return acc;
        // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
        return [
            ...acc,
            current
        ];
    }, []);
    return $2353d2a3e6891d9b$var$sortValues(errorsRemoved);
};
const $2353d2a3e6891d9b$export$e461c7ed8d621371 = (initialValues, currentValues)=>{
    if (initialValues.length !== currentValues.length) return true;
    const initialIds = initialValues.map((value)=>value.id);
    const currentIds = currentValues.map((value)=>value.id);
    return currentIds.reduce((previous, current)=>previous || initialIds.indexOf(current) === -1, false);
};
const $2353d2a3e6891d9b$export$d83dc62c6c49f683 = (props)=>{
    const { area: area, render: render, messages: messages, isExpanded: isExpanded, isMultiple: isMultiple, onCancel: onCancel, autoCompleteConfig: autoCompleteConfig, useResolveFieldValuesById: useResolveFieldValuesById, fieldId: fieldId, actionSubject: actionSubject, source: source, onSuccess: onSuccess, onFailure: onFailure, onEscape: onEscape, isDuplicatesAllowed: isDuplicatesAllowed, onConfirm: onConfirm, onChange: onChange, initialServices: initialServices } = props;
    const [isEditing, setIsEditing] = (0, $eJOHy.useState)(false);
    const [isFieldExpanded, setIsFieldExpanded] = (0, $eJOHy.useState)(isExpanded == null || isExpanded);
    const [displayValues, setDisplayValues] = (0, $eJOHy.useState)(// Type assertion is safe because BasicServiceDetails is a subset of ServiceDetails.
    // SSR provides BasicServiceDetails (id, name) which will be replaced with full
    // ServiceDetails (id, name, tier, description) when client data loads via useEffect.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $7jTnu.fg)('ssring_affected_services_in_issue_view') ? initialServices ?? [] : []);
    const [saveValues, setSaveValues] = (0, $eJOHy.useState)([]);
    const [isDirty, setIsDirty] = (0, $eJOHy.useState)(false);
    const [isHovered, hoverProps] = (0, $92SYB.useHoverState)();
    const issueKey = (0, $bmoS1.useIssueKey)();
    const [{ value: fieldConfig }] = (0, $2rHwS.useFieldConfig)(issueKey, (0, $39jkZ.toString)(fieldId));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { data: projectContext } = (0, $eJrcF.useResource)((0, $dZRaT.projectContextResource));
    const [{ isLoading: isLoading, data: data, error: error }, { saveValue: saveValue }] = (0, $95Rzw.useCollapsibleField)({
        fieldId: fieldId,
        onSuccess: onSuccess,
        onFailure: onFailure,
        useResolveFieldValuesById: useResolveFieldValuesById
    });
    const isProjectArchived = !!projectContext?.isProjectArchived;
    (0, $eJOHy.useEffect)(()=>{
        setIsDirty($2353d2a3e6891d9b$export$e461c7ed8d621371(saveValues, displayValues));
    }, [
        saveValues,
        displayValues
    ]);
    const onExpandCollapseClick = (0, $eJOHy.useCallback)(()=>{
        setIsFieldExpanded(!isFieldExpanded);
    }, [
        isFieldExpanded
    ]);
    const onEditModeClick = (0, $eJOHy.useCallback)(()=>{
        setSaveValues(displayValues);
        setIsFieldExpanded(true);
        setIsEditing(!isEditing);
    }, [
        displayValues,
        isEditing
    ]);
    // This is called when the user 'confirms' the updated field values (by
    // clicking the tick icon shown under the field when in edit mode). This
    // method is responsible for 'committing' any staged changes to the backend.
    const onConfirmRequest = (analyticsEvent)=>{
        setIsEditing(false);
        saveValue?.(displayValues, null, analyticsEvent).then(()=>{
            const [to, from] = [
                displayValues.map((it)=>it.id),
                $2353d2a3e6891d9b$var$displayValuesFromData(data).map((it)=>it.id)
            ];
            const [addedCount, removedCount] = [
                to.filter((toValue)=>!from.includes(toValue)).length,
                from.filter((fromValue)=>!to.includes(fromValue)).length
            ];
            (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'affectedServices updated', {
                addedCount: addedCount,
                removedCount: removedCount
            });
        });
        onConfirm?.(analyticsEvent);
    };
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $7jTnu.fg)('ssring_affected_services_in_issue_view') || data && data.length > 0) setDisplayValues($2353d2a3e6891d9b$var$displayValuesFromData(data));
    }, [
        data
    ]);
    const isViewTracked = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (!isLoading && !isViewTracked.current) {
            isViewTracked.current = true;
            const values = $2353d2a3e6891d9b$var$displayValuesFromData(data);
            const attributes = {
                objectIds: values.map((value)=>({
                        id: value.id,
                        isDemoService: value.name === 'Demo Service'
                    })),
                numberOfObjects: values.length,
                source: // Distinguish between Insight vs Service views of this component
                source
            };
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'insightField viewed', attributes);
        }
    }, [
        isLoading,
        data,
        source,
        createAnalyticsEvent
    ]);
    const cancel = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        setIsEditing(false);
        setDisplayValues(saveValues);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent);
    }, [
        saveValues
    ]);
    const onCancelRequest = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        cancel(analyticsEvent);
        onCancel?.(analyticsEvent);
    }, [
        cancel,
        onCancel
    ]);
    const onEditRequested = (0, $eJOHy.useCallback)(()=>{
        setSaveValues(displayValues);
    }, [
        displayValues
    ]);
    const onEscapeRequest = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        cancel(analyticsEvent);
        onEscape && onEscape(analyticsEvent);
    }, [
        cancel,
        onEscape
    ]);
    // This gets called whenever the core select component gets a new value
    // added. Nothing is saved/persisted as a result of this method call.
    const onChangeRequest = (value)=>{
        if (!isDuplicatesAllowed && displayValues.some((x)=>x.id === value.id)) return;
        const values = $2353d2a3e6891d9b$var$sortValues([
            ...displayValues,
            value
        ]);
        setDisplayValues(values);
        onChange?.(values);
    };
    // This gets called whenever a cards' delete button is clicked. Nothing is
    // saved/persisted as a result of this method call.
    const onHandleDelete = (value)=>{
        const values = displayValues.filter((x)=>x.id !== value.id);
        setDisplayValues(values);
        // There is currently an issue with passing an empty array to the
        // onChange callback — it seems to get filtered out. Passing null
        // here instead of an empty array as a workaround in those cases.
        onChange?.(values.length > 0 ? values : null);
    };
    // Left empty as this component has it's own special read view
    const renderReadView = ()=>null;
    const renderEditView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3y1fQ.CollapsibleFieldEdit), {
            isMultiple: isMultiple,
            values: displayValues,
            onChange: onChangeRequest,
            autoCompleteConfig: autoCompleteConfig,
            OptionContent: render.OptionContent,
            messages: messages
        });
    if (!fieldConfig) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        onMouseOver: !isEditing ? hoverProps.onMouseOver : undefined,
        onFocus: !isEditing ? hoverProps.onFocus : undefined,
        onMouseOut: !isEditing ? hoverProps.onMouseOut : undefined,
        onBlur: !isEditing ? hoverProps.onBlur : undefined,
        xcss: [
            $2353d2a3e6891d9b$var$wrapperStyles,
            area === (0, $5OyZl.CONTENT_AREA) && $2353d2a3e6891d9b$var$wrapperAreaStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $p7eiP.CollapsibleFieldLabel), {
        isEditing: isEditing,
        canEdit: !isProjectArchived,
        isLoading: isLoading,
        onEditModeClick: onEditModeClick,
        values: displayValues,
        isParentHovered: isEditing || isHovered,
        isExpanded: isFieldExpanded,
        onExpandCollapseClick: onExpandCollapseClick,
        inlineErrorMessage: error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dZ10j.InlineErrorMessage), {
            messageDescriptor: messages.globalErrorMessage
        }) : undefined,
        messages: messages,
        additionalLabelContent: render.AdditionalLabelContent,
        issueKey: issueKey,
        fieldId: (0, $39jkZ.toString)(fieldId)
    }, fieldConfig.title), isLoading && !(0, $7jTnu.fg)('ssring_affected_services_in_issue_view') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "service-entity-collapsible-field-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $2353d2a3e6891d9b$var$cardsWrapperFirstStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        isShimmering: true
    }))), isFieldExpanded && (!isLoading || (0, $7jTnu.fg)('ssring_affected_services_in_issue_view')) && displayValues.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, displayValues.map((value, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            key: `${value.id}-${index}`,
            xcss: [
                index === 0 && $2353d2a3e6891d9b$var$cardsWrapperFirstStyles,
                index === displayValues.length - 1 && $2353d2a3e6891d9b$var$cardsWrapperLastStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hCIC7.CollapsibleCard), {
            value: value,
            isEditing: isEditing,
            render: render,
            onHandleDelete: onHandleDelete,
            messages: messages
        })))), isEditing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $2353d2a3e6891d9b$var$fieldContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $daGbj.FieldInlineEditStateLess), {
        actionSubject: actionSubject,
        label: fieldConfig.title,
        fieldId: fieldId,
        isEditable: fieldConfig.isEditable,
        isEditing: isEditing,
        isLabelHidden: true,
        readView: renderReadView(),
        editView: fieldConfig.isEditable ? renderEditView() : null,
        onCancel: onCancelRequest,
        onConfirm: onConfirmRequest,
        onEdit: onEditRequested,
        onEscape: onEscapeRequest,
        isFitContainerWidthReadView: true,
        areActionButtonsHidden: true,
        isConfirmOnBlurDisabled: true,
        testId: "issue-field-service-entity.common.ui.collapsible-field.inline-edit-field"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $2353d2a3e6891d9b$var$actionButtonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j66uq.ActionButtons), {
        isConfirmDisabled: !isDirty,
        onConfirm: onConfirmRequest,
        onCancel: onCancelRequest
    }))));
};
const $2353d2a3e6891d9b$var$wrapperStyles = (0, $1DXK0.xcss)({
    position: 'relative',
    marginBottom: 'space.200'
});
const $2353d2a3e6891d9b$var$wrapperAreaStyles = (0, $1DXK0.xcss)({
    border: `1px solid ${"var(--ds-border, #091E4224)"}`,
    borderRadius: 'radius.xsmall',
    paddingTop: 'space.100',
    paddingRight: 'space.200'
});
const $2353d2a3e6891d9b$var$fieldContainerStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.150'
});
const $2353d2a3e6891d9b$var$cardsWrapperFirstStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.150'
});
const $2353d2a3e6891d9b$var$cardsWrapperLastStyles = (0, $1DXK0.xcss)({
    marginBottom: 'space.100'
});
const $2353d2a3e6891d9b$var$actionButtonWrapperStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    top: `calc(100% + ${"var(--ds-space-100, 8px)"})`,
    right: "var(--ds-space-0, 0px)",
    zIndex: 'navigation'
});

});
parcelRegister("92SYB", function(module, exports) {
$parcel$export(module.exports, "useHoverState", () => $513a790af2e2fa0b$export$66bed54b0a694e74);

var $eJOHy = parcelRequire("eJOHy");
const $513a790af2e2fa0b$export$66bed54b0a694e74 = ()=>{
    const [isHovered, setIsHovered] = (0, $eJOHy.useState)(false);
    const inputMethod = (0, $eJOHy.useRef)('mouse');
    const setTrueWithInput = (method)=>()=>{
            if (!isHovered) {
                setIsHovered(true);
                inputMethod.current = method;
            }
        };
    const setFalseWithInput = (method)=>()=>{
            if (inputMethod.current === method) setIsHovered(false);
        };
    return [
        isHovered,
        {
            onMouseOver: setTrueWithInput('mouse'),
            onMouseOut: setFalseWithInput('mouse'),
            onFocus: setTrueWithInput('keyboard'),
            onBlur: setFalseWithInput('keyboard')
        }
    ];
};

});

parcelRegister("hCIC7", function(module, exports) {
$parcel$export(module.exports, "CollapsibleCard", () => $48ecb3f674937b32$export$80f39b42e5b764f4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $5pWSu = parcelRequire("5pWSu");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $4BfvE = parcelRequire("4BfvE");

var $jtHNl = parcelRequire("jtHNl");
const $48ecb3f674937b32$export$80f39b42e5b764f4 = (props)=>{
    const { render: { HeaderContent: HeaderContent, DetailContent: DetailContent }, isEditing: isEditing, onHandleDelete: onHandleDelete, messages: customMessages } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isExpanded, setIsExpanded] = (0, $eJOHy.useState)(false);
    const handleExpandCollapseClick = ()=>{
        setIsExpanded(!isExpanded);
    };
    const renderChevronButton = ()=>{
        const buttonLabel = formatMessage(isExpanded ? (0, $jtHNl.default).showLessDetails : (0, $jtHNl.default).showDetails);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4BfvE.ExpandCollapseToggle), {
            isExpanded: isExpanded,
            label: buttonLabel,
            onClick: handleExpandCollapseClick,
            testId: "issue-field-service-entity.common.ui.collapsible-field.card.collapse-toggle"
        });
    };
    const renderDeleteButton = (value)=>{
        const buttonLabel = formatMessage(customMessages.removeItem);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: buttonLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($48ecb3f674937b32$var$DeleteButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "subtle",
            onClick: ()=>onHandleDelete(value),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5pWSu))), {
                spacing: "spacious",
                label: buttonLabel
            }),
            testId: "issue-field-service-entity.common.ui.collapsible-field.card.delete-button",
            interactionName: "auto-generated.issue-field-service-entity.common.ui.collapsible-field.card.delete-button.button"
        })));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($48ecb3f674937b32$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($48ecb3f674937b32$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($48ecb3f674937b32$var$HeaderContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(HeaderContent, {
        value: props.value,
        isEditing: isEditing,
        isExpanded: isExpanded
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($48ecb3f674937b32$var$CardActions, null, isEditing ? renderDeleteButton(props.value) : null, renderChevronButton())), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(DetailContent, {
        value: props.value,
        isEditing: isEditing
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $48ecb3f674937b32$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _kqswh2mm _1bsb1osq _bfhkhp5a _16qszucj _otyru2gc _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _vchhusvi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $48ecb3f674937b32$var$Header = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _2lx2vrvc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $48ecb3f674937b32$var$HeaderContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1f9d",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $48ecb3f674937b32$var$CardActions = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _19pkr5cr _otyrr5cr _1hbsidpf _1u71idpf _y2qtidpf _fl8bidpf _1gflidpf _yhjmidpf _1gqnidpf _11lvidpf _14hpzwfg _1ko9u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $48ecb3f674937b32$var$DeleteButtonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_6pup18uv _1u08s4qr",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4BfvE", function(module, exports) {
$parcel$export(module.exports, "ExpandCollapseToggle", () => $9be9b8e31f89c31a$export$170fda29b81e014c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5lAAn = parcelRequire("5lAAn");

var $goZPP = parcelRequire("goZPP");

var $k71qx = parcelRequire("k71qx");
const $9be9b8e31f89c31a$export$170fda29b81e014c = (props)=>{
    const handleCollapseChevronClick = (event, analyticsEvent)=>{
        props.onClick(analyticsEvent);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: props.label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        onClick: handleCollapseChevronClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9be9b8e31f89c31a$var$AnimatedRotation, {
            isRotated: props.isExpanded
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
            spacing: "spacious",
            label: props.label,
            size: "small"
        })),
        testId: props.testId
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9be9b8e31f89c31a$var$AnimatedRotation = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isRotated: isRotated, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_v5641hdd",
            __cmplp.isRotated ? "_t9ec1sub" : "_t9ec1ul7",
            __cmplp.className
        ])
    });
});

});

parcelRegister("jtHNl", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ef7fd2ec5946d9b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $0ef7fd2ec5946d9b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    showDetails: {
        "id": "issue-field-service-entity.common.collapsible-field.card.show-details",
        "defaultMessage": "Show details"
    },
    showLessDetails: {
        "id": "issue-field-service-entity.common.collapsible-field.card.show-less-details",
        "defaultMessage": "Show less details"
    }
});

});


parcelRegister("j66uq", function(module, exports) {
$parcel$export(module.exports, "ActionButtons", () => $69b2f69ba9f60b47$export$88c65d2d98aab183);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $entZ3 = parcelRequire("entZ3");

var $6J9k6 = parcelRequire("6J9k6");

var $lRq8t = parcelRequire("lRq8t");

var $dfjoE = parcelRequire("dfjoE");
const $69b2f69ba9f60b47$export$88c65d2d98aab183 = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleCancel = (event, analyticsEvent)=>{
        props.onCancel(analyticsEvent);
    };
    const handleConfirm = (event, analyticsEvent)=>{
        props.onConfirm(analyticsEvent);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($69b2f69ba9f60b47$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($69b2f69ba9f60b47$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        isDisabled: props.isConfirmDisabled,
        onClick: handleConfirm,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($entZ3))), {
            label: formatMessage((0, $dfjoE.default).confirm),
            LEGACY_size: "small"
        }),
        testId: "issue-field-service-entity.common.ui.collapsible-field.edit.action-buttons.confirm",
        interactionName: "auto-generated.issue-field-service-entity.common.ui.collapsible-field.edit.action-buttons.confirm.button"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($69b2f69ba9f60b47$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        onClick: handleCancel,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))), {
            label: formatMessage((0, $dfjoE.default).cancel),
            LEGACY_size: "small"
        }),
        testId: "issue-field-service-entity.common.ui.collapsible-field.edit.action-buttons.cancel",
        interactionName: "auto-generated.issue-field-service-entity.common.ui.collapsible-field.edit.action-buttons.cancel.button1"
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $69b2f69ba9f60b47$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _19pkidpf _otyridpf _18u01i6y _2hwx1i6y",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $69b2f69ba9f60b47$var$ButtonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _16qszucj _bfhkvuon _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _dpd31txw _xlob1h6o _12no1h6o _14hpzwfg _jq8gzwfg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dfjoE", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9e30eafe3f3bef9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c9e30eafe3f3bef9$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    confirm: {
        "id": "issue-field-service-entity.common.collapsible-field.edit.action-buttons.confirm",
        "defaultMessage": "Confirm"
    },
    cancel: {
        "id": "issue-field-service-entity.common.collapsible-field.edit.action-buttons.cancel",
        "defaultMessage": "Cancel"
    }
});

});


parcelRegister("3y1fQ", function(module, exports) {
$parcel$export(module.exports, "CollapsibleFieldEdit", () => $fb0ad6f7df2cff41$export$9a0451bce5935a3d);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6J86O = parcelRequire("6J86O");

var $88oIq = parcelRequire("88oIq");

var $6XEne = parcelRequire("6XEne");
var $c4OV1 = parcelRequire("c4OV1");

var $dPMMf = parcelRequire("dPMMf");

var $lRq8t = parcelRequire("lRq8t");
const $fb0ad6f7df2cff41$var$customStyles = {
    menu: (provided)=>({
            ...provided,
            position: 'absolute',
            zIndex: (0, $dPMMf.layers).modal
        })
};
const $fb0ad6f7df2cff41$export$9a0451bce5935a3d = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { isMultiple: isMultiple, values: values, onChange: propsOnChange, OptionContent: OptionContent, autoCompleteConfig: autoCompleteConfig, messages: messages } = props;
    const { context: context, useAutoComplete: useAutoComplete } = autoCompleteConfig;
    const autoComplete = useAutoComplete(values, context);
    const onChange = (0, $eJOHy.useCallback)((selectedOption)=>{
        propsOnChange(selectedOption.rawData);
    }, [
        propsOnChange
    ]);
    const customComponents = (0, $eJOHy.useMemo)(()=>({
            Option: (optionProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Option, optionProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(OptionContent, optionProps))
        }), // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const shouldShowSelect = isMultiple || values.length === 0;
    const shouldShowInformation = !isMultiple && values.length === 1;
    const shouldShowWarning = !isMultiple && values.length > 1; // use custom filter on input to prevent default filter flickering issue
    const filterOption = (opt)=>{
        const { data: data } = opt;
        const { rawData: { id: id } } = data;
        let display = true; // don't display already chosen options
        values.forEach((value)=>{
            if (value.id === id) display = false;
        });
        return display;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, shouldShowSelect && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default // Setting a value of null causes the field to go back to being empty after a selection is made
    ), {
        value: null,
        autoFocus: true,
        label: formatMessage(messages.searchPlaceholder),
        onChange: onChange,
        filterOption: filterOption,
        placeholder: formatMessage(messages.searchPlaceholder),
        components: customComponents,
        styles: $fb0ad6f7df2cff41$var$customStyles,
        ...autoComplete.selectProps
    }), shouldShowInformation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fb0ad6f7df2cff41$var$MessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6J86O))), {
        spacing: "spacious",
        label: "info"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fb0ad6f7df2cff41$var$Message, null, formatMessage(messages.infoSingleItemMessage))), shouldShowWarning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fb0ad6f7df2cff41$var$MessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($88oIq))), {
        spacing: "spacious",
        label: "warning",
        color: "var(--ds-icon-warning, #E56910)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fb0ad6f7df2cff41$var$Message, null, formatMessage(messages.warningMultipleItemMessage))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fb0ad6f7df2cff41$var$MessageContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81o8v _syaz1gjq _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fb0ad6f7df2cff41$var$Message = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});

});

parcelRegister("dZ10j", function(module, exports) {
$parcel$export(module.exports, "InlineErrorMessage", () => $a5c179f12eb9ab73$export$208a4a09ee635e17);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1NG86 = parcelRequire("1NG86");

var $fAoiP = parcelRequire("fAoiP");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $dTocu = parcelRequire("dTocu");
const $a5c179f12eb9ab73$export$208a4a09ee635e17 = ({ messageDescriptor: messageDescriptor })=>{
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const message = formatMessage(messageDescriptor);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fAoiP.default), {
        placement: "bottom-end",
        appearance: "error",
        testId: "issue-field-service-entity.common.ui.collapsible-field.inline-error-message.inline-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a5c179f12eb9ab73$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a5c179f12eb9ab73$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
        LEGACY_size: "medium",
        spacing: "spacious",
        label: message
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $a5c179f12eb9ab73$var$messageStyles
    }, message)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a5c179f12eb9ab73$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $a5c179f12eb9ab73$var$messageStyles = (0, $1DXK0.xcss)({
    paddingLeft: 'space.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a5c179f12eb9ab73$var$IconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syazs4qr",
            __cmplp.className
        ])
    });
});

});

parcelRegister("p7eiP", function(module, exports) {
$parcel$export(module.exports, "CollapsibleFieldLabel", () => $8a43e5a5c46179cf$export$1953a5264c927dcb);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $bp0jd = parcelRequire("bp0jd");

var $dQmRx = parcelRequire("dQmRx");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $9Tg2c = parcelRequire("9Tg2c");

var $9NIQG = parcelRequire("9NIQG");

var $4BfvE = parcelRequire("4BfvE");
const $8a43e5a5c46179cf$export$1953a5264c927dcb = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { values: values, messages: messages, isLoading: isLoading, canEdit: canEdit, additionalLabelContent: AdditionalLabelContent, issueKey: issueKey, fieldId: fieldId } = props;
    const handleEditModeClick = (event, analyticsEvent)=>{
        props.onEditModeClick(analyticsEvent);
    };
    const buttonLabel = formatMessage(props.isExpanded ? messages.hideDetails : messages.showDetails);
    const hasValues = values.length > 0;
    const shouldShowAddButton = !props.isEditing && !hasValues && !props.inlineErrorMessage;
    const shouldShowEditButton = !props.isEditing && hasValues && !props.inlineErrorMessage;
    const shouldShowLabelContent = shouldShowEditButton && !props.isExpanded;
    const editButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage(messages.editField)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bp0jd))), {
            spacing: "spacious",
            label: formatMessage(messages.editField),
            color: "var(--ds-icon, #44546F)"
        }),
        onClick: handleEditModeClick,
        testId: "issue-field-service-entity.common.ui.collapsible-field.label.edit-button",
        interactionName: "auto-generated.issue-field-service-entity.common.ui.collapsible-field.label.edit-button.button1"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8a43e5a5c46179cf$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _16jlkb7n _2hwxu2gc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9NIQG.FieldHeadingTitle), null, props.children), issueKey !== undefined && fieldId !== undefined && // @ts-expect-error label is required, please pass it through when working on this code.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Tg2c.FieldDescription), {
        issueKey: issueKey,
        fieldKey: fieldId
    })), props.inlineErrorMessage, shouldShowLabelContent && AdditionalLabelContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $8a43e5a5c46179cf$var$additionalLabelContentWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AdditionalLabelContent, {
        values: values
    })), canEdit && shouldShowAddButton && !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "link",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dQmRx))), {
            label: "",
            color: "var(--ds-icon-brand, #0C66E4)"
        }),
        onClick: handleEditModeClick,
        interactionName: "auto-generated.jira-issue-field-service-entity.common.ui.collapsible-field.label.button"
    }, formatMessage(messages.addItem)), shouldShowLabelContent && !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_2hwxu2gc"
        ])
    }, formatMessage(messages.itemCount, {
        count: values.length
    }), ' '), canEdit && shouldShowEditButton && !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_2hwxu2gc _1wk5idpf",
            props.isParentHovered && "_1wk5kb7n"
        ])
    }, editButton), shouldShowEditButton && !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4BfvE.ExpandCollapseToggle), {
        isExpanded: props.isExpanded,
        label: buttonLabel,
        onClick: props.onExpandCollapseClick
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8a43e5a5c46179cf$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _1tkezwfg",
            __cmplp.className
        ])
    });
});
const $8a43e5a5c46179cf$var$collapsibleFieldHeadingStyles = null;
const $8a43e5a5c46179cf$var$additionalLabelContentWrapperStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.100'
});
const $8a43e5a5c46179cf$var$editButtonWrapperStyles = null;
const $8a43e5a5c46179cf$var$editButtonWrapperVisibleStyles = null;
const $8a43e5a5c46179cf$var$objectCountStyles = null;

});
parcelRegister("dQmRx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9e6ffc08f8732438cd22c0f207c76517>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a141ddb01154cb52$var$_react = $a141ddb01154cb52$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a141ddb01154cb52$var$_add = $a141ddb01154cb52$var$_interopRequireDefault((parcelRequire("dcLzM")));

var $a141ddb01154cb52$var$_custom = $a141ddb01154cb52$var$_interopRequireDefault((parcelRequire("eJrv9")));
function $a141ddb01154cb52$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AddIcon.
 * This component is AddIcon, with `UNSAFE_fallbackIcon` set to "EmojiCustomIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a141ddb01154cb52$var$AddIcon = (props)=>/*#__PURE__*/ $a141ddb01154cb52$var$_react.default.createElement($a141ddb01154cb52$var$_add.default, Object.assign({
        name: "AddIcon",
        LEGACY_fallbackIcon: $a141ddb01154cb52$var$_custom.default
    }, props));
$a141ddb01154cb52$var$AddIcon.displayName = 'AddIconMigration';
var $a141ddb01154cb52$var$_default = module.exports.default = $a141ddb01154cb52$var$AddIcon;

});
parcelRegister("eJrv9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab9a99e1fe91d404$var$_react = $ab9a99e1fe91d404$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $ab9a99e1fe91d404$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ab9a99e1fe91d404$var$EmojiCustomIcon = (props)=>/*#__PURE__*/ $ab9a99e1fe91d404$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V7.002a.999.999 0 1 0-2 0V11H7.002a.999.999 0 1 0 0 2H11v3.998a.999.999 0 1 0 2 0V13h3.998a.999.999 0 1 0 0-2z"/></svg>`
    }, props));
$ab9a99e1fe91d404$var$EmojiCustomIcon.displayName = 'EmojiCustomIcon';
var $ab9a99e1fe91d404$var$_default = module.exports.default = $ab9a99e1fe91d404$var$EmojiCustomIcon;

});



parcelRegister("95Rzw", function(module, exports) {
$parcel$export(module.exports, "useCollapsibleField", () => $be56ba33b8c80b99$export$d2a20d0a58bb31e2);

var $jGzN3 = parcelRequire("jGzN3");

var $bmoS1 = parcelRequire("bmoS1");

var $2QNHW = parcelRequire("2QNHW");

var $2rHwS = parcelRequire("2rHwS");

var $39jkZ = parcelRequire("39jkZ");
const $be56ba33b8c80b99$var$getFieldUpdate = (fieldId, values)=>({
        fields: {
            [fieldId]: values
        }
    });
const $be56ba33b8c80b99$var$saveField = async (issueKey, fieldId, newValue)=>(0, $jGzN3.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify($be56ba33b8c80b99$var$getFieldUpdate(fieldId, newValue))
    });
const $be56ba33b8c80b99$var$toFieldValue = (values)=>values.map((x)=>({
            id: x.id
        }));
const $be56ba33b8c80b99$export$d2a20d0a58bb31e2 = ({ fieldId: fieldId, onSuccess: onSuccess, onFailure: onFailure, useResolveFieldValuesById: useResolveFieldValuesById })=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const [{ value: fieldConfig }] = (0, $2rHwS.useFieldConfig)(issueKey, (0, $39jkZ.toString)(fieldId));
    const fieldType = fieldConfig?.schema.type ?? 'array';
    // Retrieves the current field values as stored in Bento (IDs)
    const [{ value: value, error: errorEditField }, { saveValue: saveValue }] = (0, $2QNHW.useEditField)({
        fieldKey: (0, $39jkZ.toString)(fieldId),
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: [],
        onSuccess: onSuccess,
        onFailure: onFailure,
        saveField: $be56ba33b8c80b99$var$saveField
    });
    // Resolve the Bento field values using the passed in resolver
    // eslint-disable-next-line react-hooks/react-compiler
    const { isLoading: isLoading, data: data, error: fieldValueError } = useResolveFieldValuesById(fieldId, value);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const save = (values, meta, analyticsEvent)=>saveValue($be56ba33b8c80b99$var$toFieldValue(values), meta, analyticsEvent);
    return [
        {
            isLoading: isLoading,
            data: data,
            error: errorEditField || fieldValueError
        },
        {
            saveValue: save
        }
    ];
};

});


parcelRegister("8ywYE", function(module, exports) {
$parcel$export(module.exports, "useResolveFieldValuesByIdGraphQL", () => $621ab16902640451$export$6ac4d28dcfc4a567);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $4mEPL = parcelRequire("4mEPL");

var $8xBO5 = parcelRequire("8xBO5");

var $39jkZ = parcelRequire("39jkZ");

var $9RM4T = parcelRequire("9RM4T");
const $621ab16902640451$export$36cddef7b835540e = (fieldId, fieldValues)=>{
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(true);
    const [error, setError] = (0, $eJOHy.useState)(undefined);
    const [data, setData] = (0, $eJOHy.useState)(undefined);
    const { fetchActiveIncidentsForServices: fetchActiveIncidentsForServices } = (0, $8xBO5.useFetchActiveIncidents)();
    (0, $eJOHy.useEffect)(()=>{
        if (!fieldValues) {
            setData([]);
            setIsLoading(false);
            return;
        }
        const ids = fieldValues.map((value)=>value.id);
        (0, $4mEPL.default)('/rest/service-registry-api/service?query=', {
            method: 'POST',
            body: JSON.stringify({
                ids: ids
            })
        }, 'fields/service-entity/src/services/resolve-field-values-by-id').then((result)=>{
            const values = result.services.map((0, $39jkZ.toValueType));
            setData(values);
            setIsLoading(false);
        }).catch((caughtError)=>{
            setIsLoading(false);
            setError(caughtError);
            (0, $gYnSx.default)({
                meta: {
                    id: 'useResolveFieldValuesById',
                    packageName: 'jiraIssueFieldServiceEntity',
                    teamName: 'rohirrim'
                },
                attributes: {
                    dataFetchingApproach: 'rest'
                },
                error: caughtError
            });
        });
        fetchActiveIncidentsForServices((0, $39jkZ.toString)(fieldId), ids);
    // Disabling rule ensure that effect runs only if id really
    // changes not only the reference
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        JSON.stringify(fieldValues)
    ]);
    return {
        isLoading: isLoading,
        data: data,
        error: error
    };
};
const $621ab16902640451$export$6ac4d28dcfc4a567 = (fieldId, fieldValues)=>{
    const { fetchActiveIncidentsForServices: fetchActiveIncidentsForServices } = (0, $8xBO5.useFetchActiveIncidents)();
    const ids = (0, $eJOHy.useMemo)(()=>fieldValues?.map((value)=>value.id) ?? [], [
        fieldValues
    ]);
    const onCompleted = (0, $eJOHy.useCallback)(()=>fetchActiveIncidentsForServices((0, $39jkZ.toString)(fieldId), ids), // Disabling rule ensure that effect runs only if id really
    // changes not only the reference
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        JSON.stringify(ids)
    ]);
    const onError = (0, $eJOHy.useCallback)((err)=>(0, $gYnSx.default)({
            meta: {
                id: 'useResolveFieldValuesById',
                packageName: 'jiraIssueFieldServiceEntity',
                teamName: 'rohirrim'
            },
            attributes: {
                dataFetchingApproach: 'graphql'
            },
            error: err
        }), []);
    const { data: data, loading: loading, error: error } = (0, $9RM4T.useGetServicesById)({
        ids: ids,
        onCompleted: onCompleted,
        onError: onError
    });
    const results = (0, $eJOHy.useMemo)(()=>data?.devOpsServicesById?.map((service)=>{
            // The tier always exists but the query API has it as nullable
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const transformedService = {
                ...service,
                tier: service.serviceTier
            };
            return (0, $39jkZ.toValueType)(transformedService);
        }) ?? [], [
        data
    ]);
    return {
        data: results,
        isLoading: loading,
        error: error
    };
};

});
parcelRegister("8xBO5", function(module, exports) {
$parcel$export(module.exports, "useActiveIncidentsStore", () => $ef9e81678c6e8f17$export$b8f7de9f973f2470);
$parcel$export(module.exports, "useFetchActiveIncidents", () => $ef9e81678c6e8f17$export$d265cbc3fcaa489);
$parcel$export(module.exports, "useActiveIncidents", () => $ef9e81678c6e8f17$export$4ab0f1915bf1786b);
$parcel$export(module.exports, "useActiveIncidentsForService", () => $ef9e81678c6e8f17$export$71117a9b122c2b51);

var $eJOHy = parcelRequire("eJOHy");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $5XCw3 = parcelRequire("5XCw3");

var $kbsh3 = parcelRequire("kbsh3");

var $bnLK3 = parcelRequire("bnLK3");
const $ef9e81678c6e8f17$var$CACHE_INVALIDATION_MS = 300000;
const $ef9e81678c6e8f17$var$Store = (0, $GtRbT.createStore)({
    initialState: (0, $bnLK3.createInitialState)(),
    actions: $5XCw3,
    name: 'linked-object-incidents-store'
});
const $ef9e81678c6e8f17$export$b8f7de9f973f2470 = (0, $iJq0l.createHook)($ef9e81678c6e8f17$var$Store);
const $ef9e81678c6e8f17$export$d265cbc3fcaa489 = (fetchImmediate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $bnLK3.useCrossTabCache)();
    const [activeIncidents, { fetchActiveIncidents: doFetchActiveIncidents }] = $ef9e81678c6e8f17$export$b8f7de9f973f2470();
    // adding activeIncidents into fetchActiveIncidentsForServices dependencies created an infinite loop
    // FIXME: use refs
    // const activeIncidentsRef = useRef(activeIncidents);
    // activeIncidentsRef.current = activeIncidents;
    const fetchActiveIncidentsForServices = (0, $eJOHy.useCallback)((affectedServicesFieldId, serviceIds)=>{
        const currentTimeMs = Date.now();
        const serviceIdsToFetch = serviceIds.filter((serviceId)=>{
            const { loading: alreadyFetchingForService, loadedAt: loadedAt } = activeIncidents[serviceId] ?? (0, $kbsh3.emptyServiceDataState);
            const isStale = currentTimeMs - loadedAt > $ef9e81678c6e8f17$var$CACHE_INVALIDATION_MS;
            return !alreadyFetchingForService && (isStale || fetchImmediate);
        });
        (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'useFetchActiveIncidents requested', {
            ttl: $ef9e81678c6e8f17$var$CACHE_INVALIDATION_MS,
            requestedServices: serviceIds.length
        });
        if (serviceIdsToFetch.length > 0) {
            doFetchActiveIncidents(affectedServicesFieldId, serviceIdsToFetch);
            (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'useFetchActiveIncidents cacheMissed', {
                ttl: $ef9e81678c6e8f17$var$CACHE_INVALIDATION_MS,
                cacheMissedServices: serviceIdsToFetch.length
            });
        }
    }, [
        activeIncidents,
        createAnalyticsEvent,
        doFetchActiveIncidents,
        fetchImmediate
    ]);
    const fetchActiveIncidentsForService = (0, $eJOHy.useCallback)((affectedServicesFieldId, serviceId)=>fetchActiveIncidentsForServices(affectedServicesFieldId, [
            serviceId
        ]), [
        fetchActiveIncidentsForServices
    ]);
    return {
        fetchActiveIncidentsForServices: fetchActiveIncidentsForServices,
        fetchActiveIncidentsForService: fetchActiveIncidentsForService
    };
};
const $ef9e81678c6e8f17$export$4ab0f1915bf1786b = ()=>{
    const [activeIncidents] = $ef9e81678c6e8f17$export$b8f7de9f973f2470();
    return activeIncidents;
};
const $ef9e81678c6e8f17$export$71117a9b122c2b51 = (serviceId)=>{
    const [activeIncidents] = $ef9e81678c6e8f17$export$b8f7de9f973f2470();
    return activeIncidents[serviceId] ?? (0, $kbsh3.emptyServiceDataState);
};

});
parcelRegister("5XCw3", function(module, exports) {
$parcel$export(module.exports, "mergeActiveIncidents", () => $a10981832b0c3d00$export$e8828d201a43ee06);
$parcel$export(module.exports, "fetchActiveIncidents", () => (parcelRequire("fJ620")).default);

var $2RwKx = parcelRequire("2RwKx");

var $9pL9Y = parcelRequire("9pL9Y");

var $fJ620 = parcelRequire("fJ620");
const $a10981832b0c3d00$export$e8828d201a43ee06 = (activeIncidentsInCache)=>({ getState: getState, setState: setState })=>{
        const activeIncidentsInState = getState();
        const filteredActiveIncidentsInCache = (0, (/*@__PURE__*/$parcel$interopDefault($9pL9Y)))(activeIncidentsInCache, (activeIncident)=>activeIncident !== undefined && !activeIncident.error && !activeIncident.loading);
        setState((0, (/*@__PURE__*/$parcel$interopDefault($2RwKx)))({}, activeIncidentsInState, filteredActiveIncidentsInCache, (activeIncidentInState, activeIncidentInCache)=>{
            if (activeIncidentInState === undefined || activeIncidentInCache.loadedAt > activeIncidentInState.loadedAt) return activeIncidentInCache;
            return activeIncidentInState;
        }));
    };

});
parcelRegister("2RwKx", function(module, exports) {

var $9Zabf = parcelRequire("9Zabf");

var $kBNXn = parcelRequire("kBNXn");

var $4c94y = parcelRequire("4c94y");
/**
 * This method is like `_.assign` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignInWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */ var $2159ef6985639019$var$assignWith = $kBNXn(function(object, source, srcIndex, customizer) {
    $9Zabf(source, $4c94y(source), object, customizer);
});
module.exports = $2159ef6985639019$var$assignWith;

});

parcelRegister("fJ620", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e61fb3f359793ae$export$2e2bcd8739ae039);

var $gYnSx = parcelRequire("gYnSx");

var $dCgXd = parcelRequire("dCgXd");

var $kbsh3 = parcelRequire("kbsh3");
const $1e61fb3f359793ae$var$fetchActiveIncidents = (affectedServicesFieldId, serviceIds)=>async ({ getState: getState, setState: setState })=>{
        const activeIncidents = {
            ...getState()
        };
        const loadingActiveIncidents = serviceIds.reduce((accActiveIncidents, serviceId)=>{
            const { data: data, error: error, loadedAt: loadedAt } = activeIncidents[serviceId] ?? (0, $kbsh3.emptyServiceDataState);
            const serviceDataLoadingState = {
                data: data,
                loading: true,
                error: error,
                loadedAt: loadedAt
            };
            return {
                // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                ...accActiveIncidents,
                [serviceId]: serviceDataLoadingState
            };
        }, activeIncidents);
        setState(loadingActiveIncidents);
        const serviceResponse = await (0, $dCgXd.fetchActiveIncidentsService)(affectedServicesFieldId, serviceIds);
        // @ts-expect-error - TS2339 - Property 'data' does not exist on type 'ActiveIncidentsServiceResponse'.
        if (serviceResponse.data) setState(// @ts-expect-error - TS2339 - Property 'data' does not exist on type 'ActiveIncidentsServiceResponse'.
        Object.keys(serviceResponse.data).reduce((accActiveIncidents, serviceId)=>{
            const serviceDataLoadingState = {
                // @ts-expect-error - TS2339 - Property 'data' does not exist on type 'ActiveIncidentsServiceResponse'.
                data: {
                    activeIncidents: serviceResponse.data[serviceId]
                },
                loading: false,
                error: null,
                loadedAt: Date.now()
            };
            return {
                // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                ...accActiveIncidents,
                [serviceId]: serviceDataLoadingState
            };
        }, activeIncidents));
        else {
            setState(serviceIds.reduce((accActiveIncidents, serviceId)=>{
                const { data: data, loadedAt: loadedAt } = activeIncidents[serviceId] ?? (0, $kbsh3.emptyServiceDataState);
                const serviceDataLoadingState = {
                    data: data,
                    loading: false,
                    // @ts-expect-error - TS2339 - Property 'error' does not exist on type 'ActiveIncidentsServiceResponse'.
                    error: serviceResponse.error,
                    loadedAt: loadedAt
                };
                return {
                    // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                    ...accActiveIncidents,
                    [serviceId]: serviceDataLoadingState
                };
            }, activeIncidents));
            (0, $gYnSx.default)({
                meta: {
                    id: 'fetchActiveIncidents',
                    packageName: 'jiraServicedeskLinkedObjectIncidentsStore'
                },
                attributes: {
                    // @ts-expect-error - TS2339 - Property 'error' does not exist on type 'ActiveIncidentsServiceResponse'.
                    errorType: serviceResponse.error
                }
            });
        }
    };
var $1e61fb3f359793ae$export$2e2bcd8739ae039 = $1e61fb3f359793ae$var$fetchActiveIncidents;

});
parcelRegister("dCgXd", function(module, exports) {
$parcel$export(module.exports, "fetchActiveIncidentsService", () => $a04bbd889ee6253a$export$e212bb83d7ddad0);

var $aYncF = parcelRequire("aYncF");

var $eSnSE = parcelRequire("eSnSE");

var $8KUFq = parcelRequire("8KUFq");

var $jGzN3 = parcelRequire("jGzN3");

var $7jTnu = parcelRequire("7jTnu");

var $kIowl = parcelRequire("kIowl");
const $a04bbd889ee6253a$var$LOGGER_LOCATION = 'linked-object-incidents-store.fetchActiveIncidentsService';
const $a04bbd889ee6253a$var$getQueryPayloadForIncidentsOnAffectedServices = (affectedServicesJQLFieldName, serviceIds)=>({
        jql: `"Ticket category" = Incidents and resolution is EMPTY and ${affectedServicesJQLFieldName} in ("${serviceIds.join('","')}")`,
        ...(0, $7jTnu.fg)('jql-search-api-migration-agni') ? {
            fields: [
                '*navigable'
            ],
            expand: 'renderedFields'
        } : {
            expand: [
                'renderedFields'
            ]
        }
    });
const $a04bbd889ee6253a$var$transformIssueSearchResponse = (affectedServicesFieldId, issueSearchResponse, serviceIds)=>{
    if (issueSearchResponse.issues.length === 0) return {
        data: (0, $kIowl.emptyServicesWithActiveIncidentsObject)(serviceIds)
    };
    return {
        data: (0, $kIowl.mapIssuesToServicesWithActiveIncidents)(issueSearchResponse.issues, serviceIds, affectedServicesFieldId)
    };
};
const $a04bbd889ee6253a$export$e212bb83d7ddad0 = async (affectedServicesFieldId, serviceIds)=>{
    try {
        if (serviceIds.length === 0) return {
            data: {}
        };
        const { licensedProducts: licensedProducts } = (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)();
        if (!licensedProducts[(0, $aYncF.LICENSED_PRODUCTS).JIRA_SERVICEDESK]) // 'Ticket category' is not available in JQL if JSM has been deleted from the site,
        // so there is no point making a request in this case.
        return {
            data: (0, $kIowl.emptyServicesWithActiveIncidentsObject)(serviceIds)
        };
        if (!affectedServicesFieldId || !affectedServicesFieldId.startsWith((0, $kIowl.CF_SEPARATOR))) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData($a04bbd889ee6253a$var$LOGGER_LOCATION, `Format of affected services field ID was invalid - ${affectedServicesFieldId}`);
            return {
                error: 'INVALID_RESPONSE'
            };
        }
        const response = await (0, $jGzN3.performPostRequest)((0, $7jTnu.fg)('jql-search-api-migration-agni') ? '/rest/api/3/search/jql' : '/rest/api/3/search', {
            body: JSON.stringify($a04bbd889ee6253a$var$getQueryPayloadForIncidentsOnAffectedServices((0, $kIowl.getFieldNameForJql)(affectedServicesFieldId), serviceIds))
        });
        return $a04bbd889ee6253a$var$transformIssueSearchResponse(affectedServicesFieldId, response, serviceIds);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData($a04bbd889ee6253a$var$LOGGER_LOCATION, `Endpoint returned unexpected status code ${error.statusCode}`);
            return {
                error: 'INTERNAL_ERROR'
            };
        }
        if ((0, $8KUFq.isClientFetchError)(error)) return {
            error: 'CLIENT_FETCH_ERROR'
        };
        (0, $eSnSE.default).unsafeErrorWithCustomerData($a04bbd889ee6253a$var$LOGGER_LOCATION, `Endpoint returned unexpected response: ${error.message}`);
        return {
            error: 'VALIDATION_ERROR'
        };
    }
};

});
parcelRegister("kIowl", function(module, exports) {
$parcel$export(module.exports, "CF_SEPARATOR", () => $4490302bd224cecf$export$a3c7258f137a756c);
$parcel$export(module.exports, "emptyServicesWithActiveIncidentsObject", () => $4490302bd224cecf$export$a0b24f075062292d);
$parcel$export(module.exports, "mapIssuesToServicesWithActiveIncidents", () => $4490302bd224cecf$export$b06c80bd5e8a80f9);
$parcel$export(module.exports, "getFieldNameForJql", () => $4490302bd224cecf$export$f958f2fd5423f7cc);
const $4490302bd224cecf$export$a3c7258f137a756c = 'customfield_';
const $4490302bd224cecf$export$a0b24f075062292d = (serviceids)=>{
    const serviceIdIssues = {};
    return serviceids.reduce((accServiceIdIssues, serviceId)=>({
            [serviceId]: [],
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...accServiceIdIssues
        }), serviceIdIssues);
};
const $4490302bd224cecf$export$ac2f076b1102f25a = (issue, affectedServicesFieldId, plannedStartTimeFieldId, plannedEndTimeFieldId)=>{
    const issueUrl = `/browse/${issue.key}`;
    return {
        id: issue.id,
        issueKey: issue.key,
        issueSummary: issue.fields.summary,
        issueTypeIconUrl: issue.fields.issuetype.iconUrl,
        issueLink: issueUrl,
        issueTypeName: issue.fields.issuetype.name,
        issuePriorityUrl: issue.fields.priority?.iconUrl,
        issuePriorityName: issue.fields.priority?.name,
        statusCategory: issue.fields.status.statusCategory.name,
        statusCategoryId: issue.fields.status.statusCategory.id,
        statusId: issue.fields.status.id,
        statusName: issue.fields.status.name,
        assigneeUrl: issue.fields.assignee?.avatarUrls['48x48'],
        assigneeDisplayName: issue.fields.assignee?.displayName,
        created: Date.parse(issue.fields.created),
        isResolved: !!issue.fields.resolution,
        resolutiondate: issue.fields.resolutiondate !== undefined ? Date.parse(issue.fields.resolutiondate) : undefined,
        services: issue.renderedFields ? issue.renderedFields[affectedServicesFieldId] : [],
        plannedStartTime: typeof plannedStartTimeFieldId === 'string' && issue.fields ? issue.fields[plannedStartTimeFieldId] : undefined,
        plannedEndTime: typeof plannedEndTimeFieldId === 'string' && issue.fields ? issue.fields[plannedEndTimeFieldId] : undefined
    };
};
const $4490302bd224cecf$export$b06c80bd5e8a80f9 = (issues, serviceIds, affectedServicesFieldId)=>issues.reduce((accServiceIdIssues, issue)=>{
        // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
        const currentServiceIdIssues = {
            ...accServiceIdIssues
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        issue.fields[affectedServicesFieldId]?.forEach((issueAssociatedService)=>{
            if (currentServiceIdIssues[issueAssociatedService.id]) currentServiceIdIssues[issueAssociatedService.id].push($4490302bd224cecf$export$ac2f076b1102f25a(issue, affectedServicesFieldId));
        });
        return currentServiceIdIssues;
    }, $4490302bd224cecf$export$a0b24f075062292d(serviceIds));
const $4490302bd224cecf$export$f958f2fd5423f7cc = (fieldName)=>{
    // custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
    const customFieldId = fieldName.split($4490302bd224cecf$export$a3c7258f137a756c)[1];
    return `cf[${customFieldId}]`;
};

});


parcelRegister("kbsh3", function(module, exports) {
$parcel$export(module.exports, "emptyServiceDataState", () => $51e98566fd96f016$export$f45cbea476f13f67);
const $51e98566fd96f016$export$f45cbea476f13f67 = Object.freeze({
    data: null,
    error: null,
    loading: false,
    loadedAt: 0
});

});



parcelRegister("bnLK3", function(module, exports) {
$parcel$export(module.exports, "createInitialState", () => $47caee54c0eb7423$export$de5e90bd767c5d82);
$parcel$export(module.exports, "useCrossTabCache", () => $47caee54c0eb7423$export$ea586dbb740fbbd0);

var $eJOHy = parcelRequire("eJOHy");

var $dnU6V = parcelRequire("dnU6V");

var $gYnSx = parcelRequire("gYnSx");

var $8xBO5 = parcelRequire("8xBO5");
const $47caee54c0eb7423$export$7c18de80fec0beac = 'servicedesk-linked-object-incidents-store';
const $47caee54c0eb7423$export$fac14ff24e5b1e7a = 'cross-tab-cache';
const $47caee54c0eb7423$export$20931991a5b9f60d = 86400000; // 1 day expiry so that old values (e.g. deleted services) don't stay in the cache forever.
const $47caee54c0eb7423$var$localExpirableStorageProvider = (0, $dnU6V.createLocalExpirableStorageProvider)($47caee54c0eb7423$export$7c18de80fec0beac);
const $47caee54c0eb7423$var$fireStorageError = (error, errorType)=>{
    // https://data-portal.internal.atlassian.com/analytics/registry/37613
    (0, $gYnSx.default)({
        meta: {
            id: 'crossTabCache',
            packageName: 'jiraServicedeskLinkedObjectIncidentsStore'
        },
        error: error,
        attributes: {
            errorType: errorType
        },
        skipSentry: true
    });
};
const $47caee54c0eb7423$export$de5e90bd767c5d82 = ()=>{
    try {
        const cachedState = $47caee54c0eb7423$var$localExpirableStorageProvider.get($47caee54c0eb7423$export$fac14ff24e5b1e7a);
        if (cachedState != null && typeof cachedState === 'object') return cachedState;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        $47caee54c0eb7423$var$fireStorageError(error, 'INITIAL_STATE');
    }
    return {};
};
const $47caee54c0eb7423$export$ea586dbb740fbbd0 = ()=>{
    const [activeIncidents, { mergeActiveIncidents: mergeActiveIncidents }] = (0, $8xBO5.useActiveIncidentsStore)();
    // Store -> Local storage
    // Set state in local storage when the store is updated in the current tab.
    (0, $eJOHy.useEffect)(()=>{
        const isEmpty = Object.keys(activeIncidents).length === 0;
        const isLoading = Object.keys(activeIncidents).some((serviceId)=>activeIncidents[serviceId]?.loading);
        const hasError = Object.keys(activeIncidents).some((serviceId)=>activeIncidents[serviceId]?.error);
        if (isEmpty || isLoading || hasError) return;
        try {
            const expiry = Date.now() + $47caee54c0eb7423$export$20931991a5b9f60d;
            $47caee54c0eb7423$var$localExpirableStorageProvider.set($47caee54c0eb7423$export$fac14ff24e5b1e7a, activeIncidents, expiry);
            $47caee54c0eb7423$var$localExpirableStorageProvider.removeExpiredKeys();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            $47caee54c0eb7423$var$fireStorageError(error, 'SET_STATE');
        }
    }, [
        activeIncidents
    ]);
    // Local storage -> Store
    // Sync state from local storage when the the data is updated in another tab.
    (0, $eJOHy.useEffect)(()=>{
        const handleStorageEvent = ({ key: key, oldValue: oldValue, newValue: newValue })=>{
            if (key?.includes(`${$47caee54c0eb7423$export$7c18de80fec0beac}_${$47caee54c0eb7423$export$fac14ff24e5b1e7a}`)) {
                if (newValue == null || oldValue === newValue) return;
                try {
                    const cachedState = JSON.parse(newValue);
                    mergeActiveIncidents(cachedState);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    $47caee54c0eb7423$var$fireStorageError(error, 'SYNC_STATE');
                }
            }
        };
        try {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.addEventListener('storage', handleStorageEvent, false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            $47caee54c0eb7423$var$fireStorageError(error, 'ADD_EVENT_LISTENER');
        }
    }, [
        mergeActiveIncidents
    ]);
};

});


parcelRegister("9RM4T", function(module, exports) {
$parcel$export(module.exports, "useGetServicesById", () => $15b6655567ee28d6$export$7f12900e3bb31f7a);

var $eJOHy = parcelRequire("eJOHy");

var $jbJvT = parcelRequire("jbJvT");


var $eNEty = parcelRequire("eNEty");
const $15b6655567ee28d6$export$7f12900e3bb31f7a = ({ ids: ids, onCompleted: onCompleted, onError: onError })=>{
    const { data: data, loading: loading, error: error } = (0, $jbJvT.useQuery)((0, $eNEty.SEARCH_SERVICES_BY_ID_QUERY_AGG_RELAY), {
        variables: {
            ids: ids,
            propertyKeys: [
                (0, $1a496f3339b1c957$export$b7473a87fd6e24db)
            ]
        },
        fetchPolicy: 'network-only'
    });
    // onCompleted
    (0, $eJOHy.useEffect)(()=>{
        if (data) onCompleted?.(data);
    }, [
        data,
        onCompleted
    ]);
    // onError
    (0, $eJOHy.useEffect)(()=>{
        if (error) onError?.(error);
    }, [
        error,
        onError
    ]);
    return {
        data: data,
        loading: loading,
        error: error
    };
};

});
const $1a496f3339b1c957$export$ad257a98f20ee631 = 'issueFieldsServiceEntity';
const $1a496f3339b1c957$export$b7473a87fd6e24db = 'compass_component';

parcelRegister("eNEty", function(module, exports) {
$parcel$export(module.exports, "SEARCH_SERVICES_BY_ID_QUERY_AGG_RELAY", () => $d4ae4b752e2a5416$export$4854ef2d9d3f869b);

var $e5d59 = parcelRequire("e5d59");
const $d4ae4b752e2a5416$export$4854ef2d9d3f869b = (0, $e5d59.default);

});
parcelRegister("e5d59", function(module, exports) {
$parcel$export(module.exports, "default", () => $22f7996e594fd406$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<98c07c3038ae2238faff51328c39cbf2>>
 * @relayHash 3802c6a316b2a7f76fae5a6914ae5372
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 67bcc509cbc12319640bbfe5c71c93d9c479f58721ebda10840de2cb8202f877
const $22f7996e594fd406$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ids"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "propertyKeys"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "ids",
            "variableName": "ids"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "description"
    }, v5 = {
        "kind": "ScalarField",
        "name": "level"
    }, v6 = {
        "args": [
            {
                "kind": "Variable",
                "name": "keys",
                "variableName": "propertyKeys"
            }
        ],
        "kind": "ScalarField",
        "name": "properties"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "gqlJiraJsmServicesSearchServicesByIdQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "DevOpsService",
                    "kind": "LinkedField",
                    "name": "devOpsServicesById",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "DevOpsServiceTier",
                            "kind": "LinkedField",
                            "name": "serviceTier",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ 
                            ]
                        },
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "gqlJiraJsmServicesSearchServicesByIdQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "DevOpsService",
                    "kind": "LinkedField",
                    "name": "devOpsServicesById",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "DevOpsServiceTier",
                            "kind": "LinkedField",
                            "name": "serviceTier",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        },
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "67bcc509cbc12319640bbfe5c71c93d9c479f58721ebda10840de2cb8202f877",
            "metadata": {},
            "name": "gqlJiraJsmServicesSearchServicesByIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$22f7996e594fd406$var$node.hash = "d536fa7bf1b35ed5337307d00fe95d1e";
var $22f7996e594fd406$export$2e2bcd8739ae039 = $22f7996e594fd406$var$node;

});




parcelRegister("1tGhP", function(module, exports) {
$parcel$export(module.exports, "useAutoComplete", () => $924bd4b82e517e80$export$e792b3a03c5e32cf);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $4mEPL = parcelRequire("4mEPL");
const $924bd4b82e517e80$export$51186ad6e864892a = (details)=>{
    const rawData = {
        id: details.id,
        name: details.name,
        data: details
    };
    return {
        value: details.id,
        label: details.name,
        rawData: rawData
    };
};
const $924bd4b82e517e80$export$6d5eb2b1056739cf = (query, values, autoCompleteUrl, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
setOptions, setIsLoading)=>{
    if (autoCompleteUrl == null) return Promise.resolve();
    setIsLoading(true);
    const existingIds = values.map((value)=>value.id);
    return (0, $4mEPL.default)(`${autoCompleteUrl}${query}`, {}, 'fields/service-entity/src/services/use-auto-complete').then((result)=>{
        const options = result.services.filter((service)=>existingIds.indexOf(service.id) === -1).map($924bd4b82e517e80$export$51186ad6e864892a);
        setOptions(options);
        setIsLoading(false);
    }).catch(()=>{
        setOptions([]);
        setIsLoading(false);
    });
};
const $924bd4b82e517e80$export$e792b3a03c5e32cf = (values, fieldConfig)=>{
    const [options, setOptions] = (0, $eJOHy.useState)([]);
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const onInputChange = (0, $eJOHy.useCallback)((query)=>{
        $924bd4b82e517e80$export$6d5eb2b1056739cf(query, values, fieldConfig ? fieldConfig.autoCompleteUrl : null, setOptions, setIsLoading);
    }, [
        values,
        fieldConfig
    ]);
    const debouncedOnInputChange = (0, $eJOHy.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(onInputChange, 400));
    // Initial search
    // Not using onMenuOpen here because onMenuOpen is being called whenever input changes
    // Details https://atlassian.slack.com/archives/CFHSME8EB/p1629070846357700
    // TODO: add back onMenuOpen once @atlaskit/select is upgraded
    (0, $eJOHy.useEffect)(()=>{
        $924bd4b82e517e80$export$6d5eb2b1056739cf('', values, fieldConfig ? fieldConfig.autoCompleteUrl : null, setOptions, setIsLoading);
    }, [
        values,
        fieldConfig
    ]);
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const onMenuClose = ()=>{};
    return {
        selectProps: {
            isLoading: isLoading,
            // Prevent showing cached options while loading, to reduce the risk of duplicates
            options: isLoading ? [] : options,
            onInputChange: debouncedOnInputChange.current,
            onMenuClose: onMenuClose
        }
    };
};

});

parcelRegister("f6gq6", function(module, exports) {
$parcel$export(module.exports, "AdditionalLabelContent", () => $900e050a3908d519$export$3afa8e4de2b6cf2);

var $eJOHy = parcelRequire("eJOHy");

var $gRxNL = parcelRequire("gRxNL");
const $900e050a3908d519$export$3afa8e4de2b6cf2 = ({ values: values })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gRxNL.ActiveIncidentsIndicator), {
        services: values.map((value)=>value.data)
    });

});
parcelRegister("gRxNL", function(module, exports) {
$parcel$export(module.exports, "ActiveIncidentsIndicator", () => $f23fea3bf3a5059e$export$1a5ed97e92529873);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cA0Y2 = parcelRequire("cA0Y2");

var $1NG86 = parcelRequire("1NG86");

var $jkYbX = parcelRequire("jkYbX");

var $k71qx = parcelRequire("k71qx");

var $gYnSx = parcelRequire("gYnSx");

var $6joHJ = parcelRequire("6joHJ");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $8xBO5 = parcelRequire("8xBO5");

var $aHTRb = parcelRequire("aHTRb");

var $a5VAk = parcelRequire("a5VAk");
const $f23fea3bf3a5059e$export$1a5ed97e92529873 = ({ services: services })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isDialogOpen, setIsDialogOpen] = (0, $eJOHy.useState)(false);
    const activeIncidents = (0, $8xBO5.useActiveIncidents)();
    const buttonLabel = formatMessage((0, $a5VAk.default).viewActiveIncidents);
    const servicesToDisplay = services.filter(({ id: serviceId })=>activeIncidents[serviceId]?.error || activeIncidents[serviceId]?.data?.activeIncidents.length);
    const loading = services.some(({ id: serviceId })=>activeIncidents[serviceId]?.loading);
    const serviceWithError = services.find(({ id: serviceId })=>activeIncidents[serviceId]?.error);
    const errorType = serviceWithError ? activeIncidents[serviceWithError.id]?.error : null;
    (0, $eJOHy.useEffect)(()=>{
        if (loading) return;
        if (errorType) (0, $gYnSx.default)({
            meta: {
                id: 'activeIncidentsIndicator',
                packageName: 'jiraIssueFieldServiceEntity'
            },
            attributes: {
                errorType: errorType
            },
            sendToPrivacyUnsafeSplunk: true
        });
        else (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'activeIncidentsIndicator rendered', {
            numServices: servicesToDisplay.length
        });
    }, [
        loading,
        errorType,
        servicesToDisplay.length,
        createAnalyticsEvent
    ]);
    if (servicesToDisplay.length === 0 && !loading && !errorType) // We want to force show the indicator in the error/loading state.
    return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: buttonLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6joHJ.JiraInlineDialog), {
        onClose: ()=>setIsDialogOpen(false),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f23fea3bf3a5059e$var$InlineDialogContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aHTRb.ObjectActiveIncidentsPanelList), {
            services: servicesToDisplay.map(({ id: id, name: name })=>({
                    id: id,
                    name: name
                }))
        })),
        isOpen: isDialogOpen,
        placement: "bottom-end",
        messageId: "issue-field-service-entity.common.ui.active-incidents-indicator.inline-dialog",
        messageType: "transactional",
        testId: "issue-field-service-entity.common.ui.active-incidents-indicator.incident-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cA0Y2.default), {
        appearance: "subtle",
        isSelected: isDialogOpen,
        onClick: ()=>setIsDialogOpen(true),
        iconBefore: errorType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
            spacing: "spacious",
            label: buttonLabel,
            color: "var(--ds-icon-danger, #C9372C)",
            testId: "issue-field-service-entity.common.ui.active-incidents-indicator.error-icon"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))), {
            spacing: "spacious",
            label: buttonLabel,
            color: "var(--ds-icon-warning, #E56910)",
            testId: "issue-field-service-entity.common.ui.active-incidents-indicator.incident-warning"
        }),
        isLoading: loading,
        testId: "issue-field-service-entity.common.ui.active-incidents-indicator.loading-button",
        interactionName: "auto-generated.issue-field-service-entity.common.ui.active-incidents-indicator.loading-button.button"
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f23fea3bf3a5059e$var$InlineDialogContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo1wug _18m91wug _19pkmgjw _2hwx10v4 _otyrmgjw _18u010v4 _c71l1mjv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aHTRb", function(module, exports) {
$parcel$export(module.exports, "ObjectActiveIncidentsPanelList", () => $6102024102ce26cc$export$a15374bdc0e09969);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $d1MlG = parcelRequire("d1MlG");
const $6102024102ce26cc$export$a15374bdc0e09969 = ({ services: services })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'activeIncidentPanelList rendered', {
            numOfServices: services.length
        });
    }, [
        createAnalyticsEvent,
        services.length
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, services.map(({ name: name, id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Fragment), {
            key: id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d1MlG.default), {
            serviceId: id,
            serviceName: name
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6102024102ce26cc$var$PanelDividerLine, null))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6102024102ce26cc$var$PanelDividerLine = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _4t3iyh40 _1bsb1vuk _bfhkmuej _1grsglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("d1MlG", function(module, exports) {
$parcel$export(module.exports, "default", () => $82d0f2e9a61d497e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1NG86 = parcelRequire("1NG86");

var $jkYbX = parcelRequire("jkYbX");

var $gYnSx = parcelRequire("gYnSx");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $8xBO5 = parcelRequire("8xBO5");

var $8CHDk = parcelRequire("8CHDk");

var $1Zy2s = parcelRequire("1Zy2s");
const $82d0f2e9a61d497e$var$Content = ({ serviceData: { data: data, loading: loading, error: error }, serviceName: serviceName })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const activeIncidents = data?.activeIncidents ?? [];
    (0, $eJOHy.useEffect)(()=>{
        if (loading) return;
        if (error) (0, $gYnSx.default)({
            meta: {
                id: 'activeIncidentPanel',
                packageName: 'jiraServicedeskObjectActiveIncidentsPanel'
            },
            attributes: {
                errorType: error
            },
            sendToPrivacyUnsafeSplunk: true
        });
        else (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'activeIncidentPanel rendered', {
            numOfIncidents: activeIncidents.length
        });
    }, [
        createAnalyticsEvent,
        activeIncidents.length,
        loading,
        error
    ]);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($82d0f2e9a61d497e$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($82d0f2e9a61d497e$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
        spacing: "spacious",
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error icon"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($82d0f2e9a61d497e$var$ContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($82d0f2e9a61d497e$var$Title, null, formatMessage((0, $1Zy2s.default).errorTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($82d0f2e9a61d497e$var$Description, null, formatMessage((0, $1Zy2s.default).errorDescription))));
    if (loading || activeIncidents.length === 0) return null;
    // We are trying to format the service name here so that:
    // * The name is wrapped inside apostrophes
    // * Keep the apostrophes when the name itself is truncated
    // * Don't break at the apostrophes when the name has to wrap in another line
    const title = serviceName !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
        ...(0, $1Zy2s.default).titleWithServicename,
        values: {
            incidentCount: activeIncidents.length,
            serviceName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($82d0f2e9a61d497e$var$ServiceNameWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
                ...(0, $1Zy2s.default).serviceName,
                values: {
                    serviceName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($82d0f2e9a61d497e$var$ServiceName, null, serviceName)
                }
            }))
        }
    }) : formatMessage((0, $1Zy2s.default).title, {
        incidentCount: activeIncidents.length
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($82d0f2e9a61d497e$var$Container, {
        "data-testid": "servicedesk-object-active-incidents-panel.ui.active-incident-panel.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($82d0f2e9a61d497e$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))), {
        spacing: "spacious",
        color: "var(--ds-icon-warning, #E56910)",
        label: "warning icon"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($82d0f2e9a61d497e$var$ContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($82d0f2e9a61d497e$var$Title, null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($82d0f2e9a61d497e$var$Description, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8CHDk.default), {
        incidents: activeIncidents.map(({ issueKey: issueKey, issueSummary: issueSummary, issueTypeIconUrl: issueTypeIconUrl })=>({
                issueKey: issueKey,
                issueSummary: issueSummary,
                issueTypeIconUrl: issueTypeIconUrl
            }))
    }))));
};
const $82d0f2e9a61d497e$var$WrappedContent = ({ serviceId: serviceId, serviceName: serviceName, renderWrapper: renderWrapper })=>{
    const activeIncidentsState = (0, $8xBO5.useActiveIncidentsForService)(serviceId);
    const content = $82d0f2e9a61d497e$var$Content({
        serviceData: activeIncidentsState,
        serviceName: serviceName
    });
    if (content === null) return null;
    return renderWrapper ? renderWrapper({
        hasError: activeIncidentsState.error !== null
    }, content) : content;
};
const $82d0f2e9a61d497e$var$ObjectActiveIncidentsPanel = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "activeIncidents",
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($82d0f2e9a61d497e$var$WrappedContent, props));
var $82d0f2e9a61d497e$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $82d0f2e9a61d497e$var$ObjectActiveIncidentsPanel;
const $82d0f2e9a61d497e$var$ContentContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $82d0f2e9a61d497e$var$Description = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_cvk5u2gc",
            __cmplp.className
        ])
    });
});
const $82d0f2e9a61d497e$var$IconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1bsb1ylp _1yti1i6y _7yhbidpf _1bdk1i6y _24rcidpf _15tyjp4b",
            __cmplp.className
        ])
    });
});
const $82d0f2e9a61d497e$var$ServiceNameWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_o5721q9c",
            __cmplp.className
        ])
    });
});
const $82d0f2e9a61d497e$var$ServiceName = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _p12f1kdj _1e0c1o8l _s7n4yfq0",
            __cmplp.className
        ])
    });
});
const $82d0f2e9a61d497e$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "section", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _1e0c1txw _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
});
$82d0f2e9a61d497e$var$Container.displayName = 'Container';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $82d0f2e9a61d497e$var$Title = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "h4", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c8140y",
            __cmplp.className
        ])
    });
});
$82d0f2e9a61d497e$var$Title.displayName = 'Title';

});
// SCREENS
const $466f60259c330878$export$f636b5b56f1d624a = 'Screen';
const $466f60259c330878$export$9d2de6eebf7462b5 = 'Drawer';
const $466f60259c330878$export$1171103ea9083ffa = 'Modal';
const $466f60259c330878$export$cae2783c9279926 = 'InlineDialog';
const $466f60259c330878$export$d1123261ca8831d2 = 'Dropdown';
const $466f60259c330878$export$238d30785c4bca84 = 'Banner';
const $466f60259c330878$export$a1562d08625f5d7e = 'UI';
const $466f60259c330878$export$947dac6c72b26f81 = 'TRACK';
const $466f60259c330878$export$f1d537d508d2945a = 'SCREEN';
const $466f60259c330878$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("8CHDk", function(module, exports) {
$parcel$export(module.exports, "default", () => $0cfa4f4948255a50$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $lRq8t = parcelRequire("lRq8t");

var $hih5V = parcelRequire("hih5V");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $8aeRQ = parcelRequire("8aeRQ");

var $5pS2g = parcelRequire("5pS2g");
const $0cfa4f4948255a50$var$VISIBLE_INCIDENTS_MAX_COUNT = 2;
const $0cfa4f4948255a50$var$IncidentIssueCards = ({ incidents: incidents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, incidents.map((incident)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8aeRQ.default), {
            key: incident.issueKey,
            issueKey: incident.issueKey,
            issueSummary: incident.issueSummary,
            issueTypeIconUrl: incident.issueTypeIconUrl
        })));
const $0cfa4f4948255a50$var$IncidentList = ({ incidents: incidents })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const visibleIncidents = incidents.slice(0, $0cfa4f4948255a50$var$VISIBLE_INCIDENTS_MAX_COUNT);
    const hiddenIncidents = incidents.slice($0cfa4f4948255a50$var$VISIBLE_INCIDENTS_MAX_COUNT);
    const [isListExpanded, setIsListExpanded] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const route = (0, $hih5V.useCurrentRoute)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0cfa4f4948255a50$var$IncidentIssueCards, {
        incidents: visibleIncidents
    }), hiddenIncidents.length > 0 && (isListExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0cfa4f4948255a50$var$IncidentIssueCards, {
        incidents: hiddenIncidents
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "link",
        spacing: "none",
        onClick: ()=>{
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            }), 'showLessIncidentButton', {
                routeGroup: route.group ?? undefined,
                routeName: route.name ?? undefined
            });
            setIsListExpanded(!isListExpanded);
        }
    }, formatMessage((0, $5pS2g.default).lessIncidents))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "link",
        spacing: "none",
        onClick: ()=>{
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            }), 'showMoreIncidentsButton', {
                routeGroup: route.group ?? undefined,
                routeName: route.name ?? undefined
            });
            setIsListExpanded(!isListExpanded);
        }
    }, formatMessage((0, $5pS2g.default).moreIncidents, {
        incidentCount: hiddenIncidents.length
    }))));
};
var $0cfa4f4948255a50$export$2e2bcd8739ae039 = $0cfa4f4948255a50$var$IncidentList;

});
parcelRegister("8aeRQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1972b75e1bfe916$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k71qx = parcelRequire("k71qx");

var $giHTp = parcelRequire("giHTp");

var $7keuM = parcelRequire("7keuM");

var $hih5V = parcelRequire("hih5V");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $lYbYH = parcelRequire("lYbYH");
const $d1972b75e1bfe916$var$IssueCard = ({ issueKey: issueKey, issueSummary: issueSummary, issueTypeIconUrl: issueTypeIconUrl, statusCategoryId: statusCategoryId, statusName: statusName, issuePriorityUrl: issuePriorityUrl, issuePriorityName: issuePriorityName })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const route = (0, $hih5V.useCurrentRoute)();
    const statusLozenge = statusCategoryId !== undefined && statusName !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $giHTp.default), {
        category: (0, $7keuM.statusCategoryForId)(statusCategoryId),
        name: statusName
    });
    const priority = issuePriorityName !== undefined && issuePriorityUrl !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d1972b75e1bfe916$var$IssuePriority, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lYbYH.default), {
        iconUrl: issuePriorityUrl,
        name: issuePriorityName
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d1972b75e1bfe916$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: issueSummary
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d1972b75e1bfe916$var$IssueContainer, {
        href: `/browse/${issueKey}`,
        target: "_blank",
        onClick: ()=>{
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'link'
            }), 'incidentLink', {
                routeGroup: route.group ?? undefined,
                routeName: route.name ?? undefined
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d1972b75e1bfe916$var$IssueTypeIcon, {
        src: issueTypeIconUrl,
        alt: "",
        role: "presentation"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d1972b75e1bfe916$var$IssueKey, null, issueKey), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d1972b75e1bfe916$var$IssueSummary, null, issueSummary), priority, statusLozenge)));
};
var $d1972b75e1bfe916$export$2e2bcd8739ae039 = $d1972b75e1bfe916$var$IssueCard;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $d1972b75e1bfe916$var$IssuePriority = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2hwxu2gc _1xoqidpf",
            __cmplp.className
        ])
    });
});
const $d1972b75e1bfe916$var$IssueTypeIcon = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkolb4i _16jlidpf _1o9zidpf _i0dl1wug _4t3i7vkz _1bsb7vkz _19pkidpf _2hwx1b66 _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});
const $d1972b75e1bfe916$var$IssueContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _1reo15vq _18m915vq _1e0c116y _4cvr1h6o _vwz41tcg _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _bfhkhp5a _80omtlke _16qszucj _p12f1osq _vchhusvi _1nrm18uv _1a3b18uv _9oik18uv _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _qdji18uv _1c7c18uv _1uqq18uv _q9wy8stv _1i7s8stv _bwjq8stv _87h7nqa1 _1lfanqa1 _aqasnqa1",
            __cmplp.className
        ])
    });
});
const $d1972b75e1bfe916$var$IssueSummary = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _16jlidpf _1o9zkb7n _i0dl1wug _syaz1fxt _o5721q9c _1bto1l2s _2hwxu2gc _1xoq1b66",
            __cmplp.className
        ])
    });
});
const $d1972b75e1bfe916$var$IssueKey = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _16jlidpf _1o9zidpf _i0dl1wug _k48p1pd9 _vwz41tcg _syaz1gjq _19pkidpf _2hwxu2gc _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});
const $d1972b75e1bfe916$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxu2gc _otyru2gc _18u0t94y _9rb0idpf _1xoqu2gc _dxh9idpf _it7vt94y",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lYbYH", function(module, exports) {
$parcel$export(module.exports, "default", () => $7375e27ac3201b53$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $bQyn2 = parcelRequire("bQyn2");

var $lRq8t = parcelRequire("lRq8t");

var $7Dz8a = parcelRequire("7Dz8a");

var $6cywQ = parcelRequire("6cywQ");
const $7375e27ac3201b53$var$priorityIconSize = 20;
const $7375e27ac3201b53$var$Priority = /*#__PURE__*/ (0, $eJOHy.memo)(({ iconUrl: iconUrl, name: name })=>{
    const intl = (0, $lRq8t.default)();
    const title = intl.formatMessage((0, $7Dz8a.default).issuePriorityTitle, {
        issuePriorityName: name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6cywQ.Wrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: name,
        position: "bottom",
        testId: "servicedesk-insight-object-issue-card.ui.priority.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQyn2.default), {
        alt: title,
        url: iconUrl,
        width: $7375e27ac3201b53$var$priorityIconSize,
        height: $7375e27ac3201b53$var$priorityIconSize
    })));
});
var $7375e27ac3201b53$export$2e2bcd8739ae039 = $7375e27ac3201b53$var$Priority;

});
parcelRegister("7Dz8a", function(module, exports) {
$parcel$export(module.exports, "default", () => $9819d08c5c63b1cc$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9819d08c5c63b1cc$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    issuePriorityTitle: {
        "id": "servicedesk-insight-object-issue-card.priority.issue-priority-title",
        "defaultMessage": "Priority: {issuePriorityName}"
    }
});

});

parcelRegister("6cywQ", function(module, exports) {
$parcel$export(module.exports, "Wrapper", () => $a4db4e11a0a5b739$export$e6dfd72ab29f8598);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $a4db4e11a0a5b739$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3igktf",
            __cmplp.className
        ])
    });
});

});



parcelRegister("5pS2g", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd9020d41440fead$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $fd9020d41440fead$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    moreIncidents: {
        "id": "servicedesk-object-active-incidents-panel.active-incident-panel.incident-list.more-incidents",
        "defaultMessage": "+ {incidentCount} more {incidentCount, plural, one {incident} other {incidents}}"
    },
    lessIncidents: {
        "id": "servicedesk-object-active-incidents-panel.active-incident-panel.incident-list.less-incidents",
        "defaultMessage": "Show less"
    }
});

});


parcelRegister("1Zy2s", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc320f112b40e815$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $bc320f112b40e815$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "servicedesk-object-active-incidents-panel.active-incident-panel.title",
        "defaultMessage": "{incidentCount, plural, one {1 open incident} other {{incidentCount} open incidents}} on this service"
    },
    titleWithServicename: {
        "id": "servicedesk-object-active-incidents-panel.active-incident-panel.title-with-servicename",
        "defaultMessage": "{incidentCount, plural, one {1 open incident} other {{incidentCount} open incidents}} on {serviceName}"
    },
    serviceName: {
        "id": "servicedesk-object-active-incidents-panel.active-incident-panel.service-name",
        "defaultMessage": "\u2019{serviceName}\u2019"
    },
    errorTitle: {
        "id": "servicedesk-object-active-incidents-panel.active-incident-panel.error-title",
        "defaultMessage": "There's been a problem loading a panel"
    },
    errorDescription: {
        "id": "servicedesk-object-active-incidents-panel.active-incident-panel.error-description",
        "defaultMessage": "Try refreshing the page."
    }
});

});



parcelRegister("a5VAk", function(module, exports) {
$parcel$export(module.exports, "default", () => $d39aa750763e4375$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $d39aa750763e4375$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    viewActiveIncidents: {
        "id": "issue-field-service-entity.common.active-incidents-indicator.view-active-incidents",
        "defaultMessage": "View open incidents"
    }
});

});



parcelRegister("7FpnE", function(module, exports) {
$parcel$export(module.exports, "DetailContent", () => $13f1e3082b2b075e$export$c3a954a81164202f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $806LH = parcelRequire("806LH");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $1KdDN = parcelRequire("1KdDN");

var $lRq8t = parcelRequire("lRq8t");

var $d1MlG = parcelRequire("d1MlG");

var $3Jvep = parcelRequire("3Jvep");


var $8iLKz = parcelRequire("8iLKz");
const $13f1e3082b2b075e$var$Description = ({ value: value })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isEmpty = value.description == null || value.description === '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($13f1e3082b2b075e$var$DescriptionLabel, null, formatMessage((0, $8iLKz.default).description)), isEmpty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($13f1e3082b2b075e$var$EmptyDescription, null, formatMessage((0, $8iLKz.default).emptyDescription)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($13f1e3082b2b075e$var$DescriptionValue, null, value.description));
};
const $13f1e3082b2b075e$export$c3a954a81164202f = (props)=>{
    const { value: value } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (value == null) return null;
    const { data: { id: serviceId, tier: { level: level }, properties: properties } } = value;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $13f1e3082b2b075e$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d1MlG.default), {
        serviceId: serviceId,
        renderWrapper: ({ hasError: hasError }, children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($13f1e3082b2b075e$var$ActiveIncidentsPanelWrapper, {
                hasError: hasError
            }, children)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($13f1e3082b2b075e$var$Description, {
        value: value.data
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($13f1e3082b2b075e$var$AttributeList, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($13f1e3082b2b075e$var$Attribute, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($13f1e3082b2b075e$var$Label, null, formatMessage((0, $8iLKz.default).tier)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($13f1e3082b2b075e$var$Value, null, formatMessage((0, $8iLKz.default).tier), " ", level)), !!properties?.compass_component && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "issueServiceEntityDetailContent",
        packageName: (0, $1a496f3339b1c957$export$ad257a98f20ee631),
        // This is a rare edge case as links between JSM and Compass should be automatically cleaned up when a component is deleted.
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($13f1e3082b2b075e$var$Attribute, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($13f1e3082b2b075e$var$Label, null, formatMessage((0, $8iLKz.default).compass)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($13f1e3082b2b075e$var$Value, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Jvep.CompassSmartLink), {
        url: properties.compass_component.url
    }))))));
};
const $13f1e3082b2b075e$var$ATTRIBUTE_VERTICAL_GAP = 8; // Total vertical space between each attribute
const $13f1e3082b2b075e$var$LABEL_VALUE_HORIZONTAL_GAP = 24; // Total horizontal space between label & value
const $13f1e3082b2b075e$var$DescriptionLabel = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall",
        as: "div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($13f1e3082b2b075e$var$DescriptionLabelComponent, props));
const $13f1e3082b2b075e$var$Label = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($13f1e3082b2b075e$var$LabelHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall",
        as: "div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($13f1e3082b2b075e$var$LabelComponent, props))); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $13f1e3082b2b075e$var$LabelHeader = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _i0dl15e7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $13f1e3082b2b075e$var$DescriptionValue = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pk1y44 _2hwx1crf _otyr1crf _18u0idpf _syaz1fxt _1tke1tcg _vwz41tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $13f1e3082b2b075e$var$EmptyDescription = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pk1y44 _2hwx1crf _otyr1crf _18u0idpf _syaz131l _1tke1tcg _vwz41tcg",
            __cmplp.className
        ])
    });
});
const $13f1e3082b2b075e$var$Value = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1crf _otyridpf _18u01crf _syaz1fxt _1tke1tcg _vwz41tcg _i0dlnr97 _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $13f1e3082b2b075e$var$ActiveIncidentsPanelWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasError: hasError, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1phy744": (0, $awdRS.default)(__cmplp.hasError ? "var(--ds-background-danger, #FFECEB)" : "var(--ds-background-warning, #FFF7D6)")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pk1crf _2hwxidpf _otyr1y44 _18u0idpf _bfhkxn82",
            __cmplp.className
        ])
    });
});
const $13f1e3082b2b075e$var$DescriptionLabelComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pk1crf _2hwx1crf _otyr1y44 _18u0idpf _syaz1gjq _1tke1tcg _vwz41tcg",
            __cmplp.className
        ])
    });
});
const $13f1e3082b2b075e$var$LabelComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pk1y44 _2hwx1crf _otyr1y44 _18u0idpf _syaz1gjq _1tke1tcg _vwz41tcg",
            __cmplp.className
        ])
    });
});
const $13f1e3082b2b075e$var$AttributeList = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $13f1e3082b2b075e$var$Attribute = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $13f1e3082b2b075e$var$wrapperStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.200'
});

});
parcelRegister("3Jvep", function(module, exports) {
$parcel$export(module.exports, "CompassSmartLink", () => $6ad99f3ae3f05845$export$e70c358e78d54785);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4cFYC = parcelRequire("4cFYC");
var $18DG7 = parcelRequire("18DG7");
const $6ad99f3ae3f05845$export$e70c358e78d54785 = ({ url: url })=>{
    const handleClick = (event)=>{
        event.preventDefault();
        // Open smart link in new tab by default, as it takes the user out of Jira
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(url, '_blank', 'noopener');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6ad99f3ae3f05845$var$SmartLinkStyleOverrides, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4cFYC.Card), {
        appearance: "inline",
        url: url,
        showHoverPreview: false,
        onClick: handleClick,
        actionOptions: {
            hide: false,
            exclude: [
                (0, $18DG7.CardAction).ChangeStatusAction
            ]
        }
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6ad99f3ae3f05845$var$SmartLinkStyleOverrides = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_jwdiglyw _rd6pglyw _14cfglyw _nydzglyw _qwcqglyw _1xz77vkz _slup7vkz _1h7u16yg _bagku2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8iLKz", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d7651f8851650bc$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9d7651f8851650bc$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    compass: {
        "id": "issue-field-service-entity.detail-content.compass.do-not-translate",
        "defaultMessage": "Compass"
    },
    description: {
        "id": "issue-field-service-entity.detail-content.description",
        "defaultMessage": "Description"
    },
    emptyDescription: {
        "id": "issue-field-service-entity.detail-content.empty-description",
        "defaultMessage": "None"
    },
    tier: {
        "id": "issue-field-service-entity.detail-content.tier",
        "defaultMessage": "Tier"
    },
    serviceOwners: {
        "id": "issue-field-service-entity.detail-content.service-owners",
        "defaultMessage": "Service Owners"
    }
});

});


parcelRegister("iSmqR", function(module, exports) {
$parcel$export(module.exports, "HeaderContent", () => $04c730f0e50fc21c$export$78a558edcc066ec2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cA0Y2 = parcelRequire("cA0Y2");

var $806LH = parcelRequire("806LH");

var $fL0In = parcelRequire("fL0In");

var $cYbWd = parcelRequire("cYbWd");

var $8rAKL = parcelRequire("8rAKL");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $in5u6 = parcelRequire("in5u6");

var $8XHsn = parcelRequire("8XHsn");

var $jopyG = parcelRequire("jopyG");

var $8E59C = parcelRequire("8E59C");

var $9lLzu = parcelRequire("9lLzu");

var $lvKO5 = parcelRequire("lvKO5");

var $gRxNL = parcelRequire("gRxNL");

var $48RM5 = parcelRequire("48RM5");

var $gqVbO = parcelRequire("gqVbO");
const $04c730f0e50fc21c$var$DetailsButton = (props)=>{
    const { value: { id: id }, onViewObjectDetails: onViewObjectDetails } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { workspaceId: workspaceId } = (0, $8XHsn.useWorkspaceContext)();
    const buttonLabel = formatMessage((0, $gqVbO.default).viewFullServiceDetails);
    const { loading: isLoading, fetch: fetch } = (0, $48RM5.useFetchObjectDetails)(workspaceId, id);
    const handleViewObjectDetails = (event, analyticsEvent)=>{
        (0, $8E59C.graphModalExperience).start();
        fetch().then((cmdbObject)=>{
            if (!cmdbObject) return;
            onViewObjectDetails(cmdbObject, analyticsEvent);
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: buttonLabel,
        testId: "issue-field-service-entity.ui.header-content.details-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cA0Y2.default), {
        onClick: handleViewObjectDetails,
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cYbWd))), {
            spacing: "spacious",
            label: buttonLabel
        }),
        isLoading: isLoading,
        testId: "issue-field-service-entity.ui.header-content.graph-button",
        interactionName: "auto-generated.issue-field-service-entity.ui.header-content.graph-button.button",
        "aria-label": buttonLabel
    }));
};
const $04c730f0e50fc21c$export$78a558edcc066ec2 = (props)=>{
    const { value: value, isEditing: isEditing, isExpanded: isExpanded, projectKey: projectKey, onViewObjectDetails: onViewObjectDetails } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const tenantContext = (0, $lvKO5.useTenantContext)();
    const isPremium = (0, $jopyG.isPremiumInstance)(tenantContext);
    if (value == null) return null;
    const buttonLabel = formatMessage((0, $gqVbO.default).viewFullServiceDetails);
    const ariaLabel = formatMessage((0, $gqVbO.default).ariaLabel);
    const buttons = [];
    if (!isEditing) {
        if (!isExpanded) buttons.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gRxNL.ActiveIncidentsIndicator), {
            services: [
                value.data
            ]
        }));
        if (isPremium) buttons.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($04c730f0e50fc21c$var$DetailsButton, {
            value: value,
            onViewObjectDetails: onViewObjectDetails
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($04c730f0e50fc21c$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($04c730f0e50fc21c$var$Label, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        /* @ts-expect-error - TS2322 - Type '(props: { [key: string]: string; }) => JSX.Element' is not assignable to type 'ComponentType<CustomGlyphProps> | undefined'. */ glyph: (0, $9lLzu.ServicesGlyph),
        label: value.name,
        testId: "issue-field-service-entity.ui.header-content.icon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: buttonLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($04c730f0e50fc21c$var$DetailLink, {
        href: (0, $in5u6.getServiceDetailsUrl)(projectKey, value.id),
        target: "_blank",
        "aria-label": ariaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall",
        as: "div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($04c730f0e50fc21c$var$NameComponent, null, value.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8rAKL))), {
        label: "",
        testId: "issue-field-service-entity.ui.header-content.shortcut-icon"
    })))), buttons.map((button, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($04c730f0e50fc21c$var$ButtonWrapper, {
            key: index
        }, button)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04c730f0e50fc21c$var$Header = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _19pkr5cr _otyrr5cr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04c730f0e50fc21c$var$DetailLink = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz14q2 _1e0c1txw _4cvr1h6o _u5f31b66 _19bv1b66 _2hwx1b66 _18u01b66 _xqk6ewfl _18nuewfl _q2zf15vq _vn8912b0 _9h8h16c2 _f8pj16c2 _30l316c2",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04c730f0e50fc21c$var$NameComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1reo15vq _18m915vq _syaz1gjq _19bv1b66 _u5f31b66 _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04c730f0e50fc21c$var$Label = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _16jlkb7n _1bsbb5o0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04c730f0e50fc21c$var$ButtonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_wsviu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("in5u6", function(module, exports) {
$parcel$export(module.exports, "getServiceRegistryUrl", () => $5ecb74412b1059dd$export$10b9638e67c00050);
$parcel$export(module.exports, "getServiceDetailsUrl", () => $5ecb74412b1059dd$export$32ab9da0e8f0445b);

var $hkZVc = parcelRequire("hkZVc");
const $5ecb74412b1059dd$export$10b9638e67c00050 = (projectKey)=>{
    // Allows showing services page in a top nav outside of project context
    if (!projectKey) return '/jira/servicedesk/services';
    return `/jira/servicedesk/projects/${projectKey}/services`;
};
const $5ecb74412b1059dd$export$32ab9da0e8f0445b = (projectKey, serviceId)=>`${$5ecb74412b1059dd$export$10b9638e67c00050(projectKey)}/${(0, $hkZVc.serviceAriToServiceUrlParam)(serviceId)}`;

});
parcelRegister("hkZVc", function(module, exports) {
$parcel$export(module.exports, "mapAggMutationResultToSwag", () => $e98f73f6da15b501$export$1e8166c8994bfafd);
$parcel$export(module.exports, "mapServiceAriToPublicId", () => $e98f73f6da15b501$export$b65f3769664d0a1a);
$parcel$export(module.exports, "serviceAriToServiceUrlParam", () => $e98f73f6da15b501$export$6b99235725b6332b);
$parcel$export(module.exports, "serviceUrlParamToServiceAri", () => $e98f73f6da15b501$export$90a4975e6f854ff1);
$parcel$export(module.exports, "getChangeManagementAssociation", () => $e98f73f6da15b501$export$b4bb0c4d543d3da);
$parcel$export(module.exports, "getOpsgenieTeamHref", () => $e98f73f6da15b501$export$e53fe140d3612e22);
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'atob-lite'. '/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/node_modules/atob-lite/atob-node.js' implicitly has an 'any' type.

var $Kguyb = parcelRequire("Kguyb");

var $8oKDI = parcelRequire("8oKDI");

var $7jTnu = parcelRequire("7jTnu");

var $gEqhc = parcelRequire("gEqhc");

var $5Ovjr = parcelRequire("5Ovjr");
var $e98f73f6da15b501$require$Buffer = $5Ovjr.Buffer;
const $e98f73f6da15b501$export$1e8166c8994bfafd = (errors)=>({
        statusCode: (errors ?? [])[0]?.extensions?.statusCode ?? 0,
        errorType: (errors ?? [])[0]?.extensions?.errorType ?? null,
        message: (errors ?? [])[0]?.message ?? ''
    });
// SSR-compatible
const $e98f73f6da15b501$var$ssrSafeBtoa = (str)=>{
    if (typeof window !== 'undefined' && window.btoa) return window.btoa(str);
    return $e98f73f6da15b501$require$Buffer.from(str).toString('base64');
};
const $e98f73f6da15b501$export$b65f3769664d0a1a = (serviceAri)=>{
    if ((0, $7jTnu.fg)('ssring_affected_services_in_issue_view')) return `b:${$e98f73f6da15b501$var$ssrSafeBtoa(serviceAri)}`;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return `b:${window.btoa(serviceAri)}`;
};
const $e98f73f6da15b501$export$6b99235725b6332b = (serviceAri)=>encodeURIComponent(serviceAri.startsWith('b:') ? serviceAri : $e98f73f6da15b501$export$b65f3769664d0a1a(serviceAri));
const $e98f73f6da15b501$export$90a4975e6f854ff1 = (encoded)=>(0, (/*@__PURE__*/$parcel$interopDefault($Kguyb)))(decodeURIComponent(encoded).slice(2));
const $e98f73f6da15b501$export$b4bb0c4d543d3da = (service)=>{
    const changeManagementAssociation = service.jiraProjects && service.jiraProjects.nodes.find((assoc)=>assoc.associationType === (0, $gEqhc.SERVICE_PROJECT_ASSOCIATION_TYPES).CHANGE_MANAGEMENT);
    return changeManagementAssociation || null;
};
const $e98f73f6da15b501$export$f899d7c04b586bd3 = (environment)=>environment && environment === 'staging' ? (0, $gEqhc.OPSGENIE_STAGING_URL) : (0, $gEqhc.OPSGENIE_PROD_URL);
const $e98f73f6da15b501$export$32e17ecac7e548f2 = (href, environment)=>{
    if (!href.startsWith('http')) {
        const ogBaseUrl = $e98f73f6da15b501$export$f899d7c04b586bd3(environment);
        return `${ogBaseUrl}/${href}`;
    }
    return href;
};
const $e98f73f6da15b501$export$e53fe140d3612e22 = (ogTeamIdOrAri)=>{
    if (ogTeamIdOrAri == null) return undefined;
    let teamId = null;
    if (/^[a-z0-9-]{36}$/.test(ogTeamIdOrAri)) // ogTeamIdOrAri === {teamId}
    teamId = ogTeamIdOrAri;
    else {
        const teamAri = (0, $8oKDI.toAri)(ogTeamIdOrAri) ?? null;
        // ogTeamIdOrAri === ari:cloud:opsgenie:{cloudId}:team/{teamId}
        if (teamAri != null) {
            const { resourceOwner: resourceOwner, resourceType: resourceType, resourceId: resourceId } = (0, $8oKDI.getAriConfig)(teamAri);
            if (resourceOwner === 'opsgenie' && resourceType === 'team') teamId = resourceId;
        }
    }
    return teamId == null ? undefined : `teams/dashboard/${teamId}/main`;
};

});
parcelRegister("Kguyb", function(module, exports) {
module.exports = function _atob(str) {
    return atob(str);
};

});

parcelRegister("gEqhc", function(module, exports) {
$parcel$export(module.exports, "SERVICE_PROJECT_ASSOCIATION_TYPES", () => $5e1f4f4e35dba7a1$export$7c6de9b2dfb3fc0a);
$parcel$export(module.exports, "SLO_THRESHOLD_TTI", () => $5e1f4f4e35dba7a1$export$f48e18e4ba22e20d);
$parcel$export(module.exports, "SLO_THRESHOLD_TTR", () => $5e1f4f4e35dba7a1$export$64d639323343af49);
$parcel$export(module.exports, "SLO_THRESHOLD_CREATE_SERVICE_INTERACTION", () => $5e1f4f4e35dba7a1$export$ca872be9342ac9c);
$parcel$export(module.exports, "SLO_THRESHOLD_UPDATE_SERVICE_INTERACTION", () => $5e1f4f4e35dba7a1$export$dd9d82cb315ba5e4);
$parcel$export(module.exports, "MISSING_ERROR_TYPE", () => $5e1f4f4e35dba7a1$export$5f7a5b4c43382fda);
$parcel$export(module.exports, "OPSGENIE_STAGING_URL", () => $5e1f4f4e35dba7a1$export$d01f1fd369e587a0);
$parcel$export(module.exports, "OPSGENIE_PROD_URL", () => $5e1f4f4e35dba7a1$export$4a2a3693d6320aef);
const $5e1f4f4e35dba7a1$export$7c6de9b2dfb3fc0a = {
    CHANGE_MANAGEMENT: 'CHANGE_MANAGEMENT'
};
const $5e1f4f4e35dba7a1$export$f48e18e4ba22e20d = 4000;
const $5e1f4f4e35dba7a1$export$64d639323343af49 = 1000;
const $5e1f4f4e35dba7a1$export$ca872be9342ac9c = 5000;
const $5e1f4f4e35dba7a1$export$dd9d82cb315ba5e4 = 5500;
const $5e1f4f4e35dba7a1$export$5f7a5b4c43382fda = 'MISSING_ERROR_TYPE';
const $5e1f4f4e35dba7a1$export$d01f1fd369e587a0 = 'https://app.opsgeni.us';
const $5e1f4f4e35dba7a1$export$4a2a3693d6320aef = 'https://app.opsgenie.com';

});



parcelRegister("9lLzu", function(module, exports) {
$parcel$export(module.exports, "IncidentsGlyph", () => $20df754c7d362b79$export$dccd7347f5424c62);
$parcel$export(module.exports, "ChangesGlyph", () => $20df754c7d362b79$export$fdf1495a4a912188);
$parcel$export(module.exports, "ProblemsGlyph", () => $20df754c7d362b79$export$7e45df5d5091bdc1);
$parcel$export(module.exports, "ServiceRequestsGlyph", () => $20df754c7d362b79$export$aa6aa7c7f5b660eb);
$parcel$export(module.exports, "PostIncidentReviewsGlyph", () => $20df754c7d362b79$export$d16eebd02cbe077);
$parcel$export(module.exports, "ServicesGlyph", () => $20df754c7d362b79$export$3d11ab79d49f0705);

var $eJOHy = parcelRequire("eJOHy");
const $20df754c7d362b79$export$dccd7347f5424c62 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.8716 5.54947C12.7818 5.38984 12.6499 5.25794 12.4903 5.16815C12.0089 4.89739 11.3992 5.06811 11.1284 5.54947L3.83826 18.5097C3.75407 18.6594 3.70984 18.8283 3.70984 19C3.70984 19.5523 4.15755 20 4.70984 20H19.2901C19.4619 20 19.6307 19.9558 19.7804 19.8716C20.2618 19.6008 20.4325 18.9911 20.1617 18.5097L12.8716 5.54947ZM12 9.09932L16.7254 17.5H7.27461L12 9.09932Z",
        fill: "currentColor"
    }));
const $20df754c7d362b79$export$fdf1495a4a912188 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.4123 10.1551C12.8378 10.1525 12.3701 9.68475 12.3675 9.11027L12.3598 7.39768L5.63605 14.1215C5.24553 14.512 4.61236 14.512 4.22184 14.1215C3.83132 13.731 3.83132 13.0978 4.22184 12.7073L10.9456 5.98347L9.23304 5.97583C8.65857 5.97326 8.19079 5.50548 8.18823 4.93101C8.18567 4.35654 8.64929 3.89291 9.22376 3.89548L13.3845 3.91404C13.9589 3.9166 14.4267 4.38438 14.4293 4.95886L14.4478 9.11955C14.4504 9.69403 13.9868 10.1577 13.4123 10.1551Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.8118 19.0691C15.8093 18.4946 15.3415 18.0269 14.767 18.0243L13.0544 18.0166L19.7782 11.2929C20.1687 10.9023 20.1687 10.2692 19.7782 9.87864C19.3877 9.48812 18.7545 9.48811 18.364 9.87864L11.6402 16.6024L11.6326 14.8898C11.63 14.3154 11.1622 13.8476 10.5877 13.845C10.0133 13.8425 9.54965 14.3061 9.55222 14.8806L9.57078 19.0413C9.57334 19.6157 10.0411 20.0835 10.6156 20.0861L14.7763 20.1046C15.3508 20.1072 15.8144 19.6436 15.8118 19.0691Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("mask", {
        id: "mask0",
        "mask-type": "alpha",
        maskUnits: "userSpaceOnUse",
        x: "7",
        y: "7",
        width: "16",
        height: "16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.8118 19.0691C15.8093 18.4946 15.3415 18.0269 14.767 18.0243L13.0544 18.0166L19.7782 11.2929C20.1687 10.9023 20.1687 10.2692 19.7782 9.87864C19.3877 9.48812 18.7545 9.48811 18.364 9.87864L11.6402 16.6024L11.6326 14.8898C11.63 14.3154 11.1622 13.8476 10.5877 13.845C10.0133 13.8425 9.54965 14.3061 9.55222 14.8806L9.57078 19.0413C9.57334 19.6157 10.0411 20.0835 10.6156 20.0861L14.7763 20.1046C15.3508 20.1072 15.8144 19.6436 15.8118 19.0691Z",
        fill: "var(--ds-icon-inverse, #FFFFFF)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        mask: "url(#mask0)"
    }));
const $20df754c7d362b79$export$7e45df5d5091bdc1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM17.3946 8.37281L8.37281 17.3946C9.40883 18.0926 10.6568 18.5 12 18.5C15.5899 18.5 18.5 15.5899 18.5 12C18.5 10.6568 18.0926 9.40883 17.3946 8.37281ZM5.5 12C5.5 8.41015 8.41015 5.5 12 5.5C13.3432 5.5 14.5912 5.9074 15.6272 6.60536L6.60536 15.6272C5.9074 14.5912 5.5 13.3432 5.5 12Z",
        fill: "currentColor"
    }));
const $20df754c7d362b79$export$aa6aa7c7f5b660eb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 4C16.4183 4 20 7.13401 20 11C20 14.866 16.4183 18 12 18C11.2426 18 10.5098 17.9079 9.81538 17.7358L9.48536 17.9384C8.76804 18.3682 7.14214 19.3047 4.60766 20.748L5.41439 17.3256C5.60252 16.5045 5.73944 15.8795 5.82514 15.4509C4.6849 14.2411 4 12.6905 4 11C4 7.13401 7.58172 4 12 4ZM12 6C8.68629 6 6 8.23858 6 11C6 13.7614 8.68629 16 12 16C15.3137 16 18 13.7614 18 11C18 8.23858 15.3137 6 12 6Z",
        fill: "currentColor"
    }));
const $20df754c7d362b79$export$d16eebd02cbe077 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "var(--ds-icon-inverse, #FFFFFF)",
        fillOpacity: ".01",
        d: "M0 0h24v24H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 17H5V7h1V5H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h1v-2Zm13-6.995V19H9V5h5.99v2.49a1.5 1.5 0 0 0 1.5 1.5h4.5v-.522c0-.297-.132-.578-.359-.768l-5.074-4.236c-.36-.3-.813-.464-1.282-.464H9a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8.995h-2Z",
        fill: "var(--ds-icon, #44546F)"
    }));
const $20df754c7d362b79$export$6be6d2feb174f383 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: "false",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M19 5h.006C20.107 5 21 5.895 21 6.994v12.012A1.995 1.995 0 0 1 19.006 21H6.994A1.995 1.995 0 0 1 5 19.006V19h13c.555 0 1-.448 1-1V5zM3 5.006C3 3.898 3.897 3 5.006 3h9.988C16.102 3 17 3.897 17 5.006v9.988A2.005 2.005 0 0 1 14.994 17H5.006A2.005 2.005 0 0 1 3 14.994V5.006zM5 5v10h10V5H5zm1 3c0-.552.453-1 .997-1h6.006c.55 0 .997.444.997 1 0 .552-.453 1-.997 1H6.997A.996.996 0 0 1 6 8zm0 3c0-.552.453-1 .997-1h6.006c.55 0 .997.444.997 1 0 .552-.453 1-.997 1H6.997A.996.996 0 0 1 6 11z",
        fill: "currentColor"
    }));
const $20df754c7d362b79$export$3d11ab79d49f0705 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 6C20 7.10457 19.1046 8 18 8C16.8954 8 16 7.10457 16 6C16 4.89543 16.8954 4 18 4C19.1046 4 20 4.89543 20 6ZM20 18C20 19.1046 19.1046 20 18 20C16.8954 20 16 19.1046 16 18C16 16.8954 16.8954 16 18 16C19.1046 16 20 16.8954 20 18ZM18 10C20.2091 10 22 8.20914 22 6C22 3.79086 20.2091 2 18 2C15.7909 2 14 3.79086 14 6C14 8.20914 15.7909 10 18 10ZM18 22C20.2091 22 22 20.2091 22 18C22 15.7909 20.2091 14 18 14C15.7909 14 14 15.7909 14 18C14 20.2091 15.7909 22 18 22ZM11.1377 5C10.803 5 10.4904 5.16747 10.3051 5.44617L9.28468 6.98023C8.97881 7.44008 9.10363 8.06082 9.56348 8.36669C10.0233 8.67256 10.6441 8.54774 10.9499 8.08789L11.6736 7H12.5688C13.1211 7 13.5688 6.55228 13.5688 6C13.5688 5.44772 13.1211 5 12.5688 5H11.1377ZM8.90917 11.156C9.21504 10.6962 9.09022 10.0754 8.63037 9.76954C8.17052 9.46367 7.54978 9.5885 7.24391 10.0483L6.49738 11.1707C6.19106 11.377 6.03512 11.7238 6.0583 12.0681C6.03512 12.4124 6.19106 12.7592 6.49738 12.9656L7.24391 14.0879C7.54978 14.5477 8.17052 14.6726 8.63037 14.3667C9.09022 14.0608 9.21504 13.4401 8.90917 12.9802L8.30247 12.0681L8.90917 11.156ZM3 11C2.44772 11 2 11.4477 2 12C2 12.0229 2.00077 12.0456 2.00228 12.0681C2.00077 12.0906 2 12.1133 2 12.1362C2 12.6885 2.44772 13.1362 3 13.1362H5.02808C5.58036 13.1362 6.02808 12.6885 6.02808 12.1362C6.02808 12.1133 6.02731 12.0906 6.02579 12.0681C6.02731 12.0456 6.02808 12.0229 6.02808 12C6.02808 11.4477 5.58036 11 5.02808 11H3ZM10.9499 16.0483C10.6441 15.5885 10.0233 15.4637 9.56348 15.7695C9.10363 16.0754 8.97881 16.6962 9.28468 17.156L10.3051 18.6901C10.4904 18.9688 10.803 19.1362 11.1377 19.1362H12.5688C13.1211 19.1362 13.5688 18.6885 13.5688 18.1362C13.5688 17.5839 13.1211 17.1362 12.5688 17.1362H11.6736L10.9499 16.0483Z",
        fill: "currentColor"
    }));

});

parcelRegister("48RM5", function(module, exports) {
$parcel$export(module.exports, "useFetchObjectDetails", () => $f42adbd932e7b116$export$b37a506962399e6);

var $eJOHy = parcelRequire("eJOHy");

var $hPZg4 = parcelRequire("hPZg4");

var $7YIsm = parcelRequire("7YIsm");

var $cae2X = parcelRequire("cae2X");

var $98WBz = parcelRequire("98WBz");
const $f42adbd932e7b116$export$b37a506962399e6 = (workspaceId, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
serviceId)=>{
    const request = (0, $eJOHy.useCallback)(()=>{
        if (workspaceId == null) return Promise.resolve(undefined);
        return (0, $98WBz.fetchReadOnlySchemaId)(workspaceId).then((readOnlySchemaId)=>(0, $7YIsm.fetchInsightId)(workspaceId, readOnlySchemaId, serviceId)).then((workspaceAndObjectId)=>(0, $cae2X.fetchObjectDetails)(workspaceAndObjectId));
    }, [
        serviceId,
        workspaceId
    ]);
    return (0, $hPZg4.useService)(request);
};

});
parcelRegister("7YIsm", function(module, exports) {
$parcel$export(module.exports, "fetchInsightId", () => $46eb0cd1285cef10$export$8a0344b38410d33c);

var $jGzN3 = parcelRequire("jGzN3");

var $8rYjX = parcelRequire("8rYjX");
const $46eb0cd1285cef10$var$serviceIdField = 'Service ID';
const $46eb0cd1285cef10$export$8a0344b38410d33c = async (workspaceId, readOnlySchemaId, serviceId)=>{
    const qlQuery = `objectSchemaId = "${readOnlySchemaId}" and "${$46eb0cd1285cef10$var$serviceIdField}" = "${serviceId}"`;
    const aqlSearchResponse = await (0, $jGzN3.performPostRequest)((0, $8rYjX.getCmdbObjectQueryLanguageUrl)(workspaceId, {
        includeAttributes: false,
        maxResults: 1
    }), {
        body: JSON.stringify({
            qlQuery: qlQuery
        })
    });
    const { values: values } = aqlSearchResponse;
    if (values.length !== 1) throw new Error('Could not find object.');
    return values[0].globalId;
};

});

parcelRegister("cae2X", function(module, exports) {
$parcel$export(module.exports, "fetchObjectDetails", () => $47d2c3bbf57caaf1$export$756a7008ba257136);

var $4mEPL = parcelRequire("4mEPL");

var $55tVS = parcelRequire("55tVS");
const $47d2c3bbf57caaf1$export$498e90683e0a9866 = (workspaceAndObjectId)=>`/rest/servicedesk/cmdb/latest/object/${workspaceAndObjectId}`;
const $47d2c3bbf57caaf1$export$756a7008ba257136 = (workspaceAndObjectId)=>(0, $4mEPL.default)($47d2c3bbf57caaf1$export$498e90683e0a9866(workspaceAndObjectId), {}, 'fields/service-entity/src/services/fetch-object-details/fetch-object-details').then((object)=>(0, $55tVS.transformBackendValueToCmdbObject)(object));

});

parcelRegister("98WBz", function(module, exports) {
$parcel$export(module.exports, "fetchReadOnlySchemaId", () => $63c72eccfd7ac098$export$e4380cab5ff04f7);

var $4mEPL = parcelRequire("4mEPL");

var $9VcRq = parcelRequire("9VcRq");
const $63c72eccfd7ac098$export$e4380cab5ff04f7 = async (workspaceId)=>{
    const url = (0, $9VcRq.getCmdbGlobalConfigUrl)(workspaceId);
    const result = await (0, $4mEPL.default)(url, {}, 'fields/service-entity/src/services/fetch-object-details/fetch-read-only-schema-id');
    const { restrictedObjectSchemaIds: restrictedObjectSchemaIds } = result;
    if (restrictedObjectSchemaIds.length !== 1) throw new Error('Could not find readonly schema.');
    return restrictedObjectSchemaIds[0];
};

});


parcelRegister("gqVbO", function(module, exports) {
$parcel$export(module.exports, "default", () => $f79c1c3ac6040799$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f79c1c3ac6040799$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    viewFullServiceDetails: {
        "id": "issue-field-service-entity.header-content.view-full-service-details",
        "defaultMessage": "View full service details"
    },
    deleteService: {
        "id": "issue-field-service-entity.header-content.delete-service",
        "defaultMessage": "Remove service"
    },
    ariaLabel: {
        "id": "issue-field-service-entity.header-content.aria-label",
        "defaultMessage": "View full service details in a new window"
    }
});

});


parcelRegister("lYkoS", function(module, exports) {
$parcel$export(module.exports, "default", () => $2acf0acb74ff1375$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $2acf0acb74ff1375$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    addItem: {
        "id": "issue-field-service-entity.add-item",
        "defaultMessage": "Add service"
    },
    removeItem: {
        "id": "issue-field-service-entity.remove-item",
        "defaultMessage": "Remove service"
    },
    editField: {
        "id": "issue-field-service-entity.edit-field",
        "defaultMessage": "Edit Field"
    },
    showDetails: {
        "id": "issue-field-service-entity.show-details",
        "defaultMessage": "Show details"
    },
    hideDetails: {
        "id": "issue-field-service-entity.hide-details",
        "defaultMessage": "Hide details"
    },
    itemCount: {
        "id": "issue-field-service-entity.item-count",
        "defaultMessage": "{count, plural, one {# Service} other {# Services}}"
    },
    searchPlaceholder: {
        "id": "issue-field-service-entity.search-placeholder",
        "defaultMessage": "Select or search for a service"
    },
    infoSingleItemMessage: {
        "id": "issue-field-service-entity.info-single-item-message",
        "defaultMessage": "This field can only store a single service"
    },
    warningMultipleItemMessage: {
        "id": "issue-field-service-entity.warning-multiple-item-message",
        "defaultMessage": "This field is configured to store a single object. Remove some services to save changes."
    },
    globalErrorMessage: {
        "id": "issue-field-service-entity.global-error-message",
        "defaultMessage": "We couldn\u2019t retrieve the affected service details."
    }
});

});

parcelRegister("4Pnd1", function(module, exports) {
$parcel$export(module.exports, "OptionContent", () => $f02d78f4a53757dd$export$b381d9a2f3b4390b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $fL0In = parcelRequire("fL0In");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $9lLzu = parcelRequire("9lLzu");
const $f02d78f4a53757dd$export$5582a6f6f935c0e7 = (props)=>{
    const { innerProps: innerProps, label: label } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f02d78f4a53757dd$var$Outer, innerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        glyph: (0, $9lLzu.ServicesGlyph),
        label: label
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $f02d78f4a53757dd$var$innerStyles
    }, label));
};
const $f02d78f4a53757dd$export$b381d9a2f3b4390b = (props)=>{
    const { innerProps: innerProps, data: { label: label } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f02d78f4a53757dd$export$5582a6f6f935c0e7, {
        innerProps: innerProps,
        label: label
    });
};
// TODO: https://product-fabric.atlassian.net/browse/DSP-858
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f02d78f4a53757dd$var$Outer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _ca0qu2gc _u5f3pxbi _n3tdu2gc _19bvpxbi _irr3166n",
            __cmplp.className
        ])
    });
});
const $f02d78f4a53757dd$var$innerStyles = (0, $1DXK0.xcss)({
    paddingLeft: 'space.100'
});

});




$parcel$global.rlb("72RZh")
//# sourceMappingURL=sync.6e716e60.js.map
